import React from 'react'

export class LargeMap extends React.Component {

  componentDidMount() {
    if (this.props.onRender) {
      this.props.onRender([this.path1, this.path2, this.path3])
    }
  }

  render() {
    return (
  <svg viewBox="0 0 1271 1271" onClick={this.props.onClick}>
    <rect
      x="0"
      y="0"
      width="1271"
      height="1271"
      style={{ fill: 'rgb(66, 182, 240)' }}
    />
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M98.40503363404423,179.61344214202836L80.02635383605957,171.42844917951152L123.06324690114707,81.02348721912131L208.46884649340063,119.67734316829592L208.46884649340063,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer recreation_track"
        d="M141.98468034621328,135.5698249018751L156.09469738136977,104.05537166818976L208.46884649340063,127.64804176194593L208.46884649340063,152.89407648611814L203.69608550332487,163.44947648746893Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M91.41392489057034,165.99987681675702L98.66378827951849,149.95658405451104L125.13959515374154,161.80539907468483L117.92523164022714,177.97665243316442Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M98.66378827951849,149.95658405451104L125.35969437938184,90.30014094663784L156.09469738136977,104.05537166818976L141.98468034621328,135.5698249018751L129.40589125826955,163.71169639378786L125.13959515374154,161.80539907468483Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M129.40589125826955,163.71169639378786L141.98468034621328,135.5698249018751L203.69608550332487,163.44947648746893L196.391788973473,179.61344214202836L164.4419013550505,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M117.92523164022714,177.97665243316442L125.13959515374154,161.80539907468483L164.41507922764868,179.61344214202836L121.54779667593539,179.61344214202836Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M208.46884649340063,119.67734316829592L123.0553580392152,81.02452778629959L80.02162051852793,171.42844917951152L98.29222292080522,179.61344214202836L-8.205035817809403,179.61344214202836L-8.205035817809403,-37.06008652690798L208.46884649340063,-37.06008652690798Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M208.46884649340063,119.67734316829592L123.06324690114707,81.02348721912131L80.02635383605957,171.42844917951152L98.29537846427411,179.61344214202836L-8.205035817809403,179.61344214202836L-8.205035817809403,-37.06008652690798L208.46884649340063,-37.06008652690798Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean_boundary"
        d="M208.46884649340063,119.67422148166224L123.08691348414868,81.02869005594403"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M90.94059322308749,148.5018848995678L-8.205035817809403,91.5373740280047"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M121.5044079395011,169.95398399978876L138.3179376879707,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M96.19773028790951,155.41326400870457L121.5044079395011,169.95398399978876"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M89.48588722851127,151.5569608863443L96.19773028790951,155.41326400870457"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M-8.205035817809403,95.42908976366743L89.48588722851127,151.5569608863443"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M97.5940587092191,152.3238513446413L90.94059322308749,148.5018848995678"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M145.09131386317313,179.61344214202836L122.88653641194105,166.85625338135287"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M122.88653641194105,166.85625338135287L97.5940587092191,152.3238513446413"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M208.46884649340063,124.44727669144049L124.3317757723853,86.0629541547969L86.24829861614853,168.80000926880166L109.74921595398337,179.61344214202836"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank_boundary"
        d="M123.08691348414868,81.02869005594403L80.05080930516124,171.43989527551457"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M91.41392489057034,165.99987681675702L98.66378827951849,149.95658405451104L125.13959515374154,161.80539907468483L190.95399698987603,191.6474245400168L203.69608550332487,163.44947648746893L141.98468034621328,135.5698249018751L156.09469738136977,104.05537166818976L217.95441312901676,131.92058217106387L262.2314351648092,151.86912797391415L234.67169877234846,212.8579830317758L213.1919076582417,203.14862485416234L206.48795346170664,217.99516553990543L183.5905340006575,207.64899886678904L117.92523164022714,177.97665243316442Z"
      />
    </g>
    <g>
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M239.67797005083412,-37.06008652690798L256.55066625773907,-24.625103309750557L260.1085426323116,-28.964337596204132L276.3753743041307,-16.081918564625084L331.58951342571527,10.13029632391408L320.9158843019977,44.11549761798233L321.50754888821393,48.038457156624645L322.07554689142853,51.7741115228273L313.839575859718,69.28691559797153L306.29782460909337,85.87357099028304L304.2230541296303,95.75894899107516L304.0968323517591,110.93037538556382L300.72828864399344,127.86031611822546L296.2079712115228,135.05058574816212L292.728983447887,140.74244368588552L290.1729924380779,146.42389137018472L288.72144198883325,155.99701612675563L281.4479120168835,152.70885737333447L241.42771945148706,134.6239563561976L240.07083533518016,133.97880941536278L208.46884649340063,119.67734316829592L208.46884649340063,-37.06008652690798Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M398.80418811459094,159.74613953754306m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer water"
        d="M252.17865941300988,179.61344214202836L263.6632634624839,154.10216280911118L278.3894005538896,161.0322663327679L271.3580586183816,179.61344214202836Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer swimming_pool"
        d="M329.64727581385523,137.78829716145992L332.77994257211685,129.12875930499285L346.5917606567964,134.29409897699952L343.28238340932876,143.12428193585947Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean_boundary"
        d="M256.54277739673853,-24.6365497270599L260.1408869624138,-28.936241827439517M241.4498082632199,134.58857733244076L240.03296880144626,133.96840381994843L208.46884649340063,119.66901867231354"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank_boundary"
        d="M239.69769220333546,-37.06008652690798L256.54277739673853,-24.6365497270599"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer water_boundary"
        d="M252.18970382027328,179.61344214202836L263.68456338718534,154.07718945061788L278.3894005538896,161.07492910930887L271.35332530085,179.61344214202836"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer swimming_pool_boundary"
        d="M329.67962014395744,137.7778915683739L332.77994257211685,129.09650193480775L346.5988606316969,134.32323464611545L343.3210388273001,143.0930651864037L329.67962014395744,137.7778915683739"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M208.46884649340063,119.67734316829592L240.07872419711202,133.9829716575332L241.4324527690187,134.62811859417707L281.4581675371155,152.7130196033977L288.7285419628024,156.0011783526279L290.18167018610984,146.4270130423829L292.7329278783873,140.74348424421623L296.21270452812314,135.0526668690145L300.7338108466938,127.86031611822546L304.10708787012845,110.9293348225765L304.227787447162,95.75686786137521L306.3041356988251,85.87877382431179L313.84430917631835,69.28795616701245L322.0858024097979,51.77723323972896L321.5114933187142,48.04261944722384L320.9237731639296,44.116538191214204L331.59661340061575,10.128215165808797L276.3840520521626,-16.077756233047694L260.11248706281185,-28.96121584298089L256.5553995743394,-24.624062726739794L239.68428114056587,-37.06008652690798L371.246818379499,-37.06008652690798L370.46661001164466,-35.93521390389651L362.11151717882603,-13.82385565713048L351.8496866058558,33.36636899178848L334.1754821082577,67.53771831933409L330.4763951189816,81.35022542858496L326.1390992635861,98.32914496259764L336.2660303097218,105.501755642239L363.9259552396834,114.76380873378366L342.02489894162863,179.61344214202836L208.46884649340063,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer footway"
        d="M360.57871145941317,179.61344214202836L367.9224522933364,160.6711935433559L378.8927025953308,138.8725596102886L390.33786233887076,121.53162399725989L396.3546967301518,115.83350691385567L403.0160510772839,113.57340512098745L409.0817964076996,117.3287948477082L411.91705310251564,124.80522968666628L410.36452523060143,132.00590808782727L404.70268958900124,135.86118152504787L398.21804573200643,134.195245816838L393.4839401617646,131.47418194636703L391.3089811457321,134.74778293911368L390.1248630871996,137.29195047356188L384.47722739726305,144.66951076779515L378.81460287142545,160.28826906485483L371.7477610614151,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer recreation_track"
        d="M208.46884649340063,127.64804176194593L217.95441312901676,131.92058217106387L208.46884649340063,152.89407648611814Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer recreation_ground"
        d="M411.09503377228975,35.449599287472665L425.1435176897794,-5.338956733234227L425.1435176897794,40.291390360333025Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer picnic_site"
        d="M332.7941425209865,125.78335696086287L338.88118777796626,107.07508808095008L355.29396338108927,112.41838044021279L349.21401809901,131.11935097631067Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M222.1923093330115,143.8120909044519L224.89897759072483,137.66030839504674L255.77598009444773,151.2458343412727L253.0614229766652,157.40384812932462Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pier"
        d="M240.07872419711202,133.9829716575332L245.03214010689408,123.38798545533791L244.0050103859976,122.9207734526135L246.3645687540993,117.88133331481367L256.3495002994314,122.5451308186166L253.94024210702628,127.70423203520477L246.33616885449737,124.14655453991145L241.4324527690187,134.62811859417707Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M279.43151910975575,156.74517608108L265.37830187380314,150.40922643523663"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M367.6195200262591,179.61344214202836L374.12309715058655,163.93853741465136L382.2872795443982,144.15963731892407L386.1567659340799,136.74669746868312L404.1378471320495,114.26746040023863"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M404.1378471320495,114.26746040023863L405.1420991541818,113.01358237257227L422.7453039037064,91.34903157874942L425.1435176897794,88.61026125820354"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M289.9686709344387,172.26505454909056L296.1843046275899,174.8518710071221L302.5624488592148,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M392.91041995584965,119.09566911077127L382.7976888604462,133.32325682416558L367.90115236863494,161.08949688775465L363.31851293332875,172.54704464552924"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M363.31851293332875,172.54704464552924L360.4919339865446,179.61344214202836M425.1435176897794,79.28261744603515L420.037846759893,84.57390287704766L401.08091343939304,107.59849158488214L392.91041995584965,119.09566911077127"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M425.1435176897794,-22.15059633925557L421.4838750073686,-12.647998308297247L352.13131894916296,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M295.4474849961698,-37.06008652690798L354.0033456971869,23.462171635590494"
        style={{ display: 'none' }}
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M239.68428114056587,-37.06008652690798L256.5553995743394,-24.624062726739794L260.11248706281185,-28.96121584298089L276.3840520521626,-16.077756233047694L331.59661340061575,10.128215165808797L320.9237731639296,44.116538191214204L321.5114933187142,48.04261944722384L322.0858024097979,51.77723323972896L313.84430917631835,69.28795616701245L306.3041356988251,85.87877382431179L304.227787447162,95.75686786137521L304.10708787012845,110.9293348225765L300.7338108466938,127.86031611822546L296.21270452812314,135.0526668690145L292.7329278783873,140.74348424421623L290.18167018610984,146.4270130423829L288.7285419628024,156.0011783526279L281.4581675371155,152.7130196033977L241.4324527690187,134.62811859417707L240.07872419711202,133.9829716575332L208.46884649340063,119.67734316829592L208.46884649340063,-37.06008652690798Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M265.37830187380314,150.40922643523663L208.46884649340063,124.44727669144049"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M412.96232720278203,179.61344214202836L423.4537236345932,150.8275303998962L425.1435176897794,146.1387785365805"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M266.9631740776822,-37.06008652690798L268.96378926280886,-35.99868959747255L278.07779053784907,-33.461743481922895L284.54744555894285,-32.17870258819312L297.97665387857705,-32.08713114447892L311.56206164788455,-35.33271513879299L314.9763607494533,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M286.00925152841955,179.61344214202836L287.94202250801027,175.19837531168014L289.9686709344387,172.26505454909056L295.553195736371,164.17890564724803L297.1120346970856,161.91153572918847L309.0818037055433,152.24476902093738L319.4138451414183,141.25335794407874L323.56023055687547,130.19117134530097L324.81455947831273,120.79490642203018L323.16342084109783,111.23421980068088L318.8190250117332,98.3437128723599L320.64766302425414,84.04321366269141L332.0636339802295,58.92075610626489L343.62239332310855,35.86791019141674L350.6308575607836,9.759850466623902L350.0644373316318,0.1927672135643661L353.3667146032676,-9.700031153857708L359.3125492464751,-22.895653852727264L363.91175529081374,-34.94977985275909L364.82449652440846,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M283.2229057736695,158.54533808818087L275.38847777526826,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M295.553195736371,164.17890564724803L283.2229057736695,158.54533808818087L279.43151910975575,156.74517608108"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M346.1310511659831,3.941974895540625L339.52649661898613,14.026220077648759L334.2322819083929,26.470476826652884L325.80618932377547,41.64309545373544L321.5114933187142,48.04261944722384"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,151.4435401726514L423.4537236345932,150.8275303998962"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M425.1435176897794,134.7259311871603L418.8545175893232,138.12855996284634L409.69160537514836,142.65707126352936L398.8562545981258,141.941167101264L390.1248630871996,137.29195047356188"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M353.3667146032676,-9.700031153857708L356.0378829864785,-1.068415510468185L358.5970295406878,2.3394828238524497"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M358.5970295406878,2.3394828238524497L359.2415494956076,3.197960762772709L363.7697557900101,3.991922694724053L367.49724267888814,-4.405556054320186L367.1075329389423,-20.266100666951388L375.7008693786338,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M311.56206164788455,-35.33271513879299L323.04272126592696,-36.869659416843206L328.18310318514705,-37.06008652690798M349.6857719970867,-37.06008652690798L341.2273350805044,-28.642797118984163L337.7830583071336,-24.517923215404153L334.72139129880816,-17.247370672877878L334.3387815337628,-9.012207016348839L338.7470771390945,-1.7416707393713295L346.1310511659831,3.941974895540625L350.6308575607836,9.759850466623902"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M316.408977933228,-37.06008652690798L311.56206164788455,-35.33271513879299"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M91.41392489057034,165.99987681675702L98.66378827951849,149.95658405451104L125.13959515374154,161.80539907468483L190.95399698987603,191.6474245400168L203.69608550332487,163.44947648746893L141.98468034621328,135.5698249018751L156.09469738136977,104.05537166818976L217.95441312901676,131.92058217106387L262.2314351648092,151.86912797391415L234.67169877234846,212.8579830317758L213.1919076582417,203.14862485416234L206.48795346170664,217.99516553990543L183.5905340006575,207.64899886678904L117.92523164022714,177.97665243316442Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.4613049030304,175.04957616887987L427.84071931336075,160.0905634816736L481.43685301579535,179.52187349833548L471.76353148557246,206.40138101950288L457.36399324517697,201.17886485811323L448.6965015111491,198.03952619154006L452.9840975413099,186.11897503817454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M374.1585970260203,198.09571589156985L378.75780307129025,185.29069575946778L388.82083434052765,188.93262653099373L390.9823822937906,182.93072359636426L380.9335509724915,179.29503298457712L384.54822714813054,169.21102824341506L395.2344784485176,173.08709206571802L395.7803876399994,171.56372120091692L406.7790378415957,175.53863627742976L394.6893581440672,209.19421331351623L384.66813783720136,205.55853648064658L385.82385599426925,202.326590903569Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.9246995244175,158.93450599489734L387.71560489572585,145.56959339883178L414.10621206928045,155.12190820649266L406.7790378415957,175.53863627742976L395.7803876399994,171.56372120091692L394.7169691575691,171.18079732405022L397.67923651635647,162.91046887123957L391.15988166909665,160.55777297867462L390.7204721039161,161.76273629954085Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M397.61612562742084,75.02877482399344L403.56117138266563,58.82814529677853L407.2965471325442,60.21730731893331L407.2326473565772,60.35882493155077L416.9911685883999,63.9737665229477L418.0537981837988,65.26303280005231L418.89001746475697,67.58038167422637L418.096398034133,69.74892836716026L417.94729855749756,70.13914183154702L417.6924883425236,70.04653117246926L416.2464600959793,76.23999642208219L414.992131174542,77.55839632637799L412.986782672815,78.21811646781862L408.1327664135024,76.42417700728402L407.3312581209466,78.62185683660209Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M320.30686422251165,167.134081476368L323.65884132124484,158.6722859106958L330.8519049100578,161.5358952083625L327.49992780946195,169.98311951896176Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M335.75640987977386,158.14160237228498L339.6677072336897,146.82346553727984L343.8417036635801,148.25527277914807L339.9162063598633,159.57965061208233Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M341.68094459641725,160.78461410291493L345.69164160080254,148.62363011855632L349.37652863841504,149.83587941573933L345.36583163496107,162.00310460524634Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M354.0033456971869,23.462171635590494L378.56689263135195,48.85010368190706L416.5304590975866,71.32955290656537L425.1435176897794,74.49080090085045"
        style={{ display: 'none' }}
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer dog_park"
        d="M476.08662739023566,16.14483581483364L495.882935536094,-37.06008652690798L576.4376744134352,-37.06008652690798L560.3830531062558,-29.30877093784511L538.7612624922767,-18.274425508454442L516.6929623391479,-8.133956629782915L499.47946732956916,3.7931720754131675L481.8265627557412,17.91693875659257Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M611.5967507446185,132.22546622529626m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer recreation_ground"
        d="M425.1435176897794,-5.338956733234227L425.83458192646503,-7.347277469933033L459.1989423474297,4.140725510194898L444.44440535549074,46.943774772342294L425.1435176897794,40.291390360333025Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M466.20740658510476,56.93638712586835L477.13584592193365,26.81074509350583L492.5988026438281,31.679597149137408L482.4008718468249,62.53465787740424Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M578.3830675706267,150.8774771410972L583.4784829821438,135.87470879545435L613.3204669030383,146.00870881276205L608.2250514924526,161.02602300001308Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer garden"
        d="M600.0892689991742,-20.896693860180676L615.0781051646918,-27.565792723093182L628.507313484326,-31.85299962386489L631.7172910822555,-29.039259650744498L633.1349194291979,-23.440919461194426L629.7687423815951,-13.4554897043854L628.4150138087571,-10.678177546244115L622.7665892336518,-11.266106029972434L616.0484350854531,-13.55538555374369L601.3009980702773,-19.826974746771157Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M581.7279446935281,155.90232550306246L576.0156203415245,154.00226937187836L582.5712639512494,134.74778293911368L626.6928754234686,150.32494130404666L626.1540662068874,157.09272184595466"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,146.1387785365805L430.2499775066972,131.96324513014406L447.8318823296577,83.08589184330776L452.4594882754609,70.59282999299467"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M470.59676892403513,44.836614751257L489.7887903051451,30.795108357444406"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M433.2619446888566,79.33776754140854L468.11414432153106,46.6534549864009L470.59676892403513,44.836614751257M489.7887903051451,30.795108357444406L495.872680015862,26.343526580836624"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M425.1435176897794,88.61026125820354L433.2619446888566,79.33776754140854"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M471.6081209210679,18.8024697676301L509.49358766246587,31.69312462443486"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M580.494915698655,-37.06008652690798L563.8336409684271,-29.6063780086115L522.5961971292272,-6.00805005338043L491.4501844616607,16.343586079310626"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M425.1435176897794,74.49080090085045L641.8174000009894,154.03556718723848"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M437.8682507099584,66.09236699622124L425.1435176897794,79.28261744603515"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M430.8842419423163,-37.06008652690798L425.1435176897794,-22.15059633925557"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M465.4066871777177,39.87828259263188L437.8682507099584,66.09236699622124"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M502.4796012220904,179.61344214202836L490.8269644314423,175.3835938218981L425.1435176897794,151.4435401726514"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M430.2499775066972,131.96324513014406L425.1435176897794,134.7259311871603"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M447.8318823296577,83.08589184330776L514.8864131383598,107.74833273980767L582.4931642254815,132.30350821791217L641.8174000009894,154.05949998740107"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M607.814041826874,64.93733440106735L538.2011533519253,40.941748888697475L509.49358766246587,31.69312462443486"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M452.4594882754609,70.59282999299467L468.8580639269203,26.385149610694498"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M479.16170546226203,27.44861797709018L475.8034172747284,30.48397638835013"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M475.8034172747284,30.48397638835013L465.4066871777177,39.87828259263188M491.4501844616607,16.343586079310626L479.16170546226203,27.44861797709018"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M475.3427077848464,7.663084927946329L470.02009317371994,6.10325744561851"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M459.1989423474297,4.140725510194898L451.96327890921384,3.835835822392255L449.4191211918369,10.617286911699921L444.3805055823177,34.54221833869815"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M470.02009317371994,6.10325744561851L464.9041667236015,4.5652817748487L453.29570755548775,39.31845389120281L451.60906904470176,39.97817767225206L450.2837403714657,39.212315360084176L449.5327207921073,38.09265780542046L459.7590514877811,7.031453693751246L459.1989423474297,4.140725510194898"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M538.2011533519253,40.941748888697475L514.8864131383598,107.74833273980767L490.8269644314423,175.3835938218981L489.287847623229,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M468.8580639269203,26.385149610694498L471.6081209210679,18.8024697676301L475.3427077848464,7.663084927946329L490.82302000094205,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M538.2011533519253,40.941748888697475L548.6333833234385,13.480957373976707L550.6813316754997,10.150067307986319L553.9410091005266,7.017926171887666L557.5051965629682,4.940930804703385L594.6325437482446,-12.357676035258919L598.6440296368673,-13.257779174484313"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M598.6440296368673,-13.257779174484313L602.39991642721,-13.00179607141763L606.7364233955741,-11.578280464746058L631.4127810429782,-2.9039986971765757L641.8174000009894,0.9128483347594738"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M565.470579655841,179.61344214202836L582.4931642254815,132.30350821791217L607.814041826874,64.93733440106735L631.4127810429782,-2.9039986971765757L633.9072389351204,-10.1183448061347L641.8174000009894,-30.874850244726986"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M495.872680015862,26.343526580836624L518.4506006008014,12.750471780076623L543.4527682121843,-1.8124301792122424L566.0945885721594,-13.966415368020535L579.0062876008451,-20.2733847447671L592.1309858802706,-26.13394945533946L610.0536895059049,-33.32022395450622L620.1482762200758,-37.06008652690798"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M610.5640988219529,-37.06008652690798L596.1566717196256,-31.58348824083805L581.7989444443956,-25.67297090869397L564.2659505605698,-16.31188722094521L526.3386728549376,1.9721582890488207L491.8122831871733,20.922124623786658"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,77.12031714431942L607.814041826874,64.93733440106735"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M518.4506006008014,12.750471780076623L535.6009847195819,6.947166821919382L542.5029493309557,3.6089895595796406L550.0999226104468,-0.18912555184215307L557.8246954381466,-3.739584627561271L566.3848986616358,-8.119388496503234L579.2121868757531,-14.249453632161021L592.5703954454511,-20.66984679736197L605.2698841094971,-25.488787615206093L624.1061178538948,-32.49816205911338L639.8041626373306,-37.06008652690798"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M481.6356523167342,28.22800906840712L474.85596505273134,33.09477898105979"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M474.85596505273134,33.09477898105979L465.4066871777177,39.87828259263188M491.8122831871733,20.922124623786658L481.6356523167342,28.22800906840712"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M435.60020313225687,-28.444045572075993L452.2756778113544,-75.69816710567102L452.89889784064144,-75.46403411310166L454.7417358029634,-80.6940467953682L455.62765490915626,-80.37562569556758L457.64010338578373,-86.07286817627028L458.8802323564887,-85.62645393749699L462.8207184970379,-96.7805749331601L468.0928443977609,-94.90334312617779L469.93568235915154,-100.12608631467447L473.67736919783056,-105.58296744292602L479.00629489775747,-103.69012432312593L483.00358083844185,-114.986836171709L477.2060567867011,-117.04929973976687L474.017379113473,-118.60083050606772L483.0319807380438,-137.7135119633749L495.97207966726273,-131.2930103810504L495.0435607107356,-128.66445666598156L513.6320842169225,-122.05249342136085L509.21668863575906,-109.54451598692685L507.99075961392373,-106.07829096121714L488.6228166287765,-51.199574045836926L474.0741789136082,-56.372336068190634L468.7239532889798,-41.20057668304071L465.13057703897357,-42.48257866129279L462.20380955561996,-34.183909345418215L465.4137871535495,-33.043428419623524L468.41865436173975,-36.89151170896366L472.23134095128626,-37.74895403115079L482.58547119703144,-34.06424208637327L475.57621807418764,-14.22135792253539L455.01784594357014,-21.534571193158627L457.64010338578373,-28.869644444901496L454.89714636746794,-29.861321138218045L452.2756778113544,-22.512719256337732Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M624.495827594772,56.84377629077062L627.5645945779979,48.29027570504695L628.4647136349231,48.60973145021126L637.4785263743252,23.522525055333972L636.6139071928337,23.21035218704492L639.8956734267995,14.076167804189026L652.4034627657384,18.60476015228778L660.8224553735927,21.65156878065318L662.2187837958336,17.329012698028237L677.5326410420239,22.87008374137804L670.32537750341,42.91155441803858L663.0550030767918,40.27578175533563L661.1624652892351,45.54108264204115L655.6560402130708,43.55670983158052L652.3679628903046,52.712707372847944L654.6005105925724,53.52019106363878L653.1402823952958,57.57425723783672L650.9148346679285,56.75949002197012L650.7665240783244,57.176759069785476L647.9383673602715,56.15699926018715L645.0257998257875,64.27136957645416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.4613049030304,175.04957616887987L427.84071931336075,160.0905634816736L481.43685301579535,179.52187349833548L471.76353148557246,206.40138101950288L457.36399324517697,201.17886485811323L448.6965015111491,198.03952619154006L452.9840975413099,186.11897503817454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M609.7128907032311,210.15776100428775L617.5512631321326,188.27395747881383L627.1180850379169,161.67741075204685L629.7119425805286,162.61287005571648L630.767472201027,159.67226007767022L631.1713818917051,159.81377566000447L637.0320168342441,161.93963072635233L637.3231158088893,161.12487577553838L637.4146265992895,160.86993966111913L641.7661224035546,162.43597564660013L641.6738227279857,162.6981955920346L641.383512637578,163.5129503547214L647.18024780415,165.61070930445567L647.6693571945652,165.7876036320813L641.4474124126136,183.1357123912312L642.3759313691407,183.46868910314515L639.6897741518915,190.9596203151159L640.7673925831914,192.81596317980438L631.6888911817223,218.10858516115695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.4194938074797,-7.2692339066416025L642.88555180002,-13.979942930396646L644.586390260607,-13.356634437572211L645.3239987781271,-15.361835749354213L644.2392803709954,-15.76558159571141L647.0950481034815,-23.561627119779587L666.4771910402924,-16.403458456508815L664.7905525276437,-11.790559090673923L665.8965708604082,-11.386813476216048L665.3080618185923,-9.798886368051171L668.5046283528209,-8.60846156347543L670.2898776279762,-13.477341920137405L677.0719315521419,-10.968499746639282L680.9201180152595,-21.463811551686376L692.2942780070007,-17.26818231958896L682.8970666173846,8.407098578754812Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.9698685314506,143.8120909044519L647.2086477028206,109.29981283983216L645.6853086175397,108.74727368820459L647.6764571694657,103.15528364852071L654.7701211078092,105.7067467267625L655.9960501277819,105.54337819712237L656.6129590701312,105.54337819712237L657.8317881152034,105.72859856765717L658.993817362003,106.14586466597393L660.057235843502,106.77644630242139L660.9707659631968,107.61305947555229L661.3683645650744,108.08755645295605L668.3484289031476,110.59635462937877L666.3430804004893,116.18833866622299L665.3080618185923,115.81269566714764L653.0905825700611,150.28227845858783Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M527.2309030499309,181.20132549479604L530.3777697589248,172.363907167688L534.0413568727672,173.67500491207466L536.6210144655779,166.4473153753206L532.9574273526669,165.1362162642181L535.6427956847474,157.60259434394538L547.308054652065,161.78354741074145L545.0826069246978,168.03416118817404L549.15720370505,169.50134289637208L551.5885507073253,162.69091170374304L562.7497114483267,166.69496740028262L559.5539338011295,175.66662434162572L555.9605575520545,174.3763380460441L554.5366181153804,178.40223860740662L558.1150055285543,179.68524028453976L554.1319195376709,190.8534841062501L543.2184690376744,186.941010910552L546.0608257064596,178.93396114604548L540.9228104446083,177.09114175708964L538.0670427121222,185.09195033600554Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M434.6929841004312,144.2012596419081L440.58911891654134,126.74691624613479L461.8211997896433,133.9611199037172L457.17939389590174,147.7162639820017L458.6530331559479,148.2126099234447L456.4283743137494,154.80349792400375L438.03786122519523,148.52477716235444L438.70446999091655,146.85260115377605L435.13239366654307,145.63306742766872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M567.285017718561,195.0625119782053L577.1003387495875,167.8000364182517L578.524278184399,168.31719201011583L591.0825562346727,172.83215639088303L590.8198571586981,173.5615845611319L589.1971184210852,178.07654552301392L583.1944839805365,194.75138738239184L583.2796836802736,194.7794822473079L585.1509215431288,195.45271838689223L585.115421667695,195.55885452590883L583.2299838550389,200.7959426175803Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M578.524278184399,168.31719201011583L583.0461733900011,155.76705317618325L608.8127716481686,165.04360687406734L604.0297551387921,178.31691326200962L590.8198571586981,173.5615845611319L591.0825562346727,172.83215639088303Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M447.4066727142781,105.90549442404881L452.2543778847903,92.44058525469154L476.21442694123834,101.12930475128815L471.3667217697948,114.59315648069605L469.47497286926955,113.90638517355546L463.88334809150547,111.87936885654926L465.08087721373886,108.57037790678442L456.3147747144103,105.3883341779001L455.11724559310824,108.70461058989167L454.68493600189686,108.54852607287467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M504.1070732763037,156.4902398060076L508.7346792202443,143.45101721817628L515.1554233031347,145.72567707952112L514.2127043968067,148.36869354499504L525.6933640139177,152.4507992803119L526.6005830448121,149.89206950599328L532.964527326636,152.1604839125648L528.8891416620463,163.6471819728613L513.497184690088,158.18426516652107L513.7874947804958,157.3684692219831L511.5131361139938,156.568281524349L510.7053167335689,158.82836929801852Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M442.63075618073344,119.1861979952082L447.4066727142781,105.90549442404881L454.68493600189686,108.54852607287467L453.50870680622756,111.80861057713628L460.9565806090832,114.50887091457844L462.1328098056838,111.24150374298915L463.88334809150547,111.87936885654926L469.47497286926955,113.90638517355546L464.6556675983593,127.30049452278763L457.3142934218049,124.63561824103817L458.55442239157856,121.20592824276537L451.1838594293222,118.52648175042123L449.9934302829206,121.8500358085148Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M596.7940916996449,114.4797351649031L601.889507111162,101.35510725853965L607.8992415266111,103.59544231323525L606.6449126061052,106.84096125187352L617.9693727726117,111.26231500320137L619.3649123096839,107.67653385456651L624.942337134853,109.85963588906452L619.7759219743311,123.1757109630853L613.5894770687446,120.76577069656923L614.8438059892505,117.54211008036509L604.1078548636287,113.33199457358569L602.7612262675539,116.81163545371965Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.1971184210852,178.07654552301392L590.8198571586981,173.5615845611319L604.0297551387921,178.31691326200962L607.6507424013689,179.6207260102965L609.3586808377877,174.88724982878193L619.1598019190133,178.40952247660607L626.8561748480424,157.05005904240534L631.5539916567504,158.73680037725717L631.1713818917051,159.81377566000447L630.767472201027,159.67226007767022L629.7119425805286,162.61287005571648L627.1180850379169,161.67741075204685L617.5512631321326,188.27395747881383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M459.2486421726644,156.2914935592562L461.8069998398423,149.38219644222409L475.56911809928715,154.51318265590817L487.3329878328368,158.91369488090277L484.77463016379625,165.82298249658197Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M475.56911809928715,154.51318265590817L480.67163348570466,140.722673072014L492.44260319229215,145.11591014219448L487.3329878328368,158.91369488090277Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.309397152625,109.98762516770512L640.4478937061504,98.868157599587L644.331580045633,88.40110740391538L645.2600990021601,85.90686912974343L651.8859534747899,88.38029607152566L642.9494515741244,112.46000295411795Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.8739791242406,105.9908206583932L535.9409946352243,92.01499380217865L539.6826814739034,81.69049100158736L546.2517361463979,84.09212031820789L542.6804487081245,93.97125746682286L537.8895433368161,107.17394162900746L537.4501337716356,108.39244155492634Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M455.9534648731351,-6.1922328299842775L459.93576197791845,-17.19742272188887L474.24378942884505,-11.982026089914143L470.6725019896403,-2.081940406933427L470.2685922998935,-0.9830879606306553Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M533.8149465573952,75.82272852538154L536.288104524836,68.99763731658459L544.6502973344177,72.0589917586185L554.7630284307525,75.75092930579558L554.3449187902734,76.89243271201849L556.7470770068467,77.77067221375182L555.2592377960682,81.860103498213L552.700880127959,80.9246332985349L552.1194710619748,82.51253925869241L540.8731106212363,78.40229700040072Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M462.0547100799158,65.48987704468891L464.4505572076887,58.779238463845104L487.6098868586123,67.126693315804L485.1998397791758,73.83836438460276L476.7035363325849,70.77701072813943L477.8087657773867,67.7083717319183L471.4448214964941,65.4191182916984L470.34669202566147,68.48775830166414L462.4870196701959,65.64596252841875Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M603.4483460728079,94.35418560914695L606.0990034146234,87.15346809383482L618.7132923780009,91.84538155375049L624.1061178538948,93.85783581063151L621.4483605362475,101.04397845780477L614.2631858093664,98.37180812703446L604.3555651037022,94.68716658558697Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.58911891654134,126.74691624613479L442.4958566548303,121.10603433428332L448.5268909968436,123.1611431078054L449.504320891574,122.58779383543879L451.16255950462073,123.14761581039056L451.80076836887747,124.57110345643014L454.7914356281981,125.59189375862479L456.4709741640836,124.81251361547038L457.6614033114165,125.21625126898289L458.0582130262628,126.54920970695093L463.7768484679982,128.50442306464538L462.98322903644294,130.8363186349161L465.8744966443628,131.82797233760357L465.08087721373886,134.16715070605278L462.1967095816508,133.18902461836115L461.9205994401127,134.0037828492932L461.8211997896433,133.9611199037172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M543.3888684371486,156.13541011605412L545.6356160920113,150.16157382540405L550.4825323754922,152.0044003748335L550.9006420150399,150.89204493770376L554.3094189148396,152.18129505077377L563.975640470162,155.84509490337223L561.3107831766829,162.93232053378597Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M602.7186264162883,1.7734076115302742L605.1917843846604,-5.136043532751501L622.7452893070877,1.185480186715722L620.2721313396469,8.102209078148007L607.4385320367292,3.474754841532558Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.26997102610767,57.53887782013044L503.9942625602707,34.272709521465L508.990278320387,36.16551444865763L500.4079862860963,59.062273744959384L498.43813765980303,58.31826553074643L498.2961381589994,58.686627651099116Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.9689566344023,35.896005699411035L593.3995147515088,29.078159202821553L597.80071038194,30.67336106626317L610.0813005194068,35.08851995691657L607.6507424013689,41.898035952821374Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M498.61484814994037,170.91129382234067L501.13770594168454,163.8740229960531L516.8349618390203,169.51487010298297L514.3121040463448,176.55213520210236Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.1274757673964,130.63028773339465L478.82248443365097,128.73854916123673L479.97741370555013,127.81765313632786L481.30984235182405,128.32024386292323L482.089261832647,126.20894633699208L485.49803872965276,127.47738982643932L497.33921930287033,131.89873041352257L494.9086611857638,138.46153883635998L479.38180468790233,132.67186640528962L478.6875849086791,132.40964532317594Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M566.0306887971237,71.3368368879892L571.0622044317424,58.50973059143871L578.857977011241,61.33696130011231L576.2357195680961,68.60118036903441L574.2445710171014,74.14949440676719L572.266833527945,73.37010847683996L571.6933133238927,74.85812159255147L567.6605275096372,73.26397046353668L568.0999370748177,72.15160239022225Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M476.90864672046155,139.31895935861394L479.38180468790233,132.67186640528962L494.9086611857638,138.46153883635998L492.44260319229215,145.11591014219448L480.67163348570466,140.722673072014Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M566.1584883471951,111.12079842714593L567.6250276342034,107.20932079292834L569.304566170089,107.83990233205259L570.1762853255495,105.50799902528524L571.4448141977191,105.9908206583932L571.6933133238927,105.31029188074172L574.5206811558455,106.38727546622977L583.7829930214211,109.88773109437898L581.1749355290085,116.81163545371965L580.2961163967848,116.46408766834065L569.1775555061176,112.2622960084118Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M490.75596468150616,90.70388061413541L496.02177949342877,76.55945088015869L502.8740442786366,79.13173510646448L497.6019183797762,93.26991619588807Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.8828305732459,89.44271435821429L533.8149465573952,75.82272852538154L540.8731106212363,78.40229700040072L539.6826814739034,81.69049100158736L535.9409946352243,92.01499380217865L529.1873406125233,89.54885212006047Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M524.3325354680419,102.97110377345234L529.1873406125233,89.54885212006047L535.9409946352243,92.01499380217865L530.8739791242406,105.9908206583932L527.7271124152467,104.8420380987227L526.7425825446844,105.65679966192693L525.2894543232396,105.12611206481233L525.1261548968032,104.04184433631599L524.8216448575258,103.92842284636572Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.0635615279898,72.42110973224044L462.4870196701959,65.64596252841875L470.34669202566147,68.48775830166414L476.7035363325849,70.77701072813943L474.29348925314844,77.53758496278897Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.6614033114165,79.15254646539688L460.0635615279898,72.42110973224044L474.29348925314844,77.53758496278897L471.88423106167465,84.27005729358643Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.5650614080951,80.46366184111685L611.1802188763395,73.39820382976905L623.6454083640128,78.02665195195004L622.9511885838583,79.91112039098516L624.2055175052956,80.37937586056069L622.7949891332537,84.19825816201046L621.6826597126201,83.7809907454066L621.1793503714725,85.15557982819155Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M484.2437098091468,88.25959036080167L488.06349637452513,78.00480002490804L489.51583570986986,74.11411507148296L496.02177949342877,76.55945088015869L490.75596468150616,90.70388061413541Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M625.6365569159389,138.6176226772368L630.548161862418,125.66265190020204L631.2565815923735,123.77091197250411L634.0279385102913,124.8333248347044L633.3897296441719,126.49926279112697L637.1385164577514,127.93731759628281L632.1567006474361,141.10455807158723Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M497.6019183797762,93.26991619588807L502.8740442786366,79.13173510646448L503.59035287052393,77.19731918629259L506.4745205035433,78.28159111272544L504.8020819425583,82.78100563166663L508.33076952956617,84.10668825823814L504.22777285054326,95.11275787139311L504.022662460804,95.67882545758039Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M594.0732234939933,45.98020439315587L594.5828439230099,44.583755505271256L596.9005913250148,38.26955538569018L608.1895516170189,42.44433699036017L605.3621837841347,50.15394078288227L595.7661730935797,46.603507491759956Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.7421808699146,123.10495279775932L520.0804393133149,116.52131859026849L533.1412378167734,121.16950858943164L530.7958793994039,127.76042230473831Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M619.1882018186152,136.1650248481892L622.476279143244,127.47738982643932L624.0919179050252,123.1965221897699L630.548161862418,125.66265190020204L625.6365569159389,138.6176226772368Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M501.04619515221566,163.6471819728613L503.5477530201897,156.6463232417591L515.6658326182514,160.9615085539408L513.1642747512087,167.96340348059312Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M487.97829667292535,120.79490642203018L490.5863541662693,113.74301683716476L501.71911500766873,117.8959011840634L502.42753473855555,118.16540674725547L499.820266132243,125.21625126898289Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M583.9952033860609,71.72600969439372L586.5961609026417,64.8166282819584L598.2961308602244,69.24633339233696L595.6888622539118,76.15571038844064Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.9037577519193,37.25707681430504L560.0564542552456,25.76912872446701L567.1012072525918,28.341431797947735L565.6480790320784,32.38094465387985L562.955610724166,39.82937562838197Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M514.0288939317688,129.51792886620387L516.4949519243091,122.72202624659985L528.2801215816289,127.00913753919303L525.8069636132568,133.80503595806658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M485.49803872965276,127.47738982643932L487.97829667292535,120.79490642203018L499.820266132243,125.21625126898289L497.33921930287033,131.89873041352257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.0209543798119,139.2482013590634L562.5935119986534,132.41692924359813L574.0102718397975,136.74669746868312L571.4448141977191,143.57068141037598L568.4825468398631,142.45104071265087Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M511.55573596432805,58.44625576259568L513.9720941307023,52.08940482372418L526.0262739537284,56.70954260462895L523.6099157864228,63.05182132124901Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M581.5504453191534,78.23892782721668L583.9952033860609,71.72600969439372L595.6888622539118,76.15571038844064L593.2433153009042,82.6675837924704L583.8539927713573,79.11092374892905Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M566.6049978872761,119.10815585264936L569.1775555061176,112.2622960084118L580.2961163967848,116.46408766834065L577.7235587788746,123.32451122067869Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M511.6614467026666,136.34296048386022L514.0288939317688,129.6948241153732L525.5868643885478,133.80503595806658L523.220206046477,140.46045229537413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M556.1664568269625,13.877417474519461L556.7967768330127,12.18335684388876L558.3280047792941,11.453911688644439L569.1491556055844,15.478866301942617L568.4541469393298,17.364392320625484L572.7701428700238,18.97312438255176L571.4803140731528,22.43824456213042L556.3431673170999,16.78999371919781L556.8464766573161,15.415391078684479Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M549.2495033787563,34.847106675151736L553.4092998579144,23.34562709927559L560.0564542552456,25.76912872446701L555.9037577519193,37.25707681430504Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M504.22777285054326,95.11275787139311L508.33076952956617,84.10668825823814L515.1412233533338,86.66544231725857L511.03822667337954,97.67775125708431Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M516.2259417586029,46.15710177179426L518.5642002020031,39.9989891462028L530.6183800231665,44.605607538018376L528.2801215816289,50.77828408032656Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M546.6130459867418,62.53465787740424L546.9680447382852,61.57837365753949L550.695531626232,51.564956553746015L550.8651421405375,51.09669913863763L557.3071861481294,53.51290706265718L553.055089992471,64.95086181210354Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M513.9720941307023,52.08940482372418L516.2259417586029,46.15710177179426L528.2801215816289,50.77828408032656L526.0262739537284,56.70954260462895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M490.5863541662693,113.74301683716476L492.9885123837739,107.26551123103127L504.1070732763037,111.41839945595711L501.71911500766873,117.8959011840634Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M537.8895433368161,107.17394162900746L542.6804487081245,93.97125746682286L544.8348966846243,94.7579250400886L543.4314682874829,98.63403049716726L548.0448742834851,100.32078604353592L544.6573973093182,109.64007704006508Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.8859752370045,43.56399384513497L571.9552235137671,37.85228520212695L571.3391034593806,37.62544005271047L572.3520332295448,34.81172714009881L574.8393911467865,27.937688501086086L578.1132685197517,29.135390846524388L575.1936010112986,37.19984523765743L578.5384781351313,38.42564148129895L575.8886096775532,45.75335950916633Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M552.4878808772191,146.93688632315025L553.4163998337463,144.4572369288653L557.477585548535,146.0014249063097L565.9454890964553,149.21154504083097L566.4061985872686,149.38948034495115L563.975640470162,155.84509490337223L554.3094189148396,152.18129505077377L555.8043581005186,148.19179877405986Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.33738821186125,64.28489698609337L511.55573596432805,58.44625576259568L523.6099157864228,63.05182132124901L521.391568033956,68.89149923669174L510.91042712237686,64.87385963089764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M554.628128903918,63.994577925652266L558.4266155445948,54.186156923417L564.4505499107763,56.539929491933435L561.1056727878749,65.16417865734547L559.773244141601,68.61470777262002L555.138538219966,66.80099500296637L556.0173573512584,64.53359323507175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M576.5402296083048,46.17895380221307L580.1052059577778,36.44855065876618L582.8331741392612,37.45478590019047L584.4843127764761,33.11038760468364L587.5459797848016,34.23004596447572L584.5056127011776,42.522379994392395L582.3724646493793,48.332939175888896Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.7652394352481,96.37392309308052L637.6560257496312,85.89230119390413L644.331580045633,88.40110740391538L640.4478937061504,98.868157599587Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M572.7843428188935,90.42084662197158L574.1096714902669,86.88500189362094L584.8669225415215,90.96610327111557L586.1709512881935,87.50830131582916L590.7346574580297,89.23772279219702L588.1131889019161,96.22512226039544L587.8291899003088,96.12522799149156L578.5037671467289,92.58938617212698Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M580.0058063073084,6.677656934596598L580.5304155731574,5.323863866273314L580.0342062078416,5.139681390952319L581.0408248882741,2.5038943621329963L582.7337744897231,1.170912069734186L587.6950792614371,3.084537624847144L593.5912140775472,5.366527601610869L591.4012662246823,11.078263013157994L585.9516409495845,8.96692977566272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.889507111162,101.35510725853965L604.3555651037022,94.68716658558697L614.2631858093664,98.37180812703446L611.8034389056265,105.0553537150845L607.8992415266111,103.59544231323525Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M591.3799662999809,127.81036921124905L593.6338139278814,121.8500358085148L604.6458751931787,126.0528622167185L602.3928164513782,132.01215144386515Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M587.6027795858681,1.5965090999379754L588.7506088819355,-1.366021370049566L590.9050568584353,-2.811387062072754L600.2028685985133,0.7744512460194528L597.8220103066415,6.996074021328241L593.5912140775472,5.366527601610869L587.6950792614371,3.084537624847144L588.1770886769518,1.8160713710822165Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M597.80071038194,30.67336106626317L599.6995592573658,25.33624914707616L611.9809382818639,29.75869546364993L610.0813005194068,35.08851995691657Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M575.9170095780864,99.46336069470271L578.5037671467289,92.58938617212698L587.8291899003088,96.12522799149156L585.2495323065668,102.99295562552288L576.965439222753,99.85981587646529Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M572.5437325546518,10.192731015849859L573.0746529093012,8.810843016020954L572.600532354787,8.63394468370825L573.5353623991832,6.188584910705686L575.5343998121098,4.948214859701693L580.0058063073084,6.677656934596598L585.9516409495845,8.96692977566272L583.8113929210231,14.550671184901148L578.1629683459178,12.368579709436744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.7049077600241,22.672374242451042L603.5832455977798,17.31444461736828L615.4749148814008,21.5173344113864L613.5965770436451,26.87422020966187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M540.7382110944018,59.239170792512596L544.4585980083793,49.22575030988082L550.695531626232,51.564956553746015L546.9680447382852,61.57837365753949Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M562.6006119726226,40.82104234909639L562.955610724166,39.82937562838197L565.6480790320784,32.38094465387985L566.4984982628375,32.67854906106368L567.3702174182981,30.24776582373306L569.8504753615707,31.147863313555717L568.9716562302783,33.585930256638676L572.3520332295448,34.81172714009881L571.3391034593806,37.62544005271047L569.2974661951885,43.266389903146774Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M581.373734829016,85.70083689363673L583.8539927713573,79.11092374892905L593.2433153009042,82.6675837924704L590.7346574580297,89.23772279219702L586.1709512881935,87.50830131582916Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer school"
        d="M615.9001244967803,60.62104873871431L635.8486876618117,5.784840320236981L641.8174000009894,7.95548750506714L641.8174000009894,70.04132832633331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M564.9680592017248,12.233304583001882L566.0093888724223,9.504908784292638L567.6960273832083,8.329055193811655L572.5437325546518,10.192731015849859L578.1629683459178,12.368579709436744L576.0937200682238,17.747324695345014L565.0106590511277,13.473673331085593L565.4145687427372,12.410202824044973Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.37597489356995,85.63736231252551L480.5367339598015,79.8195504299365L482.0608619330451,75.75092930579558L488.06349637452513,78.00480002490804L484.2437098091468,88.25959036080167L479.8851140299812,86.61549511412159L480.02001355495304,86.24713447922841Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M574.5206811558455,106.38727546622977L576.965439222753,99.85981587646529L585.2495323065668,102.99295562552288L586.2277510883287,103.36859931796789L583.7829930214211,109.88773109437898Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M612.9591570636258,136.4844765421003L615.439415005967,129.95080193597823L617.1402534674853,125.45037747826427L622.476279143244,127.47738982643932L619.1882018186152,136.1650248481892L618.2951827384531,138.51772901928052Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M602.6405266905203,16.882605092599988L604.2845653537661,12.30406388035044L617.1189535427839,16.925268756691366L615.4749148814008,21.5173344113864L603.5832455977798,17.31444461736828Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M605.8299932498485,7.974217920564115L607.4385320367292,3.474754841532558L620.2721313396469,8.102209078148007L618.6635925536975,12.594385106116533Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.477585548535,146.0014249063097L560.0209543798119,139.2482013590634L568.4825468398631,142.45104071265087L565.9454890964553,149.21154504083097Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M507.3533396339044,74.22753704991192L509.1953887110576,69.38056683633476L520.640548452735,73.76032173400745L518.797710490413,78.61457286216319Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.7057473370805,115.40895745903254L559.9649434667081,104.07722351374105L564.8828595010564,105.93358964892104L563.3382204892114,110.04381558159366L560.6236633714288,117.27988842967898Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M593.6125140022486,52.47129470575601L595.7661730935797,46.603507491759956L605.3621837841347,50.15394078288227L603.2077358076349,56.02172498870641Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M604.2845653537661,12.30406388035044L605.8299932498485,7.974217920564115L618.6635925536975,12.594385106116533L617.1189535427839,16.925268756691366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.1056727878749,65.16417865734547L564.4505499107763,56.539929491933435L570.5446951417252,58.913472110871226L567.206917992793,67.53771831933409Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.1953887110576,69.38056683633476L510.91042712237686,64.87385963089764L521.391568033956,68.89149923669174L522.348486890085,69.26714477781206L520.640548452735,73.76032173400745Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M551.1838521314785,113.70035376632586L555.4430482601747,102.35508969286457L559.9649434667081,104.07722351374105L555.7057473370805,115.40895745903254Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M622.2285689041018,85.71540482668206L622.7949891332537,84.19825816201046L624.2055175052956,80.37937586056069L624.5668273456395,79.40124217886478L631.1429819921032,81.84553555306047L628.1531036198139,89.9536323971115L622.9014887576923,87.99736759951338L623.5531086884439,86.2044712388888Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M510.37240679282695,140.04943161644042L511.5841358648613,136.5698024025187L525.3675540480763,141.33868374302983L524.162924952805,144.82559446850792Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.21668863575906,143.45101721817628L510.40711778216064,140.14100078167394L524.1274250773713,144.89635241311044L522.887296105735,148.36869354499504Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M538.010242911987,130.3264441685751L540.6112004304305,123.43064846657217L547.1731551270932,125.91758931009099L544.5792975844815,132.82795037515461Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M576.2357195680961,68.60118036903441L578.857977011241,61.33696130011231L584.9947220925242,63.56274130893871L582.3866645991802,70.82591747725382Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M543.5734677892178,135.49178294930607L544.5792975844815,132.82795037515461L547.1731551270932,125.91758931009099L549.2211034782231,126.68344204127789L550.1070225862786,128.05802261736244L551.5672507816926,128.61056022904813L548.3067844724283,137.29195047356188Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M548.3067844724283,137.29195047356188L551.5672507816926,128.61056022904813L553.309900207445,129.2629915899597L554.8624280812219,128.8311590361409L556.6342662936077,129.5044015813619L556.4141670679674,130.07046636240557L553.8487094240263,136.8954974352382L553.0266900928691,139.07754970854148Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.6236633714288,117.27988842967898L563.3382204892114,110.04381558159366L566.1584883471951,111.12079842714593L569.1775555061176,112.2622960084118L566.6049978872761,119.10815585264936L566.4629983883351,119.48379867523909Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M553.8487094240263,136.8954974352382L556.4141670679674,130.07046636240557L562.5935119986534,132.41692924359813L560.0209543798119,139.2482013590634Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M607.9907523170114,82.02347258618101L608.5650614080951,80.46366184111685L621.1793503714725,85.15557982819155L619.9392214007676,88.51452914625406L608.2605513678864,84.17744682030752L608.6431611329317,83.12855510320514Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M476.21442694123834,108.6338522741571L478.67338495887816,101.97216199198738L484.78173013869673,104.25411941250786L482.31567214708775,110.90123962098733Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M606.0990034146234,87.15346809383482L606.6733125066385,85.59469906892627L607.8566416772082,85.26171765848994L608.2605513678864,84.17744682030752L619.9392214007676,88.51452914625406L618.7132923780009,91.84538155375049Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M583.9746923465282,21.162497812882066L585.0870217671618,18.18644820759073L593.024004961364,21.162497812882066L590.9831565842032,26.63384721800685L590.5792468935251,27.73893856583163L585.8806411987171,25.96787871280685L587.213069844991,22.382053438574076Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M582.3724646493793,48.332939175888896L584.5056127011776,42.522379994392395L587.3337694210932,43.56399384513497L587.8646897757426,42.11135350773111L590.9334567589685,43.24453786527738L588.2756994413212,50.508775897324085Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M565.6906788814813,103.81500135315582L568.1993367243558,97.13145456975326L573.9534720405936,99.30727597232908L571.6933133238927,105.31029188074172L571.4448141977191,105.9908206583932L570.1762853255495,105.50799902528524Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M602.2508169515058,132.39507748559117L602.3928164513782,132.01215144386515L604.6458751931787,126.0528622167185L606.4532132800668,126.739632319659L607.4598319614306,126.18709456129L609.6213799146935,127.00913753919303L610.1665002191439,128.1287807333283L607.7572420276701,134.50012977002189Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M472.53585099149495,84.54580756602809L475.06580875907093,77.77067221375182L480.5367339598015,79.8195504299365L478.37597489356995,85.63736231252551L478.013876167126,86.60092717874795Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M536.288104524836,68.99763731658459L537.8753433870152,64.62516339868307L546.2375361965969,67.68651977134869L544.6502973344177,72.0589917586185Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M588.2756994413212,50.508775897324085L590.9334567589685,43.24453786527738L594.5828439230099,44.583755505271256L594.0732234939933,45.98020439315587L595.7661730935797,46.603507491759956L593.6125140022486,52.47129470575601Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M607.7572420276701,134.50012977002189L610.1665002191439,128.1287807333283L611.6977281663567,128.71773795317858L612.4700476722792,127.9019385385327L614.83670601435,128.80930726928636L615.439415005967,129.95080193597823L612.9591570636258,136.4844765421003Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M443.7146857017651,7.663084927946329L445.4794239383191,1.9721582890488207L451.0355488387868,3.701601108070463L449.263710626401,9.40605384344235Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M593.6685249162838,166.68039963394403m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.9032439459115,103.25829950999469m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M518.484522704035,154.4705198360607m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M456.0623311577365,116.51715634390712m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M610.8189090350643,112.29767514625564m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M623.8457854362205,168.08722946885973m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M473.29397054575384,157.60259434394538m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.0054662041366,149.8140277150087m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M536.7764250291511,99.98052138602361m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M465.1005993662402,-9.087128855288029m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M544.2889874931425,75.78734919894487m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M479.84488083794713,66.3868482480757m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M613.7772319633514,94.10549043258652m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M452.191266996786,127.6261899904348m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M557.4696966875345,159.53386615822092m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M502.1309135593474,46.85220437310636m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M600.5255230199546,35.492262840270996m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M507.7249049944803,170.21308199781924m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M487.9262301903218,132.15470815263689m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.0375752616674,64.96855150070041m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M485.909048397094,138.89024911029264m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M496.81303226575255,84.91833055997267m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.2819671370089,85.56660376489162m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M468.3839433733374,71.59906028071418m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M489.86373448651284,83.13271737191826m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M631.3899033460766,133.2774721942842m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M502.96634395513684,88.68830374162644m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M601.3861977700144,43.514046331867576m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M525.4417093442753,122.13723075995222m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M624.5226497221738,131.82172897923738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M508.3560138856992,162.30486567132175m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M495.20291570574045,119.47963642701507m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M560.7759183915332,34.81901116296649m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M492.6587579883635,126.34630035841838m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M518.7906105155125,57.57737895241007m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M588.6196537874639,77.19731918629259m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M518.6249444326386,135.07451861631125m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.8364889211953,17.077193027362227m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M552.138404328376,57.546161820180714m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M542.9660254810005,103.74736468493938m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.7743948921561,36.00526600377634m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M560.357019864954,150.78486755816266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M516.4736519986764,63.66887946706265m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M559.5381560781971,60.267254712525755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M582.1215988658369,39.98858340969309m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M639.0491986265406,92.38751639425755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M583.0722066331655,91.7777447681874m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M586.7996935211122,6.022092297673225m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.0775297889486,99.86397813586518m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M593.7489913003519,2.4508248162455857m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M604.8904298879206,30.215507993940264m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M581.873888624832,97.79429454402998m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M579.2476867511868,9.579830422997475m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.5903057632968,22.094854350667447m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M568.0533927930519,36.218583738896996m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M587.3045806344599,84.18473079241812m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M600.0640246430412,119.600341594778m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M571.5773470643908,12.941938097123057m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M482.87972571793944,82.72793669719249m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M580.3742161225528,104.87741727335379m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M617.312230640091,133.05791408661753m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M609.8730345852673,16.903416636399925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M613.0514567382634,8.037693208549172m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.9816439654678,144.22623303625733m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M513.9965496016666,73.99444967973977m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M559.5223783552647,112.72638704208657m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M611.4744733963162,12.449744783341885m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M565.8263672934845,62.03830580320209m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M515.7723322436213,69.32333552464843m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M555.5732144694775,108.88879030989483m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M517.8691915338859,140.69353743083775m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M516.6337958797812,144.17316457489505m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M542.5936712352559,128.12253737077117m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M580.617981932126,66.08196129836142m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M552.4342366214842,133.4835030194372m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M564.8994261091575,114.77109267283231m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M558.2207162678242,134.65621369984m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M614.7207397548482,84.66651334194466m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M480.4957118816674,106.44346590898931m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M586.5961609026417,45.94794663274661m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M606.279658335261,130.07046636240557m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M541.2628203611821,68.34207857307047m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M592.0197529383004,48.55666225636378m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M594.2144341077656,121.14869735669345L596.7940916996449,114.4797351649031L602.7612262675539,116.81163545371965L605.9144040644169,118.05198548734188L603.3355353586376,124.70637639053166Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M776.9583246530965,179.61344214202836L791.13224146422,137.74563423916698L815.3897005841136,92.35525885410607L818.097157727927,61.202727700117975L812.6830323273316,49.694007851649076L858.4912823121995,54.58365526376292L858.4912823121995,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M736.893165579997,162.7086011446081m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer school"
        d="M641.8174000009894,7.95548750506714L680.4452085746452,22.00640535634011L660.5108453594148,76.83520146273077L641.8174000009894,70.04132832633331Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M742.8934333622456,172.42113762814552L754.1397938048467,139.96410580119118L766.8250825181603,144.36462726118043L770.9848789973184,132.37426628824323L773.8690466294065,133.37320368783548L760.8011481501162,171.0673769316636L760.1211283216253,170.83325226418674L758.1859906837344,176.42518770787865L756.2942417804152,174.22129556443542L752.8073651585728,171.98826721310616L748.2578589376062,171.78327808808535L744.2471619341522,172.89563016965985Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M732.1850932501256,132.3596984501928L735.1970604341477,123.65749080572277L737.0114984959364,124.29535477701575L738.1593277929351,120.99261312233284L770.9848789973184,132.37426628824323L766.8250825181603,144.36462726118043L754.1397938048467,139.96410580119118Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M746.3306101616472,179.48649470321834L746.8828304409981,177.17646711412817L748.357258589007,175.80085572460666L750.8943163314834,175.48973026825115L754.0687940539792,176.64474444044754L755.3870227504522,178.8267841981724L755.3302229512483,179.61344214202836L746.3771544415504,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M770.5099695567042,5.2177248117513955L757.4704709770158,43.337148882914335L733.3755223965272,109.92311024758965L712.9236498903483,165.75950865028426L708.4806432966143,178.5083750076592L708.0696336310357,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M788.832638441585,-37.06008652690798L824.8721116753295,1.5465612839907408L858.4912823121995,36.94906686292961"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M796.1566571239382,31.757640273310244L795.8450471097603,38.82938417093828L796.5534668406472,43.73360727541149L798.8570142928511,49.19765485543758L800.430053204298,55.42651816410944L801.6133823748678,62.04558979533613L801.9462923165411,69.99658385012299L801.1739728096873,76.35341836558655L799.1047245319933,85.50312918331474L794.1584085971117,99.79634142573923L784.2152880160138,128.61056022904813"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M778.9928619414568,179.61344214202836L780.898810791783,174.39818967320025L793.3647891664878,140.99113718792796L795.256538067013,132.77071958733723"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M844.2968544615433,6.727604714222252L802.4377683643252,-37.06008652690798"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M743.2192433271557,177.29613072471693L712.9236498903483,165.75950865028426"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M641.8174000009894,-30.874850244726986L642.5029420340434,-32.67506144475192L645.7673527738079,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M848.7327610813081,37.220656719990075L858.4912823121995,51.42968219285831"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M770.5099695567042,5.2177248117513955L757.3284714780748,-14.986185641493648"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.4912823121995,19.74939469760284L844.2968544615433,6.727604714222252"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M722.5212383540347,-37.06008652690798L752.5880548171699,-7.581408163998276L770.5099695567042,5.2177248117513955"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,144.9785564923659L839.6976484162733,153.27283914620057L826.2613401226699,155.186422706116L815.0993904946372,154.84616074198857L800.9617624450475,165.29854283528402L791.7136505292729,174.19944393774495L780.898810791783,174.39818967320025"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.4912823121995,120.44423715071753L857.9950729459524,121.14869735669345L853.7926766164601,126.17356726992875L846.9964227434248,132.3461711704731L841.9578071329743,135.4283088245429L836.0971721913666,137.40537141775712L830.1726374756545,138.4761066623032L822.795763422735,139.1701594479382L815.8433101000264,138.56039193458855L809.3452551783994,137.561455281917L802.9103111466393,136.00998151069507L795.256538067013,132.77071958733723"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M810.0465749343857,87.84856658661738L811.988023661077,72.93827244034037L812.3714223131537,69.86963440058753L812.562332753092,64.06533669633791L811.7190134953707,56.199662684928626L810.5427842997015,50.23198369657621L808.1477260570973,42.487000499852L805.1073589744046,38.114509858656675L796.1566571239382,31.757640273310244"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M757.3284714780748,-14.986185641493648L754.0687940539792,-18.288993661291897L737.4012082358822,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M777.2304903622717,-37.06008652690798L848.7327610813081,37.220656719990075"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M796.1566571239382,31.757640273310244L770.5099695567042,5.2177248117513955"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M784.2152880160138,128.61056022904813L771.9559978041798,165.97906572092324L767.7046905355528,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M790.9113533524796,179.61344214202836L791.7136505292729,174.19944393774495"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M795.256538067013,132.77071958733723L799.1370688630268,122.76781094353646"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M799.1370688630268,122.76781094353646L803.7039305772632,110.99384973431006L807.1837072260678,99.17304310807958L809.3239552536979,89.90368521772325L810.0465749343857,87.84856658661738"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M641.8174000009894,154.03556718723848L708.4806432966143,178.5083750076592L723.6635454464704,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M848.7327610813081,37.220656719990075L858.4912823121995,46.58893947536126"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.4912823121995,117.86364376172423L855.3799154786393,120.241327626165L851.7021284140646,122.75012139976025L848.4921508152038,124.43687108112499L843.4606351805851,126.35046260477975L839.0026397500187,127.00913753919303L833.8717244639993,127.00913753919303L830.1229376513511,126.25160933006555L826.3528509112075,124.9259347608313L822.2569542080164,122.72931017447263L818.607567043975,119.58993597747758L815.6097998097539,116.07491737417877L812.7611320521683,112.04273723484948L810.5427842997015,107.79723922768608L809.5361656183377,103.30928715644404"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M809.5361656183377,103.30928715644404L809.2742554275319,102.14177399268374L808.70704631228,97.77660493878648L809.3239552536979,89.90368521772325"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M824.8721116753295,1.5465612839907408L833.5246145743877,6.528854173142463L841.993307008408,13.296775116119534L858.4912823121995,30.757647652179003"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M757.3592380359769,179.61344214202836L757.371071328409,179.3304117829539L756.7194513976574,176.33257846580818L752.0634455522522,173.78842525882646L748.4211583640426,173.4908269108273L744.7993822135031,174.82377606490627L743.2192433271557,177.29613072471693L743.6334085371345,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M841.7992410240695,35.65251129725948L843.4464352307841,35.67644450860098L858.4912823121995,36.053132423665375"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M796.1566571239382,31.757640273310244L804.3705393439159,33.82630300708115L812.0306235104799,35.23003808222711L841.7992410240695,35.65251129725948"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.4912823121995,22.144802019000053L844.2968544615433,6.727604714222252"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M795.256538067013,132.77071958733723L794.0369201358408,132.3107921378687"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M794.0369201358408,132.3107921378687L784.2152880160138,128.61056022904813L733.3755223965272,109.92311024758965L641.8174000009894,77.12031714431942"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,154.05949998740107L708.4806432966143,178.5083750076592"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,0.9128483347594738L757.4704709770158,43.337148882914335"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M842.380650090985,36.26228786073625L843.4464352307841,35.67644450860098"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M816.8909508595243,75.0818438148126L818.5862671192735,72.37116242898628L821.8601444913074,65.48259305441752L826.2542401477695,53.98844831530005L827.4162693936378,51.26631238637492"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M810.0465749343857,87.84856658661738L811.761613345705,83.97869850415736L814.469070488587,78.95483856834471L816.8909508595243,75.0818438148126M827.4162693936378,51.26631238637492L828.5001989146695,48.729397282004356L830.9662569062784,44.739841458853334L833.9924240410328,41.46619795681909L838.0465097799897,38.64520258642733L842.380650090985,36.26228786073625"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M839.6976484162733,153.27283914620057L842.0359068587422,166.23400164721534L845.6994939716533,174.60317872092128L850.9708309862763,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M746.6209202511236,104.52362550608814L762.9413961786777,59.42335182754323L763.4376055439934,59.60128943854943L769.8370497003198,41.9198879939504L782.599649255164,46.582696037366986L788.3048736313358,59.14031656133011L785.2716065235436,67.53771831933409L790.2108224835247,69.33790349541232L773.5219367397949,115.4578638956882L748.8810789678246,106.47884507663548L749.2431776942685,105.47990380134434Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M624.495827594772,56.84377629077062L627.5645945779979,48.29027570504695L628.4647136349231,48.60973145021126L637.4785263743252,23.522525055333972L636.6139071928337,23.21035218704492L639.8956734267995,14.076167804189026L652.4034627657384,18.60476015228778L660.8224553735927,21.65156878065318L662.2187837958336,17.329012698028237L677.5326410420239,22.87008374137804L670.32537750341,42.91155441803858L663.0550030767918,40.27578175533563L661.1624652892351,45.54108264204115L655.6560402130708,43.55670983158052L652.3679628903046,52.712707372847944L654.6005105925724,53.52019106363878L653.1402823952958,57.57425723783672L650.9148346679285,56.75949002197012L650.7665240783244,57.176759069785476L647.9383673602715,56.15699926018715L645.0257998257875,64.27136957645416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M693.045297589153,8.016881638672203L698.7221220657229,-7.431564518716186L714.8295987406746,-1.479444582015276L726.4948577107862,2.836879753973335L728.1317963972688,2.3967146882787347L729.2086259424686,2.8077435330487788L730.7043540142477,2.0574858016334474L732.2134931506589,4.728652685415L731.5831731455401,6.436242661438882L735.926780089736,7.477861935738474L744.1903621330857,-1.9612331232056022L759.5184193300083,13.118836321402341L751.8504463015124,34.03233678871766L727.7136867558584,25.10316013544798L729.6338355587795,19.873223334085196L720.1877132290974,16.371681667864323L719.6418040376157,17.853463555220515ZM737.3586083874106,15.36544336238876L741.149995050393,17.50591081008315L743.0843438021839,19.42681589256972L749.044378394261,13.32487071538344L744.1051624342799,8.463289814535528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M609.7128907032311,210.15776100428775L617.5512631321326,188.27395747881383L627.1180850379169,161.67741075204685L629.7119425805286,162.61287005571648L630.767472201027,159.67226007767022L631.1713818917051,159.81377566000447L637.0320168342441,161.93963072635233L637.3231158088893,161.12487577553838L637.4146265992895,160.86993966111913L641.7661224035546,162.43597564660013L641.6738227279857,162.6981955920346L641.383512637578,163.5129503547214L647.18024780415,165.61070930445567L647.6693571945652,165.7876036320813L641.4474124126136,183.1357123912312L642.3759313691407,183.46868910314515L639.6897741518915,190.9596203151159L640.7673925831914,192.81596317980438L631.6888911817223,218.10858516115695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.4194938074797,-7.2692339066416025L642.88555180002,-13.979942930396646L644.586390260607,-13.356634437572211L645.3239987781271,-15.361835749354213L644.2392803709954,-15.76558159571141L647.0950481034815,-23.561627119779587L666.4771910402924,-16.403458456508815L664.7905525276437,-11.790559090673923L665.8965708604082,-11.386813476216048L665.3080618185923,-9.798886368051171L668.5046283528209,-8.60846156347543L670.2898776279762,-13.477341920137405L677.0719315521419,-10.968499746639282L680.9201180152595,-21.463811551686376L692.2942780070007,-17.26818231958896L682.8970666173846,8.407098578754812Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.9698685314506,143.8120909044519L647.2086477028206,109.29981283983216L645.6853086175397,108.74727368820459L647.6764571694657,103.15528364852071L654.7701211078092,105.7067467267625L655.9960501277819,105.54337819712237L656.6129590701312,105.54337819712237L657.8317881152034,105.72859856765717L658.993817362003,106.14586466597393L660.057235843502,106.77644630242139L660.9707659631968,107.61305947555229L661.3683645650744,108.08755645295605L668.3484289031476,110.59635462937877L666.3430804004893,116.18833866622299L665.3080618185923,115.81269566714764L653.0905825700611,150.28227845858783Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M686.7594530321658,52.76265482325107L695.256545365788,29.65255678538233L695.71725485567,28.412190930452198L723.3550909766927,38.65248660556972L720.9032329339534,45.33504920499399L719.9818139532581,45.002065856941044L713.4908590065315,62.66264802822843Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M707.1056147990748,95.88485739845783L718.0829650759697,67.43886420642957L719.8895142776892,66.58143479330465L720.7257335586473,66.19850511662662L721.0807323092595,66.02889223583043L739.1659464742988,73.05897841928527L728.3298068111762,102.61731190886348L725.8708487935364,102.66621843213215Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M662.558793711476,193.46110464027151L666.4629910895601,182.22210745932534L663.8131226329133,181.2939346707426L666.3572803512216,173.9590760571882L667.172199706547,171.64800607366487L667.2573994062841,171.38578646676615L696.8082843525335,181.76114273630083L696.6457738121971,182.24291850673035L688.5596911441535,205.44511665031314L672.9263350209221,199.95309739606455L673.8051541540772,197.40166900865734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M703.1935285599902,130.53871844243258L710.712402112782,110.17180485464633L722.6395712709054,114.60772435646504L715.1206977171823,134.96734099229798Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M687.9995820028707,84.32624791562557L692.7833873983473,71.35764826880768L691.4296588273719,70.86129682604223L695.7243548315018,59.239170792512596L706.8287157732993,63.36399239720777L704.8091673217714,68.86340386467054L702.6058084042743,74.8373102224432L701.2875797087327,74.3336750450544L696.4398745372891,87.45835411641747Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M685.2929137460887,127.96645329147577L691.9684680430219,109.63279309822246L690.4301401209086,109.05840214388445L692.3794777086005,103.7015798590146L702.2721095783636,107.32274222979322L693.6409066049382,131.02778168953955Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M651.5956433843821,101.27810548152775L653.9836016511545,94.72982977097854L653.5086922114715,94.56646098475903L653.0408827457577,93.04307286115363L653.8700020508841,90.78920703567564L654.947620482184,90.45622587157413L655.3231302741915,89.41461906628683L671.3177962359041,95.28965399926528L670.9280864940956,96.35207122331485L671.3532961113378,96.50815601181239L671.7430058512837,97.2667280412279L670.7363871689886,100.00965719809756L669.836268113926,100.24274369329214L669.1633482575417,99.99508929206058L666.6759903393686,106.81910941563547Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M679.7083889432251,50.15394078288227L684.4708944140002,37.18527719937265L688.2054812787101,27.037590594030917L695.256545365788,29.65255678538233L686.7594530321658,52.76265482325107Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.309397152625,109.98762516770512L640.4478937061504,98.868157599587L644.331580045633,88.40110740391538L645.2600990021601,85.90686912974343L651.8859534747899,88.38029607152566L642.9494515741244,112.46000295411795Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M695.2281454652548,135.0953298052773L697.672903534025,128.47632793104276L698.2543125990778,128.6958861835301L703.1935285599902,130.53871844243258L715.1206977171823,134.96734099229798L712.6830396251753,141.58633666764945L705.3834764109924,138.8725596102886L706.1060960926116,136.8028876655735L702.9742182185873,135.70509762316942L702.2721095783636,137.71753914328292L698.8278328040615,136.43452969752252Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M667.0657000802457,119.23510439973325L674.2658636439592,98.4779457533732L674.6626733597368,98.61321919551119L675.3000933388248,96.7568511031568L680.0980986850336,98.43632315518335L678.4966598739848,103.04186214366928L677.9365507317707,102.85768226440996L676.8455212367699,105.99706404004246L677.4048414910212,106.18852778151631L676.4629114717245,108.88150636712089L673.6631546523422,107.90337670827284L672.9050350962207,110.07919473014772L675.7111030044034,111.05732408259064L674.7478730585426,113.83562691463158L674.1806639432907,113.6368794455193L673.2663449374959,116.27262421138585L673.0754344984889,116.81891938764602L673.6418547276407,117.03119407454506L672.2463151924312,121.04256007820368Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M672.2463151924312,121.04256007820368L673.6418547276407,117.03119407454506L674.733673109673,117.4068370074965L675.1872826255858,116.0822013085708L675.8460025293753,114.21751339547336L674.7478730585426,113.83562691463158L675.7111030044034,111.05732408259064L678.9644693396986,112.19778111157939L679.715488919057,110.01572037348524L676.4629114717245,108.88150636712089L677.4048414910212,106.18852778151631L678.6591704124585,106.63492963695899L679.7509887944907,103.4882641993463L678.4966598739848,103.04186214366928L680.0980986850336,98.43632315518335L685.4341243607923,100.3072587014176L677.5894408421591,122.9207734526135Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M698.2543125990778,128.6958861835301L705.7731861528009,108.32896718289703L710.712402112782,110.17180485464633L703.1935285599902,130.53871844243258Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M653.1118824947625,71.32955290656537L658.5970076462254,56.22047411091626L665.0887514781207,58.595057408791035L659.6178262783214,73.70309045817703Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.8916891878471,180.45004652347416L649.3346957806498,167.68661597324535L656.0031501026824,170.011214483995L655.6773401377723,170.9331454592757L652.1904635140672,180.95367398578674L651.5530435331166,182.78192461887375Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer bridge"
        d="M808.9847342241555,-37.06008652690798L858.4912823121995,14.788963441736996L858.4912823121995,51.655486319214106L851.9640386048704,46.2996602463536L772.3717407854274,-37.06008652690798Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M694.7816359251738,147.3832855555229L696.8224843014032,141.87040912779048L711.0666119772941,147.16372789628804L711.3009111536667,147.2563375243917L709.2671627514064,152.76920966804028Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M679.4393787803128,160.7918979935348L684.6405049292371,146.29278108943254L690.1824298808351,148.29065173584968L687.0497631225735,157.02820736402646L684.98761481978,162.78976445831358Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M688.821601334028,163.55561311589554L690.8482497613877,158.04899288667366L705.3337765876204,163.43490871414542L703.2929282095283,168.93424078496173Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M667.4838097216561,76.53759894799441L671.1970966598019,67.16207268461585L672.8766351975501,62.91758775385097L678.5037598479539,65.15689466660842L677.3417306020856,68.06944936560467L673.2663449374959,78.39501302363351L673.1038343980908,78.7914694105275Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M696.8224843014032,141.87040912779048L698.8278328040615,136.43452969752252L702.2721095783636,137.71753914328292L705.3834764109924,138.8725596102886L712.6830396251753,141.58633666764945L713.0727493651211,141.73513652710244L711.0666119772941,147.16372789628804Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M692.818887273781,152.72030350053683L694.7816359251738,147.3832855555229L709.2671627514064,152.76920966804028L707.2965252390131,158.11246680282056Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M690.8482497613877,158.04899288667366L692.818887273781,152.72030350053683L707.2965252390131,158.11246680282056L705.3337765876204,163.43490871414542Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.0097687849775,150.0335852908902L661.4669753294438,136.9662554585375L667.4696097709239,139.02864344138652L663.0124032273889,152.09596938453615Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M656.4141597691923,185.3614532891661L657.321378801018,182.75278915371746L660.7656555734575,172.86753521952778L661.0346657382324,172.08816038630903L666.0377814751118,173.8456557104364L666.3572803512216,173.9590760571882L663.8131226329133,181.2939346707426L661.7225744305179,187.2885551629588L661.3825645148754,187.16160786245018L660.4611455341801,189.80460853036493L660.3191460333765,189.76194592844695L658.4344971068203,189.0959930960089L658.2001979313791,188.06792828487232L658.8526067472994,186.2188680130057L658.1291981805116,185.96393282106146Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M673.2663449374959,78.39501302363351L677.3417306020856,68.06944936560467L684.4992943145335,70.91852812515572L680.4168086750433,81.24408754101023Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.9578506574035,34.769063585903496L682.1886468864977,23.281111372169107L688.7016906449571,25.69836956495419L688.2054812787101,27.037590594030917L684.4708944140002,37.18527719937265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.7652394352481,96.37392309308052L637.6560257496312,85.89230119390413L644.331580045633,88.40110740391538L640.4478937061504,98.868157599587Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M672.7630355963483,158.15512960078195L673.5850549265742,155.72439036658034L676.8384212618694,146.20745535148308L682.7061561774462,148.22717772843316L678.637870487757,160.1675646053627Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M663.0124032273889,152.09596938453615L667.4696097709239,139.02864344138652L672.7559356214479,140.84962122142315L668.2987290769815,153.91798428772017Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M683.0674660168588,108.38515761308372L685.6755235111341,101.23544233478606L692.3794777086005,103.7015798590146L690.4301401209086,109.05840214388445L688.0776817277074,115.52237876225263L683.9320851992816,113.99067074758932L685.6258236858994,109.3206241056323Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M722.107862030156,179.33769565215334L722.1646618302912,179.2024237839505L722.5188716948032,178.21077685896307L722.1504618804902,178.07654552301392L722.8304817099124,176.23372590448707L723.4047908009961,176.44599877251312L724.3262097816914,173.9445083066821L724.4256094330922,173.67500491207466L735.1260606832802,177.62910771695897L734.0066312877461,180.6976980501786L734.6724511682987,180.93910625204444L734.1833417769521,182.28558115521446L733.695021272637,182.10868724808097L733.5672217216343,182.4489478743635L733.2059118822217,183.44059419305995L724.319109806791,180.15244845859706L723.1215806864202,179.71333520719782Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.0883135776967,48.53168851789087L724.0777106564492,38.114509858656675L730.101645023562,40.43186780717224L729.6338355587795,41.664947495330125L726.1264478946105,50.84904298372567Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M662.2676947358996,74.46166498027742L667.6542091220617,60.827081720810384L670.6582874441519,62.024778387043625L668.9716489324346,66.28383183898404L671.1970966598019,67.16207268461585L667.4838097216561,76.53759894799441Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M735.5512702986598,141.01298891939223L736.2391789909452,139.11396926781163L736.643088680692,139.25548527156934L737.6134186014533,136.58332967339084L748.3785585137084,140.50207464117557L747.2938401056454,143.53530243225396L747.9675488481298,143.78399583650753L747.4713394828141,145.179384178482L746.8047307161614,144.92444747779518L746.37242112495,146.13669742178172L737.7128182519227,142.98276601312682L737.2521087611094,142.8131550089456L735.6861698254943,142.2387668043375L736.0190797643736,141.3178725731559L736.0616796147078,141.20445169182494Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M726.6644682241604,166.94261941919103L727.52198742982,164.57639767974615L727.0328780403361,164.39846276585013L727.7349866805598,162.45678675314412L728.2169960960746,162.63368116132915L728.6280057616532,161.5213274313137L730.7256539389491,162.29446011781693L739.3355569895357,165.42653108760715L738.9671471724287,166.43274760898203L739.8317663539201,166.75844123819843L739.2787571875378,168.26828595018014L738.3999380571768,167.94259239174426L737.3515084115788,170.84782002167776Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M715.3684079581872,64.87385963089764L717.9906654004008,57.87186056608334L717.0692464187741,57.51702582882717L718.508174690418,53.69812882319093L724.5597200728953,55.98634556401521L720.7257335586473,66.19850511662662L719.8895142776892,66.58143479330465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M734.1344308387488,152.96795601770282L734.9351502433419,150.75677251815796L734.5667404290289,150.61525674862787L735.2325603095815,148.7869976335205L735.7571695744991,148.97117629181594L736.2036791155115,147.7662107446231L745.5156908044592,151.16779256192967L745.9756114101037,151.33844391535968L747.5707391323522,151.9190747095272L746.6138202762231,154.56208881316707L745.0265814149752,153.98145824065432L744.0838625095785,156.6036604354158L743.6018530931324,156.42676587309688Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M732.2489930251613,158.21236017951742L732.8730019424111,156.4902398060076L732.4825033163652,156.3549674921669L733.170412006788,154.44866814883426L733.5530217718333,154.5839405003935L734.1344308387488,152.96795601770282L743.6018530931324,156.42676587309688L744.0838625095785,156.6036604354158L743.4243537159637,158.40382247790694L744.8632819894701,158.93450599489734L743.9134631073102,161.55670631676912L742.5179235721007,161.04683411121368L742.2268245965242,161.84806184656918L741.688804266043,161.65659964317456Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.1904635140672,180.95367398578674L655.6773401377723,170.9331454592757L656.0031501026824,170.011214483995L661.1269654147327,171.81137304287404L661.0346657382324,172.08816038630903L660.7656555734575,172.86753521952778L657.321378801018,182.75278915371746Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M736.2036791155115,147.7662107446231L736.8339991206303,146.01599271642044L736.210779090412,145.7891511064954L736.8765989709646,143.918227837421L737.3160085361451,144.07431155443192L737.7128182519227,142.98276601312682L746.37242112495,146.13669742178172L747.244140281342,146.45510810241103L749.3062885832042,147.2063907571137L748.3856584886089,149.7224586745724L746.7700197268277,149.13454379793257L745.9756114101037,151.33844391535968L745.5156908044592,151.16779256192967Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M730.7114539900795,161.09678077790886L731.3914738195017,159.22586163692176L731.8237834097818,159.3881883462891L732.2489930251613,158.21236017951742L741.688804266043,161.65659964317456L742.2268245965242,161.84806184656918L741.7732150815427,163.12274214671925L743.2121433531865,163.6471819728613L742.1913247210905,166.46812647022307L740.2001761691645,165.74494088161737L739.3355569895357,165.42653108760715L730.7256539389491,162.29446011781693L731.101163729094,161.245580220595Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M676.0306018805131,128.02992748422548L678.1637499323115,122.08416213048622L684.0243848739192,124.19650147249922L682.5712566524744,128.24948575068265L681.8912368230522,130.1412244560197Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M684.98761481978,162.78976445831358L687.0497631225735,157.02820736402646L690.3244293797761,158.21236017951742L688.2622810797766,163.98015961889178Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M760.631537636742,176.96315371617675L761.6870672563091,173.3638793565333L764.1247253511101,174.00173875456676L762.5303865140304,179.29503298457712Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M768.4162658099085,86.93078682711348m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M654.3772558225319,31.899158467072994m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M664.7724081464112,-7.938327412586659m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M697.7872920203954,72.84566181711853m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M693.3616409199312,118.79910897603258m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M661.9016515789554,98.63090880122036m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M642.1550432574004,104.42789361393079m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M705.1744215916842,135.03185568004847m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M671.781661269255,109.48087085643783m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M680.7110631959513,110.5360019672662m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M704.4833573559299,119.43385170819238m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.284514663741,175.69159762514755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.5673918398097,150.0627208929509m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M703.0412735389546,147.31981154019013m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M685.4861908433959,152.65995120443404m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.4159257058054,72.30352545063943m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M704.9472223902121,141.80277282744646m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M701.043025012128,152.74423630721867m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M699.0731763867661,158.0812501241453m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.2392948353663,144.5311165493913m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.0965064484626,177.625986056868m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M678.8816362963989,74.65625129872933m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M683.0824548546225,30.90332816913724m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M678.147972212173,151.97630533995107m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M667.8845638670027,146.472797581926m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M687.724260748364,106.0438894117251m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M728.5372838592157,178.70712061645463m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M724.8626523399726,45.09779857099056m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M666.7304234830663,70.81239007785916m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M741.8876035669819,141.77779942564666m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M733.0915233949199,165.92911908961833m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M740.8525849860162,152.44351538084447m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M738.1648499947041,157.40801035426557m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M656.477270658128,176.91008550627157m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M742.4082684023306,146.83074943954125m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.2987290769815,153.91798428772017L672.7559356214479,140.84962122142315L673.861953953281,137.71753914328292L679.1056799534708,139.524990004953L676.8384212618694,146.20745535148308L673.5850549265742,155.72439036658034Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer bridge"
        d="M1075.1651646215469,0.6506222691386938L1059.2967204386368,-37.06008652690798L1075.1651646215469,-37.06008652690798Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1024.5360315954313,159.96257512737066m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer bridge"
        d="M858.4912823121995,14.788963441736996L871.2893817396834,28.192629504483193L888.9777861880139,44.04577921843156L904.6679421104491,55.98634556401521L922.7247563758865,68.61470777262002L920.918207174167,70.66983211040497L916.7363218842074,75.43979935860261L913.3772448105738,79.26596835860983L910.5143771022558,82.54791854834184L905.808671431616,87.91204114397988L903.9098225552589,90.08786544110626L871.8352909311652,62.60541666066274L858.4912823121995,51.655486319214106Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M901.3372649373487,59.69285966688767L901.705674752593,46.95834278734401L903.1162031246349,-2.5918246512301266L904.2427324960008,-28.06839475594461L912.0101051740348,-27.409705142490566L969.9648346565664,-16.21199133200571L969.8299351315945,9.229155526962131L970.0358344065025,44.895927413366735L967.767786828801,81.88819881994277L967.9807860795408,88.37301210779697L969.4402253897861,92.3479748913087L972.1547825103626,94.9920522775501L974.0820312863216,96.84113688534126L977.5192080847919,98.63403049716726L977.5192080847919,100.16470134072006L958.8454848779365,99.555970962625L944.2684472631663,90.28661358496174L928.3092811768875,78.6926154550165L919.3727792771533,73.33472913736477L909.012337940745,65.7801960427314Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M987.6887389812618,-35.665702358819544L987.7692053643987,-37.06008652690798L1046.1609777528793,-37.06008652690798L1045.926678577438,-22.85298994416371L1007.6799019966274,-31.520012587308884Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1007.2333924565464,43.400623850058764L1010.3873591395095,43.55670983158052"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1010.3873591395095,43.55670983158052L1050.929794313386,45.51923060929403"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1047.8263163408265,105.8347360836342L965.5281391516328,103.27598910033703L959.0513841556385,102.3478057407774L953.2404490383342,100.90246167592704L948.2231333535165,98.15224891528487L942.0855993861333,93.50404348317534L930.661739568226,85.24714972125366L920.7123078983277,78.25973918708041L916.7363218842074,75.43979935860261"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1073.2016270849854,-4.015338412486017L1075.1651646215469,-3.5564424991607666"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M907.0140894139186,-37.00493550626561L969.5609249658883,-25.13498921133578L990.5161068132147,-20.911262020468712L1035.9985468322411,-11.697947335895151L1061.1845249086618,-6.624073822516948L1072.9270947165787,-4.079854393843561L1073.2016270849854,-4.015338412486017"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1047.8263163408265,105.8347360836342L1047.726916690357,116.09572861948982"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M895.6162628382444,-37.06008652690798L909.4730474324897,-32.009087305516005"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M916.7363218842074,75.43979935860261L903.8459227802232,66.26926386170089L889.2546852137893,55.249621021561325"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,36.94906686292961L860.2773204743862,38.82938417093828L910.5143771022558,82.54791854834184"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M886.7365607386455,179.61344214202836L887.4757470274344,165.18512234650552"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1075.1651646215469,-4.88318247301504L1070.659836024046,-15.560586923733354L1061.5963234603405,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1067.5816024076194,-37.06008652690798L1075.1651646215469,-19.163083005696535"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1054.42140425276,-37.06008652690798L1050.929794313386,45.51923060929403"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.4912823121995,46.58893947536126L878.2915348876268,65.59601517347619"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M862.1335695004091,114.79918786138296L858.8099923012778,117.61911167670041L858.4912823121995,117.86364376172423"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1072.7850952167064,92.66014464758337L1048.3580255806446,91.97337116627023"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,30.757647652179003L860.1921207727864,32.55784237990156L873.032820051536,45.420376183930784"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,36.053132423665375L880.6802820414305,36.60879909386858"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M880.6802820414305,36.60879909386858L892.9537722039968,36.91680906107649"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1047.726916690357,116.09572861948982L1044.6455275276676,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M889.2546852137893,55.249621021561325L864.2028177771717,28.348715828265995L858.4912823121995,22.144802019000053"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M963.785489724949,49.268413776531816L962.942170468159,54.44838096154854L960.936033080332,59.76361847901717L958.3145645242184,64.06533669633791L954.8063879748806,68.28900952916592L950.922701635398,71.37221623491496L946.5719947163016,73.56157311843708L941.3487797556445,74.70307688368484L936.3385640447959,74.95073218643665L930.4140293290839,74.26291638193652"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M976.0802798131481,41.89075193973258L979.850366551429,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M892.9537722039968,36.91680906107649L894.7540103159845,-16.056944590527564L896.5029708305374,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1002.4432759713382,113.97714343247935L1047.726916690357,116.09572861948982"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M989.4834548905492,179.61344214202836L987.5822393549606,170.55750542506576L982.8410338098183,157.01468013320118L976.7468885788694,144.14506950508803L969.2919148011133,131.96324513014406L960.4966235151514,121.1278861258179L948.9812529077753,108.94498073495924L923.5680756308138,88.26687432778999L913.3772448105738,79.26596835860983"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1075.1651646215469,-11.259862542152405L1069.6705728368834,-12.40762395085767"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1069.6705728368834,-12.40762395085767L1063.8067823518068,-13.633429188746959"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1063.8067823518068,-13.633429188746959L1046.0828780271113,-17.112094972282648"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1050.929794313386,45.51923060929403L1049.5129548516124,71.08814088487998"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1067.9736788067967,46.51922110142186L1075.1651646215469,46.943774772342294"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1050.929794313386,45.51923060929403L1065.3727212892845,46.37666263105348"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M963.771289775148,30.38200002349913L964.1112996898592,35.68997197272256L964.4513096064329,42.160260456148535L963.785489724949,49.268413776531816"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,-25.55122262844816L1070.2874817792326,-37.06008652690798"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,105.5360942510888L1072.5089850760996,105.565230040811"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M999.8012963756919,179.61344214202836L1002.4432759713382,113.97714343247935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M887.9680119631812,104.16775259329006L882.0829215524718,115.23830522224307L876.6687961509451,125.01126076094806L870.0421527922153,134.42937172111124L863.4162983223796,142.80587110249326L858.4912823121995,144.9785564923659"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M890.6084137866274,99.20113835996017L887.9680119631812,104.16775259329006"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M862.1335695004091,114.79918786138296L860.2702204985544,117.91671242425218L858.4912823121995,120.44423715071753"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1047.726916690357,116.09572861948982L1072.2612748369575,117.18727839784697"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M910.5143771022558,82.54791854834184L924.0003852210939,92.92236723052338L944.2755472389981,109.767025757581L961.3825426213443,128.8800653750077L965.1100295102224,136.03807661077008L972.5586922001094,147.54665309982374L977.2991088582203,159.05521047767252L981.3531945990399,171.9175095469691L982.9759333347902,179.61344214202836"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M858.4912823121995,54.58365526376292L863.465998146683,55.11538730375469L887.1641370123252,79.48656873684376L888.1068559195846,108.42053676955402L884.6412792196497,179.61344214202836L858.4912823121995,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1049.5129548516124,71.08814088487998L1049.3354554763064,74.24938898999244"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M865.138436707668,62.1943913619034L866.5702650053427,66.31192722404376L868.2143036667258,70.82591747725382L869.1144227236509,75.7374019199051L869.4189327629283,80.6197469853796L869.6595430281013,86.99842365970835L869.1073227487504,93.41871709330007L868.1717038173229,99.32184388069436L866.2302550906315,105.67865150189027L863.671897421591,111.82942183548585L862.1335695004091,114.79918786138296"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1072.2612748369575,117.18727839784697L1075.1651646215469,117.30902417004108"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,92.72361916163936L1072.7850952167064,92.66014464758337"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M873.032820051536,45.420376183930784L885.2360993493348,57.75843831943348L892.4575628377497,56.6887311800383"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M906.6519906884059,-37.06008652690798L907.0140894139186,-37.00493550626561"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M913.3772448105738,79.26596835860983L889.2546852137893,55.249621021561325"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M973.6639216458425,82.66134038940072L974.0607313606888,75.9361504749395L976.0802798131481,41.89075193973258"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M901.9762626895681,37.45686704805121L970.0161122540012,41.52863236842677"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M892.9537722039968,36.91680906107649L901.9762626895681,37.45686704805121M970.0161122540012,41.52863236842677L976.0802798131481,41.89075193973258L1050.929794313386,45.51923060929403"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1049.3354554763064,74.24938898999244L1048.3580255806446,91.97337116627023"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M927.8477827999741,-24.34934870293364L928.4796805763617,-24.008037358522415L933.1845973618329,-21.130825011525303L937.7696034563705,-17.29627804318443L942.2346988609061,-13.406582360621542L945.8343862006441,-9.692747085820884L949.2076632231474,-5.787446961738169L952.9422500869259,-0.6573864608071744L956.1956164212897,4.388383334502578L958.5693747391924,9.944032819010317L960.7593225920573,15.387295486871153L962.1130511630327,20.935652120038867L963.2750804098323,26.137492573354393L963.771289775148,30.38200002349913"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M909.4730474324897,-32.009087305516005L915.9640023782849,-29.535618282854557L922.4557462101802,-27.268185740336776L927.8477827999741,-24.34934870293364"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M930.4140293290839,74.26291638193652L924.48239463754,72.42110973224044L920.918207174167,70.66983211040497"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M892.4575628377497,56.6887311800383L892.7036953056231,46.88134040962905"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M892.7036953056231,46.88134040962905L892.9537722039968,36.91680906107649"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M891.544821604155,79.49281214550138L892.0607531229034,68.62927574524656L892.4575628377497,56.6887311800383"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M887.4757470274344,165.18512234650552L890.6084137866274,99.20113835996017L891.544821604155,79.49281214550138"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1048.3580255806446,91.97337116627023L981.1756952228025,88.79756321571767L977.8947178740054,88.47914988640696L975.2511605061591,86.26066184835508L973.6639216458425,82.66134038940072"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M976.0802798131481,41.89075193973258L1007.2333924565464,43.400623850058764"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1048.3580255806446,91.97337116627023L1047.8263163408265,105.8347360836342"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.4912823121995,51.42968219285831L858.8462810637429,51.94684646744281"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M860.7277744440362,54.82298671454191L865.138436707668,62.1943913619034"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M858.8462810637429,51.94684646744281L860.0927211232483,53.761603695806116L860.7277744440362,54.82298671454191"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1072.5089850760996,105.565230040811L1047.8263163408265,105.8347360836342"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M920.918207174167,70.66983211040497L903.3639133647084,59.00608291849494L888.1486668828875,46.95834278734401L858.4912823121995,19.74939469760284"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M887.4757470274344,165.18512234650552L940.6545599745587,167.5170055772178L945.5298761604354,168.64392610779032L950.667891420424,170.1319187716581L955.4864078052342,172.45651645958424L959.6888041356578,175.14218542724848L962.8427708186209,178.1535464450717L963.9227559091523,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M905.808671431616,87.91204114397988L940.8028705641627,116.30904389033094L952.2480303067714,129.2629915899597L961.049632682465,141.4521046220325L967.1374668236822,150.93366722296923L971.8778834817931,161.08949688775465L975.26536045596,173.9590760571882L976.2648791633546,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1065.3727212892845,46.37666263105348L1067.9736788067967,46.51922110142186"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1046.0828780271113,-17.112094972282648L988.701668751426,-28.642797118984163L970.3971442468464,-32.48359387367964L946.5317615251988,-37.06008652690798"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1051.7873135190457,185.82866108138114L1053.948861470446,126.81143100978807L1072.0340756354854,127.46282197767869L1075.4996523354203,127.5908109312877L1083.1747253378853,127.87384340260178L1083.0043259374797,132.5438775443472L1102.6136680748314,133.259782679379L1100.7921300362796,183.05142765957862L1080.3962684441358,182.3063922021538L1080.2337579047307,186.87025339715183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M984.9741818616167,35.74720356520265L986.1646110089496,7.280151997227222L1043.829030400142,9.70365923969075L1043.382520860061,20.128164634108543L1043.2555101960897,23.224920252803713L1042.6244013048708,38.17798487376422L1010.6634692791849,36.83148197690025L1007.5173914572224,36.69620732823387Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M982.9830333096907,78.86951200198382L984.145062555559,51.005128796212375L1006.8720826152712,51.961414475459605L1010.0331492749974,52.09564825426787L1041.9869813248515,53.44214818440378L1041.263572756201,70.84776942711323L1041.1365620922297,73.92993442714214L1040.8241631910205,81.3075621589087Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1055.9613099480048,81.93814605753869L1056.2666088733822,74.5251396629028L1056.4007195131853,71.28688957449049L1057.1241280799732,54.08730262052268L1065.153410948813,54.42028552806005L1067.6833687173203,54.52018039859831L1091.5795179959387,55.532656447030604L1103.5058982688934,83.95060319034383L1076.095261350274,82.79557357449085L1072.9980944665149,82.6675837924704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1057.6692483853549,38.80857269326225L1058.293257300742,23.855509434826672L1058.4281568266451,20.766038132831454L1059.058476831764,5.565278175286949L1065.4721209388226,5.833747527562082L1071.5378662701696,7.797319563571364L1085.0451743137091,39.963609642349184L1068.2426889715716,39.25497888633981L1065.5786205651239,39.14155633794144Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M919.5786785529926,149.87854226399213L920.72650784906,121.99155216477811L935.3674452397972,122.59403720265254L934.5028260573745,143.67057499615476L933.8299062028527,159.87724956078455L925.1340145682916,159.51617670804262L925.517413219437,150.11891098180786Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1011.0318790953606,170.50027494551614L1011.7126878118142,155.21451772935688L1037.7277851933613,156.38410306768492L1037.4161751791835,163.54104534350336L1037.0469764769077,171.6698577059433Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1072.0340756354854,127.46282197767869L1072.2612748369575,117.18727839784697L1072.5089850760996,105.565230040811L1072.7850952167064,92.66014464758337L1072.9980944665149,82.6675837924704L1076.095261350274,82.79557357449085L1075.9603618253022,92.74547104537487L1075.7899624239653,105.52985086850822L1075.6345518594608,117.3287948477082L1075.4996523354203,127.5908109312877Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1006.8720826152712,51.961414475459605L1007.2333924565464,43.400623850058764L1007.5173914572224,36.69620732823387L1010.6634692791849,36.83148197690025L1010.3873591395095,43.55670983158052L1010.0331492749974,52.09564825426787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1041.1365620922297,73.92993442714214L1041.263572756201,70.84776942711323L1049.5129548516124,71.08814088487998L1056.4007195131853,71.28688957449049L1056.2666088733822,74.5251396629028L1049.3354554763064,74.24938898999244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1043.2555101960897,23.224920252803713L1043.382520860061,20.128164634108543L1058.4281568266451,20.766038132831454L1058.293257300742,23.855509434826672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1065.153410948813,54.42028552806005L1065.3727212892845,46.37666263105348L1065.5786205651239,39.14155633794144L1068.2426889715716,39.25497888633981L1067.9736788067967,46.51922110142186L1067.6833687173203,54.52018039859831Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1014.440655994229,21.676542615983635m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1012.6530400598422,62.145484555047005m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M878.2915348876268,65.59601517347619L905.808671431616,87.91204114397988"
        style={{ display: 'none' }}
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer residential"
        d="M1290.7290841694921,54.228820357937366L1291.839046932757,20.392471116036177L1291.839046932757,54.29229522589594Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1140.2048802953213,-30.272351917810738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M1167.2226519286633,138.23469697963446L1172.8000767538324,136.12340247398242L1177.448982624337,134.3721409435384L1182.9696076512337,133.7207506261766L1198.517764071934,136.25763462297618L1201.0619217902422,136.78936039749533L1209.842224240303,135.25141372159123L1218.2470168983564,137.73835032386705L1228.196448569186,141.1825999636203L1234.8649028912187,143.9817018834874L1240.9456370584667,146.78808657545596L1245.7073536422104,149.00655524199829L1250.3633594866842,151.33844391535968L1254.9767654817551,138.51772901928052L1291.839046932757,141.1878027538769L1291.839046932757,179.61344214202836L1188.9580421419814,179.61344214202836L1179.9434405164793,164.78138701757416L1172.9625872941688,150.20423667132854Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer recreation_ground"
        d="M1143.7375123128295,-1.2026503193192184L1144.9918412333354,-36.62928422540426L1223.6043424988165,-32.32750618457794L1218.6438266132027,36.60463679395616L1187.6532245101407,17.122978422790766L1164.6713942354545,6.542381695471704Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M1151.050486589782,60.70637552952394L1157.1809205822647,57.27665389981121L1214.2355310088024,59.53053062176332L1224.2559624286368,67.42429623194039L1245.2403330625966,88.64251881884411L1257.259013010189,102.5465535344556L1267.9878641609102,116.23100171843544L1252.4326077634469,112.21234898921102L1238.0543694496155,106.91171958344057L1206.5888579059392,92.8370408359915L1193.7197587266564,88.40110740391538L1180.879059447907,86.39593552891165L1161.7801266275346,85.2190544125624Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer commercial"
        d="M1225.1773814102635,16.449724961537868L1228.5790583342314,-34.09233787609264L1281.8288710312918,-31.200553161092103L1279.1782136894763,19.99288965994492Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M1169.3699999302626,96.6850521042943L1178.8942219857126,97.54247779585421L1187.887523685582,98.59136733366176L1195.4063972383738,100.28540684422478L1206.6101578306407,104.30406648898497L1219.628356483765,110.54744816152379L1222.5906238425523,117.10923623526469L1212.9670021366328,116.25909690046683L1176.9882731335238,114.45892391400412Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M1134.1635904340073,22.360201333649457L1135.8502289447933,19.717136818915606L1145.374450999312,22.459056089632213L1155.8484919359908,26.165588121395558L1168.3278813743964,31.984485611785203L1181.5590792782605,38.65248660556972L1190.4387813787907,43.833502299152315L1189.4960624724627,45.420376183930784L1149.286537239328,41.82727695815265L1140.2932355394587,34.847106675151736Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1188.6874542050064,-37.06008652690798L1226.74332034681,-34.9851597417146L1222.4849131032825,19.404963776934892L1220.6917749661952,41.27473242813721"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1222.4849131032825,19.404963776934892L1279.404624003917,22.65052214032039"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1223.3771432982758,47.35480097262189L1276.3224459560588,50.67214572476223"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer retaining_wall"
        d="M1138.3162869373336,155.88047381816432L1136.1050391606987,157.3611853304319L1135.7792291939259,158.9563576700166L1135.1481203036383,168.89886193722486L1130.4921144582331,168.67930495832115L1129.9264831151813,179.61344214202836"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer retaining_wall"
        d="M1198.517764071934,136.25763462297618L1182.9696076512337,133.7207506261766L1177.448982624337,134.3721409435384L1172.8000767538324,136.12340247398242L1171.014038592577,135.72590880980715L1170.4042296260595,134.41480388725176L1168.753090989776,133.5927617852576L1136.6296484256163,146.62575957085937L1137.685178047046,148.9566084886901L1137.8981772968546,150.32494130404666L1136.948358415626,151.38735009590164L1134.4042006973177,152.33737858152017L1133.0362721765414,153.4996805083938L1131.548432965763,155.62553751142696L1130.8116133343428,158.80027428781614L1130.4921144582331,163.8740229960531"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer retaining_wall"
        d="M1172.9625872941688,150.20423667132854L1167.2226519286633,138.23469697963446"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1182.544398035854,160.3808785174042L1172.9625872941688,150.20423667132854"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1168.753090989776,133.5927617852576L1172.2825674638152,139.74454790446907L1177.045072933659,147.47589518409222L1180.6447602724656,152.55693607777357L1184.6562461620197,157.20614246698096L1189.524462372996,161.38709577079862L1192.493829704821,163.39952983660623"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1127.0912264203653,179.61344214202836L1129.8049946539104,131.18386569991708"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer retaining_wall"
        d="M1141.547564460896,146.03680387232453L1143.7730121882632,151.5434336452745L1146.8409902853891,166.99984992761165L1152.1359938830137,179.61344214202836"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1174.1325054010376,128.63969592098147L1172.8639765297994,129.63863385887817L1171.2759487815201,129.4326029215008L1170.0642197113484,128.32024386292323L1163.1267552236095,127.58352700807154"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1139.1454062433913,147.2063907571137L1119.6354637565091,100.49768203869462L1075.1651646215469,-4.88318247301504"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,-19.163083005696535L1144.6802312191576,144.8817846016027"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1194.5985778579488,39.18421986466274L1208.5594954174012,49.23303431412205L1222.626123717986,59.395256416872144L1232.8879542890936,68.38162021385506L1243.1560959490016,77.90594606054947L1251.0441682040691,85.85692192194983L1267.3362442301586,103.63706488208845"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1153.1426125643775,93.76834716415033L1147.9896084675565,97.42281280970201L1118.7834667535499,104.30718818120658"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1118.7834667535499,104.30718818120658L1115.4330674270168,105.09697627276182M1156.2737015513703,91.5477796876803L1153.1426125643775,93.76834716415033"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1170.4326295256615,122.60860506119207L1183.557327805087,123.14033188298345L1223.85205273889,125.21625126898289L1265.8484050193802,132.72805663431063L1291.839046932757,135.6478668563068"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1127.5913802161813,125.23914361093193L1132.0233424063772,128.37019076477736L1162.134336492978,129.92895016958937L1168.7562465332448,130.53351564193144"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1119.132154416293,119.2631995701231L1127.5913802161813,125.23914361093193M1168.7562465332448,130.53351564193144L1179.8298409171402,131.54494002554566"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1291.3033932615072,119.34852563915774L1263.8564675822854,87.44482675287873L1253.679836710915,76.43874496361241L1241.5972569873556,64.97999777225778"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1126.8569272458553,48.85010368190706L1134.380534114316,49.58891005022451"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1134.380534114316,49.58891005022451L1138.9821068178862,50.0405184100382L1194.1946681672707,54.137250057887286L1280.1493324954063,57.62420465052128L1291.839046932757,58.09870505006984"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1111.9288353081793,-3.2775669912807643L1089.6869802102447,-8.225527756847441L1075.1651646215469,-11.259862542152405"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1115.9363767681643,-2.386830369476229L1111.9288353081793,-3.2775669912807643"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1144.6802312191576,144.8817846016027L1157.9461401132867,176.77897580247372L1159.230446706526,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1112.683799320832,93.77250943053514L1094.2435864033177,48.070714903995395"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1132.0233424063772,128.37019076477736L1131.5302885845304,134.60002348572016"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1131.5302885845304,134.60002348572016L1129.0113752223551,166.46812647022307L1128.3281998476014,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1140.9093555938452,179.61344214202836L1140.9732553698123,178.52918606624007L1141.3913650102913,163.82511690398678L1140.860444655642,152.18129505077377L1139.1454062433913,147.2063907571137"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1132.3917522206903,166.5669791684486L1129.0113752223551,166.46812647022307"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1185.852986398153,179.61344214202836L1162.59504598286,137.61140211857855"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1137.5786784207448,153.6557640102692L1135.630129719153,154.74626731779426L1133.4543818160892,156.8305016886443L1132.8382617617026,160.65662576444447L1132.3917522206903,166.5669791684486"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1140.860444655642,152.18129505077377L1137.5786784207448,153.6557640102692"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1259.2998613873497,125.25163034396246L1249.3575296914205,121.55243522906676L1245.0131338611245,119.12168315704912L1241.8457561135292,116.89696155395359L1234.2132829595357,111.99279021751136"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1280.1493324954063,57.62420465052128L1285.4711582204327,-34.496084813028574"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1285.4711582204327,-34.496084813028574L1291.839046932757,-34.14540770556778"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1085.2084737401456,105.42995673418045L1075.7899624239653,105.52985086850822"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1094.933072866872,-37.06008652690798L1103.6549977445975,-16.15579989599064L1167.9949714336544,135.40749763697386"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1095.1287166234106,48.09152635606006L1126.8569272458553,48.85010368190706"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,46.943774772342294L1094.2435864033177,48.070714903995395L1095.1287166234106,48.09152635606006"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1267.3362442301586,103.63706488208845L1283.9407191602513,123.72824896452948L1291.839046932757,133.39921768242493"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1285.4711582204327,-34.496084813028574L1243.8842378323898,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1138.9821068178862,50.0405184100382L1156.2737015513703,91.5477796876803"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1169.1088786274195,137.52087347814813L1175.216434921138,149.11269209254533L1183.8058269312605,159.58693450177088L1192.7983397450298,167.75737368315458L1197.0788357993588,170.67092582583427L1203.5350797586143,174.6885041068308L1209.2750151241198,177.48759249644354L1214.5053300596774,179.60719882603735L1214.530574414879,179.61344214202836M1243.716993975453,179.61344214202836L1244.1485146805644,179.40116937365383L1247.4933918034658,176.71550205908716L1249.4001295417547,174.1005913480185L1250.9731684532017,171.35769150732085L1251.8874874599278,168.13301386870444L1252.3268970251083,164.32042113738135L1252.0428980244324,160.2747418396175L1250.724669327028,156.1926407115534L1248.2373114097863,153.25098745292053L1244.7299237465486,150.63606789056212L1237.3451608326286,146.7599915168248L1229.5643770908937,143.45101721817628L1213.8813211424276,138.27007598476484L1205.0931298332289,136.08282066090032"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1167.9949714336544,135.40749763697386L1169.1088786274195,137.52087347814813M1205.0931298332289,136.08282066090032L1197.9363550059497,134.3013828927651L1179.8298409171402,131.54494002554566"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1160.1715878415853,138.6176226772368L1177.162616965361,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1170.0334531534463,179.61344214202836L1153.8999432353303,141.1825999636203"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer bridge"
        d="M1097.5821524392813,-37.06008652690798L1170.4042296260595,134.41480388725176L1167.9949714336544,135.40749763697386L1162.59504598286,137.61140211857855L1160.1715878415853,138.6176226772368L1153.8999432353303,141.1825999636203L1147.0184896616265,143.9817018834874L1144.6802312191576,144.8817846016027L1139.1454062433913,147.2063907571137L1137.174768730998,148.0138634396717L1075.1651646215469,0.6506222691386938L1075.1651646215469,-37.06008652690798Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1156.2737015513703,91.5477796876803L1165.8831233056262,115.72736955108121L1167.2581518031657,118.16540674725547L1168.6331803007051,120.39012794662267L1170.4326295256615,122.60860506119207"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1288.412914538756,140.9391092597507L1291.839046932757,146.4426214080304"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1251.0441682040691,85.85692192194983L1263.6229572920129,106.0615789978765L1274.7415181836113,120.45464276662096L1285.7401683852077,136.64680378418416L1288.412914538756,140.9391092597507"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1115.4330674270168,105.09697627276182L1112.683799320832,93.77250943053514"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1251.3336894074455,148.64340070961043L1262.468028021045,154.3144363523461L1279.071714063175,166.1632439228706L1291.839046932757,176.62809558724985"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1183.557327805087,123.14033188298345L1197.900855130516,128.3910019742325L1216.3118792613968,133.36591977067292L1239.4002091595903,142.56446157069877L1251.3336894074455,148.64340070961043"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1180.095695537515,179.61344214202836L1162.59504598286,137.61140211857855"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1152.356093108654,91.91509947320446L1145.8564604157582,92.52591165481135L1114.3246824378148,93.71111605409533"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1114.3246824378148,93.71111605409533L1112.683799320832,93.77250943053514M1291.839046932757,126.24640652677044L1269.9940015487373,122.94158467836678L1251.7951877834275,118.05926942266524L1234.2132829595357,111.99279021751136L1204.8036086289212,97.92540573934093L1185.548476357013,92.84432479785755L1156.2737015513703,91.5477796876803L1152.356093108654,91.91509947320446"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1128.6429654071108,-8.558513674885035L1130.6364806164056,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1075.1651646215469,-3.5564424991607666L1091.0194088565186,0.15114402305334806L1102.6554790381342,3.105349209625274L1116.1785648046061,6.72968586999923"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1116.1785648046061,6.72968586999923L1117.254605463706,7.017926171887666L1136.4024492241442,12.523625812027603L1153.7579437335953,18.767090155743062L1165.607013166882,23.74208663124591L1177.2430833484977,29.45380690181628L1184.4361469363794,33.4725076132454L1194.5985778579488,39.18421986466274"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.7899624239653,105.52985086850822L1075.1651646215469,105.5360942510888"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1203.8537897476926,35.23003808222711L1192.1467198152095,28.334147770889103L1178.093502579257,20.390389963518828L1167.690461394377,15.36544336238876L1155.1968720061705,9.795230126939714L1141.504964611493,4.451858658809215"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1291.839046932757,119.98430888308212L1291.3033932615072,119.34852563915774"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1157.9461401132867,176.77897580247372L1158.8012926615775,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1162.134336492978,129.92895016958937L1162.4530464829877,127.28592667356133L1166.3958992809057,124.97484112810344"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1166.3958992809057,124.97484112810344L1170.4326295256615,122.60860506119207L1178.8516221353784,116.705498106312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1115.4330674270168,105.09697627276182L1085.2084737401456,105.42995673418045"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,117.30902417004108L1075.6345518594608,117.3287948477082"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.9603618253022,92.74547104537487L1075.1651646215469,92.72361916163936"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1141.504964611493,4.451858658809215L1128.5222658310086,0.6391758937388659L1115.9363767681643,-2.386830369476229"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1147.0184896616265,143.9817018834874L1075.1651646215469,-25.55122262844816"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1162.59504598286,137.61140211857855L1089.050349115394,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1123.692705041729,115.97294226801023L1129.1928190290928,37.37362111965194"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1119.2394429277629,179.61344214202836L1123.692705041729,115.97294226801023M1129.1928190290928,37.37362111965194L1133.7454807916656,-27.68545987084508L1134.0689241001382,-37.06008652690798"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1086.2229812825099,-37.06008652690798L1160.1715878415853,138.6176226772368"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1126.8569272458553,48.85010368190706L1126.287351471372,30.53184284735471"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1126.287351471372,30.53184284735471L1126.16980743967,26.747269973158836L1128.6429654071108,-8.558513674885035"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1126.8569272458553,48.85010368190706L1130.6980137340724,55.342231878079474L1145.8564604157582,92.52591165481135L1147.9896084675565,97.42281280970201L1155.529781945981,114.76380873378366L1158.6545598423108,121.94264577515423L1162.134336492978,129.92895016958937"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1115.4330674270168,105.09697627276182L1119.132154416293,119.2631995701231"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1155.529781945981,114.76380873378366L1162.3276135902852,115.39647071203217"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1162.3276135902852,115.39647071203217L1165.8831233056262,115.72736955108121L1178.8516221353784,116.705498106312L1208.8569054827094,117.8959011840634L1229.273278114386,119.79492664569989L1246.728172273375,122.76468925829977L1259.2998613873497,125.25163034396246L1274.025998477824,128.15063250344247L1291.839046932757,130.79261511052027"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1153.8999432353303,141.1825999636203L1078.4682307820767,-37.06008652690798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.6345518594608,117.3287948477082L1119.132154416293,119.2631995701231"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1112.683799320832,93.77250943053514L1075.9603618253022,92.74547104537487"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1125.2515440024436,119.6783837294206L1158.6545598423108,121.94264577515423L1165.2662143651396,122.31620731949806"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1119.132154416293,119.2631995701231L1125.2515440024436,119.6783837294206M1165.2662143651396,122.31620731949806L1170.4326295256615,122.60860506119207"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1119.132154416293,119.2631995701231L1122.3997207004577,133.40858271811157L1119.990462508984,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1162.1185587700456,179.61344214202836L1147.0184896616265,143.9817018834874"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1241.5972569873556,64.97999777225778L1225.9781008167192,51.89793958561495L1216.800988651812,44.69093452999368L1203.8537897476926,35.23003808222711"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1051.7873135190457,185.82866108138114L1053.948861470446,126.81143100978807L1072.0340756354854,127.46282197767869L1075.4996523354203,127.5908109312877L1083.1747253378853,127.87384340260178L1083.0043259374797,132.5438775443472L1102.6136680748314,133.259782679379L1100.7921300362796,183.05142765957862L1080.3962684441358,182.3063922021538L1080.2337579047307,186.87025339715183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1227.6576393526047,-8.119388496503234L1228.2674483191222,-22.55538316257298L1234.8578029153869,-22.27130397548899L1235.2191127557307,-30.995558033231646L1276.3713568942621,-29.230727129150182L1274.9332175096497,4.998162648174912L1233.7738733943552,3.254152045119554L1234.2487828349695,-7.836350483819842Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1055.9613099480048,81.93814605753869L1056.2666088733822,74.5251396629028L1056.4007195131853,71.28688957449049L1057.1241280799732,54.08730262052268L1065.153410948813,54.42028552806005L1067.6833687173203,54.52018039859831L1091.5795179959387,55.532656447030604L1103.5058982688934,83.95060319034383L1076.095261350274,82.79557357449085L1072.9980944665149,82.6675837924704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1057.6692483853549,38.80857269326225L1058.293257300742,23.855509434826672L1058.4281568266451,20.766038132831454L1059.058476831764,5.565278175286949L1065.4721209388226,5.833747527562082L1071.5378662701696,7.797319563571364L1085.0451743137091,39.963609642349184L1068.2426889715716,39.25497888633981L1065.5786205651239,39.14155633794144Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1102.3083691485226,-37.49401061190292L1120.0322734722868,-36.495048731099814L1118.6501449998468,-11.762463388498873L1118.5870341109112,-10.713557311799377L1113.6044294154271,-10.989311373326927Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1072.0340756354854,127.46282197767869L1072.2612748369575,117.18727839784697L1072.5089850760996,105.565230040811L1072.7850952167064,92.66014464758337L1072.9980944665149,82.6675837924704L1076.095261350274,82.79557357449085L1075.9603618253022,92.74547104537487L1075.7899624239653,105.52985086850822L1075.6345518594608,117.3287948477082L1075.4996523354203,127.5908109312877Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1136.0979391848668,-14.667767560575157L1137.0761579666287,-35.89254991430789L1143.8369119642302,-35.580374381970614L1143.3478025728837,-24.96433351840824L1142.8586931824684,-14.35559298377484Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1225.9284009905532,39.00003828993067L1226.219499967061,32.06877218140289L1233.1214645793661,32.360133153386414L1232.8311544889584,39.29035839997232Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1077.265179457143,157.7836510981433m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1251.8693430786952,-15.195342625491321m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1075.808895691298,63.40977748669684m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1113.6730625070632,-24.128745027352124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1285.5902800243348,-37.06008652690798L1285.4711582204327,-34.496084813028574"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M141.2857272485271,396.2874816409312L1.4769634595140815,332.31079886993393L44.23853527288884,243.01091114571318L208.46884649340063,316.7350900028832L208.46884649340063,396.2874816409312ZM208.46884649340063,228.6295478567481L98.40503363404423,179.61344214202836L208.46884649340063,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M196.391788973473,179.61344214202836L190.95399698987603,191.6474245400168L164.4419013550505,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M164.41507922764868,179.61344214202836L190.95399698987603,191.6474245400168L183.5905340006575,207.64899886678904L121.54779667593539,179.61344214202836Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M98.29222292080522,179.61344214202836L208.46884649340063,228.97292783670127L208.46884649340063,316.73613053467125L44.229857524856925,243.00778951775283L1.4722301438450813,332.30663674976677L141.27862727455795,396.2874816409312L-8.205035817809403,396.2874816409312L-8.205035817809403,179.61344214202836Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M98.29537846427411,179.61344214202836L208.46884649340063,228.97188729187474L208.46884649340063,316.7350900028832L44.23853527288884,243.01091114571318L1.4769634595140815,332.31079886993393L141.2857272485271,396.2874816409312L-8.205035817809403,396.2874816409312L-8.205035817809403,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pier"
        d="M1.4769634595140815,332.31079886993393L44.23853527288884,243.01091114571318L208.46884649340063,316.7350900028832L208.46884649340063,323.4215466394089L206.26075426023453,322.46737947454676L173.09598202537745,396.2874816409312L141.09008349385113,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M208.46884649340063,216.02749085891992L185.74340420681983,202.97069093072787"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M138.3179376879707,179.61344214202836L184.32735363207757,206.04863498499617"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M184.32735363207757,206.04863498499617L208.46884649340063,219.91913670208305"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M185.74340420681983,202.97069093072787L145.09131386317313,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M208.46884649340063,337.6705660712905L206.76406360045075,341.3602810949087L205.07032511383295,348.34118324844167L203.79469626769423,355.9588805013336L202.526167396456,362.308169095777L201.0454281596467,369.08302633836865L197.65795118641108,376.4749072599225L192.7889460902661,383.88759073987603L189.6215683426708,390.23685374995694L187.69905288238078,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M208.46884649340063,379.0959847611375L206.96996287629008,382.4069276172668L201.25763852521777,390.23685374995694L195.20293760020286,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M109.74921595398337,179.61344214202836L208.46884649340063,225.03966523893178"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank_boundary"
        d="M1.4769634595140815,332.30663674976677L141.250227374956,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M91.41392489057034,165.99987681675702L98.66378827951849,149.95658405451104L125.13959515374154,161.80539907468483L190.95399698987603,191.6474245400168L203.69608550332487,163.44947648746893L141.98468034621328,135.5698249018751L156.09469738136977,104.05537166818976L217.95441312901676,131.92058217106387L262.2314351648092,151.86912797391415L234.67169877234846,212.8579830317758L213.1919076582417,203.14862485416234L206.48795346170664,217.99516553990543L183.5905340006575,207.64899886678904L117.92523164022714,177.97665243316442Z"
      />
    </g>
    <g>
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M208.46884649340063,228.97292783670127L209.1622773874551,229.28301034821197L209.09916649851948,231.29126252233982L240.2838345868513,255.13010787870735L210.79527164436877,317.78082477487624L208.46884649340063,316.73613053467125Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M423.1918134437874,192.40494560496882m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer water"
        d="M227.74764534831047,233.88325967732817L252.17865941300988,179.61344214202836L271.3580586183816,179.61344214202836L264.9459922835231,196.55778282042593L262.1959352893755,200.85941614257172L257.76002867054194,211.6457447563298L257.1155087156221,219.90144740603864L258.17813831102103,229.6388768395409L263.2522537969053,236.61885096505284L270.66462772432715,243.81212940905243L274.2580039743334,246.34897311404347L278.48880020249635,248.2552471831441L274.6761136148125,252.69836210925132L271.50794698111713,253.32997095678002L266.8519411366433,253.32997095678002L263.47156413737684,250.3748318706639L261.7715145610273,247.83694909652695L260.08487604930997,241.69982651574537L257.5478183059022,238.1005857703276L253.73513171635568,235.35042744828388L250.13465549331158,236.61885096505284L246.1239584889263,242.7559780422598L243.7849111603573,246.08675633370876Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer water_boundary"
        d="M227.7192454477772,233.89054348878562L252.16288169194013,179.61344214202836M271.36121416278183,179.61344214202836L264.9246923578903,196.59732372919098L262.1785797951743,200.84901064727455L257.74977315124124,211.65615023579448L257.1297086654231,219.89416357688606L258.1923382617533,229.6388768395409L263.24199827667326,236.63654021546245L270.6827721055597,243.81212940905243L274.2256596432999,246.38122993847355L278.4777557980269,248.24172013113275L274.6690136389807,252.6702674794942L271.47954708058387,253.29043037164956L266.8732410604134,253.29043037164956L263.50706401094794,250.36754807690158L261.73601468652487,247.79844902269542L260.05253171827644,241.6862994520925L257.5722737759352,238.14324807515368L253.76353161688894,235.30776512622833L250.13149994798005,236.63654021546245L246.14525841455907,242.7486942410469L243.75335571542382,246.11485099000856L227.7192454477772,233.89054348878562"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M208.46884649340063,316.7350900028832L210.80394939146936,317.7829058403149L240.29172344785184,255.13010787870735L209.10311092901975,231.29022197751328L209.5425204942003,229.1071581877768L208.46884649340063,228.6295478567481L208.46884649340063,179.61344214202836L342.02489894162863,179.61344214202836L312.5828802799806,266.79456759244204L265.1432138122618,396.2874816409312L208.46884649340063,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pier"
        d="M208.46884649340063,316.7350900028832L210.80394939146936,317.7829058403149L208.6566013880074,323.50166753679514L208.46884649340063,323.4215466394089Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer footway"
        d="M280.67795916926116,396.2874816409312L323.00012141652405,280.06039537722245L337.23714911565185,241.15458172373474L351.65167619194835,202.63875570660457L360.57871145941317,179.61344214202836L371.7477610614151,179.61344214202836L362.26061665359885,205.55853648064658L338.64767748862505,272.8109654560685L337.70495858136564,275.4185551586561L333.3321628505364,273.9659634097479L325.1403694432229,296.53729021642357L328.96015600673854,297.9898772351444L292.9049050519243,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M368.2340623103082,213.30437801592052L369.35428059101105,210.22123444406316L395.44747769925743,219.66732438839972L394.32725941669196,222.7504637609236Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M370.7498201262206,205.71461880998686L371.4803286679089,203.66577780945227L397.863835866563,213.18367447983474L397.1199162611738,215.23875595349818L385.55405694339424,211.0640784194693Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M326.62110867910087,270.164874822367L338.10886827204376,274.3020573752001"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M208.46884649340063,219.91913670208305L244.34502030164003,240.53129611955956L313.0901340516284,265.290987579152"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M313.0901340516284,265.290987579152L326.62110867910087,270.164874822367M338.10886827204376,274.3020573752001L425.1435176897794,305.6492511741817"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M208.46884649340063,225.03966523893178L215.09075653366745,228.08638312807307L220.71788118593395,232.8416744256392L226.05390686169267,237.24317746749148"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M332.9850529609248,396.2874816409312L374.8323057666421,286.08406548481435L398.76395492162555,218.56954746693373L412.96232720278203,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M224.48402349371463,396.2874816409312L224.89187761582434,394.8723739585839L241.0143431276083,362.7764054876752L243.7352113360539,347.13625236134976L245.72714877407998,335.7549518281594L246.4142685784027,312.2483137422241L251.58778371475637,287.3951417193748L259.22025686781853,274.6818539365195L265.5905122384429,268.0130394594744L276.3769520763308,264.10893413843587L284.2713354192674,256.6388927991502L288.6796310245991,249.16988395433873L290.06807058583945,239.2909679999575L287.77241199370474,226.82524187024683L281.54336723685265,210.10781469149515L281.0542578473687,196.66495949402452L283.3499164376408,185.6871460294351L286.00925152841955,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M360.4919339865446,179.61344214202836L353.00540476478636,198.32983963750303L279.73760692216456,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,304.6336900582537L374.8323057666421,286.08406548481435"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M338.64767748862505,272.8109654560685L374.8323057666421,286.08406548481435"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M398.76395492162555,218.56954746693373L425.1435176897794,228.03955858154222"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,356.3272268008441L410.57200227770954,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M362.26061665359885,205.55853648064658L398.76395492162555,218.56954746693373"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M215.39605546090752,317.208532134071L211.20785908214748,322.73687708191574L212.89449759200215,326.9676760174334L210.7755494909361,332.6791464295238L208.46884649340063,337.6705660712905"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M246.4142685784027,312.2483137422241L239.98642452154309,313.84969363640994L233.84257946535945,316.1815268546343L227.27983588259667,320.4123297915794L220.9663803121075,329.0508180754259L218.61313303373754,332.2535697296262L215.43155533540994,342.62868521315977L213.5319175729528,353.42207690840587L213.31970720831305,364.8460099590011L210.99485983140767,373.51982067292556L208.46884649340063,379.0959847611375"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M251.58778371475637,287.3951417193748L242.72938153985888,295.4384849346243L235.74852831754833,300.7254432234913L222.84392926376313,310.0371810523793L215.39605546090752,317.208532134071L218.61313303373754,322.95642918068916L220.9663803121075,329.0508180754259L226.0120958974585,336.27937859343365L232.36105134431273,342.40913373744115L243.7352113360539,347.13625236134976"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M241.97126198373735,250.35298048658296L255.7262802682817,261.6844753017649L265.5905122384429,268.0130394594744"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M275.38847777526826,179.61344214202836L270.2394181098789,193.46110464027151L271.29573661554605,196.416267988272L271.29573661554605,201.91557389264926L268.7515788981691,207.42215927317739L266.8519411366433,214.4021557699889L266.6397307710722,220.53201869362965L269.17678851261735,224.77016383130103L273.41468471847475,230.48171845125034L277.22027133218944,236.41386375110596L278.27580095268786,240.2191330222413L276.8021616926417,244.86828061239794L274.2580039743334,246.34897311404347"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M226.05390686169267,237.24317746749148L241.97126198373735,250.35298048658296"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M339.24013096001,271.12425188114867L327.78077126760036,266.9964322880842"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M314.16933025512844,262.09444822883233L245.77684859745204,237.46273227455094L208.46884649340063,216.02749085891992"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M327.78077126760036,266.9964322880842L314.16933025512844,262.09444822883233M425.1435176897794,302.06253004912287L339.24013096001,271.12425188114867"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M286.148095484823,396.2874816409312L359.2344495197758,199.8251097779721L367.6195200262591,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M302.5624488592148,179.61344214202836L310.7826421679929,185.7506196941249L316.3884668946266,200.98011989379302L309.72711254749447,214.48019683826715L327.5717164473608,222.4102051090449"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M327.5717164473608,222.4102051090449L335.4511109543964,225.91164269624278"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M352.13131894916296,179.61344214202836L345.43683138582855,198.17375714192167L335.4511109543964,225.91164269624278L319.7972437925637,269.45210544532165L273.5921840937808,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M91.41392489057034,165.99987681675702L98.66378827951849,149.95658405451104L125.13959515374154,161.80539907468483L190.95399698987603,191.6474245400168L203.69608550332487,163.44947648746893L141.98468034621328,135.5698249018751L156.09469738136977,104.05537166818976L217.95441312901676,131.92058217106387L262.2314351648092,151.86912797391415L234.67169877234846,212.8579830317758L213.1919076582417,203.14862485416234L206.48795346170664,217.99516553990543L183.5905340006575,207.64899886678904L117.92523164022714,177.97665243316442Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.0671151643619,427.64036689233035L411.2007445106283,424.5583591698669L410.51362470537424,424.30967583926395L412.6467727581039,418.5483361147344L415.310841165483,419.5337055558339L417.1039793025702,414.6796931712888L413.3906923625618,413.3114125393331L414.49592180829495,410.32824766775593L415.14833062607795,410.568607354071L416.9769686376676,405.5938885062933L416.1754603460431,405.3035837407224L417.2743787029758,402.2912808810361L421.1367651168257,403.71575172431767L422.88651451840997,398.97514492599294L420.24374603573233,397.997056201566L423.7298337733373,388.5501687480137L429.32855852507055,390.60623875120655L436.29521179851145,393.17840644018725L443.9268960664049,395.99821700854227L447.8531822543591,397.44454006291926L441.1421280829236,415.65673902537674L442.57395638059825,416.1811597463675L437.0817312542349,431.09175609145314L435.86290220730007,430.6453751302324L433.7510540802032,436.3786109178327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M374.1585970260203,198.09571589156985L378.75780307129025,185.29069575946778L388.82083434052765,188.93262653099373L390.9823822937906,182.93072359636426L380.9335509724915,179.29503298457712L384.54822714813054,169.21102824341506L395.2344784485176,173.08709206571802L395.7803876399994,171.56372120091692L406.7790378415957,175.53863627742976L394.6893581440672,209.19421331351623L384.66813783720136,205.55853648064658L385.82385599426925,202.326590903569Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.83098489791155,387.7500077369623L425.8069709111005,377.22616498498246L426.04758117720485,376.6309857405722L426.2597915409133,376.37605755217373L426.81280070822686,376.0285227801651L427.1315106973052,375.9504835358821L427.7839195141569,376.0066717923619L432.77993527334183,377.90666706487536L435.4802924422547,370.73433825885877L430.193177706562,368.69387022731826L429.9312675157562,368.4951300644316L429.55575772561133,367.9779894063249L429.38535832520574,367.3547152034007L429.4563580751419,366.7095899269916L433.4031553044915,356.2845652261749L435.5292033823207,357.00773093570024L441.15632803272456,359.2188486424275L439.47678949683905,363.6691761184484L446.15234379377216,366.1986922863871L447.7253827052191,361.64951651729643L455.6907657980919,364.7325927349739L450.63873912300915,378.1397442156449L444.9406147217378,375.9858613242395L443.4527755109593,379.93360558943823L449.1572110019624,382.09477091161534L443.9268960664049,395.99821700854227L436.29521179851145,393.17840644018725L438.1017610002309,388.373280106578L431.164296512492,385.7376388045959L429.32855852507055,390.60623875120655L423.7298337733373,388.5501687480137Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.0009681582451,255.10825650859624L403.5682713575661,231.8000890170224L402.1514318967238,231.28293816372752L402.3778422102332,230.68774638790637L403.7812706073746,229.60349829820916L408.27397702727467,231.26837053289637L408.74178649298847,229.99994603637606L421.71028532180935,234.79789834469557L422.4265939127654,235.06011554971337L418.5642074989155,245.56960654631257L418.5287076244131,245.66221485985443L417.55048884265125,248.3260040706955L419.9739469848573,249.21878944477066L419.00361706502736,251.8409556094557L424.3538426896557,253.81902553979307L420.42045652493834,264.52619070140645L401.34361251536757,257.46092030918226Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.6964725833386,292.4552693339065L416.5304590975866,282.0093222069554L426.62189026828855,285.74380994588137L427.96772997733206,282.07279498968273L416.09104953240603,277.67964471830055L419.5203374698758,268.33872831612825L435.54340333119035,274.25627367570996L435.96151297166944,273.1012757704593L446.76925273425877,277.0979839237407L442.95656614471227,287.4939926932566L432.12831534352154,283.4764797911048L430.7745867725462,287.1402102471329L441.6170375235379,291.14419405860826L437.7333511840552,301.7170726195909L426.8483005836606,297.692284216173L427.3019100986421,296.437398834154L423.76533364877105,295.12632430996746L423.30462415795773,296.38120993226767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.26422814652324,281.81786332372576L394.1860488029197,254.8106616488658L395.0009681582451,255.10825650859624L401.34361251536757,257.46092030918226L399.84078446775675,261.5221509905532L401.6268226308748,262.188096864149L401.7901220563799,261.74170502554625L402.37074223626405,261.94669148977846L403.06575090251863,260.0549887595698L416.5091591728851,265.0298120561056L411.73245375137776,278.0407114154659L407.63655704725534,276.524647383485L407.0693479301408,278.0625627124682L406.5518386410549,277.86381995212287L405.7369192838669,280.07496290421113L411.2007445106283,282.09464627550915L408.0617666626349,290.63433138187975ZM394.62545836903155,275.3051364752464L401.44222327973694,277.82844165945426L403.9445700328797,271.01811689836904L398.8846544986591,269.1472274265252L399.4013749025762,267.7300127078779L397.6508366158232,267.0848781596869Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M328.1949364775792,292.9869831269607L333.3108629267663,278.96262801997364L333.96327174361795,278.74931775499135L345.6632417002693,283.05090007092804L343.42359402310103,289.195269794669L351.02766727562994,291.99431194458157L353.260214978829,285.87907973350957L365.42089442629367,290.3429812658578L359.11374994460493,307.6491569560021L347.62599035259336,303.4256299706176L346.6911603072658,305.9905462716706L340.603326164186,303.7586009032093L338.8101880280301,303.0926590207964L339.7458069585264,300.51941737160087L329.10846659727395,296.608046610374L330.1718850787729,293.70287168910727Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M342.8358738683164,393.4052399522625L350.0573373558,373.6478050830774L351.587776417844,374.2003231192939L358.6814403543249,376.8005910203792L357.2575009185821,380.6848629429005L364.60597507096827,383.3631675746292L366.01650344207883,379.5080317906104L373.5566769205034,382.25084926374257L374.0946972509846,382.44854850973934L366.8740226486698,402.2132419287227L358.7595400791615,399.2446395615116L361.6437077121809,391.35645442735404L354.37254439946264,388.70624695997685L351.5025767162442,396.57258418528363L344.85542231984437,394.1492122001946Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M314.55982888210565,360.84206872200593L320.49856354855,344.6202561012469L327.47152791079134,347.1643466078676L326.28819874022156,350.38165727071464L332.90695323608816,352.8050445592962L332.56694332137704,353.7550454395823L334.5233808849007,354.47092772834003L336.0538199460134,350.29009088361636L339.8381066340953,351.6719108070247L342.5313638271764,352.66353291412815L336.57132923509926,368.92070453893393L335.9402203448117,368.69387022731826L329.98018575273454,366.5108497082256L331.6668242653832,361.897161568515L327.32321732025594,360.3103601359762L326.9824185203761,361.2312252735719L323.1421209163964,359.82131306035444L321.788392345421,363.49228683905676Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M386.11416608281434,316.3448904203251L387.8434044457972,311.5397108257748L388.75772345252335,311.872681368608L389.35254358220845,310.2140716947615L386.22066570911556,309.0809309803881L387.3187951799482,306.0477756294422L389.7422533221543,299.2936674733646L406.23312865011394,305.28194271493703L402.8030518265441,314.7924161301926L399.9188841935247,313.74355930881575L399.3240640638396,315.40841133194044L400.1736944084987,315.72057104250416L398.3458452820778,320.80148861091584Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.04931818600744,314.4022164386697L409.1172962831333,306.4088408490643L430.09377805516124,314.52291821176186L426.3520912164822,324.3028764971532L420.28634588606656,321.9575191019103L420.9663657164201,320.1636427254416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.66365783941,312.9361059325747L378.9921022458002,295.38853923557326L389.7422533221543,299.2936674733646L387.3187951799482,306.0477756294422L385.76705619320273,305.4806846892461L381.61435968987644,317.01083102682605L373.98188653588295,314.2471770863049L374.2508967015892,313.5021557328291Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M351.587776417844,374.2003231192939L354.1532340599224,367.2059201877564L368.32636198494583,372.4002171168104L376.1221345635131,375.2626975979656L373.5566769205034,382.25084926374257L366.01650344207883,379.5080317906104L358.6814403543249,376.8005910203792Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M387.34719508048147,363.35701856855303L389.30284375697374,358.028487008065L396.0067979535088,360.49453317094594L396.6947066457942,358.60910048894584L412.476373356767,364.42771890806034L409.83360487408936,371.6489588683471L389.57974278274924,364.1790334205143Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M324.034351112321,324.6004683733918L324.3254500888288,323.799259447027L326.0049886247143,322.5454193223268L326.1461992384866,322.15522006712854L332.55984334647655,324.5151448305696L348.78170850872993,330.47530396841466L346.24465076532215,337.4197985669598L345.188332259655,337.0306406780146L330.0298855789006,331.4534022207372L330.766705208458,329.4118820936419L324.2473503621295,327.02386467158794Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.82615391444415,246.6184736834839L355.6268733208999,244.48536078678444L357.1723012179136,243.67789934342727L357.89492089953274,241.7289617327042L362.3734273677692,243.41568246064708L378.95660237036645,249.6797496783547L376.4124446520582,256.4547170023434L375.27881530765444,256.0291356225498L355.89667237270623,248.70892368629575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M392.9530198071152,353.450171129778L395.6596880638972,346.39851823356L403.4270607428625,349.4035616898909L414.5172217339277,353.69781647529453L413.0506824478507,357.51758872764185L414.2411115942523,357.98582544364035L414.5882214838639,358.94206876913086L413.8088020030409,360.98358019674197L413.0435824729502,361.1958474069834L406.8571375673637,358.800557251554L407.2610472571105,357.7517070895992L404.7736893398687,356.7881799149327L404.42579056322575,357.69551868131384L402.2650314969942,356.85165201034397L402.5695415362716,356.0514873401262L399.95438406895846,355.0442578215152L399.5859742546454,356.0223526037298Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M312.50478055421263,363.93867212580517L313.27000008523464,361.84097319701687L314.55982888210565,360.84206872200593L321.788392345421,363.49228683905676L329.98018575273454,366.5108497082256L335.9402203448117,368.69387022731826L333.55226207803935,375.2626975979656L319.5771445669234,370.11834797123447L320.21535343304276,368.36090241232887L313.3906996604055,365.8521975320764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.0529152136296,206.4867060193792L412.45507343206555,200.09461215604097L434.4665737859905,208.37842336995527L432.7160355001688,213.04215998668224L424.39644254092127,209.90906998189166L423.7440337231383,211.63846091926098Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.24022862594575,324.2674984410405L408.8269861936569,317.520691761747L420.28634588606656,321.9575191019103L426.3520912164822,324.3028764971532L427.2380103226751,324.65041385916993L424.65125275496393,331.38264617929235L424.3751426162198,331.27651211991906Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M407.16164760664105,214.1753164017573L409.86121588852257,206.80511392466724L430.1647778060287,214.23983035143465L428.9956485852599,217.44263505283743L422.68140412773937,215.13262011297047L421.15806504152715,219.29272754397243Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.55984334647655,324.5151448305696L335.2176006641239,317.2230995837599L351.89938643202186,323.3601552969776L349.24241799954325,330.6521940869279L348.78170850872993,330.47530396841466Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M370.7080091619864,322.71502592554316L373.1243673302233,316.0681088375859L391.28768122009933,322.72230964619666L388.8634341917932,329.37650406360626Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M362.3734273677692,243.41568246064708L365.08798448648304,236.17245748080313L381.6703706039116,242.43757178867236L378.95660237036645,249.6797496783547Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.12125159427524,329.80208094231784L370.7080091619864,322.71502592554316L388.8634341917932,329.37650406360626L387.29039527941495,333.6780549623072L384.17981733195484,332.5376343764365L383.1660986766219,335.3158484338783L381.59305976424366,334.74147618049756Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.1053146356717,368.2193910861388L389.57974278274924,364.1790334205143L409.83360487408936,371.6489588683471L407.3241581460461,378.50912986136973L393.73953926283866,373.50525334337726L394.7737689577043,370.67086628917605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.9290709765628,221.35405048495159L369.6729905810207,219.34891707124189L371.82033858355135,218.43427636567503L372.7204576395452,216.01812593219802L389.2255329173058,222.24787987861782L386.6529752993956,229.11444200435653L370.06980029772967,222.85659948177636L369.6374907065183,222.6869904352352Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M363.42264589946717,342.7212922330946L365.7183044916019,336.4063231633045L377.2983637601137,340.65168115403503L387.531794430688,344.4079883834347L385.89406685717404,348.88641961151734L375.4910256722942,345.06664260243997L374.81810581777245,346.90941733587533Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M385.6605565678328,375.0296203503385L387.11368479020894,371.0537791433744L393.73953926283866,373.50525334337726L407.3241581460461,378.50912986136973L404.83680022880435,385.3047817084007L404.2064802236855,385.06442114524543L391.3862919844687,380.33732838742435L392.4142105905339,377.5164709263481Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M326.9824185203761,338.98683519335464L329.7679753890261,331.36079505085945L330.0298855789006,331.4534022207372L345.188332259655,337.0306406780146L342.4035642761737,344.65563405351713Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M335.2176006641239,317.2230995837599L337.71915853209794,310.38471913244575L354.02543450985104,316.38026851741597L354.4009442999959,316.5144971748814L351.89938643202186,323.3601552969776Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.42579056322575,328.9873457252979L406.24022862594575,324.2674984410405L424.3751426162198,331.27651211991906L421.6392855718732,338.41246324498206L410.6414242563769,334.1598201743327L411.56915432587266,331.74371007597074Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M365.08798448648304,236.17245748080313L367.61794225499034,229.41932178288698L384.20032837148756,235.6771583831869L381.6703706039116,242.43757178867236Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M337.03913870081306,310.1360317058861L337.9810687219724,307.55654946761206L338.70447728876024,306.6356771993451L339.441296919249,306.91245915880427L340.603326164186,303.7586009032093L346.6911603072658,305.9905462716706L356.4985924772918,309.6053597633727L354.02543450985104,316.38026851741597L337.71915853209794,310.38471913244575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M367.61794225499034,229.41932178288698L370.06980029772967,222.85659948177636L386.6529752993956,229.11444200435653L384.20032837148756,235.6771583831869Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M208.46884649340063,228.97188729187474L209.16701070405543,229.28405089583248L209.10311092901975,231.29022197751328L240.29172344785184,255.13010787870735L210.80394939146936,317.7829058403149L208.46884649340063,316.7350900028832Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M308.03337405994534,394.8005780479871L308.7275938410312,392.8943442790769L310.27223285194486,391.980766993016L311.1297520585358,389.62814884539694L326.28109876438975,395.1980568547733L323.7724409215152,402.05092090787366L308.9611041303724,396.615245512221Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M401.74752220511436,332.9985890700482L402.3920421609655,331.29732271982357L403.4483606684953,331.38264617929235L410.6414242563769,334.1598201743327L421.6392855718732,338.41246324498206L419.2158274287358,344.7128630937077L404.68848963920027,339.0929691349156L403.89487020950764,338.7880941797048L405.3188096443191,335.08901302237064L402.7036521760747,334.0755372745916Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M351.4031770657748,257.0072443797253L352.2606962714344,254.72533724689856L353.7422243943438,253.38616020558402L373.47147722076625,260.8343536988832L371.51582854334265,266.0568249146454L352.2393963476643,258.786569527816Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M313.49009931087494,379.3800474880263L314.25531884096563,377.28963689506054L316.09736791811883,376.2272627274506L316.7994765592739,376.48947458481416L331.17850375920534,381.77533053187653L328.7329568071291,388.4658865155652L313.8088093008846,382.97297174250707L314.5456289323047,380.93979097297415Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M311.122652082704,386.0060934331268L311.8523717392236,384.02181809116155L313.2416001856327,384.53271441860124L313.8088093008846,382.97297174250707L328.7329568071291,388.4658865155652L326.28109876438975,395.1980568547733L311.1297520585358,389.62814884539694L311.8949715895578,387.5367008219473Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M324.013840071857,342.84199351258576L325.6010789340362,338.47593550756574L326.9824185203761,338.98683519335464L342.4035642761737,344.65563405351713L339.8381066340953,351.6719108070247L336.0538199460134,350.29009088361636L328.3077471917495,347.43384325737134L329.27886599767953,344.77633529994637Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.3937791706994,390.52819966943935L383.6268081665039,387.140262093395L388.5731241013855,388.96117469482124L389.37384350784123,386.75735012535006L401.89583279564977,391.3783053671941L402.1230319952592,391.46362808765844L399.61437415424734,398.3092121910304L386.8651856649667,393.6029388792813L387.3329951297492,392.34911137772724Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.5970729319379,199.86777231795713L415.1625305758789,193.1073173941113L432.1772262835875,199.5556073896587L431.1145966872573,202.3765372731723L427.48650944884866,201.00197143480182L425.98368140123785,204.95605865167454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.1532340599224,367.2059201877564L356.69739177729934,360.1823754790239L357.016101767309,360.29579277383164L370.36721036117524,365.19978843908757L370.87761967722327,365.38396134693176L368.32636198494583,372.4002171168104Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M353.18211525212973,251.86280699213967L353.89763495884836,249.94925011787564L355.89667237270623,248.70892368629575L375.27881530765444,256.0291356225498L373.47147722076625,260.8343536988832L353.7422243943438,253.38616020558402L353.88422389514744,252.98971380712464Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.2397980224341,348.6876788805239L363.42264589946717,342.7212922330946L374.81810581777245,346.90941733587533L380.5864410828799,349.0279313302599L379.79282165132463,351.2036736640148L378.5810925811529,350.7572875604965L377.1989641096443,354.5416835313663L376.70275474339724,354.36479402007535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M316.25356736779213,374.97967522544786L316.96198709961027,373.030774531886L318.9255246371031,371.87579308403656L319.5771445669234,370.11834797123447L333.55226207803935,375.2626975979656L331.17850375920534,381.77533053187653L316.7994765592739,376.48947458481416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M342.33966450206935,401.05826534330845L344.85542231984437,394.1492122001946L351.5025767162442,396.57258418528363L358.1852309880778,399.03861663723364L355.6623731954023,405.94870542595163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.3707277709618,400.4277104786597L386.8651856649667,393.6029388792813L399.61437415424734,398.3092121910304L400.16028334386647,398.5141946170479L397.6650365656242,405.331677749753L391.6702909851447,403.113291118294L384.6894377619028,400.54841075418517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M359.17054974474013,354.38560455013067L361.2397980224341,348.6876788805239L376.70275474339724,354.36479402007535L374.63350646663457,360.0689581790939Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M357.016101767309,360.29579277383164L359.17054974474013,354.38560455013067L374.63350646663457,360.0689581790939L373.01076772995293,364.5130419600755L370.9060195777565,363.73264815239236L370.36721036117524,365.19978843908757Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M418.5287076244131,245.66221485985443L418.5642074989155,245.56960654631257L422.4265939127654,235.06011554971337L422.6601042030379,234.4222617740743L429.7750680660829,237.05900115519762L429.95256744138896,237.12975815637037L430.20027768146247,237.21404223144054L427.63482003845274,244.18776547163725L427.57092026341707,244.3511307341978L426.0688811019063,248.46127458894625Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M398.16124593187124,341.92008540127426L399.6285741040483,338.1003045551479L404.3626796742901,339.9357974403538L404.68848963920027,339.0929691349156L419.2158274287358,344.7128630937077L418.9894171152264,345.8251874279231L418.571307473816,346.4703146489337L417.9969983836636,346.9801732157357L416.95566871296614,347.34123630076647L416.3387597706169,348.95717547042295Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M396.49590734485537,346.26429015398026L398.16124593187124,341.92008540127426L416.3387597706169,348.95717547042295L414.5172217339277,353.69781647529453L403.4270607428625,349.4035616898909L403.7741706324741,348.4899786715396L401.76172215584666,347.70958306081593L401.5629228549078,348.2204820634797Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M365.7183044916019,336.4063231633045L368.12125159427524,329.80208094231784L381.59305976424366,334.74147618049756L380.67874075844884,337.2710029054433L378.7791029959917,336.5769699555822L377.2983637601137,340.65168115403503Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M416.0413497071713,193.2696433099918L418.25890857353806,187.16160786245018L430.3422771813348,191.5412883386016L428.123929428868,197.6493199276738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.15096506662667,264.3420151132159L423.34722400829196,258.1268665725365L427.09601082187146,259.4733264828101L424.89975188020617,265.67494679708034Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M388.06271478626877,193.51417272677645m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.01127795223147,246.9941095933318m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.7550600813702,293.3449274180457m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M359.1571386810392,386.03522804379463m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M328.40004686731845,357.1461209091358m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M363.8557443767786,374.7320306394249m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M405.59886421542615,368.03833982674405m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M338.95534307230264,329.9435930508189m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.42703181505203,249.19485697010532m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M404.79341149237007,354.37103718100116m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M325.1025029104203,367.4358761231415m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M422.26013894286007,207.43256475962698m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M416.78842485602945,324.47664518188685m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.21902278251946,210.49073641793802m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M342.23000933229923,323.9376500872895m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M380.9974507484585,322.7191880508326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.0222934288904,242.92662714095786m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M374.6390286684036,326.045765794348m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M401.5510895643383,371.1599125955254m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M379.3321121605113,222.46743516018614m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M371.9576047677547,341.68596650799736m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M399.1055426103994,378.01280040992424m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M336.08537539001554,338.0087380018085m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M344.8096669251099,316.8682781220414m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M417.6246441360563,331.50959083857015m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M374.644550871104,235.92480793781579m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.76847114693373,309.8706957390532m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.1350643336773,229.26636162446812m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.08270472195,383.87302343081683m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M317.3098858753219,395.9066512193531m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M411.00983407069,336.7507383325137m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M362.85701455548406,259.81046169018373m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M322.49207875784487,382.3746714233421m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M319.93214331846684,389.04649744415656m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M335.33356692269444,346.1050894074142m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.3335705054924,392.9765454172157m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M418.8048177631572,196.3309428668581m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M362.5146379824728,366.2944205640815m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M364.51130873709917,254.70764804258943m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M369.402402644977,347.79906842904165m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M324.95340343471617,375.87556585483253m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.9366522440687,354.3751992858015m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M362.51858241297305,357.2272819490172m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M424.63547503203154,240.70090472698212m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.6873533502221,343.3164743888192m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.0980554232374,347.9655528301373m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M373.65686545614153,335.5738997217268m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M383.91001828107983,381.77533053187653L385.25664687808603,378.08355597546324L391.3862919844687,380.33732838742435L404.2064802236855,385.06442114524543L401.89583279564977,391.3783053671941L389.37384350784123,386.75735012535006L388.8563342159614,386.57317778561264L389.52294298261404,384.73041359707713L384.8527371874079,383.01563315605745L384.3352278973907,381.9314088956453Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M633.9285388607532,379.5361259067431L508.8908786708489,335.003689608071L441.7590370243415,310.7603515861556L425.1435176897794,304.6336900582537"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M448.631023962982,225.184301125817m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,230.5399889801629L558.193105253391,199.8396774744615L502.4796012220904,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M489.287847623229,179.61344214202836L466.2926062839106,242.81320792576298L441.7590370243415,310.7603515861556L425.1435176897794,356.3272268008441"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M425.1435176897794,305.6492511741817L633.1988192042336,380.58497277321294L641.8174000009894,383.4807465816848"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,382.2768623251468L633.9285388607532,379.5361259067431"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,358.15543117932975L633.9285388607532,379.5361259067431L627.8178270207718,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M641.8174000009894,379.91695722658187L634.3111486257985,377.39577025035396L425.1435176897794,302.06253004912287"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M486.70582337118685,396.2874816409312L508.8908786708489,335.003689608071L533.5806473819539,267.6800668104552L558.193105253391,199.8396774744615L565.470579655841,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M570.0918745119125,333.7207166766748L575.0310904718935,320.11473773559555L611.8176388563588,333.5646372316405L612.3564480720088,332.0912470673211L612.4771476471797,331.74371007597074L619.2592015694827,313.0776183856651L619.6560112852603,313.2264145659283L622.3058797419071,314.1899477955885L624.3404170302674,308.6054072258994L646.3156286226586,316.64872583094984L626.5934757720679,370.996550321579L576.8873394988477,352.819611933548L582.2099541099742,338.1429662411101Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M521.6400671591982,323.2893991759047L538.3928526779637,277.10526768956333L578.1629683459178,291.6467729425058L573.2024524593726,305.31732086790726L568.2206366490573,319.05131427338347L565.5557793565094,318.0732142715715L565.0879698907956,319.37700073141605L560.786962796934,317.80371647980064L554.599729004316,315.5363968149759L548.2570846481249,333.0266833738424L545.1536066755652,331.8925058594905Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M451.3471588548273,306.5784478439018L470.9131122548133,252.44342936296016L496.47538900747895,261.748988810461L497.5735184792429,262.1527184913866L484.2153099095449,299.1022090665065L478.0067761922255,316.28037742106244L477.22735671140254,316.0046363668516Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M482.8544813627377,429.9794454406947L489.0693261688575,413.26146769011393L497.7573289433494,416.5078821578063L495.922379842028,421.4472156148404L501.0816950276494,423.3815354667604L502.08042484894395,420.688679064624L502.9237441048026,420.23501381790265L507.8558600889519,406.947603401728L507.4172394089401,406.2181997895241L508.44436912983656,403.4472977812402L503.30635386984795,401.5337827564217L501.47850474435836,406.4585596183315L492.7755131330341,403.1986136944033L499.13235743995756,386.08413256611675L502.0591249233112,387.1756398291327L509.08257799688727,389.8050374579616L507.4172394089401,394.26991258375347L508.63606845680624,394.7298226552084L509.3231882620603,394.37604567874223L517.9409801717848,397.6006180741824L518.1176906609908,399.04590027499944L519.3152197813615,399.49228327116L521.1083579184487,398.74831159366295L529.8602604679763,402.01554324897006L530.7816794486716,401.57644405262545L531.9011088451371,398.57142321392894L541.2273204857484,402.05092090787366L538.7257626177743,408.7757944264449L539.5619818978012,409.0879499325529L540.0652912389487,410.5831746077165L536.5997145399451,419.93742604972795L527.7626122906804,416.6421088776551L529.7963606929407,411.1710673114285L524.0138254771009,409.0026274290867L522.170987514779,413.9700602083467L521.5690674092621,414.3810646450147L518.2241902854294,423.39610269339755L518.7416995773092,424.35233699623495L516.9272615145892,429.25628734380007L522.3271869653836,431.2686436427757L524.4319351166487,425.6134423180483L533.2619373919442,428.92332244105637L526.8837931603193,446.08764241216704L518.0892907613888,442.7996212663129L519.3933195071295,439.29100963892415L509.03997814655304,435.41509467270225L508.89797864481807,433.99791394686326L505.9144113631919,432.8845632476732L505.76531188655645,433.2674726676196L504.7239822167903,433.72842066315934L495.8868799665943,430.42582644242793L495.7093805912882,429.8805964952335L494.5970511706546,429.46230937168L492.9956123586744,433.771081764251L485.3773391554132,430.9148685336113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.4613049030304,175.04957616887987L427.84071931336075,160.0905634816736L481.43685301579535,179.52187349833548L471.76353148557246,206.40138101950288L457.36399324517697,201.17886485811323L448.6965015111491,198.03952619154006L452.9840975413099,186.11897503817454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M609.7128907032311,210.15776100428775L617.5512631321326,188.27395747881383L627.1180850379169,161.67741075204685L629.7119425805286,162.61287005571648L630.767472201027,159.67226007767022L631.1713818917051,159.81377566000447L637.0320168342441,161.93963072635233L637.3231158088893,161.12487577553838L637.4146265992895,160.86993966111913L641.7661224035546,162.43597564660013L641.6738227279857,162.6981955920346L641.383512637578,163.5129503547214L647.18024780415,165.61070930445567L647.6693571945652,165.7876036320813L641.4474124126136,183.1357123912312L642.3759313691407,183.46868910314515L639.6897741518915,190.9596203151159L640.7673925831914,192.81596317980438L631.6888911817223,218.10858516115695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M570.9628047822043,318.33542832685634L571.0764043815434,318.0243092668243L575.3924003122374,306.11853192700073L573.6205620998517,305.47340095136315L573.2024524593726,305.31732086790726L578.1629683459178,291.6467729425058L578.3901675455272,291.7248131399974L591.4225661493838,296.49462827062234L591.3799662999809,296.628857314121L621.2574500963092,307.55654946761206L619.2592015694827,313.0776183856651L612.4771476471797,331.74371007597074L612.3564480720088,332.0912470673211L582.4789642747492,321.1635935930535L582.5073641752824,321.07827000739053L586.2987508391961,310.6323660146445L586.4407503390685,310.2359228907153L584.4070019386709,309.49818483600393L584.2508024862036,309.44927977072075L579.892206707038,321.47471251059324L579.8496068557724,321.58188725449145Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.0671151643619,427.64036689233035L411.2007445106283,424.5583591698669L410.51362470537424,424.30967583926395L412.6467727581039,418.5483361147344L415.310841165483,419.5337055558339L417.1039793025702,414.6796931712888L413.3906923625618,413.3114125393331L414.49592180829495,410.32824766775593L415.14833062607795,410.568607354071L416.9769686376676,405.5938885062933L416.1754603460431,405.3035837407224L417.2743787029758,402.2912808810361L421.1367651168257,403.71575172431767L422.88651451840997,398.97514492599294L420.24374603573233,397.997056201566L423.7298337733373,388.5501687480137L429.32855852507055,390.60623875120655L436.29521179851145,393.17840644018725L443.9268960664049,395.99821700854227L447.8531822543591,397.44454006291926L441.1421280829236,415.65673902537674L442.57395638059825,416.1811597463675L437.0817312542349,431.09175609145314L435.86290220730007,430.6453751302324L433.7510540802032,436.3786109178327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.6254799989983,381.5984417181462L533.9285461585969,372.69052326353267L545.7066158400849,377.10546430386603L549.2424034038559,367.5950763830915L537.0888239303604,363.0459015276283L537.9108432624489,360.82021768251434L540.3414013795555,354.2867545308545L567.0089075788856,364.26435647765175L566.5410981131718,365.51194590562955L564.0892400713637,372.1307214386761L558.0937056038529,369.88423002744094L555.1953380210325,377.6871167072095L561.1908724866807,379.93360558943823L558.3556157937273,387.57936220476404L555.2805377207696,386.4389504841529L552.3253703387454,394.37604567874223L553.4873995846137,394.81514533096924L551.5672507816926,399.9813275421038L540.6609002565965,395.8920839377679L545.1607066504657,383.77417382830754L541.844229426235,382.5265876855701L540.7808109456673,385.39738815743476Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M545.1536066755652,341.21148551721126L547.6977643920109,334.2316167135723L548.9236934138462,334.6915307659656L549.2495033787563,333.77794580720365L548.7532940125093,332.1339087942615L550.3547328244895,327.71165539557114L551.7723611714318,326.91044682916254L552.4247699873522,325.1394634153694L557.4562856238335,326.98120291670784L560.786962796934,317.80371647980064L565.0879698907956,319.37700073141605L565.5557793565094,318.0732142715715L568.2206366490573,319.05131427338347L568.5535465907305,319.1647322438657L569.0142560806125,317.91713447123766L575.0310904718935,320.11473773559555L570.0918745119125,333.7207166766748L582.2099541099742,338.1429662411101L576.8873394988477,352.819611933548Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.83098489791155,387.7500077369623L425.8069709111005,377.22616498498246L426.04758117720485,376.6309857405722L426.2597915409133,376.37605755217373L426.81280070822686,376.0285227801651L427.1315106973052,375.9504835358821L427.7839195141569,376.0066717923619L432.77993527334183,377.90666706487536L435.4802924422547,370.73433825885877L430.193177706562,368.69387022731826L429.9312675157562,368.4951300644316L429.55575772561133,367.9779894063249L429.38535832520574,367.3547152034007L429.4563580751419,366.7095899269916L433.4031553044915,356.2845652261749L435.5292033823207,357.00773093570024L441.15632803272456,359.2188486424275L439.47678949683905,363.6691761184484L446.15234379377216,366.1986922863871L447.7253827052191,361.64951651729643L455.6907657980919,364.7325927349739L450.63873912300915,378.1397442156449L444.9406147217378,375.9858613242395L443.4527755109593,379.93360558943823L449.1572110019624,382.09477091161534L443.9268960664049,395.99821700854227L436.29521179851145,393.17840644018725L438.1017610002309,388.373280106578L431.164296512492,385.7376388045959L429.32855852507055,390.60623875120655L423.7298337733373,388.5501687480137Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M458.0795129509643,386.49513865821064L468.58905376214534,356.80274728126824L472.44434020109475,358.17728222347796L474.9600980198011,359.07005344936624L473.7901799129322,362.3653979883529L480.6006337348372,364.7960647600703L480.71423333510756,364.47038043569773L482.9254811136052,365.2632604595274L483.9881107090041,362.29464226495475L489.7288349606097,364.3351121810265L491.4572844374925,364.95942717790604L480.8846327364445,394.81514533096924L473.15275993198156,392.05152241233736L474.27928930334747,388.8841761131771L472.0688304118812,388.0902582691051L472.202941050753,387.70734635647386L465.2086767628789,385.21945891249925L464.01114764250815,388.6073974268511ZM468.28454372286797,377.4384316978976L470.99831195548177,378.40195599896833L471.1332114804536,378.02008407283574L476.51183700561523,379.9398487280123L478.92109519802034,373.15147528378293L473.6134694227949,371.2525192312896L473.7199690481648,370.9538888349198L470.93441217951477,369.9549856730737Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.6964725833386,292.4552693339065L416.5304590975866,282.0093222069554L426.62189026828855,285.74380994588137L427.96772997733206,282.07279498968273L416.09104953240603,277.67964471830055L419.5203374698758,268.33872831612825L435.54340333119035,274.25627367570996L435.96151297166944,273.1012757704593L446.76925273425877,277.0979839237407L442.95656614471227,287.4939926932566L432.12831534352154,283.4764797911048L430.7745867725462,287.1402102471329L441.6170375235379,291.14419405860826L437.7333511840552,301.7170726195909L426.8483005836606,297.692284216173L427.3019100986421,296.437398834154L423.76533364877105,295.12632430996746L423.30462415795773,296.38120993226767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M527.2309030499309,181.20132549479604L530.3777697589248,172.363907167688L534.0413568727672,173.67500491207466L536.6210144655779,166.4473153753206L532.9574273526669,165.1362162642181L535.6427956847474,157.60259434394538L547.308054652065,161.78354741074145L545.0826069246978,168.03416118817404L549.15720370505,169.50134289637208L551.5885507073253,162.69091170374304L562.7497114483267,166.69496740028262L559.5539338011295,175.66662434162572L555.9605575520545,174.3763380460441L554.5366181153804,178.40223860740662L558.1150055285543,179.68524028453976L554.1319195376709,190.8534841062501L543.2184690376744,186.941010910552L546.0608257064596,178.93396114604548L540.9228104446083,177.09114175708964L538.0670427121222,185.09195033600554Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M600.1886686487123,252.1323073436506L600.3874679505825,251.59330662386492L602.7612262675539,244.97441599704325L603.3844462968409,243.23774957098067L610.2729998454452,245.72568797506392L613.1997673278674,237.58967865118757L612.8881573127583,237.47625934844837L606.3112137801945,235.08821025118232L606.5810128310695,234.3442209311761L608.9902710234746,227.6337458230555L609.3657808126882,226.57759199058637L633.1775192795321,235.20162959583104L633.4607293950394,235.30776512622833L630.4558621868491,243.67789934342727L623.5602086624131,241.17539259698242L623.4828978246078,241.14729792112485L623.1633989475667,242.040084219072L620.4283307911828,249.65893883397803L627.1180850379169,252.08236133260652L627.3941951775923,252.18849660782143L624.2836172301322,260.86244829325005Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.0551189212129,386.33906039921567L593.4279146511108,373.5760089517571L606.4603132549673,378.3530514235608L604.2135656028986,384.51086345501244L609.9471898796037,386.6158391768113L612.1860486716032,380.45074535533786L622.0581695027649,384.07176314946264L614.9077057642862,403.7095086076297L590.5863468693569,394.7943349224515L593.1518045123667,387.7572913891636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M583.0674733156338,278.36639980087057L586.0652405489236,270.25956388702616L594.4629332330078,273.37077529961243L594.9725536620244,271.97437222115695L594.1647342825308,271.6767780892551L596.212682634592,266.14943295530975L588.4957986669615,263.28586687752977L591.4083661995828,255.42041893303394L616.3395340619609,264.6396095636301L615.8859245469794,265.8591223489493L613.4545775419101,272.44261471601203L604.8730743946508,269.2741732238792L604.1575546888635,271.2168598524295L605.3266839105636,271.65596730681136L603.5335457716137,276.4819853142835L610.9459196990356,279.2310867840424L608.4869616823271,285.87179597467184L607.8708416270092,287.5439384491183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.0067761922255,316.28037742106244L484.2153099095449,299.1022090665065L497.0702091390267,303.79397906083614L493.56913256365806,313.48134507704526L495.5823699263856,314.21179898129776L496.3262895317748,312.1848412398249L497.9774281689897,312.787309744861L501.23000561632216,303.7794115850702L511.6685466784984,307.57111693779007L504.9716924559325,326.10299498960376Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M567.285017718561,195.0625119782053L577.1003387495875,167.8000364182517L578.524278184399,168.31719201011583L591.0825562346727,172.83215639088303L590.8198571586981,173.5615845611319L589.1971184210852,178.07654552301392L583.1944839805365,194.75138738239184L583.2796836802736,194.7794822473079L585.1509215431288,195.45271838689223L585.115421667695,195.55885452590883L583.2299838550389,200.7959426175803Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.2636815663427,260.5086644869298L631.4624808682129,259.9488536044955L634.480759140104,251.5433606095612L639.6116744251922,253.4080115831457L641.7377225030214,247.4613132327795L636.6139071928337,245.5977012021467L639.5193747496232,237.50539458356798L658.5828076964244,244.39275245461613L655.0959310727194,254.102052859962L651.985353124328,252.97514622239396L650.4123142147437,254.30703955050558L648.7043757755309,253.69832271011546L647.9383673602715,255.81686519412324L649.710205571726,256.4547170023434L649.172185242176,257.94997460441664L650.4194141887128,258.3963666842319L650.2774146879092,258.79385331552476L653.0550826955587,259.7927724965848L650.3129145633429,267.41056705918163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.2051302939653,408.57705541560426L639.4349639359862,390.99539363291115L663.848622508347,399.71183293825015L661.8779849950224,405.2682060957886L659.4474268769845,404.40353483567014L658.4550081454217,407.21709772665054L659.1713167373091,407.4720247806981L656.3786598937586,415.33834071131423L649.3914955826476,412.8442200785503L651.3329443074763,407.379418625962L649.0230857664719,406.5511657851748L649.3275958066806,405.68649468244985L647.882356445305,405.16935680201277L645.160699352622,412.85774681018665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M582.7550744144246,237.73223318904638L583.0674733156338,236.86025721859187L588.9849080573767,220.3905043504201L608.6431611329317,227.5057587167248L608.9902710234746,227.6337458230555L606.5810128310695,234.3442209311761L606.3112137801945,235.08821025118232L603.5903455717489,242.6779372948222L603.3844462968409,243.23774957098067L602.7612262675539,244.97441599704325L602.4425162766129,244.86099681211635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.878875262104,273.4623427032493L572.3236333290115,266.83722971891984L573.2166524101049,267.17020240891725L574.1451713657007,264.6396095636301L576.1434198925272,265.3835956319235L577.1855384493247,262.563731929753L576.008520366624,262.1246239002794L578.0288577061146,256.6534603764303L577.617848040536,256.5046629817225L577.0648388741538,255.19358090590686L577.837158379145,253.08856527414173L579.4385971911252,252.48609157744795L580.2393165975809,250.32488584704697L581.2246353533119,249.66622262774035L581.8486442696303,247.98574667796493L591.096756185405,251.40913069574162L589.346217898652,256.129027586896L590.0546376276761,257.6523798657581L589.4314175974578,259.34638050431386L587.8788897255436,260.21731310524046L585.8593412740156,265.6957575934939L584.6476122019812,265.23479842441157L583.6409935215488,267.9849448921159L586.5117500890046,269.04109241534024L586.0652405489236,270.25956388702616L583.0674733156338,278.36639980087057Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M472.50114000122994,340.99921769835055L476.09372736513615,330.8228410212323L499.8762770453468,339.29795331228524L495.6596807660535,351.21095735486597L494.5189514448866,350.8072328576818L489.29652537126094,348.94260808778927L489.9126454256475,347.20700823841617Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M550.4470325000584,243.1961278426461L555.3444374958053,229.68882300984114L562.8775109993294,232.437943036668L561.4172828020528,236.45652606431395L569.6737648714334,239.46786044631153L571.1261042067781,235.45656297681853L577.7235587788746,237.86646336736158L577.9862578548491,237.96531505323946L573.0959528340027,251.46531996224076L570.8783939676359,250.65785933099687L566.1584883471951,248.9284781292081L567.206917992793,246.05866167647764L566.1797882718965,244.6195908379741L560.5313636958599,242.5509910103865L559.0151245854795,243.01091114571318L557.958806078881,245.930674912408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M472.44434020109475,358.17728222347796L477.234456686303,344.6410666606389L489.29652537126094,348.94260808778927L494.5189514448866,350.8072328576818L489.7288349606097,364.3351121810265L474.9600980198011,359.07005344936624Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.1971184210852,178.07654552301392L590.8198571586981,173.5615845611319L604.0297551387921,178.31691326200962L607.6507424013689,179.6207260102965L609.3586808377877,174.88724982878193L619.1598019190133,178.40952247660607L626.8561748480424,157.05005904240534L631.5539916567504,158.73680037725717L631.1713818917051,159.81377566000447L630.767472201027,159.67226007767022L629.7119425805286,162.61287005571648L627.1180850379169,161.67741075204685L617.5512631321326,188.27395747881383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.473170706071,331.0985814877786L520.4638379635289,322.8565381783992L521.6400671591982,323.2893991759047L545.1536066755652,331.8925058594905L544.9761072983965,332.38155490206555L545.9898259555921,332.7571861650795L547.6977643920109,334.2316167135723L545.1536066755652,341.21148551721126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M559.4900340260938,216.43642593594268L562.076791593805,209.30659253150225L563.0968213388696,208.7467775149271L588.1273888507858,217.88174591306597L588.8571085073054,218.93061724025756L586.2277510883287,226.20195497525856L583.3080835798755,225.14580092811957L560.0706542050466,216.64869757276028Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.04931818600744,314.4022164386697L409.1172962831333,306.4088408490643L430.09377805516124,314.52291821176186L426.3520912164822,324.3028764971532L420.28634588606656,321.9575191019103L420.9663657164201,320.1636427254416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M542.9494588719681,263.46379925031215L545.3871169639751,256.83763616811484L572.3236333290115,266.83722971891984L569.878875262104,273.4623427032493Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M511.44213636312634,350.91336662042886L513.83009463083,344.4787442917004L540.3414013795555,354.2867545308545L537.9108432624489,360.82021768251434L529.8744604177773,357.80893601989374L514.2411042964086,351.96221781848Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.3401022721082,248.78696436434984L505.4679018231109,248.1491118487902L505.83631163742393,247.6101108188741L507.57264997344464,242.79135651513934L520.0804393133149,247.32708323700354L530.1860704338178,250.99811659241095L531.94370869454,251.6432526386343L530.016459918581,257.04262277809903L529.6622500522062,257.61700147017837L529.4066509520635,257.8365556318313L528.8047308465466,258.1268665725365L528.1310221068561,258.16952875442803L522.8588962061331,256.19978439388797L522.8943960806355,256.1217437987216L522.0084769744426,256.7242171773687L520.7399481041357,256.2632574113086L520.4070381633937,255.3069999217987L514.099893681705,253.01780843595043L513.3480852153152,253.32997095678002L512.1363561442122,252.89710558904335L512.0022455053404,252.25925345439464L506.1274106139317,250.13342608790845L505.6454011974856,249.70160106709227L505.3827021215111,249.1064108707942Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.60731757152826,211.6176499594003L457.36399324517697,201.17886485811323L471.76353148557246,206.40138101950288L472.22424097545445,206.57203101366758L468.4683541879058,217.0035241637379Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M625.5663460511714,294.1419777185656L631.9508013725281,276.80767377698794L633.283230018802,277.30401047179475L633.2193302437663,276.10635100258514L634.6653584903106,272.18768269522116L640.2001834679395,274.24898990709335L638.7470552446321,278.16869758674875L637.6773256743327,279.08228987269104L639.031054245308,279.5931939375587L637.3941155588254,284.0508562955074L632.9361201291904,296.14708949718624L632.6955098640174,296.78493759362027Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M502.0591249233112,387.1756398291327L504.8304818421602,379.73486575251445L519.8895288733765,385.36201041331515L521.3347682338208,385.90724386135116L520.7115482036024,387.57936220476404L525.2894543232396,389.2951820399612L523.1492062956095,395.0700728450902L509.08257799688727,389.8050374579616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M426.3236913168803,266.65305419266224L428.7337383944541,259.8843400804326L438.76126979105175,263.484610053245L449.51142086740583,267.339810367208L450.43283984810114,267.6727830339223L448.0306816305965,274.4196382299997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.3444374958053,229.68882300984114L557.7678956389427,222.99187049642205L564.2446506358683,225.35182902030647L574.683980582282,229.1706314543262L574.1096714902669,230.75121963955462L575.6827104026452,230.4681913643144L579.8496068557724,231.9915492851287L577.7235587788746,237.86646336736158L571.1261042067781,235.45656297681853L562.8775109993294,232.437943036668Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M547.3648544531316,249.52366833901033L549.7457127450034,242.93391094449908L550.4470325000584,243.1961278426461L557.958806078881,245.930674912408L566.1584883471951,248.9284781292081L570.8783939676359,250.65785933099687L570.7079945672303,251.15419789915904L571.6223135730252,252.21659123664722L571.2752036834136,253.1874167402275L570.1904852762818,254.1228636908345L570.0563746364787,254.49849919462577L570.4460843773559,255.61187854595482L570.020874761045,256.7741631548852L568.7736458163708,257.31940671801567L555.6702474616468,252.56413221452385Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.0936838416383,276.0844996999949L642.5810417598113,269.2741732238792L650.652924478054,272.2365880231373L661.3754645409063,276.19167514238507L658.8802177617326,283.0155218052678L653.5938919112086,281.05931149376556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.0529152136296,206.4867060193792L412.45507343206555,200.09461215604097L434.4665737859905,208.37842336995527L432.7160355001688,213.04215998668224L424.39644254092127,209.90906998189166L423.7440337231383,211.63846091926098Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.6831700652838,350.56583057297394L441.319627459161,343.7410098821856L455.71206572279334,349.3546569100581L456.5908848531544,349.69386879960075L462.2748093055561,351.9122725268826L461.0630802344531,355.05154150538146L455.92506497353315,353.04644676623866L454.46483677625656,356.8089904389344L451.89306804630905,355.76013997383416L451.382658730261,355.56243996694684Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.24022862594575,324.2674984410405L408.8269861936569,317.520691761747L420.28634588606656,321.9575191019103L426.3520912164822,324.3028764971532L427.2380103226751,324.65041385916993L424.65125275496393,331.38264617929235L424.3751426162198,331.27651211991906Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M407.16164760664105,214.1753164017573L409.86121588852257,206.80511392466724L430.1647778060287,214.23983035143465L428.9956485852599,217.44263505283743L422.68140412773937,215.13262011297047L421.15806504152715,219.29272754397243Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.6236633714288,385.1778380367905L562.7355114975944,379.5080317906104L561.5166824525222,379.0470801908523L564.0892400713637,372.1307214386761L566.5410981131718,365.51194590562955L573.1314527094364,367.9779894063249L565.9880889477208,387.1829234790057Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.7678956389427,222.99187049642205L560.0706542050466,216.64869757276028L583.3080835798755,225.14580092811957L581.6001451443881,229.84386425372213L564.8402596507221,223.71400956436992L564.2446506358683,225.35182902030647Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.7217276878655,400.09474418871105L591.032856409438,396.49454516917467L592.9530052104965,397.20313940104097L593.3143150517717,396.20424002222717L614.83670601435,404.1059463880956L612.9449571128935,409.3147829240188L593.6898248419166,402.2496601077728L591.4083661995828,401.4057988594286L591.6276765391231,400.7960544177331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.54828500468284,393.1076510315761L457.56910363491625,390.22332697641104L462.20380955561996,391.8808769863099L463.38003875128925,388.5720196990296L473.15275993198156,392.05152241233736L480.32452359516174,394.6164059215225L478.1345757432282,400.80333805363625L475.3569077346474,399.81796594988555L462.2464094059542,395.1345851109363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M626.6999753983691,258.2194747212343L629.7332425061613,249.80045257881284L630.4629621617496,250.06266921944916L631.9018904333934,246.06594547769055L629.8602531701326,245.32820059312508L630.4558621868491,243.67789934342727L633.4607293950394,235.30776512622833L639.5193747496232,237.50539458356798L636.6139071928337,245.5977012021467L634.480759140104,251.5433606095612L631.4624808682129,259.9488536044955Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M504.0368624115363,379.42999258218333L506.7435306683183,372.15153191564605L518.847410316579,376.67364719044417L522.5961971292272,378.08355597546324L519.8895288733765,385.36201041331515L504.8304818421602,379.73486575251445Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.4869616823271,285.87179597467184L610.9459196990356,279.2310867840424L613.4545775419101,272.44261471601203L615.8859245469794,265.8591223489493L621.5335602359846,267.9422827735543L617.9125729734078,277.7285500075668L614.1353862583637,287.9476666273549Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.23535411898047,271.9889397667721L505.6170012978837,265.2993118991144L522.4762864401564,271.34380561485887L520.0946392621845,278.0334276477806L519.40041948203,277.78577960142866L505.74480084888637,272.8817220921628Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.1811887603253,365.5972689469345L511.7537463782355,358.6517620496452L527.3871024996042,364.4984746091068L524.8216448575258,371.442935122177Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.0594541467726,299.41436951002106L639.3568642102182,298.5923469783738L643.7572709554806,286.4097534925677L644.841989361681,283.4130070246756L651.8149537239224,285.942552477587L649.9587046988308,291.0099649084732L648.8739862907678,290.60519637260586L648.2294663349167,292.3491346789524L649.3204958317801,292.7601463268511L645.9472188074142,301.9792872951366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.2136091263965,248.70892368629575L440.2562089767307,248.55284232273698L442.55975642986596,242.09003030182794L446.05294414330274,243.34492552326992L446.2872433178127,242.7070725071244L456.8890838045627,246.50505452556536L457.94461342692375,246.8879742412828L455.35785585734993,254.14471506653354L443.57268620003015,249.92115547740832Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M619.8114218497649,291.99431194458157L620.4283307911828,290.2940760664642L621.3710496975109,287.74268093239516L622.8943887818605,283.61070908699185L623.8229077383876,282.9874272979796L624.8358375104144,280.2518543121405L624.2197174550965,280.017733332701L626.0546665564179,275.02939378935844L627.2103847125545,271.89633180433884L630.3777624601498,273.08046499593183L629.3648326899856,275.85141911776736L631.9508013725281,276.80767377698794L625.5663460511714,294.1419777185656Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M511.7537463782355,358.6517620496452L514.2411042964086,351.96221781848L529.8744604177773,357.80893601989374L527.3871024996042,364.4984746091068Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M487.5388871077448,212.77265811292455L489.99784512538463,205.92689077416435L504.76658206712455,211.27010693075135L505.15629180613905,211.4189052968286L502.69733378943056,218.2646672106348Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M482.6911819372326,226.258144446183L485.24953960441053,219.13664551777765L499.71376650594175,224.37995907245204L497.1696087885648,231.48792552901432L495.85848006699234,231.02072081249207Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.5970729319379,199.86777231795713L415.1625305758789,193.1073173941113L432.1772262835875,199.5556073896587L431.1145966872573,202.3765372731723L427.48650944884866,201.00197143480182L425.98368140123785,204.95605865167454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M565.5415794067085,388.4013741868548L565.9880889477208,387.1829234790057L573.1314527094364,367.9779894063249L579.3541863774881,370.3098044162616L575.2362008616328,381.39970192546025L573.0888528591022,380.5995400897227L570.9280937928706,386.42438318161294L569.1349556548521,385.7584492410533L567.8451268598437,389.25876379571855Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M489.99784512538463,205.92689077416435L492.45680314302444,199.05926512740552L507.23264005966485,204.4035271257162L504.76658206712455,211.27010693075135Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M506.7435306683183,372.15153191564605L509.1811887603253,365.5972689469345L524.8216448575258,371.442935122177L522.631697004661,377.3322983412072L519.0959094418213,376.0066717923619L518.847410316579,376.67364719044417Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M573.7199617512524,385.48167042946443L575.2362008616328,381.39970192546025L579.3541863774881,370.3098044162616L585.9516409495845,372.77584621077403L585.6258309837431,373.6478050830774L581.182035503909,385.60237096529454L580.3174163224176,387.948747347109Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M435.5931031573564,254.66186421457678L436.88293195329607,251.05430586263537L442.46035677939653,253.0531868552789L443.57268620003015,249.92115547740832L455.35785585734993,254.14471506653354L452.95569764077663,260.89782667253166L451.9348790086806,260.5221915161237Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M459.6028520371765,402.603436680045L462.2464094059542,395.1345851109363L475.3569077346474,399.81796594988555L472.713350366801,407.2805693615228L462.7071188976988,403.71575172431767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M485.24953960441053,219.13664551777765L487.5388871077448,212.77265811292455L502.69733378943056,218.2646672106348L500.4079862860963,224.63593339687213L499.71376650594175,224.37995907245204Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M434.12656387034804,258.25485311448574L435.4234926421195,254.59839118178934L435.5931031573564,254.66186421457678L451.9348790086806,260.5221915161237L449.51142086740583,267.339810367208L438.76126979105175,263.484610053245L439.88069918751717,260.3099212264642Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M520.7896479284391,224.53604097757488L522.7452966058627,219.10751020768657L539.4838821738958,225.1811794876121L537.5282334955409,230.62427313579246L525.1119549479336,226.10934639861807Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M445.04001437313855,334.1462932890281L445.38002428691834,333.27432944765314L447.5699721407145,327.6055212793872L459.0640428205952,332.0912470673211L460.9494806341827,332.82794218929484L461.14827993605286,332.8986982125789L459.09954269602895,338.2064385097474L458.61832216661423,339.4467489295639Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M446.527853583917,327.20075487857684L446.924663297832,326.18727798294276L449.18561090156436,320.33428991772234L460.89978080801666,324.8980602347292L461.7218001410365,325.2237464184873L459.340941847302,331.3680787589401L459.0640428205952,332.0912470673211L447.5699721407145,327.6055212793872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M435.5292033823207,357.00773093570024L438.1514608245343,350.35356303909793L438.6831700652838,350.56583057297394L451.382658730261,355.56243996694684L451.89306804630905,355.76013997383416L450.9645490888506,358.1419043401256L450.6032392475754,358.0003928048536L449.3205104274675,357.4967782073654L449.1217111265287,358.0003928048536L447.7253827052191,361.64951651729643L441.15632803272456,359.2188486424275Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M418.5287076244131,245.66221485985443L418.5642074989155,245.56960654631257L422.4265939127654,235.06011554971337L422.6601042030379,234.4222617740743L429.7750680660829,237.05900115519762L429.95256744138896,237.12975815637037L430.20027768146247,237.21404223144054L427.63482003845274,244.18776547163725L427.57092026341707,244.3511307341978L426.0688811019063,248.46127458894625Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M496.2339898571372,246.83074439270422L501.00359530281276,233.64289386430755L501.7901147585362,233.06851318432018L507.3675395846367,235.11006168602034L502.3289239751175,249.05646483786404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M614.1353862583637,287.9476666273549L617.9125729734078,277.7285500075668L621.0941506708041,278.905398438219L622.9511885838583,273.87335547432303L626.0546665564179,275.02939378935844L624.2197174550965,280.017733332701L622.8943887818605,283.61070908699185L621.3710496975109,287.74268093239516L620.4283307911828,290.2940760664642Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.9361201291904,296.14708949718624L637.3941155588254,284.0508562955074L643.7572709554806,286.4097534925677L639.3568642102182,298.5923469783738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M436.12481239717454,224.8201100397855L439.30639009550214,216.41457444475964L440.03689863719046,216.6913600093685L440.44790830276906,216.30115479556844L440.9859286332503,216.1315455888398L441.5460377726704,216.20230280375108L441.79453689884394,216.33029011683539L442.1913466155529,216.73402244364843L442.3609571289271,217.27926915884018L442.3609571289271,217.55605468619615L443.757285551168,218.0877742213197L443.16167653445154,219.66732438839972L448.5339909726754,221.7088768351823L446.26594339311123,227.72531383065507L445.95433337893337,228.56919622328132Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M581.182035503909,385.60237096529454L585.6258309837431,373.6478050830774L591.8903756141663,375.9858613242395L587.4465801352635,387.95499047636986Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M416.0413497071713,193.2696433099918L418.25890857353806,187.16160786245018L430.3422771813348,191.5412883386016L428.123929428868,197.6493199276738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M500.0537764215842,288.86229816125706L501.9810251984745,283.4411015273072L515.64453269355,288.33786780852824L513.7101839417592,293.7663443638012Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M443.10487673431635,339.1356308152899L443.32497596088797,338.55397517746314L445.04001437313855,334.1462932890281L458.61832216661423,339.4467489295639L459.09954269602895,339.63092252239585L459.41904157307,339.7589075556025L457.4981038849801,344.7544842129573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M498.147827568464,294.2335448488593L500.0537764215842,288.86229816125706L513.7101839417592,293.7663443638012L511.80344620440155,299.13758725114167Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M501.9810251984745,283.4411015273072L503.8877629349008,278.09794100467116L517.5433815699071,282.99471106007695L515.64453269355,288.33786780852824Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M496.24818980693817,299.5704497289844L498.147827568464,294.2335448488593L511.80344620440155,299.13758725114167L509.89749735221267,304.47448835289106Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.8877629349008,278.09794100467116L505.74480084888637,272.8817220921628L519.40041948203,277.78577960142866L517.5433815699071,282.99471106007695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M520.0804393133149,247.32708323700354L522.6103970799595,240.30445760395378L532.7160282013938,243.96821087785065L530.1860704338178,250.99811659241095Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.6427812213078,206.9122904408723L518.9681098917499,203.26932856533676L521.9374772254378,195.1124583990313L522.3910867413506,195.26854096353054L523.5673159360886,194.59530480857939L525.3675540480763,195.26125711249188L525.7004639888182,196.62229693727568L527.5149020506069,197.2882490460761L523.6170157613233,207.97469055932015L523.2557059219107,208.97361706430092Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M533.8859463082626,212.46777760144323L538.3502528276294,200.22155921906233L541.0222100960091,201.1996758505702L541.7448297757655,202.38382111722603L543.7430783035234,203.11324617965147L539.569081873633,214.5509540704079Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M441.319627459161,343.7410098821856L441.41113824769855,343.5152152720839L443.10487673431635,339.1356308152899L457.4981038849801,344.7544842129573L455.9037650488317,348.8656090637669L455.71206572279334,349.3546569100581Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M477.6667662775144,240.24098443891853L479.4599044136703,235.25885953800753L492.62720254436135,240.02038917737082L490.8340644063428,245.00979445688426Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,228.03955858154222L466.2926062839106,242.81320792576298L533.5806473819539,267.6800668104552L641.8174000009894,307.20484911464155"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.3835054710507,230.91458521736786L525.1119549479336,226.10934639861807L537.5282334955409,230.62427313579246L535.7918951595202,235.4211844666861Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M449.77411994244903,230.0644598393701L451.573569169268,225.02509759599343L452.0484786098823,225.19574713055044L463.0471288114786,229.15710436413065L461.2468907004222,234.2027068710886Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M529.924160243012,207.23798216879368L532.8935275757685,199.07383282575756L534.6298659136519,199.71897370414808L536.0893052257597,199.39328162325546L538.3502528276294,200.22155921906233L533.8859463082626,212.46777760144323L530.8952790498734,211.36895899288356L532.1070081209764,208.02463688747957Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M479.4599044136703,235.25885953800753L480.9548436002806,231.09147787606344L494.1221417300403,235.86133473273367L492.62720254436135,240.02038917737082Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M520.3005385389552,239.460576640442L521.8664774745703,235.11006168602034L534.2827560240403,239.61665820656344L532.7160282013938,243.96821087785065L522.6103970799595,240.30445760395378Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M502.6760338647291,197.2882490460761L506.0138110117987,188.11787475645542L511.8815459283069,190.2718160226941L508.5366688054055,199.44218746200204Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.5584066314623,220.97216990450397L455.26634506881237,216.2168704662472L466.2571064103395,220.17823282908648L464.56336792279035,224.93352955160663Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M521.8664774745703,235.11006168602034L523.3835054710507,230.91458521736786L535.7918951595202,235.4211844666861L534.2827560240403,239.61665820656344Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M539.569081873633,214.5509540704079L543.7430783035234,203.11324617965147L545.1962065240368,203.6449668239802L546.7763454113156,203.21938220132142L549.2566033536568,204.1340249152854L546.0537257306278,212.90688877785578L542.9068590225652,211.75188064668328L541.6170302256942,215.30222934484482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.6170157613233,207.97469055932015L527.5149020506069,197.2882490460761L527.7768122414127,196.5515395188704L530.3138699838892,197.48699411656708L531.0648895641789,198.40788088552654L532.8935275757685,199.07383282575756L529.924160243012,207.23798216879368L526.5721831452101,205.99764809431508L525.5868643885478,208.70515557890758Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M491.8193831620738,193.3050220347941L495.15716031193733,184.13568302802742L500.6777853379026,186.16163766290992L497.33921930287033,195.33201454021037Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M497.33921930287033,195.33201454021037L500.6777853379026,186.16163766290992L506.0138110117987,188.11787475645542L502.6760338647291,197.2882490460761Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M508.5366688054055,199.44218746200204L511.8815459283069,190.2718160226941L517.1749717546627,192.22076810058206L513.8371946057305,201.3838531137444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M513.8371946057305,201.3838531137444L517.1749717546627,192.22076810058206L522.2987870657817,194.106246041134L521.9374772254378,195.1124583990313L518.9681098917499,203.26932856533676Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M452.0484786098823,225.19574713055044L453.5584066314623,220.97216990450397L464.56336792279035,224.93352955160663L463.0471288114786,229.15710436413065Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.1438649604097,219.4415257354267L641.8655220530927,211.87258420791477L647.882356445305,214.04836959624663L645.160699352622,221.61626819847152Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M545.4794166395441,254.68267504358664L547.3648544531316,249.52366833901033L555.6702474616468,252.56413221452385L553.7919096229598,257.7231366573833Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M427.57092026341707,244.3511307341978L427.63482003845274,244.18776547163725L430.20027768146247,237.21404223144054L435.8061024071649,239.2909679999575L435.9473130227998,239.3471573656425L434.0910639958456,244.42188766039908L433.4599551046267,246.1294185896404L433.3329444397241,246.48424367094412Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.15096506662667,264.3420151132159L423.34722400829196,258.1268665725365L427.09601082187146,259.4733264828101L424.89975188020617,265.67494679708034Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M446.26594339311123,227.72531383065507L448.5339909726754,221.7088768351823L450.9929489893839,222.64432803494856L448.73200138565153,228.66076422156766Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.0590597689152,220.3551257639192L531.0364896636456,217.64137954590842L536.4230040498078,219.5965672088787L535.4447852699086,222.3113532080315Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M515.0205237763003,214.69246853375807L516.0200424836949,211.99953105580062L521.391568033956,214.0057071428746L520.3999381894246,216.70592767046764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M516.0200424836949,211.99953105580062L517.1749717546627,209.24311908334494L522.2845871150494,211.36895899288356L521.391568033956,214.0057071428746Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M538.4851523526013,217.18041718099266L539.4341823486611,214.6009003506042L539.569081873633,214.5509540704079L544.6715972600505,216.5706565300934L543.7217783778906,219.13664551777765Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M535.4447852699086,222.3113532080315L536.4230040498078,219.5965672088787L541.2841202858835,221.34780720435083L540.3272014297545,224.01888958271593Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M553.1608007326722,298.48205027682707m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M475.8105172496289,280.62748839939013m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M628.6209130845964,189.6162687521428m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M602.778581761755,311.85499230772257m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M543.7430783035234,377.39577025035396m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.1911800801754,336.4177689841017m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M439.1407240116969,376.2022901689634m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M616.5596332876012,244.32615769701079m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M599.4983932999894,271.436413585674m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M486.6537568885833,312.4855552325025m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M578.2978678699583,186.41345119057223m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M581.7169002881274,263.6021910943091m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M564.0616290559992,241.00890562776476m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M483.48164582345635,354.491738258861m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M574.0970493135974,217.26574204536155m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M462.915384830907,209.09432067302987m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M631.4798363624141,289.09641884220764m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M511.69300214760005,387.377501018811m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M437.9187394203618,266.9964322880842m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M565.3830132978037,230.07798692770302m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M559.1216242099181,250.09076385991648m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M448.2799696428701,350.1298496997915m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M566.5521425185725,375.58942193863913m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M568.5819464903325,223.35294003924355m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M470.87603460717946,394.87549551809207m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M633.5033292453736,247.9326790086925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M513.3165297703817,378.7567743100226m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M615.6839697016403,275.0855828667991m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M512.8558202804998,271.6663726987317m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M518.2849345160648,365.04787179781124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M626.4593651322648,283.2995884688571m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M520.8141033975407,358.2303490494378m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M496.3475894574076,212.09526146296412m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M491.20326310768723,225.3195720957592m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.8974611256272,375.45415390096605m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M498.61484814994037,205.16520899208263m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M515.782587762922,371.7977537899278m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M580.4302270375192,377.523754586m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M448.9481561826542,257.5920284842141m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M493.97383114043623,218.7006563777104m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.34610218461603,262.00392121402547m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M530.135581722483,224.8586102416739m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M453.02275296021253,333.71031138068065m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.71231904253364,356.3844557455741m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.801948050037,240.9704055180773m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M619.979454590939,281.8147417102009m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M638.364445480518,291.2784232054837m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M586.5369944451377,380.79411781346425m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M507.8487601149827,288.6000829911791m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M451.4994138740003,339.5393559890799m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M505.92861131299287,294.0004648761824m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M509.7625978272408,283.21738603012636m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M504.0258180052042,299.35401849169284m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M511.6440912084654,277.94186030188575m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M526.398628199473,245.64764725929126m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M523.2407170850784,200.27878945041448m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M538.8133289767429,207.79051346890628m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M449.40965455863625,344.2477470645681m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M485.1469844104722,240.13068680930883m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M488.40666183363646,231.05609934404492m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M530.4558694837615,230.7689089057967m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.1360232066363,203.73029185459018m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M527.2908583944663,239.53861742233858m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M507.27760656829923,193.7805536966771m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M459.90815096348524,220.57468110322952m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M528.6177648389712,202.53574132313952m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.6765151573345,191.72546586068347m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M512.8566091665998,195.8314787214622m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M517.8881248012185,198.2486767405644m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M458.3059232663363,225.06463834270835m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M550.5756209371611,253.6234037107788m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M431.7938276315108,241.76746184099466m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M480.9548436002806,231.09147787606344L482.6911819372326,226.258144446183L495.85848006699234,231.02072081249207L494.1221417300403,235.86133473273367Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M762.6439861133695,260.7916915342212L773.940046380274,188.5288925850764L776.9583246530965,179.61344214202836L858.4912823121995,179.61344214202836L858.4912823121995,396.2874816409312L765.1699994513765,396.2874816409312L764.5712348911911,372.81850768625736L763.4234055951238,322.00642407825217Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M739.0420913537964,223.78892888873816m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M755.3302229512483,179.61344214202836L755.2095233751461,181.26479919906706L753.9977943031117,182.9515346409753L751.4252366861328,183.63205579388887L749.4695880096406,183.37712050741538L747.053229842335,181.44897699542344L746.3771544415504,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,307.20484911464155L658.3847972815856,313.25450895074755"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M683.4713757093996,245.8318233434111L641.8174000009894,230.5399889801629"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M658.3847972815856,313.25450895074755L755.316023000516,346.8240940673277"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M850.9708309862763,179.61344214202836L856.1522349836305,184.53941722866148L858.4912823121995,189.2166970516555M858.4912823121995,285.6335130399093L857.7189628053457,287.00598102249205L849.8805903764442,299.0314526981674L839.0381396245211,299.27285677799955"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M708.0696336310357,179.61344214202836L683.4713757093996,245.8318233434111L658.3847972815856,313.25450895074755L641.8174000009894,358.15543117932975"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M802.9245110964403,298.3936048061587L789.8353126933798,295.2969721178524L780.8846108429134,287.90500463265926L776.1015943335369,277.33938876725733L776.4700041487813,265.7311359504238L781.5441196337342,232.1049686805345L787.107344510965,205.3036020002328L790.9113533524796,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M769.7881387621164,396.2874816409312L769.7092501511797,387.11216800892726L768.2001110147685,344.5214059394784L767.4696024740115,303.9635861259885L767.1437925072387,293.4333729511127L767.0088929831982,272.95247872779146L767.1437925072387,258.23404229525477L768.0581115139648,246.1086077336222L769.8228497523814,232.2891451222822L773.0754271997139,207.44297024514526L774.7620657114312,197.74921273300424L776.6893144883215,187.7276679337956L778.510852525942,180.93182238191366L778.9928619414568,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M641.8174000009894,383.4807465816848L679.942688120529,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M763.0581513233483,293.3189140241593L767.1437925072387,293.4333729511127"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M732.3057928262278,287.9268558979966L741.87971470505,290.96730292961L747.8397492971271,292.58949845610186L754.1610937295482,293.0712665230967L763.0581513233483,293.3189140241593"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M757.2653605882078,181.78195378789678L757.3592380359769,179.61344214202836M743.6334085371345,179.61344214202836L743.9134631073102,181.1805144441314L747.0319299176335,184.63098580902442L751.5033364119008,185.85051267128438L755.4225226249546,184.96396244643256L757.2653605882078,181.78195378789678"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M682.1468359222636,396.2874816409312L641.8174000009894,382.2768623251468"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M767.7046905355528,179.61344214202836L766.109562812373,184.73087880248204L764.3448245758191,192.0438744467683L761.063847227022,209.21502428036183L758.0660799946636,231.97698165569454L755.6071219760925,251.50069838901982L754.6928029702976,263.4211371038109L754.2107935547829,274.51848939154297L754.1610937295482,293.0712665230967L755.316023000516,346.8240940673277L756.5135521218181,370.9403620236553L757.27719388064,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M757.2653605882078,181.78195378789678L766.109562812373,184.73087880248204"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M690.5618841014802,396.2874816409312L641.8174000009894,379.91695722658187"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M775.676384717226,183.39897210337222L858.4912823121995,189.42688841745257"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M747.0027411310002,181.312664616853L754.7693249238655,181.8776846122928"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M723.6635454464704,179.61344214202836L747.0027411310002,181.312664616853M754.7693249238655,181.8776846122928L763.4873053701594,182.51242156792432L775.676384717226,183.39897210337222"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M651.8149537239224,368.87075936980546L653.48739228677,364.25082965102047L654.5650107171386,363.79716071113944L654.0404014512897,362.7129334448837L655.762539839372,357.95773124089465L656.7612696588039,357.5956281805411L656.3573599690571,356.31369996163994L657.9524876913056,351.91955621307716L659.0293172374368,351.3597527141683L658.6041076211259,350.1121607394889L660.1700465586036,345.803336342331L661.1127654640004,345.14468219550326L660.836655324325,343.9616018421948L662.3954942850396,339.6663004993461L663.4731127182022,339.0284563465975L663.0479031018913,337.87346923397854L664.6138420375064,333.5157323339954L665.7119715092704,332.7779967589304L665.2867618929595,331.6875214627944L666.839289765805,327.3994962265715L667.9516191873699,326.8115964154713L667.6684090718627,325.65660726698115L668.1425296254456,324.3028764971532L670.0918672140688,323.26754801813513L671.4668957106769,323.76388138951734L672.3031149916351,324.8907765187323L673.1464342474937,324.3882000427693L678.0643502827734,326.18727798294276L678.383060272783,327.05195899959654L679.2760793538764,326.6347061987035L684.2436952134594,328.45563469361514L684.5766051551327,329.39107148721814L685.5619239108637,328.9446839801967L690.2392296809703,330.6667615082115L690.8340498106554,331.701048349496L691.465158700943,331.1131489062682L696.5889740129933,332.9985890700482L696.8366842521355,333.8060401091352L697.850402909331,333.45121949678287L702.6121194930747,335.2024307306856L703.0026181200519,336.3147565876134L704.0936476150528,335.7549518281594L708.7567534353584,337.4551765555516L709.1819630516693,338.49050291255116L708.2747440198436,341.0980679113418L708.7709533860907,342.45179540105164L710.2871924974024,342.98350535612553L711.88863130752,342.45179540105164L712.7816503886133,339.8931357623078L713.7243692949414,339.2771427365951L718.1681647757068,340.91389435436577L718.7061851052567,342.0189356007613L720.038613752462,341.6016837032512L724.290709907189,343.16039515752345L724.9068299634382,344.3372324774973L721.5619528386742,353.939218651969L721.5619528386742,353.9537860243581L721.5974527141079,354.0245418329723L721.9800624800846,354.67591145122424L722.2072616806254,355.0869194041006L723.6106900777668,355.5832504965365L724.6804196480662,355.02344729052857L725.1553290886804,356.2991325943731L728.1530963210389,357.3552666576579L728.6138058118522,357.093054078985L729.8965346338227,356.3626046925783L730.4984547384083,357.7662744522095L731.2920741690323,359.62985632615164L729.7758350577205,360.47268213378266L726.2889584349468,370.4939771881327L728.2382960226387,374.7382737817243L729.4074252434075,377.2823532316834L730.7682537902147,376.53109551314265L741.9649144066498,380.45074535533786L744.1051624342799,386.28287222329527L740.0092657292262,398.08237884007394L738.6768370829523,398.692123521585L736.8055992200971,399.5557549749501L734.5596404531971,400.6045988118276L722.8872815100476,396.5091124526225L720.2090131537989,390.55629373760894L723.1144807115197,382.2009041933343L720.8464331338182,381.4069855841808L719.8611143771559,382.0666768066585L717.430556259118,389.04649744415656L715.8575173486024,389.60629790090024L711.5344214430079,388.0611236668192L710.8686015624553,386.93527933117L709.7980831060559,387.4378512725234L705.4544761618599,385.8864334258251L704.8233672715724,384.79492595931515L701.5707898223773,383.6461896048859L700.3945606276393,384.07176314946264L696.2631640471518,382.583816410508L695.6391551317647,381.3580810269341L694.3848262093961,381.9178821039386L690.0688302805647,380.3727061566897L689.4811101248488,378.97632463788614L688.0989816533402,379.6713938647881L683.8823853740469,378.1543115377426L683.4145759083331,376.75168643007055L681.9267366966233,377.45299901859835L677.6888404916972,375.9359162063338L677.1855311524123,374.40530625823885L665.8610709849745,370.4939771881327L664.5712421890348,370.98302350891754L663.9401332968846,372.78312987834215L664.5712421890348,374.13581065740436L663.5362236071378,374.6394240502268L658.9583174865693,373.030774531886L658.3705973308533,371.93926504347473L657.3781786002219,372.37836611736566L652.658272979781,370.72809511236846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M680.686607724987,290.0318609504029L702.3076094537973,230.0353245739825L743.0843438021839,244.85371300950646L722.1220619790256,303.01461895368993L721.4633420743048,304.8355536512099Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M570.0918745119125,333.7207166766748L575.0310904718935,320.11473773559555L611.8176388563588,333.5646372316405L612.3564480720088,332.0912470673211L612.4771476471797,331.74371007597074L619.2592015694827,313.0776183856651L619.6560112852603,313.2264145659283L622.3058797419071,314.1899477955885L624.3404170302674,308.6054072258994L646.3156286226586,316.64872583094984L626.5934757720679,370.996550321579L576.8873394988477,352.819611933548L582.2099541099742,338.1429662411101Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M609.7128907032311,210.15776100428775L617.5512631321326,188.27395747881383L627.1180850379169,161.67741075204685L629.7119425805286,162.61287005571648L630.767472201027,159.67226007767022L631.1713818917051,159.81377566000447L637.0320168342441,161.93963072635233L637.3231158088893,161.12487577553838L637.4146265992895,160.86993966111913L641.7661224035546,162.43597564660013L641.6738227279857,162.6981955920346L641.383512637578,163.5129503547214L647.18024780415,165.61070930445567L647.6693571945652,165.7876036320813L641.4474124126136,183.1357123912312L642.3759313691407,183.46868910314515L639.6897741518915,190.9596203151159L640.7673925831914,192.81596317980438L631.6888911817223,218.10858516115695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M662.558793711476,193.46110464027151L666.4629910895601,182.22210745932534L663.8131226329133,181.2939346707426L666.3572803512216,173.9590760571882L667.172199706547,171.64800607366487L667.2573994062841,171.38578646676615L696.8082843525335,181.76114273630083L696.6457738121971,182.24291850673035L688.5596911441535,205.44511665031314L672.9263350209221,199.95309739606455L673.8051541540772,197.40166900865734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M672.6715248068795,312.5250954772346L678.4966598739848,296.2532240943983L717.0692464187741,310.16516663506627L715.9924168735743,313.2045633792877L711.2512113275006,326.43596483115107Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M717.508655984886,328.89473852235824L724.5313201714307,309.8956685368903L745.6640013959259,317.76209520036355L745.9125005211681,339.4748432058841Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M808.1335261082277,284.52534119552L808.6218466125429,268.9838627493009L837.42250086274,269.8839292344637L836.9333914723247,285.4326894208789Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.2636815663427,260.5086644869298L631.4624808682129,259.9488536044955L634.480759140104,251.5433606095612L639.6116744251922,253.4080115831457L641.7377225030214,247.4613132327795L636.6139071928337,245.5977012021467L639.5193747496232,237.50539458356798L658.5828076964244,244.39275245461613L655.0959310727194,254.102052859962L651.985353124328,252.97514622239396L650.4123142147437,254.30703955050558L648.7043757755309,253.69832271011546L647.9383673602715,255.81686519412324L649.710205571726,256.4547170023434L649.172185242176,257.94997460441664L650.4194141887128,258.3963666842319L650.2774146879092,258.79385331552476L653.0550826955587,259.7927724965848L650.3129145633429,267.41056705918163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.2051302939653,408.57705541560426L639.4349639359862,390.99539363291115L663.848622508347,399.71183293825015L661.8779849950224,405.2682060957886L659.4474268769845,404.40353483567014L658.4550081454217,407.21709772665054L659.1713167373091,407.4720247806981L656.3786598937586,415.33834071131423L649.3914955826476,412.8442200785503L651.3329443074763,407.379418625962L649.0230857664719,406.5511657851748L649.3275958066806,405.68649468244985L647.882356445305,405.16935680201277L645.160699352622,412.85774681018665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M658.4621081212536,228.94379256572574L664.0111330477521,213.91309840371832L665.2086621690542,214.3594933222048L683.1171658430248,221.01379176648334L677.5681409174576,236.04551107762381Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.3741798959672,223.79933435004205L645.160699352622,221.61626819847152L647.882356445305,214.04836959624663L651.3258443335071,204.48781159846112L665.0603515775874,209.46995861642063L662.0554843703285,217.81827254639938L660.1842465074733,217.13775474764407L659.2565164370462,219.72455446096137L661.1198654398322,220.39778817584738L658.1078982558101,228.77418366866186Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.0936838416383,276.0844996999949L642.5810417598113,269.2741732238792L650.652924478054,272.2365880231373L661.3754645409063,276.19167514238507L658.8802177617326,283.0155218052678L653.5938919112086,281.05931149376556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M645.9472188074142,301.9792872951366L649.3204958317801,292.7601463268511L649.9587046988308,291.0099649084732L651.8149537239224,285.942552477587L653.5938919112086,281.05931149376556L658.8802177617326,283.0155218052678L658.993817362003,283.0581838330254L651.3400442833081,303.9635861259885Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.0594541467726,299.41436951002106L639.3568642102182,298.5923469783738L643.7572709554806,286.4097534925677L644.841989361681,283.4130070246756L651.8149537239224,285.942552477587L649.9587046988308,291.0099649084732L648.8739862907678,290.60519637260586L648.2294663349167,292.3491346789524L649.3204958317801,292.7601463268511L645.9472188074142,301.9792872951366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.9298379672691,209.42729613697156L671.2680964106694,203.09243519604206L687.9995820028707,209.31387637136504L686.9085525069386,212.22637049946934L685.6116237351671,215.63520451122895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.2086621690542,214.3594933222048L667.2573994062841,208.80400767736137L668.9298379672691,209.42729613697156L685.6116237351671,215.63520451122895L683.9107852745801,219.9513936485164L683.6204751841724,221.19900905387476L683.1171658430248,221.01379176648334Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.8916891878471,180.45004652347416L649.3346957806498,167.68661597324535L656.0031501026824,170.011214483995L655.6773401377723,170.9331454592757L652.1904635140672,180.95367398578674L651.5530435331166,182.78192461887375Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.9361201291904,296.14708949718624L637.3941155588254,284.0508562955074L643.7572709554806,286.4097534925677L639.3568642102182,298.5923469783738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M656.4141597691923,185.3614532891661L657.321378801018,182.75278915371746L660.7656555734575,172.86753521952778L661.0346657382324,172.08816038630903L666.0377814751118,173.8456557104364L666.3572803512216,173.9590760571882L663.8131226329133,181.2939346707426L661.7225744305179,187.2885551629588L661.3825645148754,187.16160786245018L660.4611455341801,189.80460853036493L660.3191460333765,189.76194592844695L658.4344971068203,189.0959930960089L658.2001979313791,188.06792828487232L658.8526067472994,186.2188680130057L658.1291981805116,185.96393282106146Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M725.0701293870807,223.84199674101546L728.6422057123855,213.6019746568054L730.9307643296197,214.4021557699889L731.4624735703692,212.8860778226517L734.1833417769521,213.84234116552398L733.5956216230989,215.49369006836787L734.5738404039294,215.84123288840055L731.086963779293,225.83984503243119L728.8189162015915,225.03966523893178L728.5428060628474,225.83984503243119L726.7212680242956,225.19574713055044L726.9555672006682,224.50794623466209Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M738.5987373581156,231.1060455092229L739.4207566883415,228.76689985208213L742.4256238965318,220.13557041576132L743.9063631324098,220.66000592848286L744.1832621591166,219.84525788389146L745.6782013438642,220.37697724346071L745.4020912051201,221.16987375030294L748.2223590621725,222.1552712493576L744.3954725237563,233.15383785543963L741.6462044166401,232.19029335863888L741.4687050404027,232.68559270678088L739.8672662293538,232.12577957753092L740.0447656046599,231.61591256270185Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M801.9178924150765,305.65757544571534L806.1486886451021,306.9259860967286L811.0176937403157,308.2016802527942L816.7292292062193,309.4700904362835L821.810444667004,310.1006535780616L827.0975594026968,310.31396287865937L833.0213052332401,309.4700904362835L841.0576880779117,307.13825496006757L837.2986457431689,396.2874816409312L805.2241141190752,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M719.2662942474708,221.31242862530053L722.6821711212397,211.51151406718418L723.9506999924779,211.95062530273572L724.4753092583269,210.42726298049092L727.2103774156421,211.38352666189894L726.6786681748927,212.91417261073366L728.6422057123855,213.6019746568054L725.0701293870807,223.84199674101546L723.2485913503915,223.20414192881435L723.0434809606522,223.79205052554607L721.2574427993968,223.1687633576803L721.6116526639089,222.13446032255888Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M722.107862030156,179.33769565215334L722.1646618302912,179.2024237839505L722.5188716948032,178.21077685896307L722.1504618804902,178.07654552301392L722.8304817099124,176.23372590448707L723.4047908009961,176.44599877251312L724.3262097816914,173.9445083066821L724.4256094330922,173.67500491207466L735.1260606832802,177.62910771695897L734.0066312877461,180.6976980501786L734.6724511682987,180.93910625204444L734.1833417769521,182.28558115521446L733.695021272637,182.10868724808097L733.5672217216343,182.4489478743635L733.2059118822217,183.44059419305995L724.319109806791,180.15244845859706L723.1215806864202,179.71333520719782Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.5525622405112,267.0422160322778L654.69202138111,261.2099888380617L655.7554398644716,261.6064347694628L665.4145614439622,265.1640417096205L663.274313416332,270.99626557715237Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M704.5472571309656,218.61949371919036L708.2960439454764,207.8685546084307L711.3364110291004,208.9319951273501L711.6267211195081,208.10892131738365L713.0088495910168,208.58445196319371L712.7248505894095,209.4200122980401L713.9160686219111,209.83831270271912L710.8331016879529,218.66111559513956L710.153081856668,220.61734351608902L708.5508541604504,220.05752941267565L708.260544070974,220.90765601675957L706.9494153475389,220.4477344150655L707.2539253877476,219.56847244454548Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M716.8428361052647,194.46731709176674L717.1402461696416,193.65256596449763L717.7145552616566,192.10734805231914L717.2467457950115,191.93045439617708L717.9764654505998,189.9388396400027L718.3732751663774,190.07411129726097L718.8055847566575,188.89724778477103L720.9032329339534,189.67037741839886L729.4571250686422,192.83053089119494L729.0532153770328,193.93559574475512L729.9320345092565,194.26961248507723L729.3719253679737,195.78569450695068L728.7479164525867,195.55885452590883L727.6710869064555,198.47135443333536Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M658.8660178119317,250.3103182562627L660.8863551495597,244.7756722876802L670.375077329576,248.28334182826802L671.4526957608759,248.68082903977484L669.418158473447,254.20818810118362L668.4194286530837,253.8325525824912Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M655.7554398644716,261.6064347694628L657.6968885911629,256.2986358143389L657.9098878409714,255.710729975719L666.6475904397666,258.9426506613381L667.569009420462,259.27562372898683L665.4145614439622,265.1640417096205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M650.652924478054,272.2365880231373L652.5525622405112,267.0422160322778L663.274313416332,270.99626557715237L661.3754645409063,276.19167514238507Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.1904635140672,180.95367398578674L655.6773401377723,170.9331454592757L656.0031501026824,170.011214483995L661.1269654147327,171.81137304287404L661.0346657382324,172.08816038630903L660.7656555734575,172.86753521952778L657.321378801018,182.75278915371746Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.0097687849775,255.37775673670694L658.8455067714676,250.3748318706639L658.8660178119317,250.3103182562627L668.4194286530837,253.8325525824912L669.418158473447,254.20818810118362L667.569009420462,259.27562372898683L666.6475904397666,258.9426506613381L657.9098878409714,255.710729975719Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.85353310965,188.57883905433118L721.5690528135747,186.64341312553734L721.9658625293523,186.79949588282034L722.6608711965382,184.8932049125433L732.5393031165004,188.54970361292362L731.7527836598456,190.6974014393054L732.5251031657681,190.99499905155972L733.318722596392,191.28531279275194L732.3554926514626,193.90750087611377L731.6044730702415,193.62447109818459L729.4571250686422,192.83053089119494L720.9032329339534,189.67037741839886L721.250342823565,188.72035404574126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M722.6608711965382,184.8932049125433L723.33379105106,183.0649548363872L722.8872815100476,182.89534481894225L723.5964901270345,180.97448503877968L723.9648999422789,181.10871631931514L724.319109806791,180.15244845859706L733.2059118822217,183.44059419305995L734.9635501438752,184.08573652617633L735.7642695503309,184.38333442248404L734.8428505687043,186.9056321545504L734.0705310637131,186.60803436907008L733.347122495994,186.35309918923303L732.5393031165004,188.54970361292362Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M731.086963779293,225.83984503243119L734.5738404039294,215.84123288840055L735.7571695744991,216.2595329033211L736.3377897553146,214.59361651726067L739.1801464240998,215.5925420699641L738.648437182419,217.13775474764407L739.1801464240998,217.32921542041004L735.657769924961,227.44228543434292L733.680821322836,226.74720094213262L733.489121997729,227.3070145053789L731.7953835101798,226.71182238915935L731.9941828101873,226.15200877701864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M714.8721985910088,219.77450070530176L718.3661751914769,209.77483925921842L719.294694148004,210.09324701596051L719.755403637886,208.77591286972165L722.476271844469,209.73217678256333L721.9453514898196,211.24929596856236L722.6821711212397,211.51151406718418L719.2662942474708,221.31242862530053L718.5436745658517,221.05645417561755L718.1815758403391,222.0845140949823L716.5588371036574,221.5101324589923L716.9201469440013,220.49039682885632Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.1438649604097,219.4415257354267L641.8655220530927,211.87258420791477L647.882356445305,214.04836959624663L645.160699352622,221.61626819847152Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M710.8331016879529,218.66111559513956L713.9160686219111,209.83831270271912L714.8792985668406,207.0673321923241L717.5938556846231,208.01735304715112L717.1331461947411,209.33572788443416L718.3661751914769,209.77483925921842L714.8721985910088,219.77450070530176L713.6604695208371,219.34891707124189L713.2991596804932,220.36969341523945L711.7261207681149,219.81612257426605L711.9880309589207,219.06588833220303Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M735.657769924961,227.44228543434292L739.1801464240998,217.32921542041004L740.703485510312,217.8682188037783L741.1286951256916,216.66326523385942L743.3541428530589,217.449918883387L742.4256238965318,220.13557041576132L739.4207566883415,228.76689985208213L738.5277376072481,228.45577676966786L738.2942273169756,229.13525291113183L736.4939892049879,228.50468240585178L736.7274994952604,227.81792238587514Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M691.916401559487,361.5933281411417m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M822.7776190424338,277.20411881199107m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M647.8902453063056,252.25925345439464m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M670.7900314256549,224.9793135742657m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M655.0911977561191,215.5925420699641m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.7341797472909,276.1375671508722m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M645.1567549211904,292.55412023793906m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M678.4643155429512,209.37110652728006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.4113262817264,214.99734894698486m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M729.8223793394864,219.84109569294378m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M743.8219523187727,225.46108634071425m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M723.9538555368781,217.45720271207392m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M658.983561841771,266.1036492045969m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M709.2300851047039,214.22838432714343m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M723.0963363312185,193.79408085579053m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M661.6618301998824,260.44102934747934m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M656.9640133911744,271.6164268264547m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M663.2143580727279,254.792972442694m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M726.6897125793621,189.19484547479078m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M729.1336817611009,184.2345354766585m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M735.1339495452121,221.58505180571228m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M718.7787626283243,215.64248834131286m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M643.5127162598073,216.74442791519687m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M714.5881995903328,214.25023582717404m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M743.4882534919307,213.2898103473708L751.1988263707608,192.22805195581168L754.2746933298185,193.3549684691243L746.5641204519197,214.41672343667597Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M884.6412792196497,179.61344214202836L880.8711924813688,257.0852849641815L879.0993542680517,286.82804925134405L875.612477645278,327.80322208162397L873.8903392571956,372.1380051067099L872.464033164084,396.2874816409312L858.4912823121995,396.2874816409312L858.4912823121995,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1012.0369200045243,365.78144184174016m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M968.3562958687544,191.207271466963L963.2750804098323,313.56666875630617L959.2848944440484,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M963.9227559091523,179.61344214202836L965.8050381774083,182.1575932111591L967.7606868539006,186.82134746806696L968.3562958687544,191.207271466963"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M976.2648791633546,179.61344214202836L977.2991088582203,185.46758958278224L978.0154174501076,199.1591579131782L974.975050367415,259.9415698214434"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,189.2166970516555L860.857940653339,193.95016345009208L863.4730981225148,214.3386823683977L862.4317684518173,244.1315761450678L861.9000592101365,253.54952525161207L863.9977073865011,261.38688072469085L862.4317684518173,278.63589912559837L858.4912823121995,285.6335130399093"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M875.632988682948,396.2874816409312L886.7365607386455,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1044.6455275276676,179.61344214202836L1043.9923298256472,193.07193866930902"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1043.9923298256472,193.07193866930902L1075.1651646215469,194.43297892296687"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M981.2427505431697,396.2874816409312L987.3976400056854,269.72784835100174"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M980.3536758925766,269.5301458919421L974.8062287382782,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M987.3976400056854,269.72784835100174L990.8348168032244,199.00307543296367L990.2825965238735,183.41978314705193L989.4834548905492,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M974.975050367415,259.9415698214434L973.578721945174,287.7926266854629L967.8253755150363,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,189.42688841745257L884.0732812182978,191.28843444678932"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M884.0732812182978,191.28843444678932L942.1707990858704,195.5161919617094L1002.6199864605442,204.39624328399077L1030.052712189965,215.61439356347546L1054.4663707623258,231.70123724639416L1073.2458047075197,249.21878944477066L1075.1651646215469,251.81494206143543"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M882.9120408585295,365.24244996206835L889.6940947799012,232.05502252466977L960.8729221923277,235.68340165214613L954.0908682700247,368.87075936980546Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M982.9759333347902,179.61344214202836L984.0669628307223,184.78706860728562L984.747771547176,199.00307543296367L981.6293047387153,246.90878509450704L980.3536758925766,269.5301458919421"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M884.8534895842895,423.53761289361864L884.8747895099223,422.89249284379184L885.101988710463,421.63867064286023L885.2999991253018,421.0216443622485L885.5555982263759,420.44103611214086L886.2072181571275,419.334966853261L886.6040278710425,418.8386403257027L887.5254468526691,417.9531604181975L888.588076448068,417.23728468827903L888.8791754236445,410.73196869529784L885.3993987748399,410.568607354071L887.4047472774982,366.9291406329721L952.7229397473857,369.9414588599466L950.7388911712915,413.40401861444116L936.7921735607088,412.7588976211846L935.8423546804115,433.2674726676196L949.7109725642949,433.9125917502679L947.4713248871267,482.91025117458776L885.7110087899491,480.06134174671024L888.0216562179849,429.511213587597L887.0292374873534,428.71105730580166L886.596927896142,428.2428253670223L886.2001181812957,427.74753999430686L885.5484982505441,426.64147189911455L885.101988710463,425.44383823359385L884.9599892096594,424.8132855864242Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1051.7873135190457,185.82866108138114L1053.948861470446,126.81143100978807L1072.0340756354854,127.46282197767869L1075.4996523354203,127.5908109312877L1083.1747253378853,127.87384340260178L1083.0043259374797,132.5438775443472L1102.6136680748314,133.259782679379L1100.7921300362796,183.05142765957862L1080.3962684441358,182.3063922021538L1080.2337579047307,186.87025339715183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1035.6798368431628,240.8216077866964L1036.105046457611,227.92405802942812L1048.5844358960167,228.12904549436644L1049.8529647681862,199.56289123697206L1108.4672030415386,202.1070349845104L1107.6238837838173,231.09147787606344L1093.0247573582456,230.25487960828468L1096.6181336073205,235.3296165582724L1087.1002226416022,243.79131854744628Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M899.6364264758304,220.37697724346071L900.6643450828269,197.26639749342576L952.4326296579093,199.60555377975106L951.3905111020431,222.71508518373594L947.2307146219537,222.53090848447755L946.8694047816098,229.01559019787237L950.9937013853341,229.24242908135056L951.0505011854693,230.34748812764883L901.6701748780906,227.70450292062014L901.719874702394,226.64106528135017L902.5702939331532,226.66916001355276L902.7974931336939,220.52577541442588Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.9714460400864,426.0608641188592L1072.0269756605849,403.2912199012935L1074.6066332543269,403.41816324414685L1074.9892430193722,395.218867264688L1093.9745762394741,396.11163371708244L1092.026027536951,438.05800068285316L1079.90084796492,437.48467745585367L1080.1911580553278,431.1562680238858L1077.7960998127237,431.0428518843837L1078.0083101773635,426.37926194118336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1073.9337133988738,381.4288365552202L1074.3021232131869,372.0381148145534L1076.428171291016,372.11615410400555L1076.6829815050587,365.73878032527864L1074.5427334783599,365.653457287699L1074.9963429933414,354.4001719225198L1077.1223910702392,354.491738258861L1077.3566902475432,348.76571843540296L1075.2164422189817,348.6876788805239L1075.584852034226,339.33333129109815L1092.1254271874204,339.9992696889676L1090.4663996901363,382.0874872542918Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1040.1299434117973,336.95988469570875L1042.0366811482236,295.20436446741223L1058.4068569019437,295.94938778923824L1058.1299578752369,301.9792872951366L1057.981647286564,305.24656456243247L1056.195609123446,305.16124077886343L1055.933698934503,310.87376969261095L1057.7189482096583,310.9445259408094L1057.1738279052079,322.7576877074316L1055.394889718853,322.67236414412037L1055.1250906670466,328.5544850840233L1056.9040288543329,328.63252486661077L1056.4930191887543,337.7173898774199Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1002.9181854119524,385.9353379518725L1004.82413426321,344.1665858756751L1021.1872100420296,344.9178471053019L1020.7691004015505,354.20871503744274L1018.9759622626007,354.1306755444966L1018.7140520736575,359.8421235778369L1020.5071902107447,359.9201630037278L1019.961281019263,371.7197144967504L1018.182342832908,371.64167519984767L1017.9133326672018,377.53103824937716L1019.6922708554193,377.6163611407392L1019.2812611889094,386.68659465154633Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1006.1636628853157,284.0508562955074L1008.0767117114738,242.2814902830869L1024.4326875135303,243.04004635754973L1024.007477899082,252.32376704923809L1022.2293285978958,252.23844261700287L1021.96662952099,257.94997460441664L1023.752667684108,258.03529896587133L1023.213858468458,269.83398335194215L1021.4286091923714,269.7496996736154L1021.1588101414964,275.6381087563932L1022.9448483027518,275.7234329013154L1022.526738663204,284.7948402799666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1074.259523363784,318.4280356699601L1075.0673427442089,304.4245427194983L1098.1343727186322,305.75642616162077L1098.1130727929994,306.14662634022534L1097.3336533131078,319.7463895091787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M939.9311514087021,352.17448530206457L940.0234510842711,348.80838005663827L944.7220567790791,348.9363649240695L944.6226571286097,352.3097537960857Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M926.0309780789539,209.99127329327166m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1049.2494668904692,316.80896778870374m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M991.0793714979663,396.2874816409312L999.8012963756919,179.61344214202836"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M1291.839046932757,268.7185252076015L1268.0730638615787,267.51670209737495L1263.6229572920129,257.46092030918226L1253.8999359365553,263.704164031893L1246.7068723486736,259.15492099383846L1239.9248184263706,253.34349799714983L1233.6886736955494,247.41240773024037L1227.551928613335,240.43140393076465L1232.6323551880196,233.76984031125903L1224.483161630109,228.15818076813594L1217.7153076585382,221.4893215293996L1207.2341667460278,207.95387958968058L1197.8227554056793,194.1978144957684L1188.9580421419814,179.61344214202836L1291.839046932757,179.61344214202836Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1158.7949815718457,345.293477688916m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer retaining_wall"
        d="M1129.9264831151813,179.61344214202836L1127.211137109436,232.0623063389212"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1123.7739603109658,233.59294772008434L1125.1986886328086,214.2252626856789L1126.686527843587,186.8286313302815L1127.0912264203653,179.61344214202836"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1134.0925906831399,234.3296533068642L1137.0477580660954,232.57945713307709L1141.342454072088,228.88760311715305L1143.298102747649,223.81390199344605L1144.616331444122,217.35002636210993"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M1129.2732854122296,241.6862994520925L1134.8294103126973,241.7424887982197L1145.572461414151,234.59915434382856L1151.653195581399,227.45581252779812"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer retaining_wall"
        d="M1152.1359938830137,179.61344214202836L1160.3837982052937,199.2652939944528L1159.533378975466,199.68359501240775L1158.0526397377253,218.93790106941015L1151.653195581399,227.45581252779812"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1287.8023166870698,276.7015388789587L1272.6083701308817,279.8835039678961"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1188.1210339758545,359.8712582979351L1107.1063744928688,356.44064416224137"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1159.230446706526,179.61344214202836L1164.8843934861943,192.09382088994607L1207.709076186642,296.437398834154L1215.9860692955554,321.3685783003457L1230.1946970960125,353.0963920489885L1233.9150840081275,361.52881556237116L1247.281181438826,393.22106778854504L1248.4439995717257,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1291.839046932757,276.9367005103268L1287.8023166870698,276.7015388789587"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,194.43297892296687L1119.117954466492,196.35279442137107"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1128.3281998476014,179.61344214202836L1125.52449859865,233.54404211975634"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1125.52449859865,233.54404211975634L1128.267455616966,233.64289386430755L1131.3354337140918,231.5305878724903L1133.8795914314687,228.3558844095096L1135.5733299190179,223.5943467579782L1137.3735680310056,214.1753164017573L1138.429097651504,208.25876029906794L1140.0171253997833,194.7087248126045L1140.9093555938452,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1193.96746896673,194.26961248507723L1185.852986398153,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1214.530574414879,179.61344214202836L1221.3291949452832,181.40631434088573L1228.01894919388,182.37819031439722L1234.468093175441,182.73197810770944L1239.2802984705195,181.79652152210474L1243.716993975453,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1177.162616965361,179.61344214202836L1221.8964040623978,287.5439384491183L1257.4483456769958,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1158.8012926615775,179.61344214202836L1168.2363705839962,210.88718524714932L1170.9146389421076,218.71106184693053L1172.5941774789244,225.20303095364943L1173.6007961593568,232.79901209054515L1174.0473057003692,236.94558184081689L1173.5013965098187,242.19616572745144L1172.1050680875778,246.83802819252014L1169.4622996067628,251.23223855206743L1166.2302331971005,254.5765398107469L1162.580846033059,257.99263678397983L1157.9177402136847,260.8197861309163L1152.29771553725,262.393083316274L1146.359769755043,263.0174074959941L1140.4352350402623,262.36498872563243L1135.3398196287453,261.0185293769464L1130.6270139841363,258.66586678428575L1126.5595171796158,254.4849721537903L1124.5604797666892,250.23956138966605L1122.5977311152965,244.86099681211635"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1272.6083701308817,279.8835039678961L1270.1636120639741,363.2019803132862"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1267.151644879952,396.2874816409312L1270.1636120639741,363.2019803132862"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1108.8711127312854,327.7824114714749L1106.2078332100064,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1254.646222201176,396.2874816409312L1208.7433058815077,289.6343761095777L1162.1185587700456,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1118.6501449998468,205.4024541452527L1113.2431195750833,253.54224146110937"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1272.6083701308817,279.8835039678961L1231.4064261671156,277.37476706225425L1220.677575015463,277.0137003338896"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1113.2431195750833,253.54224146110937L1118.9625439019874,248.23443633457646L1122.5977311152965,244.86099681211635"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1253.170216280967,361.84097319701687L1249.7898392826319,345.13011480495334L1241.4836573880166,323.83463750593364L1234.546192901209,306.83441913546994L1220.677575015463,277.0137003338896L1180.095695537515,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1264.7581644114107,396.2874816409312L1253.170216280967,361.84097319701687"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1175.102835321799,273.5050047910772L1191.0407014833763,290.25869783665985L1190.4245814280584,305.0270119002089L1188.1210339758545,359.8712582979351"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1215.9860692955554,321.3685783003457L1217.1054986920208,334.67800388112664L1217.5449082572013,342.5152676268481L1215.0859502386302,348.09978087665513L1212.2940822830424,352.13182370131835L1210.7352433213964,354.36479402007535L1207.8218869017437,356.49058942031115L1205.2501181699336,357.9431638759561L1200.1050029341131,359.17618708265945L1188.1210339758545,359.8712582979351"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1190.4245814280584,305.0270119002089L1197.6247449908406,312.3263537082821L1200.3811130728573,316.4510247083381L1204.0802000630647,320.47580221900716L1206.3056477895007,325.02604554221034L1207.1489670462906,330.31194073567167L1207.3619662970304,335.71229012683034L1207.9922863021493,338.24910019896924L1210.1183343790472,339.411370952148L1213.3922117529437,340.8930837861262"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1213.3922117529437,340.8930837861262L1217.5449082572013,342.5152676268481L1223.0229334328324,346.39851823356L1230.1946970960125,353.0963920489885"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1229.2590781636536,320.6880706693046L1170.0334531534463,179.61344214202836"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1111.287470898591,270.90469814045355L1175.102835321799,273.5050047910772"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1113.2431195750833,253.54224146110937L1111.287470898591,270.90469814045355L1107.1063744928688,356.44064416224137"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1253.170216280967,361.84097319701687L1233.9150840081275,361.52881556237116L1188.1210339758545,359.8712582979351"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1107.1063744928688,356.44064416224137L1105.7494903774932,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,251.81494206143543L1086.880912302062,267.6592560191639L1100.4024202963337,293.92242470709607L1108.8711127312854,327.7824114714749"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1125.52449859865,233.54404211975634L1125.7587977740914,240.16918692644686L1127.664746625349,248.53203147370368L1124.5604797666892,250.23956138966605L1120.5781826637685,256.0437032012269L1120.8329928778112,265.7030413732864L1111.287470898591,270.90469814045355"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M1117.0345062380657,378.3603350818157L1117.573315454647,364.6899312119931L1144.1201220778748,365.73878032527864L1143.5813128622249,379.4154252647422Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1266.1158374128863,263.0944074764848L1256.4298937041312,269.7424158998765L1231.4064261671156,277.37476706225425"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1253.170216280967,361.84097319701687L1229.2590781636536,320.6880706693046"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1270.1636120639741,363.2019803132862L1291.839046932757,364.32574745547026"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1270.1636120639741,363.2019803132862L1253.170216280967,361.84097319701687"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1287.8023166870698,276.7015388789587L1270.8444207804278,274.07209834922105L1256.4298937041312,269.7424158998765L1250.724669327028,267.7300127078779L1243.1000850349665,263.54808300500736L1237.047750769183,258.3963666842319L1231.0025164755061,252.92520021786913L1224.9083712464198,245.32820059312508L1219.585756634362,237.39821854047477L1193.96746896673,194.26961248507723"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1122.5977311152965,244.86099681211635L1121.5493014696985,238.57507381867617L1121.2227026186883,236.2369712255895L1119.9612737214193,227.12283793184906L1118.6501449998468,205.4024541452527"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1291.839046932757,223.3071560068056L1291.4595927111804,223.8201452731155L1283.0973999034613,231.54515550518408L1272.9420689567924,237.15056903893128L1262.3615283947438,240.53129611955956L1250.2994597125798,240.95583790773526L1238.8692888058722,238.95071016438305L1231.2454933989793,235.58975265547633"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1231.2454933989793,235.58975265547633L1229.0326678492129,234.6137219676748L1222.3642135281116,229.7450124551542L1216.6589891510084,224.77016383130103L1193.96746896673,194.26961248507723"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1108.8711127312854,327.7824114714749L1119.2394429277629,179.61344214202836"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1119.990462508984,179.61344214202836L1119.117954466492,196.35279442137107L1118.6501449998468,205.4024541452527"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1051.7873135190457,185.82866108138114L1053.948861470446,126.81143100978807L1072.0340756354854,127.46282197767869L1075.4996523354203,127.5908109312877L1083.1747253378853,127.87384340260178L1083.0043259374797,132.5438775443472L1102.6136680748314,133.259782679379L1100.7921300362796,183.05142765957862L1080.3962684441358,182.3063922021538L1080.2337579047307,186.87025339715183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1035.6798368431628,240.8216077866964L1036.105046457611,227.92405802942812L1048.5844358960167,228.12904549436644L1049.8529647681862,199.56289123697206L1108.4672030415386,202.1070349845104L1107.6238837838173,231.09147787606344L1093.0247573582456,230.25487960828468L1096.6181336073205,235.3296165582724L1087.1002226416022,243.79131854744628Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1160.4476979812607,391.3502112990245L1161.5884273014963,369.4170346413739L1182.3952985592186,370.50750400312245L1182.544398035854,367.6304542175494L1227.6718393024057,369.9976471657865L1238.1600801898167,397.997056201566L1237.6007599337026,398.8617282612249L1188.3127333009616,396.2895626826212L1188.4894437901676,392.81630522059277Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1275.0965169342235,398.45072290394455L1276.6127560464665,372.3367451648228L1333.2208569310606,375.64561019837856L1333.0086465673521,379.3592370329425L1331.6407180447131,402.8157026125118L1328.1254415204749,402.603436680045L1327.9842309057713,405.06218335125595L1322.4281060043722,404.73650091933087L1322.570105505176,402.2850377657451L1302.8124527791515,401.12902067089453L1302.713053128682,402.70228601107374L1276.5985560957342,401.1716819726862Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1121.2227026186883,306.5930153164081L1122.4841315140948,279.9469767687842L1172.0277572488412,282.2996321390383L1170.7024285765365,310.29211168084294L1163.785475130193,309.9591410611756L1145.1196407843381,309.07364724529907L1145.1827516732737,307.7407239070162Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.9714460400864,426.0608641188592L1072.0269756605849,403.2912199012935L1074.6066332543269,403.41816324414685L1074.9892430193722,395.218867264688L1093.9745762394741,396.11163371708244L1092.026027536951,438.05800068285316L1079.90084796492,437.48467745585367L1080.1911580553278,431.1562680238858L1077.7960998127237,431.0428518843837L1078.0083101773635,426.37926194118336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1278.8737036483362,324.33825455233455L1279.6531231300905,302.83044438948855L1287.5617064228281,302.85125507460907L1288.0863156886771,288.49394827662036L1293.9043507790193,288.7062177043408L1292.9900317732245,313.6509519019164L1301.5155240083113,313.9631116921082L1335.9567139754072,315.7705165948719L1335.5599042596295,322.4455283153802L1318.6083194408566,321.4039563704282L1313.7259032810107,321.099080637563L1313.3716934155673,327.9593016617L1301.026414617896,327.27255149232224L1301.1045143427327,325.1457066005096Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1073.9337133988738,381.4288365552202L1074.3021232131869,372.0381148145534L1076.428171291016,372.11615410400555L1076.6829815050587,365.73878032527864L1074.5427334783599,365.653457287699L1074.9963429933414,354.4001719225198L1077.1223910702392,354.491738258861L1077.3566902475432,348.76571843540296L1075.2164422189817,348.6876788805239L1075.584852034226,339.33333129109815L1092.1254271874204,339.9992696889676L1090.4663996901363,382.0874872542918Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1161.922126127407,349.4670338546857L1162.3047358933836,341.44560443097726L1163.785475130193,309.9591410611756L1170.7024285765365,310.29211168084294L1170.6740286760032,310.97990406444296L1177.8954921653494,311.3201583651826L1177.3992828000337,321.9637622893788L1176.0668541518971,350.13401180692017Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1146.0189709551632,394.56021781452L1146.8125903857872,379.25310370884836L1147.2519999509677,366.51813338231295L1161.6878269519657,367.53160438360646L1161.5884273014963,369.4170346413739L1160.4476979812607,391.3502112990245L1160.2425875905901,395.3041899353266Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1074.259523363784,318.4280356699601L1075.0673427442089,304.4245427194983L1098.1343727186322,305.75642616162077L1098.1130727929994,306.14662634022534L1097.3336533131078,319.7463895091787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1118.2044243449345,393.36257860576734L1118.7637446010485,379.8482827274129L1133.9718911070377,380.47155580762774L1133.8156916573644,384.36206880398095L1133.6957809682935,387.26096260081977L1131.5271330401301,387.16211304673925L1131.4490333143622,389.0891588185914L1133.6176812425256,389.18176521733403L1133.4188819406554,393.99313411302865Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1176.0668541518971,350.13401180692017L1177.3992828000337,321.9637622893788L1184.4645468359813,322.31129977153614L1183.8547378713265,335.24405190581456L1182.28879893478,335.15976902330294L1182.1609993837774,337.97960319230333L1183.720627230592,338.05139969242737L1183.1250182157382,350.4742641877383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1277.8386850673705,334.59996417025104L1278.1999949077144,326.6700842422433L1295.1515797264874,327.4348742640577L1294.797369861044,335.35746961273253Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1277.5767748765647,340.72243709722534L1277.8386850673705,334.59996417025104L1294.797369861044,335.35746961273253L1299.1480767801404,335.5562107213773L1298.8790666144341,341.68596650799736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1291.1258938852698,356.3345104861073L1291.45249273628,347.3131420542486L1298.0996471345425,347.5545444553718L1297.7809371436015,356.582155729644Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1155.288382794708,349.1413488104008L1155.6638925857842,341.11991900904104L1162.3047358933836,341.44560443097726L1161.922126127407,349.4670338546857Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1146.6248354911804,294.44685463793576m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1286.322366337292,308.25162585871294m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1083.050870217383,360.07312028249726m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1153.6309330686927,385.30166014423594m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1086.1874814070761,312.2868134584278m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1126.1382519947365,385.7615708075464m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1179.4645866453648,336.6123479488306m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1286.4967101681978,331.017420142889m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1288.3608480561525,338.13984465645626m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M1291.839046932757,236.6115671545267L1287.6469061234966,243.17427643574774L1279.9221332939342,251.7493879199028L1271.2483304701746,259.57321839686483L1266.1158374128863,263.0944074764848"
        style={{ display: 'none' }}
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M-8.205035817809403,607.2050110218115L4.247531493194401,612.9620320000686L-8.205035817809403,612.9620320000686ZM73.31056634709239,612.9620320000686L116.33089280407876,523.2547617619857L126.26691341027617,528.2574896826409L121.06499837432057,546.2997438372113L130.32021026406437,543.1678449548781L130.07959999982268,527.8610590039752L130.3628101143986,518.81806326285L130.24921051319689,507.09679993381724L132.12044837605208,497.1183630693704L135.5647251503542,492.2071771910414L144.16042824927717,478.9906592685729L143.1893094414845,473.81100932881236L132.26875896565616,488.9264614651911L128.64777170214802,490.4997068787925L123.92786608170718,490.69844354270026L120.29977884329855,486.54578254232183L119.4564595874399,482.3639848474413L98.69928815495223,470.90486816409975L102.95848428457975,462.7909738509916L110.42765801306814,466.97174284327775L118.19503069203347,464.68990482669324L122.46132679563016,453.6417610379867L137.23006373643875,443.7485693031922L146.91758521739393,444.72665156936273L148.85903394315392,453.93206377653405L165.15110997203737,454.54908712767065L174.71083190105855,450.05615699710324L181.90389548894018,442.06918091420084L182.54210435505956,434.26636670622975L180.86256581824273,428.5549799972214L174.83863145206124,419.9728036150336L175.4839402930811,411.93688853038475L141.2857272485271,396.2874816409312L208.46884649340063,396.2874816409312L208.46884649340063,520.1072449428029L161.30292350705713,505.57350247213617L150.79338269587606,536.166329018306L205.93494429532439,559.6368309338577L186.65693432558328,612.9620320000686Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer beach"
        d="M143.1893094414845,473.81100932881236L144.2456279490143,467.843689864967L146.99489605706185,458.75171181885526L148.85903394315392,453.93206377653405L165.15110997203737,454.54908712767065L174.71083190105855,450.05615699710324L181.90389548894018,442.06918091420084L178.61581816524267,450.9697266295552L178.19770852476358,458.5883516087197L155.76178744249046,488.4166133380495L153.862149679102,486.9422155828215L147.51240534707904,494.3402138571255L144.97534760460258,493.49740432808176L146.03166611120105,486.5093648075126L147.09429570659995,482.0663997461088L144.16042824927717,478.9906592685729Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer picnic_site"
        d="M73.31056634709239,612.9620320000686L116.33089280407876,523.2547617619857L126.02551425993443,528.1867356528528L119.78226955235004,547.2289082496427L112.60340591426939,550.410749156028L108.16039932053536,559.7221515858546L87.36062803678215,612.9620320000686Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M141.27862727455795,396.2874816409312L175.4768403172493,411.9379290472716L174.82995370402932,419.97072258219123L180.85704361554235,428.5549799972214L182.53737103845924,434.2674072207883L181.89837328530848,442.07126193959266L174.70373192522675,450.0519949477166L165.14243222400546,454.54700610321015L148.85193396918476,453.9331042910926L146.9112741285935,444.72457054490224L137.22375264856964,443.7464882750064L122.45580459292978,453.6417610379867L118.18793071620166,464.6919858478941L110.41740249283612,466.97070233430713L102.95453985407948,462.7878523217514L98.6945548383519,470.90382765606046L119.45014849770814,482.3598228180781L120.29425663966686,486.5426610200666L123.92313276510686,490.694281517528L128.64067172724754,490.49658535886556L132.26165899075568,488.92542095901445L143.1798428092152,473.8068472938612L144.15017272904515,478.98857825109735L135.55920294765383,492.20301516680047L132.1117706289515,497.1142010493204L130.24211053922772,507.0926379188895L130.3525545950979,518.8191037634388L130.0685555934906,527.8610590039752L130.3131102900952,543.1668044566177L121.05947617162019,546.2987033394165L126.25823566224426,528.2564491825178L116.32615948747844,523.25164025696L91.57880208827555,575.328529281076L76.00619019940495,607.9583247206174L73.55827658716589,612.9620320000686L4.247531493194401,612.9620320000686L-8.205035817809403,607.2060515093617L-8.205035817809403,396.2874816409312Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M141.2857272485271,396.2874816409312L175.4839402930811,411.93688853038475L174.83863145206124,419.9728036150336L180.86256581824273,428.5549799972214L182.54210435505956,434.26636670622975L181.90389548894018,442.06918091420084L174.71083190105855,450.05615699710324L165.15110997203737,454.54908712767065L148.85903394315392,453.93206377653405L146.91758521739393,444.72665156936273L137.23006373643875,443.7485693031922L122.46132679563016,453.6417610379867L118.19503069203347,464.68990482669324L110.42765801306814,466.97174284327775L102.95848428457975,462.7909738509916L98.69928815495223,470.90486816409975L119.4564595874399,482.3639848474413L120.29977884329855,486.54578254232183L123.92786608170718,490.69844354270026L128.64777170214802,490.4997068787925L132.26875896565616,488.9264614651911L143.1893094414845,473.81100932881236L144.16042824927717,478.9906592685729L135.5647251503542,492.2071771910414L132.12044837605208,497.1183630693704L130.24921051319689,507.09679993381724L130.3628101143986,518.81806326285L130.07959999982268,527.8610590039752L130.32021026406437,543.1678449548781L121.06499837432057,546.2997438372113L126.26691341027617,528.2574896826409L116.33089280407876,523.2547617619857L91.58432429283857,575.3274887879379L76.01486794557422,607.9614461874589L73.56774321943521,612.9620320000686L4.247531493194401,612.9620320000686L-8.205035817809403,607.2050110218115L-8.205035817809403,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pier"
        d="M173.09598202537745,396.2874816409312L167.63136791344732,408.4501121682115L141.09008349385113,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M-8.205035817809403,450.8844046420418L42.34599748440087,475.05753853544593L130.27603264246136,509.87910604616627M156.28560782130808,520.1790395583957L166.91584820859134,524.3878674660809L208.46884649340063,539.9558262624778"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M130.27603264246136,509.87910604616627L156.28560782130808,520.1790395583957"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M199.88339891377836,438.90185746829957L203.36238667648286,435.57117182714865L208.40100228693336,430.6807526429184L208.46884649340063,430.6339294645004"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M92.14127788878977,612.9620320000686L92.57674302347004,611.7665115012787L106.02725126873702,574.6823828634806L115.52307342272252,552.6998424315825"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M160.79172530490905,507.06246331334114L159.2123753046617,503.78695713961497"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M162.4586416631937,510.5190154807642L160.79172530490905,507.06246331334114"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M195.20293760020286,396.2874816409312L192.37083644978702,399.11665562260896L185.8088817531243,405.8914768900722"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M-8.205035817809403,612.7258412833326L-7.689104299061,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M187.69905288238078,396.2874816409312L186.8652002606541,398.9116732147522L185.8088817531243,405.8914768900722"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M159.2123753046617,503.78695713961497L150.5172725552693,500.3501712004654"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M199.88339891377836,438.90185746829957L198.2953711664304,445.2583536822349L194.27757418807596,454.14536865148693L190.04677795805037,461.96897068992257L184.32814251817763,471.4865126973018L177.34728929493576,479.3236217657104L170.15422570705414,486.9422155828215L162.95406214427203,496.03415665682405L160.21189401112497,501.3282454824075L159.2123753046617,503.78695713961497L155.5700881164521,512.6738970731385L150.08496296592057,528.1086981203407L145.81866686046124,537.3004731107503L140.52524103503674,544.4861560515128L131.43253968469799,549.9924693047069L115.52307342272252,552.6998424315825"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M185.8088817531243,405.8914768900722L186.65930098481476,412.4613095293753L190.89009721484035,424.51569801196456L193.64646529685706,432.2186337709427L199.88339891377836,438.90185746829957"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M115.52307342272252,552.6998424315825L132.27585894148797,545.1239812988788L135.2452262742445,537.3004731107503L141.16976098995656,522.0571447871625L146.03166611120105,508.72622840385884L149.83725272584707,501.3282454824075L150.5172725552693,500.3501712004654L155.13067855127156,493.70238393871114L164.0032806750387,483.9871760904789L179.2966268826276,463.8533347523771L189.71386801823974,445.68392344377935L199.88339891377836,438.90185746829957"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,526.7581283878535L162.4586416631937,510.5190154807642L153.99704920500517,534.2101901457645L208.46884649340063,553.5499282414094"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank_boundary"
        d="M102.99398415908217,462.7909738509916L98.74188800528646,470.94024547189474L119.47065953724086,482.3681468772702M135.5923361638561,492.2009341563098L132.1378038711846,497.1610237779096L130.27761041466147,507.0822328822687"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M208.46884649340063,574.3629513625056L199.96070975251496,599.5001887278631L195.0988046331331,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M208.46884649340063,588.8455655346625L199.54338899999857,612.9620320000686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M205.63437868654728,612.9620320000686L208.46884649340063,605.223920462653"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M153.45114001445472,602.9442089344375L174.10891179554164,545.1166978124529L207.77778225764632,557.2353663728572L187.12001047562808,615.0690193250775Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M161.07651319168508,529.2282765265554L165.37120919674635,516.8972965679131L187.673019641079,524.7208277857862L183.37122366111726,537.0590773168951Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M183.37122366111726,537.0590773168951L187.673019641079,524.7208277857862L199.98200967814773,529.079484982416L196.08491227496415,541.7714962284081L190.7409977382049,539.731078542769Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M265.1432138122618,396.2874816409312L218.63443295937032,523.2401947453618L208.46884649340063,520.1072449428029L208.46884649340063,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M380.225131242536,438.66357979457825m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M255.74758019391447,514.0629681469873L266.264220979996,485.28364779800177L291.6766093708575,494.57432759786025L295.999705276452,500.1306247226894L298.67876252066344,505.68691738834605L299.5078818257898,511.4554682117887L293.51234735827893,527.8610590039752Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M366.25711370725185,517.8191814078018L425.1435176897794,539.2514086165465"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M289.10484064090997,568.0284239179455L273.0415415856987,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M273.5921840937808,396.2874816409312L245.01084018312395,474.7464265078306L232.85726070962846,508.3506066771224L222.8581292135641,531.8357697734609L214.75784659478813,555.7817931827158L208.46884649340063,574.3629513625056"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M414.1306675383821,612.9620320000686L409.93221563939005,611.4054621886462L289.10484064090997,568.0284239179455"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M289.10484064090997,568.0284239179455L237.47776667866856,548.6595922922716"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M210.6690498655662,599.2202969803475L211.62596872262657,596.6086671203375L286.148095484823,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M208.46884649340063,605.223920462653L210.6690498655662,599.2202969803475"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M208.46884649340063,430.6339294645004L213.9003273891285,426.9109654589556L218.61313303373754,416.6702028415166L224.48402349371463,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M296.1985045783222,493.1644425080158L261.7076147859916,481.3432470834814"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M409.37526204343885,612.9620320000686L409.93221563939005,611.4054621886462L425.1435176897794,568.9960837080143"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M225.97501824982464,546.5140863661654L236.79222464561462,550.5657832240686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M208.46884649340063,539.9558262624778L225.97501824982464,546.5140863661654M236.79222464561462,550.5657832240686L290.17457021120936,570.5651489752345"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M410.57200227770954,396.2874816409312L366.25711370725185,517.8191814078018"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M290.17457021120936,570.5651489752345L406.2394397398457,612.9620320000686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M218.77643245924264,600.6124721788801L218.3228229433298,610.5907600671053L220.51987077202648,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M313.8017093250528,499.0953225046396L366.25711370725185,517.8191814078018"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M313.8017093250528,499.0953225046396L296.1985045783222,493.1644425080158"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M296.1985045783222,493.1644425080158L332.9850529609248,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M279.73760692216456,396.2874816409312L208.46884649340063,588.8455655346625"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M289.10484064090997,568.0284239179455L313.8017093250528,499.0953225046396"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M222.8581292135641,531.8357697734609L208.46884649340063,526.7581283878535M208.46884649340063,553.5499282414094L214.75784659478813,555.7817931827158"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.0671151643619,427.64036689233035L411.2007445106283,424.5583591698669L410.51362470537424,424.30967583926395L412.6467727581039,418.5483361147344L415.310841165483,419.5337055558339L417.1039793025702,414.6796931712888L413.3906923625618,413.3114125393331L414.49592180829495,410.32824766775593L415.14833062607795,410.568607354071L416.9769686376676,405.5938885062933L416.1754603460431,405.3035837407224L417.2743787029758,402.2912808810361L421.1367651168257,403.71575172431767L422.88651451840997,398.97514492599294L420.24374603573233,397.997056201566L423.7298337733373,388.5501687480137L429.32855852507055,390.60623875120655L436.29521179851145,393.17840644018725L443.9268960664049,395.99821700854227L447.8531822543591,397.44454006291926L441.1421280829236,415.65673902537674L442.57395638059825,416.1811597463675L437.0817312542349,431.09175609145314L435.86290220730007,430.6453751302324L433.7510540802032,436.3786109178327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M359.1492498200387,582.8960334653966L359.21314959507436,582.704582891427L361.9979175776243,574.7885131989606L367.9295522691682,557.9293772303499L397.8283359911293,568.5382661921903L396.2410971308127,573.0592128606513L394.4124591173604,578.2543960334733L391.7128908354789,585.9290676796809L389.04803354199976,593.4976007812656Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M300.51371162198484,560.5368596836925L302.0449395691976,556.2781099048443L302.9876584755257,555.6829460314475L303.6179784806445,555.9170577004552L304.6600970365107,553.0047079790384L305.09240662679076,553.1597419893369L305.34011686686426,552.4584471769631L304.07868797145784,552.0047905514948L303.7315780799836,551.1827979730442L304.1354877706617,550.0632231119089L304.84390750154853,549.8363947244361L306.11243637278676,550.2973349709064L307.40226516872644,546.7253073956817L306.23313594795763,546.2997438372113L305.6659268317744,545.5068845194764L306.09823642205447,544.3155143768527L307.0764552038163,544.0751593280584L308.2029845751822,544.4788725660183L308.4088838510215,543.9190846169367L307.99077421054244,543.77029338805L309.1102036051452,540.6383933625184L308.1958845993504,540.3043933128938L308.07518502511084,539.7165115601383L309.1102036051452,536.8114385246299L323.9925401471555,542.1897765756585L321.6889926949516,548.6106889122166L322.37611250020564,548.8583272867836L322.9291216665879,550.1485438765958L322.69561137631536,550.7936520841904L330.7951051099226,553.7195291914977L330.07958540320396,555.7037559580058L334.331681557931,557.2488928223029L332.5882432460785,562.1038458729163L332.8998532611877,562.2172598647885L329.44216542318463,571.8335111541674L301.0951206870377,561.5721527221613Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M366.8101228727028,425.0255508390255L376.8305542943999,397.6432793941349L384.3707277709618,400.4277104786597L384.6894377619028,400.54841075418517L381.7058704793453,408.69047191925347L388.6796237267554,411.2709570401348L391.6702909851447,403.113291118294L397.6650365656242,405.331677749753L399.7697847187519,406.1047832434997L389.7422533221543,433.4870212660171L388.16921441070735,432.9064140561968L381.8123701037839,430.5538098020479L384.9876367133111,421.8790299366228L377.8371729757637,419.2434013742022L374.654806391336,427.92442763317376Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M330.766705208458,618.8043681220151L332.90695323608816,612.9932466335595L336.41512978542596,614.2969776261598L336.464829611592,614.1835644831881L338.8669878281653,607.6284898659214L338.30766757391393,606.5016406988725L335.65701022930443,605.5162978349254L338.6192775880918,597.4733144054189L349.7946382788941,601.6113421027549L346.4213612563908,610.7676430400461L346.97437042184174,611.8799246801063L346.15945106651634,614.0982445045374L348.5190094327554,614.9701730227098L349.29132893960923,612.851740301121L350.5882577104494,612.1140344510786L353.8913238700479,603.1210921024904L365.17318418622017,607.3028169493191L364.9459849856794,607.9260695758276L362.2393167298287,615.2958455784246L359.1847496954724,614.1627547331154L357.88782092370093,614.715253598988L355.4998626559973,621.1922850282863L359.5247596092522,622.6801805500872L357.3277117833495,628.6473667277023L346.08845131564885,624.4802215606906L347.08797002304345,621.7447833335027L345.4723312612623,621.1423416766338L343.3809941718355,620.3630172461271L342.3751643775031,623.0984560186043Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M311.3356513334438,485.46053396863863L321.5682931197807,457.4895720137283L334.0555714191869,462.10319652967155L333.3463628012687,464.02397840702906L336.68413995113224,465.2569827446714L333.7644724426791,473.2147978665307L327.7768268371001,471.01100008608773L327.1173180444166,472.8183640409261L329.98018575273454,473.8817639136687L327.93933737743646,479.4588877763599L327.15991789568216,479.1675455975346L326.28819874022156,481.5638346658088L329.0595556581393,482.5762483407743L329.50527631212026,481.3432470834814L330.7532941447571,481.7969083311036L327.26641752105206,491.3289901963435Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M342.8358738683164,393.4052399522625L350.0573373558,373.6478050830774L351.587776417844,374.2003231192939L358.6814403543249,376.8005910203792L357.2575009185821,380.6848629429005L364.60597507096827,383.3631675746292L366.01650344207883,379.5080317906104L373.5566769205034,382.25084926374257L374.0946972509846,382.44854850973934L366.8740226486698,402.2132419287227L358.7595400791615,399.2446395615116L361.6437077121809,391.35645442735404L354.37254439946264,388.70624695997685L351.5025767162442,396.57258418528363L344.85542231984437,394.1492122001946Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M389.04803354199976,593.4976007812656L391.7128908354789,585.9290676796809L396.3546967301518,587.5876113828272L399.0613649878651,579.9056581254117L394.4124591173604,578.2543960334733L396.2410971308127,573.0592128606513L399.89758426882327,574.3629513625056L400.82610322441906,571.7200973173603L414.6024214345962,576.6104170009494L406.48083889018744,599.6843554112129Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M339.0728871030733,575.5615997938439L342.04225443676114,567.1283961432055L342.3680644016713,566.2283682520501L346.81107099633664,567.8078390867449L347.43507991265506,566.0369172170758L346.4852610314265,565.7039588824846L347.17238083668053,563.7613547826186L346.5917606567964,562.5710282721557L346.237550791353,562.4503308176063L348.3990987436846,556.2999603250064L364.8394853612408,562.1246557794511L362.5367267932743,568.6589635401033L360.821688381955,568.0565172694623L358.8447397807613,573.6616586940363L361.9979175776243,574.7885131989606L359.21314959507436,582.704582891427Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M351.4528768910095,547.3485654713586L353.77062429487705,540.942218942102L355.7830727705732,540.4604681045748L356.2792821377516,539.0859693051316L356.825191328302,539.2847045767121L357.56911093369126,537.2359621678479L353.6712246434763,535.8115187636577L356.94510201830417,526.7477233801037L376.95835384353995,534.0333052198403L374.17279697488993,541.7434027707204L370.9841193035245,540.5738824503496L368.94327092543244,546.2289899885654L370.10530017036945,546.6399865872227L367.70314195379615,553.2731561297551Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M390.34496231377125,517.1314095458947L391.31608111970127,514.4739666488022L393.46264023706317,508.52853276161477L396.0635977545753,509.4774717995897L397.2398269511759,506.2394249001518L396.67340672016144,506.0334051558748L399.60727417934686,497.9268354959786L411.91705310251564,502.4124510702677L411.74665370211005,502.87963749235496L417.0542794773355,504.8149751275778L415.5238404162228,509.0591894760728L411.01693404559046,507.40895101008937L410.08131511416286,509.9737918348983L409.5922057237476,509.7969062924385L407.87716731242836,514.5655308677815L412.8660830985755,516.3874504980631L410.93173434585333,521.7304273499176L410.0032153893262,524.3035868830048Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M248.73832707107067,583.8595292116515L254.51455119810998,568.0138569972478L277.184771457687,576.3409292618744L271.41643619164824,592.186582440976L264.39298311807215,589.6072051567025L265.86031129024923,585.5815434143879L257.1999195292592,582.392435202375L255.71918029431254,586.4316251911223Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M209.71213100850582,493.37670567119494L216.09737521689385,475.5538610354997L225.40938690677285,470.72798162233084L231.67393153812736,472.98796696728095L226.52171632740647,487.39587646350265L222.70192976295948,498.0756277097389Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M239.568314881064,614.0274913511239L240.52523373812437,611.3846524278633L242.80748126562685,609.9664671905339L245.67744894791394,602.1222223951481L265.16530262399465,609.2932713069022L259.8647768236697,623.8070270875469L240.37613426242024,616.6359931877814Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.5678045284003,605.6796545796096L431.75201666820794,579.7069240184501L442.0564470887184,583.3850648002699L438.0875610494986,594.6098851952702L437.16693095397204,594.2769282325171L435.4873924171552,595.9281865092926L438.789669691585,597.1049809167162L434.2890744097531,609.8540944666602Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M309.7973234113306,614.1908478951082L311.9517713887617,608.2090824386105L313.42619953583926,607.5858298353851L316.04056811798364,600.3357019457035L315.5096477633342,599.2307018809952L317.79110640473664,592.9024401069619L318.046705506742,592.590292877052L318.67702551186085,592.1158290631138L319.42094511631876,591.8609087998047L319.81854371819645,591.8317750543356L320.5979631980881,591.9670388698578L320.9592730393633,592.1366388807073L321.596693020314,592.6256695631891L321.8380921706557,592.9378167912364L321.9722028095275,593.4268474183045L331.2416146490723,596.7855504490435L328.7116568814963,603.8088554325514L327.1741178454831,604.3467882769182L322.1000023595989,618.4287523603998L320.9308731397614,619.172700454481L317.64279581513256,617.9886263851076L317.8053063545376,617.5214477186091L313.8656091010198,616.0970208095387L313.6668098010123,616.6568029304035L310.4284323025495,615.4800118417479Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M310.17283320147544,532.921011085622L317.5788960400969,512.4116903669201L328.69035695679486,516.4654881646857L321.9864027593285,535.0186582445167L321.29218297917396,536.9675133954734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M265.2363023739308,546.3715381789953L269.70139777939767,533.8064763098955L289.54346131999046,540.9068419924006L285.93667400535196,551.0412903805263L273.6694949315861,546.6399865872227L272.7977757770568,549.085155706387Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M398.3458452820778,453.6417610379867L402.54824161250144,442.4801836856641L404.22778014838696,443.1107347244397L409.98191546462476,445.30101470975205L410.3716252045706,446.5548326331191L422.8802034286782,451.2891638195142L423.5602232590318,451.9478078796528L420.5127562005073,460.0409046700224L419.2868271796033,460.48000016249716L406.7364379912615,455.71133838035166L405.694319434464,456.43345320643857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M269.70139777939767,533.8064763098955L273.2726852176711,523.7646073261276L293.10843766853213,530.8722667954862L289.54346131999046,540.9068419924006Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M247.10848835855722,587.2546540838666L248.0086074154824,584.7814051466994L248.73832707107067,583.8595292116515L255.71918029431254,586.4316251911223L257.5478183059022,587.0985803445801L257.10130876582116,588.3034695219249L262.522534141317,590.3012127731927L262.96194370649755,589.0827975589782L264.39298311807215,589.6072051567025L271.41643619164824,592.186582440976L267.9650594415143,601.6113421027549L249.15012562274933,594.6806385470554L250.88567507266998,589.9474457837641L247.84609687514603,588.8278771801852Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.93217224814,632.4316109917127L357.3277117833495,628.6473667277023L359.5247596092522,622.6801805500872L362.2393167298287,615.2958455784246L364.9459849856794,607.9260695758276L372.01124902348965,610.5408166386187L364.8749852348119,629.9583781706169L363.0045362589881,635.0463488111272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.41863273177296,428.00246629305184L334.88469072338194,421.21309940423816L351.1696667773649,427.1939857113175L359.87186950072646,430.3904489306733L357.39871153235435,437.1725232312456L355.0320531902835,436.3005723487586L347.13056987244636,433.40273957746103L340.63882603961974,431.0210010702722Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M369.6374907065183,637.1231553829275L371.3880289932713,632.3681414178573L378.5171928051859,612.9505866360851L385.3915464030579,615.5018620742485L376.49764435365796,639.674421927426Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M419.6907368693501,479.04060364468023L421.3773753819987,474.5976337934844L433.3968442156911,479.2102064155042L435.05508282687515,474.8598419302143L440.5678189927712,476.97103326488286L446.4923537084833,479.25286723673344L447.1731624258682,479.50779164163396L443.8211853252724,488.30944117484614L432.8580349991098,484.1005913615227Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M321.9864027593285,535.0186582445167L328.69035695679486,516.4654881646857L335.95442029554397,519.1010797624476L329.49186524935067,536.988323377911L327.4360280353576,542.6715272953734L323.86474059708416,541.3677828302607L325.338379858993,537.2786226281896L323.3259313814342,536.5492327311076Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M322.9788214918226,619.7179155154154L326.5643088789657,609.7687744353898L327.74842693749815,610.1932936096564L328.67615700606257,607.6066396073438L328.9246561322361,606.9199171424843L327.74842693749815,606.4943572795019L328.7116568814963,603.8088554325514L331.2416146490723,596.7855504490435L331.6526243146509,595.6378897144459L338.1443681474775,597.9904379420914L329.4776652986184,622.0714960577898Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M271.5150469550863,473.42081858823076L272.01125632133335,472.0598331117071L272.89007545262575,471.61345479125157L274.53411411400884,472.21590944053605L275.1865229308605,472.0171722462401L276.2491525253281,469.1047872751951L277.01437205728143,468.57308699097484L277.97129091247916,468.9279006868601L278.6513107428327,467.0570646338165L279.46623010002077,466.5326477615163L279.9979393398389,466.7241015438922L285.44756461586803,468.72916340176016L284.7036450104788,470.77064249524847L289.45905050542206,472.5207785302773L290.2029701108113,470.47929994855076L297.35343384742737,473.10866597900167L295.16348599549383,479.0967910657637L294.44086631480604,479.366282586474L286.8083931617439,476.5673160958104L286.07867350708693,478.5942257703282L285.17855445016176,478.99794282298535L276.1426528999582,475.6818435592577L275.69614335894585,475.05753853544593L273.60559515841305,474.28548123920336L273.1661855923012,474.7245758296922L271.71384625602514,474.1928759799339Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.44612790085375,561.4795486261137L411.8176534520462,546.1863295827061L421.7244852716103,549.6948871044442L416.3529597213492,564.9880984108895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M245.60644919797778,600.6478488272987L246.29356900323182,598.7489550914615L248.12930699065328,597.4587475447915L249.15012562274933,594.6806385470554L267.9650594415143,601.6113421027549L265.16530262399465,609.2932713069022L245.67744894791394,602.1222223951481Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M336.00412011984736,415.7139674774371L338.9805874284357,407.55006367433816L339.8594065597281,407.86846234370023L353.18921522796154,412.7588976211846L356.044982961379,413.8150230855681L353.06851565279067,421.97891951166093Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.249166989699,431.97827483713627L296.39651499316096,426.08895804639906L298.32455265522003,425.84755837963894L312.7737907199189,431.1562680238858L313.36229975987226,431.3758166884072L310.3290326530114,439.7020125775598L294.49766611494124,433.88449785718694Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M296.9424241827801,413.9284395026043L297.9277429394424,411.23557942872867L300.35120108164847,410.83810154069215L301.0383208869025,408.9599661757238L318.8616248620674,415.51522866403684L316.2393674198538,422.7156050791964L315.9064574781805,422.59490518970415L301.44223057758063,417.2799458880909L298.55806294456124,416.2165373326279Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M329.0169558087364,433.16862377058715L329.9446858782321,430.60271401237696L331.5185136757791,430.4612039583735L332.41863273177296,428.00246629305184L340.63882603961974,431.0210010702722L340.3627159008756,431.75768567435443L346.85367084667087,434.14670753199607L347.13056987244636,433.40273957746103L355.0320531902835,436.3005723487586L352.6504060123116,442.83499871660024L347.84608957823366,441.06300440384075L348.37779881898314,439.62397404620424L337.7262585069984,435.7262084633112L337.2087492160499,437.15795603301376L329.7821753388271,434.4370110896416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M364.8749852348119,629.9583781706169L372.01124902348965,610.5408166386187L378.5171928051859,612.9505866360851L371.3880289932713,632.3681414178573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.70497304573655,443.9327401216142L357.5336110582575,438.9445185372606L367.3978430284187,442.57903244998306L382.88288856018335,448.29144811676815L381.0613505234942,453.2869465579279L380.3316308679059,453.0184945347719L362.9335365090519,446.59749365272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.0959529662505,466.68144064815715L357.0729015674442,461.288476862479L358.6814403543249,461.8836488383822L359.2344495197758,460.35305786831304L361.1829982222989,461.0762127204798L376.0156349381432,466.5461743855849L373.4856771696359,473.46347944205627Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M298.32455265522003,425.84755837963894L301.44223057758063,417.2799458880909L315.9064574781805,422.59490518970415L312.7737907199189,431.1562680238858Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M334.5935917487368,494.0363862370141L340.07871690019965,479.04060364468023L345.3445317093283,477.16977031715214L348.3990987436846,478.2893569506705L346.3716614311561,483.8311000261456L341.68804457224905,496.643892721273Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M405.31170966941863,464.5764892389998L408.1603774270043,457.2138365772553L424.6157528795302,463.64107068581507L421.75998514704406,471.01100008608773Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M377.63127369992435,509.4774717995897L384.12301753181964,491.52772683650255L390.95398239418864,494.0218191584572L388.55182417761534,500.6331884544343L384.4630274474621,511.9725981657393Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.4630274474621,511.9725981657393L388.55182417761534,500.6331884544343L391.33028106950223,501.64039682177827L392.34321084059775,498.8403988191858L391.9038012754172,497.7072889395058L394.10084910318255,491.65466856071725L398.9264654610306,493.41936640208587L393.46264023706317,508.52853276161477L391.31608111970127,514.4739666488022Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.0746892662719,589.0755141181871L293.93045699968934,581.1240749559365L309.2380031570792,586.6803027056158L308.3094842005521,589.2596810786054L306.38144653849304,594.6171686272137Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.9108723215759,455.27848565299064L357.05870161764324,452.1257354100235L360.4532785657793,453.37226851517335L377.8513729246333,459.79326312523335L378.41069318167865,459.99824373284355L376.0156349381432,466.5461743855849L361.1829982222989,461.0762127204798L362.7142261695117,456.9016832401976L360.43907861597836,456.0588691541925L359.7590587865561,457.9224246032536L356.6689918767661,456.77370036626235Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M279.7644290504977,465.12900002487004L281.27356818690896,460.9908908540383L282.7550963079557,460.19698126846924L283.7893260028213,460.5726056075655L299.22388282511383,466.25587217276916L297.814143339172,470.10367614915594L298.7071624202654,470.4376795850694L298.2393529545516,471.7060600845143L297.69344376400113,473.2220814288594L297.35343384742737,473.10866597900167L290.2029701108113,470.47929994855076L285.44756461586803,468.72916340176016L279.9979393398389,466.7241015438922Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M360.4532785657793,453.37226851517335L362.9335365090519,446.59749365272L380.3316308679059,453.0184945347719L377.8513729246333,459.79326312523335Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M357.5478110089898,503.03571313014254L363.3871460240334,487.09829157823697L366.568723722361,478.3954887590371L371.0693190023303,480.06134174671024L371.3241292182356,480.1529064234346L362.3095275927335,504.7931245425716Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.54564339574426,573.2506637009792L340.0290170740336,551.9694136581384L346.56336075626314,554.2938833017834L344.4799125296995,560.2111845556647L341.4182455204427,559.1197045384906L340.39111580047756,562.0330921886489L338.9805874284357,566.0504436502233L342.04225443676114,567.1283961432055L339.0728871030733,575.5615997938439Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M301.0383208869025,408.9599661757238L302.8030591234565,404.1132300202735L306.1408362723887,405.3389613828622L306.8350560525432,403.460824531503L321.3205828787759,408.7830780558288L318.8616248620674,415.51522866403684Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M292.1302188867703,437.15067243296653L292.9025383936241,435.0394689706154L294.49766611494124,433.88449785718694L310.3290326530114,439.7020125775598L307.77067498490214,446.7109095361084L292.21541858743876,440.9922494846396L293.04453789256513,438.7104029180482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M283.5771156391129,456.68213538173586L284.3920349944383,454.45648160390556L286.10707340668887,453.712515829131L286.7870932370424,453.96744117327034L302.1301392689347,459.601809151005L299.6490924404934,466.4119486324489L299.22388282511383,466.25587217276916L283.7893260028213,460.5726056075655L284.43463484570384,458.8006158294156Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M324.8358594048768,448.0146718020551L327.33031729608774,441.1545695955865L342.1266652503982,446.5902100652456L343.28238340932876,447.0157797448337L342.2118649510667,449.9354575839825L343.04098425619304,450.2538543092087L343.6081933733076,450.93434922071174L343.0196843324229,452.5721149877645L342.3183645773679,453.21619176259264L341.2131351316348,452.8124732095748L340.81632541585714,453.88315973384306Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M417.54338886775076,524.1402282179333L422.24909453839064,511.15060083800927L424.3112428402528,511.9018439692445L425.4377722106874,508.7969826320186L426.9477002322674,508.3225130867213L427.3019100986421,507.33091324334964L429.5699576763436,508.1529110223055L429.2078589498997,509.1445107469335L430.3351772064343,510.89463709294796L424.6086529046297,526.7196298623458Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M288.4595317989588,596.3391801575199L291.0746892662719,589.0755141181871L306.38144653849304,594.6171686272137L303.7954778559506,601.8100755810738L303.76707795541734,601.8808288625441Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M327.26641752105206,491.3289901963435L330.7532941447571,481.7969083311036L332.7515426715836,476.33320174599066L340.07871690019965,479.04060364468023L334.5935917487368,494.0363862370141Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M280.954858195968,617.2020181887783L283.48481596354395,610.1724838479422L298.785262145102,615.7214049007744L296.652114094235,621.6605039341375L296.26240435242653,622.7446906990372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M308.03337405994534,394.8005780479871L308.7275938410312,392.8943442790769L310.27223285194486,391.980766993016L311.1297520585358,389.62814884539694L326.28109876438975,395.1980568547733L323.7724409215152,402.05092090787366L308.9611041303724,396.615245512221Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M285.95087395608425,603.2979752635583L288.4595317989588,596.3391801575199L303.76707795541734,601.8808288625441L301.2655200883746,608.8541852403432Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.60959386173636,449.9916452416219L287.2620026776567,448.19884250918403L289.2744511542842,447.37683761911467L290.08227053657174,447.68170780083165L304.53939746227115,452.99664378911257L303.40576811507344,456.1077731875703L302.1301392689347,459.601809151005L286.7870932370424,453.96744117327034L287.53101284243166,451.93428122391924Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M424.6086529046297,526.7196298623458L430.3351772064343,510.89463709294796L437.0320314280689,513.32629228523L431.3055071271956,529.1502390038222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M290.01127078570426,443.73504263162613L290.7977902404964,441.594706798438L292.21541858743876,440.9922494846396L307.77067498490214,446.7109095361084L305.36851676832885,453.3015137212351L304.53939746227115,452.99664378911257L290.08227053657174,447.68170780083165L290.8687899913639,445.527846517507Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.309433510527,468.8217687369324L355.0959529662505,466.68144064815715L373.4856771696359,473.46347944205627L371.0693190023303,480.06134174671024L366.568723722361,478.3954887590371L357.47681125905365,475.0440119248815L357.9233207991347,473.8391030593775L356.2153823617846,473.2147978665307L357.40581150818616,469.96945046493784Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M283.48481596354395,610.1724838479422L285.95087395608425,603.2979752635583L301.2655200883746,608.8541852403432L300.9957210365683,609.584608017467L298.785262145102,615.7214049007744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M371.19632966723293,549.9851858234033L374.17279697488993,541.7434027707204L376.95835384353995,534.0333052198403L383.5629083914682,536.435818316415L379.09150189720094,548.8156668934971L377.80167310032994,552.3876933925785Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.3937791706994,390.52819966943935L383.6268081665039,387.140262093395L388.5731241013855,388.96117469482124L389.37384350784123,386.75735012535006L401.89583279564977,391.3783053671941L402.1230319952592,391.46362808765844L399.61437415424734,398.3092121910304L386.8651856649667,393.6029388792813L387.3329951297492,392.34911137772724Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M305.81502630747855,401.7606159937568L306.53054601419717,399.80443919310346L308.1816846495494,398.74831159366295L308.9611041303724,396.615245512221L323.7724409215152,402.05092090787366L321.3205828787759,408.7830780558288L306.8350560525432,403.460824531503Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M327.33031729608774,441.1545695955865L329.7821753388271,434.4370110896416L337.2087492160499,437.15795603301376L344.57221220526844,439.86537322960794L342.1266652503982,446.5902100652456Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M362.9477364588529,439.2202547006309L364.2801651051268,435.59198211319745L374.17989695072174,439.2421054923907L384.4630274474621,443.032696234528L384.76753748673946,443.14611217658967L382.88288856018335,448.29144811676815L367.3978430284187,442.57903244998306L367.95795216877013,441.06300440384075Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M407.6507569970563,434.0114406356588L410.0671151643619,427.64036689233035L424.3254427900538,432.96988545684144L422.9291143678129,436.66163078462705L424.7719523301348,437.35669422661886L423.7369337491691,440.10573189146817L420.95216576661915,439.05689403088763Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.93173434585333,521.7304273499176L412.8660830985755,516.3874504980631L414.82962063513696,510.95186475943774L416.7355694863945,511.6396372341551L418.67701821308583,506.2820855542086L423.3827238837257,507.99683550558984L422.24909453839064,511.15060083800927L417.54338886775076,524.1402282179333Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M383.07379900012165,557.0574415409938L385.23534695245326,551.0558573361486L384.32102794665843,550.7218577847816L388.7932233279571,538.3420126130804L394.1718488531187,540.3043933128938L389.63654258288443,552.8413499901071L387.52469445578754,558.7014252101071L386.95748534053564,558.4964475207962L386.0502663096413,559.1197045384906L384.20742834731936,558.45378718758L383.5842083161697,557.2488928223029Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M394.4834588672966,475.1074829399586L397.2122159358114,468.8217687369324L414.92823139950633,476.5454654241912L413.4545921385288,479.95416945405304L408.8837859928608,477.95639440137893L409.4502062238753,476.6380706522614L407.63655704725534,475.8441628590226L405.82211898546666,480.05405819183215Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M393.4981401115656,560.8989521400072L395.6454881140962,554.9743680018L394.9867682084441,554.740256300196L399.49367457814515,542.2397204954177L404.74528943933547,544.1531966831535L400.2446941593662,556.6110686901957L398.1257460564375,562.4721812210046L397.7218363657594,562.3233903902583L396.54560716915876,562.861326451879L394.70276920776814,562.1954094627872L394.15054892748594,561.1393066071905Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer footway"
        d="M209.34372119419277,592.186582440976L280.67795916926116,396.2874816409312L292.9049050519243,396.2874816409312L261.7076147859916,481.3432470834814L237.47776667866856,548.6595922922716L218.77643245924264,600.6124721788801L216.7426840569824,601.4136491101235L211.71747951116413,600.9454288370907L209.7831307593733,597.7636111252941Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M377.6525736246258,555.1231589876115L379.8283215267584,549.085155706387L379.09150189720094,548.8156668934971L383.5629083914682,536.435818316415L388.7932233279571,538.3420126130804L384.32102794665843,550.7218577847816L382.14528004452586,556.7463331953622L381.67747057788074,556.5684083485976L380.4586415318772,557.1927060345188L378.7791029959917,556.5829752949066L378.1771828914061,555.3218937991187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M389.1403332175687,487.4874410429038L391.73419076018035,481.478513055481L403.0728508774191,486.41780021833256L406.5589386159554,487.94110188633204L403.95798109751195,493.95106477709487Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.6654237769544,558.5245409114286L390.5926725529134,553.1888758973219L389.63654258288443,552.8413499901071L394.1718488531187,540.3043933128938L399.49367457814515,542.2397204954177L394.9867682084441,554.740256300196L393.087130445987,559.9843564997427L391.69159091077745,560.7002174905501L389.64995364658535,559.9635465866886Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M341.68804457224905,496.643892721273L346.3716614311561,483.8311000261456L353.59312491863966,486.48855467373505L348.8945192238316,499.3086259900592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M342.33966450206935,401.05826534330845L344.85542231984437,394.1492122001946L351.5025767162442,396.57258418528363L358.1852309880778,399.03861663723364L355.6623731954023,405.94870542595163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M339.8594065597281,407.86846234370023L342.33966450206935,401.05826534330845L355.6623731954023,405.94870542595163L353.18921522796154,412.7588976211846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.3707277709618,400.4277104786597L386.8651856649667,393.6029388792813L399.61437415424734,398.3092121910304L400.16028334386647,398.5141946170479L397.6650365656242,405.331677749753L391.6702909851447,403.113291118294L384.6894377619028,400.54841075418517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M334.10527124255896,420.93007890786976L336.00412011984736,415.7139674774371L353.06851565279067,421.97891951166093L351.1696667773649,427.1939857113175L334.88469072338194,421.21309940423816Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M346.5846606809646,538.9298944817856L351.6800760924816,524.8342423890717L356.94510201830417,526.7477233801037L353.6712246434763,535.8115187636577L350.5038468968123,544.5641934019513L347.3427802361548,543.4092405340634L348.68230885919183,539.6957015837543Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M329.49186524935067,536.988323377911L335.95442029554397,519.1010797624476L341.3188458709046,521.0572228981182L336.21711937058717,535.152882669121L333.53806212730706,534.1748131616041L332.1701336055994,537.9663924905472Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M340.0290170740336,540.5738824503496L346.414261280559,522.9207608709112L351.6800760924816,524.8342423890717L346.5846606809646,538.9298944817856L343.5584935480729,537.8311276221648L342.2686647521332,541.395876289811Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M336.21711937058717,535.152882669121L341.3188458709046,521.0572228981182L346.414261280559,522.9207608709112L340.0290170740336,540.5738824503496L337.2655490161851,539.5750037310645L338.55537781398743,536.0102541269735Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M391.73419076018035,481.478513055481L394.4834588672966,475.1074829399586L405.82211898546666,480.05405819183215L407.69335684832186,480.87605920806527L406.7506379419938,483.0371930571273L404.88650005310774,482.22247585002333L403.0728508774191,486.41780021833256Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M424.4248424395919,499.0391352456063L425.3249614974484,496.6865534354001L427.83361933846027,497.642777627334L438.6831700652838,501.8099990426563L436.27391187287867,508.1310604503378L425.2113618962467,503.90037208702415L426.7205010326579,499.9246047944762Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M352.8705052379519,501.30639488901943L358.70984025485814,485.36896936176345L363.3871460240334,487.09829157823697L357.5478110089898,503.03571313014254Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M348.7320086834952,499.77581262402236L348.8945192238316,499.3086259900592L353.59312491863966,486.48855467373505L354.5642437245697,483.83838357776403L358.70984025485814,485.36896936176345L352.8705052379519,501.30639488901943Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M405.87181880977005,438.7457803902216L407.6507569970563,434.0114406356588L420.95216576661915,439.05689403088763L419.1732275802642,443.7912303400226Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.22778014838696,443.1107347244397L405.87181880977005,438.7457803902216L419.1732275802642,443.7912303400226L417.5291889179498,448.1572220120579L409.98191546462476,445.30101470975205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M375.98723503760993,434.30174420028925L377.88608391489834,429.10749365389347L381.8123701037839,430.5538098020479L388.16921441070735,432.9064140561968L386.2703655352816,438.0860945614986Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M374.17989695072174,439.2421054923907L375.98723503760993,434.30174420028925L386.2703655352816,438.0860945614986L384.4630274474621,443.032696234528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M268.3902690578252,497.39513742318377L270.43111743498594,491.6619521039538L275.95884243492037,493.63891309453174L273.9108940847218,499.3866638489999Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.20558279100806,576.5209345859475m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M317.2467749873176,554.7017579311505m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M383.4019756242633,415.25718035455793m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M321.8089033830911,476.5246552606113m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M405.19101009331644,582.9168433095329m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M350.1748813856393,571.1603115680628m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M365.4216833123937,539.8725863662548m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.42377130687237,512.223359355703m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M263.2293761000037,579.3666828926653m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M251.9830156583339,612.7060720156878m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M320.30055313464254,605.9668294889852m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M319.4312006365508,524.6927342582494m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M277.3890929603949,543.639190625865m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M411.16366686299443,451.6190061122179m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M281.40531216654927,532.3393717077561m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M260.2836753493175,593.4341308507137m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.14525111578405,429.19593745609745m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M328.97041152697057,527.059873572085m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M331.2913144752383,608.6877071037889m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M284.14511364139616,472.8152425130829m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M256.7683988260105,601.8673024992459m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.0245515406132,414.76397508755326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M303.58484526351094,432.9313864107244m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M308.5224834512919,415.8658830053173m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M341.6257225694135,435.0821300628595m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M366.999455540441,445.26563727110624m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M369.5081133833155,470.07246087444946m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M307.11353285145015,424.22123197466135m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.4834154751152,488.9337450112216m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.96373127400875,464.1093002334237m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M390.82776061538607,505.0844656471163m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M368.65611638035625,458.85784392571077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M289.55135018005967,466.48998686205596m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M370.39245471637696,453.19538152916357m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M337.73493625503033,564.041247961577m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M315.00397176481783,412.2375981961377m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M301.27183117717505,440.34713106090203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M292.9593381937593,460.0866871387698m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M334.05793807748705,447.51522579137236m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M423.75823367387056,518.021038796287m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M297.4204891677946,595.4786946927197m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M333.16886342689395,486.5634711533785m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M294.8597648423165,602.589402097743m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M295.66363979224116,453.4825627519749m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M298.9264727598056,447.1968289404176m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M364.85210753884166,473.3396589094773m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M292.47890655044466,609.2193966382183m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M376.6325438795611,545.2800559825264m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M314.96373857278377,402.7553524947725m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M335.95126475021243,440.5104917003773m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M374.4268183046952,441.8215387244709m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M415.9884943366051,433.4911833223887m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M417.46765579935163,514.0130240204744m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M389.24446618463844,545.5131275062449m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.1342501025647,471.96410629479215m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M399.86366216558963,549.4462082637474m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M405.1799656879157,551.3638444482349m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M383.94236261211336,543.5788417309523m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M397.8504248028621,487.7142714681104m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.5678696827963,547.5400170213543m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M347.63782364409417,491.56622555758804m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M350.2616588585079,400.04896132368594m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M347.76167876366526,406.90910421079025m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M392.2651111148298,399.47147287381813m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M343.97660318855196,421.5960094691254m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M352.32932936400175,531.2801428032108m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M335.9118204442784,527.6165413833223m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.3511503916234,531.3332083011046m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M341.31647921260446,529.0368244680576m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M399.46448579151183,480.46505871322006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M358.1284311879426,494.202867126558m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M353.59785823524,492.89807304320857m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M413.4119922872633,438.90185746829957m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M411.6993205342442,443.4509825417772m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M382.07822472415864,433.6045994204469m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M399.1039648381993,562.2307863044553L401.02411363925785,556.8951241425239L400.2446941593662,556.6110686901957L404.74528943933547,544.1531966831535L410.1168149895966,546.1155757359229L403.7812706073746,563.634414376691L403.09415080212057,563.3857360356487L402.7888518758118,564.2368610319681L401.7759221056476,564.6613829941489L400.35829375870526,564.1442569741048L399.6427740538493,563.1235312493518L399.86918436829,562.5002745925449Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,539.2514086165465L434.58017338626087,542.6860942719504L450.3405401725322,548.3692935155705L558.3556157937273,587.3254075106233L629.1944332905114,612.9224934694357L629.3032995732501,612.9620320000686"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.6740435352549,487.3740258263424m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M627.8178270207718,396.2874816409312L573.5779622495174,544.9751900956035L558.3556157937273,587.3254075106233L548.8866157662123,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M573.5779622495174,544.9751900956035L513.0719750756398,518.4424420818686L452.01297873444855,492.12289621541277"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M513.0719750756398,518.4424420818686L548.8881935393438,425.84027477074414"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,577.9693009625189L629.1944332905114,612.9224934694357"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M482.8544813627377,429.9794454406947L489.0693261688575,413.26146769011393L497.7573289433494,416.5078821578063L495.922379842028,421.4472156148404L501.0816950276494,423.3815354667604L502.08042484894395,420.688679064624L502.9237441048026,420.23501381790265L507.8558600889519,406.947603401728L507.4172394089401,406.2181997895241L508.44436912983656,403.4472977812402L503.30635386984795,401.5337827564217L501.47850474435836,406.4585596183315L492.7755131330341,403.1986136944033L499.13235743995756,386.08413256611675L502.0591249233112,387.1756398291327L509.08257799688727,389.8050374579616L507.4172394089401,394.26991258375347L508.63606845680624,394.7298226552084L509.3231882620603,394.37604567874223L517.9409801717848,397.6006180741824L518.1176906609908,399.04590027499944L519.3152197813615,399.49228327116L521.1083579184487,398.74831159366295L529.8602604679763,402.01554324897006L530.7816794486716,401.57644405262545L531.9011088451371,398.57142321392894L541.2273204857484,402.05092090787366L538.7257626177743,408.7757944264449L539.5619818978012,409.0879499325529L540.0652912389487,410.5831746077165L536.5997145399451,419.93742604972795L527.7626122906804,416.6421088776551L529.7963606929407,411.1710673114285L524.0138254771009,409.0026274290867L522.170987514779,413.9700602083467L521.5690674092621,414.3810646450147L518.2241902854294,423.39610269339755L518.7416995773092,424.35233699623495L516.9272615145892,429.25628734380007L522.3271869653836,431.2686436427757L524.4319351166487,425.6134423180483L533.2619373919442,428.92332244105637L526.8837931603193,446.08764241216704L518.0892907613888,442.7996212663129L519.3933195071295,439.29100963892415L509.03997814655304,435.41509467270225L508.89797864481807,433.99791394686326L505.9144113631919,432.8845632476732L505.76531188655645,433.2674726676196L504.7239822167903,433.72842066315934L495.8868799665943,430.42582644242793L495.7093805912882,429.8805964952335L494.5970511706546,429.46230937168L492.9956123586744,433.771081764251L485.3773391554132,430.9148685336113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M486.3058581119403,502.51858250889927L496.5952996965498,474.8171810824424L497.08440908789635,474.9940675199032L502.1017247736454,461.5007410007529L503.8451630854979,462.1458574552089L511.8886459041387,440.4678306407295L518.0892907613888,442.7996212663129L526.8837931603193,446.08764241216704L531.3985883910209,447.774313414935L530.8668791493401,449.1987749086693L523.3480055965483,469.44503381382674L523.5318160606548,469.5230720094405L516.6795512745157,487.9910461967811L508.13985908962786,512.0433523613028ZM499.0542577151209,487.4385372339748L502.25792422425,488.65697031700984L502.17272452358156,488.8838007063605L505.3266912084073,490.088706954848L507.4243393847719,484.5251182327047L501.06039510294795,482.1444377973676Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M598.2756198225543,589.4292811555788L614.7515063136816,543.8410472590476L616.7647436773404,544.5714768865146L616.8349545411766,544.3727417695336L617.4731634082273,542.6153403888457L632.8083205781877,548.2069759173319L632.327100048773,549.5388125176542L632.1709005981684,549.9706188621931L637.599225949496,551.9486037208699L637.8327362388372,552.0328839682043L621.2858499968424,597.8135546459816L621.0941506708041,597.7428013258614Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M552.9059905176982,418.9811911354773L559.6241446640342,400.9094710475765L568.2987363757566,404.1558913034387L568.4612469151616,403.7511293743737L568.0999370748177,403.1070480039343L567.9516264852136,402.3766034664586L568.1496368981898,401.28509859927L568.5535465907305,400.64726011734456L569.1278556799516,400.1727831652388L569.814975486137,399.8824781724252L570.5588950915262,399.7971555539407L570.8073942186311,399.13122290046886L581.6072451192886,403.1778033101L579.4314972152933,409.03800505260006L603.816755887121,418.17999311955646L601.8185073602945,423.5303292805329L604.0439550876617,424.35962060978636L601.1455875057727,432.1759726619348L598.9201397774741,431.34668226819485L596.7514918493107,437.1725232312456L572.6289322553203,428.12316608894616L570.580195017159,433.6150045674294L559.6028447393328,429.6183866607025L561.4669826272875,424.5937367132865L560.7656628713012,424.3315266780555L561.552182327956,422.22656240919605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.0671151643619,427.64036689233035L411.2007445106283,424.5583591698669L410.51362470537424,424.30967583926395L412.6467727581039,418.5483361147344L415.310841165483,419.5337055558339L417.1039793025702,414.6796931712888L413.3906923625618,413.3114125393331L414.49592180829495,410.32824766775593L415.14833062607795,410.568607354071L416.9769686376676,405.5938885062933L416.1754603460431,405.3035837407224L417.2743787029758,402.2912808810361L421.1367651168257,403.71575172431767L422.88651451840997,398.97514492599294L420.24374603573233,397.997056201566L423.7298337733373,388.5501687480137L429.32855852507055,390.60623875120655L436.29521179851145,393.17840644018725L443.9268960664049,395.99821700854227L447.8531822543591,397.44454006291926L441.1421280829236,415.65673902537674L442.57395638059825,416.1811597463675L437.0817312542349,431.09175609145314L435.86290220730007,430.6453751302324L433.7510540802032,436.3786109178327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M521.4412678591907,517.7900473503396L529.0595410624519,496.67926989821717L533.8220465322956,498.40858929231763L550.7452314505354,504.5662946761586L546.0466257566586,517.5705014234409L557.3923858478665,521.7023338107392L570.693794616498,526.542744745966L566.6617976874113,537.704186743591Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.6254799989983,381.5984417181462L533.9285461585969,372.69052326353267L545.7066158400849,377.10546430386603L549.2424034038559,367.5950763830915L537.0888239303604,363.0459015276283L537.9108432624489,360.82021768251434L540.3414013795555,354.2867545308545L567.0089075788856,364.26435647765175L566.5410981131718,365.51194590562955L564.0892400713637,372.1307214386761L558.0937056038529,369.88423002744094L555.1953380210325,377.6871167072095L561.1908724866807,379.93360558943823L558.3556157937273,387.57936220476404L555.2805377207696,386.4389504841529L552.3253703387454,394.37604567874223L553.4873995846137,394.81514533096924L551.5672507816926,399.9813275421038L540.6609002565965,395.8920839377679L545.1607066504657,383.77417382830754L541.844229426235,382.5265876855701L540.7808109456673,385.39738815743476Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.2432936709374,541.5384245798923L457.93041347619146,539.6603246298619L460.7017703950405,532.1052592429332L465.1163770882413,533.7211553417146L471.3241219203919,516.7838818323798L466.59080523531884,515.0410404908471L470.22599244862795,505.1406528581865L491.68448363710195,513.006857954897L488.693816379644,521.1633540522307L487.43238748330623,524.6146966861561L484.9166296655312,523.701136757154L485.5477385558188,521.9853501925245L483.66230074316263,521.2840522248298L477.37645618710667,538.4408600102179L482.0395620074123,540.1493590143509L481.6924521168694,541.0982937230729L478.6520850341767,549.3827379303984Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.72446351032704,635.0109723419882L511.48473621346056,613.815231882967L512.6609654100612,610.6115698288195L529.0311411619186,616.6568029304035L528.251721682027,618.7898013056256L533.3329371428117,620.6751632248051L538.0457427874207,622.4106946019456L529.8957603434101,644.6708229356445Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M536.288104524836,570.4090748610906L540.2491017030552,559.4318532720208L544.9690073244274,561.1393066071905L545.9685260308906,558.362223548349L543.2255690125749,557.3623068961315L546.2375361965969,549.0071184057742L544.3031874438748,548.305823171977L548.0022744331509,538.051713406574L565.818478432484,545.8960307049565L565.7048788312823,546.1936130682006L562.5367121975869,554.9951779297553L558.1718053286895,553.4157041730359L556.5419666180387,557.9293772303499L557.271686273627,559.1842152783647L556.6271663177758,560.9697058354504L555.3586374456063,561.473305657506L553.6577989850193,566.1711410419084L558.0937056038529,567.7870291974396L554.7346285302192,577.105691736564Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.0551189212129,386.33906039921567L593.4279146511108,373.5760089517571L606.4603132549673,378.3530514235608L604.2135656028986,384.51086345501244L609.9471898796037,386.6158391768113L612.1860486716032,380.45074535533786L622.0581695027649,384.07176314946264L614.9077057642862,403.7095086076297L590.5863468693569,394.7943349224515L593.1518045123667,387.7572913891636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M591.1109561352059,524.700017764233L600.7913776403293,497.6854383344762L601.2796981437132,497.86232418660074L607.906341502443,500.25756628857926L607.1829329356551,502.26365895057097L620.51353049092,507.0749493581243L618.6493926029652,512.2774655036628L619.0320023689419,512.4116903669201L612.6751580620185,530.1636862270534L599.7989589087665,525.5074464734644L599.0621392773464,527.5697188572958L598.0768205216154,527.2086651599966ZM602.6050268150866,517.68391614547L603.7812560116872,518.1094814618118L609.6213799146935,520.2279431363568L612.1860486716032,513.0640856036916L605.1633844841272,510.52629900490865Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.6520850341767,549.3827379303984L481.6924521168694,541.0982937230729L484.2721097096801,542.0128918550909L485.4554388811812,541.8849105527624L489.7990458253771,529.6111806225963L486.1851585358381,528.3209602101706L487.43238748330623,524.6146966861561L488.693816379644,521.1633540522307L509.1109778974205,528.4416582584381L506.0351109383628,537.1298312568106L503.31345384474844,536.166329018306L501.4856047183275,536.4066843409091L501.13060596678406,536.2724599409848L500.0963762719184,539.1921001859009L500.8757957518101,539.4615893694572L498.4097377592698,546.448535008356L499.56466703116894,547.6960916505195L502.08042484894395,548.5961219510064L499.8904769960791,554.8110100599006L499.1039575394243,557.0366316167638L491.5211842106655,554.3438271344639L492.5349028687924,551.4730966296047L486.5109685026109,549.3265510774218L485.56114962045103,551.9912640945986L478.67338495887816,549.5388125176542ZM491.7909832634032,539.7945489645936L494.7532506212592,540.8579385597259L497.72971792984754,532.4382191915065L494.7603505952284,531.3758688019589Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.60770478192717,534.9052438074723L447.32147301454097,527.2513256855309L455.57085510902107,530.1917797322385L456.33607463911176,528.0306605813093L448.08748143166304,525.0829221126623L450.68765006400645,517.7265767296776L461.09148013498634,521.4401274453849L461.89929951541126,519.1864009108394L451.48205838073045,515.4728489848785L454.06092708650976,508.1737210927531L462.7497187461704,511.27754220506176L463.5291382279247,509.073756522499L454.8482354283333,505.9699344248511L457.4981038849801,498.4793436261825L470.48080266453326,504.2551839747466L470.22599244862795,505.1406528581865L466.59080523531884,515.0410404908471L460.7017703950405,532.1052592429332L457.93041347619146,539.6603246298619Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M583.6622934462503,545.4642241066322L591.1109561352059,524.700017764233L598.0768205216154,527.2086651599966L596.8437915248796,530.652721281629L604.4833646528423,533.4090054472908L605.6950937248766,530.0294617055915L612.3706480208784,532.4319761907682L611.2086187750101,535.6419173721224L610.4717991454527,535.3724280428141L609.025770897977,539.4043619357981L610.570409909822,539.9506237660535L605.7376935752109,553.4365141056478L597.4110006410629,550.4388425787911L599.1394501179457,545.6265417714603L593.0808047614992,543.4373339833692L591.3586663734168,548.2485958142206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M615.5664256708696,455.76752599095926L616.5730443522334,452.97583355521783L616.7931435778737,453.0611555175856L622.3413796173409,437.6688484433107L626.7283752989024,439.26291576819494L626.1398662561551,440.8996437797323L644.3528799712658,447.5048206662759L638.2792457789183,464.3496580547653L617.9480728488415,456.9724379987456L618.0545724732801,456.6675682272762Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M487.43238748330623,596.4380267285742L488.58021677751094,593.3061504978687L490.23845539055765,588.7498403307982L495.6596807660535,590.7475834540091L496.7230992484838,587.8279649233446L497.8141287425533,588.2316756136715L499.1820572661236,584.497350837104L496.8579987734556,583.6399853760377L497.1128089884296,582.9595034928061L492.9317125836387,581.4143723584712L494.5899511957541,576.8788642371073L495.3125708764419,574.9019269850105L496.42568918317556,574.0518437912688L515.7936321683228,581.1948284455575L513.2991742761806,587.9913220875897L513.0719750756398,588.614576453343L507.1900402083993,586.4389086342417L506.50292040314525,588.3388462318107L506.8855301681906,588.4803530629724L504.8304818421602,594.0927614057437L510.3298069424927,596.1196367167868L507.4945502495393,603.8369486369193Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.2051302939653,408.57705541560426L639.4349639359862,390.99539363291115L663.848622508347,399.71183293825015L661.8779849950224,405.2682060957886L659.4474268769845,404.40353483567014L658.4550081454217,407.21709772665054L659.1713167373091,407.4720247806981L656.3786598937586,415.33834071131423L649.3914955826476,412.8442200785503L651.3329443074763,407.379418625962L649.0230857664719,406.5511657851748L649.3275958066806,405.68649468244985L647.882356445305,405.16935680201277L645.160699352622,412.85774681018665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.368465946056,579.2178924246691L580.0768060581759,548.9509315514006L590.4798472430557,552.6571820634417L590.2605369044468,553.2804396054707L593.4918144270778,554.435390827246L591.0754562597722,561.2527206144296L586.8588599804789,559.7440019943751L585.7812415482476,562.7843298041262L586.1283514378592,562.9039867585525L582.5073641752824,573.1372498874553L581.7492446191609,572.8615190503187L580.9485252145678,575.1433214577846L585.1225216425955,576.6312268641777L582.5428640497848,583.9229992297478Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.2432646108791,492.2779315910302L643.7572709554806,479.5431689051911L650.5961246779189,481.9883616925217L650.8517237799242,481.2797761261463L653.1757822707295,482.1090605473146L654.15400105156,479.3309053215198L664.1105326972902,482.88840052159503L657.1517682857811,502.50401544896886L647.1447479296476,498.92572021717206L647.9312673844397,496.72193060815334L646.8686377890408,496.3317411602475L647.2867474295199,495.1486866082996Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M442.7719667945057,613.2273563677445L443.0062659708783,612.603063724935L446.3866429682821,603.3624855922535L447.4066727142781,603.7381021711044L452.5020881248638,589.8267488060519L464.7479672729969,594.3403981560841L459.5957520632073,608.4078157274053L460.09906140342355,608.5919821741991L456.76838423032314,617.6910471045412L456.5277739642188,618.3434324329719L452.1052784100175,616.7202726486139L451.9206790588796,617.2311518280767L446.6485531590879,615.282319241669L446.8544524349272,614.7360633481294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M506.6725309183821,559.5379838407971L507.40303946007043,557.4975713840686L508.7417791951448,553.7060027346015L512.3280554693192,554.9951779297553L514.9503129133955,547.6107708532363L511.3498366875574,546.3215942885727L514.595314161852,537.1516817403026L516.9059615898877,537.9736759853549L518.8403103407472,532.5235401759855L522.2703871652484,533.7492488296703L521.838077574037,534.9832812664099L524.7151452321559,535.9956871364266L524.5668346425518,536.435818316415L527.6214016769081,537.5273019061424L525.4598537236452,543.6360691301525L527.5788018265739,544.3935517296195L526.2463731803,548.1643155207857L525.1048549721017,551.3950593560003L521.6258672093973,550.1620703404769L519.081709491089,557.3269300297834L522.5614861408249,558.5672012413852L521.2432574443519,562.30153998686L520.4772490281612,564.4564054817893Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M431.75201666820794,579.7069240184501L440.8731179172173,553.9255475183018L453.11189709138125,558.2977128005587L448.3777915202081,571.6774370684288L444.29609476588666,570.2176239388064L444.2747948411852,572.7689151060767L445.63483450282365,573.2579471552745L442.0564470887184,583.3850648002699Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.5678045284003,605.6796545796096L431.75201666820794,579.7069240184501L442.0564470887184,583.3850648002699L438.0875610494986,594.6098851952702L437.16693095397204,594.2769282325171L435.4873924171552,595.9281865092926L438.789669691585,597.1049809167162L434.2890744097531,609.8540944666602Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M470.64410208910704,622.8081603613682L474.03867903817445,613.538462178316L475.28590798564255,613.9921147748828L476.3840374555439,611.0163196814246L475.9020280400291,610.8383962269872L477.4829558124766,606.5224504726939L478.1416757181287,606.7638438441791L479.36760473810136,603.4051456497982L478.38307486847043,603.0357719878666L479.64450376387686,599.5917518269271L490.9263640809804,603.7443451071158L489.62943531014025,607.2955335276201L489.0338262943551,607.0614235945977L487.7865973478183,610.4554966152646L488.3751063896343,610.6760800885968L486.7381677022204,615.1262461342849L486.19225851166993,614.9275130368769L485.30633940547705,617.3653746605851L487.0284777926281,618.010476608295L483.5345011930913,627.5631808857433Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.5345011930913,627.5631808857433L487.0284777926281,618.010476608295L488.82871590554714,618.6763882371597L489.9339453512803,615.6506517641246L489.09062609355897,615.3385055591352L490.65656503103673,611.0725060328841L491.23087412212044,611.2785226553679L492.35030351765454,608.2090824386105L492.0528934523463,608.1029526172206L493.4137219991535,604.3821649006568L504.1496731247753,608.3443459342234L500.08217632211745,619.4702796726488L499.8486660318449,619.3849597591907L498.6006481992081,622.7863101512194L499.13945741485804,622.9850430199876L495.80168026778847,632.0913724526763Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M529.7395608928055,616.0262676766142L532.6245174109936,608.1674629016779L534.9130760291591,609.0102584916167L536.273904575035,605.3248478835449L533.4323367932811,604.2760350210592L537.804343637079,592.3499395018443L539.300071708858,592.9024401069619L538.9805728336796,593.7878976655193L547.4279653411359,596.9062473056838L538.0457427874207,622.4106946019456L533.3329371428117,620.6751632248051L534.4026667131111,617.7409904804081Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M542.084839691408,458.0847443151288L545.3232171898708,449.134263144806L565.2086694659665,456.3699820204638L567.3418175186962,457.1430818224326L564.1105399960652,466.0997957098298L563.6782304039225,465.9447597526014Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.792792593129,625.0618532071821L562.7710113730282,622.4106946019456L563.2814206890762,621.015402324032L564.3156503839418,621.4045442710631L564.7195600764826,620.3130738893524L563.6853303797543,619.9374582082964L569.6595649216324,603.6808752710931L569.9356750622392,602.9369255113415L578.5597780598328,606.1260242699645L572.40883302968,622.8362534912303L571.2610037326813,622.4106946019456L570.786094292067,623.7008975055069L571.7572130998597,624.069229580462L570.2330851266161,628.1937150903977Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.80168026778847,632.0913724526763L499.13945741485804,622.9850430199876L503.56905294489115,610.8956230706535L511.48473621346056,613.815231882967L503.72446351032704,635.0109723419882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M419.6907368693501,479.04060364468023L421.3773753819987,474.5976337934844L433.3968442156911,479.2102064155042L435.05508282687515,474.8598419302143L440.5678189927712,476.97103326488286L446.4923537084833,479.25286723673344L447.1731624258682,479.50779164163396L443.8211853252724,488.30944117484614L432.8580349991098,484.1005913615227Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.4047980979085,503.2843936337158L624.9210372101516,499.05370231019333L643.1908507253975,505.5662189438008L654.6218105182052,509.64083080971614L655.344430198893,509.9030376179144L653.0195828201249,516.4155440591276L652.44606261421,516.2105651185848L637.1243165088817,510.74584515579045L638.7399552706629,506.21757432166487L637.3515157084912,505.72853754321113L636.9121061433107,506.9688179893419L636.1957975523546,506.706611066591L635.8415876869112,507.72006157180294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M535.0195756535977,477.6796192713082L537.1314237816259,471.8194755576551L556.9742762073874,479.03332008840516L554.883728004992,484.8299867780879L557.5974962376058,485.8153467993252L556.173556801863,489.7411778839305L553.3737999824807,488.7204412063584L552.7931798035279,490.32906387513503L547.2441548770294,488.30944117484614L549.2211034782231,482.83845617296174Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M554.4869182892144,619.3422998031601L561.3746829517186,600.6124721788801L569.6595649216324,603.6808752710931L563.6853303797543,619.9374582082964L563.2814206890762,621.015402324032L562.7710113730282,622.4106946019456Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M539.6755814999342,464.78875327529386L542.084839691408,458.0847443151288L563.6782304039225,465.9447597526014L561.2689722115174,472.64147755037993L559.5113339507952,471.996362069156Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M537.1314237816259,471.8194755576551L539.6755814999342,464.78875327529386L559.5113339507952,471.996362069156L556.9742762073874,479.03332008840516Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.8264976013452,605.382074772846L515.8496430823579,588.9412907371297L513.2991742761806,587.9913220875897L515.7936321683228,581.1948284455575L523.446616361849,584.0301699126139L522.7665965305641,585.8718406301923L517.4021709552035,600.5271520325914L515.3613225789741,606.0979310730472L514.3902037711814,607.0541401752271Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M436.210012097843,610.1017306530848L441.78743692394346,594.858562416397L443.6365859750658,595.5452860733494L445.7342341532931,589.8267488060519L450.67345011327416,591.6476081623696L446.3866429682821,603.3624855922535L443.0062659708783,612.603063724935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M622.4833791172132,525.968388337642L623.9499184042215,521.8303154855967L631.9508013725281,524.6792077445425L647.4784467555583,530.234440236818L645.1961992280558,536.640796661377L631.3914811173454,531.708828784991L632.1922005228698,529.4405385814607Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M499.8904769960791,554.8110100599006L502.08042484894395,548.5961219510064L504.96459248196334,540.4604681045748L509.1172889843583,541.9421379654668L511.2433370621875,535.9603101615794L514.595314161852,537.1516817403026L511.3498366875574,546.3215942885727L508.7417791951448,553.7060027346015L507.40303946007043,557.4975713840686Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M448.16479227039963,412.171005054377L449.71022016648203,407.79146397393197L453.70671722106636,409.21489316644147L455.5495551833883,408.4927734239027L459.38354169763625,409.86001449031755L458.8376325080171,411.4051838614978L460.2552608549595,411.9087945455685L460.8003811594099,410.3709089127369L465.9099965188652,412.191815410275L465.37118730228394,413.72970064077526L466.8101155748591,414.2468378818594L467.35602476634085,412.70895276684314L470.4105917988345,413.80045583844185L472.1106413761154,414.40291551547125L469.7794829085469,420.9935504179448L468.0999443717301,420.39109131274745L464.98147756326944,419.27149532875046L465.4066871777177,418.0811440059915L464.35825753211975,417.7055173679255L463.9330479176715,418.90315237175673L458.43372281547636,416.9469804079272L458.87313238251954,415.69211661443114L457.2574936207384,415.126075161621L456.81808405555785,416.3590881964192L456.63348470441997,416.30185974622145L452.88469788990915,414.9699975447729L452.1336783096194,413.5809066169895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.76838423032314,617.6910471045412L460.09906140342355,608.5919821741991L463.1110285874456,600.3648356525227L470.28989222459495,603.014962203335L463.94724786747247,620.327640701551Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.8189670238644,486.63006358454004L467.60373500641435,479.13216833164915L482.54997132346034,484.7238550684415L483.7475004438311,485.1702325446531L480.96194357518107,492.675404808484Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M635.3595782713965,500.0099261784926L637.0249168584123,495.31828898750246L647.1447479296476,498.92572021717206L657.1517682857811,502.50401544896886L654.6218105182052,509.64083080971614L643.1908507253975,505.5662189438008L644.0554699068889,503.12103447364643Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.9641256509349,606.6930906153284L524.9139445321634,604.1064353073016L530.2357702581212,589.5499781398103L537.804343637079,592.3499395018443L533.4323367932811,604.2760350210592L532.4896178860217,606.877257107757L528.3440213566646,605.3466981514357L527.3587026000023,608.0394828207791L526.6715827956796,607.784563141875L525.8069636132568,608.2382161151618L524.6023345179856,607.8053729115054L524.3396354420111,606.8273136522621Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.4021709552035,600.5271520325914L522.7665965305641,585.8718406301923L530.5481691602618,588.7279900130816L530.2357702581212,589.5499781398103L524.9139445321634,604.1064353073016L524.4887349177152,603.9649287946522L524.2615357171744,604.5881817243062L523.0072067957371,605.0491183274426L521.5903673339635,604.5247118948027L522.1220765756443,603.0929988934658L521.4767677346244,602.8516053939238L521.7323668356985,602.1357487584464Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.7217276878655,400.09474418871105L591.032856409438,396.49454516917467L592.9530052104965,397.20313940104097L593.3143150517717,396.20424002222717L614.83670601435,404.1059463880956L612.9449571128935,409.3147829240188L593.6898248419166,402.2496601077728L591.4083661995828,401.4057988594286L591.6276765391231,400.7960544177331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M470.40349182579666,465.1081898272969L472.8553498676047,458.48950307490304L474.478088603355,459.1054855068214L486.1993584856391,463.48499416420236L494.3422409556806,466.5326477615163L491.88959402777255,473.14404327468947L485.6179494205862,470.7987362416461L484.859829865396,470.521960823331L486.0573589866981,467.283895727247L478.7088848343119,464.52654475998133L477.50425573810935,467.7656516530551L472.4656401267275,465.8802481452003Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.54828500468284,393.1076510315761L457.56910363491625,390.22332697641104L462.20380955561996,391.8808769863099L463.38003875128925,388.5720196990296L473.15275993198156,392.05152241233736L480.32452359516174,394.6164059215225L478.1345757432282,400.80333805363625L475.3569077346474,399.81796594988555L462.2464094059542,395.1345851109363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M468.1425442220643,586.6522094290704L474.44968870375305,569.4528607032262L481.0116434004158,571.8761714049615L476.5544368568808,584.0364128667861L474.8890982689336,588.5864831842482L472.86244984250516,587.8352483627386L472.59265079163015,588.5511064776219L471.1048115808517,589.3658111877739L469.11366302799433,588.6291433325969Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M572.40883302968,622.8362534912303L578.5597780598328,606.1260242699645L585.4696315331385,608.6981119872071L579.7580960672349,624.2044927640818L579.3257864769548,625.394808690995Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M455.93216494936496,575.5470328871161L460.10616137832403,564.1515404377133L467.61793495714664,566.9223782084882L463.2530280863866,578.8277076175436L461.6579003650695,583.1863307934254L460.1984610548243,583.8949059429578L457.3916042596102,582.853373282589L456.8322840053588,581.5205025873147L458.64593318104744,576.5604733279906Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M417.54338886775076,524.1402282179333L422.24909453839064,511.15060083800927L424.3112428402528,511.9018439692445L425.4377722106874,508.7969826320186L426.9477002322674,508.3225130867213L427.3019100986421,507.33091324334964L429.5699576763436,508.1529110223055L429.2078589498997,509.1445107469335L430.3351772064343,510.89463709294796L424.6086529046297,526.7196298623458Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.9277065815404,442.38861851394176L581.7137447437271,437.4555430645123L600.3874679505825,444.2448940454051L598.1620202222839,450.42449829913676L586.2774509144947,446.10116907954216L581.9543550089002,444.5279135899618L582.4150644987822,443.2813788931817Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M482.8118815124035,437.8384522302076L485.3773391554132,430.9148685336113L492.9956123586744,433.771081764251L502.3920348631218,437.28593926876783L501.0816950276494,440.8007949911989L499.29565686546266,440.1348662744276L498.0342279691249,443.52902102749795L497.7368179038167,443.4228886854835Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M547.2441548770294,443.79851393029094L549.2637033285573,438.19951058458537L569.1562555814162,445.43524087173864L567.1438071038574,451.034238376189Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M432.566936022602,465.19351164251566L433.55935475509614,462.571426180657L434.94858320150524,461.64225042052567L435.6357030067593,459.84216712601483L440.3059088019654,461.6360073592514L451.55226924363524,465.9655699483119L449.01521150022745,472.6341939875856L433.2690446646884,466.5888352850452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.3511213315651,564.8320241677575L534.1194565976039,548.5399350901134L534.1691564228386,548.3911439632066L540.9583103200421,550.8144620251842L535.1473752036691,567.2553364853375Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M551.2122520310804,432.8210918470286L553.2041894691065,427.30011830246076L559.6028447393328,429.6183866607025L570.580195017159,433.6150045674294L573.0888528591022,434.5285763689317L571.1048042820767,440.0568277509883Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M463.2530280863866,578.8277076175436L467.61793495714664,566.9223782084882L474.44968870375305,569.4528607032262L468.1425442220643,586.6522094290704L466.8030155999586,587.3389339018613L464.31565768271685,586.4180987998843L463.6782377026975,584.6742344736122L465.5202867798507,579.6569803683087Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M476.5544368568808,584.0364128667861L481.0116434004158,571.8761714049615L487.70849762205034,574.342141492758L483.4777013929561,585.8791240709834L481.55045261699706,591.1731442846358L479.00629489775747,592.7463664924726L477.38355616107583,592.3280891962349L476.9867464462295,590.6841135011055L478.6449850592762,584.8094984279014Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.4777013929561,585.8791240709834L487.70849762205034,574.342141492758L494.5899511957541,576.8788642371073L492.9317125836387,581.4143723584712L490.23845539055765,588.7498403307982L488.58021677751094,593.3061504978687L486.66006797738373,594.4402852449566L484.2579097598791,593.5610707113519L483.71910054422915,591.6767419092357L485.5548385316506,586.6522094290704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M463.94724786747247,620.327640701551L470.28989222459495,603.014962203335L475.9091280149296,605.0844949502498L472.99656048230827,613.0359066291712L474.0741789136082,613.4323324384168L474.03867903817445,613.538462178316L470.64410208910704,622.8081603613682Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M612.3067482458428,464.1862979796715L614.6947065144777,457.52494938950986L632.7523096650839,464.0593557502143L631.532691732049,467.4607823570259L627.6639942284673,466.0581753202714L626.5082760713995,469.3108081165701Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.7865539556369,456.25656629540026L435.35959286708385,452.1465456490405L439.6116890218109,453.76974396780133L453.54420668073,459.1127690807916L454.08222701214254,459.3250332856551L451.55226924363524,465.9655699483119L440.3059088019654,461.6360073592514L441.2628276590258,459.1273362324573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M549.2637033285573,438.19951058458537L551.2122520310804,432.8210918470286L571.1048042820767,440.0568277509883L569.1562555814162,445.43524087173864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M521.2432574443519,562.30153998686L522.5614861408249,558.5672012413852L525.1048549721017,551.3950593560003L526.2463731803,548.1643155207857L530.3138699838892,549.6168498117477L531.0790895149112,547.4557367190719L534.1194565976039,548.5399350901134L528.3511213315651,564.8320241677575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M424.6086529046297,526.7196298623458L430.3351772064343,510.89463709294796L437.0320314280689,513.32629228523L431.3055071271956,529.1502390038222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M545.3232171898708,449.134263144806L547.2441548770294,443.79851393029094L567.1438071038574,451.034238376189L565.2086694659665,456.3699820204638Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M430.7532868459821,473.20127125503495L433.2690446646884,466.5888352850452L449.01521150022745,472.6341939875856L446.4923537084833,479.25286723673344L440.5678189927712,476.97103326488286L435.05508282687515,474.8598419302143Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.9508013725281,524.6792077445425L632.9148202035576,521.9499731431715L635.2183676576242,522.7719691907987L636.8411063943058,518.1948026218452L650.0644154371694,522.9207608709112L647.4784467555583,530.234440236818Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M467.60373500641435,479.13216833164915L470.06269302405417,472.35013508144766L483.22289117705077,477.27590214274824L485.0586291644722,477.95639440137893L482.54997132346034,484.7238550684415Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.7576581658795,517.4498031856492L637.1243165088817,510.74584515579045L652.44606261421,516.2105651185848L650.0644154371694,522.9207608709112L636.8411063943058,518.1948026218452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M622.4052793933079,437.4701102618128L624.7869265703484,430.7442240631208L638.2934457296506,435.57117182714865L640.0013841660693,436.17987269582227L637.6205258741975,442.9057536171749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.2148864725605,514.1264388007112L559.4190342752263,507.99683550558984L563.7137302793562,509.5700765871443L575.293000661768,513.7861944553442L572.9973420696333,520.1436625029892L559.6951444149017,515.3032470983453L559.7874440904707,515.0410404908471Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M462.700018921867,492.327875867486L464.8189670238644,486.63006358454004L480.96194357518107,492.675404808484L478.56688533257693,499.1317401751876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M627.3231954276562,424.06203301856294L629.7119425805286,417.32989070843905L630.066152445972,417.45683379191905L643.0630511743948,422.1058625113219L646.2943286970258,423.2473088777624L645.2884989026934,426.0671072136611L642.0635324679315,424.9267018274404L640.6821928825229,428.8244734816253Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M459.6028520371765,402.603436680045L462.2464094059542,395.1345851109363L475.3569077346474,399.81796594988555L472.713350366801,407.2805693615228L462.7071188976988,403.71575172431767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M559.3480345252901,504.1979562509805L560.5739635461941,500.8111147368327L567.9161266097799,503.47584640048444L577.7235587788746,507.03957223519683L575.293000661768,513.7861944553442L563.7137302793562,509.5700765871443L564.9183593755588,506.23214137461036Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M588.4957986669615,633.9413542766124L590.6005468191579,628.2290915953927L596.3049823092297,612.7164768925868L601.4926973963156,614.6372170378454L595.794572994113,630.1352606466971L593.3569149002433,629.2289980249479L591.2521667499095,634.9620695733465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M474.478088603355,459.1054855068214L476.9583465466276,452.4368484527804L477.33385633770376,452.5721149877645L489.21132566966116,457.01509895315394L492.9530125083402,458.4177078199573L491.43677339702845,462.5069145420566L487.15627734269947,460.91285256529227L486.1993584856391,463.48499416420236Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M448.90240078698844,577.9068713854067L450.48253967333585,573.6127554932609L449.5895205922425,573.2787570287473L453.7848169468343,561.8270741002634L460.10616137832403,564.1515404377133L455.93216494936496,575.5470328871161L454.3307261383161,579.9191845296882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M591.8903756141663,407.19524683617055L593.6898248419166,402.2496601077728L612.9449571128935,409.3147829240188L611.1447190009058,414.26140512758866Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M439.6116890218109,453.76974396780133L442.09904693998396,447.2634217492305L442.3183572795242,447.3487437805161L456.01736464817077,452.6137354616076L453.54420668073,459.1127690807916Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M566.2578879976645,494.9718006872572L568.6032464141026,488.48736777482554L569.1704555302858,488.6996310800314L582.5854639001191,493.5754422498867L580.2464165724814,500.05987040372565Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M624.7869265703484,430.7442240631208L627.1748848389834,424.01208824664354L627.3231954276562,424.06203301856294L640.6821928825229,428.8244734816253L638.2934457296506,435.57117182714865Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.1704555302858,488.6996310800314L571.5939136734232,481.9748350959271L585.0089220432565,486.8568940376863L582.5854639001191,493.5754422498867Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M610.0323895802721,470.52924438612536L612.3067482458428,464.1862979796715L626.5082760713995,469.3108081165701L624.2268174309283,475.65999288577586L622.6884895069525,475.1074829399586L610.8615088853985,470.83411354618147Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M564.2659505605698,499.6343039800413L565.980988971889,494.864628626965L566.2578879976645,494.9718006872572L580.2464165724814,500.05987040372565L577.7235587788746,507.03957223519683L567.9161266097799,503.47584640048444L568.716846014373,501.2574911778793Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.09019549097866,441.1337593230419L446.29434329271317,434.91148569621146L460.6449705949053,440.0349769615568L458.44082279130816,446.257245992776L444.61480475682765,441.325213809032Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M571.5939136734232,481.9748350959271L573.9818719392642,475.3478403771296L577.0719388490543,476.47471086354926L587.4039802849293,480.23094449564815L585.0089220432565,486.8568940376863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M580.1052059577778,457.81629248149693L582.422164474614,451.388012457639L584.1514028366655,452.01856268709525L596.0217721946537,456.3346046390943L593.7040247917175,462.75559650175273L582.422164474614,458.6591063486412Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.7580960672349,624.2044927640818L585.4696315331385,608.6981119872071L591.018656459637,610.7468332769349L585.3134320825338,626.2594523867592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M442.3183572795242,447.3487437805161L444.61480475682765,441.325213809032L458.44082279130816,446.257245992776L456.01736464817077,452.6137354616076Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.066152445972,417.45683379191905L632.4115108624101,410.80272392369807L645.4226095415652,415.4590407270007L643.0630511743948,422.1058625113219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M480.68583343550563,443.52902102749795L482.8118815124035,437.8384522302076L497.7368179038167,443.4228886854835L495.62496977765113,449.11345289926976L492.56330276839435,447.9720107889734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M470.06269302405417,472.35013508144766L472.4656401267275,465.8802481452003L477.50425573810935,467.7656516530551L484.859829865396,470.521960823331L485.6179494205862,470.7987362416461L483.22289117705077,477.27590214274824Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.3923858478665,521.7023338107392L559.6951444149017,515.3032470983453L572.9973420696333,520.1436625029892L570.693794616498,526.542744745966Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M585.3134320825338,626.2594523867592L591.018656459637,610.7468332769349L596.3049823092297,612.7164768925868L590.6005468191579,628.2290915953927Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M427.2593102483079,492.7888199384324L428.2872288543731,490.0741398683749L430.2925773561001,490.8399523659609L441.2486277082935,495.0560816270299L438.6831700652838,501.8099990426563L427.83361933846027,497.642777627334L429.37825835030526,493.59625236224383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M603.7599560869858,490.9107067803852L606.1203033411875,484.3274219012819L606.857122970745,484.5896296668798L617.8628731481731,488.5716487937607L618.2951827384531,488.7204412063584L615.9285243963823,495.30476241884753L614.83670601435,494.907289349474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M454.06802706234157,423.2046477147378L456.63348470441997,416.30185974622145L456.81808405555785,416.3590881964192L458.43372281547636,416.9469804079272L463.9330479176715,418.90315237175673L464.98147756326944,419.27149532875046L468.0999443717301,420.39109131274745L465.6338863801211,427.3365363474004Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.4869616823271,477.4527885178104L610.8615088853985,470.83411354618147L622.6884895069525,475.1074829399586L620.3147311909124,481.72615382494405L609.3089810134843,477.7503738165833Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M425.1435176897794,568.9960837080143L434.58017338626087,542.6860942719504L452.01297873444855,492.12289621541277L486.70582337118685,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M533.0497270273045,483.1506083444692L535.0195756535977,477.6796192713082L549.2211034782231,482.83845617296174L547.2441548770294,488.30944117484614L538.569563168101,485.16294899815693Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M424.4248424395919,499.0391352456063L425.3249614974484,496.6865534354001L427.83361933846027,497.642777627334L438.6831700652838,501.8099990426563L436.27391187287867,508.1310604503378L425.2113618962467,503.90037208702415L426.7205010326579,499.9246047944762Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M430.2925773561001,490.8399523659609L432.8580349991098,484.1005913615227L443.8211853252724,488.30944117484614L441.2486277082935,495.0560816270299Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M606.857122970745,484.5896296668798L609.3089810134843,477.7503738165833L620.3147311909124,481.72615382494405L617.8628731481731,488.5716487937607Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M577.284149213694,470.0121113420464L579.4456971660256,464.0094112660736L580.3742161225528,464.3423744854517L591.6560764396563,468.44614484440535L589.4945284873247,474.44155751820654L579.2618867019191,470.72798162233084Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M584.1514028366655,452.01856268709525L586.2774509144947,446.10116907954216L598.1620202222839,450.42449829913676L596.0217721946537,456.3346046390943Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M447.1021626750007,430.4466367443092L448.6539016617462,426.08167443517596L464.1310583325103,431.60264894971624L462.5864193206653,435.97489138366655Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M445.6135345771909,434.677369939629L447.1021626750007,430.4466367443092L462.5864193206653,435.97489138366655L462.79941857233644,436.0602135551162L461.3036905005574,440.2690925360657L460.6449705949053,440.0349769615568L446.29434329271317,434.91148569621146Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M448.6539016617462,426.08167443517596L450.16382968239486,421.8155584339984L454.06802706234157,423.2046477147378L465.6338863801211,427.3365363474004L464.1310583325103,431.60264894971624Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.40357144363225,410.23564155446365L462.7071188976988,403.71575172431767L472.713350366801,407.2805693615228L470.4105917988345,413.80045583844185L467.35602476634085,412.70895276684314L465.9099965188652,412.191815410275L460.8003811594099,410.3709089127369Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M580.3742161225528,464.3423744854517L582.422164474614,458.6591063486412L593.7040247917175,462.75559650175273L591.6560764396563,468.44614484440535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M577.0719388490543,476.47471086354926L579.2618867019191,470.72798162233084L589.4945284873247,474.44155751820654L589.9197381027043,474.5976337934844L587.7305791368708,480.3516433816403L587.4039802849293,480.23094449564815Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M508.45146910473704,530.3270447505638L509.1109778974205,528.4416582584381L511.3569366633892,522.1060483516194L518.6493999017403,525.5220134854317L515.9987425580621,533.0125750643201Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.93529514875263,448.25607069348916L480.68583343550563,443.52902102749795L492.56330276839435,447.9720107889734L490.81276448164135,452.68553077382967Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M477.33385633770376,452.5721149877645L478.93529514875263,448.25607069348916L490.81276448164135,452.68553077382967L489.21132566966116,457.01509895315394Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.0235598934814,537.9944859640673L532.5890175364912,531.3259248025715L539.285871759057,534.2320406353101L536.8269137414172,540.6311098742299Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M536.8269137414172,540.6311098742299L539.285871759057,534.2320406353101L546.0111258812249,537.1652082293294L543.6578786028549,543.2739757699892Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.3937211818993,496.4597233007662L530.7958793994039,489.585101950448L536.273904575035,491.56934707425535L533.8220465322956,498.40858929231763L529.0595410624519,496.67926989821717Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.7958793994039,489.585101950448L533.0497270273045,483.1506083444692L538.569563168101,485.16294899815693L536.273904575035,491.56934707425535Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M512.9386533219367,415.4444734826684m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M618.0537835871801,570.731628025882m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.2639855761081,413.6090005948208m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.20518469810486,411.940010082908m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M474.0757566858083,528.3604992264882m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M598.10522042308,537.5231399093755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M630.5883950535208,450.24032765068114m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.22211675625294,589.7487119650468m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M452.92335331067443,606.0729593425058m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M444.10991764348,564.2576709324494m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M554.7133286045864,457.61339282942936m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M550.1354224849492,480.9364086454734m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M551.6784837245941,465.3662362829782m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M548.3209844222292,471.90791881550103m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M516.625118133612,594.7337035587989m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.9608181687072,599.4533666898496m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M633.8725279457867,527.7049839263782m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M506.71591965388507,547.4588582129218m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M462.2132761888206,414.324876699131m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M474.2832337329164,485.90066835749894m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M531.3559885406867,598.2276696511544m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M523.8205483788624,595.0385672580451m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M604.2640543142334,403.1778033101m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M486.42734657321125,465.49421899812296m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M475.05713101197034,577.9568150490522m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.7746555097401,571.2341866418719m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M590.6494577582926,443.7631364846602m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M490.6810205001384,435.52851073862985m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M558.2002052292228,444.6173977055587m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M442.2733907708898,466.27772287651896m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.6566880410537,557.8232466396876m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M468.85096395295113,574.1402857452631m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M482.1310727968812,579.1897991211154m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M488.2047069882974,583.6472688200884m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.26416657399386,609.0602019308135m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M618.6233593616635,460.79215334169567m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.663408103399,457.6851880904287m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M560.1842538062483,439.12868948606774m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M527.835978699848,554.981651475653m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M430.8203421663493,520.022964307107m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M556.2327232602984,450.08425082685426m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M439.88385473098606,472.91721237264574m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M641.0080028474331,523.7999843629077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M476.3288154285401,478.5442813918926m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M631.2037262227386,436.82499150792137m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M566.2539435671642,513.9568368843757m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M636.2470751488581,422.67606545984745m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M467.47987988591194,401.21122171450406m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M570.7190389716998,508.3048245268874m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M483.03829182777554,457.7164034228772m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M454.8482354283333,568.7151502356865m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M602.4172719204798,408.25553522026166m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.8145268354565,453.1922599929385m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M574.4220703924075,494.27362150279805m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M632.7349541699514,429.78486909670755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M577.0892943432555,487.7787828729488m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M618.2699383823201,469.9195060231723m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.5527178943157,500.658160564024m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M452.36718859989196,440.5843681646511m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M579.4985525356606,481.1028898493387m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M588.0634890757501,457.07544859778136m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.3799844775349,446.8035151655786m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M637.7435921076685,416.4579373309389m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M489.21132566966116,443.4759548585862m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M477.84111010842025,471.57495595887303m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M565.1944695170969,520.9229982006364m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M434.54230685252696,496.3494297475554m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M611.0271749701351,489.8160943314433m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.0954245654866,421.79786965670064m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M615.5877255955711,476.2801358276047m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.0578076373786,496.38480692589656m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M541.1350208101794,482.9945322619751m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M431.94608265161514,502.85570589406416m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M437.05648689810187,489.5746968877502m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M613.5863215234131,483.15789189422503m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M584.4701128276065,469.2286078836769m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M591.1559226438403,451.22153053758666m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M454.4403813071549,435.4431885611266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M457.1454717926681,426.709105420392m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M466.55846090521663,408.75810561468825m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M587.0395149011165,463.5484652845189m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M583.4958384754136,475.5361723918468m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M513.8805833421648,526.9818360265344m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M485.7489045159891,448.11456099990755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.07331040967256,452.6283026239835m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.6551102688536,536.1132635548711m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M541.4182309256867,538.8976390184835m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M532.322374029085,494.0145356184803m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.2796981437132,497.86232418660074L603.7599560869858,490.9107067803852L614.83670601435,494.907289349474L613.3346668528393,499.1026060404256L613.7598764691502,499.25868175923824L612.7745577124879,502.01601891219616L607.906341502443,500.25756628857926Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M858.4912823121995,503.9461542670615L849.568980361335,504.11991844605654L780.6511005526409,500.72579336026683L775.0665757507086,476.99912698287517L770.7718797465786,451.4161062799394L765.7119642104954,417.5702501521446L765.1699994513765,396.2874816409312L858.4912823121995,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M661.4906419124454,578.9702551369555m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M837.2986457431689,396.2874816409312L836.7424810342491,409.4916710322723L833.0213052332401,406.5927865328267L829.846827509813,404.4670064970851L826.6723497882485,402.9936314057559L823.4970831787214,402.27047049440444L820.3297054311261,402.3557930807583L816.0918092262,403.41816324414685L812.4913330022246,404.89257876295596L808.8064459627494,407.40126951783895L805.7589789042249,410.95151800708845L805.2241141190752,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M763.7989153843373,425.2877608514391L765.1597439311445,436.3359498330392L768.1575111644343,456.0651122238487L769.8938495023176,464.994774247054L774.2232564957812,484.74570571631193"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M774.2232564957812,484.74570571631193L775.8885950818658,492.6608377266675L780.1761911120266,511.2993927663192"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M766.3225620631129,421.653237872757L767.0514928335324,420.60335670458153L768.7239313935861,414.84929751977324L769.865449600853,405.20473444415256L769.7881387621164,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M763.7989153843373,425.2877608514391L766.3225620631129,421.653237872757"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,489.5986285316758L776.9267692090943,484.9007412502542"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M776.9267692090943,484.9007412502542L774.2232564957812,484.74570571631193"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M748.5623689778149,518.6619879826903L753.8565836884081,514.3251747880131L764.5925348158926,511.9018439692445L780.1761911120266,511.2993927663192"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M816.3750193407759,494.5961782145314L778.7853848934174,492.7992249955423"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M778.7853848934174,492.7992249955423L775.8885950818658,492.6608377266675"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M704.6111569069326,404.09137912048027L641.8174000009894,577.9693009625189"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M748.5623689778149,518.6619879826903L752.5880548171699,507.1883642501198L759.8371293209493,489.69851713068783L761.4677569177002,486.4531774437055L763.9054150097072,485.12757176253945L774.2232564957812,484.74570571631193"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M767.005737438798,426.22110354714096L770.375070030801,428.75371843390167L774.8117655357346,435.81153063708916L777.4340229807422,444.187665828038L787.8244419870898,501.07956490898505"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M679.942688120529,396.2874816409312L758.2569904346019,422.59490518970415L765.6133534470573,425.17434461647645L767.005737438798,426.22110354714096M787.8244419870898,501.07956490898505L808.2589589999989,612.9620320000686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M763.7989153843373,425.2877608514391L704.6111569069326,404.09137912048027L682.1468359222636,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M716.1517718695104,612.9620320000686L748.5623689778149,518.6619879826903"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M757.27719388064,396.2874816409312L757.5059708524495,403.87182959215716L758.5828003985807,414.88467511348426L759.8797291694209,420.1288811196573L763.7989153843373,425.2877608514391"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M780.1761911120266,511.2993927663192L858.4912823121995,516.3416684004478"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M780.1761911120266,511.2993927663192L792.0039606196806,562.2526367087848"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,496.87904688948765L816.3750193407759,494.5961782145314"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M791.6134619927034,501.2658152151853L780.6795004522428,443.15339576778933L778.1992425108328,434.061385337729L772.9547276236117,426.2804129454307L767.4554025242105,422.3118847492151L766.3620063690469,421.91648852825165"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M766.3620063690469,421.91648852825165L759.568119155243,419.46295041637495L690.5618841014802,396.2874816409312M812.630176958628,612.9620320000686L791.6134619927034,501.2658152151853"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M792.0039606196806,562.2526367087848L803.7883413909003,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M651.8149537239224,368.87075936980546L653.48739228677,364.25082965102047L654.5650107171386,363.79716071113944L654.0404014512897,362.7129334448837L655.762539839372,357.95773124089465L656.7612696588039,357.5956281805411L656.3573599690571,356.31369996163994L657.9524876913056,351.91955621307716L659.0293172374368,351.3597527141683L658.6041076211259,350.1121607394889L660.1700465586036,345.803336342331L661.1127654640004,345.14468219550326L660.836655324325,343.9616018421948L662.3954942850396,339.6663004993461L663.4731127182022,339.0284563465975L663.0479031018913,337.87346923397854L664.6138420375064,333.5157323339954L665.7119715092704,332.7779967589304L665.2867618929595,331.6875214627944L666.839289765805,327.3994962265715L667.9516191873699,326.8115964154713L667.6684090718627,325.65660726698115L668.1425296254456,324.3028764971532L670.0918672140688,323.26754801813513L671.4668957106769,323.76388138951734L672.3031149916351,324.8907765187323L673.1464342474937,324.3882000427693L678.0643502827734,326.18727798294276L678.383060272783,327.05195899959654L679.2760793538764,326.6347061987035L684.2436952134594,328.45563469361514L684.5766051551327,329.39107148721814L685.5619239108637,328.9446839801967L690.2392296809703,330.6667615082115L690.8340498106554,331.701048349496L691.465158700943,331.1131489062682L696.5889740129933,332.9985890700482L696.8366842521355,333.8060401091352L697.850402909331,333.45121949678287L702.6121194930747,335.2024307306856L703.0026181200519,336.3147565876134L704.0936476150528,335.7549518281594L708.7567534353584,337.4551765555516L709.1819630516693,338.49050291255116L708.2747440198436,341.0980679113418L708.7709533860907,342.45179540105164L710.2871924974024,342.98350535612553L711.88863130752,342.45179540105164L712.7816503886133,339.8931357623078L713.7243692949414,339.2771427365951L718.1681647757068,340.91389435436577L718.7061851052567,342.0189356007613L720.038613752462,341.6016837032512L724.290709907189,343.16039515752345L724.9068299634382,344.3372324774973L721.5619528386742,353.939218651969L721.5619528386742,353.9537860243581L721.5974527141079,354.0245418329723L721.9800624800846,354.67591145122424L722.2072616806254,355.0869194041006L723.6106900777668,355.5832504965365L724.6804196480662,355.02344729052857L725.1553290886804,356.2991325943731L728.1530963210389,357.3552666576579L728.6138058118522,357.093054078985L729.8965346338227,356.3626046925783L730.4984547384083,357.7662744522095L731.2920741690323,359.62985632615164L729.7758350577205,360.47268213378266L726.2889584349468,370.4939771881327L728.2382960226387,374.7382737817243L729.4074252434075,377.2823532316834L730.7682537902147,376.53109551314265L741.9649144066498,380.45074535533786L744.1051624342799,386.28287222329527L740.0092657292262,398.08237884007394L738.6768370829523,398.692123521585L736.8055992200971,399.5557549749501L734.5596404531971,400.6045988118276L722.8872815100476,396.5091124526225L720.2090131537989,390.55629373760894L723.1144807115197,382.2009041933343L720.8464331338182,381.4069855841808L719.8611143771559,382.0666768066585L717.430556259118,389.04649744415656L715.8575173486024,389.60629790090024L711.5344214430079,388.0611236668192L710.8686015624553,386.93527933117L709.7980831060559,387.4378512725234L705.4544761618599,385.8864334258251L704.8233672715724,384.79492595931515L701.5707898223773,383.6461896048859L700.3945606276393,384.07176314946264L696.2631640471518,382.583816410508L695.6391551317647,381.3580810269341L694.3848262093961,381.9178821039386L690.0688302805647,380.3727061566897L689.4811101248488,378.97632463788614L688.0989816533402,379.6713938647881L683.8823853740469,378.1543115377426L683.4145759083331,376.75168643007055L681.9267366966233,377.45299901859835L677.6888404916972,375.9359162063338L677.1855311524123,374.40530625823885L665.8610709849745,370.4939771881327L664.5712421890348,370.98302350891754L663.9401332968846,372.78312987834215L664.5712421890348,374.13581065740436L663.5362236071378,374.6394240502268L658.9583174865693,373.030774531886L658.3705973308533,371.93926504347473L657.3781786002219,372.37836611736566L652.658272979781,370.72809511236846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M718.8836844824255,631.496215088293L721.9453514898196,623.3606585380621L720.7541334582493,622.9142899573781L729.8397348336875,598.7271048026159L730.6830540886149,599.0538186137564L733.7794320872054,590.8329037209041L746.6848200270906,595.723209920805L748.0101486975327,595.4037793865427L781.5725195333362,587.275463914033L792.5356698604301,634.8975595384836L780.8775108670816,637.6048995051533L775.4420855417848,635.5426598568447L768.9653305457905,652.7845043600537L760.950247627683,649.7442160234787L760.439838311635,651.0697902278043L728.5712059624493,638.9866621559486L728.9183158520609,638.0585505268537L721.2148429481313,635.1389519213699L722.1220619790256,632.7219062452205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M702.6831192439422,443.98996834270656L703.6329381251708,441.3678748616949L704.6466567823663,440.91421097004786L708.6076539605856,442.36676773196086L709.0044636754319,441.2471752958372L708.210844244808,439.88618350587785L709.8903827806935,435.28711140248924L711.1163118034601,434.79806961864233L710.5427915984765,433.4870212660171L712.1655303342268,429.05858943331987L713.3062596553937,428.5123188639991L712.7319505652413,427.4915731679648L714.4185890760273,422.86439890647307L715.8788172733039,422.2411296381615L722.8304817099124,424.798718362581L723.3408910259604,425.9890685309656L724.9281298872083,425.62072593020275L727.0541779650375,426.40007225517184L731.2076633553952,424.28158190567046L731.611573045142,424.42309208773077L733.8078319868073,425.2242893832736L735.8281693244353,429.3270423831418L737.8619177266955,430.07829438336194L738.6413372075185,431.48923282139003L740.2498759953305,430.6880362499505L747.0603298163041,433.1894340645522L747.6622499227524,434.7772593302652L746.0324112102389,439.2556321728043L744.8774819392711,439.86537322960794L745.4091911800206,440.97039870126173L743.7651525186375,445.44252446386963L742.6804341124371,446.08035882376134L743.1837434526533,447.24261149717495L741.5894046155736,451.60131741082296L740.4833862837404,452.11116824578494L736.8694989960641,450.79283957835287L735.417159659788,454.76863505132496L738.3297271924093,455.83828076021746L738.8819474736229,456.8236449030228L738.2942273169756,458.45412570098415L737.1811090102419,458.82246655691415L734.7434509182349,457.9297081818804L733.7581321615726,460.6433603274636L738.9387472728267,471.6561156557873L749.0656783189625,475.546577478759L750.9724160553887,474.6819149814546L752.5170550681651,478.10518704215065L750.8162166057155,478.8845274662599L749.1153781432658,483.2785907308571L749.6541873598471,484.5750625692308L748.4629693282768,485.14942240715027L747.9817487979308,486.3959495755844L748.3643585639074,487.5092916795984L747.3151400322095,488.1325550796464L746.8118306910619,489.4363095546141L747.3151400322095,490.5423676301725L746.2951102862135,491.12297000875697L745.7705010194331,492.48395174369216L746.2525104358792,493.63162955641747L745.0620812894776,494.37559104757383L743.9134631073102,497.3316666157916L743.9560629585758,498.48662716010585L743.5663532176986,499.54273956269026L747.704849771224,505.68691738834605L738.9529472226277,529.6746511375532L737.8193178772926,530.0367452055216L738.364438181743,531.3051148029044L737.8974176021293,532.5870106634684L736.6217887559906,532.96263107704L737.2805086607113,534.2528506265953L733.5033219484612,544.634947264567L732.4619922759011,544.1885736174881L727.267177214846,542.3531348151155L715.489107533358,537.9518255046569L707.5166244646534,535.1455991747789L706.8642156487331,534.8407328417525L709.1322632264346,528.6185433273204L706.1628958927467,527.5270583359525L710.6059024874121,515.3313406636007L707.8566343784332,514.3251747880131L720.1025135274976,480.7699274374172L719.6347040617839,480.5992841948755L729.400325268507,453.81136443139985L715.9356170743704,448.8585273763165Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M743.8353633834049,585.305813072715L745.5085908314213,584.9010617206804L744.3528726734221,580.0544485789724L750.220607588999,578.6362569313496L748.867667905055,572.988459284883L756.3652415312827,571.1884049051441L751.8433463266119,552.2389023452997L750.4194068908691,552.5864282823168L748.9591786935925,546.4849524307065L750.6742171049118,546.0729153263383L749.8876976501197,542.7714151288383L754.9689131099731,541.5446675699204L755.7483325917274,544.7910219598562L757.5698706284165,544.3508913097903L755.3728228006512,535.1455991747789L758.1299797696993,534.4796795235015L757.9666803432629,533.7846258189529L757.8743806676939,533.3736284589395L758.370590033941,532.849216605071L759.4971194053069,531.9429412609898L760.1140283467248,531.5673207924701L760.7585483016446,531.240603803657L762.1335767982528,530.7869457914494L762.8419965282083,530.6381542813033L764.2880247747526,530.5611572754569L765.7119642104954,530.7307587862015L766.4140728525817,530.9076437973417L767.0940926829353,531.1625663032755L767.2431921586394,531.7868662769906L767.3709917087108,532.2831847183406L768.6182206552476,531.9856017571874L769.1633409606293,531.8576202699915L782.3235391145572,587.0840134625323L781.5725195333362,587.275463914033L748.0101486975327,595.4037793865427L747.0461298674345,591.3500277525745L746.4150209752843,588.7071801838465L748.754068302922,588.1473958068527L748.4495582636446,586.879036612343L744.445172348991,587.8498152471147Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M643.870870555751,606.1614008871838L654.5082109170035,578.5727868652903L666.6120905643329,583.7180222859606L685.4483243105933,591.6621750355698L684.2436952134594,595.0781058939174L679.0212691398337,592.8743468555622L675.6692920401692,600.8320154766552L670.8996865944937,612.2139212843031L662.8704037256539,609.5273811654188L661.5308751044795,612.7237603059039Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M695.5823553316295,594.113571216818L697.0354835540056,590.2304593771696L695.8166545070708,589.769521788694L697.8859027847648,584.3277506381273L697.0354835540056,583.9583759605885L704.7665674705058,562.4794646869414L706.446106008254,563.2369452272542L708.9902637256309,557.5256647784263L717.1899459948763,561.3952684937976L725.3675394533202,564.2930477624759L711.491821593605,600.1380089139566Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.2454466866329,622.4044516850263L683.0035662427545,620.3703006543219L687.0008521825075,609.7406812519766L688.1486814785749,610.1724838479422L692.6839877488092,598.0830415505916L691.3870589761063,597.594011249952L692.485977333039,594.6525453040376L714.0004794364795,602.7881355490535L703.611638199538,630.4754992844537Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M699.295642268844,553.6352489651181L701.5849897721782,547.1508709280752L703.0941289085895,547.6825651824474L707.5166244646534,535.1455991747789L715.489107533358,537.9518255046569L713.6533695459366,543.1605614689179L717.430556259118,544.4861560515128L718.0190653000027,542.8276020349003L720.627122794278,543.7494834270328L720.9245328577235,542.8983559147455L721.505941924639,543.1043745656498L721.08783228416,544.2947044163011L723.1925804372877,545.0386604699306L724.4887203220278,541.3750663213432L727.267177214846,542.3531348151155L732.4619922759011,544.1885736174881L725.3675394533202,564.2930477624759L717.1899459948763,561.3952684937976L719.3443939723074,555.279233448673L716.4949373286217,554.2730733714998L715.8859172482044,556.0086213732138L711.0737119531259,554.3157337275334L711.4563217181712,553.2523461962119L707.7714346796274,551.9621301810257L706.3048953926191,556.1012255419046L699.6648409711197,553.7195291914977Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M615.5664256708696,455.76752599095926L616.5730443522334,452.97583355521783L616.7931435778737,453.0611555175856L622.3413796173409,437.6688484433107L626.7283752989024,439.26291576819494L626.1398662561551,440.8996437797323L644.3528799712658,447.5048206662759L638.2792457789183,464.3496580547653L617.9480728488415,456.9724379987456L618.0545724732801,456.6675682272762Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M680.7079076506197,504.21980683505535L687.9924820270389,484.2629104643129L697.0070836534724,487.58732967218384L695.5042556058615,491.7181394235231L703.3781279101968,494.60970478737727L704.8801670717075,490.4788967561908L709.9258826561272,492.327875867486L702.6476193685085,512.2774655036628L697.7297033332288,510.46282831626013L699.1331317303702,506.61504674097523L695.0230350764468,505.10527572548017L691.3373591527343,503.75157999945804L689.9347196407616,507.60664668586105L682.1176471365616,504.729653801769Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.2051302939653,408.57705541560426L639.4349639359862,390.99539363291115L663.848622508347,399.71183293825015L661.8779849950224,405.2682060957886L659.4474268769845,404.40353483567014L658.4550081454217,407.21709772665054L659.1713167373091,407.4720247806981L656.3786598937586,415.33834071131423L649.3914955826476,412.8442200785503L651.3329443074763,407.379418625962L649.0230857664719,406.5511657851748L649.3275958066806,405.68649468244985L647.882356445305,405.16935680201277L645.160699352622,412.85774681018665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M676.4913113713264,520.1644725352526L682.1176471365616,504.729653801769L689.9347196407616,507.60664668586105L688.1131816031411,512.6166694210842L696.0714647220448,515.5436031450517L697.7297033332288,510.46282831626013L702.6476193685085,512.2774655036628L705.9009857028723,513.4750841688365L699.713751909323,530.4331757612526L692.025267843157,527.0317800543271L693.598306754604,522.7230656314641L686.0723332269117,519.9522101930343L684.6760048046708,523.7854173472151L682.5073568774387,522.8291967613623Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.2432646108791,492.2779315910302L643.7572709554806,479.5431689051911L650.5961246779189,481.9883616925217L650.8517237799242,481.2797761261463L653.1757822707295,482.1090605473146L654.15400105156,479.3309053215198L664.1105326972902,482.88840052159503L657.1517682857811,502.50401544896886L647.1447479296476,498.92572021717206L647.9312673844397,496.72193060815334L646.8686377890408,496.3317411602475L647.2867474295199,495.1486866082996Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M670.4389771046117,533.5442704032175L675.5201925644651,519.7389073427767L676.4913113713264,520.1644725352526L682.5073568774387,522.8291967613623L681.6072378214449,524.8633764153346L698.5091228140518,532.6796151432209L694.5268257111311,541.7506862580776L684.1513955378905,537.1724917213432L684.5134942652658,536.3504973817617L682.649356377311,535.5285029467195L682.3661462636665,536.1736125112511L677.9862505579367,534.2382836318575L677.0151317501441,536.4493448073044Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M663.1962136914954,553.1670254650526L665.72617145814,545.9886350068264L678.8579697133973,551.7925291871652L679.9205993087962,552.2597122839652L679.8645883947611,552.3876933925785L691.9045682679862,557.7171160476282L694.0022164443508,551.6364546497352L699.295642268844,553.6352489651181L699.6648409711197,553.7195291914977L695.2281454652548,565.8943694313057L684.9316039057449,561.7063766331412L685.8877338757738,559.5244573950768L677.2707308512181,555.7183229089715L675.9241022551432,558.7867458714172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M669.6027578227222,615.2958455784246L670.8996865944937,612.2139212843031L675.6692920401692,600.8320154766552L682.3519463129342,603.0503388373181L683.5707753589377,600.1234420584515L689.6436206642538,602.6955320062116L687.0008521825075,609.7406812519766L683.0035662427545,620.3703006543219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.4047980979085,503.2843936337158L624.9210372101516,499.05370231019333L643.1908507253975,505.5662189438008L654.6218105182052,509.64083080971614L655.344430198893,509.9030376179144L653.0195828201249,516.4155440591276L652.44606261421,516.2105651185848L637.1243165088817,510.74584515579045L638.7399552706629,506.21757432166487L637.3515157084912,505.72853754321113L636.9121061433107,506.9688179893419L636.1957975523546,506.706611066591L635.8415876869112,507.72006157180294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M660.6662559239194,560.0623936764896L663.1962136914954,553.1670254650526L675.9241022551432,558.7867458714172L674.577473658137,561.8478840072639L686.3697432912886,567.056602016557L684.7541045295075,570.7212230861187L679.5592894684523,568.4175688414834Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.4691284773871,406.20363252749667L670.296977603808,401.05826534330845L678.8508697375655,404.1132300202735L678.5747595988214,404.89257876295596L690.9121495354921,409.3074992969632L688.5525911683217,415.96889421949163L673.6631546523422,410.6466462123208L674.4709740336984,408.35750602558255Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M655.0959310727194,438.05800068285316L656.3573599690571,434.5077660768293L664.025332997553,437.2432781900279L679.0914800036699,442.63626068271697L676.724821661599,449.30490716267377L661.6302747558802,443.91192986024544L660.6165560986847,442.28144564153627L661.1837652148679,440.6665687393397L660.6094561237842,439.3482378991321L658.8597067221999,438.7239295989275L658.0368985049427,439.1068386947736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M622.4833791172132,525.968388337642L623.9499184042215,521.8303154855967L631.9508013725281,524.6792077445425L647.4784467555583,530.234440236818L645.1961992280558,536.640796661377L631.3914811173454,531.708828784991L632.1922005228698,529.4405385814607Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M635.3595782713965,500.0099261784926L637.0249168584123,495.31828898750246L647.1447479296476,498.92572021717206L657.1517682857811,502.50401544896886L654.6218105182052,509.64083080971614L643.1908507253975,505.5662189438008L644.0554699068889,503.12103447364643Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M692.9671978624538,470.59999900404364L695.3772449418902,464.0094112660736L703.0657290089875,466.8229499622248L701.768800237216,470.3950187098235L709.1251632506028,473.10138241853565L710.4220920223743,469.53035557316616L717.6861553601921,472.20862587960437L715.2761082816869,478.7992058224045L706.4887058576569,475.5684281522408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M667.9232192868367,540.3189602913335L670.4389771046117,533.5442704032175L677.0151317501441,536.4493448073044L689.4953100755811,541.9702314208262L687.3550620479509,546.8740985617042L679.9205993087962,543.5861252197064L679.1695797285065,545.2935824557208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M645.0257998257875,473.20127125503495L646.4505281485617,469.2109192246571L656.0954497782513,472.66228772467L666.4345911890268,476.35505241760984L664.1105326972902,482.88840052159503L654.15400105156,479.3309053215198L649.8593050474301,477.8003182015382L650.7665240783244,475.25627563893795Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.767888341099,566.8516245740466L660.6662559239194,560.0623936764896L679.5592894684523,568.4175688414834L677.9791505821049,572.0176785723306L673.9826535284519,570.2602841975167L673.7128544785082,569.1615223041736L672.4159257058054,568.5882099196315L670.6724873939529,572.5639378326014Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M658.5473078209907,450.8427841574885L661.077265589498,443.7131918547675L661.6302747558802,443.91192986024544L676.724821661599,449.30490716267377L674.209063843824,456.43345320643857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.8326710844412,418.25803189212456L666.4211801262572,416.5786373275332L668.0865187123418,416.1957269879058L675.5485924659297,418.86049117846414L686.1788328513503,422.65837668441236L683.7545858230442,429.49040328199044L672.2960150158033,425.393893470522L673.4083444373682,422.26193996472284L666.6262905150652,419.8385769594461Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.9508013725281,524.6792077445425L632.9148202035576,521.9499731431715L635.2183676576242,522.7719691907987L636.8411063943058,518.1948026218452L650.0644154371694,522.9207608709112L647.4784467555583,530.234440236818Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M656.223249329254,457.3761563063599L658.5473078209907,450.8427841574885L674.209063843824,456.43345320643857L671.885005351156,462.96786059532315L671.3958959607407,462.7909738509916L656.7825695844367,457.5748939202167Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M800.0403434634209,531.9491842617281L801.1952727343887,526.9745525205508L803.739430452697,522.9498949060217L808.2889366718009,520.4121119226329L812.959142467007,519.4059467879124L850.7168096574023,523.1694406638853L854.522396271117,524.8560929098167L857.7970625311136,528.0379440863617L858.4912823121995,531.0876503023319L858.4912823121995,550.5689047155902L856.8543436238542,609.8114344500937L856.0275909779593,612.9620320000686L818.3756345259026,612.9620320000686Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.72617145814,545.9886350068264L667.9232192868367,540.3189602913335L679.1695797285065,545.2935824557208L686.2561436910182,548.4192373915575L684.300495014526,552.8840103587136L679.3399791289121,550.6937643666752L678.8579697133973,551.7925291871652Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M666.3217804757878,430.77335848659277L668.6813388420269,424.1046941759996L672.2960150158033,425.393893470522L683.7545858230442,429.49040328199044L681.3879274809733,436.1590624116361Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M627.3231954276562,424.06203301856294L629.7119425805286,417.32989070843905L630.066152445972,417.45683379191905L643.0630511743948,422.1058625113219L646.2943286970258,423.2473088777624L645.2884989026934,426.0671072136611L642.0635324679315,424.9267018274404L640.6821928825229,428.8244734816253Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M664.025332997553,437.2432781900279L666.3217804757878,430.77335848659277L681.3879274809733,436.1590624116361L679.0914800036699,442.63626068271697Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M654.4159112423658,464.22271583089605L656.7825695844367,457.5748939202167L671.3958959607407,462.7909738509916L669.0213487586007,469.4377502501011L655.8690394638106,464.7471328768879Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M690.4514400446787,477.5027329013683L692.9671978624538,470.59999900404364L706.4887058576569,475.5684281522408L703.9729480408132,482.47740014642477Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M671.0203861696646,413.226090088021L671.693306026049,411.34795537311584L673.1535342233256,410.4624745072797L673.6631546523422,410.6466462123208L688.5525911683217,415.96889421949163L686.1788328513503,422.65837668441236L675.5485924659297,418.86049117846414L676.4984113471583,416.1957269879058L671.90551639162,414.55170951830223Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M655.1243309723213,573.5628117984161L657.767888341099,566.8516245740466L670.6724873939529,572.5639378326014L670.9848862951621,572.6981615303084L668.4691284773871,579.3666828926653L655.458029798232,573.8104492807761Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M687.9924820270389,484.2629104643129L690.4514400446787,477.5027329013683L703.9729480408132,482.47740014642477L701.5068900482729,489.2386133633554L697.0070836534724,487.58732967218384Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M697.878802808933,457.15660846512765L700.2099612765014,450.7501785857603L713.4624591069296,455.6187328696251L714.277378462255,458.0566505212337L713.2920597046614,460.75677597988397L711.8957312833518,461.5007410007529L711.2583113024011,461.2666261433624L710.996401113458,461.97625426435843L708.6999536361545,461.1324002877809Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M700.2099612765014,450.7501785857603L702.6831192439422,443.98996834270656L715.9356170743704,448.8585273763165L713.4624591069296,455.6187328696251Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.066152445972,417.45683379191905L632.4115108624101,410.80272392369807L645.4226095415652,415.4590407270007L643.0630511743948,422.1058625113219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M654.8198209321126,467.70218057138845L655.8690394638106,464.7471328768879L669.0213487586007,469.4377502501011L669.6879575233907,469.68643196159974L667.2218995308504,476.6380706522614L666.4345911890268,476.35505241760984L656.0954497782513,472.66228772467L657.5059781512246,468.6656923284754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M731.611573045142,424.42309208773077L739.0168469985947,404.8426338532008L736.8055992200971,399.5557549749501L738.6768370829523,398.692123521585L740.7105854852125,403.55343073559925L745.7847009701654,400.75339311361313L746.9041303666309,401.1508715832606L747.4997393833473,402.13624349655584L747.3009400814772,403.3265975569375L741.5823046416044,406.0267443363555L733.8078319868073,425.2242893832736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M695.3772449418902,464.0094112660736L697.878802808933,457.15660846512765L708.6999536361545,461.1324002877809L706.2054957440123,467.97791558969766L703.0657290089875,466.8229499622248Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M659.1713167373091,412.91497528832406L661.8779849950224,405.2682060957886L663.848622508347,399.71183293825015L663.9685331974179,399.37886661477387L669.4394583981484,401.3350435323082L664.6422419380397,414.8701078686863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M653.5938919112086,578.1617921618745L655.458029798232,573.8104492807761L668.4691284773871,579.3666828926653L666.6120905643329,583.7180222859606L654.5082109170035,578.5727868652903Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M847.2023220192641,451.6783152939752L847.3648325596005,446.4632675135508L856.493033785373,446.74628696776927L856.3297343589365,451.95509146200493Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M787.2911549750715,443.3021891564131L795.6817476842552,443.0899244607426L795.8095472343266,448.5037126527168L789.6018024031073,448.6597895123996L787.4260544991121,448.709734109696Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M734.1675640558824,483.9268266791478m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M765.2323214542121,561.8874228335917m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M661.9576624920592,597.9550612834282m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M711.0681897494942,574.1257188357413m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M694.9867463139817,499.1806438989006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M690.8569275084883,517.7484272713773m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M651.6761097684503,487.5831676456146m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M681.1268061781302,528.7714968812652m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M684.5900162179023,556.7171993027441m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M678.9763026293367,610.9767811363563m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M644.8948447322473,508.6804462559521m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.533603628166,564.4522435013205m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M668.3728843713179,441.4740072377026m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M646.2548843920231,501.2574911778793m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M699.8352403715253,471.4043124895543m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.0153054511175,538.3846730696969m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M657.7339662387967,475.8056640503928m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M663.7799894157797,563.457530203741m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M667.6368536269292,450.07384570594877m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M679.2374239340425,424.0266554695554m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M665.215762142092,456.9048047726974m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M643.6010715039447,516.8307044305839m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.9880020311102,547.2039363067597m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.0381831498817,430.1313606556505m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.7070246823132,436.7011703206226m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.9051147149876,463.5068448786624m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M698.4704673951492,476.5350603428669m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M682.011147512123,417.5275889514014m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M663.058158621192,573.1299664322287m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M695.982320590876,483.37015536241233m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M705.9388522356749,456.3876707102172m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M708.0727891745046,449.804353043437m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.8901258790866,471.1743600028567m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M702.0385992880911,462.571426180657m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M663.607223357074,409.0910714860074m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.7576581658795,517.4498031856492L637.1243165088817,510.74584515579045L652.44606261421,516.2105651185848L650.0644154371694,522.9207608709112L636.8411063943058,518.1948026218452Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M872.464033164084,396.2874816409312L870.1912522688508,434.7554085268639L867.6896944018081,503.7661470579915L858.4912823121995,503.9461542670615L858.4912823121995,396.2874816409312Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1045.2316699111834,417.4433070709929m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M966.3998583070934,535.0821287101135L963.9992778617889,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M987.0079302638769,500.9026791364886L976.1796794617549,500.28670041589066"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M957.9666657475755,520.2570771803148L957.5982559332624,529.7454051519744L954.6336219161749,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M968.7933387765661,612.9620320000686L970.6235545622185,530.3051942451857"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M869.9648419544101,497.50126894237474L870.8152611842379,490.30825375253335L875.632988682948,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M909.345247881487,499.14526673592627L869.9648419544101,497.50126894237474"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,516.3416684004478L866.7895753448829,516.8764865249395L943.1419178927317,519.9230761453509L946.6990053802729,520.0583413662389L957.9666657475755,520.2570771803148"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M981.5867048883811,521.0790734295733L991.231626519002,521.9218796077184L995.271512308158,522.1278988793492L1022.5338386381045,523.5096845487133"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M962.6439715167508,494.1206671865657L962.5098608788103,499.5989268189296"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M959.2848944440484,396.2874816409312L954.8844876997173,487.5092916795984L954.7353882249445,490.69844354270026L954.6430885493755,492.5547061371617L954.5791887743399,493.901120509021"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M970.6235545622185,530.3051942451857L968.3846957692876,530.1917797322385L964.9120190963149,530.0294617055915L961.7438524616882,529.8733866787516L957.5982559332624,529.7454051519744L948.8747532842681,529.2563700331375L946.1672961395234,529.1221454939805L946.2950956905261,526.9464590055868L946.6990053802729,520.0583413662389L947.2520145466551,510.67509094718844L947.677224162966,503.4113351451233L947.9391343519092,499.4782282677479L948.2444332791492,493.63162955641747L948.3856438929215,491.243668705225L949.0593526344746,487.8630639007315L951.2067006370053,487.30327137885615L954.8844876997173,487.5092916795984L962.9634703937918,487.9556689769961L968.6466059600934,488.2813475029543L970.7726540379226,488.4447070127353L973.3239117302,488.5435551190749L976.7468885788694,488.72772475052625L987.3345291158184,489.32289437018335L990.2328966977075,489.4789703101851L991.5511253951117,489.5642918259837L992.2240452496335,491.1656307564117L992.485955439508,493.5535916322842L992.3802447002381,495.8218935756013L992.1530455006287,501.1014155028388L991.7988356342539,509.10185011290014L991.4872256200761,516.302129315678L991.231626519002,521.9218796077184L990.9484164044261,528.391714238096L988.3190589863807,531.1490398021415L980.8356853080913,530.7942292909138"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M962.5098608788103,499.5989268189296L957.9666657475755,520.2570771803148"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M957.9666657475755,520.2570771803148L970.9288534875959,520.7034523715265L981.5867048883811,521.0790734295733"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,505.53916584467515L1054.5799703625962,504.86387881310657"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M981.5867048883811,521.0790734295733L976.1796794617549,500.28670041589066"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M861.866925993003,612.9620320000686L866.7895753448829,516.8764865249395L869.9648419544101,497.50126894237474"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1041.1862619183958,504.2125233076513L996.114831564948,501.3001518631354L992.1530455006287,501.1014155028388L987.0079302638769,500.9026791364886"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M867.9208380319178,497.3909754054621L858.4912823121995,496.87904688948765"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M869.9648419544101,497.50126894237474L867.9208380319178,497.3909754054621"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M967.8253755150363,396.2874816409312L966.7690570075065,416.2165373326279"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1022.5338386381045,523.5096845487133L1075.1651646215469,526.1962580042891"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M970.6235545622185,530.3051942451857L970.9288534875959,520.7034523715265L971.4242739668116,500.0525868711993L971.0771640762687,494.7865907168016"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M858.4912823121995,531.0876503023319L858.5409821365029,531.3051148029044L858.8596921265125,537.2359621678479L858.4912823121995,550.5689047155902Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M978.2891609324142,612.9620320000686L980.8356853080913,530.7942292909138L981.5867048883811,521.0790734295733"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M976.1796794617549,500.28670041589066L971.4242739668116,500.0525868711993L962.5098608788103,499.5989268189296"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M962.5098608788103,499.5989268189296L954.6004886990413,499.5281724957749L947.9391343519092,499.4782282677479L909.345247881487,499.14526673592627"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1054.5799703625962,504.86387881310657L1041.1862619183958,504.2125233076513"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M954.5791887743399,493.901120509021L954.6004886990413,499.5281724957749L957.9666657475755,520.2570771803148"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M976.1796794617549,500.28670041589066L976.4423785386607,494.94995007431135L976.5125894034281,493.5681587122381L976.5764891784638,492.2071771910414L976.7468885788694,488.72772475052625L981.2427505431697,396.2874816409312"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M974.8062287382782,396.2874816409312L970.7726540379226,488.4447070127353L970.8649537125602,491.88149885227904L971.0771640762687,494.7865907168016"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M970.6235545622185,530.3051942451857L980.8356853080913,530.7942292909138M980.8356853080913,530.7942292909138L978.5534377805889,530.6808147849515"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M981.5867048883811,521.0790734295733L987.0079302638769,500.9026791364886L987.1286298399791,495.59506341582164L987.1996295899153,492.5547061371617L987.3345291158184,489.32289437018335L991.0793714979663,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M868.1827482227236,490.15633985353634L858.4912823121995,489.5986285316758"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1075.1651646215469,499.678005178459L992.3802447002381,495.8218935756013L987.1286298399791,495.59506341582164L976.4423785386607,494.94995007431135L971.0771640762687,494.7865907168016L968.511706433259,494.4609124972485L962.6439715167508,494.1206671865657L954.5791887743399,493.901120509021L948.2444332791492,493.63162955641747L870.8152611842379,490.30825375253335L868.1827482227236,490.15633985353634"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M884.8534895842895,423.53761289361864L884.8747895099223,422.89249284379184L885.101988710463,421.63867064286023L885.2999991253018,421.0216443622485L885.5555982263759,420.44103611214086L886.2072181571275,419.334966853261L886.6040278710425,418.8386403257027L887.5254468526691,417.9531604181975L888.588076448068,417.23728468827903L888.8791754236445,410.73196869529784L885.3993987748399,410.568607354071L887.4047472774982,366.9291406329721L952.7229397473857,369.9414588599466L950.7388911712915,413.40401861444116L936.7921735607088,412.7588976211846L935.8423546804115,433.2674726676196L949.7109725642949,433.9125917502679L947.4713248871267,482.91025117458776L885.7110087899491,480.06134174671024L888.0216562179849,429.511213587597L887.0292374873534,428.71105730580166L886.596927896142,428.2428253670223L886.2001181812957,427.74753999430686L885.5484982505441,426.64147189911455L885.101988710463,425.44383823359385L884.9599892096594,424.8132855864242Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M875.4002672797069,621.4118276746012L876.9378063166514,583.1010104329325L878.0927355876192,583.1509540593252L880.1903837639838,531.0491518010385L901.5920751513913,529.5612366111018L914.6599736306816,530.0856487145647L944.9342671437189,531.9283742648549L943.616827333346,564.8819679254666L942.7238082522526,587.0278269159608L943.4109280575067,587.0559201897122L943.106418017298,594.5672250846401L942.071399435401,594.5256054657511L941.5333791067824,607.9052598066628L943.0283182924613,607.9614461874589L942.3624984119087,624.6716709802859L933.8583061015233,624.3241486595944L933.9222058774903,622.7446906990372L915.7730919383466,622.0142693086527L915.7304920880124,623.2753386716358L915.5884925872087,623.5947679192759L915.1490830220282,624.1472660326399L914.5542628914118,624.5228814845905L914.2134640906006,624.6290110577829L913.866354200989,624.6716709802859L913.1721344199032,624.5863511301577L912.8392244810238,624.452128438279L912.2791153388098,624.0338530517183L912.0598049992695,623.7581242402084L911.7758059985936,623.1057394207455L911.8042058981955,622.3264152104966L904.6750420862809,622.0350790349767L904.5401425594464,622.7374072936364L904.3847319958732,623.048512680456L903.9666223553941,623.5240148622543L903.2858136389405,623.8996303477325L902.5915938587859,624.0057599302381L901.9044740526006,623.8496870161034L901.5920751513913,623.6800877829082L901.1739655109122,623.317998603452L900.8907553972676,622.8997231489047L900.6856450075284,622.2338119288906L900.7282448578626,620.3130738893524L898.7079075183719,620.2287944713607L898.6511077182367,621.7947266818956L882.6493417816237,621.1423416766338L882.6288307420909,621.7021233895794ZM892.9821721035987,588.387749326881L927.5795615203679,589.7840886651538L927.9479713365436,580.5143463215791L893.3576818937436,579.119045610074Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1017.6017226530239,627.8253832343034L1020.1529803453013,570.5152052585036L1059.6043860223144,572.2372227758169L1056.1459092991427,629.1436782311648Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.734418339096,619.6336360904388L1059.462386522442,575.5043726586737L1059.6043860223144,572.2372227758169L1061.0425254097208,539.9433402768336L1068.313688722439,540.2627733657137L1068.4059883961454,538.1006168583408L1072.9767945418134,538.3066356498748L1072.8844948662445,540.4750350853428L1083.1747253378853,540.942218942102L1081.0202773604542,589.2596810786054L1086.4770026113838,589.5146014383063L1084.960763500072,623.403318468947L1073.9976131739095,622.9142899573781L1073.8485136982054,626.2376021868549L1063.041562821716,625.7485738755204L1063.3034730115905,619.9374582082964Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M990.019897447899,590.7902435888536L992.549855215475,533.9271742631681L1021.1091103153303,535.209069638513L1021.0452105402946,536.5200987528078L1021.6692194575444,536.5492327311076L1020.1529803453013,570.5152052585036L1018.8560515735298,599.6271284772083L991.6213362589478,598.3941480405629L991.9550350857899,590.875563853886Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M988.4255586108193,626.5143713881262L989.6798875331879,598.3161112959497L991.6213362589478,598.3941480405629L1018.8560515735298,599.6271284772083L1017.6017226530239,627.8253832343034Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.9714460400864,426.0608641188592L1072.0269756605849,403.2912199012935L1074.6066332543269,403.41816324414685L1074.9892430193722,395.218867264688L1093.9745762394741,396.11163371708244L1092.026027536951,438.05800068285316L1079.90084796492,437.48467745585367L1080.1911580553278,431.1562680238858L1077.7960998127237,431.0428518843837L1078.0083101773635,426.37926194118336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1071.3895556805655,478.9053376233205L1071.9488759357482,467.23395126638934L1073.7562140226364,467.3119894871488L1074.0402130233124,461.245815933682L1073.3949041822925,461.21772214910015L1073.8130138227716,452.50136018544436L1088.9501605788246,453.22347534587607L1088.510751013644,462.54957546526566L1087.5751320822164,462.5069145420566L1087.2209222177044,469.97673403006047L1089.070860155858,470.06205578288063L1088.6882503880188,478.0344325006008L1086.8454124266282,477.94182728929445L1086.491202562116,485.3762529110536L1087.4197215186432,485.43244028277695L1086.9661120027304,495.0560816270299L1071.8218652708456,494.3266872847453L1072.282574761659,484.56777902087197L1072.9341946914792,484.59691321477294L1073.1968937674537,478.99794282298535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M997.0149506200105,473.42081858823076L997.454360185191,465.8448708122596L999.2325094873086,465.9510028110817L999.6932189781219,457.86519649717957L998.4601899823174,457.7944417488761L998.9918992221355,448.5463736630045L1014.249745555222,449.4391332473606L1014.0509462533519,452.8624177738093L1013.7180363126099,458.687200143002L1012.9315168568864,458.6445391983725L1012.6128068668768,464.2435260307975L1014.5826554941013,464.3569416254759L1013.8947468027472,476.0990873896517L1011.924898176454,475.98567198961973L1011.5777882859111,481.9529844415374L1012.8605171069503,482.0383060462773L1012.3217078913003,491.342516775243L997.0433505205438,490.45704612648115L997.5813708500937,481.1455506584607L998.3465903811157,481.18821146758273L998.7859999462962,473.5269504711032Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1036.898665888235,421.24847696581855L1037.2386758048087,413.5528126396239L1039.1588246058673,413.63709456985816L1039.506723381579,405.69377831555903L1038.4859047494829,405.65736015699804L1038.8543145647272,397.20313940104097L1053.5875516310334,397.86282912129536L1053.403741166927,402.0436372733675L1053.1907419152558,406.88413176266477L1052.0003127697855,406.8196196053177L1051.7455025548115,412.5247811167501L1053.6088515557349,412.6028199531138L1053.0984422396868,424.2389207482338L1051.242193213664,424.16816565720364L1050.98659411259,429.9014067989774L1052.1699232831597,429.9513515313156L1051.7802135441452,438.97261240985245L1037.06117642764,438.3129266030155L1037.4508861685172,429.2916648630053L1038.4646048247814,429.3343259920366L1038.8188146902248,421.3337993179448Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1006.2946179807186,553.5322397975251m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1005.751075447537,469.68643196159974m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M966.7690570075065,416.2165373326279L962.9634703937918,487.9556689769961L962.7930709943175,491.36436739983037L962.7078712927178,492.8876679833047L962.6439715167508,494.1206671865657"
        style={{ display: 'none' }}
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer university"
        d="M1139.9106257744133,612.9620320000686L1140.3997351648286,610.4908732101321L1183.847637896426,611.7457017437555L1183.847637896426,612.9620320000686Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1233.7612512167543,443.7631364846602m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M1143.4535133121535,609.4285347838886L1144.4317320939153,590.6060766670853L1178.5045122439042,592.3707493185066L1177.526293464005,611.1932026413269Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M1170.6740286760032,498.92572021717206L1171.3966483576223,484.7311386154033L1194.8888879483566,485.92147849313915L1194.173368241638,500.1087741232477Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M1140.7752449540421,497.50126894237474L1141.4978646356612,483.3774389112368L1163.6789755038917,484.5251182327047L1162.956355823204,498.63541936082765Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1101.0469402521849,506.6285732896067L1092.7983470438048,500.4989633606747L1075.1651646215469,499.678005178459"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1100.3456204961985,527.4781548092142L1140.1441360637546,529.4405385814607"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1140.1441360637546,529.4405385814607L1260.2425802936777,535.3651445452124L1291.839046932757,537.1319122561254"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1100.3456204961985,527.4781548092142L1098.2905721701682,576.1848552767187"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1257.4483456769958,396.2874816409312L1266.301225649193,423.3669682396576"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1291.839046932757,469.5896646003239L1266.6420244509354,401.88755936175585"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1266.301225649193,423.3669682396576L1291.839046932757,489.8670791378245"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1268.966082942672,456.1785279526375L1291.839046932757,516.754747773055"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1101.0469402521849,506.6285732896067L1100.3456204961985,527.4781548092142"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1105.6816461728886,398.2665508748032L1251.5474775442854,404.4670064970851"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1103.8679969962686,444.0461560487747L1266.8897346900776,450.68670734763145"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1251.5474775442854,404.4670064970851L1266.8897346900776,450.68670734763145L1268.966082942672,456.1785279526375"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1248.4439995717257,396.2874816409312L1251.5474775442854,404.4670064970851"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1105.6816461728886,398.2665508748032L1103.8679969962686,444.0461560487747L1102.7690786384046,468.3889168249443"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1266.6420244509354,401.88755936175585L1264.7581644114107,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1101.0469402521849,506.6285732896067L1088.1068413238972,505.962650898844L1075.1651646215469,505.53916584467515"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1105.7494903774932,396.2874816409312L1105.6816461728886,398.2665508748032"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1098.2905721701682,576.1848552767187L1096.9952211696655,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1291.839046932757,517.8993000620976L1177.526293464005,511.1433173175901"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1177.526293464005,511.1433173175901L1101.0469402521849,506.6285732896067"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,526.1962580042891L1082.7708156481385,526.585405273363L1100.3456204961985,527.4781548092142"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M1112.9883093601093,498.50743725756183L1115.1072574621066,450.54519770434126L1256.3233940787613,456.3918327554129L1272.7929694810882,506.5651025637053Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1102.7690786384046,468.3889168249443L1101.0469402521849,506.6285732896067"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1260.2425802936777,535.3651445452124L1256.8480033446103,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1266.6420244509354,401.88755936175585L1267.151644879952,396.2874816409312"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1106.2078332100064,396.2874816409312L1097.7841072846204,612.9620320000686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1187.3061146195978,634.2951190238819L1189.2128523578867,591.6049480354413L1189.4392626713961,586.4534755186178L1187.7384242098778,586.3827220830135L1188.1778337759897,576.5250965598971L1189.1418526070192,576.5677567790262L1190.2186821522191,552.2180924084969L1189.2554522072896,552.181675019674L1189.6522619230673,543.3520131343976L1250.7601692024618,546.094765778631L1246.7139723235741,636.96708276961L1231.605225467123,636.2793227289803L1231.5413256920874,637.6756524182856L1202.067751585506,636.3573590433225L1202.1316513605416,634.9620695733465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1264.3100770981982,635.832954980433L1267.7898537460715,557.7733028312214L1298.368657298386,559.1488384203985L1321.8111970638856,620.6470700870268L1321.7906860252842,621.0788719998673L1320.876367018558,641.694000528194L1269.1293823681772,639.3622768041678Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1112.081090329215,592.0159419407137L1112.7121992204338,577.7008537687361L1115.3691676529124,577.8142675077543L1116.9635064881295,542.1897765756585L1143.390402423218,543.3738635946065L1142.9438928822055,553.4573240401223L1159.186269084923,554.1877526557073L1159.3211686108261,551.1619880334474L1166.5986430123448,551.4949470646679L1166.4645323725417,554.5207115411758L1166.65544281248,554.5279950178228L1165.2812032010406,585.3692830749787L1179.9860403677449,586.0351978405379L1180.1485509062186,582.5276992022991L1186.8312051789835,582.8325634379871L1186.6686946386471,586.3254950363189L1187.7384242098778,586.3827220830135L1189.4392626713961,586.4534755186178L1189.2128523578867,591.6049480354413L1186.4414954381064,591.4780081422068L1186.3002848234028,594.6952054146677L1179.6176305515692,594.390341700986L1179.758841167204,591.1731442846358L1141.3353540962562,589.451131473761L1140.3997351648286,610.4908732101321L1139.5919157834724,628.6973100230098L1135.2333200043067,628.498577317223L1135.0842205276713,631.7584172906354L1119.6567636830732,631.0571304280311L1116.1201872322708,630.9010576754808L1116.2621867340058,627.648500696756L1113.165019848384,627.5132375801913L1114.7388476477936,592.1366388807073Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.734418339096,619.6336360904388L1059.462386522442,575.5043726586737L1059.6043860223144,572.2372227758169L1061.0425254097208,539.9433402768336L1068.313688722439,540.2627733657137L1068.4059883961454,538.1006168583408L1072.9767945418134,538.3066356498748L1072.8844948662445,540.4750350853428L1083.1747253378853,540.942218942102L1081.0202773604542,589.2596810786054L1086.4770026113838,589.5146014383063L1084.960763500072,623.403318468947L1073.9976131739095,622.9142899573781L1073.8485136982054,626.2376021868549L1063.041562821716,625.7485738755204L1063.3034730115905,619.9374582082964Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1160.4476979812607,391.3502112990245L1161.5884273014963,369.4170346413739L1182.3952985592186,370.50750400312245L1182.544398035854,367.6304542175494L1227.6718393024057,369.9976471657865L1238.1600801898167,397.997056201566L1237.6007599337026,398.8617282612249L1188.3127333009616,396.2895626826212L1188.4894437901676,392.81630522059277Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1172.5657775793225,434.7554085268639L1173.9053061995655,406.8060928634368L1232.8595543885604,409.64774877019227L1231.7188250683248,433.4443601635285L1241.1223475467414,433.90530814928934L1240.7752376571298,441.2471752958372L1227.0202193725854,440.5947733023204L1227.1685299612582,437.39207170531154L1196.136116893962,435.8895692117512Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1290.552373680286,442.6144099012017L1301.1329142414033,442.9338474762626L1301.4445242574438,446.42060649301857L1309.8067170670256,447.058440761175L1314.5621225629002,446.64015467464924L1315.5182525310665,448.3268255395815L1329.9114796817303,448.95737605029717L1329.1675600772724,459.8640178530477L1331.1800085538998,460.07628203276545L1329.6921693431213,508.63466410757974L1315.3060421664268,507.0541392834857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1275.0965169342235,398.45072290394455L1276.6127560464665,372.3367451648228L1333.2208569310606,375.64561019837856L1333.0086465673521,379.3592370329425L1331.6407180447131,402.8157026125118L1328.1254415204749,402.603436680045L1327.9842309057713,405.06218335125595L1322.4281060043722,404.73650091933087L1322.570105505176,402.2850377657451L1302.8124527791515,401.12902067089453L1302.713053128682,402.70228601107374L1276.5985560957342,401.1716819726862Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1117.0700061134994,426.1097683608532L1117.6585151553154,411.63930040365085L1139.1880060937256,412.5320647438057L1139.4428163086995,406.39508797507733L1153.9567430354655,406.9975482961163L1153.8928432594985,408.42201816895977L1162.2479360932484,408.76851079938933L1161.9781370423734,415.3810019250959L1163.7712751794606,415.4590407270007L1163.3886654144153,424.82056919671595L1161.6026272512972,424.74981411127374L1161.2342174360529,433.5515331751667L1138.3659867634997,432.61611043522134L1138.592397077009,426.9962877444923L1121.4712017439306,426.2876965547912L1121.4357018694282,427.0670428071171L1120.2594726728275,428.0805049533956L1118.7708445768803,428.01599299535155L1117.7926257941872,426.924492163118L1117.8210256956518,426.1451458972879Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.9714460400864,426.0608641188592L1072.0269756605849,403.2912199012935L1074.6066332543269,403.41816324414685L1074.9892430193722,395.218867264688L1093.9745762394741,396.11163371708244L1092.026027536951,438.05800068285316L1079.90084796492,437.48467745585367L1080.1911580553278,431.1562680238858L1077.7960998127237,431.0428518843837L1078.0083101773635,426.37926194118336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1071.3895556805655,478.9053376233205L1071.9488759357482,467.23395126638934L1073.7562140226364,467.3119894871488L1074.0402130233124,461.245815933682L1073.3949041822925,461.21772214910015L1073.8130138227716,452.50136018544436L1088.9501605788246,453.22347534587607L1088.510751013644,462.54957546526566L1087.5751320822164,462.5069145420566L1087.2209222177044,469.97673403006047L1089.070860155858,470.06205578288063L1088.6882503880188,478.0344325006008L1086.8454124266282,477.94182728929445L1086.491202562116,485.3762529110536L1087.4197215186432,485.43244028277695L1086.9661120027304,495.0560816270299L1071.8218652708456,494.3266872847453L1072.282574761659,484.56777902087197L1072.9341946914792,484.59691321477294L1073.1968937674537,478.99794282298535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1195.7109072785825,444.7765961950645L1196.136116893962,435.8895692117512L1227.1685299612582,437.39207170531154L1227.0202193725854,440.5947733023204L1226.750420320779,446.2790967593901Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1174.8835249822587,466.48998686205596L1175.266134747304,457.2138365772553L1193.0539388461038,457.95051839808L1192.663440220058,467.23395126638934Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1226.750420320779,446.2790967593901L1227.0202193725854,440.5947733023204L1240.7752376571298,441.2471752958372L1240.499127516523,446.9304577084258Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1219.0871806098148,589.0297325006686m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1288.2243707580492,589.8975022062659m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1202.7438269853592,421.54606467997655m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1140.4478572178632,420.1039087190293m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1082.3030061824247,414.73900266876444m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1080.2526911720634,474.0014224019833m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1211.366352211684,442.6862053205259m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1266.301225649193,423.3669682396576L1254.646222201176,396.2874816409312"
        style={{ display: 'none' }}
      />
    </g>
    <g>
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer water"
        d="M29.554998031817377,669.2116107493639L41.403278578072786,642.6148282876238L56.1649155439809,649.1917199515738L44.31584611069411,675.78847718006Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M205.72115615848452,751.5660973209888m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M73.56774321943521,612.9620320000686L60.77832153905183,639.0927915046923L4.247531493194401,612.9620320000686ZM-8.205035817809403,725.4378427192569L8.479116609320045,733.0135067966767L-8.205035817809403,775.9941366906278Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer water_boundary"
        d="M29.55815357621759,669.1908011636697L41.42852293327451,642.6148282876238L56.13336009904742,649.1709103039466L44.35134598612785,675.7458175690845L29.55815357621759,669.1908011636697"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M-8.205035817809403,775.9941366906278L8.479116609320045,733.0135067966767L-8.205035817809403,725.4378427192569L-8.205035817809403,612.9620320000686L4.247531493194401,612.9620320000686L60.77832153905183,639.0927915046923L73.31056634709239,612.9620320000686L186.65693432558328,612.9620320000686L139.504422403872,743.3880224837922L119.74676967784762,737.9598980201408L112.69570558983833,732.2123450748622L109.42182821780443,726.1464033280499L91.22301445249468,712.3840832179412L68.27589516621083,703.2060665441677L57.12893437594175,700.5705449404195L46.63359351363033,700.2511192406528L36.4640626180917,704.1841122056358L27.94567035883665,710.4134274469689L22.53154495730996,723.2049919283018L14.991371478885412,743.2038596183993L-1.236804772168398,786.1490506324917L-7.465849528089166,803.5257802437991L-8.205035817809403,805.7887784685008Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M-8.205035817809403,623.9506141683087L-6.743229848332703,620.6959729557857L36.80407253373414,640.2768619717099L2.490682115778327,716.5865515968762L-8.205035817809403,711.7743661287241Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer picnic_site"
        d="M6.111669380217791,721.0293663507327L23.729074079543352,679.90564857563L24.303383169695735,680.0679630907252L39.44052992668003,686.6021596770734L41.389078627340496,682.0812870580703L42.55899673514068,679.5935052642599L44.31584611069411,675.78847718006L56.1649155439809,649.1917199515738L60.77832153905183,639.0927915046923L73.31056634709239,612.9620320000686L87.36062803678215,612.9620320000686L60.12670160830021,682.6691567371599L56.31401501968503,687.3180075907148L52.28911806549877,689.8546889955178L43.621626330539584,691.7618815805763L32.4036657884717,695.3619272545911L27.322450328618288,698.9619710585102L21.19201633706689,705.0914055020548L11.674894256517291,724.1403754567727Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M47.00910330377519,679.0691044712439L55.0454861484468,667.638405894395L62.23854973632842,671.026206383016L58.64517348725349,682.2373586604372L51.87100842501968,687.948536362499Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M54.4143772572279,656.4272300070152L58.42586314678192,648.8088224590756L66.68155633099377,651.3465584339574L61.607440846040845,666.582319100853L55.68290612939745,663.6127894637175Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M144.27718339394778,829.6360527910292L149.02233336959034,783.9588783415966"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M46.06638439837843,704.4962544073351L50.28298067767173,703.873010460753L54.25896669179201,703.8303510225378L59.00727221276611,704.2340549589135L63.570978382602334,705.1486315676011L67.46807578578591,706.6084162797779L92.94515283964574,718.9817181248218L96.60873995255679,720.8732956242748L99.36589692160487,722.5817496636882L102.09386510401964,724.8707860871218L104.99223268684,727.7684970186092L107.79198950529099,731.3269051965326L111.16526652872562,736.279540438205L112.87951605487615,738.3136574598029L114.48884372785687,739.7807184704579L116.25279307831079,740.7441924111918L146.3219762025401,753.3869141968898"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M137.36417437624186,829.6360527910292L140.52524103503674,815.9915098007768L149.02233336959034,783.9588783415966L152.45162130706012,771.0123968287371"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M25.916655274108052,700.3666119221598L17.570240187458694,694.2829542243853"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M13.766231345012784,691.5100864092819L-8.205035817809403,675.4940218161792"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M17.570240187458694,694.2829542243853L13.766231345012784,691.5100864092819M33.813405274413526,706.1225150590762L25.916655274108052,700.3666119221598"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M208.46884649340063,768.5142423049547L136.2234450560063,751.0978871891275L79.65715513378382,730.3915226394311L34.848423856310546,706.877898955252L33.813405274413526,706.1225150590762"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M-8.205035817809403,790.7759824111126L12.717012813314795,733.6513146986254L14.020252673886716,730.3623894765042L20.341597105376422,714.4244500854984L25.664211715571582,706.9902701056562L37.76099138893187,698.7705236906186L48.277632175944746,695.5242414097302L53.59235792700201,692.6265169978142L60.22610125876963,689.0119032338262L62.075250309892,686.7582311765291L64.38589773792773,683.9239722052589L67.97138512693346,676.6739241527393L77.55240698251873,651.4526875959709L91.59852424357086,614.4530507517047L92.14127788878977,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M153.99704920500517,739.8795629953966L144.58563786372542,768.0491547123529"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M-1.499503848142922,829.6360527910292L-4.036561590619385,828.3646164131351L-5.772111041471362,826.8757245824672L-7.161339488811791,825.2390876971185L-7.842148205265403,823.5951672354713L-8.205035817809403,822.1593376542442M-8.205035817809403,816.9424876635894L-7.9194590440019965,816.0830700364895L26.975340439006686,720.0305136330426L28.10896978341043,717.4792766640894L29.4697983302176,715.0133574940264L31.411247057840228,712.6109062843025L33.353484669700265,710.5268390150741L35.939453351311386,708.3793022409081L38.25010077934712,707.1400983035564L41.21236813813448,705.8571942504495L46.06638439837843,704.4962544073351"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M161.11201306711882,741.6795735713094L170.31752513255924,712.3903260533698L186.56700130924582,665.001830291003L205.63437868654728,612.9620320000686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M42.55899673514068,679.5935052642599L51.41029893420637,690.0482175638899"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M26.9043406881392,672.9250803170726L42.55899673514068,679.5935052642599M51.41029893420637,690.0482175638899L53.59235792700201,692.6265169978142"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M62.075250309892,686.7582311765291L67.53197556082159,692.6046670046635L72.40098065696657,697.0547804557718L79.79915463458747,700.2303097490221L85.51857896149158,702.3414324438199L93.34196255449206,705.5169593147002L101.8106549885124,711.434131484013L110.48445781320333,719.0597535092384L116.82710217032582,727.7268781992607L119.79646950215101,732.6025212514214L121.90831763017923,735.9819662361406L139.9856429323554,742.0572635936551"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M139.9856429323554,742.0572635936551L149.09254423342645,745.1172803342342"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M58.89603927079588,643.2141466275789L73.09204489272088,649.4830549862236"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M58.03615340683609,642.8354107383639L58.89603927079588,643.2141466275789M73.09204489272088,649.4830549862236L77.55240698251873,651.4526875959709"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M37.76099138893187,698.7705236906186L39.774228752590716,702.9043290237896"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M39.774228752590716,702.9043290237896L41.21236813813448,705.8571942504495"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M144.58563786372542,768.0491547123529L133.73608713876456,799.8758486742154L126.36552417464554,824.9061418138444L125.40150534268469,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M16.18811171501875,697.5094680604525L23.467163889668882,702.8158887140453"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M-8.205035817809403,679.7287673680112L12.332036389037967,694.699144418817"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M12.332036389037967,694.699144418817L16.18811171501875,697.5094680604525M23.467163889668882,702.8158887140453L30.913459919393063,708.2440406968817"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M30.913459919393063,708.2440406968817L33.033985793590546,709.7901840326376L78.26871557347476,733.5233369348571L135.22392634954304,754.3722360427491L208.46884649340063,772.0341324070469"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M152.45162130706012,771.0123968287371L161.11201306711882,741.6795735713094"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M199.54338899999857,612.9620320000686L173.570102580823,683.1373714902438L153.99704920500517,739.8795629953966"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M195.0988046331331,612.9620320000686L175.27094104140997,667.8579470696859L172.11776324454695,676.6031716382131L149.09254423342645,745.1172803342342L146.3219762025401,753.3869141968898L118.13349757436663,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,688.1285387892276L190.59978712443262,681.7837105300277"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M14.020252673886716,730.3623894765042L-8.205035817809403,720.2552555077709M-7.689104299061,612.9620320000686L44.23143529705703,636.6767876907252"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M44.23143529705703,636.6767876907252L58.03615340683609,642.8354107383639"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,789.689741004724L193.72929833829403,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,766.386492323596L146.3219762025401,753.3869141968898"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M37.44228139985353,837.0524135250598L74.7960388995707,736.1172272399999L96.47384042758495,744.1392404478975L84.05835076514632,777.7015366838314L89.62867561541498,779.7637340421788L90.71970511041582,776.8296286333352L96.60873995255679,779.0052366992459L95.63052116986364,781.6563354176469L101.1156463213265,783.6831558886915L113.71573533583432,749.6318690399639L135.28782612551004,757.6247335644439L133.1333781471476,763.4503003247082L132.03524867538363,763.0393165801652L98.42317801434547,853.8619694598019L99.94651710055768,854.4290155428462L97.99796839989722,859.6874553486705L75.0366491638124,851.1911297668703L77.75830625742674,843.8413731520995L78.96293535362929,844.2950106780045L88.50845733378083,818.4854853856377L71.77697174064815,812.2989260251634L61.94113967008889,838.8742484012619L65.09431746881455,840.0364352203906L62.73475910164416,846.4144131266512Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M5.155539409257472,825.1048688883893L42.50929690990597,724.1684681735933L74.7960388995707,736.1172272399999L37.44228139985353,837.0524135250598Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M153.45114001445472,602.9442089344375L174.10891179554164,545.1166978124529L207.77778225764632,557.2353663728572L187.12001047562808,615.0690193250775Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M127.49284243024886,736.5417386768386L132.70106855593622,722.0146927982569L131.90744912531227,721.7244012840092L135.061415810138,712.9147243285552L135.9757348159328,713.2487160651945L140.2270420845598,701.3706698454916L135.1813264992088,699.5425559845753L136.16664525587112,696.7863378729671L154.7906686346978,703.5182087896392L141.17686096485704,741.481884569861Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M191.63401681929827,671.4798552175052L200.2660086788237,647.3209325424396L203.6321857282892,648.5258112540469L211.10845943074673,651.2258625258692L210.42133962456137,653.1393086267635L219.99526150617748,656.5833021849394L216.7773950463161,665.6042681368999L217.55050343926996,665.8737524035387L212.81639786809683,679.1044807163998ZM202.1790575068444,664.434768713545L202.76046657189727,664.6480671106838L202.53326737042516,665.2931646606885L207.30287281703204,667.0078752776608L208.53590181376785,667.4469576613046L210.9735599057749,660.6297323089093L204.39030528441072,658.2553552375175Z"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M73.55827658716589,612.9620320000686L60.772799336351454,639.0896700518206L4.247531493194401,612.9620320000686ZM-8.205035817809403,725.4420046033338L8.469649975188076,733.0135067966767L-8.205035817809403,775.972286962904Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M195.4822032833472,719.3001024937257L198.4160707416013,711.3488127021119L205.53103460464627,714.0061801280826L209.1386108044535,704.2340549589135L206.282054184936,703.170690419618L209.41472094412893,694.694982517045L223.92785878386348,700.0950480434112L221.22829050198197,707.3877310147509L218.8679432477802,706.5158141246065L217.38010403700173,710.5268390150741L217.3375041866675,711.8305516638793L215.9135647509247,715.6792598026805L215.133356384933,716.3243526061997L214.3184370296076,718.5207890975289L217.13949377369136,719.5623013721779L217.60020326357335,718.2939662216231L220.5829816609621,719.406230612658L217.58600331377238,727.5208650380373Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M178.6087181903422,713.0146097093821L181.74138494953513,704.5461971592158L183.9313328024,705.3681715549901L185.2416726378724,701.8035072037019L184.41255333088338,701.0096251978539L185.2345726629719,698.7913331873715L186.36899089440703,698.3657789630815L187.4458204396069,695.4534890847281L185.08626207336783,694.5815706928261L187.8142302557826,687.1692194421776L189.98997815791517,687.9839125624858L202.49776749592274,692.6327598514035L199.44398934859782,700.9034967981279L196.74363218061626,699.9036007057875L193.22835565637797,709.4280993537977L198.4160707416013,711.3488127021119L195.4822032833472,719.3001024937257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M207.57898295670748,647.1367671275511L212.51188782788813,633.7707148040645L209.49282066896558,632.6511532822624L211.36326964572072,627.5912739937194L214.33973695430905,628.704593422357L214.48883642908186,628.2998446039855L222.70192976295948,631.361992531456L218.62023300956935,642.3890434107743L218.21632331889123,643.4794698348269L216.16837496683002,642.7147146807984L213.6952169984579,649.4112617089413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M188.3317395457998,778.2831554743461L190.02547803334892,770.7855756715871L204.3974052593112,774.2076610489748L205.54523455444723,776.1429229346104L202.42045665718615,784.7038491363637L195.3189038587734,782.0808440656401L195.70940248575062,781.0112486961298Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M162.86255135387182,776.0576049466617L165.37120919674635,765.0734257502481L175.99356072302908,767.5185178238899L173.54880265612155,778.2124039968476L172.53587288502604,777.9710165951401L172.02546356990933,780.1892832685262L169.48130585160106,779.6076646372676L169.9136154409498,777.6942534404807Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M185.2345726629719,786.3904377510771L186.41159074474126,783.1868554488756L187.48842029087245,781.514832526911L194.57498425245285,784.1222308822908L195.3189038587734,782.0808440656401L202.42045665718615,784.7038491363637L199.82659911364317,791.7685821703635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M199.38718954846263,835.0120827518404L201.39253805018961,829.5403309096582L208.57850166317075,832.1914103049785L207.45197229273617,835.2597108935006L208.30239152349532,835.5718471957371L209.8399305595085,834.296250087209L218.54923325870186,837.5060514952056L217.06849402282387,841.5461332923733L212.43378810212016,839.8377085714601Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M173.54880265612155,778.2124039968476L175.99356072302908,767.5185178238899L183.01701379567385,769.1270757969469L180.47995605319738,780.2527514891699L178.67971794120967,779.8490519816987L178.26870827563107,781.634485708084L175.15024146717042,780.91864753142L175.66065078228712,778.694138311781Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.35528670158237,824.1830249149352L205.36852406524122,818.6977385873906L212.362788352184,821.2780710868537L211.15105928108096,824.5867218398489L212.27758865244687,825.0049851224758L213.92872728966177,823.7439524587244L222.3903197478503,826.8757245824672L220.9939913256094,830.6962765636854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.39253805018961,829.5403309096582L203.35528670158237,824.1830249149352L220.9939913256094,830.6962765636854L219.66235156543553,834.3243423574604L211.05165963061154,831.1426317621954L210.69034979026765,829.3072689380497L209.76183083374053,828.9670400591567L208.57850166317075,832.1914103049785Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.36852406524122,818.6977385873906L207.33127271663398,813.3404242130928L207.96159272175282,813.5745271784253L217.86211345344782,817.2317347330973L224.98417729139328,819.8599287881516L223.68014854378998,823.4390988172963L215.1901561850682,820.3000419461168L214.61663598008454,818.6269875220023L213.4822177477181,818.2087238519453L212.362788352184,821.2780710868537Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M175.99356072302908,818.3866419834085L177.11377900466323,815.32457666751L179.01262788008898,816.019602144137L179.5940369470045,814.439147404395L190.11067773308605,818.3221336556599L187.7929303292185,824.6585132996552L177.27628954406828,820.7744901427068L177.9002984603867,819.0806266968139Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M24.303383169695735,680.0679630907252L26.251931871287525,675.5470862095244L41.389078627340496,682.0812870580703L39.44052992668003,686.6021596770734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M183.93843277730048,796.6795558258891L185.0436622230336,793.6611802685075L187.0419107498601,794.4051095601171L187.6162198400125,792.8173666661605L198.04056095145643,796.6722726058215L195.7796133486554,802.8307535122149L185.31977236177772,798.9685677792877L185.88698147796094,797.3953923722729Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M173.81860170606524,824.3390933154151L175.01613082643598,821.0720607028343L176.91497970372438,821.767085606698L177.27628954406828,820.7744901427068L187.7929303292185,824.6585132996552L185.652682303451,830.5183587474748L175.17864136584103,826.6561884400435L175.76715040858835,825.0549270082265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M181.81948467437178,802.4842805815861L182.95311402063817,799.3733066334389L184.90166272129864,800.1026688795537L185.31977236177772,798.9685677792877L195.7796133486554,802.8307535122149L193.738764972426,808.4148959429003L183.20792423561215,804.5246209306642L183.69703362695873,803.1855500997044Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.66105245798826,787.963615655899L185.2345726629719,786.3904377510771L199.82659911364317,791.7685821703635L198.04056095145643,796.6722726058215L187.6162198400125,792.8173666661605L188.84214886184782,789.5014175237156Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M190.93979703914374,753.1247165943496L193.45555485785007,742.3173806755804L199.07557953335345,743.6294110910967L196.55272174067795,754.4502710304223Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M178.88561721611768,810.4989337832667L179.51593722123653,808.784258661326L191.93221577070653,813.3622738216072L190.11067773308605,818.3221336556599L179.5940369470045,814.439147404395L180.7773661185056,811.2074856981635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M196.55272174067795,754.4502710304223L199.07557953335345,743.6294110910967L204.56070468388498,744.9185509639792L202.15775758121163,755.2576729771681L202.04415798094124,755.7404493559152Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M179.51593722123653,808.784258661326L180.0192465633154,807.39524664497L181.90389548894018,808.0819492484443L183.20792423561215,804.5246209306642L193.738764972426,808.4148959429003L191.93221577070653,813.3622738216072Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M180.47995605319738,780.2527514891699L183.01701379567385,769.1270757969469L188.0769293308258,770.2965575563721L185.52567163854837,781.41494813608Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M171.52925420273095,830.5901501486078L172.11776324454695,828.9951323540881L174.06631194613874,829.7182487505488L175.17864136584103,826.6561884400435L185.652682303451,830.5183587474748L183.95263272710145,835.1681509101763Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M202.15775758121163,755.2576729771681L204.56070468388498,744.9185509639792L209.69083108380437,746.1234127101488L209.28692139312625,747.8734792280011L207.2815728923306,756.4698161915876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M207.13957339152694,757.0940958778374L207.2815728923306,756.4698161915876L209.28692139312625,747.8734792280011L214.91404604539275,749.1844681259245L212.76669804286212,758.4113258235157Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M207.96159272175282,813.5745271784253L209.69083108380437,808.8758189929649L219.59135181549937,812.5257458221167L217.86211345344782,817.2317347330973Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M85.49885680899024,797.9905354939401m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M179.88355815131217,737.2544600274414m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M190.13749986048788,703.1748523167334m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M196.8643317548558,777.2125190556981m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M196.67184354364872,789.0789902512915m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M178.28448599763215,773.669741384685m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M208.3647135263309,824.7958534853533m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M205.620178735815,829.1366342748515m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M183.55582301225513,819.9275584700517m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M191.54487268906087,798.1819801218808m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M181.41478609945625,825.8560779984109m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M189.4290801314637,803.8556057750247m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M192.58699124492705,790.6344797089696m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M195.00650495756418,748.3770654690452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M185.7623374722898,813.9001904064789m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M200.55789654236287,749.6849328689277m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M189.24605855159461,811.0732666212134m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M184.27449826151133,775.2741360780783m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M167.3055579494685,744.5002828468569L172.20927403401583,723.7158632581122L192.7889460902661,728.6050352463499L192.46313612535596,730.0086296317168L187.88523000478745,749.3904806431383Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M362.9477364588529,742.9843208314851L208.46884649340063,688.1285387892276"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M240.55757806822658,828.0670461626723m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M222.89362908899784,615.5226718243212L233.73607983998954,627.1875655958429L264.03167327679694,638.1646798886359"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M264.03167327679694,638.1646798886359L383.36410908959806,685.5606424487196L425.1435176897794,699.495734619908"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,617.0438641491346L414.1306675383821,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M208.46884649340063,772.0341324070469L248.10800706595182,781.5918267481029L425.1435176897794,819.7413167259656"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M330.63259457051754,829.6360527910292L342.35386445280164,797.9197842138819L362.9477364588529,742.9843208314851L365.945503693074,734.6574487383477L383.36410908959806,685.5606424487196L409.37526204343885,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M425.1435176897794,816.2443409091793L248.8732265960425,778.2540225125849L208.46884649340063,768.5142423049547"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M271.9118566708639,781.0611908957362L254.15324135683477,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M216.45158508047462,768.0564379645512L208.46884649340063,789.689741004724"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,755.9391784165055L365.945503693074,734.6574487383477"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,817.1776309683919L404.75948938913643,812.2781168688089L342.35386445280164,797.9197842138819L271.9118566708639,781.0611908957362L216.45158508047462,768.0564379645512L208.46884649340063,766.386492323596"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M404.75948938913643,812.2781168688089L398.4081672858447,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M273.0415415856987,612.9620320000686L264.03167327679694,638.1646798886359"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M406.2394397398457,612.9620320000686L425.1435176897794,619.8667051144876"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.872687314637,677.1837584343739L414.71602103486657,625.3448653696105L435.37379281781614,632.9206388327293L435.2530932407826,633.2463105446659L426.21798057854176,658.1211331961676L423.00011411868036,666.9724989715032L417.3808783283457,682.4288064851426L416.53755907248706,684.7459490434267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M289.982870885171,756.038022711873L293.2362372195348,747.2356726345606L299.89759156573564,729.1720915758051L300.2873013066128,728.1378640346229L311.15105198323727,732.1696858135983L309.47151344642043,736.7269421871752L313.91530892718583,738.3708832482807L315.48834783770144,734.1184855373576L348.2357993181795,746.3002922246233L346.4852610314265,751.0489852400497L350.0644373316318,752.3880661423318L346.4639611057937,762.1393141243607L347.193680761382,762.9612816916779L346.1310511659831,765.8173581105657L345.2451320607215,766.0368961766362L337.23004914075136,763.0538830957375L337.5629590814933,762.1601234306581L313.1351005602628,753.0758146592416L312.3130812291056,755.294089301955L313.7236096011475,757.349010062404L312.75249079521745,759.9709840267897L309.9464228861034,760.8137611616403L303.94378844462335,758.5892454902641L303.63217842951417,759.424739531707Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M375.6188252232969,733.75015930878L389.70675344672054,695.2131392760202L404.06448072288185,700.513318839483L400.66990377381444,709.7901840326376L398.79235482309014,714.9280387563631L395.9996979786083,713.900051927194L395.7306878147647,714.6377469422296L393.73243928700686,713.900051927194L390.5997725278139,722.4964310186915L392.56331006623805,723.2122752284631L392.4284105403349,723.5806020139717L395.3409780729562,724.6512467176653L390.0688521740958,739.0721592553891Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M215.46705521084368,680.5923638087697L217.9686130778864,673.3433527532034L222.3903197478503,674.8738966956735L223.58784886915237,671.3872525896877L227.19542506802827,672.6347867469303L228.471053914167,668.9421266098507L220.68238131143153,666.2566489549354L222.94332891423255,659.6943402132019L244.25982060097158,667.0359682263806L242.76488141529262,671.3591596591286L246.57046802900732,672.6701630242169L244.33792032767087,679.1263307486661L241.843462433666,678.2752198618837L240.73823298793286,681.4788506468758L245.00374020729214,682.9459236827679L242.58738203905523,689.9472913742065Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M330.766705208458,618.8043681220151L332.90695323608816,612.9932466335595L336.41512978542596,614.2969776261598L336.464829611592,614.1835644831881L338.8669878281653,607.6284898659214L338.30766757391393,606.5016406988725L335.65701022930443,605.5162978349254L338.6192775880918,597.4733144054189L349.7946382788941,601.6113421027549L346.4213612563908,610.7676430400461L346.97437042184174,611.8799246801063L346.15945106651634,614.0982445045374L348.5190094327554,614.9701730227098L349.29132893960923,612.851740301121L350.5882577104494,612.1140344510786L353.8913238700479,603.1210921024904L365.17318418622017,607.3028169493191L364.9459849856794,607.9260695758276L362.2393167298287,615.2958455784246L359.1847496954724,614.1627547331154L357.88782092370093,614.715253598988L355.4998626559973,621.1922850282863L359.5247596092522,622.6801805500872L357.3277117833495,628.6473667277023L346.08845131564885,624.4802215606906L347.08797002304345,621.7447833335027L345.4723312612623,621.1423416766338L343.3809941718355,620.3630172461271L342.3751643775031,623.0984560186043Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M191.63401681929827,671.4798552175052L200.2660086788237,647.3209325424396L203.6321857282892,648.5258112540469L211.10845943074673,651.2258625258692L210.42133962456137,653.1393086267635L219.99526150617748,656.5833021849394L216.7773950463161,665.6042681368999L217.55050343926996,665.8737524035387L212.81639786809683,679.1044807163998ZM202.1790575068444,664.434768713545L202.76046657189727,664.6480671106838L202.53326737042516,665.2931646606885L207.30287281703204,667.0078752776608L208.53590181376785,667.4469576613046L210.9735599057749,660.6297323089093L204.39030528441072,658.2553552375175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.57448836322874,733.5441463268362L398.79235482309014,724.480609478429L403.51226044259965,726.1672127451748L408.5508760539815,711.9377203718759L403.8522703582421,710.2573564806953L406.8784374911338,701.7254716260359L423.48922351002693,707.657213659957L420.36365672480315,716.4512902139686L416.8491690866649,715.190237800125L411.8247534260154,729.3489715205505L415.3463410390541,730.6110618272796L412.2002632180229,739.4831444169395Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M195.4822032833472,719.3001024937257L198.4160707416013,711.3488127021119L205.53103460464627,714.0061801280826L209.1386108044535,704.2340549589135L206.282054184936,703.170690419618L209.41472094412893,694.694982517045L223.92785878386348,700.0950480434112L221.22829050198197,707.3877310147509L218.8679432477802,706.5158141246065L217.38010403700173,710.5268390150741L217.3375041866675,711.8305516638793L215.9135647509247,715.6792598026805L215.133356384933,716.3243526061997L214.3184370296076,718.5207890975289L217.13949377369136,719.5623013721779L217.60020326357335,718.2939662216231L220.5829816609621,719.406230612658L217.58600331377238,727.5208650380373Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M237.8035766435787,735.0465843058191L240.78714392706752,726.9683751626872L248.10090709105134,729.6819219952449L251.7999940784648,719.6757127898745L248.91582644544542,718.6061077914201L251.98459342960268,710.2927325665951L267.7733601164073,716.1682817703113L267.43335020076483,717.103666249197L265.5834122635424,722.1135375765152L262.1825242266059,720.8379195923917L261.1901054950431,723.537942698691L260.9842062201351,723.4526240662672L257.3135191295296,733.3818330643699L260.9281953042373,734.7209173766896L258.0361388111487,742.5660525979474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M217.58600331377238,727.5208650380373L220.5829816609621,719.406230612658L223.60914879478514,720.526818593964L223.10583945270628,721.8731886907481L226.1391065614298,722.9927358040586L226.97532584238797,720.7172248936258L226.64241590257734,719.9805709938519L228.2438547136262,715.6574098845012L228.86076365504414,715.2464233106002L230.49060236662626,710.8108881600201L227.88964485004544,709.8463695864193L230.60420196782798,702.490220269654L245.51414952240884,708.0328245870769L242.54478218965232,716.0756797422655L239.7174143558368,715.02688363567L235.96862754318863,725.168360767886L240.78714392706752,726.9683751626872L237.8035766435787,735.0465843058191Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.1216821987182,802.3417376577854L415.2477302746847,793.4270766270347L418.83321766369045,794.2844161423855L421.341875506565,783.7611905466765L417.7279882179573,782.896566495765L420.0520467106253,773.158873737324L433.4741550544277,776.3832699372433L433.8007539054379,776.461304675322L426.8341006329283,805.6379119437188Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.50302178412676,741.538069867529L418.096398034133,731.403899975121L415.9419500567019,730.6318712281063L418.0679981345311,724.6366801238619L422.98591416794807,726.3940353598446L423.6525229346007,724.5378353805281L422.1425949120894,723.9915880938061L424.3112428402528,717.8684131954797L420.36365672480315,716.4512902139686L423.48922351002693,707.657213659957L437.4501410694793,712.6525251963176L434.381374085322,721.298848465085L431.0009970869869,720.0794158019125L428.1949291797355,728.0026028756984L431.3126071030274,729.1159061775543L429.20075897406787,735.0757174496539L426.7134010568261,734.189237464685L423.0285140192136,744.5856012236327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.21273345686495,845.3229781710543L336.97523892764,832.3183457907289L337.9384688716382,832.6731408685446L340.48972656484693,825.720818746835L351.445776916109,829.7671501450241L348.9939188733697,836.4499905817211L358.16393106337637,839.8377085714601L353.40931445453316,852.8131941999309L348.08669984247535,850.8436187994666L348.62550905905664,849.3620149604976L338.62637756206095,845.6632062443532L337.9739687470719,847.4559061862528L333.61616185400635,845.8400832200423Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M376.33434492815286,640.1207894268446L376.49764435365796,639.674421927426L385.3915464030579,615.5018620742485L398.50125584658235,620.3630172461271L389.4519432326779,644.9819273338653L382.48607884626836,642.4025696939789Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M239.568314881064,614.0274913511239L240.52523373812437,611.3846524278633L242.80748126562685,609.9664671905339L245.67744894791394,602.1222223951481L265.16530262399465,609.2932713069022L259.8647768236697,623.8070270875469L240.37613426242024,616.6359931877814Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M320.2855642968789,647.7246397705749L325.27526897005737,634.1400868282653L328.3716469667852,625.7277641599067L341.9073549117893,630.7449849192053L339.9588062092662,636.0389708695002L334.1683821324259,651.7929251845926L333.8141722669825,652.7491279807873ZM328.69035695679486,639.4756895340979L331.14300388656557,640.3829913022928L333.07735263742507,641.1061273738742L334.1257822820917,638.2354327961802L329.73957548942417,636.613318155054Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M309.7973234113306,614.1908478951082L311.9517713887617,608.2090824386105L313.42619953583926,607.5858298353851L316.04056811798364,600.3357019457035L315.5096477633342,599.2307018809952L317.79110640473664,592.9024401069619L318.046705506742,592.590292877052L318.67702551186085,592.1158290631138L319.42094511631876,591.8609087998047L319.81854371819645,591.8317750543356L320.5979631980881,591.9670388698578L320.9592730393633,592.1366388807073L321.596693020314,592.6256695631891L321.8380921706557,592.9378167912364L321.9722028095275,593.4268474183045L331.2416146490723,596.7855504490435L328.7116568814963,603.8088554325514L327.1741178454831,604.3467882769182L322.1000023595989,618.4287523603998L320.9308731397614,619.172700454481L317.64279581513256,617.9886263851076L317.8053063545376,617.5214477186091L313.8656091010198,616.0970208095387L313.6668098010123,616.6568029304035L310.4284323025495,615.4800118417479Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M297.22563429828733,710.1158521356992L302.271349882707,696.2681812327355L322.2420018604025,703.6035276683979L317.18918630015105,717.4511839179322Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.93217224814,632.4316109917127L357.3277117833495,628.6473667277023L359.5247596092522,622.6801805500872L362.2393167298287,615.2958455784246L364.9459849856794,607.9260695758276L372.01124902348965,610.5408166386187L364.8749852348119,629.9583781706169L363.0045362589881,635.0463488111272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.185267213732,816.6147436667234L297.0631237588823,808.7488830778748L296.24820440169424,808.4513119850308L296.74362488277256,807.0831090738066L295.3338853958994,806.5660011349246L297.7644435139373,796.4173598638736L301.32863097824156,797.7075303788297L301.70492965355515,796.6722726058215L308.5145945902914,799.1745788208209L307.4874648693949,801.9734150543809L301.19452033750713,819.1940364842303Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M369.6374907065183,637.1231553829275L371.3880289932713,632.3681414178573L378.5171928051859,612.9505866360851L385.3915464030579,615.5018620742485L376.49764435365796,639.674421927426Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.34367766976357,667.2773594926111L378.8714026706293,652.23200852843L381.1678501497954,645.9818313503638L388.7222235770896,648.780729434453L380.8909511221573,670.0762489787303Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M403.46966059319675,836.7475604698993L408.90508591849357,821.7951779272407L420.03074678592384,825.8623207318597L416.8065692363307,834.7634141440503L416.3529597213492,835.9901098180562L409.87541583925486,833.6085096253082L408.75598644278944,836.7059423052706L410.8465346451849,837.4633928784169L411.12264478579164,837.86084630806L411.1936445347965,838.3498596572317L411.02403402142227,838.809740263503L410.66982415597886,839.1291595827788L410.2020146911964,839.2571353977546L409.79100502468646,839.108350506518L408.45147640258074,842.7925963760354L403.47676056902856,840.9718029825017L404.82970025297254,837.2511402550153Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M207.57898295670748,647.1367671275511L212.51188782788813,633.7707148040645L209.49282066896558,632.6511532822624L211.36326964572072,627.5912739937194L214.33973695430905,628.704593422357L214.48883642908186,628.2998446039855L222.70192976295948,631.361992531456L218.62023300956935,642.3890434107743L218.21632331889123,643.4794698348269L216.16837496683002,642.7147146807984L213.6952169984579,649.4112617089413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M345.26643198542297,812.6818144880235L347.2504805615172,807.2953626248054L371.22472956683487,813.1000784914941L368.26246220897883,821.1854704609141L358.63174052815884,817.6281488663517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M293.03743791766465,830.738935219124L295.32678542099893,824.3609428908676L308.27398432511836,829.0377910202369L319.7475439682603,833.1829636772163L318.35831552091986,837.0388876236975L317.4510964890942,839.5682310634293L294.0156567003578,831.0854067397304Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M360.9494879320264,702.0303306188434L361.26819792203605,701.1376035623252L367.4546428285539,683.8532197619788L374.9664164064452,686.5595001354814L368.4044617097825,704.9353344161063L366.9095225231722,704.3901260606945L364.9530849605799,709.8609362114221L361.68630756251514,708.6779181021266L363.7058560140431,703.0156597639434Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M322.9788214918226,619.7179155154154L326.5643088789657,609.7687744353898L327.74842693749815,610.1932936096564L328.67615700606257,607.6066396073438L328.9246561322361,606.9199171424843L327.74842693749815,606.4943572795019L328.7116568814963,603.8088554325514L331.2416146490723,596.7855504490435L331.6526243146509,595.6378897144459L338.1443681474775,597.9904379420914L329.4776652986184,622.0714960577898Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M305.3188169421628,687.7009029570036L313.63130992557853,664.4493354340084L320.1656536087394,666.8091436685063L314.1133193420246,683.7252410799265L312.90159026999027,685.0789016606286L312.157670664601,684.8094181385823L310.3574325526133,689.8338794698939L308.18878462538123,690.6485722791404L305.5807271320373,689.7131842314266Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M333.0560527117923,695.8082911702804L340.77372556645423,674.2360833887942L347.5975904511288,676.6947337160818L339.88070648442954,698.2742171715945Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M385.859355869703,769.2612956888042L389.0622334908694,760.2966497703455L392.81102030631155,749.7941819252446L400.99650262575597,752.7491081100889L395.6241881893948,767.7588651254773L392.3219109158963,766.5612903912552L390.7346720546484,771.0259228595532Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.2486783983186,768.794127216097L395.6241881893948,767.7588651254773L400.99650262575597,752.7491081100889L409.2947956593707,755.7404493559152L404.8652001284063,772.258872592356Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M281.27356818690896,669.7859552893788L287.212302852422,654.740609772969L294.2562669645995,657.5467876885086L284.9442552747205,681.1386145153083L284.8030446600169,681.4923768513836L284.21453562006354,681.2593099023215L283.82482587825507,682.2581682070158L282.0174877913669,681.5423197685741L282.4142975071445,680.5153684681281L281.57097825035453,680.1813751552254L285.08625477552414,671.3019333151169Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M284.9442552747205,681.1386145153083L294.2562669645995,657.5467876885086L300.1311018569395,659.5809278134257L295.57449566107243,672.279983477667L294.1221563257277,676.3482544808649L292.7755277296528,675.8592297034338L289.8487602462992,682.8959807781503L289.22475132904947,682.82522832416L288.43113189935684,683.0520523604937L288.02012223377824,683.0728619042784L287.19810290262103,682.9459236827679L286.4470833214,682.5911209406331L286.11417338158935,682.336204004474L285.58956411574036,681.6983913835138L285.397864789702,681.3227790296078Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M346.1097512403503,700.8254612060264L349.5753279402852,691.1375960134901L353.9189348835498,678.9702590783127L360.79328848142177,681.4507577554323L356.59089215192944,693.1925357915461L354.84035386517644,692.5620074989274L351.1128669772297,702.9657170018181L349.5114281643182,704.0145149324089L346.76847114693373,703.0291859298013Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M326.7205083295703,693.5265284786001L330.1718850787729,683.8813126436435L334.43818118423223,671.9470302448608L340.77372556645423,674.2360833887942L333.0560527117923,695.8082911702804Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M250.53856518305838,693.3205143003725L255.0525715276599,680.2313180817291L255.35787045396864,680.344730142504L255.79728001914918,679.7703864746727L256.4063000995666,679.3812478040345L257.10130876582116,679.1679498618469L257.51231843046844,679.1825165515766L260.3680861648172,670.8555678213015L265.16530262399465,672.5140912085772L262.4657343411818,680.3801063783467L257.22831942979246,695.637653217651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.0582565497607,682.5203684866428L296.21270452812314,676.4970428645611L296.9992239838466,675.7811938314699L297.9419428901747,673.1373379747383L295.57449566107243,672.279983477667L300.1311018569395,659.5809278134257L306.94155567884445,662.0333404573612L302.42044935934246,674.6543557420373L299.040072360076,684.1362295239232L298.2180530298501,683.838653084822L297.7715434897691,685.1142778755166L294.97967553138733,684.1154199833982L295.37648524716496,682.9885832495056Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M301.13062056247145,685.6105853389017L304.7516078259796,675.4971432527527L302.42044935934246,674.6543557420373L306.94155567884445,662.0333404573612L313.63130992557853,664.4493354340084L305.3188169421628,687.7009029570036L303.28506853990257,688.3813745616935L301.6907297037542,687.8070315592922Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M339.61090743355453,699.0035900506191L339.88070648442954,698.2742171715945L347.5975904511288,676.6947337160818L353.9189348835498,678.9702590783127L349.5753279402852,691.1375960134901L348.3990987436846,690.7057984615676L344.81282246951014,700.740142296534L342.62287461571395,701.1022274293937L340.70272581558675,700.4144737529568Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M364.8749852348119,629.9583781706169L372.01124902348965,610.5408166386187L378.5171928051859,612.9505866360851L371.3880289932713,632.3681414178573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M306.8350560525432,642.7500911112875L313.5113992365077,624.5863511301577L320.46306367311627,627.1667558844201L320.4417637484148,627.2375089041889L313.79460935108364,645.3221652405336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M366.21451385784894,834.7706973259337L368.6947718001902,828.1731726159342L382.71958913560957,833.5023832540028L388.5873240502551,835.7414412470534L386.0928661590442,842.3389587518759L379.0489020459354,839.6535482681356L379.48121163714677,838.4986445633695L374.0812861863524,836.4499905817211L373.63477664627135,837.6059350809082L370.7995199523866,836.5207414655015Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M320.62636309862137,687.5021719406359L322.83682199101895,681.3154956856743L327.1315179951489,669.3177396347746L334.43818118423223,671.9470302448608L330.1718850787729,683.8813126436435L327.8967375261709,683.0728619042784L325.6720786849037,689.2949127857573L324.1195508111268,690.2521508857608L321.41288255434483,689.2741032582708Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.3254283256829,800.7050949842669L409.67740542441607,786.6734433248639L411.9383530272171,777.2270855391398L415.5664402656257,778.0989935393445L413.25579283759,787.7856967439875L416.4168594973162,788.5441931262612L415.2477302746847,793.4270766270347L413.1216821987182,802.3417376577854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.5429437998682,698.8974616196938L356.59089215192944,693.1925357915461L360.79328848142177,681.4507577554323L367.4546428285539,683.8532197619788L361.26819792203605,701.1376035623252L360.22607936523855,701.7254716260359L359.04985016863793,701.2999175819568L358.7737400298938,700.2729692063294L357.50521115772426,699.8120389357209L356.9309020675719,700.4997926694341L355.535362531431,700.0034862747416L355.40046300552785,699.2023207396269Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M261.55851530935615,834.5657277991995L263.91807367745787,827.9962951927446L276.29885235149413,832.4744140091352L281.7910774759948,834.45856098691L279.45913012418896,841.0352706457488L279.0197205590084,840.8719194456935L261.8985252259299,834.685380062554Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M275.6046325704083,632.0778461494483L278.36100065428764,624.4094685097225L293.6685468107462,629.9583781706169L290.9113898416981,637.6267496710643Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.56376243103296,659.7224331912585L360.3041790910065,646.8319057198241L362.90513660851866,639.759741592221L363.33034622389823,639.9158141450025L364.2801651051268,639.7878346517682L364.7550745457411,639.8304944830015L365.6693935515359,640.0781295979396L366.49141288455576,640.5598735129461L367.157232764177,641.2330663600005L368.3902617599815,641.786603549961L367.71734190452844,643.6282589235343L361.04809869546443,661.7638560379855Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M273.4856844674796,734.9196470389143L278.5456000044942,721.2353797079995L284.8669444350526,723.5878853122704L277.87189126294106,742.5161101208068L275.4910329701379,741.630671555642L273.51408436801285,740.0356332948431L275.17232298012823,735.5428881947882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M276.8376615680754,745.3160096989013L277.87189126294106,742.5161101208068L284.8669444350526,723.5878853122704L289.982870885171,725.494028145913L284.41333492007107,740.5673127546906L283.66152645274997,740.2978313891217L280.8625585194677,747.8807624992914L277.62418102286756,746.6759010585956Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M420.1940462095663,768.8149365033023L422.4407938634977,760.4735289211385L422.53940462879837,760.0979208350182L436.48612223844975,765.1368941068649L434.4665737859905,772.6771390349604Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M278.36100065428764,624.4094685097225L280.954858195968,617.2020181887783L296.26240435242653,622.7446906990372L293.6685468107462,629.9583781706169Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M300.2376014813781,640.3049550303258L306.0343366479501,624.544731692411L310.56964291632175,626.2313592704013L311.4555620243773,623.8288772939704L313.5113992365077,624.5863511301577L306.8350560525432,642.7500911112875Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M262.22433518990874,666.8164270250127L264.287272377871,661.5724076423794L263.49996403604746,659.8358455877751L264.20917265396565,658.0358137576841L265.54870127514005,657.3844726476818L269.1980884373188,648.1501971026883L274.83862415421754,650.403881709557L267.5895496523008,668.7579617663287L264.8749925335869,667.8725137831643Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M280.954858195968,617.2020181887783L283.48481596354395,610.1724838479422L298.785262145102,615.7214049007744L296.652114094235,621.6605039341375L296.26240435242653,622.7446906990372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M242.38937162421644,690.5143508650362L242.58738203905523,689.9472913742065L245.00374020729214,682.9459236827679L246.90337796974927,677.4251493471675L255.0525715276599,680.2313180817291L250.53856518305838,693.3205143003725Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.8652001284063,772.258872592356L409.2947956593707,755.7404493559152L415.6942398156971,758.0502841500565L412.02276384085417,771.7417620578781L411.1021337462589,775.192979935091L406.5518386410549,773.9600307247601L406.8571375673637,772.805116076488Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M283.48481596354395,610.1724838479422L285.95087395608425,603.2979752635583L301.2655200883746,608.8541852403432L300.9957210365683,609.584608017467L298.785262145102,615.7214049007744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M313.79460935108364,645.3221652405336L320.4417637484148,627.2375089041889L324.10535086132586,628.5911805154756L322.4542122259736,633.0839949315414L325.27526897005737,634.1400868282653L320.2855642968789,647.7246397705749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.04809869546443,661.7638560379855L367.71734190452844,643.6282589235343L371.60023935791105,645.0599635536782L369.30458076577634,651.2966152997687L372.1603484991938,652.3599877934903L371.9623380834237,652.8906334992498L367.7804527943954,664.2578871119767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M274.555414037779,667.1140041975304L280.49414870515466,652.0686528808437L287.212302852422,654.740609772969L281.27356818690896,669.7859552893788Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M263.68456338718534,697.8777962145396L268.9282893873751,682.6056876261719L275.70324333384633,684.9582063402049L270.4666173104197,700.215743101202Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M254.6983616631478,659.637113771867L255.61978064384311,657.1357976696454L260.08487604930997,645.0526801720262L267.043640460819,647.6466035810299L261.6508149858564,662.2310317242518Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M423.5957231344655,751.2758070430718L427.0470998827368,741.2332126111723L437.2655417183414,744.7697640494443L436.57842191308737,746.7685026805848L433.8149538561702,754.8258794224821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M314.1133193420246,683.7252410799265L320.1656536087394,666.8091436685063L327.1315179951489,669.3177396347746L322.83682199101895,681.3154956856743L319.0028354758397,679.9264581296593L317.24598610028625,684.8520776913501Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M257.22831942979246,695.637653217651L262.4657343411818,680.3801063783467L268.9282893873751,682.6056876261719L263.68456338718534,697.8777962145396Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M267.4546501254663,669.0909151518717L267.5895496523008,668.7579617663287L274.83862415421754,650.403881709557L275.03032347839326,649.8930049780756L280.49414870515466,652.0686528808437L274.555414037779,667.1140041975304L272.35126623604447,666.2285560015589L271.2247368656099,669.0701055657119L270.36011768411845,670.253130434081Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M340.48972656484693,825.720818746835L342.7932740179822,819.4354224526323L356.1514825867489,824.3671856285073L359.0782500691712,825.4513406916521L358.22783083841205,827.7830018205568L355.56376243103296,826.7914476762526L354.11063420865685,830.7524611344561L351.445776916109,829.7671501450241Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M342.7932740179822,819.4354224526323L345.26643198542297,812.6818144880235L358.63174052815884,817.6281488663517L356.1514825867489,824.3671856285073Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M248.54741663113236,654.4992180718109L253.16792260017246,642.0061455438845L260.2331866379827,644.635446514003L260.08487604930997,645.0526801720262L255.61978064384311,657.1357976696454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.84255040530115,840.6815164489672L417.0400795266032,837.3718329244293L418.4009080734104,837.0950721451081L418.96101721469313,835.5499976533465L416.8065692363307,834.7634141440503L420.03074678592384,825.8623207318597L420.6618556762114,824.1476494097151L426.62189026828855,826.3305258136243L422.75240387860686,836.9681367431767L420.74705537687987,842.4815008533187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.0431518703699,755.3929336066358L372.7772574396804,742.1623508953489L379.43151181191206,744.5647918619215L379.3037122618407,744.9258342385292L375.5478254724294,755.4283094597049L374.63350646663457,757.9868157254532L369.47419128008187,755.959987741895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M262.3805346414447,730.7879417361692L265.5834122635424,722.1135375765152L267.43335020076483,717.103666249197L273.81149443332106,719.478023161646L268.75867887213826,733.1622939645313Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M400.31569390837103,799.2598965214565L403.61087120790035,785.4259296902455L404.6245898641646,781.1881273179315L407.0125481309369,781.7697458192706L406.04931818600744,785.7942531728186L409.67740542441607,786.6734433248639L406.3254283256829,800.7050949842669Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.02276384085417,771.7417620578781L415.6942398156971,758.0502841500565L422.4407938634977,760.4735289211385L420.1940462095663,768.8149365033023L418.9113173894584,773.6052326415665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M289.10484064090997,742.1904435418546L294.63177675474435,727.2160071660765L299.89759156573564,729.1720915758051L293.2362372195348,747.2356726345606L290.8048902153969,746.3356681270525L291.9393084477633,743.2392355389893Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M214.85014627035707,794.7879990120418L218.8545321850106,783.8527512094006L226.69211572781205,786.7441947176121L225.28158735577017,790.5928612654097L222.67352986335754,797.6794379581697Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M232.89986055810004,822.8512410754338L235.20340801216662,816.5648017232306L238.57668503466994,817.8123097526841L248.8448266973719,821.596450757701L246.54206812940538,827.8964114692062L236.11062704306096,824.0415228940547Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M329.6117759384215,785.816102869343L332.0281341057271,775.4125177045353L341.42534549627453,777.6162187173031L338.01656859740615,787.7929799729027Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M228.17995493859053,650.7722123665735L228.7826639302075,649.1636269288138L233.82127953972667,635.5L239.58961480669677,637.6475593512878L235.20340801216662,649.5246742740273L234.8697091853246,650.4111650856212L232.85726070962846,649.6599369640462L231.90113073866814,652.2601015390828L230.81641233246773,652.5930557167158L228.54205366503447,651.7502654246055Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M235.20340801216662,649.5246742740273L239.58961480669677,637.6475593512878L239.81681400723755,637.0378356883302L246.5917679546401,639.5610092007555L241.97836195863783,652.0551266158Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M238.18697529565543,810.7184704369865L240.44003403745592,804.5745629617013L243.9482105858624,805.8709747134708L253.3170220758766,809.3294588071294L253.8692423561588,809.5417122878134L251.61618361528963,815.6793726161122L251.09157434944063,815.4806452686898L240.82974377740175,811.6965009304695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M241.97836195863783,652.0551266158L246.5917679546401,639.5610092007555L253.16792260017246,642.0061455438845L248.54741663113236,654.4992180718109Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M375.5478254724294,755.4283094597049L379.3037122618407,744.9258342385292L387.1625957293436,747.7673515453935L383.4138089157641,758.2562964037061Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M307.4874648693949,801.9734150543809L308.5145945902914,799.1745788208209L308.7772936662659,798.4587424551137L318.4506151964888,800.6624361416325L318.5145149724558,800.5063672056422L330.38409544341266,803.539306210354L328.61304611712694,808.4513119850308L317.15368642564863,804.3050840813667L317.25308607518673,804.0147960125469Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M339.3418972687796,653.7198973884806L344.08310281392187,640.8147919862531L345.75554137676954,636.2585130422376L348.2357993181795,637.1793415253051L346.56336075626314,641.7366603468545L349.5256281150505,642.8354107383639L344.7844225689769,655.7394718979485Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.093267833814,798.0051019326784L398.31034540664405,784.518646907527L399.4794746283442,779.614947875496L402.64764126203954,780.3880116282962L401.5629228549078,784.9369126078673L403.61087120790035,785.4259296902455L400.31569390837103,799.2598965214565Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M282.96020669769496,744.5148493982852L284.41333492007107,740.5673127546906L289.982870885171,725.494028145913L294.63177675474435,727.2160071660765L289.10484064090997,742.1904435418546L286.9716925881803,741.4038494387642L285.47596451546997,745.4502300517634Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M367.44044287875295,665.1859952346422L367.7804527943954,664.2578871119767L371.9623380834237,652.8906334992498L375.51942557189614,654.2089237268083L376.56154412962496,651.3819348206744L378.8714026706293,652.23200852843L373.34367766976357,667.2773594926111L373.3152777692303,667.3616383355111Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M223.09163950383663,647.0379212792031L224.06275830976665,644.4148641186766L228.14445506315678,633.388856946025L233.82127953972667,635.5L228.7826639302075,649.1636269288138Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.35528670158237,824.1830249149352L205.36852406524122,818.6977385873906L212.362788352184,821.2780710868537L211.15105928108096,824.5867218398489L212.27758865244687,825.0049851224758L213.92872728966177,823.7439524587244L222.3903197478503,826.8757245824672L220.9939913256094,830.6962765636854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.39253805018961,829.5403309096582L203.35528670158237,824.1830249149352L220.9939913256094,830.6962765636854L219.66235156543553,834.3243423574604L211.05165963061154,831.1426317621954L210.69034979026765,829.3072689380497L209.76183083374053,828.9670400591567L208.57850166317075,832.1914103049785Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M417.3808783283457,682.4288064851426L423.00011411868036,666.9724989715032L427.8194193886593,668.7371521801688L422.1993947122246,684.1924152830616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.8661410845816,819.768368599005L268.82967862300575,814.3049283870496L282.30858676787466,819.1732273492962L280.34504923038185,824.6512301103212L279.7715290253982,824.437936635688Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.36852406524122,818.6977385873906L207.33127271663398,813.3404242130928L207.96159272175282,813.5745271784253L217.86211345344782,817.2317347330973L224.98417729139328,819.8599287881516L223.68014854378998,823.4390988172963L215.1901561850682,820.3000419461168L214.61663598008454,818.6269875220023L213.4822177477181,818.2087238519453L212.362788352184,821.2780710868537Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M334.1683821324259,651.7929251845926L339.9588062092662,636.0389708695002L342.0564543865621,636.8110101465136L341.00723585579544,639.674421927426L344.08310281392187,640.8147919862531L339.3418972687796,653.7198973884806Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M383.59840826690197,795.2343565230258L386.81548583880067,781.7624625815079L392.6122210044414,783.1441964986734L389.3880434576422,796.6306541971862Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.02758765779436,778.5734446207061L363.22384659945965,772.6344800191L374.9593164315447,776.2844259324484L378.55269268061966,777.4039642582648L377.88608391489834,779.2112483307719L374.59800659120083,777.9918258539401L373.188267105259,781.8124047755264Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M365.27889492642134,767.0357422647066L367.49724267888814,761.0052068168297L379.0489020459354,765.5478777261451L382.1807799199596,766.7881116843782L381.53625996410847,768.8784048268571L377.9996835142374,767.7734316289425L377.09246448334306,770.713783653453Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M379.0631019966677,827.6841585491784L379.8922213027254,824.9488005046733L382.6485893856734,815.8780999584123L388.2402141606435,817.2379774781875L385.1998470770195,827.237803127151L384.5979269724339,829.2573270862922L384.18612842075527,830.6182424332947L383.71200786624104,830.8804371040314L382.82608876004815,831.3694509463385L380.5793411079794,830.6817101920024L380.0831317426637,829.3707367070019L380.465741507709,828.1159475683235Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M389.3880434576422,796.6306541971862L392.6122210044414,783.1441964986734L398.31034540664405,784.518646907527L395.093267833814,798.0051019326784Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M283.07380629889667,806.1903955456801L286.10707340668887,793.4978279503994L292.0876190382987,794.9929697150365L289.0835407143459,807.5294657964259Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M358.99305036943406,784.0941384057514L361.02758765779436,778.5734446207061L373.188267105259,781.8124047755264L376.38404475338757,782.6551792551763L375.767924699001,784.986854779534L372.35204782523215,784.0795719395392L371.2602294422686,787.0490499706939Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M350.1133482698351,657.7028598417528L354.85455381590873,644.8050452363677L360.3041790910065,646.8319057198241L355.56376243103296,659.7224331912585Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M356.94510201830417,789.6782959285192L358.99305036943406,784.0941384057514L371.2602294422686,787.0490499706939L369.29748079087585,792.3637257721275L364.8118743458763,791.3856925517321L364.42847569379956,793.1295048799366L360.85718825738877,792.3637257721275L361.22559807263315,790.6136704864912Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.1993947122246,684.1924152830616L427.8194193886593,668.7371521801688L432.3476256830618,670.401918948628L426.7276010066271,685.8509354772978Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M363.22384659945965,772.6344800191L365.27889492642134,767.0357422647066L377.09246448334306,770.713783653453L379.38181198667735,771.4160968516953L378.67339225672185,773.7404929092154L376.0014349874109,772.9185266238637L374.9593164315447,776.2844259324484Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M268.82967862300575,814.3049283870496L270.67172770015895,809.1879564831033L284.14353586919606,814.0562590388581L282.30858676787466,819.1732273492962Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M344.7844225689769,655.7394718979485L349.5256281150505,642.8354107383639L354.85455381590873,644.8050452363677L350.1133482698351,657.7028598417528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M268.75867887213826,733.1622939645313L273.81149443332106,719.478023161646L278.5456000044942,721.2353797079995L273.4856844674796,734.9196470389143L271.57894673012197,735.3868177942932L269.7510976046324,734.7001079875045Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M277.50348144583404,804.9428854235448L280.5793484048918,792.1015296471305L286.10707340668887,793.4978279503994L283.07380629889667,806.1903955456801Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M289.0835407143459,807.5294657964259L292.0876190382987,794.9929697150365L297.7644435139373,796.4173598638736L295.3338853958994,806.5660011349246L294.7950761811808,808.8050678269938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M378.5171928051859,794.0149368653074L381.74137035384774,780.5295145390555L386.81548583880067,781.7624625815079L383.59840826690197,795.2343565230258Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.5979269724339,829.2573270862922L385.1998470770195,827.237803127151L388.2402141606435,817.2379774781875L394.7311691083014,818.8184315795079L391.0604820186272,828.7402208000422L387.64460514485836,827.6841585491784L386.95038536470383,829.9731602682732Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M238.57668503466994,817.8123097526841L240.82974377740175,811.6965009304695L251.09157434944063,815.4806452686898L248.8448266973719,821.596450757701Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M213.1280078822747,799.4794335281476L214.85014627035707,794.7879990120418L222.67352986335754,797.6794379581697L227.87544489931315,799.6063696132042L226.15330651123077,804.2842749012634Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M242.18347234930843,765.313773136586L244.60693049058318,754.90391440643L250.90697499737144,756.3917812285945L248.49061683099717,766.7881116843782Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M218.63443295937032,759.7868216019124L221.0578911015764,749.3904806431383L227.3721355581656,750.87106538238L224.94867741595954,761.2746873768046Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M313.56741015054286,814.2976451832801L315.4812478637323,808.9684197837487L326.9406075552106,813.1208876450546L325.033869817853,818.4501098543406Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M211.42716942168772,804.141732017044L213.1280078822747,799.4794335281476L226.15330651123077,804.2842749012634L224.445368074812,808.9465701580048L221.3276901524514,807.7916613379493Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M265.3428019983694,770.7429166468792L267.7662601424381,760.3465921198949L274.0521046984941,761.8136484674178L271.6357465311885,772.216213577427Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M218.62023300956935,642.3890434107743L222.70192976295948,631.361992531456L228.14445506315678,633.388856946025L224.06275830976665,644.4148641186766Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M271.8061459315941,803.6745658945292L276.3911520270631,791.0527450400405L280.5793484048918,792.1015296471305L277.50348144583404,804.9428854235448Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M367.49724267888814,761.0052068168297L369.47419128008187,755.959987741895L374.63350646663457,757.9868157254532L381.01875067315996,760.5026619574055L379.0489020459354,765.5478777261451Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M236.08932711742818,763.8831338062882L238.50568528659642,753.4795157262124L244.60693049058318,754.90391440643L242.18347234930843,765.313773136586Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M383.4138089157641,758.2562964037061L387.1625957293436,747.7673515453935L392.81102030631155,749.7941819252446L389.0622334908694,760.2966497703455Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M253.65703199151903,768.0075361351483L256.07339015975595,757.6039242446423L262.1257244264707,759.013755552005L259.70857737213373,769.4173653270118Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M311.73956102505326,819.3854805296287L313.56741015054286,814.2976451832801L325.033869817853,818.4501098543406L323.2123317811638,823.5244162194431Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M309.9180229874328,824.4733121385798L311.73956102505326,819.3854805296287L323.2123317811638,823.5244162194431L321.3773826798424,828.6122447913513Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M300.3867009570822,778.9636181881651L302.8101590992883,768.5673059886321L308.79859359096736,769.969851818867L306.37434656266123,780.3661619117483Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M277.2344712819904,773.5417643589899L279.6579294251278,763.1381607744843L285.6747638164088,764.5417481670156L283.2505167881027,774.9453496490605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M323.69434119574726,784.4343694867566L326.1114882500842,774.0307822460309L332.0281341057271,775.4125177045353L329.6117759384215,785.816102869343Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M212.76669804286212,758.4113258235157L214.91404604539275,749.1844681259245L215.1901561850682,748.0087399980985L221.0578911015764,749.3904806431383L218.63443295937032,759.7868216019124Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.5260660164058,777.5881262146868L296.94952415768057,767.1855691652745L302.8101590992883,768.5673059886321L300.3867009570822,778.9636181881651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M317.8692061295733,783.0734450696036L320.2926642727107,772.6698557897471L326.1114882500842,774.0307822460309L323.69434119574726,784.4343694867566Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M265.3286020476371,824.0560892764479L266.8661410845816,819.768368599005L279.7715290253982,824.437936635688L279.6508294502273,824.7927321172319L280.4586488297209,825.0830193161964L279.7644290504977,827.0109838084318L279.01340946927667,826.741505805403L278.82171014416963,827.2731786156073L278.23320110235363,827.060925676953L277.709380723536,828.5414938265458Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M312.10087086446583,781.7198036247864L314.5243290066719,771.3162123118527L320.2926642727107,772.6698557897471L317.8692061295733,783.0734450696036Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M306.37434656266123,780.3661619117483L308.79859359096736,769.969851818867L314.5243290066719,771.3162123118527L312.10087086446583,781.7198036247864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M288.8137416644022,776.2563334242441L291.23719980567694,765.8527339138091L296.94952415768057,767.1855691652745L294.5260660164058,777.5881262146868Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M220.51987077202648,612.9620320000686L222.89362908899784,615.5226718243212"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M230.39830269105732,762.5502979182638L232.82176083419472,752.1466778381728L238.50568528659642,753.4795157262124L236.08932711742818,763.8831338062882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M259.70857737213373,769.4173653270118L262.1257244264707,759.013755552005L267.7662601424381,760.3465921198949L265.3428019983694,770.7429166468792Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M283.2505167881027,774.9453496490605L285.6747638164088,764.5417481670156L291.23719980567694,765.8527339138091L288.8137416644022,776.2563334242441Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M271.6357465311885,772.216213577427L274.0521046984941,761.8136484674178L279.6579294251278,763.1381607744843L277.2344712819904,773.5417643589899Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.62767667043954,824.6585132996552L374.0102864354849,823.4182896958664L376.7311546429992,814.439147404395L382.6485893856734,815.8780999584123L379.8922213027254,824.9488005046733L376.5970440050587,823.9426795691252L376.1434344891459,825.4305315744132Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M315.4812478637323,808.9684197837487L317.15368642564863,804.3050840813667L328.61304611712694,808.4513119850308L326.9406075552106,813.1208876450546Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M245.93935913778841,800.435615954455L248.0086074154824,794.7952822339721L257.3774189054966,798.2600146164186L255.30817062873393,803.8941027615219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M224.94867741595954,761.2746873768046L227.3721355581656,750.87106538238L232.82176083419472,752.1466778381728L230.39830269105732,762.5502979182638Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M308.27398432511836,829.0377910202369L309.9180229874328,824.4733121385798L321.3773826798424,828.6122447913513L319.7475439682603,833.1829636772163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M243.9482105858624,805.8709747134708L245.93935913778841,800.435615954455L255.30817062873393,803.8941027615219L253.3170220758766,809.3294588071294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M248.49061683099717,766.7881116843782L250.90697499737144,756.3917812285945L256.07339015975595,757.6039242446423L253.65703199151903,768.0075361351483Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M218.8545321850106,783.8527512094006L221.10759092587978,777.7233864055015L229.05877406988293,780.280843981076L229.03037416841835,780.3453526608646L226.69211572781205,786.7441947176121Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M202.15775758121163,755.2576729771681L204.56070468388498,744.9185509639792L209.69083108380437,746.1234127101488L209.28692139312625,747.8734792280011L207.2815728923306,756.4698161915876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.0005520200357,821.8804953526706L368.26246220897883,821.1854704609141L371.22472956683487,813.1000784914941L376.7311546429992,814.439147404395L374.0102864354849,823.4182896958664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M263.91807367745787,827.9962951927446L265.3286020476371,824.0560892764479L277.709380723536,828.5414938265458L276.29885235149413,832.4744140091352Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M229.8381935507059,791.8320502848364L233.50966952554882,781.8259307872504L238.42758555989712,783.1868554488756L234.70719864498824,793.3490420808084Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M207.13957339152694,757.0940958778374L207.2815728923306,756.4698161915876L209.28692139312625,747.8734792280011L214.91404604539275,749.1844681259245L212.76669804286212,758.4113258235157Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M209.69083108380437,808.8758189929649L211.42716942168772,804.141732017044L221.3276901524514,807.7916613379493L219.59135181549937,812.5257458221167Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M248.0086074154824,794.7952822339721L249.83724542707205,789.8062726566568L259.20605691801757,793.2710075308569L257.3774189054966,798.2600146164186Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M207.96159272175282,813.5745271784253L209.69083108380437,808.8758189929649L219.59135181549937,812.5257458221167L217.86211345344782,817.2317347330973Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M234.70719864498824,793.3490420808084L238.42758555989712,783.1868554488756L243.04099155496806,784.7392248432152L239.39160439185798,794.7172477017157Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M225.28158735577017,790.5928612654097L226.69211572781205,786.7441947176121L229.03037416841835,780.3453526608646L233.50966952554882,781.8259307872504L229.8381935507059,791.8320502848364Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M233.02766010910273,832.4608880961314L234.57229912094772,828.2366403974593L245.00374020729214,832.0988098233938L243.44490124564618,836.3230551686138Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M234.57229912094772,828.2366403974593L236.11062704306096,824.0415228940547L246.54206812940538,827.8964114692062L245.00374020729214,832.0988098233938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M381.1678501497954,645.9818313503638L382.48607884626836,642.4025696939789L389.4519432326779,644.9819273338653L390.04045227356255,645.2014692262746L388.7222235770896,648.780729434453Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M419.0288614202291,645.6842532702722m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M320.7360182693228,746.7685026805848m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M386.5472645610571,718.7122359201312m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M234.36324430070817,674.1081045269966m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M355.9605721468106,613.5457455897704m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M410.25408117379993,720.4664712431841m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M309.73263475019485,706.8591704294086m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M364.8947073891759,618.9885342917405m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M300.9333990337327,807.7666903338395m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.38623771071434,623.9350068769418m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M313.4514438919723,675.2671975325793m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.3272160254419,686.2515190304257m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M392.5585767487064,763.4294910221361m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M402.7288965312764,761.7491396134719m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M287.76531201880425,663.665853951592m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M294.3998442366719,665.9309787927195m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M353.196315202862,691.8503220318817m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M335.47162199392915,679.0586996930651m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M256.5072775222361,686.8508335985243m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M299.937824758701,672.7086607399397m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M306.709623160772,675.0757495099679m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M348.25552147161216,684.8375110174529m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M371.69806123524904,621.4544876208529m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M313.63840990141034,634.9932841053233m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M328.6382904741913,676.63126454968m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M412.2397075230256,790.9861555378884m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M362.02316193282604,688.5228793504648m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M361.05125424079597,653.2776926918887m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M279.17670889478177,729.2532482566312m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M284.3376018535346,732.8959337174892m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M287.3117025028914,623.5770796565339m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M306.57314586266875,633.2681607245468m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M267.661338288337,658.9358297302388m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M289.87006017100066,616.4622318288311m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M248.3525617606938,686.4460881752893m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M410.34874750766903,764.8965467144735m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M319.53533360362053,639.7306080474518m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M366.50482394732535,657.3272461867891m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M280.8838584451005,660.927309746854m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M269.6942978044972,691.4174840492196m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M261.3313161097467,652.3912022504956m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M321.3016496123746,674.6221009111032m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M263.0779099659994,689.1221937220544m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M274.5420029750094,659.1480878167786m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M349.20139592140913,824.9092631824315m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M350.7121128300205,818.5312654906884m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M254.3165407832712,649.7764709703624m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M373.67422095127404,750.1593858981505m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M267.60927180573344,726.4512612475082m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M404.99457745067775,792.966152550187m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M417.62148859351873,764.6447542002425m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M294.5023994324729,735.6812706142664m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M220.06389459688216,792.6904304567724m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M240.8731325129047,822.2238459438086m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M234.18495603930205,643.4055955302902m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M240.8975879829377,644.5428435276262m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M246.02771438285708,810.1306116161868m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M247.57156450860202,647.0306379022077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M381.3556050444022,751.5983517938294m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M344.4333682479337,648.2771359579638m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M399.3532528495416,791.7155186636373m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M289.5237391665578,733.8916631750762m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.9642234481871,659.2334072408266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M228.94517446961254,639.957433491014m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M422.60014885943383,675.5824624723755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M274.58775837067515,819.4707979816012m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M209.43838752806187,818.4178556893021m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M339.1265313597396,646.3043809994124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M388.1045257495716,789.1892791469581m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M369.21149220503867,776.8441951177083m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M373.1070118350908,766.1679947334342m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M384.0654288455844,821.0939102913253m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M393.85077220387757,790.5751734287478m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M287.5791348963976,800.5916848927736m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.72838630899787,783.3678958648816m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M355.2087636794895,652.26738491375m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M371.32176255993545,772.0247682323679m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M276.4866072461009,814.1800734852441m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M349.8190937489271,650.2727809636854m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M273.6505616661161,727.1983191645704m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M281.8068551989272,799.2203590497375m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M293.53995837364346,801.4916823557578m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M382.6675226511434,787.888702431228m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M244.83491857815534,816.6469978378154m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M220.5025152778253,799.5429015723057m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M246.54601255990565,760.8532988522202m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M223.00407314486802,755.3294651587494m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M320.25400885380805,813.7087462088093m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M218.79063240997493,804.2124832300469m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M269.69982000719756,766.2782839937136m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M223.3827384794131,637.8889516387135m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M374.2579966755584,760.753414160572m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M240.34694547671825,759.3935255603865m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M388.1132034966722,754.0247202208266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M257.8909837650135,763.5106473015621m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M318.3867154214531,818.9183154343627m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M316.5643884977326,823.9988641957752m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M304.59225283097476,774.4667364615016m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M281.45422310661525,769.0417577256449m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M327.86123765073717,779.9229248324409m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M216.9115056861192,753.9009046996944m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M298.66771811433136,773.0777175701223m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M321.99192496202886,778.5515949013643m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M272.54927665088326,824.2475331872702m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M316.19676756858826,777.1948311827146m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M310.44973222725093,775.841188589111m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M292.8820273531601,771.7209527804516m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M234.45317731704563,758.0149083076976m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M263.7358409855515,764.8819802054204m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M287.24385829642415,770.3985230401158m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M275.6456546485424,767.6777088949457m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.32786013837904,819.6476756222546m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M322.04714698996395,808.7093456606381m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M251.6579945795238,799.3483356013894m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M228.8852191241458,756.7112043420784m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M314.8256835024804,828.8255381379277m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M249.62819060776383,804.8825388066471m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M252.28279238101095,762.1965397186577m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M223.94442539196461,782.0985319274478m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.6037024958059,817.8123097526841m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M270.81451608706266,828.2688945163973m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M234.1344673279673,787.5099744452164m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M211.0989927975461,752.8271431168541m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M215.50886617414653,808.3337401878089m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M253.60733216721565,794.0326246949844m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M213.7764722686261,813.05013652239m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M238.8748839860782,789.0436145667918m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M230.09931485448033,784.285583420191m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M247.51239804830402,788.9416493573226L248.44801698066294,786.3904377510771L250.77286435849965,787.2550613665953L251.55938381515443,785.1210743645206L261.310805070214,787.5453501371667L259.20605691801757,793.2710075308569L249.83724542707205,789.8062726566568Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M548.8866157662123,612.9620320000686L532.6600172864273,656.8954465324059L507.7856492260471,727.0599365755916L491.21667417138815,773.56985687837L471.41642159596086,828.3011486325413L470.9288899768144,829.6360527910292"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M564.863137348555,805.7013799287379m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M451.61616901960224,765.4563168222085L425.1435176897794,755.9391784165055"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M425.1435176897794,819.7413167259656L471.05668952688575,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,696.457547721453L532.6600172864273,656.8954465324059L425.1435176897794,617.0438641491346"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,699.495734619908L507.7856492260471,727.0599365755916L641.8174000009894,775.6185294426978"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M638.1340907346457,829.6360527910292L641.8174000009894,819.3688332196325"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M487.27461025863886,829.6360527910292L425.1435176897794,816.2443409091793"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M477.974431861192,829.6360527910292L471.41642159596086,828.3011486325413L425.1435176897794,817.1776309683919"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M491.21667417138815,773.56985687837L592.2516854554415,805.9281999440864"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M629.3032995732501,612.9620320000686L641.8174000009894,617.5079213855788"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.872687314637,677.1837584343739L414.71602103486657,625.3448653696105L435.37379281781614,632.9206388327293L435.2530932407826,633.2463105446659L426.21798057854176,658.1211331961676L423.00011411868036,666.9724989715032L417.3808783283457,682.4288064851426L416.53755907248706,684.7459490434267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M518.9752098675817,719.6049607144669L520.1656390121207,716.2244672724046L521.4270679093897,715.4805295905098L522.4052866902202,715.8280473416671L527.0115927103907,702.766986425966L526.3528728047386,702.5266368682496L527.4936021259055,699.2803563466296L531.0364896636456,700.5414116540924L530.767479499802,701.2999175819568L562.253502083011,712.4974947529845L563.975640470162,707.6072709313594L574.5206811558455,711.363379323855L572.2100337278098,717.9183558509685L565.7545786574483,736.1879791473038L545.9756260057911,729.1575249885209L546.4718353711069,727.7268781992607L525.0346441082656,720.1012657051906L524.4319351166487,721.7878700364381L522.8943960806355,722.1000114488415L519.3933195071295,720.8524861936457Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.8611361384392,684.1435128641315L644.7070898367092,664.8748917393386L675.3568931398913,675.8373796604574L673.4296443620697,681.2728361082263L674.1380640929565,681.5350364283659L674.5064739072695,682.4288064851426L679.0070691900328,684.0373842031695L679.7935886448249,683.5910195317119L680.6085080001503,683.8813126436435L680.8917181156576,684.7386657060124L680.6156079750508,685.5179829001427L679.8290885202587,685.8082759305835L678.2481607468799,690.2521508857608L678.6591704124585,691.2791007454507L678.2126608733088,691.9387624794617L677.3835415663198,692.2717147516087L676.8100213613361,692.0521743497811L676.5899221356958,691.1594460085034L671.7359058763832,689.4156080316752L671.090597034432,689.7839366127737L670.5596766797826,689.5924889910966L668.6742388661951,694.893713326659Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.72446351032704,635.0109723419882L511.48473621346056,613.815231882967L512.6609654100612,610.6115698288195L529.0311411619186,616.6568029304035L528.251721682027,618.7898013056256L533.3329371428117,620.6751632248051L538.0457427874207,622.4106946019456L529.8957603434101,644.6708229356445Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M499.3524566665292,772.4503179336898L499.91177692078054,770.8989862515591L502.8030445287004,762.8624374950305L504.0786733748391,763.3368896222673L509.79809770267457,747.4344019391574L508.45146910473704,746.9453821768984L511.80344620440155,737.6269479426555L531.6391986552626,744.8124232362024L531.7882981300354,744.8686085036024L531.0435896394774,746.9245728245005L531.688898479566,747.1576375681907L530.00225996878,751.8709541219287L528.3369213817641,756.49790877942L526.3733838442713,755.7831084728241L523.2415059711784,754.6490001277998L522.8020964059979,755.8601029794663L522.0084769744426,755.5843794108368L516.7568621132523,770.1893897531554L517.9898911109194,770.6367893116549L517.6143813207746,771.656444018241L518.5713001759723,772.0039589521475L519.5069191073999,772.3441906273365L517.1536718299612,778.8991094934754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.8708923170343,838.42061052192L563.4794311048463,830.3914232281968L564.7053601257503,830.6390515342355L564.9680592017248,829.3280780427158L567.2708177678287,829.7962828911841L569.0639559049159,820.8098656642251L567.0373074794188,820.4061685176566L567.2637177929282,819.3074462725781L565.676478930749,818.9890664969571L567.235317892395,811.2074856981635L578.5108671216294,813.4756837063469L576.3777190688998,824.1403662166558L577.8016585055739,824.4316938999109L577.9578579552472,823.6732014440931L580.0200062571093,824.0841815914027L579.8638068065047,824.848916739691L581.1536356033757,825.1048688883893L583.3932832814753,813.8929072013125L595.3062524888664,816.2953233118169L593.6196139780805,824.7001315369271L591.4083661995828,824.2537759235129L591.1456671236083,825.5512244505808L589.5229283859953,825.2318045068532L587.5459797848016,835.1182090970688L591.38706627395,835.89750938816L590.6289467187598,839.6743573406711L589.743027612567,844.0546660302207L578.1700683198869,841.7084440253675L580.2748164730147,831.2060995171778L574.754191446118,830.079286692664L572.6494432929903,840.596199257765Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.7709606830031,823.5733176581562L609.1038706246763,820.8598075779155L613.1642674524337,808.9184777857736L623.6099084885791,812.4976534633897L623.8087077904493,811.9233207469806L635.5512775965035,815.9623769973405L622.7381893321872,850.1839721859433L610.5775098847225,848.2143960427493L610.840208960697,846.896142702084L612.5765472985804,838.2291670045815L616.856254465878,839.7034900449216L617.2459642067552,837.9170308243483L616.4807446766645,837.3437406667508L618.6067927535623,830.5402083056979L617.8415732234716,829.1720097516663L618.684892478399,826.8975741495378L619.7759219743311,826.4293691059574L619.7901219241321,825.0757361254655L613.2778670527041,822.2977183423936L612.859757412225,824.3963183970191Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M481.48655284103006,821.8305534464307L483.71200056839734,815.7293145665899L484.6760193994269,816.0830700364895L485.84514862205833,812.8514090995304L484.88822976499796,812.4976534633897L487.071077642031,806.516059118323L490.0120450751856,807.5929337642156L492.91751263290644,799.6136528328061L489.97654519975185,798.5440601683222L496.21978990733624,781.3868556488305L506.43192065227777,785.1429240633734L501.01069527771324,800.0173511896282L504.0510623604059,801.1368856821209L502.27212417311966,806.0135175613686L502.9805439049378,806.275713160634L501.78301478363574,809.5635619098321L502.4488346641883,809.803907753434L501.35780516732484,812.7952243825421L502.34312392398715,813.1635464080609L499.8557660076767,826.1245155828074L493.0595121346414,824.7927321172319L493.27172249834985,823.7085769516416L489.9339453512803,823.0562109481543L489.76354594994336,823.9707718836144L482.12476170714945,822.4756363695487L481.6356523167342,822.1073148357682Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M616.0768349869177,800.9600075660273L617.5725630577654,796.8501912876964L618.8055920545012,793.4551690663211L625.0133368857205,795.7368988636881L625.9489558162168,793.1721637663431L627.1890847887844,789.7417640620843L620.9742399817333,787.4745987504721L623.4047980979085,780.7844278649427L645.0825996277854,788.7210715562105L637.2663160087541,810.2513047577813L621.7820593630895,804.5745629617013L622.2703798664734,803.2282089265063Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.1216821987182,802.3417376577854L415.2477302746847,793.4270766270347L418.83321766369045,794.2844161423855L421.341875506565,783.7611905466765L417.7279882179573,782.896566495765L420.0520467106253,773.158873737324L433.4741550544277,776.3832699372433L433.8007539054379,776.461304675322L426.8341006329283,805.6379119437188Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M543.5308679388836,649.6099938172847L552.3608702123165,624.7642742325552L565.9667890211567,629.6327063045464L565.7332787318155,630.305900211446L557.1438867226243,654.4784084428102Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.50302178412676,741.538069867529L418.096398034133,731.403899975121L415.9419500567019,730.6318712281063L418.0679981345311,724.6366801238619L422.98591416794807,726.3940353598446L423.6525229346007,724.5378353805281L422.1425949120894,723.9915880938061L424.3112428402528,717.8684131954797L420.36365672480315,716.4512902139686L423.48922351002693,707.657213659957L437.4501410694793,712.6525251963176L434.381374085322,721.298848465085L431.0009970869869,720.0794158019125L428.1949291797355,728.0026028756984L431.3126071030274,729.1159061775543L429.20075897406787,735.0757174496539L426.7134010568261,734.189237464685L423.0285140192136,744.5856012236327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M442.7719667945057,613.2273563677445L443.0062659708783,612.603063724935L446.3866429682821,603.3624855922535L447.4066727142781,603.7381021711044L452.5020881248638,589.8267488060519L464.7479672729969,594.3403981560841L459.5957520632073,608.4078157274053L460.09906140342355,608.5919821741991L456.76838423032314,617.6910471045412L456.5277739642188,618.3434324329719L452.1052784100175,616.7202726486139L451.9206790588796,617.2311518280767L446.6485531590879,615.282319241669L446.8544524349272,614.7360633481294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M626.5366759719327,757.8088960465975L634.4878591159359,735.2806899175048L638.9458545455709,736.8611627067439L637.7483254252002,740.2551721767522L640.2711832178757,741.1624607550912L641.9862216291949,736.315956861712L648.5623762765899,738.6538907852955L648.0803668601438,740.0075406399556L640.0936838416383,762.6356160729192Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M613.0088568879291,753.0050629242323L620.2863312903792,732.3684155489318L620.960040031001,730.46851742547L634.4878591159359,735.2806899175048L626.5366759719327,757.8088960465975Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.8885734509677,763.2307621762156L640.0936838416383,762.6356160729192L648.0803668601438,740.0075406399556L660.984965913929,744.5928844981827L652.7931725056842,767.8160906708799Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M566.0803886232898,795.928343554493L568.4754468640313,789.2319380599074L568.8162456657737,788.2819968545809L572.2242336785421,789.5014175237156L574.272970915772,783.7819997887127L571.3462034324184,782.7259306902997L572.1114229634404,780.5856995200738L577.8087584804744,764.6624421053566L587.6595793860033,768.1844150885008L582.358264698647,783.0162196480669L581.4652456175536,785.4966810974292L579.0133875757456,784.6112480219454L576.660929184407,791.1880049705505L579.0275875255466,792.0380615349859L576.6254293089733,798.763597194571L576.3280192427337,799.6063696132042Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M527.1322922855616,829.3072689380497L528.5846316209063,821.873212155886L531.9792085699737,822.5391041999683L533.7652467321604,813.3685165676288L530.6751798251644,812.7671320224181L532.68052832596,802.4270553197712L546.5002352716401,805.1270466484129L544.8419966604561,813.6525614997372L541.03641004581,812.9013510700315L538.839362218976,824.2184004187584L542.6307488819584,824.9696096251719L541.7377298017964,829.5829895748757L541.2486204104498,832.0780007280409Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M470.64410208910704,622.8081603613682L474.03867903817445,613.538462178316L475.28590798564255,613.9921147748828L476.3840374555439,611.0163196814246L475.9020280400291,610.8383962269872L477.4829558124766,606.5224504726939L478.1416757181287,606.7638438441791L479.36760473810136,603.4051456497982L478.38307486847043,603.0357719878666L479.64450376387686,599.5917518269271L490.9263640809804,603.7443451071158L489.62943531014025,607.2955335276201L489.0338262943551,607.0614235945977L487.7865973478183,610.4554966152646L488.3751063896343,610.6760800885968L486.7381677022204,615.1262461342849L486.19225851166993,614.9275130368769L485.30633940547705,617.3653746605851L487.0284777926281,618.010476608295L483.5345011930913,627.5631808857433Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M588.3182992907241,744.2099922737107L593.1731044370681,730.447708025109L596.7869917247444,720.1928272112273L608.0404521413147,724.2038441882469L604.2561654523015,734.9050804660656L599.5575597584248,748.2137120841071Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.5345011930913,627.5631808857433L487.0284777926281,618.010476608295L488.82871590554714,618.6763882371597L489.9339453512803,615.6506517641246L489.09062609355897,615.3385055591352L490.65656503103673,611.0725060328841L491.23087412212044,611.2785226553679L492.35030351765454,608.2090824386105L492.0528934523463,608.1029526172206L493.4137219991535,604.3821649006568L504.1496731247753,608.3443459342234L500.08217632211745,619.4702796726488L499.8486660318449,619.3849597591907L498.6006481992081,622.7863101512194L499.13945741485804,622.9850430199876L495.80168026778847,632.0913724526763Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M607.5513427499682,673.6835892666131L607.8069418519735,672.9604565934278L615.2832155553624,651.912580601871L616.5943442760035,648.2063831533305L617.8699731230736,648.6600334816612L626.6786754727364,651.8137348219752L626.6502755722031,651.8990543363616L618.1176833631471,675.9154155305587L617.6293628588319,677.2971705449745Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.1438867226243,654.4784084428102L565.7332787318155,630.305900211446L576.2996193431318,634.3450622810051L573.2450523106381,642.9415400270373L567.795427034609,658.2980149560608Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M583.5281828055158,801.2929546018131L586.2064511636272,793.9160931110382L591.1180561101064,795.7160896589048L592.6200952706859,791.5636113719083L590.9973565340042,790.9684676984325L591.3657663492486,789.9477753755637L588.1975997155532,788.7855801624246L589.3675178224221,785.5819989633746L594.7319433987141,770.8136682007462L594.9023427981883,770.3454593699425L603.0941362064332,773.3430358069018L597.0276019889861,790.0393359586596L592.1593857798725,803.4404625925235Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M529.7395608928055,616.0262676766142L532.6245174109936,608.1674629016779L534.9130760291591,609.0102584916167L536.273904575035,605.3248478835449L533.4323367932811,604.2760350210592L537.804343637079,592.3499395018443L539.300071708858,592.9024401069619L538.9805728336796,593.7878976655193L547.4279653411359,596.9062473056838L538.0457427874207,622.4106946019456L533.3329371428117,620.6751632248051L534.4026667131111,617.7409904804081Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M515.3471226282418,826.9964174325578L516.6298514483497,820.4134517158382L515.3968224534765,820.1647825860418L516.8633617386222,812.6391557194293L519.4288193825632,813.1427372554317L520.8677476551384,805.7929403018206L527.2451030006632,807.0404502735473L525.7004639888182,814.9843471054919L529.7679607933387,815.7854992598295L528.5846316209063,821.873212155886L527.1322922855616,829.3072689380497Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.792792593129,625.0618532071821L562.7710113730282,622.4106946019456L563.2814206890762,621.015402324032L564.3156503839418,621.4045442710631L564.7195600764826,620.3130738893524L563.6853303797543,619.9374582082964L569.6595649216324,603.6808752710931L569.9356750622392,602.9369255113415L578.5597780598328,606.1260242699645L572.40883302968,622.8362534912303L571.2610037326813,622.4106946019456L570.786094292067,623.7008975055069L571.7572130998597,624.069229580462L570.2330851266161,628.1937150903977Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.0489454390481,660.6151655805297L442.0848469892517,635.7486757514998L449.25661065243185,638.3706957083195L440.22780907712877,663.2517428519204Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M596.4256818844005,845.4644797593355L597.3187009654939,841.0279874731787L600.2454684488475,826.4085599929094L602.2863168269396,816.1891966764815L609.4438805384561,817.6354320645332L607.1971328863874,828.8962890994735L604.7310748929158,828.3927087071352L603.5193458218127,828.9670400591567L602.9734366321936,831.6951133362018L603.816755887121,832.9499018252827L606.2765027908608,833.4389155213721L603.866455713287,845.5071383235045L603.5832455977798,846.9169517541304Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.2801215816289,764.5209388677031L534.2827560240403,748.0087399980985L544.7993968091905,751.8563875854015L538.7967623677105,768.3685772903264Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M621.2361501716077,729.0940563026816L624.7656266447157,719.350045137573L630.2152519216761,704.290240552742L637.2024162337184,706.8706156406552L629.1021336149424,729.2074675648473L628.2304144585505,731.6380057088099Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M426.21798057854176,658.1211331961676L435.2530932407826,633.2463105446659L442.0848469892517,635.7486757514998L433.0489454390481,660.6151655805297Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.80168026778847,632.0913724526763L499.13945741485804,622.9850430199876L503.56905294489115,610.8956230706535L511.48473621346056,613.815231882967L503.72446351032704,635.0109723419882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.22780907712877,663.2517428519204L449.25661065243185,638.3706957083195L455.98186477459967,640.8366421419196L447.5841720914468,663.9395002163947L446.9388632485643,665.7041541999206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M554.4869182892144,703.9572888612747L554.6991286547855,703.3621376692317L563.2033209633082,679.8557056472637L569.9853748856112,682.336204004474L561.7217928422615,705.1486315676011L561.2689722115174,706.4169691223651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M583.6835933700204,664.7188197481446L583.9107925714925,664.0591554241255L591.734176164493,642.0550482599065L592.3368851551786,640.3403314729221L599.0479393275455,642.7428077268414L590.3875475684181,667.1212875535712Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.3875475684181,667.1212875535712L599.0479393275455,642.7428077268414L605.7163936495781,645.1244734935462L602.5482270158827,654.0528514985926L597.0560018904507,669.5164711726829Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M467.19982531573623,672.5702770627104L470.63700211420655,663.0956708244048L476.0582274897024,648.1855735052377L482.6911819372326,650.6161400573328L476.1221272656694,668.7017758819275L475.22200820967555,671.1677115261555L473.82567978836596,675.0081184133887L469.52467269357294,673.4286720021628Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M441.99254731368273,731.6598555766977L447.4776724651456,716.2390338811092L457.17939389590174,719.7038055248559L451.45365847926587,735.8269363157451L451.24775920342654,736.1380366235971L450.7089499887079,736.6489070020616L450.0502300830558,736.9600072740577L449.3205104274675,737.0526090227067L448.95210061222315,737.0099497889169L448.26419191993773,736.7685609520413L447.6835717400536,736.315956861712L447.26546210050583,735.7062418754213L447.130562575534,735.3660084046423L447.03116292413324,734.629356064368L447.16606245096773,733.9062297483906L447.32147301454097,733.5659961900674L446.7408528337255,733.35998320207L446.44265388231725,733.8562872097827L445.968533327803,734.2110873265192L445.39422423765063,734.3453078949824L444.81281517166644,734.259989395272L444.30319474171847,733.9624151047319L443.94819599110633,733.4806776805781L443.80698537640274,732.9209049940109L443.89218507613987,732.3403228637762Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M618.1176833631471,675.9154155305587L626.6502755722031,651.8990543363616L633.347129794769,654.3015265837312L632.6032101884484,656.384570278693L624.8287375355139,678.3043532436714Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M431.97211589384824,728.0733548691496L434.381374085322,721.298848465085L437.4501410694793,712.6525251963176L447.4776724651456,716.2390338811092L441.99254731368273,731.6598555766977L437.1243311036378,729.9586870637722L436.81903217732906,730.2281688312069L436.11771242227405,730.6245879367925L435.72090270742774,730.7379991738126L434.905983351171,730.8025083164684L434.11946389544755,730.6110618272796L433.41735525336117,730.2136022495106L433.1199451899156,729.9378776606172L432.6521357242018,729.270936250221L432.36892560776323,728.2086160229519Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.7217928422615,705.1486315676011L569.9853748856112,682.336204004474L576.8313285848126,684.8375110174529L570.9841047078371,700.9669657438062L570.339584751986,702.781553063076L568.5677465396002,707.657213659957Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M554.4869182892144,619.3422998031601L561.3746829517186,600.6124721788801L569.6595649216324,603.6808752710931L563.6853303797543,619.9374582082964L563.2814206890762,621.015402324032L562.7710113730282,622.4106946019456Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M597.0560018904507,669.5164711726829L602.5482270158827,654.0528514985926L605.4047836344689,655.073563830927L608.0901519665495,647.4978145784698L612.952057087794,649.2343797241338L612.3706480208784,650.8710581604391L604.9014742933214,671.9189373175614L604.7736747441813,672.2727001239546Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M473.82567978836596,675.0081184133887L475.22200820967555,671.1677115261555L476.46213718131185,671.62864370225L476.547336881049,671.3872525896877L478.96369504835457,672.2727001239546L479.7715144297108,670.0335893351585L476.1221272656694,668.7017758819275L482.6911819372326,650.6161400573328L489.35963625926524,653.0612725014798L481.01874337531626,676.0288276616484L480.5225340090692,677.4605256007053Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M481.01874337531626,676.0288276616484L489.35963625926524,653.0612725014798L496.05727936699986,655.5126469703391L490.64236508030444,670.3883927194402L487.70849762205034,678.473951142747Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M624.4532277435064,679.3458715635352L624.8287375355139,678.3043532436714L632.6032101884484,656.384570278693L639.3284643115476,658.7870409721509L631.1713818917051,681.7483342993073Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.1713818917051,681.7483342993073L639.3284643115476,658.7870409721509L646.0182185582817,661.1895108325407L644.7070898367092,664.8748917393386L637.8611361384392,684.1435128641315Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M507.303639809601,687.2264456534758L508.28106970433146,684.5399346044287L516.1549420077354,662.8761294982396L521.0373581694439,664.6688767098822L521.9090773249045,666.6249787686393L513.5823843916878,689.5217366078869Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M548.2499846732244,701.0096251978539L550.8154423153028,693.9021401745267L556.7470770068467,677.503185199108L563.2033209633082,679.8557056472637L554.6991286547855,703.3621376692317Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M575.4208002118394,708.8329486306757L576.7674288079143,705.1194982980378L577.4190487386659,703.2986687449738L583.2725837044418,687.1837861151434L590.2676368793473,689.7204675660469L582.4150644987822,711.370662632864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.4172972654924,741.0490496894345L585.1367215933278,724.8354100761935L585.8238413985819,722.8928505661897L587.5459797848016,721.7025513830595L590.0972374780104,722.6098423893563L591.1180561101064,724.764658050146L589.5655282372609,729.1648082816973L593.1731044370681,730.447708025109L588.3182992907241,744.2099922737107Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M491.7625833628699,709.6767724547535L499.3524566665292,688.7850793935359L500.7124963272363,685.0570516451262L506.0138110117987,687.0058646155521L503.12254340481013,694.9571823282167L503.7386634591967,697.0485376049764L498.2819382082671,712.0573747511953Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M582.358264698647,711.5048836432397L582.4150644987822,711.370662632864L590.2676368793473,689.7204675660469L597.1199016664177,692.208245725371L589.7501275883988,712.5255875186995L589.2255183225498,713.9926539841108Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M549.377302929759,779.7637340421788L550.9432418663055,775.4478934579529L557.9801060026512,756.0806818264537L564.7692598998547,758.5673957061954L564.3582502352074,759.7015034151264L559.4332342250273,773.236908510793L558.5331151690334,775.7246567015536L556.6413662675768,775.0296271820553L554.2739190394059,781.5502082519233Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M484.69731932505965,707.0828722566366L492.2871926277876,686.2057380522601L499.3524566665292,688.7850793935359L491.7625833628699,709.6767724547535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M595.6888622539118,716.2317505767569L596.1850716201589,714.8708127713762L603.5264457967132,694.5607611802407L610.3155996939167,697.0339709538966L604.9724740441889,711.8170255147852L602.4780161511153,718.7049526167102Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M447.5841720914468,663.9395002163947L455.98186477459967,640.8366421419196L462.3316091056913,643.1610819874331L456.76128425542265,658.4821800775826L453.93391642253846,666.2566489549354Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M635.2538675321266,732.5598619892262L635.6080773966387,731.5672537549399L643.7154599912465,709.2158428090625L649.9729046467692,711.4976003337651L644.0554699068889,727.8111563101411L641.5184121634811,734.8270452618599Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M629.1021336149424,729.2074675648473L637.2024162337184,706.8706156406552L643.7154599912465,709.2158428090625L635.6080773966387,731.5672537549399Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M501.5913154575974,682.0948132639751L503.02314375527203,678.1618077666499L509.4651877619326,660.4237171532586L516.1549420077354,662.8761294982396L508.28106970433146,684.5399346044287Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M620.676041030325,636.7194475419819L625.3249469008297,623.7362740323879L632.0076011726633,626.1460394426249L632.5819102646783,625.791233794298L633.2477301433682,625.6778208403848L633.5885289451107,625.7131973579526L634.2188489502296,625.961873463355L634.7079583415762,626.4155252436176L635.0124683808535,627.031492756214L635.0621682060882,627.3644481454976L634.9911684561521,628.0313993585296L634.6795584410429,628.6327999322675L634.4531481256709,628.8814759324305L629.7261425303295,642.0904246969149L621.696859662421,639.1926779490896L622.3555795680732,637.3218878456391Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M610.2871997943148,635.1597616095096L615.5246147057042,620.5190902361646L620.6263412050903,622.3617917448282L620.7328408313915,622.0777389751747L625.3249469008297,623.7362740323879L620.676041030325,636.7194475419819L619.9818212492391,638.6537073254585Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M535.3311856696382,777.9137911307625L538.7967623677105,768.3685772903264L544.7993968091905,751.8563875854015L544.9903072491288,751.3247089884244L551.3968513822183,753.6709615862928L545.7413268303499,769.2332031531259L543.6933784782887,768.4819879103452L541.1492207599804,775.4832692132331L539.3710714587942,774.838181915693L537.9108432624489,778.8564505167305Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.4483533697203,825.1402443903498L506.999129768461,806.7075035138987L513.497184690088,807.9685392794199L512.5402658348903,812.9440098344348L515.0134238013998,813.418458533939L512.4203551448882,826.8757245824672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.17007561866194,704.6949849370867L482.42927174735814,692.9657120895572L485.84514862205833,683.5837361933663L492.3716034432873,685.9716307860799L492.2871926277876,686.2057380522601L484.69731932505965,707.0828722566366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M450.3192402468994,739.0159739376977L451.45365847926587,735.8269363157451L457.17939389590174,719.7038055248559L464.30145773198456,722.2550416775048L457.6117034852505,741.0781828071922L454.5216365773231,739.9648814266548L454.34492608718574,740.4539016811177Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M484.5198199497536,754.2588251917623L487.58148695807904,745.6697687604465L486.3626579120755,745.2306913319044L491.1172745209187,731.8513020365499L498.1123276948929,734.3598744678311L493.8957314155996,746.2087310641073L493.1936227735132,745.9600592744537L489.5939354347065,756.0806818264537Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M463.85494819190353,744.2308016335592L466.0519960206002,738.0379331912845L470.58020231407136,725.2952982136048L477.3977561118081,727.7404043166898L471.1048115808517,745.4356634994037L470.02009317371994,748.4759098715149L466.4985055606812,747.207580011338L467.1359255416319,745.4075708696619Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.04576454963535,745.4928892320022L457.6117034852505,741.0781828071922L464.30145773198456,722.2550416775048L470.8287014402449,724.5940208127722L470.58020231407136,725.2952982136048L466.0519960206002,738.0379331912845L463.9188479669392,737.2721479996108L460.4319713432342,747.0733596934006Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.7501275883988,712.5255875186995L597.1199016664177,692.208245725371L603.5264457967132,694.5607611802407L596.1850716201589,714.8708127713762Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M604.6387752173468,720.1439250437543L606.8784228963777,713.9354279940017L608.6005612825975,714.5659543424845L609.0541707985103,713.3049015863799L604.9724740441889,711.8170255147852L610.3155996939167,697.0339709538966L617.0479537919164,699.4926131945103L611.5983285168186,714.5597115084529L608.9973709983751,721.7379274098203Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M458.2491234662011,697.4022991326638L464.68406749889255,679.6996339913458L467.19982531573623,672.5702770627104L469.52467269357294,673.4286720021628L468.42575433664024,676.4470999077894L471.48742134682834,677.5666543603875L470.1478927237913,681.2593099023215L469.00716340355575,680.8483212860301L466.710715925321,687.1692194421776L468.9645635532215,688.0057625668123L464.69116747379303,699.7620961493813Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M544.35998724401,773.0381799498573L545.7413268303499,769.2332031531259L551.3968513822183,753.6709615862928L557.9801060026512,756.0806818264537L550.9432418663055,775.4478934579529Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M548.6049834238365,831.8158061020076L548.7674939632416,830.9511880450882L550.7657424900681,820.696455901023L551.063941440545,819.1305686226115L552.9130904925987,819.4988903147168L554.1674194131047,813.0574197247624L553.309900207445,812.8940678648651L553.9978088997304,809.3513084310107L560.0351543296129,810.5270261522382L558.0653057033196,820.6537971841171L557.6471960637718,820.569520201534L555.3799373703077,832.2548780469224L555.2095379708335,833.119495941326Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M597.0276019889861,790.0393359586596L603.0941362064332,773.3430358069018L611.5628286413848,776.4404954113998L606.4745132047683,790.4721677815542L601.2307872055098,788.5441931262612L600.2525684246793,791.2160974149592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M572.7275430187583,738.6757406326942L578.2339680949226,723.0780544443987L580.3032163716853,717.2097944011912L583.4145832061768,718.3147756629623L582.3227648232132,721.4122598553076L581.3240350037813,722.1489135995507L584.1514028366655,723.3256865832955L584.3502021376044,723.537942698691L584.5979123758152,724.0696234242059L584.5979123758152,724.6512467176653L585.1367215933278,724.8354100761935L579.4172972654924,741.0490496894345Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M602.8961257915944,632.212068695575L608.4159619323909,617.2020181887783L614.9716055402532,619.6336360904388L606.6449126061052,642.2964403969236L603.866455713287,641.2757261833176L602.9521367065609,639.54019952612L604.0155551880598,636.6486946195364L605.9286040151492,635.8548051519319L606.7435233704746,633.6364922886714Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.76838423032314,617.6910471045412L460.09906140342355,608.5919821741991L463.1110285874456,600.3648356525227L470.28989222459495,603.014962203335L463.94724786747247,620.327640701551Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M594.9094427740201,632.5242141368799L595.794572994113,630.1352606466971L601.4926973963156,614.6372170378454L608.4159619323909,617.2020181887783L602.8961257915944,632.212068695575L601.8398072859272,635.0962920603342Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M606.4390133302659,750.6588101042435L611.1376190260053,737.3501831805333L611.4066291907802,736.5843979115598L613.0932677024975,737.1868295362219L615.4110151063651,730.6318712281063L620.2863312903792,732.3684155489318L613.0088568879291,753.0050629242323Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M498.2819382082671,712.0573747511953L503.7386634591967,697.0485376049764L504.70978226698935,694.3620303636417L511.67564665339887,696.9132758402266L505.2485914826393,714.6086137159728Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M496.06437934283167,675.6105553889647L497.1057090125978,672.7617251542397L502.5056344643235,657.8724582470022L509.4651877619326,660.4237171532586L503.02314375527203,678.1618077666499Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M529.8957603434101,686.2764904717915L535.8344950098544,669.8775174599141L543.3320686379448,672.6129366937093L537.4004339464009,689.0119032338262Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M461.7714999653399,813.7732545798644L465.49188687931746,797.4380512349308L467.1146256150678,797.8063740753569L468.6245536375791,791.1588720632717L474.5987881794572,792.5270781163126L473.6489692982286,796.6587466234341L471.21131120529026,796.8782837120816L470.6867019403726,799.1953880158253L472.3733404530212,800.9173487275839L471.756431510672,803.6173406452872L469.6587833324447,804.2769916886464L467.2069252897054,815.0270058601163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.4816856328398,746.2160143391229L484.4346202490851,729.4550994844176L491.1172745209187,731.8513020365499L486.3626579120755,745.2306913319044L483.89581103343517,752.1612443742342L481.4510529655963,751.2820498440415L482.7124818628654,747.7392589226365Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.1048115808517,745.4356634994037L477.3977561118081,727.7404043166898L477.6525663267821,727.0245605753735L484.4346202490851,729.4550994844176L478.4816856328398,746.2160143391229L476.04402754083276,745.3441023295745L475.4563073851168,746.9880413501523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M565.7545786574483,736.1879791473038L572.2100337278098,717.9183558509685L575.9383095037192,719.2366337142885L576.2144196433946,721.150061043445L575.8460098281503,722.2269489509054L578.2339680949226,723.0780544443987L572.7275430187583,738.6757406326942Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M578.4043674953282,662.0968097597361L583.8255928717554,646.8246223405004L584.3502021376044,647.0087877656333L586.7381604043767,640.2695785877295L591.734176164493,642.0550482599065L583.9107925714925,664.0591554241255Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.98361624684185,782.6125203035772L455.5637551341206,778.2966814930551L464.2872577831149,781.5210753036663L464.386657432653,781.258878767956L477.121645973064,785.9648889028467L474.87489832006395,792.0942464205436L461.96319929137826,787.3185295220464L462.5296195205301,785.7734439373016Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M572.40883302968,622.8362534912303L578.5597780598328,606.1260242699645L585.4696315331385,608.6981119872071L579.7580960672349,624.2044927640818L579.3257864769548,625.394808690995Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M573.1385526843369,660.2041757432744L578.588177960366,644.8549884152599L580.9840250890702,638.1012103674002L586.2561509888619,639.9865670339204L583.8255928717554,646.8246223405004L578.4043674953282,662.0968097597361Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M604.4691647039726,795.9710024259984L606.4745132047683,790.4721677815542L611.5628286413848,776.4404954113998L617.4802633831277,778.6161035997793L611.6480283420533,794.6745888227597L610.3865994447842,798.1393212634139Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.69116747379303,699.7620961493813L468.9645635532215,688.0057625668123L469.56017256807536,688.2253030971624L471.89133103657514,681.7909938711673L477.8087657773867,683.9593484257348L471.2042112303898,702.1437423233874Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M462.31030918098986,664.207944071386L469.05686322785914,645.6270267162472L476.0582274897024,648.1855735052377L470.63700211420655,663.0956708244048L466.1513956701383,661.4517119121738L464.8047670731321,665.1225259597413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.76128425542265,658.4821800775826L462.3316091056913,643.1610819874331L469.05686322785914,645.6270267162472L462.31030918098986,664.207944071386L459.7732514385134,663.2798358178698L460.9565806090832,660.0272940308787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M537.4004339464009,689.0119032338262L543.3320686379448,672.6129366937093L550.0999226104468,675.0799114243127L544.1682879189029,691.4778316542506Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.2042112303898,702.1437423233874L477.8087657773867,683.9593484257348L482.22337247245014,685.581451987382L479.8851140299812,692.0303243570961L482.42927174735814,692.9657120895572L478.17007561866194,704.6949849370867Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M420.1940462095663,768.8149365033023L422.4407938634977,760.4735289211385L422.53940462879837,760.0979208350182L436.48612223844975,765.1368941068649L434.4665737859905,772.6771390349604Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M544.1682879189029,691.4778316542506L550.0999226104468,675.0799114243127L556.7470770068467,677.503185199108L550.8154423153028,693.9021401745267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M463.94724786747247,620.327640701551L470.28989222459495,603.014962203335L475.9091280149296,605.0844949502498L472.99656048230827,613.0359066291712L474.0741789136082,613.4323324384168L474.03867903817445,613.538462178316L470.64410208910704,622.8081603613682Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.84966484457254,807.3525878437795L435.83450230769813,798.6574702910148L436.6068218136206,798.8343484629877L436.9255318036303,797.3953923722729L436.1603122726083,797.2185141630471L437.71915123425424,790.3941332004033L444.51540510635823,791.9600269701332L444.3734056064859,792.5832629967481L440.653018691577,808.9184777857736L437.3436414441094,808.1599836326204L435.87710215803236,808.6489990763366L434.64407316129655,807.5440322142094Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M565.3364690160379,778.0989935393445L566.1939882226288,775.7173734572716L571.119004232809,762.1819732012227L577.8087584804744,764.6624421053566L572.1114229634404,780.5856995200738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.755906692706,644.8976482166909L637.6560257496312,642.3817600291222L642.2197319194674,629.6254229061306L649.2068962324411,632.1485991189256L649.1295853918418,632.3608580259606L644.1753805959597,646.2294662431814L643.7501709805802,647.4124950096011Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.980580130592,781.7905550668947L442.82876659557223,767.4113499750383L451.318758954294,769.7149380948395L450.9858490144834,770.5722805424593L446.811852584593,781.3941388847306L445.9401334282011,783.6758726546541Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M582.358264698647,783.0162196480669L587.6595793860033,768.1844150885008L594.7319433987141,770.8136682007462L589.3675178224221,785.5819989633746L587.0426704445854,784.7246583756059Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M570.9841047078371,700.9669657438062L576.8313285848126,684.8375110174529L583.2725837044418,687.1837861151434L577.4190487386659,703.2986687449738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M611.5983285168186,714.5597115084529L617.0479537919164,699.4926131945103L623.9365073405206,702.0022378102876L618.4860931783915,717.0610068920068Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M423.5957231344655,751.2758070430718L427.0470998827368,741.2332126111723L437.2655417183414,744.7697640494443L436.57842191308737,746.7685026805848L433.8149538561702,754.8258794224821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M451.41105862986296,694.893713326659L455.6489548338577,683.2507835044526L459.04353178292513,684.4972750474699L461.23269074968994,678.4385748943314L464.68406749889255,679.6996339913458L458.2491234662011,697.4022991326638Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M431.3836068511009,687.5593981514685L436.64942166302353,673.0593020715751L443.4527755109593,675.5616529067047L443.0133659457788,676.7665267097764L438.1940606748685,690.0534199443646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M588.4957986669615,633.9413542766124L590.6005468191579,628.2290915953927L596.3049823092297,612.7164768925868L601.4926973963156,614.6372170378454L595.794572994113,630.1352606466971L593.3569149002433,629.2289980249479L591.2521667499095,634.9620695733465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M490.64236508030444,670.3883927194402L496.05727936699986,655.5126469703391L502.5056344643235,657.8724582470022L497.1057090125978,672.7617251542397Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M611.6480283420533,794.6745888227597L617.4802633831277,778.6161035997793L623.4047980979085,780.7844278649427L620.9742399817333,787.4745987504721L618.8055920545012,793.4551690663211L617.5725630577654,796.8501912876964Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M618.4860931783915,717.0610068920068L623.9365073405206,702.0022378102876L630.2152519216761,704.290240552742L624.7656266447157,719.350045137573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.3076602751389,832.8073595305905L439.8451993120834,828.6122447913513L447.2859731391072,831.3621677597985L447.5344722652808,830.6962765636854L451.9987787846476,832.3474785233848L452.1904781097546,831.8158061020076L454.94684619270265,832.8364922632463L455.64185485895723,832.3474785233848L458.51182254217565,833.4097827910446L459.3622417729348,834.543878256809L457.41290418524295,839.8585176435299L443.10487673431635,834.5719705256633Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M559.4332342250273,773.236908510793L564.3582502352074,759.7015034151264L571.119004232809,762.1819732012227L566.1939882226288,775.7173734572716Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M576.6254293089733,798.763597194571L579.0275875255466,792.0380615349859L581.4652456175536,785.4966810974292L582.358264698647,783.0162196480669L587.0426704445854,784.7246583756059L584.2295025615022,792.4844192257151L586.433650364168,793.2990999696776L586.2064511636272,793.9160931110382L583.5281828055158,801.2929546018131Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M599.5575597584248,748.2137120841071L604.2561654523015,734.9050804660656L611.1376190260053,737.3501831805333L606.4390133302659,750.6588101042435Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.5935048321262,692.3924099449068L449.42622116580606,679.1190474056639L456.2437749635428,681.6130722332746L455.6489548338577,683.2507835044526L451.41105862986296,694.893713326659Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.6289467187598,839.6743573406711L591.38706627395,835.89750938816L593.548614227213,825.0622101989575L600.2454684488475,826.4085599929094L597.3187009654939,841.0279874731787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.386657432653,781.258878767956L466.95921505149454,774.2295107818209L479.69341470487416,778.9417684669606L477.121645973064,785.9648889028467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.84255040530115,840.6815164489672L417.0400795266032,837.3718329244293L418.4009080734104,837.0950721451081L418.96101721469313,835.5499976533465L416.8065692363307,834.7634141440503L420.03074678592384,825.8623207318597L420.6618556762114,824.1476494097151L426.62189026828855,826.3305258136243L422.75240387860686,836.9681367431767L420.74705537687987,842.4815008533187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.75240387860686,836.9681367431767L426.62189026828855,826.3305258136243L433.3329444397241,828.7964053880423L427.2593102483079,845.5071383235045L424.75065240543336,844.5925802318379L426.95480020716786,838.5059277396649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.4741550544277,776.3832699372433L434.4665737859905,772.6771390349604L436.48612223844975,765.1368941068649L442.82876659557223,767.4113499750383L438.980580130592,781.7905550668947L438.8740805052221,782.1588787422515L433.7439541053027,780.7698613917455L434.82788362633437,776.7162181530148L433.8007539054379,776.461304675322Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.7580960672349,624.2044927640818L585.4696315331385,608.6981119872071L591.018656459637,610.7468332769349L585.3134320825338,626.2594523867592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.9378716023639,639.964716878254L635.5086777480319,627.2083753100596L642.2197319194674,629.6254229061306L637.6560257496312,642.3817600291222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M466.95921505149454,774.2295107818209L469.41817306913435,767.5611768676899L482.1460616318509,772.2734390888363L479.69341470487416,778.9417684669606Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.1940606748685,690.0534199443646L443.0133659457788,676.7665267097764L449.42622116580606,679.1190474056639L444.5935048321262,692.3924099449068Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M451.1554595287889,811.3281788239256L454.87584644183517,794.9929697150365L460.4603712428361,796.2758572748862L456.7399843297899,812.6173061067238Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M469.41817306913435,767.5611768676899L471.7990313610062,761.0551491607912L484.52691992465407,765.7674158005975L482.1460616318509,772.2734390888363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M585.3134320825338,626.2594523867592L591.018656459637,610.7468332769349L596.3049823092297,612.7164768925868L590.6005468191579,628.2290915953927Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.3799373703077,832.2548780469224L557.6471960637718,820.569520201534L558.0653057033196,820.6537971841171L562.253502083011,821.4757578130811L562.9761217636988,817.7269922820851L565.2796692159027,818.1733483159915L562.2819019816816,833.6085096253082Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M567.795427034609,658.2980149560608L573.2450523106381,642.9415400270373L578.588177960366,644.8549884152599L573.1385526843369,660.2041757432744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.653018691577,808.9184777857736L444.3734056064859,792.5832629967481L449.65342036634684,793.7953996853903L445.9330334542319,810.1306116161868Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.74480084888637,795.9429099983536L510.3929178323597,783.5270865727216L516.7781620388851,785.9430392072536L513.7101839417592,794.1283470648341L512.1363561442122,798.3598987678997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M445.9330334542319,810.1306116161868L449.65342036634684,793.7953996853903L454.87584644183517,794.9929697150365L451.1554595287889,811.3281788239256Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.8149538561702,754.8258794224821L436.57842191308737,746.7685026805848L446.26594339311123,750.119848146569L446.0813440429047,750.6733766426332L443.50168644916266,758.1709781982936Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M425.1435176897794,619.8667051144876L641.8174000009894,699.0150352753699"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M417.3808783283457,682.4288064851426L423.00011411868036,666.9724989715032L427.8194193886593,668.7371521801688L422.1993947122246,684.1924152830616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M426.7276010066271,685.8509354772978L432.3476256830618,670.401918948628L436.9965315544978,672.103102076333L436.64942166302353,673.0593020715751L431.3836068511009,687.5593981514685Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.1993947122246,684.1924152830616L427.8194193886593,668.7371521801688L432.3476256830618,670.401918948628L426.7276010066271,685.8509354772978Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M513.7101839417592,794.1283470648341L516.7781620388851,785.9430392072536L523.3622055463493,788.4307828345336L522.9085960304365,789.6283537908457L519.7617293223739,798.0259111318737L518.4577005757019,797.5368949384429L517.5433815699071,799.9892587782815L514.0217939568684,798.6574702910148L515.4670333173126,794.7952822339721Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M446.811852584593,781.3941388847306L450.9858490144834,770.5722805424593L457.5549036851153,773.1380644640885L455.5637551341206,778.2966814930551L454.9752460923046,778.0698605761863L452.7923982143402,783.7258148356341Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M541.7377298017964,829.5829895748757L542.6307488819584,824.9696096251719L543.7288783537224,819.3220126670785L550.7657424900681,820.696455901023L548.7674939632416,830.9511880450882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M546.577546111308,803.7453171131201L548.1513739079237,798.4722684351727L562.253502083011,802.7173434542492L561.0417730119079,806.7501623169519Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M455.0959456684068,769.3819895423949L457.3071934459731,762.9612816916779L458.7950326576829,758.6173380673863L465.39248722884804,760.8990793349221L462.5225195456296,769.2477696524002L458.6672331066802,767.9149347967468L457.83101382572204,770.3246500883251Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M604.9014742933214,671.9189373175614L612.3706480208784,650.8710581604391L615.2832155553624,651.912580601871L607.8069418519735,672.9604565934278Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M545.7626267559826,789.7282380661927L548.5907834731042,781.8259307872504L549.2850032532588,779.8563352199271L551.014241617173,780.4795723347925L550.4825323754922,781.989283379633L555.7199472859502,783.8746009138413L552.7363800033927,792.2367895548232Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.3693055212498,781.3868556488305L525.6152642881498,775.0795694254339L530.0377598442137,776.6745996251702L534.7647654386237,778.367432970088L532.5251177614555,784.6747162020765Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M617.8699731230736,648.6600334816612L620.0812209006399,642.417136461474L628.8970232252032,645.5708406413905L626.6786754727364,651.8137348219752Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M525.3462541233748,799.7270629382692L528.4221210824326,791.7051140549593L535.2743858685717,794.347884234041L532.518017786555,801.8953806040809Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M443.50168644916266,758.1709781982936L446.0813440429047,750.6733766426332L452.9698975915089,753.0539648602717L452.3111776849255,754.9600995909423L450.3902399977669,760.5588471009396Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M539.6471815984696,787.5235004457645L542.4745494313538,779.6295143533498L548.5907834731042,781.8259307872504L545.7626267559826,789.7282380661927Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M519.7617293223739,798.0259111318737L522.9085960304365,789.6283537908457L528.4221210824326,791.7051140549593L525.3462541233748,799.7270629382692Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M553.2538892943412,791.7196805072017L555.5140480101109,784.9015369033441L562.161202407442,787.1270845918916L559.8939437158406,793.9441855465993Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M559.8939437158406,793.9441855465993L562.161202407442,787.1270845918916L568.4754468640313,789.2319380599074L566.0803886232898,795.928343554493Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M450.3902399977669,760.5588471009396L452.3111776849255,754.9600995909423L459.22734224703163,757.349010062404L458.7950326576829,758.6173380673863L457.3071934459731,762.9612816916779Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M568.5677465396002,707.657213659957L570.339584751986,702.781553063076L576.7674288079143,705.1194982980378L575.4208002118394,708.8329486306757L575.0026905713603,709.9889144124463Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.9068734860048,807.196519060526L561.0417730119079,806.7501623169519L562.253502083011,802.7173434542492L568.6813461408019,804.6525973817334L567.3489174935967,809.1380144860595Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.0377598442137,776.6745996251702L531.8372090701014,771.6137849967927L536.564214666374,773.3149432865903L534.7647654386237,778.367432970088Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M546.1878363704309,717.0714116124436m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M512.9646865641698,759.6806941013783m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M578.41146747116,827.439651502762m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M425.5466384952888,788.594135271851m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M426.1887917909771,725.5158780333586m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M623.7471746727824,744.1423618509434m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M536.5011037765071,817.7623678194359m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M598.7158182729036,732.6763946050778m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M617.2254531672224,662.4370468254201m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M593.4239702206105,787.1832695160992m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M522.5827860664576,817.9756614970975m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M571.120582005009,613.0317446775734m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M441.1555391466245,649.4934598077089m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M536.5397591954097,758.1886661178432m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M630.9812603378668,713.1103331977502m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M434.150230454281,646.9349134992808m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M505.3124912586063,618.399618725758m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M448.1016813805327,652.0436813165434m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.3394906697795,692.8491788096726m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M591.4809437217191,653.4015100104734m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M596.4682817347348,660.5870726034045m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M476.6656697979197,656.8559082499705m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M449.5879428200424,725.6823533633724m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M625.3636023206636,666.1505200224929m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M438.82516956701875,724.6866227299906m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M570.0327080534771,692.9022430698387m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M603.969010906294,662.295541501604m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M482.7416706485674,660.881528601516m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M489.55922444630414,662.9510440747254m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M637.9392358642071,673.3110979124904m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M515.0938901854679,675.5824624723755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M557.0089871976525,686.8789264662191m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M583.8453150242567,696.5095714805648m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M586.2948064086959,735.748901117593m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M497.74944008141756,703.3621376692317m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M589.7674830816686,701.7889405651949m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M558.0503168674186,766.4697294975631m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M492.0260713249445,697.9339818623848m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M603.80255593732,704.4255021759309m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M455.94952044356614,650.8221555044875m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M636.4080079160631,719.211662392132m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M509.58825399633497,670.5194930848666m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M617.8052844619378,629.4485404165462m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M545.0975957596675,761.0197733333334m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M509.23088858649135,819.2793539389968m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M483.9983662292361,698.8308712313883m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M457.8767692204565,729.0409923167899m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.72408717963845,732.8886504312977m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M464.77242274209857,731.2842459264211m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M596.6442033387721,703.5431801695377m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M611.0090305889025,705.6553423320875m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M465.4137871535495,684.2142653018236m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M551.8615053026006,762.6564253778197m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M553.197089494206,825.823823869694m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M604.5693532405421,782.4918266804889m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M578.9329211916775,731.7555788070895m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.9350489955395,625.9223350035027m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M462.50674182362854,613.1420363746583m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M602.1048730192706,623.6686424338259m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M612.4858253952116,744.0050200698897m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M503.28347617108375,666.5927238995209m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M536.6154922619462,679.4447169476189m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.97421835083514,738.5404796772636m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M477.7882547387853,737.4001256949268m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M571.9954567048699,729.6330198943615m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M584.1861138259992,654.5533231096342m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M465.2915098061785,784.1929822992533m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M578.9384433943778,615.7671863418072m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M578.4824672210962,653.5149225085042m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M611.9754160791636,784.5436179954559m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M470.4760693470016,693.9937020228244m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M469.6832388024777,654.8186458819546m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M462.91065151430666,652.0551266158m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M543.7501782784238,682.0459108306095m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M476.81634704582393,697.5552489613183m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.34166199620813,766.9764357819222m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M550.4580769054592,684.4910321854986m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M438.4007488368079,803.0929492334835m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M572.0183344027027,770.1893897531554m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M444.71657106559724,775.9826915948652m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M588.527354111895,776.9149466096424m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M577.1255831047893,694.0748591157608m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M617.7666290421039,708.2804572661407m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M430.08746696729213,749.0221552266739m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M457.1770272376016,689.6954961372539m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M437.2000641711056,682.1624442925677m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M596.0470165498555,621.4336778898723m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M496.5779442023486,664.1309485463426m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M616.532811159268,790.4648845545016m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M624.3506725504994,710.6756266644225m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M565.2757247854024,767.7099632932805m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M581.6293339300901,792.2617606148124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M605.347983835265,742.7824699948542m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.12122983206064,687.8215982308611m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M472.0396416252479,780.1008439436555m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M437.44698552507907,774.5302047324367m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M585.3899540361017,617.4756662887521m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M636.5799850896001,634.7955920640379m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M474.55303278472275,773.2514750030823m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.8061964903027,684.5857155919075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M455.80830982886255,803.8015019055456m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M476.97254649642855,766.664296394214m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M590.8096016393974,619.487967948895m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M560.008332202211,826.8653200236149m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.1914080539718,651.5765049448237m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.15361397340894,801.3574630888179m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M511.5999135868624,790.0362145737745m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.4044399484992,802.5623150249012m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M439.9469656199217,752.7491081100889m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.115935604088,805.0282030533999m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M431.6904835505411,679.4551217244007m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M427.2727213110775,677.2971705449745m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M518.3093899870291,791.8788710227236m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M452.8239536592737,775.6039629587904m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M545.8336265049875,827.2762999837287m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M551.3597737336531,800.5948062692769m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M460.1432390259579,765.438628918957m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M610.0907671516761,661.9157661772333m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M550.7428647940978,786.8014201079495m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M530.3351699085906,797.0374741088599m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.9076153971255,756.5655390820466m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M544.119376978837,784.6747162020765m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M524.0777252521366,794.8660335452296m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M564.1555065037683,791.5885824337602m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M454.5926363263279,759.5880926521495m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.7399843297899,812.6173061067238L460.4603712428361,796.2758572748862L465.49188687931746,797.4380512349308L461.7714999653399,813.7732545798644Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M825.4913872750476,829.6360527910292L851.1491192476824,768.8721620426513L836.9333914723247,708.6061254376546L829.9675270868465,673.4921412006952L825.2689213911071,640.3684245320037L858.4912823121995,639.5318756559864L858.4912823121995,829.6360527910292Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M710.7692019129172,781.6167978458107m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,775.6185294426978L655.7057400392368,780.6502081956714"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M840.9377773888409,772.8540178718977L842.5392161998898,775.6747144632973L844.3252543620765,778.7222308097407"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M839.0807394757867,767.1710026618093L838.7407295610756,770.8989862515591L837.7838107040152,774.8100894042291L836.4229821581393,779.3028090558946L817.9409582782537,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M839.1091393753886,797.3860282311216L858.4297491945326,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M641.8174000009894,699.0150352753699L731.5547732450068,731.7940761935897L802.230291317217,757.1929401541129L816.6227295799181,766.0795552325435L827.8343790341169,778.5661613820121L839.1091393753886,797.3860282311216"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M674.5987735837698,709.9462550110184L668.9582378678024,707.6353637166321"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M656.0954497782513,697.0131614520214L651.6524431845173,694.8083943412639"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M832.3089410727844,829.6360527910292L840.4983678217977,808.4575547375716L847.5494319088757,802.1294839582406"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M808.2589589999989,612.9620320000686L820.9174255859107,682.2727348897606"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,819.3688332196325L655.7057400392368,780.6502081956714L681.6143377963454,710.8816403262317L706.5100057823583,641.0135243409313L716.1517718695104,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,627.8597192559391L807.5024172160774,628.9449455356225"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M763.6285159839317,742.4307917212136L766.4921725774184,743.2392355389893"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M848.1694963956252,756.2377922288142L858.4912823121995,780.0207283236086"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M820.9174255859107,682.2727348897606L828.6137985140085,708.0036913319491L841.1712876781821,740.1136684441008L848.1694963956252,756.2377922288142"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M803.7883413909003,612.9620320000686L807.5024172160774,628.9449455356225L819.9257957395166,681.4788506468758L838.2800200702623,762.3734188210219L839.0807394757867,767.1710026618093"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,786.2125187981874L858.2640831107274,790.8404909954406L858.0234728464857,795.8575922562741"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M655.7057400392368,780.6502081956714L788.0831966334954,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M839.0807394757867,767.1710026618093L801.2733724601567,753.6563950511627L681.6143377963454,710.8816403262317L641.8174000009894,696.457547721453"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M821.4775347262621,770.2747078114189L825.5947313569486,771.8759818989784"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M826.2116402965039,787.1478938222863L826.7496606269851,782.874716787599"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M742.8082336615771,734.9623062834144L745.989811360836,736.0246254755184"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M658.7177072232589,697.7706272886135L661.8708850191906,698.8131831577048"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M665.3435616930947,712.1645434526727L668.638738992624,713.141547377687"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M747.4571395320818,736.5417386768386L751.5175363617018,737.9807074000128"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M827.9621785851195,776.1502061760984L833.5388145241886,778.1406120560132"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,778.2134444592521L847.3072438733652,752.5826334296726"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M847.3072438733652,752.5826334296726L841.7455967683345,739.8379442468286L830.3430368769914,707.0974388872273L812.630176958628,612.9620320000686"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M758.7389998491853,740.3904330963269L761.7580670071766,741.5026939408854"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,617.5079213855788L706.5100057823583,641.0135243409313L819.9257957395166,681.4788506468758"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M855.7207142785192,811.1440177634358L857.626663130708,810.811071200762L858.4912823121995,810.3907261448912M858.4912823121995,796.1260310024954L858.0234728464857,795.8575922562741L855.351515578106,795.3904255786911L852.5241477442905,795.9210603334941L850.1929892785847,797.3173578702845L848.4779508663341,799.414925024379L847.5494319088757,802.1294839582406L847.5565318847075,804.4393032919616L848.1584519892931,806.4952499456704L850.27030011639,809.3013664348982L852.6235473956913,810.6622856999747L855.7207142785192,811.1440177634358"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.2228621179238,859.0569421970285L665.790071234107,857.4619309548289L670.9706863453612,843.1609168103896L676.20021239575,828.697562132962L673.0825344724581,827.5915580098517L669.7376573495567,826.3939936119132L673.861953953281,814.7440014411695L674.7123731849715,815.0415722616017L676.7035217359662,815.7501237145625L677.7945512328297,812.6745312823914L675.2014825735241,811.7464429056272L679.1979796299711,800.7050949842669L714.1353789614514,813.4403081438504L750.5748174553737,826.720696690958L751.021326996386,825.4939993778244L759.8442292949185,828.7048453190364L759.3701087413356,830.0158189279027L756.2516419319436,838.5902045029216L752.4531552921981,849.0644456115551L738.712336958386,844.0400996874087L737.648918476887,846.966893479228L728.1317963972688,843.4803359275684L731.2991741439328,834.742605054751L724.8224191479385,832.3682876215316L718.3803751412779,852.3168987063691L725.3462395286188,853.8973448132165L724.5242201974615,858.058109367732L723.3905908502638,863.819083828479L722.4691718686372,868.5250379177742L722.1788617800921,869.970221941825L722.107862030156,870.3312577870674L683.3577761072665,862.6423346935771L665.2512620175257,859.0569421970285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M718.8836844824255,631.496215088293L721.9453514898196,623.3606585380621L720.7541334582493,622.9142899573781L729.8397348336875,598.7271048026159L730.6830540886149,599.0538186137564L733.7794320872054,590.8329037209041L746.6848200270906,595.723209920805L748.0101486975327,595.4037793865427L781.5725195333362,587.275463914033L792.5356698604301,634.8975595384836L780.8775108670816,637.6048995051533L775.4420855417848,635.5426598568447L768.9653305457905,652.7845043600537L760.950247627683,649.7442160234787L760.439838311635,651.0697902278043L728.5712059624493,638.9866621559486L728.9183158520609,638.0585505268537L721.2148429481313,635.1389519213699L722.1220619790256,632.7219062452205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M745.4020912051201,722.4610549951904L750.2348075397313,708.9609268517233L752.35375564266,703.05103588989L755.1748123867437,695.1912892940454L756.2374419812113,692.208245725371L759.1287095900625,684.1643224051222L762.8561964789405,673.7616251627915L796.5179669652134,685.8301259414293L779.0709616662934,734.5367542803288Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M779.0709616662934,734.5367542803288L796.5179669652134,685.8301259414293L806.3474879451096,689.3875151718967L817.9977580774575,740.3404906038195L804.0297405421734,743.5649020676501Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M691.7483688173816,703.1425976180471L710.1175819830969,651.7148890402168L731.8805832108483,659.5455514686182L729.4855249682441,666.2347988807596L726.6360683245584,665.2151286713779L722.3981721205637,677.0994797074236L724.2978098820895,677.7861952208914L722.525971670635,682.7263829880394L714.532188677229,679.8484223014675L713.1500602057204,683.7044315384701L704.5614570807666,707.7487753294408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M785.3710061721504,780.7490521385334L791.9187609199435,762.8978133127093L824.957311375998,775.1149451835081L815.822010175325,799.9965419936925L808.1406260821968,797.16128885746L797.5103856958449,793.2356318682432L795.8734470093623,792.6259218906052L798.453104602173,785.5892821983434Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M741.4545050906017,800.0319176241755L748.4629693282768,780.91864753142L753.7287841383368,782.8539075446315L755.6773328408599,777.5246579698287L779.1277614664286,786.1917095645331L776.3493045726791,793.7818736964837L770.169959641993,810.6331528746523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M755.6773328408599,777.5246579698287L756.9813615866005,773.9881232413463L764.7345343157649,752.8489929181524L791.9187609199435,762.8978133127093L785.3710061721504,780.7490521385334L783.5494681354612,785.7026925361715L780.275590762496,784.4832711983472L779.5876820711419,786.3613048233092L779.1277614664286,786.1917095645331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.8611361384392,684.1435128641315L644.7070898367092,664.8748917393386L675.3568931398913,675.8373796604574L673.4296443620697,681.2728361082263L674.1380640929565,681.5350364283659L674.5064739072695,682.4288064851426L679.0070691900328,684.0373842031695L679.7935886448249,683.5910195317119L680.6085080001503,683.8813126436435L680.8917181156576,684.7386657060124L680.6156079750508,685.5179829001427L679.8290885202587,685.8082759305835L678.2481607468799,690.2521508857608L678.6591704124585,691.2791007454507L678.2126608733088,691.9387624794617L677.3835415663198,692.2717147516087L676.8100213613361,692.0521743497811L676.5899221356958,691.1594460085034L671.7359058763832,689.4156080316752L671.090597034432,689.7839366127737L670.5596766797826,689.5924889910966L668.6742388661951,694.893713326659Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M666.4771910402924,773.3721687886864L684.4708944140002,724.2818795158528L697.339993593283,729.037870906759L688.1841813540086,754.0392867536284L679.6160892695189,777.4258139831945L679.3541790796444,778.1270860363729Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M704.5614570807666,707.7487753294408L713.1500602057204,683.7044315384701L722.0936620794237,686.9351122057997L729.4855249682441,666.2347988807596L731.8805832108483,659.5455514686182L743.4953534668311,663.7262017973699L743.3399429032579,664.1663248711266L735.976479915902,684.7667585820891L734.90675034374,687.7716553616337L728.0749965971336,685.3192518204451L725.9773484189063,691.2021055244841L723.525490376167,698.0682031325996L721.456242098473,703.873010460753L718.3022754155099,712.7024678890593Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M770.169959641993,810.6331528746523L776.3493045726791,793.7818736964837L794.8171285018325,800.6062513235956L797.5103856958449,793.2356318682432L808.1406260821968,797.16128885746L806.2906881459057,802.192951974459L808.1051262076944,802.8598863705993L801.0816731341183,822.0500897383317Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.4998262990266,853.6642836583778L647.2583475289866,825.8560779984109L662.8491038009524,830.6536179049872L661.6444747056812,834.7634141440503L659.3764271270484,833.8634210019372L658.1788980066776,836.9254781268537L657.5982778267935,838.3925182684325L670.7292871950194,843.076640102081L670.9706863453612,843.1609168103896L665.790071234107,857.4619309548289L665.2228621179238,859.0569421970285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.2454466866329,622.4044516850263L683.0035662427545,620.3703006543219L687.0008521825075,609.7406812519766L688.1486814785749,610.1724838479422L692.6839877488092,598.0830415505916L691.3870589761063,597.594011249952L692.485977333039,594.6525453040376L714.0004794364795,602.7881355490535L703.611638199538,630.4754992844537Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M702.5703085288405,757.3063509562053L710.8118017623201,735.1246195114218L736.9262987952679,744.9050248800777L728.6777055878192,767.0929678161629Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M647.2583475289866,825.8560779984109L658.8384067974985,793.4125101785176L676.20021239575,799.6063696132042L668.305829051882,821.8940212838352L670.4602770293131,822.6597971287556L667.10829993058,832.1279425593093L662.8491038009524,830.6536179049872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M731.5760731697083,717.5146527132019L736.3874895805493,704.0925504886545L742.3759240722284,706.246331431903L743.2121433531865,703.9156698985025L743.7793524684384,702.3133396389894L741.7874150304124,701.5902099520899L742.6094343615696,699.3022063178942L738.5987373581156,697.8559462409467L739.2716572135687,695.9851719667204L742.3049243213609,687.5167386149988L744.9271817645058,688.4521269565448L746.5712204268202,683.838653084822L750.192207689397,685.1423707520589L751.6879357621074,680.967976202257L745.4304911056533,678.7215848751366L749.8095979243517,666.504283125978L763.6711158351973,671.4798552175052L762.8561964789405,673.7616251627915L759.1287095900625,684.1643224051222L753.5228848634288,682.1593228592537L752.098945427686,686.1277022981085L754.9902130356058,687.1692194421776L753.5370848122984,691.2374817072414L756.2374419812113,692.208245725371L755.1748123867437,695.1912892940454L752.35375564266,703.05103588989L747.8823491483927,701.448705426883L745.7705010194331,707.3596382299438L750.2348075397313,708.9609268517233L745.4020912051201,722.4610549951904Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M667.7670198362321,664.5700311125256L670.4389771046117,657.0931379436515L675.8886023797095,641.8573564202525L696.1495644468814,649.1636269288138L687.7305718380958,672.7055393024348L672.2463151924312,667.1212875535712L672.5366252819076,666.2993086250499Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M616.0768349869177,800.9600075660273L617.5725630577654,796.8501912876964L618.8055920545012,793.4551690663211L625.0133368857205,795.7368988636881L625.9489558162168,793.1721637663431L627.1890847887844,789.7417640620843L620.9742399817333,787.4745987504721L623.4047980979085,780.7844278649427L645.0825996277854,788.7210715562105L637.2663160087541,810.2513047577813L621.7820593630895,804.5745629617013L622.2703798664734,803.2282089265063Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M716.5233372282237,793.739214814268L726.1122479457408,767.6381712434813L726.3031583838165,767.1210603611544L738.8322476474568,771.7209527804516L737.8193178772926,774.498990828637L729.0674153268337,798.3453323286958Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M856.0275909779593,612.9620320000686L855.7980251191184,613.8360416349024L853.36036702618,617.322714690119L850.7168096574023,618.7044813837856L847.3293326841667,619.8604621919803L823.6319827036932,621.5606172373518L821.8317445926368,621.4544876208529L820.3510053558275,620.1861345209181L819.5076860999689,617.9605332356878L818.3756345259026,612.9620320000686Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M679.6160892695189,777.4258139831945L688.1841813540086,754.0392867536284L701.3088796334341,758.8941019834019L692.7407875489444,782.2722891336307Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M626.5366759719327,757.8088960465975L634.4878591159359,735.2806899175048L638.9458545455709,736.8611627067439L637.7483254252002,740.2551721767522L640.2711832178757,741.1624607550912L641.9862216291949,736.315956861712L648.5623762765899,738.6538907852955L648.0803668601438,740.0075406399556L640.0936838416383,762.6356160729192Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.8885734509677,763.2307621762156L640.0936838416383,762.6356160729192L648.0803668601438,740.0075406399556L660.984965913929,744.5928844981827L652.7931725056842,767.8160906708799Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M729.9249345334247,764.002787288744L736.9262987952679,744.9050248800777L737.6844183523208,742.8355338755064L751.7234356375411,748.0295493472368L743.9631629334763,769.1697348314337Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M743.9631629334763,769.1697348314337L751.7234356375411,748.0295493472368L764.7345343157649,752.8489929181524L756.9813615866005,773.9881232413463Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M718.3022754155099,712.7024678890593L721.456242098473,703.873010460753L723.1854804623872,704.4816877711564L725.2476287633181,698.6924880756997L723.525490376167,698.0682031325996L725.9773484189063,691.2021055244841L739.2716572135687,695.9851719667204L738.5987373581156,697.8559462409467L736.3874895805493,704.0925504886545L731.5760731697083,717.5146527132019Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M768.6529316445813,653.592958632391L768.9653305457905,652.7845043600537L775.4420855417848,635.5426598568447L780.8775108670816,637.6048995051533L784.5063869925216,638.9793787705712L784.8321969574317,638.0939269806258L789.3746032025665,639.8086443254724L787.0221448093653,646.0598675557412L787.5609540259466,646.2575592780486L782.791348580271,658.9503964646719Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M669.6027578227222,615.2958455784246L670.8996865944937,612.2139212843031L675.6692920401692,600.8320154766552L682.3519463129342,603.0503388373181L683.5707753589377,600.1234420584515L689.6436206642538,602.6955320062116L687.0008521825075,609.7406812519766L683.0035662427545,620.3703006543219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.1713818917051,681.7483342993073L639.3284643115476,658.7870409721509L646.0182185582817,661.1895108325407L644.7070898367092,664.8748917393386L637.8611361384392,684.1435128641315Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M710.7408020133153,791.6125130360015L711.6196211436763,789.2392212874256L716.3466267390177,776.3624606714584L720.3289238428697,765.5197851778939L726.1122479457408,767.6381712434813L716.5233372282237,793.739214814268Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M692.7407875489444,782.2722891336307L701.3088796334341,758.8941019834019L707.5734242647886,761.2039357256144L699.0053321802989,784.5831555477343Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M635.2538675321266,732.5598619892262L635.6080773966387,731.5672537549399L643.7154599912465,709.2158428090625L649.9729046467692,711.4976003337651L644.0554699068889,727.8111563101411L641.5184121634811,734.8270452618599Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M629.1021336149424,729.2074675648473L637.2024162337184,706.8706156406552L643.7154599912465,709.2158428090625L635.6080773966387,731.5672537549399Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M699.0053321802989,784.5831555477343L707.5734242647886,761.2039357256144L713.766969146207,763.4929593931884L709.9116827063262,773.9881232413463L705.1988770607859,786.8721714988351Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M656.2019494045526,660.3883408131078L659.518426627852,651.0978832393885L657.4917782004923,650.3612219444476L662.4877939615399,636.3927355068736L669.2698478838429,638.837872967124L663.6214233078063,654.6344806640409L660.8650552248582,662.3444440797903L659.3693271521479,663.0956708244048L657.0381686845794,662.2528818096034Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M729.0674153268337,798.3453323286958L737.8193178772926,774.498990828637L743.6160530438647,776.6392238778062L734.878350444138,800.5063672056422Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M734.878350444138,800.5063672056422L743.6160530438647,776.6392238778062L749.2644776199013,778.7295140512288L748.4629693282768,780.91864753142L741.4545050906017,800.0319176241755L740.5188861591741,802.590407426469Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M735.976479915902,684.7667585820891L743.3399429032579,664.1663248711266L749.8095979243517,666.504283125978L742.2339245714247,687.0277146231383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M650.6458245022222,648.4685847242363L655.5779404882342,634.692584102042L655.8193396385759,633.9912975360639L662.4877939615399,636.3927355068736L657.4917782004923,650.3612219444476L655.5921404380351,655.6760025364347L654.1185011770576,656.5406424547546L651.8930534496903,655.7394718979485L650.8793347934261,653.8686862569302L652.5730732800439,649.1490601771511Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M643.1837507514283,655.519930338487L646.2446288736537,646.9661279777065L644.1753805959597,646.2294662431814L649.1295853918418,632.3608580259606L655.5779404882342,634.692584102042L650.6458245022222,648.4685847242363L648.8739862907678,653.4150362703949L647.3009473793209,654.2734335847199L646.4434281736612,656.6967146331444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.0554699068889,727.8111563101411L649.9729046467692,711.4976003337651L656.9955688351765,714.035313360393L651.5601435089484,729.037870906759L647.9036563709378,727.7050283197314L647.4287469303235,729.0305876140483Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M663.6214233078063,654.6344806640409L669.2698478838429,638.837872967124L676.0874016815796,641.2975763357244L675.8886023797095,641.8573564202525L670.4389771046117,657.0931379436515Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.755906692706,644.8976482166909L637.6560257496312,642.3817600291222L642.2197319194674,629.6254229061306L649.2068962324411,632.1485991189256L649.1295853918418,632.3608580259606L644.1753805959597,646.2294662431814L643.7501709805802,647.4124950096011Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.9378716023639,639.964716878254L635.5086777480319,627.2083753100596L642.2197319194674,629.6254229061306L637.6560257496312,642.3817600291222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M705.1988770607859,786.8721714988351L709.9116827063262,773.9881232413463L716.3466267390177,776.3624606714584L711.6196211436763,789.2392212874256Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M806.955719139427,783.1691675907932m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M758.9022992746904,796.9063761336729m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M719.7475147759542,751.1051704590209m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.4515052009374,810.7507246355526m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M680.5398749085143,660.8315855353139m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M727.1732997680083,784.1191094978712m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M661.1932318471372,724.0446521188132m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M690.4616955649108,768.1594439418986m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.5401137629524,753.6137359212153m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M740.8218184271827,756.0161729184911m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M754.3504263972864,761.0093686762266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M729.7860905779526,704.2871191329323m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M778.2623534006998,649.5215528272092m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M717.2625235179439,782.8008439689875m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M700.1571059068665,771.738640664611m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M643.4716941816732,719.6549033564515m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M704.4604796590284,779.2851211880334m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M663.3808130417019,644.6000700928271m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M736.3464675024152,787.4922866006382m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M741.7550707003102,790.4752891659737m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M742.8397891065106,675.635526868049m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M656.5679925614968,642.4306627446786m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M649.8742938823998,640.4610275733285m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.5464248526841,720.870174208656m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.7550128428265,648.245921486523m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M643.394383343868,637.3707905951887m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M650.7168242530897,739.5819889465347L653.8274022014812,731.0074809109792L651.191733693704,730.0512889069505L651.5601435089484,729.037870906759L656.9955688351765,714.035313360393L670.8286868454888,719.0524702081457L661.9134848704562,743.6356538995169Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer university"
        d="M1022.8170487517491,715.8280473416671L1023.5475572934374,644.5355601483025L1075.1651646215469,645.9287667279132L1075.1651646215469,718.1389359054156ZM1025.7225163104013,829.6360527910292L1025.7225163104013,808.9403274091892L1075.1651646215469,809.5698046609759L1075.1651646215469,829.6360527910292Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1003.6408050926402,613.0712832114659m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M955.6639071814716,828.2512067737989L955.6071073804051,829.6360527910292"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M963.9992778617889,612.9620320000686L963.8557005887851,617.6067676548846"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M964.6990198455751,639.1926779490896L959.6185932708904,789.847891102545"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M859.5752118322998,764.0953886802308L890.2179151596501,765.7892655604519L891.4864440308884,731.9355800966732L860.5605305898935,730.4549913164228"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M953.2262490894645,668.8932240833528L955.6142073562369,690.0461366106756L954.8560878001153,749.93568545999L950.6158249378204,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M861.1064397785813,627.8045735247433L861.866925993003,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1018.196542782709,812.1074817865156L1017.5425561945885,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M977.6470076348633,633.699961851351L978.2891609324142,612.9620320000686"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,780.0207283236086L880.0247176811099,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1018.196542782709,812.1074817865156L1018.5294527225196,804.1490152291954"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M954.8560878001153,749.93568545999L956.4362266864628,763.5137686976232L956.9608359532431,772.1246527587064L956.8827362265438,782.7831561123021L956.1033167466521,796.8574745072983L955.4161969404668,812.7171900514513L955.7065070299432,816.3733576000668L956.478826536797,819.6195832928643L957.8041552081704,821.6391094690189L959.9373032609001,822.5182950752787L962.8569707693532,822.829391496256L972.4450925989076,823.007309507113"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,810.3907261448912L859.9160106340423,809.6977810184471L861.9639589861035,807.5440322142094L862.9200889552012,805.4527102713473L863.2040879568085,802.7391930995509L862.55877911672,800.095385660883L861.7012599091977,799.2307636477053L860.3688312629238,797.2039477215149L858.4912823121995,796.1260310024954"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M954.6336219161749,612.9620320000686L953.9559687431902,631.9706762074493"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M880.9303589398041,829.6360527910292L858.4912823121995,778.2134444592521"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M953.9559687431902,631.9706762074493L861.1064397785813,627.8045735247433L858.4912823121995,627.8597192559391"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M953.2262490894645,668.8932240833528L947.117115020752,700.1876502870582L941.9317665947601,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M861.0441177757457,639.4684061468579L860.5605305898935,730.4549913164228L859.5752118322998,764.0953886802308L858.4912823121995,786.2125187981874"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M861.1064397785813,627.8045735247433L861.0441177757457,639.4684061468579"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,638.5267682923004L977.6470076348633,633.699961851351"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M858.4912823121995,639.5318756559864L864.1042070128024,639.390369866509L920.4645976582542,641.4317987021059L940.8383704395965,643.1184221743606L939.9098514840007,665.5054225525819L900.0261362157762,663.945743096061L895.0009316690266,829.6360527910292L858.4912823121995,829.6360527910292Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M962.602949439548,829.6360527910292L962.8569707693532,822.829391496256L972.3527929233387,656.1223690086044L977.6470076348633,633.699961851351"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M977.6470076348633,633.699961851351L968.3491958938539,633.026768273674L953.9559687431902,631.9706762074493"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M953.9559687431902,631.9706762074493L953.2262490894645,668.8932240833528"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M972.0246163010597,829.6360527910292L972.4450925989076,823.007309507113L973.366511579603,803.2635845388286L978.3341274410486,695.8082911702804L979.8787664519623,659.5590777159669L977.6470076348633,633.699961851351"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M863.2040879568085,802.7391930995509L864.2525176024064,805.45999348443L874.1057051662356,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1075.1651646215469,805.2675085957162L1018.5294527225196,804.1490152291954L973.366511579603,803.2635845388286"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M865.5281464494765,770.5015289825387L865.0035371826962,760.3465921198949"
      />
      <path
        fill="rgb(255, 255, 255)"
        stroke="rgb(255, 255, 255)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M982.2604136308655,782.3295145616867L983.1952436743304,757.4124784921296L987.3700289912522,757.5685483966954L987.6887389812618,748.922270365525L983.3372431760654,748.7599574625492L984.5915720965713,715.4732462828979L988.9430679017678,715.6366004394367L988.999867701903,711.1147062820382L1063.2892730617896,713.9219018500298L1063.161473510787,717.3232058575377L1067.0167599497363,717.4719933583401L1066.08114101924,742.580619154498L1074.6705330284312,742.8990024346858L1073.671014321968,769.6369032789953L1065.3372214138508,769.3247640100308L1064.437102357857,793.1929729790427L1050.5258846217766,792.6612975555472L1050.2426745072007,800.4075235463679L994.7398030674085,798.3172399108298L995.321212134324,782.9246589746326L986.4273100839928,782.5917110596783L986.4344100588933,782.4918266804889Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M875.4002672797069,621.4118276746012L876.9378063166514,583.1010104329325L878.0927355876192,583.1509540593252L880.1903837639838,531.0491518010385L901.5920751513913,529.5612366111018L914.6599736306816,530.0856487145647L944.9342671437189,531.9283742648549L943.616827333346,564.8819679254666L942.7238082522526,587.0278269159608L943.4109280575067,587.0559201897122L943.106418017298,594.5672250846401L942.071399435401,594.5256054657511L941.5333791067824,607.9052598066628L943.0283182924613,607.9614461874589L942.3624984119087,624.6716709802859L933.8583061015233,624.3241486595944L933.9222058774903,622.7446906990372L915.7730919383466,622.0142693086527L915.7304920880124,623.2753386716358L915.5884925872087,623.5947679192759L915.1490830220282,624.1472660326399L914.5542628914118,624.5228814845905L914.2134640906006,624.6290110577829L913.866354200989,624.6716709802859L913.1721344199032,624.5863511301577L912.8392244810238,624.452128438279L912.2791153388098,624.0338530517183L912.0598049992695,623.7581242402084L911.7758059985936,623.1057394207455L911.8042058981955,622.3264152104966L904.6750420862809,622.0350790349767L904.5401425594464,622.7374072936364L904.3847319958732,623.048512680456L903.9666223553941,623.5240148622543L903.2858136389405,623.8996303477325L902.5915938587859,624.0057599302381L901.9044740526006,623.8496870161034L901.5920751513913,623.6800877829082L901.1739655109122,623.317998603452L900.8907553972676,622.8997231489047L900.6856450075284,622.2338119288906L900.7282448578626,620.3130738893524L898.7079075183719,620.2287944713607L898.6511077182367,621.7947266818956L882.6493417816237,621.1423416766338L882.6288307420909,621.7021233895794ZM892.9821721035987,588.387749326881L927.5795615203679,589.7840886651538L927.9479713365436,580.5143463215791L893.3576818937436,579.119045610074Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M896.1140499766916,834.7634141440503L897.7304776236415,788.3600314604118L906.6448907125741,788.6721698748879L907.354099329561,768.2759759575129L904.2569324458018,768.1698485868983L905.5183613412082,731.8159260605462L908.7220278503373,731.92205399042L909.4233476063237,711.8732110522687L901.0540548218414,711.5829191138037L902.6767935594544,664.902984698303L906.5533799240366,665.0372066088021L912.321715189144,665.2505049845204L932.2781672161072,665.9445050312206L932.2568672914058,666.6041691759601L931.3851481340826,691.5704340133816L933.1703974111006,691.6339030419476L938.1877130968496,691.8035006150603L937.9116029571742,699.7485699779354L934.0421165674925,810.5904940948822L932.1219677655026,810.5270261522382L926.743342240341,810.3428650712594L925.8574231341481,835.8059494132176L899.076317335479,834.8632977716625Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1023.6106681833044,704.0925504886545L1023.6177681582049,703.9011032613926L1025.758016185835,645.2940722019412L1080.4459682703018,647.3136491659097L1082.68561594747,647.391685357783L1081.4312870251015,681.4788506468758L1080.5240679942071,706.1901458539069Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1024.5533870905638,829.9731602682732L1025.2831067452207,810.8318803608418L1078.0864099022,812.8514090995304L1074.2453234130517,914.170441898983L1050.5684844721109,913.2631759634241L1050.625284272246,911.881467982661L1051.1072936886922,899.1318694315851L1051.844113319181,879.9200300388038L1052.893331850879,852.083837501239L1053.1481420658529,845.3510703989305L1034.81521766074,844.6570883151144L1035.360337967053,830.3914232281968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1017.6017226530239,627.8253832343034L1020.1529803453013,570.5152052585036L1059.6043860223144,572.2372227758169L1056.1459092991427,629.1436782311648Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.734418339096,619.6336360904388L1059.462386522442,575.5043726586737L1059.6043860223144,572.2372227758169L1061.0425254097208,539.9433402768336L1068.313688722439,540.2627733657137L1068.4059883961454,538.1006168583408L1072.9767945418134,538.3066356498748L1072.8844948662445,540.4750350853428L1083.1747253378853,540.942218942102L1081.0202773604542,589.2596810786054L1086.4770026113838,589.5146014383063L1084.960763500072,623.403318468947L1073.9976131739095,622.9142899573781L1073.8485136982054,626.2376021868549L1063.041562821716,625.7485738755204L1063.3034730115905,619.9374582082964Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M986.8454197244719,700.9388729310594L990.0411973726004,644.358678036835L1016.3970935568213,645.8465685853735L1015.2200754741207,666.6749217924662L1019.5715712802485,666.9225559472106L1019.947081069462,666.9444060209207L1019.259961264208,679.1471403050236L1019.1392616890371,681.2593099023215L1015.8156844908372,681.0751453870907L1014.6039554188028,702.5193535494618Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M988.4255586108193,626.5143713881262L989.6798875331879,598.3161112959497L991.6213362589478,598.3941480405629L1018.8560515735298,599.6271284772083L1017.6017226530239,627.8253832343034Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M982.9617333849892,834.3742841761559L983.9754520421848,810.1025192458183L1012.9670167323202,811.3208956168965L1011.9390981271863,835.9609770984389Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M920.5206085722893,750.0459749787115m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1053.5591517314315,664.434768713545m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1004.0123704532161,673.0457758470438m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M968.3491958938539,633.026768273674L968.7933387765661,612.9620320000686"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer university"
        d="M1075.1651646215469,645.9287667279132L1133.0788720259443,647.4905312014744L1139.9106257744133,612.9620320000686L1183.847637896426,612.9620320000686L1183.847637896426,644.2098889630288L1291.839046932757,651.8449492780492L1291.839046932757,776.0544835589826L1250.2994597125798,775.589396472089L1248.2933223238215,829.6360527910292L1075.1651646215469,829.6360527910292L1075.1651646215469,809.5698046609759L1082.4655167218298,809.6624054401182L1093.4428669987246,718.9463420836255L1075.1651646215469,718.1389359054156Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1161.5339941605926,620.6855680905282m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M1200.0198032334447,767.3478816365823L1179.454331126064,766.5186313404702"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M1241.370846672915,769.2831454379484L1223.4055431978777,768.6380575648509"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M1291.839046932757,771.7459239135496L1266.5497247753665,770.940604810603"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer gate"
        d="M1192.9119393462315,639.8304944830015L1192.7344399690628,644.3940544612706L1192.5790294054896,648.4051152961329"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1095.830036379397,646.4864654722624L1093.4428669987246,718.9463420836255L1092.026027536951,761.9197759353556L1090.2967891758308,805.5661202836782"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1096.0580244660378,639.5610092007555L1095.830036379397,646.4864654722624"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1250.462759138085,780.3734451518394L1248.4526773188263,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1255.2741755479947,649.2603917806409L1253.361126719974,702.192644615192L1250.9163686530665,769.0989832608029"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1255.338075322099,647.4697215487249L1255.2741755479947,649.2603917806409"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1253.361126719974,702.192644615192L1174.2524160901085,699.719436685089"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1096.0580244660378,639.5610092007555L1075.1651646215469,638.5267682923004"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1183.847637896426,643.87901535118L1175.7410441879183,643.4087169803679"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1291.839046932757,649.2010842901655L1255.338075322099,647.4697215487249L1192.7344399690628,644.3940544612706L1183.847637896426,643.87901535118"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1172.5799775291234,765.1441773618571L1174.2524160901085,699.719436685089L1175.7410441879183,643.4087169803679"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1170.567529052496,817.1890759957023L1172.5799775291234,765.1441773618571"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1092.026027536951,761.9197759353556L1172.5799775291234,765.1441773618571L1250.9163686530665,769.0989832608029L1291.839046932757,770.3329738019966"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1090.2967891758308,805.5661202836782L1089.3043704433367,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1096.9952211696655,612.9620320000686L1096.0580244660378,639.5610092007555"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1090.2967891758308,805.5661202836782L1082.979081582278,805.4225369645283"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1082.979081582278,805.4225369645283L1075.1651646215469,805.2675085957162"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1256.8480033446103,612.9620320000686L1255.338075322099,647.4697215487249"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1096.4800785379484,646.5031131971627L1090.2967891758308,805.5661202836782L1089.5189474662766,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1097.7841072846204,612.9620320000686L1096.4800785379484,646.5031131971627"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1172.5799775291234,765.1441773618571L1214.1787312077358,726.0465181362815L1250.9163686530665,769.0989832608029"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1250.9163686530665,769.0989832608029L1250.655247349292,775.5935583258979"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1250.655247349292,775.5935583258979L1250.462759138085,780.3734451518394"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1170.08709740825,829.6360527910292L1170.567529052496,817.1890759957023"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1175.7410441879183,643.4087169803679L1134.2827122360468,641.4068270991556"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M1172.587077504024,765.0307666892186L1175.102835321799,699.9462601658888L1248.6554210502654,702.80236255005L1246.1396632324904,767.8795590046793Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1099.4384014643729,866.7739614113234L1100.8134299619123,830.8731539184228L1102.528468374163,773.0028041810729L1162.7015456091613,774.9942514277063L1160.9155074469745,834.1048064567149L1160.3624982805923,848.5473408056423L1159.7534782011062,864.3008121955208L1159.6114786993712,868.7726648640819L1135.4881302183494,867.9715188313276L1127.8422460025176,867.7093255664222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1187.3061146195978,634.2951190238819L1189.2128523578867,591.6049480354413L1189.4392626713961,586.4534755186178L1187.7384242098778,586.3827220830135L1188.1778337759897,576.5250965598971L1189.1418526070192,576.5677567790262L1190.2186821522191,552.2180924084969L1189.2554522072896,552.181675019674L1189.6522619230673,543.3520131343976L1250.7601692024618,546.094765778631L1246.7139723235741,636.96708276961L1231.605225467123,636.2793227289803L1231.5413256920874,637.6756524182856L1202.067751585506,636.3573590433225L1202.1316513605416,634.9620695733465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1177.526293464005,847.7888509891927L1178.3420017044991,834.9049159470014L1180.9918701620772,776.4758711606264L1241.7179565625265,779.4526356915012L1239.0388993201777,838.1303238817491L1238.5008789896965,845.7693324307911L1238.2523798644543,850.7655848963186L1228.657158059068,850.2973814648576L1228.5151585582644,853.2179299090058L1221.3149949954823,852.8631358812563L1221.456994496286,849.9436277430505L1206.6243577804416,849.2132302909158Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1264.3100770981982,635.832954980433L1267.7898537460715,557.7733028312214L1298.368657298386,559.1488384203985L1321.8111970638856,620.6470700870268L1321.7906860252842,621.0788719998673L1320.876367018558,641.694000528194L1269.1293823681772,639.3622768041678Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1257.1099135354161,850.7728680619039L1257.7339224508032,838.6193372108974L1259.5270605878904,794.2771329195239L1262.84353781119,794.4123927843757L1263.1054480010644,788.4172568381764L1265.2172961290926,788.5015342114493L1265.4792063180357,782.3149480889551L1293.0965313985944,783.5052368659526L1292.7912324722856,790.5710115833208L1305.994030477479,791.1453460692428L1306.050830276683,789.9051164691336L1311.27404523734,790.1246537715197L1311.0042461873963,796.4100766405463L1315.4054418178275,796.5952785527334L1314.5834224876016,815.8635335564613L1314.3988231364638,820.1512566492893L1313.662003505975,839.8304253965616L1312.9882947634906,853.1887972620316L1277.7250854671001,851.665575849358Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1112.081090329215,592.0159419407137L1112.7121992204338,577.7008537687361L1115.3691676529124,577.8142675077543L1116.9635064881295,542.1897765756585L1143.390402423218,543.3738635946065L1142.9438928822055,553.4573240401223L1159.186269084923,554.1877526557073L1159.3211686108261,551.1619880334474L1166.5986430123448,551.4949470646679L1166.4645323725417,554.5207115411758L1166.65544281248,554.5279950178228L1165.2812032010406,585.3692830749787L1179.9860403677449,586.0351978405379L1180.1485509062186,582.5276992022991L1186.8312051789835,582.8325634379871L1186.6686946386471,586.3254950363189L1187.7384242098778,586.3827220830135L1189.4392626713961,586.4534755186178L1189.2128523578867,591.6049480354413L1186.4414954381064,591.4780081422068L1186.3002848234028,594.6952054146677L1179.6176305515692,594.390341700986L1179.758841167204,591.1731442846358L1141.3353540962562,589.451131473761L1140.3997351648286,610.4908732101321L1139.5919157834724,628.6973100230098L1135.2333200043067,628.498577317223L1135.0842205276713,631.7584172906354L1119.6567636830732,631.0571304280311L1116.1201872322708,630.9010576754808L1116.2621867340058,627.648500696756L1113.165019848384,627.5132375801913L1114.7388476477936,592.1366388807073Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1023.6106681833044,704.0925504886545L1023.6177681582049,703.9011032613926L1025.758016185835,645.2940722019412L1080.4459682703018,647.3136491659097L1082.68561594747,647.391685357783L1081.4312870251015,681.4788506468758L1080.5240679942071,706.1901458539069Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1267.662054196,694.7241158294491L1268.0020641107112,664.9810206932016L1272.5941701810807,665.030963730067L1272.6935698306188,656.4698897339404L1320.6917676674202,658.8369840527885L1343.737497717142,720.6329466970637L1337.7640520622954,720.3488979535177L1333.3344565303996,720.1366417435929L1329.1746600531042,719.9379116543569L1290.04906434007,718.0598600367084L1290.1697639152408,706.8279562210664L1291.6292032264173,706.8487656931393L1291.7712027281523,695.0071251485497Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1262.3615283947438,758.4050830295309L1262.5311389099807,753.9404424317181L1262.8790376866236,747.9868901828304L1263.8990674316883,727.18063116353L1264.4023767728359,717.0963829420507L1290.04906434007,718.0598600367084L1329.1746600531042,719.9379116543569L1333.3344565303996,720.1366417435929L1337.7640520622954,720.3488979535177L1343.737497717142,720.6329466970637L1355.2678571604192,750.2832014863379L1350.9802611302584,755.66969764838L1302.1742439130321,753.4940822594799L1301.9265336729586,759.921041672118Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1024.5533870905638,829.9731602682732L1025.2831067452207,810.8318803608418L1078.0864099022,812.8514090995304L1074.2453234130517,914.170441898983L1050.5684844721109,913.2631759634241L1050.625284272246,911.881467982661L1051.1072936886922,899.1318694315851L1051.844113319181,879.9200300388038L1052.893331850879,852.083837501239L1053.1481420658529,845.3510703989305L1034.81521766074,844.6570883151144L1035.360337967053,830.3914232281968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1105.3700361559168,691.386269771494L1106.7734645530581,651.6087598833255L1123.8165601603687,652.21119889291L1123.9940595375374,647.1648601577617L1133.0788720259443,647.4905312014744L1155.005172680132,648.2708930647932L1153.9425430847332,678.6373061677441L1148.8968274984509,678.4593844520859L1145.2040515989065,678.3251628018916L1144.8640416851267,687.8288815678097L1140.512545878999,687.6728100907058L1140.3287354148924,692.6327598514035L1119.6141638318077,691.896102970466L1118.8986441269517,712.1707862890325L1139.6203156840056,712.9147243285552L1139.4428163086995,717.9682985059917L1141.1578547190875,718.0317672924139L1140.9377554943785,724.317255530972L1137.2315685311332,724.1830347683281L1137.1463688304648,726.7269859770313L1124.6243795426562,726.280624052044L1124.7166792172939,723.4390979404561L1118.55153423734,723.2268418222666L1118.4805344864726,725.2037367746234L1107.8005942739546,724.8281267783605L1108.864012756385,694.4972921777517L1109.7641318123788,694.5253850170411L1109.8627425767481,691.548584017437Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1186.420195513405,692.0802671988495L1188.099734051153,654.4784084428102L1246.4378621829674,657.1149880480953L1244.7583236480132,694.7168325027451Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.734418339096,619.6336360904388L1059.462386522442,575.5043726586737L1059.6043860223144,572.2372227758169L1061.0425254097208,539.9433402768336L1068.313688722439,540.2627733657137L1068.4059883961454,538.1006168583408L1072.9767945418134,538.3066356498748L1072.8844948662445,540.4750350853428L1083.1747253378853,540.942218942102L1081.0202773604542,589.2596810786054L1086.4770026113838,589.5146014383063L1084.960763500072,623.403318468947L1073.9976131739095,622.9142899573781L1073.8485136982054,626.2376021868549L1063.041562821716,625.7485738755204L1063.3034730115905,619.9374582082964Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building_part"
        d="M1262.8790376866236,747.9868901828304L1263.8990674316883,727.18063116353L1289.3761444855481,728.1867661452852L1290.04906434007,718.0598600367084L1329.1746600531042,719.9379116543569L1337.6078526116908,741.630671555642L1290.8497837465256,739.6246481649578L1290.3748743059114,749.1209996202961Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1123.7029605610296,752.3454070016742L1124.6243795426562,726.280624052044L1137.1463688304648,726.7269859770313L1137.2315685311332,724.1830347683281L1140.9377554943785,724.317255530972L1141.1578547190875,718.0317672924139L1164.9546043509617,718.8818328306079L1163.721575354226,753.7698059109971Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1139.4428163086995,717.9682985059917L1139.6203156840056,712.9147243285552L1140.3287354148924,692.6327598514035L1140.512545878999,687.6728100907058L1144.8640416851267,687.8288815678097L1145.2040515989065,678.3251628018916L1148.8968274984509,678.4593844520859L1153.9425430847332,678.6373061677441L1166.3580327462405,679.0763878142461L1166.2018332965672,683.6045457357541L1164.9546043509617,718.8818328306079L1141.1578547190875,718.0317672924139Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1143.4890131875873,629.4131639180705L1144.2053217785433,614.3177873762324L1167.7756610941142,615.4519186820835L1171.0424384931102,615.607991782017L1171.0850383425131,614.7714399215765L1179.4259312255308,615.1689061154611L1178.915521910414,625.961873463355L1174.6421258309856,625.7631406760775L1174.394415590912,630.9010576754808Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building_part"
        d="M1262.5311389099807,753.9404424317181L1262.8790376866236,747.9868901828304L1290.3748743059114,749.1209996202961L1290.8497837465256,739.6246481649578L1337.6078526116908,741.630671555642L1329.1746600531042,719.9379116543569L1333.3344565303996,720.1366417435929L1343.3619879269972,745.5844504032284L1294.3082604706287,743.2246689838357L1294.0668613184243,748.2917471416295L1293.8120511043817,753.1819422640838L1293.7268514037132,755.1380193470977Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1265.4792063180357,713.3683704193681L1265.9399158079177,697.9839246608317L1288.6811358183622,698.6706381049007L1288.3127260031179,710.9659186415374L1288.2204263266176,714.0488395048305Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building_part"
        d="M1263.8990674316883,727.18063116353L1264.4023767728359,717.0963829420507L1290.04906434007,718.0598600367084L1289.3761444855481,728.1867661452852Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building_part"
        d="M1262.3615283947438,758.4050830295309L1262.5311389099807,753.9404424317181L1293.7268514037132,755.1380193470977L1293.8120511043817,753.1819422640838L1302.1742439130321,753.4940822594799L1301.9265336729586,759.921041672118Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1131.7495989240706,802.9337589764036m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1210.0260347044095,807.1788312629797m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1286.5290544992313,818.006875204388m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1125.3462103363127,683.1550596039742m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1216.428634405136,674.5971294278279m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1144.1903329435736,739.5362083236687m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1152.7497472800314,702.7742697442882m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1134.2827122360468,641.4068270991556L1096.0580244660378,639.5610092007555"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M-8.205035817809403,830.3976659579203L-3.4480525497347116,834.1183323636651L-1.8111138632521033,839.1291595827788L-3.8306623147800565,844.6851805434562L-7.3104389645159245,853.5716834669001L-8.205035817809403,856.4017112739384ZM-8.205035817809403,866.5419411379844L-6.650930172763765,869.3178602918051L-3.242153273895383,872.1738928966224L1.8737731762230396,874.2651947084814L43.621626330539584,889.5223148283549L45.13865432795137,890.6772100324742L45.839974083937705,891.967363008298L46.187083973549306,893.8599337525666L22.545744908042252,960.0142685528845L-8.205035817809403,948.1512112589553Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M174.46548832021654,909.676769208163m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M-8.205035817809403,918.8690787176602L4.687729943543673,924.9348518350162L20.136486715637147,932.3469488630071L26.266131821088493,934.8845810452476L27.74765994399786,936.1528765689582L25.635811815969646,944.6210062005557L22.66644448414445,952.2401291062124L20.979805971495807,955.4145010695793L15.898590511642396,954.351175061427L-8.205035817809403,944.5232050321065Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M149.4751539984718,895.5537789254449L159.10666456539184,898.7989270971157L155.28687800187618,908.5999104194343L154.42225882038474,911.3924598204903L154.15245977044106,914.3254678323865L154.1666597193107,917.1533899572678L154.7906686346978,919.3924209298566L155.76888741739094,921.4410504037514L156.95221658796072,922.44715718925L201.7609478663653,939.547828908544L191.42180645558983,971.8481733938679L208.46884649340063,985.335304427892L208.46884649340063,986.3570084152743L204.19860595837235,999.87636454124L195.08539356850088,991.598701259587L186.92831114958972,982.0038408813998L177.68019923381507,971.3810185762122L169.26830660086125,959.7801705291495L163.86838115006685,948.8378999223933L159.28337505552918,937.4430210809223L156.95221658796072,930.9517189622857L155.5700881164521,925.7994581707753L151.72900162730366,912.8657268602401Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M-3.986861765384674,906.7427187836729L9.52754625491798,882.8613749467768L16.32380012702197,884.9516330887564L23.523963689804077,887.7015337091871L30.078818410634995,892.9880403117277L32.828875405713916,895.7441804180853L33.45919540990144,899.75613627024L31.77255689818412,904.8366257860325L26.266131821088493,911.6119932765141L22.24833484273404,914.9923914405517L16.11158976238221,916.2606906034052L11.030374300666153,915.8424328239635L3.6243114629760385,912.4547519735061Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M-8.205035817809403,874.3713204571977L-7.374338738620281,874.3713204571977L-1.6620143866166472,877.7517367806286L5.3180499486625195,881.5639371462166L9.52754625491798,882.8613749467768L-3.986861765384674,906.7427187836729L-8.205035817809403,904.1769843096845Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer dog_park"
        d="M64.93101804330945,876.9433086500503L73.47071022819728,854.1532958927564L91.40051382780075,860.8777308412828L89.88348583038896,864.9032327211462L96.46674045268446,867.3690985743888L88.79955630935729,887.8357513053343L65.95183667447418,879.2614266425371L68.33269496820867,878.3042146381922L67.78757466189563,877.1066590007395L67.40496489685029,875.9517615339719Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer garden"
        d="M-8.205035817809403,836.0171616273001L-5.467601002193987,838.3925182684325L-8.011758718639612,847.9241098104976L-8.205035817809403,848.4505787361413Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer beach"
        d="M69.84972296468914,872.6202454250306L69.99093357846141,868.8652648529969L70.926552509889,866.2568579241633L73.18040013778955,863.2593216653913L76.45427751075476,861.1690569808707L80.12496459949762,860.3751932252198L83.45564177446067,860.7643217351288L86.8360187727958,862.3874243772589L88.30334694404155,863.6557331643999L90.40809509623796,866.7666782629676L91.18041460122913,869.3178602918051L90.85460463631898,874.3432283471338L87.89233727939427,879.0554179814644L83.22923145908862,881.5993123576045L79.50174456927925,881.8968803072348L77.63760668132454,881.5504113282077L74.25722968298942,879.9273131741211L72.18088143132627,877.9712713020854L70.36723225470632,874.7469223518856Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer natural_wood"
        d="M65.10141744371504,876.766432470642L73.52751002833247,854.2802309789695L91.27271427679807,860.942238772288L89.7556862803176,864.9667001664639L96.33972978778183,867.433606446255L88.74275650922209,887.7088168351911L66.22084683924913,879.2614266425371L68.4604945173487,878.3541561369784L67.87908545229584,877.0785669013858L67.46807578578591,875.8165032593533ZM69.3890134729445,872.6202454250306L69.90652276482433,874.7968638762832L71.67757209111005,878.01392966602L73.95271964371204,880.2175980634056L77.43959626741707,881.8968803072348L79.39524494484067,882.2589559806511L83.27183130849153,881.946821781341L88.09034769330174,879.3103276845068L91.15911467559636,874.4347878159024L91.49202461726964,869.2335839020088L90.68420523684472,866.5689928312786L88.51555730868131,863.3654475808144L86.9780182717368,862.0336712687276L83.4769416982308,860.3533437605947L80.02635383605957,859.9496489204466L76.22786719724536,860.7716048886068L72.83329024817795,862.9399034571834L70.50134289450943,866.0373230320401L69.53101297467947,868.7653817203827Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer garden"
        d="M149.41204310953617,883.7259865296073L149.61715350020677,882.5773328505456L149.8514526747167,881.6419706991874L150.19856256619096,880.6993252928369L151.0986816221848,878.2542731398717L164.81820003129542,883.3212526012212L159.10666456539184,898.7989270971157L149.4751539984718,895.5537789254449L150.45337278023362,892.2576473942026L150.72948291990906,891.3222865522839L150.8359825462103,890.2173328665085L150.78628272097558,889.06139714038L150.61667220667005,887.9564430941828L149.51065387390554,885.100416994188Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M188.42403922136873,982.3721539196558L194.503984503448,974.9101695744321L207.55058305710554,985.540269496385L201.47063777595758,993.0022423993796Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer fence"
        d="M64.93101804330945,876.9433086500503L73.47071022819728,854.1532958927564L91.40051382780075,860.8777308412828L89.88348583038896,864.9032327211462L96.46674045268446,867.3690985743888L88.79955630935729,887.8357513053343L65.95183667447418,879.2614266425371L68.33269496820867,878.3042146381922L67.78757466189563,877.1066590007395L67.40496489685029,875.9517615339719Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M208.46884649340063,1006.8087438689545L204.77291504945606,1005.4249736736529L199.38718954846263,1002.3994059972465L194.95049404352903,998.7142045176588L181.04637628234923,983.5343166827224L178.86431729141623,980.6002975162119L168.70188636984676,966.3775699925609L160.57320385146886,951.4816506346688L153.80534987803549,934.5516404276714L149.06414433382452,916.2679737005383L145.67666735965759,895.9574716952629L143.11909857857972,873.0104136960581L142.31759028602391,861.0129894064739L142.89189937803894,850.2838555891067L143.2035093922168,839.9656843720004L144.27718339394778,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M203.54698602762073,1011.9380550421774L208.46884649340063,1013.7868950781412"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M142.14087979588658,963.9044563090429L138.05208306759596,950.8365797153674L134.49420669395477,934.0626338617876L130.22081061359495,905.5243591824546L129.9447004729882,882.7906245333143L130.58212045393884,866.0373230320401L132.34685869142413,851.2972558671609L137.36417437624186,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M90.12488498073071,967.3836702569388L104.08501365594566,973.463966996409"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M20.504896530881524,958.1498076366261L16.692209942266345,956.6266092872247L-8.205035817809403,946.7434992892668"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M85.00816964637488,919.1656046290882L69.11290333420038,958.6388125014491"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M32.41786573827267,943.8635673327371L69.11290333420038,958.6388125014491"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M4.7161298440769315,832.7511749751866L-1.499503848142922,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M104.08501365594566,973.463966996409L126.42232397478074,982.1380566526204"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M126.42232397478074,982.1380566526204L174.31402218528092,1000.8262767498381"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M23.211564788594842,958.1518885083497L20.504896530881524,958.1498076366261"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M93.7521833339706,1046.309544133488L100.05301672685891,1028.5984061094932L104.64512279629707,1014.1770554040559L105.2967427270487,1009.82598619489L105.35354252625257,1004.5395686873235L104.55282312072814,999.1751149161719L103.00818410981447,995.6168442242779L99.80530648678541,990.4864805396646L96.37522966228426,986.5318009383045L93.32776260469109,983.9317617374472L89.47957614064217,981.3514897772111L34.74192423094064,959.9778533056378L29.221299204044044,958.1570906904526L23.211564788594842,958.1518885083497"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M69.11290333420038,958.6388125014491L90.12488498073071,967.3836702569388"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M174.31402218528092,1000.8262767498381L181.04637628234923,983.5343166827224"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M107.47249062918127,1031.2920668050647L102.04574305098504,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M125.40150534268469,829.6360527910292L121.83731787931174,847.1083950339817L119.47775951214135,871.3030371773057L119.35705993697047,899.195336563047L120.99399862345308,917.9545303038321L127.18044352903962,955.5705665168352"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M127.18044352903962,955.5705665168352L147.51240534707904,1017.8476826837286"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M85.00816964637488,919.1656046290882L82.34331235289574,931.6602585655637L82.46401192806661,939.4833217109554L82.85372166708112,946.4001548625529L83.99445098917931,953.5157045121305L86.6309083821252,960.5313650434837L90.12488498073071,967.3836702569388"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M163.1244615437463,912.5754433344118L162.49414153862745,915.594807561487L162.79865157976747,917.521706441883L163.51417128369212,918.7130124447867L164.7756001809612,920.1727521885186L166.43383879214525,921.1081091379747L208.46884649340063,936.4546039369889"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M198.15494943782687,1046.309544133488L200.30860853008926,1036.6138383331709L202.3352569565177,1025.1119399024174L203.54698602762073,1011.9380550421774"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M162.0823429878801,1025.4313506367616L142.14087979588658,963.9044563090429"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M118.13349757436663,829.6360527910292L110.89546747785062,849.2132302909158L97.64375853445381,884.9016916365363L85.00816964637488,919.1656046290882"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M64.68330780416727,854.6204586126842L4.7161298440769315,832.7511749751866"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M174.31402218528092,1000.8262767498381L203.54698602762073,1011.9380550421774"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M200.25654204562306,1046.309544133488L200.9886283595115,1044.7426673891023L204.41870518401265,1040.0794902825728L208.4365021623671,1037.2942756903358L208.46884649340063,1037.2724267835729"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M147.51240534707904,1017.8476826837286L157.1778380163014,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M31.621879651211202,934.6161476713605L-8.205035817809403,914.3337913737632"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M35.19553374685347,936.4358760314062L31.621879651211202,934.6161476713605"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M80.38293035887182,1046.309544133488L85.348179561086,1032.7590658152476L84.85197019390762,1025.5447570513934L81.86840291228145,1019.0878715086728L76.89368707686663,1012.6257778163999L32.16226663812995,995.9643479324877L25.692611617036164,992.4924313449301L22.709044333547354,986.5182753261179L22.21283496823162,981.557495395653L22.21283496823162,977.3260555132292L29.221299204044044,958.1570906904526L32.41786573827267,943.8635673327371"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M90.12488498073071,967.3836702569388L96.03521974757314,978.4466018057428L100.17371630202979,983.6976645216346L102.97268423438072,987.8645937638357L105.04193251207471,991.3583617205732L107.52219045441598,996.1058464455418L108.91851887572557,1000.9396835668012L109.59853870701045,1005.8713176231831L109.50623903144151,1013.5184647599235L108.91851887572557,1019.6549040768296L107.47249062918127,1031.2920668050647"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M193.72929833829403,829.6360527910292L163.1244615437463,912.5754433344118"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M4.7161298440769315,832.7511749751866L-4.744981321506202,858.1996106961742L-5.212790787220001,860.169184002094L-5.262490612454712,861.6580686853267L-4.9358917605131865,863.3508812785149L-4.348171606659889,865.0801092027687L-3.405452700331807,866.2214826345444L-1.8821136141195893,867.6885165763088L0.15873476304113865,868.8787906942889L2.8732918817549944,870.1335724573582L52.54392828140408,888.657703969162"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M126.42232397478074,982.1380566526204L107.47249062918127,1031.2920668050647"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M168.67033092677593,1046.309544133488L162.0823429878801,1025.4313506367616"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M32.41786573827267,943.8635673327371L35.19553374685347,936.4358760314062L52.54392828140408,888.657703969162L64.68330780416727,854.6204586126842"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-224.87891812808812,916.366815706715L-78.12716764956713,969.8286909763701L-59.12132338993251,976.7527768849395L-57.26428547780961,971.600550132338L28.85288938973099,1002.9799655084498L26.91854063887149,1008.3163247681223L37.548781025223434,1012.185676864814L30.21371793653816,1032.4750298615545L35.32333329692483,1034.3384303604253L26.33713157195598,1059.1847629267722L21.901224952191114,1057.568989305757L14.339751549996436,1078.5032685841434L-224.87891812808812,991.3479574085213Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M102.04574305098504,1046.309544133488L107.47249062918127,1031.2920668050647L126.42232397478074,982.1380566526204L134.31039622798562,1002.1299348063767L148.67601236514747,1046.309544133488Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M5.155539409257472,825.1048688883893L42.50929690990597,724.1684681735933L74.7960388995707,736.1172272399999L37.44228139985353,837.0524135250598Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M194.0014640474692,971.7992730042897L197.92696135211736,961.3314599446021L195.1208934430033,960.2618922279216L202.10095778107643,941.6807279363275L224.96287736669183,950.3330081808381L219.44935231469572,965.0031556393951L212.3059885520488,984.016036732588L207.4235723922029,982.1599057321437L207.9331928221509,980.8063031593338L205.40402394067496,976.1149913482368Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M194.56078430265188,848.1863038265146L199.38718954846263,835.0120827518404L212.43378810212016,839.8377085714601L212.3201885027811,840.1498446678743L228.074244200252,845.9753420790657L235.50791805237532,848.7242177077569L232.23404067754745,857.6606570994481L224.55896767508239,854.8191848360002L223.12713937927037,858.7448069546372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M185.58957141451538,872.9323800425045L189.64286826737225,862.0544802760705L207.99709259718657,868.5957884769887L203.3268868010491,879.594369913917L198.32377106696367,877.7236446863972Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M181.9464953392744,880.7638330380432L184.95846252236515,872.6982790790498L185.58957141451538,872.9323800425045L198.32377106696367,877.7236446863972L195.3189038587734,885.7881523496471L192.88124576583505,884.8663164419122L182.35040502995253,880.9188597179018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M159.21947527956218,858.4971796497703L160.07699448615313,856.1447198260576L159.21947527956218,855.832584453281L159.99889476038516,853.6996590117924L160.83511404134333,854.0107540339231L161.70683319680393,851.5948251206428L176.00776067283005,856.874076097738L173.48490288015455,863.7628995217383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M156.7463173121214,865.0593002056703L157.5754366191104,862.7775932238437L156.78181718755513,862.4873076044023L157.5683366432786,860.3471010578796L158.41875587403774,860.6581957777962L159.21947527956218,858.4971796497703L173.48490288015455,863.7628995217383L171.07564468868077,870.3458240740001L159.19107537996024,865.9665724500082Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M200.3646194441244,925.9128662142903L203.88699594326317,916.2679737005383L213.1209079073742,919.6618953337893L209.60642026923597,929.3067831294611Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M199.38718954846263,835.0120827518404L201.39253805018961,829.5403309096582L208.57850166317075,832.1914103049785L207.45197229273617,835.2597108935006L208.30239152349532,835.5718471957371L209.8399305595085,834.296250087209L218.54923325870186,837.5060514952056L217.06849402282387,841.5461332923733L212.43378810212016,839.8377085714601Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M179.68633662257344,888.0552855068818L182.35040502995253,880.9188597179018L192.88124576583505,884.8663164419122L190.22427733428776,892.0100212865509Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.39692396577448,903.9647337286733L207.52218315657228,898.168417504523L209.8967303596437,899.0403102920391L219.27264182455838,902.4977074638009L220.448871021159,902.9232491557486L218.3370228940621,908.7133187442087L217.25230448693037,908.3231524825096L214.38233680464327,907.2671023551375L206.0840437700972,904.2133998493664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M156.89541678782552,872.2384007205255L159.19107537996024,865.9665724500082L171.07564468868077,870.3458240740001L168.77998609561473,876.6176483854651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.39253805018961,829.5403309096582L203.35528670158237,824.1830249149352L220.9939913256094,830.6962765636854L219.66235156543553,834.3243423574604L211.05165963061154,831.1426317621954L210.69034979026765,829.3072689380497L209.76183083374053,828.9670400591567L208.57850166317075,832.1914103049785Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.39253805018961,915.3534249416552L203.63928570225835,909.1877608895302L204.19150598347187,909.3937686532736L215.36765555944294,913.5035182116553L213.1209079073742,919.6618953337893L203.88699594326317,916.2679737005383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M154.7906686346978,877.9920802600682L156.89541678782552,872.2384007205255L168.77998609561473,876.6176483854651L166.67523794434965,882.3723647380248Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M206.77116357628256,998.7641451498494L211.22915900684893,985.9085823469795L211.60466879606247,986.0427980418317L216.5793846314773,987.7792783817276L212.1150781121105,1000.6275547095574Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M173.81860170606524,824.3390933154151L175.01613082643598,821.0720607028343L176.91497970372438,821.767085606698L177.27628954406828,820.7744901427068L187.7929303292185,824.6585132996552L185.652682303451,830.5183587474748L175.17864136584103,826.6561884400435L175.76715040858835,825.0549270082265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.55455283168703,920.682568562217L189.2105586770922,908.7913519949652L194.7240837290883,910.9669186454266L190.06807788461447,922.8581314827316Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M168.15597718022764,839.816899497062L169.2051957109943,836.9535703849979L171.27444398775697,837.7193445670418L171.79116439260542,836.3012056313455L182.13109469041228,840.1207119650207L179.9979466367513,845.9753420790657L169.3961061509326,842.0632386226207L169.97041524294764,840.4963157149032Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M177.68019923381507,893.441674624104L179.68633662257344,888.0552855068818L190.22427733428776,892.0100212865509L191.93221577070653,892.655097682029L189.9189784070477,898.0404427782632Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M165.97312930226326,845.8754586139694L167.05784770846367,842.9060057778843L168.85019696038216,843.565653082449L169.3961061509326,842.0632386226207L179.9979466367513,845.9753420790657L177.9002984603867,851.7082343786024L167.298457974568,847.7961341580376L167.75916746445,846.5278224661015Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M179.18302728235722,918.5569461672567L183.83903312683105,906.6792517211288L189.2105586770922,908.7913519949652L184.55455283168703,920.682568562217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M173.9314124211669,916.4875069987029L174.05921197216958,916.1753743425943L178.58741826564074,904.5962832369842L183.83903312683105,906.6792517211288L179.18302728235722,918.5569461672567Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M175.7884503332898,898.501359869726L177.68019923381507,893.441674624104L189.9189784070477,898.0404427782632L188.03432948235422,903.1001246701926Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M161.62242238316685,851.5667329179123L162.23144246358424,849.8864028719254L164.654900604859,850.7863939395174L166.5190384928137,849.9217782453634L167.298457974568,847.7961341580376L177.9002984603867,851.7082343786024L176.00776067283005,856.874076097738L161.70683319680393,851.5948251206428Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.19150598347187,909.3937686532736L206.0840437700972,904.2133998493664L214.38233680464327,907.2671023551375L217.25230448693037,908.3231524825096L215.36765555944294,913.5035182116553Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M170.89893419854343,832.3048198777251L171.52925420273095,830.5901501486078L183.95263272710145,835.1681509101763L182.13109469041228,840.1207119650207L171.79116439260542,836.3012056313455L172.9752824511379,833.0633113882504Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M171.52925420273095,830.5901501486078L172.11776324454695,828.9951323540881L174.06631194613874,829.7182487505488L175.17864136584103,826.6561884400435L185.652682303451,830.5183587474748L183.95263272710145,835.1681509101763Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M170.47372458316386,914.758291897364L174.7392318006605,903.0865988954902L178.58741826564074,904.5962832369842L174.05921197216958,916.1753743425943Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M46.22968382388353,934.2395085822791L47.28521344345063,929.8665399588645L56.33531494438648,930.4408629038371L55.264796488918364,934.8200738010928Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M196.7373210908845,870.7640845994465m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M190.1359220892191,879.2437390293926m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M167.61322353314608,857.6856279228814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M165.11482121050358,864.4110998944379m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M204.17809491883963,835.4157790453173m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M186.28458008076996,886.4613213823177m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M163.98513629473746,871.2915922389366m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M208.3797023622319,914.4284716397524m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M161.7849329225719,877.3053845823742m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M189.63892383687198,915.8247453067452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M175.69615065772086,841.2797772134654m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M184.80620750319213,893.0483861616813m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M184.1979763088748,913.6741508017294m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M178.94715033378452,911.4278348800726m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M182.85371437016875,898.2714215503074m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M172.98238242603838,854.290635493584m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M177.87110967375338,835.73415806517m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M181.26489773672074,832.8791509056464m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M37.44228139985353,837.0524135250598L74.7960388995707,736.1172272399999L96.47384042758495,744.1392404478975L84.05835076514632,777.7015366838314L89.62867561541498,779.7637340421788L90.71970511041582,776.8296286333352L96.60873995255679,779.0052366992459L95.63052116986364,781.6563354176469L101.1156463213265,783.6831558886915L113.71573533583432,749.6318690399639L135.28782612551004,757.6247335644439L133.1333781471476,763.4503003247082L132.03524867538363,763.0393165801652L98.42317801434547,853.8619694598019L99.94651710055768,854.4290155428462L97.99796839989722,859.6874553486705L75.0366491638124,851.1911297668703L77.75830625742674,843.8413731520995L78.96293535362929,844.2950106780045L88.50845733378083,818.4854853856377L71.77697174064815,812.2989260251634L61.94113967008889,838.8742484012619L65.09431746881455,840.0364352203906L62.73475910164416,846.4144131266512Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M208.46884649340063,985.335304427892L208.7276011388749,985.540269496385L208.46884649340063,986.3570084152743Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.33653788547963,1043.1372946337797m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M232.90696053393185,1022.9645005790517L213.08540803194046,1008.5358551545069L208.46884649340063,1006.8087438689545"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M208.46884649340063,1013.7868950781412L232.90696053393185,1022.9645005790517L257.3916188562289,1032.1212854320183"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M252.548647002317,1046.309544133488L257.3916188562289,1032.1212854320183L281.2948681116104,963.1386960684322L330.63259457051754,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,936.4546039369889L214.3184370296076,938.5906252311543L281.2948681116104,963.1386960684322L341.4892452703789,985.2000482855365L405.62410857062787,1008.401639895048L425.1435176897794,1015.5525004332885"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M208.46884649340063,1037.2724267835729L213.17770770844072,1034.154275224544L219.26554185058922,1031.2067519593984L225.54428643081337,1029.4702824945562L232.13464102894068,1028.492282724008L243.64370054658502,1029.16543789953L257.3916188562289,1032.1212854320183"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M257.3916188562289,1032.1212854320183L296.4233371205628,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M254.15324135683477,829.6360527910292L214.3184370296076,938.5906252311543"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M398.4081672858447,829.6360527910292L341.4892452703789,985.2000482855365"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M196.96373140625656,1080.6288419347256L210.4142396505922,1043.7646697731689L213.33390715811402,1044.8342246050015L224.21895775943995,1038.917337001767L236.1666379570961,1043.3037623395212L241.9641620097682,1045.436629443895L240.9788432540372,1048.1583750005811L242.57318208832294,1048.7389306798577L242.74358149059117,1048.278023576364L244.91222941782326,1049.071865814738L229.08717396948487,1092.4354900871404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M194.0014640474692,971.7992730042897L197.92696135211736,961.3314599446021L195.1208934430033,960.2618922279216L202.10095778107643,941.6807279363275L224.96287736669183,950.3330081808381L219.44935231469572,965.0031556393951L212.3059885520488,984.016036732588L207.4235723922029,982.1599057321437L207.9331928221509,980.8063031593338L205.40402394067496,976.1149913482368Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M229.68278298620135,982.4075286169536L233.72897986508906,970.7567581892945L238.78889540024102,956.1937878364697L269.65169795323163,967.5324523933232L270.3743176339194,969.0639718230814L267.2558508263901,978.028347780928L257.24251938052475,974.5345731074922L248.22160666622221,971.3737355396152L244.2669205768034,982.7404669383541L242.70808161515743,982.1952804285102L241.21945351734757,986.4610515832901L240.9717432782054,986.3622105740942L235.41561837680638,984.4207647829317Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M194.56078430265188,848.1863038265146L199.38718954846263,835.0120827518404L212.43378810212016,839.8377085714601L212.3201885027811,840.1498446678743L228.074244200252,845.9753420790657L235.50791805237532,848.7242177077569L232.23404067754745,857.6606570994481L224.55896767508239,854.8191848360002L223.12713937927037,858.7448069546372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M245.86835938785225,874.4774462026544L251.4599841637537,858.9008745802566L252.36010322067887,859.2202929696068L262.5793339414522,862.9190944531001L277.81509146280587,868.4324379251339L272.23135554697365,884.0089881327003L258.41874857712537,879.0127596226521L247.15108820889145,874.9456480001099Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.21273345686495,845.3229781710543L336.97523892764,832.3183457907289L337.9384688716382,832.6731408685446L340.48972656484693,825.720818746835L351.445776916109,829.7671501450241L348.9939188733697,836.4499905817211L358.16393106337637,839.8377085714601L353.40931445453316,852.8131941999309L348.08669984247535,850.8436187994666L348.62550905905664,849.3620149604976L338.62637756206095,845.6632062443532L337.9739687470719,847.4559061862528L333.61616185400635,845.8400832200423Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M274.94512377958745,1003.1786874788813L278.80751019343734,992.534048574511L283.7538261283189,994.3412765646353L304.7658077767119,1002.0092450054362L301.78934046812356,1010.2088637491688L300.91052133589983,1012.6538693644106Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M212.8447977686301,869.743404021021L217.21680461149663,857.5472479378805L234.78529837168753,863.8971175821498L233.90647924039513,866.3494579489343L230.19319230224937,876.6883988594636L222.3406199226156,873.8542175362818L221.80259959306568,872.9750384404324Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M328.76135670766234,859.0642253537662L333.61616185400635,845.8400832200423L337.9739687470719,847.4559061862528L347.48477973788977,850.970553944353L342.62997459154576,864.194686294999Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.97967553138733,1029.9093419206329L300.6983109731227,1014.1843383982778L311.3001514589414,1018.0744957588613L305.5807271320373,1033.8005308834836Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.492798906751,838.1084743491374L294.0156567003578,831.0854067397304L317.4510964890942,839.5682310634293L314.9353386722505,846.5912900799885L297.9419428901747,840.4401312223636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M339.12258692923933,1014.4111515898257L339.61090743355453,1013.0856468598358L345.9606517646462,995.787474790588L355.60557339619845,999.3519879747182L350.29794762004167,1013.8014610637911L346.1310511659831,1012.2501833895221L344.5864121541381,1016.4451870052144Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M403.46966059319675,836.7475604698993L408.90508591849357,821.7951779272407L420.03074678592384,825.8623207318597L416.8065692363307,834.7634141440503L416.3529597213492,835.9901098180562L409.87541583925486,833.6085096253082L408.75598644278944,836.7059423052706L410.8465346451849,837.4633928784169L411.12264478579164,837.86084630806L411.1936445347965,838.3498596572317L411.02403402142227,838.809740263503L410.66982415597886,839.1291595827788L410.2020146911964,839.2571353977546L409.79100502468646,839.108350506518L408.45147640258074,842.7925963760354L403.47676056902856,840.9718029825017L404.82970025297254,837.2511402550153Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M217.08269397262484,1002.3775569815189L221.54700049292296,989.5157582894899L222.1852093571797,987.6731543713249L232.97086030896753,991.4499196410179L227.86834492348135,1006.1407886650413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M293.03743791766465,830.738935219124L295.32678542099893,824.3609428908676L308.27398432511836,829.0377910202369L319.7475439682603,833.1829636772163L318.35831552091986,837.0388876236975L317.4510964890942,839.5682310634293L294.0156567003578,831.0854067397304Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M268.4683687835932,1020.2011280660518L274.21540412306786,1004.404312921688L283.4422161132097,1007.7846658397466L281.3445679359138,1013.5392733109184L277.7022807477042,1023.5814732806757Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M325.4519794592634,868.0994941135868L328.76135670766234,859.0642253537662L342.62997459154576,864.194686294999L346.09555129054934,865.4775610491633L344.7631226442754,869.1201749332249L338.58377771265805,866.8311861404218L337.80435823183507,868.9641075371765L344.0618028882891,871.2811877494678L342.86427376791835,874.5409135594964Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M285.96507390681654,1026.6070317123085L291.6837093466893,1010.8893036954105L300.6983109731227,1014.1843383982778L294.97967553138733,1029.9093419206329Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M417.71378826815635,1005.4176906705834L420.1301464345306,998.6861129114404L434.0342641957104,1003.7176297651604L440.2491090018302,1005.9784817853943L440.6388187427074,1007.1187915885821L438.54117056541145,1012.9587146844715Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M287.75111206807196,859.6375137157738L290.22427003551275,852.7424434791319L310.14522218797356,859.9423657641746L307.6712753335014,866.8384692855179Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.0325344847515,1051.5449491171166L359.7732587363571,1035.7773372735828L368.41156168468297,1038.9381454773247L362.67872629500926,1054.7203160319477Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M394.29885951709,1066.4697852246463L402.1017320705578,1044.912256324198L408.3236768525094,1047.1803778661415L400.5144932102412,1068.7378997136839Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M345.62774182576686,1048.4694612962194L351.37477716524154,1032.6945594819263L359.7732587363571,1035.7773372735828L354.0325344847515,1051.5449491171166Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M290.22427003551275,852.7424434791319L292.6193282781169,846.0949941445142L295.53899578657,847.1437704213895L312.5260804798454,853.2949233306572L310.14522218797356,859.9423657641746Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M285.38366483990103,866.2568579241633L287.75111206807196,859.6375137157738L307.6712753335014,866.8384692855179L305.29751701746136,873.4567661737092L293.03743791766465,869.0202918020077Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M316.3955668695271,892.7965983017348L318.82612498663366,886.1772794332355L337.35074871685356,893.0234154672362L338.53407788742334,893.4624835355207L336.11061974521726,900.081795447506Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M366.21451385784894,834.7706973259337L368.6947718001902,828.1731726159342L382.71958913560957,833.5023832540028L388.5873240502551,835.7414412470534L386.0928661590442,842.3389587518759L379.0489020459354,839.6535482681356L379.48121163714677,838.4986445633695L374.0812861863524,836.4499905817211L373.63477664627135,837.6059350809082L370.7995199523866,836.5207414655015Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M374.3715962767601,1012.0649872394279L376.80215439386666,1005.5737549914047L383.8887183563784,1008.2528586355038L384.1585174072534,1007.5443268595263L395.1918785981834,1011.7185247656889L392.5491101164371,1018.7622179221362L381.5717598395422,1014.6098732352257L381.7697702553123,1014.0917403483763L380.10443166736513,1013.4685242343694L379.84962145239115,1014.1343978773803L378.5810925811529,1013.6526799197309Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M318.82612498663366,886.1772794332355L321.2566831037402,879.5517115569673L335.7351099550724,884.9016916365363L339.77420685905963,886.3968136878684L337.35074871685356,893.0234154672362Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M209.8967303596437,899.0403102920391L214.6450358806178,886.0357786794193L224.01305848453194,889.4869396570139L219.27264182455838,902.4977074638009Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.6947428723797,1010.5209921710193L334.5793917980045,1005.3823160906322L339.04448720254004,993.2290562847629L345.9606517646462,995.787474790588L339.61090743355453,1013.0856468598358Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M312.14347071480006,1036.2028707857244L314.68762843310833,1029.1872868286446L316.24646739382297,1024.920501539018L318.62022571172565,1018.3866238272749L325.36677975859493,1020.8670010599308L323.56733053177595,1025.8069443474524L318.89002476166934,1038.6686757090501Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M227.86834492348135,1006.1407886650413L232.97086030896753,991.4499196410179L235.41561837680638,984.4207647829317L240.9717432782054,986.3622105740942L239.54701495636255,990.451105886139L233.41736984997988,1008.0895113740116Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M277.7022807477042,1023.5814732806757L281.3445679359138,1013.5392733109184L283.3215165389702,1014.2696534534916L285.39076481573284,1008.5785127161071L291.6837093466893,1010.8893036954105L285.96507390681654,1026.6070317123085Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M250.85727517306805,992.9314931137487L255.07387145236135,980.7844540756196L265.73251174017787,984.5123227955773L262.9903436070308,987.7792783817276L261.3321049949154,996.6021316424012L256.0875901086256,994.7595296078362Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M394.4692589174956,959.149666483514L397.0134166358039,952.2182799344882L399.8052845932543,953.2462314241566L413.97210142947733,958.4827471235767L411.43504368606955,965.3995613213629Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M259.40406733285636,841.5877514304593L261.8985252259299,834.685380062554L279.0197205590084,840.8719194456935L276.52526266593486,847.7680419399403L259.7937770728022,841.7302935454063Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M261.55851530935615,834.5657277991995L263.91807367745787,827.9962951927446L276.29885235149413,832.4744140091352L281.7910774759948,834.45856098691L279.45913012418896,841.0352706457488L279.0197205590084,840.8719194456935L261.8985252259299,834.685380062554Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.9868406606838,928.2226443053223L269.5025984784588,921.2350429967046L271.9260566206649,922.1069328864105L286.01477373205125,927.2019721902907L283.5061158891767,934.1968505606055Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M295.53899578657,847.1437704213895L297.9419428901747,840.4401312223636L314.9353386722505,846.5912900799885L312.5260804798454,853.2949233306572Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M392.03160082548857,965.7970074140467L394.4692589174956,959.149666483514L411.43504368606955,965.3995613213629L408.9973855940625,972.0614623338915L394.3698592679575,966.6605682191439Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M263.39425329770893,934.1760417711921L265.7041118396446,927.7690122746862L266.9868406606838,928.2226443053223L283.5061158891767,934.1968505606055L280.7702588448301,940.6028336812742L267.27005077525973,935.4224881995469Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M257.37031893152744,848.4339314969257L259.7937770728022,841.7302935454063L276.52526266593486,847.7680419399403L274.1089044986293,854.4789572115988Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M350.7515571359545,980.0051700738259L354.82615391444415,968.4469942669384L356.07338286191225,968.8933405969292L357.094201493077,965.994690018706L356.3076820373535,964.3362368447706L357.03030171711,962.303226575721L359.04275019373745,961.3814008454792L362.2393167298287,962.5154753741808L360.8358883326873,966.4909773701802L362.5864266194403,967.114197707735L361.0764985959977,971.3810185762122L357.22200104407966,982.3159705772996Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M226.73471557814628,968.3054951913655L232.25534060411155,952.4242864190601L239.24960489105433,954.8693124135025L238.78889540024102,956.1937878364697L233.72897986508906,970.7567581892945Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.93038454838097,877.9431792055257L422.5607045534998,876.2139544892125L425.8558818511665,877.4323192420416L427.15991059783846,873.8604602273554L430.7177869733423,875.172465747688L431.29209606256336,873.6128334645182L443.4101756606251,878.0846801251173L440.9015178177506,884.944349961821L429.9170675659552,880.8980507687666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M299.75559206679463,999.9543967656791L303.4191791797057,989.9548202469014L306.601545763202,981.2526486939751L307.1332550048828,979.8210134939291L312.44798075407743,981.7624605763704L311.92337148915976,983.2086614253931L306.3885465124622,998.2959517138079L305.0782066769898,1001.8958382066339Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.69033519458026,915.4241750198416L411.2291444102302,913.9571511810645L412.6325728073716,912.6815684968606L414.42571094445884,913.3474518181756L428.5846389196813,918.5704719135538L426.0759810768068,925.4373847739771L411.90285315178335,920.200844113715L412.80928329657763,917.7349970522337L411.3427440105006,917.1960480809212Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M337.45724834222347,923.5812380886637L339.99430608469993,916.8766323593445L341.0782356048003,917.2886474258266L355.7191729955375,922.8581314827316L353.18921522796154,929.5689740651287Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.4190922630951,910.6547857401893L414.290811419487,908.2804943020456L416.742669461295,907.0121936798096L416.9769686376676,906.3744017276913L431.13589661289006,911.5974270757288L428.5846389196813,918.5704719135538L414.42571094445884,913.3474518181756L414.61662138439715,912.802259852644Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M306.3885465124622,998.2959517138079L311.92337148915976,983.2086614253931L318.8545248862356,985.7525175805204L313.83720920048654,999.4445862225257L313.3267998844385,1000.8398023345508Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M418.0608981586993,899.1672445554286L420.5127562005073,892.4771814565174L425.0764623694122,894.1647842954844L436.0467126723379,898.211075745523L433.5948546305299,904.9073759717867L421.3773753819987,900.3939288286492Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M391.7760017244145,973.7334392960183L394.3698592679575,966.6605682191439L408.9973855940625,972.0614623338915L406.40352805238217,979.1332874679938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M398.118646081537,948.3988353610039L399.18916453793645,945.4575182590634L402.2508315462619,946.5915953950025L416.4097595214844,951.8145904405974L413.97210142947733,958.4827471235767L399.8052845932543,953.2462314241566L401.1661131409928,949.5256289532408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M380.96195087302476,901.0879053324461L383.15899870172143,894.8868534504436L384.62553798686713,895.4112379178405L395.8300874643028,899.3940615109168L403.25666134245694,902.0451141903177L402.16563184559345,905.126909635961L398.68585519772023,903.8867004239L397.5167259769514,904.0427670306526L395.98549802880734,903.5048574414104L395.0648679342121,906.1122099142522L390.34496231377125,904.4329335358925L390.0049523981288,903.1074077785015L387.97041511069983,902.3780563711189L386.8580856891349,903.1927241994999Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M331.44041395001113,927.2165383589454L333.3960626265034,922.0434659649618L337.45724834222347,923.5812380886637L353.18921522796154,929.5689740651287L351.24066652636975,934.7357982071117L334.55809187330306,928.4005596139468Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M356.69739177729934,1016.1611503819004L361.9979175776243,1001.7189652146772L369.098681489937,1004.3554127593525L364.9530849605799,1015.6513410299085L363.7981556886807,1018.7975924341008Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M305.5807271320373,1033.8005308834836L311.3001514589414,1018.0744957588613L312.0582710141316,1015.9842777522281L318.62022571172565,1018.3866238272749L316.24646739382297,1024.920501539018L312.8660903945565,1023.6875967411324L311.3143514096737,1027.9533423660323L314.68762843310833,1029.1872868286446L312.14347071480006,1036.2028707857244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.4341751821339,885.3272344120778L423.16341354418546,880.6150490418077L429.20075897406787,882.8540918147191L429.9170675659552,880.8980507687666L440.9015178177506,884.944349961821L438.455970864743,891.6125709651969L427.50070939864963,887.5662756641395Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M299.43688207585365,939.4479467915371L301.9810397932306,932.722547616344L307.09065515361726,934.6785740391351L306.7364452891052,935.6004033228382L308.85539339017123,936.4150672480464L309.2025032816455,935.4797123633325L315.0915381228551,937.726020488888L318.71962536033243,939.115006393753L317.33039691485465,942.7929564863443L313.702309676446,941.4039713176899L312.54738040454686,944.4586978778243Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M362.67872629500926,1054.7203160319477L368.41156168468297,1038.9381454773247L369.2690808903426,1036.5992723945528L374.144397075288,1038.378397454042L373.1314673051238,1041.1563286483288L373.9463866604492,1041.4538897522725L373.2442780183628,1043.3817940726876L372.07514879852533,1046.5842157173902L368.36186185944825,1056.8032394112088Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M220.3423713957891,966.0654395800084L225.8558964477852,950.1915087364614L232.25534060411155,952.4242864190601L226.73471557814628,968.3054951913655Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M321.2566831037402,879.5517115569673L323.7937408462167,872.6202454250306L334.9201905988157,876.7310572313145L336.00412011984736,877.1274679624476L335.8266207445413,877.6310448134318L338.0946683222428,878.4748480911367L335.7351099550724,884.9016916365363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M249.49723551236093,1013.7161460034549L256.0875901086256,994.7595296078362L261.3321049949154,996.6021316424012L254.74806148651987,1015.5587429995649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M393.61883968673646,868.0994941135868L396.11329757981,861.239807611797L406.5092387907207,865.0520170573145L411.2930441861972,866.8093366986141L409.5993056995794,871.4445382319391L406.76483789179474,870.4092914704233L405.9570185104385,872.6140027330257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M244.2669205768034,1011.8881145045161L250.3973545692861,994.2497186819091L250.85727517306805,992.9314931137487L256.0875901086256,994.7595296078362L249.49723551236093,1013.7161460034549Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M338.9521875279024,1046.0244683111086L342.8287738934159,1035.3382782186382L344.4870125046,1035.9542093956843L346.34326153062284,1030.851967040915L351.37477716524154,1032.6945594819263L345.62774182576686,1048.4694612962194Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M233.41736984997988,1008.0895113740116L239.54701495636255,990.451105886139L245.0818399321288,992.3852669741027L238.95219482667744,1010.0247079716064Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M409.22379590943456,1025.2471952638589L411.7253537774086,1018.3231577896513L425.67917136102915,1023.4108433993533L423.1776134939864,1030.334875792265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M407.0977478316054,933.3468114272691L409.5780057730153,926.5714651811868L423.7369337491691,931.7944753104821L421.2637757817283,938.5698164519854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.6174898883328,940.1075849109329L407.0977478316054,933.3468114272691L421.2637757817283,938.5698164519854L418.78351783845574,945.336827470921Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M376.1860343394801,914.6230343803763L378.50299285631627,908.0609607403167L388.2473141364753,911.5339600574225L393.2433298975229,913.3120767688379L390.9184825187549,919.8679027887993L388.53762422688305,919.0241045486182Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M398.57225559744984,854.4789572115988L401.0454135648906,847.6754416702315L410.67692413181067,851.2119388063438L417.03297955170274,853.5435912725516L415.3534410139546,858.1715185199864L409.5638058241457,856.0521196653135L408.7701863935217,858.213136558421Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.5180902387947,1038.2223338722251L406.82163769192994,1031.8518153997138L420.78176636528224,1036.9394910815172L419.3436269797385,1040.92223336827L422.44789383746684,1042.0490119201131L421.57617468200624,1044.444066004362L418.65650717448443,1043.3817940726876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M320.07335393410176,1001.7335312273353L325.09066961798817,988.0414671092294L332.07073395513,990.6498282155953L327.613527411595,1002.8030925430357L327.0534182693809,1004.3200381738134Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M239.7884141067043,895.4403703878634L242.23317217454314,888.6088029900566L251.87809380423278,892.088054726366L256.27218945976347,893.682017557323L253.82664250582457,900.5208630687557L252.74981295969337,900.1244536759332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M396.11329757981,861.239807611797L398.57225559744984,854.4789572115988L408.7701863935217,858.213136558421L414.6947211101651,860.3887190832756L413.1216821987182,864.7398820822127L407.3880579210818,862.6360919917934L406.5092387907207,865.0520170573145Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M393.7040393874049,995.313038571272L398.89175447262824,980.6502382783219L401.4493232546374,981.557495395653L401.860332920216,980.402615328785L405.5247089192271,981.7062772284262L399.933084144257,997.5301952711307Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M402.1017320705578,1044.912256324198L404.5180902387947,1038.2223338722251L418.65650717448443,1043.3817940726876L416.2393601210788,1050.0717115467414L408.3236768525094,1047.1803778661415Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M376.6175550427288,1020.5340645695105L378.2765825409442,1016.1122503024526L377.7306733503938,1015.9135286998935L378.5810925811529,1013.6526799197309L379.84962145239115,1014.1343978773803L380.10443166736513,1013.4685242343694L381.7697702553123,1014.0917403483763L381.5717598395422,1014.6098732352257L392.5491101164371,1018.7622179221362L389.9907524473965,1025.5863740816712L378.80040292069316,1021.363284486346Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M278.80751019343734,992.534048574511L285.6605638656765,973.6065063993447L290.6139797763899,975.4199819229543L286.31218379642814,987.2694669435732L283.7538261283189,994.3412765646353Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M264.6627821698785,942.2186345611699L267.27005077525973,935.4224881995469L280.7702588448301,940.6028336812742L278.15589026361704,947.4135410897434L268.2198696574196,943.5795277361758Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M350.29794762004167,1013.8014610637911L355.60557339619845,999.3519879747182L361.9979175776243,1001.7189652146772L356.69739177729934,1016.1611503819004Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M420.1301464345306,998.6861129114404L422.53230465296656,992.0034288684838L435.6428029825911,996.7581961615942L436.42932243738323,997.0411931499839L434.0342641957104,1003.7176297651604Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M238.95219482667744,1010.0247079716064L245.0818399321288,992.3852669741027L250.3973545692861,994.2497186819091L244.2669205768034,1011.8881145045161Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M340.48972656484693,825.720818746835L342.7932740179822,819.4354224526323L356.1514825867489,824.3671856285073L359.0782500691712,825.4513406916521L358.22783083841205,827.7830018205568L355.56376243103296,826.7914476762526L354.11063420865685,830.7524611344561L351.445776916109,829.7671501450241Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M406.82163769192994,1031.8518153997138L409.22379590943456,1025.2471952638589L423.1776134939864,1030.334875792265L420.78176636528224,1036.9394910815172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M402.2508315462619,946.5915953950025L404.6174898883328,940.1075849109329L418.78351783845574,945.336827470921L416.4097595214844,951.8145904405974Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M370.991219278425,1030.0019397586584L372.3094479748979,1026.4936253158376L376.3130450034514,1028.0105657661334L387.4962945552543,1032.233651312068L385.08624747768044,1038.6686757090501L377.5957738244906,1035.8345606070943L372.0893487492576,1033.7578734755516L373.188267105259,1030.8238755646162Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M325.3880796832964,1041.0502054551616L330.0653854524717,1028.1874380870722L337.1093495655805,1030.7676926143467L332.43283268250525,1043.6366977342404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M304.3831980107352,926.3945902665146L307.03385535348207,919.3924209298566L312.0582710141316,921.3130761054344L311.7040611496195,922.2910909964703L313.8159092757851,923.0776645755395L314.163019166328,922.1142159742303L320.1514536580071,924.4031865121797L317.49369634035975,931.3980677085929Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M409.5780057730153,926.5714651811868L411.90285315178335,920.200844113715L426.0759810768068,925.4373847739771L423.7369337491691,931.7944753104821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.53230465296656,992.0034288684838L425.00546262133867,985.1147328754887L438.12306092400104,989.8695048922673L435.6428029825911,996.7581961615942Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M381.4155603889376,990.9328254535794L386.5961754992604,976.2710563321598L392.76132048107684,978.4674104657024L387.5736053949222,993.1302153742872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M211.25045893155038,884.7955660517327L213.5958173479885,878.3749650954269L227.64193460904062,883.5480700745247L225.30288728047162,889.9551404430531L224.01305848453194,889.4869396570139L214.6450358806178,886.0357786794193Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M330.6964943455532,938.6260001524352L332.70894282124937,933.304153400939L349.3836286133155,939.6393875158392L347.3711801376194,944.9757955321111Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M387.5736053949222,993.1302153742872L392.76132048107684,978.4674104657024L398.89175447262824,980.6502382783219L393.7040393874049,995.313038571272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M326.8270079558715,948.9013665956445L328.825256482698,943.5795277361758L345.50704224873334,949.9293185779825L343.5016937479377,955.2376268934458Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.7644506804645,905.9280513720587L416.6361698368564,903.532949433662L419.8043364705518,904.7024085186422L421.3773753819987,900.3939288286492L433.5948546305299,904.9073759717867L431.13589661289006,911.5974270757288L416.9769686376676,906.3744017276913Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M200.3646194441244,925.9128662142903L203.88699594326317,916.2679737005383L213.1209079073742,919.6618953337893L209.60642026923597,929.3067831294611Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.84255040530115,840.6815164489672L417.0400795266032,837.3718329244293L418.4009080734104,837.0950721451081L418.96101721469313,835.5499976533465L416.8065692363307,834.7634141440503L420.03074678592384,825.8623207318597L420.6618556762114,824.1476494097151L426.62189026828855,826.3305258136243L422.75240387860686,836.9681367431767L420.74705537687987,842.4815008533187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M386.3973761992529,887.9491599700414L388.82083434052765,881.2882185764611L402.0591322220862,886.1491873716004L399.6427740538493,892.7965983017348Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M307.03385535348207,919.3924209298566L309.57801307179034,912.6815684968606L322.68851140048355,917.6850558337756L320.1514536580071,924.4031865121797L314.163019166328,922.1142159742303L314.3263185918331,921.6678666304797L312.21447046566755,920.8885759836994L312.0582710141316,921.3130761054344Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M425.00546262133867,985.1147328754887L427.4084097230807,978.4466018057428L440.5189080527052,983.1940953745507L438.12306092400104,989.8695048922673Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M363.57095648907125,984.5757891447283L367.43334290385246,973.6418811418116L368.72317169979215,969.9993221759796L374.7258061422035,972.1322118355893L373.3223777450621,976.1077083176933L369.5735909305513,986.7159573375247Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.75240387860686,836.9681367431767L426.62189026828855,826.3305258136243L433.3329444397241,828.7964053880423L427.2593102483079,845.5071383235045L424.75065240543336,844.5925802318379L426.95480020716786,838.5059277396649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M401.0454135648906,847.6754416702315L403.47676056902856,840.9718029825017L408.45147640258074,842.7925963760354L418.01829830836505,846.3010037820786L416.36005969624966,850.8644278398715L411.4563436117023,849.0644456115551L410.67692413181067,851.2119388063438Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.4053664393723,952.6927191028371L296.9353242088109,946.0391229782254L302.1861501839012,948.0440462050028L301.9242399930954,948.7598671214655L304.0431880960241,949.5537207568996L304.29089833423495,948.8451829813421L310.04582253750414,951.0488288612105L307.52296474482864,957.7107436661609Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M319.25133460201323,968.9921818580478L321.18568335380405,963.8409897699021L337.86825800780207,970.1834790171124L335.9260203950107,975.3284237910993Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.9535083975643,959.1777582471259L294.4053664393723,952.6927191028371L307.52296474482864,957.7107436661609L305.0782066769898,964.1812120298855Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M296.9353242088109,946.0391229782254L299.43688207585365,939.4479467915371L312.54738040454686,944.4586978778243L310.04582253750414,951.0488288612105L304.29089833423495,948.8451829813421L304.52519751153886,948.2427697503008L302.4062494095415,947.4634820912033L302.1861501839012,948.0440462050028Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M313.83720920048654,999.4445862225257L318.8545248862356,985.7525175805204L325.09066961798817,988.0414671092294L320.07335393410176,1001.7335312273353Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M327.613527411595,1002.8030925430357L332.07073395513,990.6498282155953L339.04448720254004,993.2290562847629L334.5793917980045,1005.3823160906322Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M378.50299285631627,908.0609607403167L380.96195087302476,901.0879053324461L386.8580856891349,903.1927241994999L390.34496231377125,904.4329335358925L395.0648679342121,906.1122099142522L393.6472395872697,910.1231193221174L389.29574378207326,908.5718184476718L388.2473141364753,911.5339600574225Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M237.43516682833433,902.009739083238L239.7884141067043,895.4403703878634L252.74981295969337,900.1244536759332L250.3973545692861,906.6865348275751Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M323.0640211906284,958.8656275128014L324.94867011811584,953.8694529519416L341.63124477211386,960.2046682708897L339.7458069585264,965.2008382668719Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M324.94867011811584,953.8694529519416L326.8270079558715,948.9013665956445L343.5016937479377,955.2376268934458L341.63124477211386,960.2046682708897Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M321.18568335380405,963.8409897699021L323.0640211906284,958.8656275128014L339.7458069585264,965.2008382668719L337.86825800780207,970.1834790171124Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M318.89002476166934,1038.6686757090501L323.56733053177595,1025.8069443474524L330.0653854524717,1028.1874380870722L325.3880796832964,1041.0502054551616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.43283268250525,1043.6366977342404L337.1093495655805,1030.7676926143467L343.62239332310855,1033.162750595715L342.8287738934159,1035.3382782186382L338.9521875279024,1046.0244683111086Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M235.111108337529,908.4792189896107L237.43516682833433,902.009739083238L250.3973545692861,906.6865348275751L248.07250719051808,913.1705765682273L245.80445961188525,912.3486268110573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.7830872349441,921.4192011328414L376.1860343394801,914.6230343803763L388.53762422688305,919.0241045486182L386.1425659842789,925.8202669858001L374.34319637715816,921.6252085338347Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M328.825256482698,943.5795277361758L330.6964943455532,938.6260001524352L347.3711801376194,944.9757955321111L345.50704224873334,949.9293185779825Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M341.0782356048003,917.2886474258266L343.20428368262947,911.6608940907754L347.385380086489,913.2558928667568L357.8452210733667,917.224140017759L355.7191729955375,922.8581314827316Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M369.1767812166363,840.8084517824464L370.7995199523866,836.5207414655015L373.63477664627135,837.6059350809082L376.6672548679635,838.7462725802325L376.3272449532524,839.6535482681356L385.0365476515144,842.9705138774589L382.83318873587996,848.7887257500552L371.3383291680366,844.4157032277435L372.2526481747627,841.9852046212181Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M375.7253248486668,988.9060655739158L379.4741116622463,978.304062501993L380.91225104779005,974.2442921670154L386.5961754992604,976.2710563321598L381.4155603889376,990.9328254535794Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.70894282124937,933.304153400939L334.55809187330306,928.4005596139468L351.24066652636975,934.7357982071117L349.3836286133155,939.6393875158392Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M351.8709865314886,889.5649731247686L354.00413458421826,883.9236714718863L359.1279498953372,885.86618585838L368.3476619096473,889.3735310174525L366.2216138327494,895.0221113520674L355.29396338108927,890.8759352243505Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M301.9810397932306,932.722547616344L304.3831980107352,926.3945902665146L317.49369634035975,931.3980677085929L315.0915381228551,937.726020488888L309.2025032816455,935.4797123633325L309.51411329675466,934.6431990987621L307.40936514455825,933.8431011177599L307.09065515361726,934.6785740391351Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M309.57801307179034,912.6815684968606L311.887871613726,906.5658433651552L325.01256989408284,911.5766182150692L322.68851140048355,917.6850558337756Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M359.04275019373745,961.3814008454792L361.28239787276834,955.0389035460539L371.2744293930009,958.5961546329781L374.16569699998945,959.6386712770909L371.93393818475306,965.9738813238218L362.2393167298287,962.5154753741808Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M244.57143061514944,882.0883226208389L247.15108820889145,874.9456480001099L258.41874857712537,879.0127596226521L255.8398798694834,886.1564705003984L254.22345222253352,885.5748607562855Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M392.0600007250905,872.3871848988347L393.61883968673646,868.0994941135868L405.9570185104385,872.6140027330257L415.9206501301378,876.2628555539995L414.9992311494425,878.814034090843L405.8434189101681,875.4627508390695L405.21309890504926,877.1992588774301Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M199.38718954846263,835.0120827518404L201.39253805018961,829.5403309096582L208.57850166317075,832.1914103049785L207.45197229273617,835.2597108935006L208.30239152349532,835.5718471957371L209.8399305595085,834.296250087209L218.54923325870186,837.5060514952056L217.06849402282387,841.5461332923733L212.43378810212016,839.8377085714601Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M371.9552381085232,928.3932765321806L374.34319637715816,921.6252085338347L386.1425659842789,925.8202669858001L383.7475077416748,932.5810478087515L382.62018948514014,932.191923331935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M366.08040321804583,941.482004200574L368.4541615359485,934.7493239208125L380.2322312183678,938.9381317985244L377.8513729246333,945.6708080098033L375.83103558793664,944.954986771103Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.4541615359485,934.7493239208125L370.8421198017895,927.9958282937296L371.9552381085232,928.3932765321806L382.62018948514014,932.191923331935L380.2322312183678,938.9381317985244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.35528670158237,824.1830249149352L205.36852406524122,818.6977385873906L212.362788352184,821.2780710868537L211.15105928108096,824.5867218398489L212.27758865244687,825.0049851224758L213.92872728966177,823.7439524587244L222.3903197478503,826.8757245824672L220.9939913256094,830.6962765636854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M366.66812337283045,847.9303525267169L368.0360518954694,844.3303860798478L370.43111013714224,845.2376610371284L370.82081987708807,844.2169767008163L371.3383291680366,844.4157032277435L382.83318873587996,848.7887257500552L380.749740508385,854.3228894895874L368.73027167469263,849.7521845414303L369.07738156523556,848.8521933429874Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M348.98681889940053,901.3781893365085L351.1625668015331,895.609962974675L364.13816560525447,900.5354292909615L361.9624177021906,906.3109346614219L351.5025767162442,902.3353981543332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M277.3827818715945,909.237702166196L277.3969818223268,909.1877608895302L279.410219184123,903.5891334149055L292.7542278030887,908.4157519428991L290.7275793766603,914.0632763197646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M376.3130450034514,1028.0105657661334L378.80040292069316,1021.363284486346L389.9907524473965,1025.5863740816712L387.4962945552543,1032.233651312068Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.39692396577448,903.9647337286733L207.52218315657228,898.168417504523L209.8967303596437,899.0403102920391L219.27264182455838,902.4977074638009L220.448871021159,902.9232491557486L218.3370228940621,908.7133187442087L217.25230448693037,908.3231524825096L214.38233680464327,907.2671023551375L206.0840437700972,904.2133998493664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.28239787276834,955.0389035460539L363.62065631430596,948.4487763522193L373.36497759539634,951.9279980589636L377.1137644080445,953.2597570987418L376.1923454273492,955.8608482414857L372.69205773994327,954.6133650499396L371.2744293930009,958.5961546329781Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M283.1590059986338,893.144107166212L285.17145447526127,887.5309004834853L286.2482840223238,887.9210679177195L298.51546309515834,892.3637728653848L296.51011459250003,897.9561667372473Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.39253805018961,829.5403309096582L203.35528670158237,824.1830249149352L220.9939913256094,830.6962765636854L219.66235156543553,834.3243423574604L211.05165963061154,831.1426317621954L210.69034979026765,829.3072689380497L209.76183083374053,828.9670400591567L208.57850166317075,832.1914103049785Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M323.7937408462167,872.6202454250306L325.4519794592634,868.0994941135868L342.86427376791835,874.5409135594964L341.5034452211112,878.2407473153435L336.53582936059684,876.411639649421L336.6983399009332,875.965287361294L335.3809000905603,875.476276665926L334.9201905988157,876.7310572313145Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M254.45775139704347,853.3729572053999L256.37080022413284,848.0656113415025L257.37031893152744,848.4339314969257L274.1089044986293,854.4789572115988L273.2087854417041,857.0082942913286L270.31041785888374,855.9532767990604L269.60909810476005,854.4154896731488L267.94375951681286,855.6411414141767L265.5061014248058,854.7619600086473L264.6769821187481,857.0655191028491Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M225.32418720517308,934.9272390617989L226.75601550284773,930.9725277619436L237.70496587920934,934.9272390617989L245.28773920889944,937.6625537117943L243.85591091122478,941.623503823299Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M364.84658533520997,850.7863939395174L365.6693935515359,848.5972825190984L368.73027167469263,849.7521845414303L380.749740508385,854.3228894895874L381.4723601890728,854.6058922922239L379.53801143728197,859.7093048128299L366.73202314786613,854.8545601866208L367.83725259359926,851.9277697214857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M425.0764623694122,894.1647842954844L427.50070939864963,887.5662756641395L438.455970864743,891.6125709651969L436.0467126723379,898.211075745523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.82083434052765,881.2882185764611L390.4585619131103,876.8090908424929L408.6068869670853,883.4565107291564L407.6507569970563,886.0784369944595L402.7391520505771,884.2857470405288L402.0591322220862,886.1491873716004Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.39253805018961,915.3534249416552L203.63928570225835,909.1877608895302L204.19150598347187,909.3937686532736L215.36765555944294,913.5035182116553L213.1209079073742,919.6618953337893L203.88699594326317,916.2679737005383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M379.0631019966677,827.6841585491784L379.8922213027254,824.9488005046733L382.6485893856734,815.8780999584123L388.2402141606435,817.2379774781875L385.1998470770195,827.237803127151L384.5979269724339,829.2573270862922L384.18612842075527,830.6182424332947L383.71200786624104,830.8804371040314L382.82608876004815,831.3694509463385L380.5793411079794,830.6817101920024L380.0831317426637,829.3707367070019L380.465741507709,828.1159475683235Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M364.66987484600395,860.3325347490609L366.73202314786613,854.8545601866208L379.53801143728197,859.7093048128299L377.46797427441925,865.2080845381133Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M390.4585619131103,876.8090908424929L392.0600007250905,872.3871848988347L405.21309890504926,877.1992588774301L404.5180902387947,879.1188852963969L409.51410599797964,880.9479922498576L408.6068869670853,883.4565107291564Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M279.410219184123,903.5891334149055L281.31616803631186,898.2818259983324L294.6601766543463,903.1074077785015L292.7542278030887,908.4157519428991Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M360.62998905498534,871.0408440371975L362.66452634427696,865.6398712182418L375.46972574759275,870.5091745811515L373.428877370432,875.9018200198188Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M357.22200104407966,982.3159705772996L361.0764985959977,971.3810185762122L367.43334290385246,973.6418811418116L363.57095648907125,984.5757891447283Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M362.66452634427696,865.6398712182418L364.66987484600395,860.3325347490609L377.46797427441925,865.2080845381133L375.46972574759275,870.5091745811515Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M281.31616803631186,898.2818259983324L283.1590059986338,893.144107166212L296.51011459250003,897.9561667372473L294.6601766543463,903.1074077785015Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M364.9530849605799,1015.6513410299085L369.098681489937,1004.3554127593525L369.6232907567173,1002.9310653358698L374.9246054412797,1004.8933145236224L370.2543996479362,1017.6219100304879Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M206.77116357628256,998.7641451498494L211.22915900684893,985.9085823469795L211.60466879606247,986.0427980418317L216.5793846314773,987.7792783817276L212.1150781121105,1000.6275547095574Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M363.62065631430596,948.4487763522193L366.08040321804583,941.482004200574L375.83103558793664,944.954986771103L373.36497759539634,951.9279980589636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.542498732917,989.1828202940524L295.83719473704696,977.3260555132292L301.5132303275168,979.3954765219241L298.36715250462294,988.1049334243871L297.22563429828733,991.2522377632558Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M351.1625668015331,895.609962974675L352.2819961970672,892.633248320315L354.3370445240289,893.4135825908743L355.29396338108927,890.8759352243505L366.2216138327494,895.0221113520674L364.13816560525447,900.5354292909615Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M255.07387145236135,980.7844540756196L257.24251938052475,974.5345731074922L267.2558508263901,978.028347780928L267.9082596413791,978.2624451871961L265.73251174017787,984.5123227955773Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M232.29794045351446,914.0216586170718L234.38138868194073,908.2170272544026L235.111108337529,908.4792189896107L245.80445961188525,912.3486268110573L243.72101138532162,918.1522142728791Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.62553798686713,895.4112379178405L386.5961754992604,889.8344486881979L398.1257460564375,893.9442098420113L398.643255347386,895.0429202597588L398.08314620610327,896.6233566263691L396.97791676037014,897.1758329775184L396.6450068205595,897.0624244636856L395.8300874643028,899.3940615109168Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M273.4288846682757,917.9045890904963L275.09422325436026,913.2631759634241L289.1892514536157,918.3509386777878L287.5239128675312,922.9996314859018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M369.5735909305513,986.7159573375247L373.3223777450621,976.1077083176933L379.4741116622463,978.304062501993L375.7253248486668,988.9060655739158Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M226.28110606223345,930.7956529613584L228.3148544644937,925.1117267850786L239.7458142573014,929.2578824367374L237.70496587920934,934.9272390617989L226.75601550284773,930.9725277619436Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M228.3148544644937,925.1117267850786L230.33440291602165,919.4923033355735L241.75826273392886,923.6238961732015L239.7458142573014,929.2578824367374Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.5979269724339,829.2573270862922L385.1998470770195,827.237803127151L388.2402141606435,817.2379774781875L394.7311691083014,818.8184315795079L391.0604820186272,828.7402208000422L387.64460514485836,827.6841585491784L386.95038536470383,829.9731602682732Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M212.1150781121105,1000.6275547095574L216.5793846314773,987.7792783817276L221.54700049292296,989.5157582894899L217.08269397262484,1002.3775569815189Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M242.23317217454314,888.6088029900566L244.57143061514944,882.0883226208389L254.22345222253352,885.5748607562855L251.87809380423278,892.088054726366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M230.33440291602165,919.4923033355735L232.29794045351446,914.0216586170718L243.72101138532162,918.1522142728791L241.75826273392886,923.6238961732015Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,954.9691943079233L405.62410857062787,1008.401639895048L391.68843536637723,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.2513997564092,873.9884354006499L293.03743791766465,869.0202918020077L305.29751701746136,873.4567661737092L303.5114788552746,878.4176234570332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M275.09422325436026,913.2631759634241L276.6601621909067,908.9120434196666L277.3969818223268,909.1877608895302L277.3827818715945,909.237702166196L290.7275793766603,914.0632763197646L289.1892514536157,918.3509386777878Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M355.35786315612495,882.0675136749633L355.99607202224433,880.3663820712827L357.1297013685107,879.6651203576475L361.01338770706207,881.145677272696L370.1408000458032,884.6186900734901L368.3476619096473,889.3735310174525L359.1279498953372,885.86618585838L358.91573952976614,884.3284053686075L356.16568253654987,883.2858773982152Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M349.37652863841504,907.9766848213039L351.5025767162442,902.3353981543332L361.9624177021906,906.3109346614219L359.82926965039223,911.9522180967033Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M252.36010322067887,859.2202929696068L254.45775139704347,853.3729572053999L264.6769821187481,857.0655191028491L262.5793339414522,862.9190944531001Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M271.9260566206649,922.1069328864105L273.4288846682757,917.9045890904963L287.5239128675312,922.9996314859018L286.01477373205125,927.2019721902907Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M287.96332243364304,883.151659714058L289.69966076966375,878.3114977725782L301.95973986852914,882.7479661987163L301.2087202882394,884.8382243770175L300.22340153250843,887.5881250421517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.2482840223238,887.9210679177195L287.96332243364304,883.151659714058L300.22340153250843,887.5881250421517L298.51546309515834,892.3637728653848Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.19150598347187,909.3937686532736L206.0840437700972,904.2133998493664L214.38233680464327,907.2671023551375L217.25230448693037,908.3231524825096L215.36765555944294,913.5035182116553Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M357.05160164181143,877.396944008302L357.6543106334284,875.8102605701424L358.8518397556618,875.243216236122L362.45862706843764,876.6176483854651L371.82033858355135,880.1749397106469L370.1408000458032,884.6186900734901L361.01338770706207,881.145677272696L360.60237804148346,879.6859293114394L357.9162208242342,878.6590073630214Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M347.385380086489,913.2558928667568L349.37652863841504,907.9766848213039L359.82926965039223,911.9522180967033L357.8452210733667,917.224140017759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.1293214550242,949.2488726484589L268.2198696574196,943.5795277361758L278.15589026361704,947.4135410897434L276.1213529743254,952.9341004202142Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M358.70274027902633,872.8834789549L359.2344495197758,871.465347210411L360.62998905498534,871.0408440371975L373.428877370432,875.9018200198188L371.82033858355135,880.1749397106469L362.45862706843764,876.6176483854651L362.2748166024685,875.2785914829001L359.3685601595789,874.1653116508387Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M289.69966076966375,878.3114977725782L291.2513997564092,873.9884354006499L303.5114788552746,878.4176234570332L301.95973986852914,882.7479661987163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M308.27398432511836,829.0377910202369L309.9180229874328,824.4733121385798L321.3773826798424,828.6122447913513L319.7475439682603,833.1829636772163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M263.91807367745787,827.9962951927446L265.3286020476371,824.0560892764479L277.709380723536,828.5414938265458L276.29885235149413,832.4744140091352Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M229.74668276216835,841.4108743467368L231.4475212227553,836.7829359099269L241.87186233513057,840.6315746782348L240.17102387174964,845.2730364343151Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M228.074244200252,845.9753420790657L229.74668276216835,841.4108743467368L240.17102387174964,845.2730364343151L238.4985853107646,849.8302184552886L235.50791805237532,848.7242177077569Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M231.4475212227553,836.7829359099269L233.02766010910273,832.4608880961314L243.44490124564618,836.3230551686138L241.87186233513057,840.6315746782348Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M298.36715250462294,988.1049334243871L301.5132303275168,979.3954765219241L306.601545763202,981.2526486939751L303.4191791797057,989.9548202469014Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M233.02766010910273,832.4608880961314L234.57229912094772,828.2366403974593L245.00374020729214,832.0988098233938L243.44490124564618,836.3230551686138Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M234.57229912094772,828.2366403974593L236.11062704306096,824.0415228940547L246.54206812940538,827.8964114692062L245.00374020729214,832.0988098233938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M250.0068559423089,943.8417181340046L252.28910346981138,937.5345797142945L258.8439581915736,939.9088611323386L256.5837994739413,946.2232804559171Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M243.85591091122478,941.623503823299L245.28773920889944,937.6625537117943L246.13815843872726,935.3090803106315L252.28910346981138,937.5345797142945L250.0068559423089,943.8417181340046Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.2442780183628,1043.3817940726876L373.9463866604492,1041.4538897522725L374.59800659120083,1039.6539570093155L375.98013506270945,1040.1637645959854L383.42800886556506,1042.8927951860242L382.06796920578927,1046.613347550854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M375.98013506270945,1040.1637645959854L377.5957738244906,1035.8345606070943L385.08624747768044,1038.6686757090501L383.49190864060074,1042.9136036499403L383.42800886556506,1042.8927951860242Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.07514879852533,1046.5842157173902L373.2442780183628,1043.3817940726876L382.06796920578927,1046.613347550854L380.91225104779005,1049.8230506568216L376.5970440050587,1048.2364066815935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M307.16875487938523,964.9532147636637L308.86249336600304,959.9997024531476L313.6100100008771,961.6363075217232L311.92337148915976,966.5835760561749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.71958913560957,833.5023832540028L383.71200786624104,830.8804371040314L389.57264280691743,833.1049295752309L388.5873240502551,835.7414412470534Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M208.68894571904093,963.167828251142m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M251.65010571852326,971.065767087508m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M213.0144082820043,847.0803028130904m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M289.8558602211997,1002.593966266606m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M304.473131028004,838.8388729714788m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M347.7608898775652,1005.8005684679374m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M225.02598825469613,996.9142606779933m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M306.8792336760089,832.1341852876358m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M336.0064867781475,866.1538534043357m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M298.9477726845071,859.7904599653557m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M301.37596414331347,853.0192036367953m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M327.7728824056685,893.242949502077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.40091895405203,835.2565895314328m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M329.3001659233123,886.2875667847693m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M216.95647219382226,894.2636266197078m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.2712051104754,1000.5848970995285m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M319.12905725557357,1027.4965955829248m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M233.5333361076191,998.7953580440953m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M257.12891978025436,990.3553862255067m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M404.22068017348647,958.8156865942292m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M269.2122883880511,841.2298354464583m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M271.6751908361912,834.511624166742m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M276.50080719590187,927.7128284871578m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M305.2367727868259,846.8680504839867m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M401.7333222562447,965.5982843725942m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M273.45176236424595,934.18644616846m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M266.94818523991853,848.100986726582m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M232.76259437482804,962.2491239430383m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M304.90544061828405,994.1259074504487m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M420.2445349218324,919.3861782802269m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.58860511146486,923.2202050141059m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M422.59778220020235,912.1998434890993m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M312.62311347201467,992.0242374860682m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.3866936592385,972.8969306494109m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.1075220583007,952.5304109677672m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M389.73278668895364,900.2409834726714m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.7808255413547,927.8085490129888m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M362.9919140813872,1010.0028589810245m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M310.06238914467394,1026.4374423334375m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M308.36549511458725,938.4210336962715m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M329.67567571345717,879.0127596226521m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M402.4551530499011,867.4544154359028m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M250.1764664556831,1003.324347561691m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M344.5659011155367,1040.9898608936928m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M239.24960489105433,1000.2373936208896m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M415.41812967602164,932.5706434114836m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M412.9410272780806,939.3387007266283m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M384.7138932319358,913.9675556072034m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M406.5960162617266,852.3772449097596m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M412.6499283006415,1037.581432716921m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M326.07125505711883,996.1911617224105m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M248.02990734018385,894.561194029171m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M404.2751133162528,859.3014481305145m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M410.3787251804024,1044.146505028475m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M384.58372702263296,1019.6486615152098m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M272.71652050781995,941.4112543878146m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M356.14911592844874,1007.760735984426m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M244.67477469705045,1002.1372178131714m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M415.00002003554255,1031.0933456369676m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M410.51678024977446,945.9642114611343m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M379.79282165132463,1032.9962826487608m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M331.2495035100728,1035.908430729527m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M312.2665369492024,925.3988884622231m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M417.82581009622663,926.0044249990024m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M387.0868626628071,984.7006409754977m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M219.4461967702955,884.1723383143544m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.03848370723426,939.1326938513666m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M393.23228549119085,986.8897094177082m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M336.16820843238384,949.4153426061384m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M424.7538079507649,906.1517467764206m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M421.7110742088407,830.5474914889783m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.22864865418524,887.0491737276316m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M314.86197226308286,918.539258657489m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M368.44627267401665,980.3422702387907m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M407.7075567971915,844.5468003018759m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M302.22638337500393,951.8707740311511m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M328.560190747492,969.5883506801911m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M304.7413523066789,945.2483902564272m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M319.463544966653,993.7430290086195m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M333.32742953579873,998.0160760669969m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M386.78314150869846,907.0871056178585m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M245.0920954514295,901.0670964429155m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M332.3476329809055,959.5356681416743m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M334.22597081866115,954.5530197354965m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M330.4645618274808,964.5203938353807m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M324.4777051080018,1033.4280588785186m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M337.6323810601607,1039.4874892174266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M242.75462589599192,907.5833971868269m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M381.16075017489493,920.2216529455036m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M338.09861275274307,944.2776616686024m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M349.4617283400148,917.2563937203959m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.9050171803683,842.4773390395567m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M380.8018069928512,983.6050660647452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M341.9744102312252,934.0199758424424m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M360.10932422149926,889.4692520727403m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M309.73736806679517,932.0608279122971m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M317.2948970394209,912.129093377851m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M366.6050124838948,960.5095158973709m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M251.49548403918743,880.5505412924103m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M403.2093281755224,874.0383769315667m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M379.04811315983534,927.1062516588718m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M373.1551338881254,940.2095478973351m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M375.53678106702864,933.4706237446517m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M375.7718691295013,849.3016687310301m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M356.5624922513962,900.9568093270063m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M285.07599925622344,908.801756428089m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M383.15110983978957,1026.7984700277448m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M212.92289749346673,903.4445116827264m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M369.27381420787424,953.9370813267305m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M290.8372345464304,892.7539400276728m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M333.33058508019894,873.5805795593187m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M259.7787882378325,850.9039650163613m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.49246955197304,853.1253297091462m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M398.7103106668219,882.3723647380248m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.10354869719595,860.0203995639458m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M399.5047189835459,878.1585519290529m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M287.03480347711593,903.348790822085m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M368.0502518443391,870.774489089381m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M362.32609420083463,977.9784069997258m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M370.06664475239813,865.4244981058873m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M288.9131413148716,898.1184761459008m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M211.67330188769847,993.271713942755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M369.72584595065564,946.7018817849457m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M296.72469161543995,983.7507265568711m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M361.35970871150494,898.0726965698414m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M261.4906711047515,979.5234497445635m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M239.05159447528422,913.1851427648216m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M391.66713544074446,894.4935650732368m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M281.3090680623427,918.1282841083594m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M374.5230624098331,982.5105314124376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M233.01267127413303,930.0267677414231m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M235.03774192836136,924.3678115182556m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M216.83182818815112,995.0716587258503m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M248.2271288689226,887.0918320384808m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M237.028101593256,918.8222588370554m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M291.076267038472,982.298283226788m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M298.274852829054,873.7231210162863m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M282.91208464466035,913.6637463732623m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M364.347220425494,884.4730274984613m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M355.6694731703028,907.1432895706967m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M258.5189371118322,858.1423858935013m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M279.7249847436324,922.5532822003588m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M294.9615311510861,882.949812960811m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M293.2362372195348,887.7545964806341m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M210.72269412130117,908.8589808102697m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M365.9242037665099,879.9304345147684m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M353.6081137545407,912.6035352894105m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.4625316904858,875.5896855327301m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M296.6055698134005,878.3645606162027m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M235.8092725481838,841.0217447527684m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M234.12263403553516,845.6236690371297m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M237.44621123373508,836.5529955429956m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M302.4764602733776,984.678791906219m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M239.01530571561307,832.2798489625566m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M254.42935149744153,941.8752899123356m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M248.04884060751647,939.6435492704622m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.31218379642814,987.2694669435732L290.6139797763899,975.4199819229543L295.83719473704696,977.3260555132292L291.542498732917,989.1828202940524Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M470.9288899768144,829.6360527910292L425.1435176897794,954.9691943079233"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M599.1071057869121,1016.5939680864103m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M471.05668952688575,829.6360527910292L587.0994702447206,854.6423080922104L641.8174000009894,864.9989541121759"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1015.5525004332885L472.3662404771894,1032.8506231899373L509.0865224264562,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M558.9204582506791,1046.309544133488L577.4474486391991,996.0215715966187L600.9538881797343,931.6176005313173L627.37999522686,859.6167047019117L638.1340907346457,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M641.8174000009894,861.5238505830057L587.7794900750741,851.2972558671609L487.27461025863886,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,862.3999097822234L627.37999522686,859.6167047019117L541.9428401915357,842.6583779072389L477.974431861192,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M472.3662404771894,1032.8506231899373L520.0946392621845,902.3780563711189L541.9428401915357,842.6583779072389"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M600.9538881797343,931.6176005313173L641.8174000009894,946.7029222222045"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,1019.0961949210614L577.4474486391991,996.0215715966187"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M626.7354752728716,897.1976823257282L631.4411809435114,883.8810131438076L635.6364772981033,870.9690530551597L655.3657301226631,875.1433331924491L655.0817311219871,876.496956396848L658.9086176604033,877.2981014437973L660.8508552741259,875.7738448819146L671.2041966356337,877.9712713020854L670.9493864206597,879.1761099225841L671.90551639162,879.3748354446143L671.104796984233,883.20784385968L666.9663004307076,905.1560420617461L671.3177962359041,906.5939353443682L669.8078682133928,912.4828439294361L666.1868809498847,911.0657607298344L654.2668117666617,918.2874717214145L657.8317881152034,907.8341440693475Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M614.6173956748098,927.5494793276303L621.5406602108851,907.1474513444118L622.5827787676826,907.501202150248L626.1540662068874,896.991674197372L626.7354752728716,897.1976823257282L657.8317881152034,907.8341440693475L654.2668117666617,918.2874717214145L647.2938474044204,938.7321249134839Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M531.7243983549997,898.9758027140051L537.8256435617805,880.8408261560835L570.4602843262255,891.9111789329909L571.8132240129635,887.9210679177195L577.9507579803467,889.9977987334132L576.5686295088381,894.1075597936288L577.0506389243528,894.2771524121054L575.3853003364056,899.231752128806L571.9410235639662,898.0622921199538L571.0409045079723,900.7268710886128L576.3067193180323,902.5122736836784L572.8056427454576,912.9229512074962Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.4998262990266,853.6642836583778L647.2583475289866,825.8560779984109L662.8491038009524,830.6536179049872L661.6444747056812,834.7634141440503L659.3764271270484,833.8634210019372L658.1788980066776,836.9254781268537L657.5982778267935,838.3925182684325L670.7292871950194,843.076640102081L670.9706863453612,843.1609168103896L665.790071234107,857.4619309548289L665.2228621179238,859.0569421970285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.8708923170343,838.42061052192L563.4794311048463,830.3914232281968L564.7053601257503,830.6390515342355L564.9680592017248,829.3280780427158L567.2708177678287,829.7962828911841L569.0639559049159,820.8098656642251L567.0373074794188,820.4061685176566L567.2637177929282,819.3074462725781L565.676478930749,818.9890664969571L567.235317892395,811.2074856981635L578.5108671216294,813.4756837063469L576.3777190688998,824.1403662166558L577.8016585055739,824.4316938999109L577.9578579552472,823.6732014440931L580.0200062571093,824.0841815914027L579.8638068065047,824.848916739691L581.1536356033757,825.1048688883893L583.3932832814753,813.8929072013125L595.3062524888664,816.2953233118169L593.6196139780805,824.7001315369271L591.4083661995828,824.2537759235129L591.1456671236083,825.5512244505808L589.5229283859953,825.2318045068532L587.5459797848016,835.1182090970688L591.38706627395,835.89750938816L590.6289467187598,839.6743573406711L589.743027612567,844.0546660302207L578.1700683198869,841.7084440253675L580.2748164730147,831.2060995171778L574.754191446118,830.079286692664L572.6494432929903,840.596199257765Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.7709606830031,823.5733176581562L609.1038706246763,820.8598075779155L613.1642674524337,808.9184777857736L623.6099084885791,812.4976534633897L623.8087077904493,811.9233207469806L635.5512775965035,815.9623769973405L622.7381893321872,850.1839721859433L610.5775098847225,848.2143960427493L610.840208960697,846.896142702084L612.5765472985804,838.2291670045815L616.856254465878,839.7034900449216L617.2459642067552,837.9170308243483L616.4807446766645,837.3437406667508L618.6067927535623,830.5402083056979L617.8415732234716,829.1720097516663L618.684892478399,826.8975741495378L619.7759219743311,826.4293691059574L619.7901219241321,825.0757361254655L613.2778670527041,822.2977183423936L612.859757412225,824.3963183970191Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M578.3972675204277,896.8428905494511L581.8699441952631,887.5735587915406L590.3662476437166,889.3953803903423L591.975575315766,889.7418489777483L591.6134765893221,891.4221693626605L595.7661730935797,892.3221550341696L596.4540817858651,889.0197792891413L594.1718342574313,888.5307695143856L599.3524493677542,864.1093693925068L613.8308762190863,867.1995052970015L599.7208591820672,904.8865670938976L588.1975997155532,900.5354292909615Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M518.2454902110621,940.7099988493137L522.6387969795614,928.7761585810222L529.9170602681115,931.4688176233321L529.5060506025329,932.5810478087515L542.2055392675102,937.3004809319973L548.3777842232957,920.5483516016975L556.7044771565124,923.6238961732015L551.4962510326877,937.7686784877442L553.3950999090448,938.4626512504183L551.5459508569911,943.4879691824317L550.0218228846788,942.9136473177932L547.7687641428784,949.0439065070823L550.7239315258339,950.1353251328692L549.8806122709066,952.4378120973706L533.2903372915462,946.286747155711L530.498469335027,945.2452689409256Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.7993605835363,998.9129266128875L611.5770285921171,990.8267014916055L616.8491544909775,992.6620215573348L619.9676213013008,983.6196321141906L615.0639052139595,981.9185254294425L616.5375444767997,977.6527514797635L637.9179359395057,985.086641213391L636.3519970029593,989.6426908979192L630.9165716767311,987.7511867335998L627.7981048692018,996.8008537981659L632.7452096892521,998.5154824173078L630.066152445972,1006.3114189724438Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M580.1336058573797,887.2125238403678L582.4150644987822,876.4615811612457L585.6613308591768,861.1752996831201L599.3524493677542,864.1093693925068L594.1718342574313,888.5307695143856L590.7070464445278,887.7930930010043L590.3662476437166,889.3953803903423L581.8699441952631,887.5735587915406Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M629.9525528457016,973.7760970736854L634.2827487252653,961.4948083050549L631.9231903590262,960.6655812291428L634.6937583908439,952.8134097615257L635.2964673824608,951.1060528969392L651.6666431343183,956.8815161380917L651.0639341427013,958.5607798141427L648.9662859663367,964.5141512239352L646.3795283986256,963.6068918770179L644.7922895364463,968.1067722192965L641.3764126617461,977.8015333958901Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M527.1322922855616,829.3072689380497L528.5846316209063,821.873212155886L531.9792085699737,822.5391041999683L533.7652467321604,813.3685165676288L530.6751798251644,812.7671320224181L532.68052832596,802.4270553197712L546.5002352716401,805.1270466484129L544.8419966604561,813.6525614997372L541.03641004581,812.9013510700315L538.839362218976,824.2184004187584L542.6307488819584,824.9696096251719L541.7377298017964,829.5829895748757L541.2486204104498,832.0780007280409Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M484.73203031532466,895.9429054618813L486.58196825068444,890.8197511406615L495.08616056106985,893.9234009324573L511.8176461532712,899.9964789845981L508.1327591156587,910.2011525565758L491.23087412212044,904.0646163565107L493.0666121095419,898.969560045749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M596.4256818844005,845.4644797593355L597.3187009654939,841.0279874731787L600.2454684488475,826.4085599929094L602.2863168269396,816.1891966764815L609.4438805384561,817.6354320645332L607.1971328863874,828.8962890994735L604.7310748929158,828.3927087071352L603.5193458218127,828.9670400591567L602.9734366321936,831.6951133362018L603.816755887121,832.9499018252827L606.2765027908608,833.4389155213721L603.866455713287,845.5071383235045L603.5832455977798,846.9169517541304Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.6728819031268,932.9358377582394L564.2517506098375,925.7776089156978L588.9920080322772,934.7566069983877L586.4123504394665,941.9148265700787L575.4279001876712,937.9247443317436Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.8295626463369,881.8615051000379L562.7852113237604,872.6566611304879L561.4953825268894,872.3726186165586L561.7572927176952,871.1542529743165L564.9183593755588,856.215470509138L571.6436134986579,857.6606570994481L568.2916363999248,873.4432403403334L566.2649879734963,883.0309678413905Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.2801578072831,958.3693396127783L466.6121051600203,951.9560898528434L477.1003460464999,955.8181903539225L489.50873573403805,960.382582759019L487.1420773928985,966.8738573174924L479.8212142540142,964.1812120298855L480.10442436952144,963.4227348612621L474.16647858917713,961.239901626017L473.9179794639349,961.9130633305758Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M539.4838821738958,992.2302427859977L541.1634207107127,987.5597473406233L555.4004484107718,992.732770846691L566.6617976874113,996.808136807289L564.1673397952691,1003.7176297651604L553.0124901439995,999.6703594671562L553.8274094983935,997.4313544188626Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.0244646240026,898.8197359926999L458.4266228405759,892.1442388002761L473.9250794388354,897.7574417479336L479.8070143042132,899.8903536307625L477.4048560867086,906.5658433651552Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.7017630971968,940.2698933351785L562.6361118480563,934.8918641228229L574.9103908957914,939.3491051145829L575.4279001876712,937.9247443317436L586.4123504394665,941.9148265700787L583.9675923706964,948.7109665665776L566.6546977134421,942.4246413446963Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.510516135022,926.4226821656339L528.2801215816289,913.4400512138382L539.7039813995361,917.6777727408335L539.5477819489315,918.0887473151088L535.508685044013,929.0799671504647L530.498469335027,927.2165383589454L529.9170602681115,928.7969673899934Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M417.71378826815635,1005.4176906705834L420.1301464345306,998.6861129114404L434.0342641957104,1003.7176297651604L440.2491090018302,1005.9784817853943L440.6388187427074,1007.1187915885821L438.54117056541145,1012.9587146844715Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M545.3232171898708,877.7517367806286L550.2916219364852,854.3228894895874L557.3781858980656,855.8398676100187L554.4585183896124,869.5946197886951L553.8629093738273,872.3726186165586L551.7226613471285,871.9189829309471L550.2490220852196,878.8005082686432Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M548.6049834238365,831.8158061020076L548.7674939632416,830.9511880450882L550.7657424900681,820.696455901023L551.063941440545,819.1305686226115L552.9130904925987,819.4988903147168L554.1674194131047,813.0574197247624L553.309900207445,812.8940678648651L553.9978088997304,809.3513084310107L560.0351543296129,810.5270261522382L558.0653057033196,820.6537971841171L557.6471960637718,820.569520201534L555.3799373703077,832.2548780469224L555.2095379708335,833.119495941326Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M430.00936724152416,1046.1170659326017L436.88293195329607,1027.1813466446474L443.4740754356608,1029.5909718177281L443.03466587048024,1030.803067064844L439.0657798303291,1041.7441678792238L436.6068218136206,1048.5194015661255Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M443.8140853503719,932.7932975166477L446.37244301941246,925.6860501240008L457.62590343598276,929.7676981426775L466.1513956701383,932.8432386238128L465.1802768642083,935.5358960856684L461.5450896508992,934.2186997919343L460.2694608028978,937.7541123423725L459.5602521877736,937.491921715904L459.2486421726644,938.378375700675L458.90863225702196,938.257684789598Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.653018691577,1014.3830600469373L443.1190766841173,1007.4871032931842L444.026295715943,1007.3383220131509L445.1883249618113,1004.0859416476451L446.1168439183384,1003.7738129347563L446.5207536080852,1002.583561974112L446.0671440921724,1001.6482160175219L446.2233435437083,1001.2091548014432L447.03116292413324,1000.8897429509088L447.42797263897955,999.8201813399792L446.95306319836527,999.1532658920623L447.0027630245313,999.0190504505299L448.10878135543317,998.4093585708179L448.7462013363838,998.65073830029L450.07153000775725,994.9374432056211L454.06092708650976,996.3753178645857L452.6653875503689,1000.294617250096L453.05509729031473,1000.5214308965951L453.4945068564266,1001.0530903819017L453.01249744091183,1002.4066890012473L452.58018784970045,1003.6250315750949L451.6303689694032,1004.1421248167753L451.3400588789955,1004.9151635318995L451.9206790588796,1005.4957228330895L450.9290492143482,1008.2528586355038L449.75991999264807,1008.8271750872955L450.3334401976317,1009.9321098658256L448.4558912459761,1015.204997707624L447.8247823547572,1016.9622792867012Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M564.1815397460014,949.2842475147918L566.6546977134421,942.4246413446963L583.9675923706964,948.7109665665776L581.5007454929873,955.5705665168352L565.5415794067085,949.7805360658094Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M540.3201014539227,1018.4865048066713L542.9139589965343,1011.2721811900847L547.9383746571839,1013.0929298554547L559.3054346749559,1017.2244669105858L556.7115771314129,1024.4315013531595L545.8691263794899,1020.4986900691874Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M546.9885557759553,985.6463935398497L547.7687641428784,983.4843759411015L549.4341027298942,982.7331839115359L557.909106252715,985.8159839198925L569.1491556055844,989.8913539485075L566.6617976874113,996.808136807289L555.4004484107718,992.732770846691L556.3999671172351,989.962103266269L547.7048643669114,986.8085557534359Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M551.2903517559171,981.2453656680882L553.1047898186371,976.2065494740382L560.3546532057226,978.8430067198351L571.6436134986579,982.9391894917935L569.1491556055844,989.8913539485075L557.909106252715,985.8159839198925L558.5970149450004,983.8963870452717Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M515.6800325671211,1039.7101398902014L519.5282190321013,1028.889725200832L521.3560681585222,1029.541031407658L523.8647260013968,1022.4900662172586L525.7004639888182,1021.1572800483555L529.0098412372172,1022.3340022773482L529.1660406878218,1024.4887247798033L527.1464922362939,1030.1788120283745L526.8482932848856,1031.0080307899043L525.7785637145862,1031.723843142856L525.4740536743775,1032.5811531855725L522.1220765756443,1042.006354562007Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.08616056106985,893.9234009324573L497.5380186038092,887.1199240977876L514.2695041969419,893.1930081131868L511.8176461532712,899.9964789845981Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M430.60418737120926,858.461804323364L432.31922578345984,853.7485602372326L435.0692827766761,854.7692431695759L435.76350255683064,852.8777022063732L438.9734801556915,854.060695707798L450.63873912300915,858.3619210384786L448.21449209563434,864.9667001664639L432.08571549411863,859.0142837157473Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M527.1890920847654,1045.8975367359817L527.5788018265739,1044.7842843057588L529.2228404870257,1040.185613493435L537.5921332715079,1043.2257306030951L548.5268836989999,1047.1866204007529L546.4718353711069,1052.8922953461297Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M427.28061017300934,872.1322749415413L429.73956819064915,865.392244163435L445.8833336280659,871.3519382784143L443.4101756606251,878.0846801251173L431.29209606256336,873.6128334645182Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M448.7533013112843,919.0459538241848L451.127059629187,912.4412262188271L462.5225195456296,916.5728232590482L469.7794829085469,919.1947369989939L470.339592050761,920.3777191839181L469.4465729687363,922.8581314827316L468.2561438223347,923.410605746787L461.0630802344531,920.8032597792335L460.1984610548243,923.1983557515778Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M431.90111614298075,965.9385065431707L434.43107391055673,958.893719278276L449.44752109143883,964.3362368447706L451.81496831960976,965.2008382668719L450.2340405480936,969.5810676417314L444.86961497180164,967.6385767124593L443.9197960905731,970.3031289386563Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.93038454838097,877.9431792055257L422.5607045534998,876.2139544892125L425.8558818511665,877.4323192420416L427.15991059783846,873.8604602273554L430.7177869733423,875.172465747688L431.29209606256336,873.6128334645182L443.4101756606251,878.0846801251173L440.9015178177506,884.944349961821L429.9170675659552,880.8980507687666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M546.6911457115784,1003.2421536576003L548.1797738075256,999.1178912809119L549.5611133947968,999.6214592712931L549.9366231840104,998.5581400422379L553.0124901439995,999.6703594671562L564.1673397952691,1003.7176297651604L561.5805822284892,1010.9101122575812L550.2135222097859,1006.7858544387855L547.3506545023993,1005.7443853146397L548.0732741840184,1003.7384383459575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M458.4266228405759,892.1442388002761L460.92108073364943,885.1992594487965L475.2078082598746,890.3733997838572L476.4195373309776,890.8197511406615L473.9250794388354,897.7574417479336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.69033519458026,915.4241750198416L411.2291444102302,913.9571511810645L412.6325728073716,912.6815684968606L414.42571094445884,913.3474518181756L428.5846389196813,918.5704719135538L426.0759810768068,925.4373847739771L411.90285315178335,920.200844113715L412.80928329657763,917.7349970522337L411.3427440105006,917.1960480809212Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.4190922630951,910.6547857401893L414.290811419487,908.2804943020456L416.742669461295,907.0121936798096L416.9769686376676,906.3744017276913L431.13589661289006,911.5974270757288L428.5846389196813,918.5704719135538L414.42571094445884,913.3474518181756L414.61662138439715,912.802259852644Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M575.1375900981948,874.9029896147549L578.4824672210962,859.1204096963629L585.7599416226149,860.68004524149L585.6613308591768,861.1752996831201L582.4150644987822,876.4615811612457Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M540.305901505053,876.6738325851038L541.7732296762988,869.7298781839199L541.1634207107127,868.4750963505358L541.6454301252961,866.1434489046223L542.771959496662,865.016641758848L543.6365786781535,860.948481477797L544.423887019977,861.1191153582186L546.0537257306278,853.4156157206744L550.2916219364852,854.3228894895874L545.3232171898708,877.7517367806286Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M622.2703798664734,964.8044325741939L627.4083951273933,950.2414497178979L634.6937583908439,952.8134097615257L631.9231903590262,960.6655812291428L629.5557431299239,967.3763872161508Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M418.0608981586993,899.1672445554286L420.5127562005073,892.4771814565174L425.0764623694122,894.1647842954844L436.0467126723379,898.211075745523L433.5948546305299,904.9073759717867L421.3773753819987,900.3939288286492Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M451.127059629187,912.4412262188271L453.5016068313271,905.8364923223853L471.3099219696596,912.285159801133L469.6800832571462,916.7923565478995L463.2806391008198,914.4680084534921L462.5225195456296,916.5728232590482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.0347454883158,850.432640240062L434.82788362633437,845.5217046625912L441.10662820748985,847.8387927073054L452.89889784064144,852.1899635866284L450.63873912300915,858.3619210384786L438.9734801556915,854.060695707798L439.42708967160434,852.79238516232Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M429.73956819064915,865.392244163435L432.08571549411863,859.0142837157473L448.21449209563434,864.9667001664639L445.8833336280659,871.3519382784143Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M435.72090270742774,842.7218455560505L436.47902226354927,840.659666925203L437.45724104437977,840.4193221516907L437.7830510092899,839.5401388118044L440.8731179172173,840.6742332754657L455.1811453681439,845.9534925711341L452.89889784064144,852.1899635866284L441.10662820748985,847.8387927073054L441.5957375979051,846.4851639084518L436.3236116990447,844.5436789416708L436.6068218136206,843.7851886865683Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.0537474937737,1056.4276473796926L464.3440575832501,1055.612997555174L469.8007828341797,1040.5820148750208L476.5544368568808,1043.0551012046635L471.34542184509337,1057.3921177354641L468.4115543877706,1056.3142414703034L467.8664340823889,1057.8238924448378Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M564.1957396958023,955.1949690021574L564.7692598998547,953.5791711458005L566.3075878228992,952.4877530620433L564.7692598998547,951.9279980589636L565.5415794067085,949.7805360658094L581.5007454929873,955.5705665168352L579.098587276414,962.2460026354529L567.8025270085782,958.1498076366261L564.6698602503166,957.015732394997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.4341751821339,885.3272344120778L423.16341354418546,880.6150490418077L429.20075897406787,882.8540918147191L429.9170675659552,880.8980507687666L440.9015178177506,884.944349961821L438.455970864743,891.6125709651969L427.50070939864963,887.5662756641395Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M467.96504484675825,865.6117790760472L470.1904925731942,859.4179786136374L484.108810284175,864.4641628442332L488.2615067884326,865.9665724500082L486.58906822651625,870.6361093679443L480.2606238210574,868.3471210747957L479.7147146295756,869.8640961283818Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.6391697283834,1002.1580264000222L497.9774281689897,995.8010003841482L510.30140704195946,1000.379932475742L513.9081943556666,1001.7116822106764L511.56283593922853,1008.068702806253L505.0852920562029,1005.6663531549275Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.62590343598276,1053.1607241393067L463.08972866181284,1038.123493600171L469.8007828341797,1040.5820148750208L464.3440575832501,1055.612997555174Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M554.4585183896124,869.5946197886951L557.3781858980656,855.8398676100187L557.6187961632386,854.6631171237677L564.9183593755588,856.215470509138L561.7572927176952,871.1542529743165Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M572.826942670159,913.2340435716324L574.4780813064426,908.8194439639337L583.2512837797403,912.129093377851L583.4855829570442,911.5058680977672L584.0236032865942,911.7035522507504L595.5468627540395,916.0546830445528L593.6622138274834,921.086259867996Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M568.2916363999248,873.4432403403334L571.6436134986579,857.6606570994481L578.4824672210962,859.1204096963629L575.1375900981948,874.9029896147549Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.34542184509337,1057.3921177354641L476.5544368568808,1043.0551012046635L483.2725910032168,1045.5146611561067L478.077775943093,1059.8506321762688L474.27928930334747,1058.4689534115605L473.28055948298424,1059.759075159207L472.04043051134795,1059.3054517358541Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M502.4062348129228,983.7829799521714L504.65298246592283,977.6527514797635L520.5908486284316,983.5624083471484L519.2229201057926,987.1841515558772L519.577918857336,987.3121246374212L518.6564998766407,989.8060385910794L517.7634807955474,989.4731006114744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M504.65298246592283,977.6527514797635L506.92813001945615,971.4944258742034L519.0746095161885,976.0015841284767L522.8588962061331,977.4040879928507L520.5908486284316,983.5624083471484Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M434.43107391055673,958.893719278276L436.77643232699484,952.3597793374211L451.25485917925835,957.6046191952191L451.8078683447093,957.8023020313121L449.44752109143883,964.3362368447706Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M446.37244301941246,925.6860501240008L448.7533013112843,919.0459538241848L460.1984610548243,923.1983557515778L464.01114764250815,924.5800614785403L461.934799390845,930.3555468176492L457.93751345109195,928.9103753827512L457.62590343598276,929.7676981426775Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.077775943093,1059.8506321762688L483.2725910032168,1045.5146611561067L490.09014480095357,1048.0023116385564L484.88822976499796,1062.3382775173523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.2064004736021,1041.829482594505L637.1953162578866,1027.5777487722225L643.8211707305163,1029.9093419206329L639.937484391965,1041.0075480914675L638.9529545204714,1043.8281355784275L636.7985065439716,1043.0769500904717L636.2809972520918,1044.5793209881522L632.6955098640174,1043.3172878380865L633.1065195286646,1042.1551351002418Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M500.0963762719184,990.0609442223795L502.4062348129228,983.7829799521714L517.7634807955474,989.4731006114744L515.4528333675116,995.7593831713311Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M409.22379590943456,1025.2471952638589L411.7253537774086,1018.3231577896513L425.67917136102915,1023.4108433993533L423.1776134939864,1030.334875792265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M470.1904925731942,859.4179786136374L472.6778504913673,852.4802496382035L484.0023106597364,856.5910733868368L486.6032681763172,857.5264389179647L484.108810284175,864.4641628442332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M625.4172465754673,1039.4344276073389L626.8135749977082,1035.4298355584033L630.3919624108821,1025.182688861154L637.1953162578866,1027.5777487722225L632.2064004736021,1041.829482594505Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M472.6778504913673,852.4802496382035L475.307207910344,845.1669102418236L486.35555793810636,849.1705717463046L487.8646970735863,849.7095260038041L489.0835261186585,851.7009512139484L488.16210713703185,854.2802309789695L486.0431590359658,854.7765263286419L484.8172300141305,854.3301726486534L484.0023106597364,856.5910733868368Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.9547059936449,1008.1186433709227L641.8158222297207,994.2632442791946L648.7469756267965,996.7082555149682L648.0590669354424,998.65073830029L643.8779705306515,1010.5626092958264Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M513.7385838413611,952.9767583259381L516.0200424836949,946.7757528573275L528.2659216327593,951.3110189782456L530.7461795732379,952.225562993437L530.1442594686523,953.8621698943898L531.0790895149112,954.2169587528333L529.9951599938795,957.1717978054658L529.5202505532652,956.9949236740358L528.9317415114492,958.6180037851445Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.66627051960677,989.3524105902761L462.8136185212061,983.4708503228612L478.91399522218853,989.4023512881249L476.7666472205892,995.2703809253871L461.7218001410365,989.7352892709896Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.3076602751389,832.8073595305905L439.8451993120834,828.6122447913513L447.2859731391072,831.3621677597985L447.5344722652808,830.6962765636854L451.9987787846476,832.3474785233848L452.1904781097546,831.8158061020076L454.94684619270265,832.8364922632463L455.64185485895723,832.3474785233848L458.51182254217565,833.4097827910446L459.3622417729348,834.543878256809L457.41290418524295,839.8585176435299L443.10487673431635,834.5719705256633Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M497.5380186038092,887.1199240977876L499.0542577151209,882.9321253569797L503.2566540436819,884.4626230266877L503.958762684837,882.5211486988701L516.4807519735768,887.0637399833649L514.2695041969419,893.1930081131868Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M502.1372246481478,1034.8492787647992L505.77951183728874,1024.6021312093362L506.92813001945615,1021.363284486346L513.8868944309652,1023.8644691747613L513.4687847904861,1025.0266249808483L509.09677794668823,1037.3431756170467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M455.01784594357014,1017.5646865470335L458.86603240761906,1006.7650458663702L459.57445213664323,1004.7871907758527L466.88111532572657,1007.4090711530298L462.3316091056913,1020.1865620925091Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M436.77643232699484,952.3597793374211L439.0799797810614,945.9538070843555L453.5584066314623,951.204894409515L451.25485917925835,957.6046191952191Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M420.1301464345306,998.6861129114404L422.53230465296656,992.0034288684838L435.6428029825911,996.7581961615942L436.42932243738323,997.0411931499839L434.0342641957104,1003.7176297651604Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M598.2961308602244,1031.4054731228389L603.7465450242162,1015.8001221283339L610.506510133855,1018.167093753349L606.9494226453826,1028.3435018952005L604.5756643284112,1027.5142828151584L602.6760265659541,1032.943220989313Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M409.5780057730153,926.5714651811868L411.90285315178335,920.200844113715L426.0759810768068,925.4373847739771L423.7369337491691,931.7944753104821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M511.54863598942757,958.9290940957144L513.7385838413611,952.9767583259381L528.9317415114492,958.6180037851445L526.7354825697839,964.5568090579472L523.446616361849,963.3374191829935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.53230465296656,992.0034288684838L425.00546262133867,985.1147328754887L438.12306092400104,989.8695048922673L435.6428029825911,996.7581961615942Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.6289467187598,839.6743573406711L591.38706627395,835.89750938816L593.548614227213,825.0622101989575L600.2454684488475,826.4085599929094L597.3187009654939,841.0279874731787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M465.5841865548864,872.2384007205255L467.96504484675825,865.6117790760472L479.7147146295756,869.8640961283818L481.48655284103006,870.5091745811515L479.1056945491582,877.142034235876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M504.28457265067846,868.2628446742892L505.8434116123244,863.932492883876L522.6245970297605,870.0336893410422L520.5553487539291,875.767602192238L508.323669555597,871.3092798697762L508.8269788958132,869.9202803820372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.7644506804645,905.9280513720587L416.6361698368564,903.532949433662L419.8043364705518,904.7024085186422L421.3773753819987,900.3939288286492L433.5948546305299,904.9073759717867L431.13589661289006,911.5974270757288L416.9769686376676,906.3744017276913Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M497.9774281689897,995.8010003841482L500.0963762719184,990.0609442223795L515.4528333675116,995.7593831713311L517.5717814704403,996.538665402215L516.2330417344347,1000.1593614029698L511.09502647351474,998.2460110783577L510.30140704195946,1000.379932475742Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.7702153213322,1046.1170659326017L445.49362388718873,1044.1111306459643L449.4688210161403,1033.1554676215164L456.34317461494356,1035.6566480584443L453.00539746694267,1044.8550330623984L451.6303689694032,1048.62552464474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M616.1478347349912,962.6288828146644L619.6844111857936,952.5938776112162L621.2787500228733,948.0658953906968L627.4083951273933,950.2414497178979L622.2703798664734,964.8044325741939Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.84255040530115,840.6815164489672L417.0400795266032,837.3718329244293L418.4009080734104,837.0950721451081L418.96101721469313,835.5499976533465L416.8065692363307,834.7634141440503L420.03074678592384,825.8623207318597L420.6618556762114,824.1476494097151L426.62189026828855,826.3305258136243L422.75240387860686,836.9681367431767L420.74705537687987,842.4815008533187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M462.8136185212061,983.4708503228612L464.8189670238644,977.9856900316663L468.3547545867041,979.2966354116797L480.9130326360464,983.9171956884675L478.91399522218853,989.4023512881249Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.92108073364943,885.1992594487965L463.18912831135094,878.8858249895275L475.02399779483676,883.172468656674L476.71773628052324,883.7894537998363L475.8949280641973,886.0992459282279L476.6396365566179,886.368721626699L475.2078082598746,890.3733997838572Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M606.2410029163584,1030.3983417227864L606.9494226453826,1028.3435018952005L610.506510133855,1018.167093753349L617.7989733722061,1020.7400690265931L613.5184773178771,1032.9640294825658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M506.92813001945615,971.4944258742034L509.23088858649135,965.2362130512483L521.1296578440815,969.6445341259241L526.0901737287641,971.4871428357437L525.1829546978697,973.9602538142353L520.4638379635289,972.2175274076872L519.0746095161885,976.0015841284767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M494.6467509958893,855.3716645212844L495.85848006699234,849.1497627012432L497.03470926359296,843.0974491653033L497.3116082884371,841.6876349574886L504.3058725753799,843.0547905862331L502.54113433975726,852.1400218992494L501.6410152828321,856.7461006105877Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.8731179172173,840.6742332754657L443.10487673431635,834.5719705256633L457.41290418524295,839.8585176435299L455.1811453681439,845.9534925711341Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M425.00546262133867,985.1147328754887L427.4084097230807,978.4466018057428L440.5189080527052,983.1940953745507L438.12306092400104,989.8695048922673Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M475.307207910344,845.1669102418236L477.9996762163937,837.6974950325675L484.5127199757844,840.0572442919947L484.9095296896994,838.9522824385203L489.4377359850332,840.596199257765L486.35555793810636,849.1705717463046Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M488.7293162541464,1030.0445971884765L493.342722248286,1017.0548772988841L500.08927629701793,1019.4707485507242L499.1181574901566,1022.2060298416764L495.4687703261152,1032.4677468892187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M481.97566223237664,1027.6276891953312L486.58906822651625,1014.6306817838922L493.342722248286,1017.0548772988841L488.7293162541464,1030.0445971884765Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.75240387860686,836.9681367431767L426.62189026828855,826.3305258136243L433.3329444397241,828.7964053880423L427.2593102483079,845.5071383235045L424.75065240543336,844.5925802318379L426.95480020716786,838.5059277396649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M605.8441931996495,947.6902974685654L608.0617520660162,941.3904456170276L621.9019700521603,946.286747155711L621.2787500228733,948.0658953906968L619.6844111857936,952.5938776112162L614.5250960001722,950.7731130565517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M427.4084097230807,978.4466018057428L429.7608681162819,971.9053972577676L441.7803369499743,976.2492072330788L442.87136644497514,976.6466527055018L440.5189080527052,983.1940953745507Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.0568559300154,1047.8243993981741L571.1687040571123,1042.0282034538686L583.9320924980566,1046.7121876999736L585.7883415231481,1047.385341106914L583.6835933700204,1053.1825729962438L581.820244369097,1052.4948542467318Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M581.451834554784,1013.7307119900361L583.7687930716202,1007.3601710121147L596.9857910266146,1012.207525848411L594.6751435985789,1018.5780623722821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M603.866455713287,845.5071383235045L606.2765027908608,833.4389155213721L606.446113304235,832.5951067619026L612.859757412225,833.898796454072L612.0164381572977,838.1084743491374L612.5765472985804,838.2291670045815L610.840208960697,846.896142702084L610.0252896044403,846.7754501984455L608.8482715236023,847.9241098104976L607.0701222224161,847.569315512199L606.4887131555006,846.0388096948154Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.9165716767311,1005.9784817853943L635.784787886776,992.1168358270079L641.8158222297207,994.2632442791946L636.9547059936449,1008.1186433709227Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M489.23262559529394,1006.6724477177486L491.46438441146165,1000.606746119447L495.6391697283834,1002.1580264000222L505.0852920562029,1005.6663531549275L502.8669443046674,1011.7185247656889Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M613.5184773178771,1032.9640294825658L617.7989733722061,1020.7400690265931L624.5952272452414,1023.1351304715499L620.3289311397821,1035.3590867044404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M463.18912831135094,878.8858249895275L465.5841865548864,872.2384007205255L479.1056945491582,877.142034235876L478.30497514270246,879.3675523116253L476.61833663191646,878.7505667726509L475.02399779483676,883.172468656674Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.3799373703077,832.2548780469224L557.6471960637718,820.569520201534L558.0653057033196,820.6537971841171L562.253502083011,821.4757578130811L562.9761217636988,817.7269922820851L565.2796692159027,818.1733483159915L562.2819019816816,833.6085096253082Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.00539746694267,1044.8550330623984L456.34317461494356,1035.6566480584443L463.08972866181284,1038.123493600171L457.62590343598276,1053.1607241393067L454.2100265612826,1051.9142988803796L456.3289746651426,1046.0744086019695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M565.1944695170969,965.3995613213629L567.8025270085782,958.1498076366261L579.098587276414,962.2460026354529L576.4905297821388,969.4957520347089Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.93751345109195,994.2070610299706L458.55442239157856,992.534048574511L460.44617129303515,993.2436223146506L461.7218001410365,989.7352892709896L476.7666472205892,995.2703809253871L474.87489832006395,1000.4433986805379Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.09677794668823,1037.3431756170467L513.4687847904861,1025.0266249808483L520.0591393876821,1027.3873509005643L519.5282190321013,1028.889725200832L515.6800325671211,1039.7101398902014Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M462.3316091056913,1020.1865620925091L466.88111532572657,1007.4090711530298L473.05336028151214,1009.62726441212L468.48965411260724,1022.4047512663528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.5678189927712,941.8222275543958L442.32545725349337,936.9467316493392L457.4413040857762,942.4246413446963L458.08661292586476,943.8635673327371L457.26459359563887,946.1525306915864L455.839865273796,947.3573574637994Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.8434116123244,863.932492883876L506.8429303187877,861.1752996831201L512.5615657595918,863.2593216653913L513.5681844409555,860.4740360286087L521.6187672344968,863.3935397351161L524.623634442687,864.4849718431942L522.6245970297605,870.0336893410422Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.3546532057226,978.8430067198351L562.8278111731634,971.9834297974594L574.1167714660987,976.0723335877992L571.6436134986579,982.9391894917935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M536.8971246052533,1028.804410325829L537.3862339965999,1027.4435338811018L538.8819620683789,1027.2666615392081L542.8713591480628,1028.7118124715053L543.8282780032605,1026.0472826943733L554.7062286296859,1029.9873738046736L552.6582802776247,1035.7138713924214L541.7164298761636,1031.7384090879932L537.7901436863467,1030.3140672906302Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.958762684837,882.5211486988701L506.17632155213505,876.3700217199512L518.6990997260436,880.9188597179018L516.4807519735768,887.0637399833649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M448.4558912459761,1015.204997707624L450.3334401976317,1009.9321098658256L450.9290492143482,1008.2528586355038L451.9206790588796,1005.4957228330895L452.58018784970045,1003.6250315750949L453.01249744091183,1002.4066890012473L455.81146537326276,1003.420067041181L455.0959456684068,1005.4176906705834L458.86603240761906,1006.7650458663702L455.01784594357014,1017.5646865470335Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.3959973407909,1019.3999995323829L581.451834554784,1013.7307119900361L594.6751435985789,1018.5780623722821L595.1926528885961,1019.6549040768296L594.5615439973772,1021.3986589848064L592.6910950215533,1022.3974682809785L592.0954860048369,1024.0486245839857L590.2179370531812,1023.3619433706626Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M538.8748620944098,1022.9010345796123L539.3923713834956,1021.4694079812616L540.5189007548615,1020.980407548137L545.0897069005296,1022.6315641887486L545.8691263794899,1020.4986900691874L556.7115771314129,1024.4315013531595L554.7062286296859,1029.9873738046736L543.8282780032605,1026.0472826943733L543.9702775040641,1025.6435975022614L539.5406819730997,1024.0350990453735Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.41285349428654,875.3628677967936L504.8943816171959,871.2603787682019L507.94105979055166,872.3653354756534L508.323669555597,871.3092798697762L520.5553487539291,875.767602192238L518.6990997260436,880.9188597179018L506.17632155213505,876.3700217199512Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.23088858649135,965.2362130512483L511.54863598942757,958.9290940957144L523.446616361849,963.3374191829935L521.1296578440815,969.6445341259241Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.937484391965,1041.0075480914675L643.8211707305163,1029.9093419206329L650.6387245273218,1032.311683170963L646.7550381878391,1043.409885498695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M516.0200424836949,946.7757528573275L518.2454902110621,940.7099988493137L530.498469335027,945.2452689409256L528.2659216327593,951.3110189782456Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M562.8278111731634,971.9834297974594L565.1944695170969,965.3995613213629L576.4905297821388,969.4957520347089L574.1167714660987,976.0723335877992Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M472.45854015182704,968.0495483269915L474.5845882296562,962.2605687300675L479.8212142540142,964.1812120298855L487.1420773928985,966.8738573174924L485.01602931600064,972.6846821699291Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M425.0764623694122,894.1647842954844L427.50070939864963,887.5662756641395L438.455970864743,891.6125709651969L436.0467126723379,898.211075745523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M571.1687040571123,1042.0282034538686L573.2237523850054,1036.3589344141074L585.9942407980561,1041.0356395267881L583.9320924980566,1046.7121876999736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M599.1678500175476,966.6897003888153L601.4216976454481,960.3045500894077L610.0955004682764,963.3727939752862L609.167770399712,966.0165391471237L613.7811763938516,967.6604258352891L612.7248578872532,970.6506339181215L611.7537390813231,971.1542039737105Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M547.9383746571839,1013.0929298554547L550.2135222097859,1006.7858544387855L561.5805822284892,1010.9101122575812L559.3054346749559,1017.2244669105858Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M468.3547545867041,979.2966354116797L470.43110283929855,973.6200320343487L482.9822809137404,978.2405960951L480.9130326360464,983.9171956884675Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M429.7608681162819,971.9053972577676L431.90111614298075,965.9385065431707L443.9197960905731,970.3031289386563L441.7803369499743,976.2492072330788Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M521.8664774745703,1042.744014668744L525.4740536743775,1032.5811531855725L526.1966733550653,1032.8433402176015L526.8482932848856,1031.0080307899043L527.1464922362939,1030.1788120283745L532.1425079954788,1031.9652217091061L529.2228404870257,1040.185613493435L527.5788018265739,1044.7842843057588Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M439.0657798303291,1041.7441678792238L443.03466587048024,1030.803067064844L449.4688210161403,1033.1554676215164L445.49362388718873,1044.1111306459643Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M470.43110283929855,973.6200320343487L472.45854015182704,968.0495483269915L485.01602931600064,972.6846821699291L482.9822809137404,978.2405960951Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M479.1127945240587,950.3049163813703L481.14654292631894,944.7281713075936L493.5620325887576,949.2915305770002L491.52828418649733,954.8693124135025Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M477.1003460464999,955.8181903539225L479.1127945240587,950.3049163813703L491.52828418649733,954.8693124135025L489.50873573403805,960.382582759019Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.3094478426501,991.890021905303L592.1309858802706,986.6951487055048L600.7345778401941,989.7425722912885L605.4820944750682,991.4218280054629L603.6542453477159,996.6094146524556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M573.2237523850054,1036.3589344141074L575.1723010865971,1031.0007478157058L585.9942407980561,1034.962685025297L587.9427895005792,1035.6784969670698L585.9942407980561,1041.0356395267881Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M520.8677476551384,859.5532372076996L521.4554678089917,856.4776642117649L523.2983057713136,856.8314176034182L525.1758547229692,847.1302445372567L530.5055693099275,848.164454324171L524.623634442687,864.4849718431942L521.6187672344968,863.3935397351161L522.3129870146513,859.8362397975288Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.4687703261152,1032.4677468892187L499.1181574901566,1022.2060298416764L505.77951183728874,1024.6021312093362L502.1372246481478,1034.8492787647992Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M619.8256217995659,1036.8052763743326L620.3289311397821,1035.3590867044404L624.5952272452414,1023.1351304715499L630.3919624108821,1025.182688861154L626.8135749977082,1035.4298355584033L623.6880082134157,1034.3249048413709L622.4975790679455,1037.7406175876968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.0319807380438,939.5759207536466L484.99472939036787,934.2041336386465L497.403119077906,938.7747829034925L495.44037042651325,944.1465664799325Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M584.0236032865942,911.7035522507504L586.178051263094,905.9499006895348L597.6942107556388,910.3010350950062L595.5468627540395,916.0546830445528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M490.1256446763873,912.5546344798058L491.75548338796943,908.0900931581855L506.6086311424151,913.5534594603814L504.9858924066648,918.0179972634651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M486.879378316924,921.433767315466L488.5163170034066,916.9692317089066L503.37735362071544,922.4325910131447L501.7404149323702,926.9044061847962Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M442.32545725349337,936.9467316493392L443.8140853503719,932.7932975166477L458.90863225702196,938.257684789598L459.80165133811533,939.6820455011912L459.0080319074914,941.8784112283029L457.4413040857762,942.4246413446963Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M439.0799797810614,945.9538070843555L440.5678189927712,941.8222275543958L455.839865273796,947.3573574637994L456.54118502978235,948.5757097126916L455.7830654736608,950.6877972199582L454.3946259133518,951.5097424313426L453.5584066314623,951.204894409515Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M520.0946392621845,902.3780563711189L600.9538881797343,931.6176005313173"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M488.5163170034066,916.9692317089066L490.1256446763873,912.5546344798058L504.9858924066648,918.0179972634651L503.37735362071544,922.4325910131447Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M575.1723010865971,1031.0007478157058L577.3906488390639,1024.920501539018L588.2117996653542,1028.889725200832L585.9942407980561,1034.962685025297Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M481.14654292631894,944.7281713075936L483.0319807380438,939.5759207536466L495.44037042651325,944.1465664799325L493.5620325887576,949.2915305770002Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M586.178051263094,905.9499006895348L588.1975997155532,900.5354292909615L599.7208591820672,904.8865670938976L597.6942107556388,910.3010350950062Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M539.6542815733701,1037.4784307433292L541.7164298761636,1031.7384090879932L552.6582802776247,1035.7138713924214L550.5890319999307,1041.4466067869216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M537.5921332715079,1043.2257306030951L539.6542815733701,1037.4784307433292L550.5890319999307,1041.4466067869216L548.5268836989999,1047.1866204007529Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.9881107090041,929.3567242608406L485.48383878171444,925.2605098295026L500.3369865352288,930.7249030396342L498.84204735048115,934.8346399529837Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M597.3542008409277,971.862739471253L599.1678500175476,966.6897003888153L611.7537390813231,971.1542039737105L612.4984475718811,971.4163933289237L611.1944188270718,975.1151349521242L606.4035134557635,973.407783579547L605.8931041397154,974.87479483895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M577.3906488390639,1024.920501539018L579.3959973407909,1019.3999995323829L590.2179370531812,1023.3619433706626L588.2117996653542,1028.889725200832Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M482.54287134855986,933.304153400939L483.9881107090041,929.3567242608406L498.84204735048115,934.8346399529837L497.403119077906,938.7747829034925L484.99472939036787,934.2041336386465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M485.48383878171444,925.2605098295026L486.879378316924,921.433767315466L501.7404149323702,926.9044061847962L500.3369865352288,930.7249030396342Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M592.1309858802706,986.6951487055048L593.8744241921231,981.7416519289836L605.8931041397154,986.0001403391361L604.4975646035746,989.962103266269L601.0816877298057,988.7572838962078L600.7345778401941,989.7425722912885Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.4216976454481,960.3045500894077L603.6542453477159,953.9474856923334L612.3280481714755,957.015732394997L610.0955004682764,963.3727939752862Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M512.4976659836248,854.5642742323689L514.3476039208472,845.0108423070051L519.7759292721748,846.0741850901395L517.8983803214505,855.775359631516L517.316971254535,858.7666564243846L515.1838232027367,858.3483951757662L515.7936321683228,855.2083136611618Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M603.6542453477159,953.9474856923334L605.8441931996495,947.6902974685654L614.5250960001722,950.7731130565517L612.3280481714755,957.015732394997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M593.8744241921231,981.7416519289836L595.5681626796722,976.936933546327L604.1007548877969,979.962512334343L603.6116454973817,981.3379641543142L607.0914221471176,982.5781595106237L605.8931041397154,986.0001403391361Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.8983803214505,855.775359631516L519.7759292721748,846.0741850901395L525.1758547229692,847.1302445372567L523.2983057713136,856.8314176034182L521.4554678089917,856.4776642117649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M502.54113433975726,852.1400218992494L504.3058725753799,843.0547905862331L509.37288808543235,844.0400996874087L507.6223497996107,853.0618621581234L506.9920297944918,856.3215965344571L504.96459248196334,855.9241441632621L505.58860139735043,852.7289176089689Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M507.6223497996107,853.0618621581234L509.37288808543235,844.0400996874087L514.3476039208472,845.0108423070051L512.4976659836248,854.5642742323689L511.95964565500617,857.3204296147451L509.9400972025469,856.9240177515894L510.5775171825662,853.6351510155946Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M595.5681626796722,976.936933546327L597.3542008409277,971.862739471253L605.8931041397154,974.87479483895L604.1007548877969,979.962512334343Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M594.6751435985789,1018.5780623722821L596.9857910266146,1012.207525848411L603.5406457474455,1014.6098732352257L601.2236872306094,1020.980407548137Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M492.03869350254536,848.3985561151057L493.21492269821465,842.3462419258431L497.03470926359296,843.0974491653033L495.85848006699234,849.1497627012432Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.2659216327593,951.3110189782456L530.498469335027,945.2452689409256L533.2903372915462,946.286747155711L532.5464176861569,948.3062364319339L533.4465367430821,949.5110628302209L532.6671172622591,951.6231500552967L530.8526791995391,951.9279980589636L530.7461795732379,952.225562993437Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M623.3535205023363,991.7443615850061m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M590.8845458198339,870.2854780270718m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M639.7986404346302,964.060521567706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.5234712520614,902.0305479695089m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M601.3530645528808,830.3310768301599m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M575.3332338538021,933.8462224369869m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M566.6980864498764,864.4069380937144m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M476.89523565769196,959.3754410403781m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M553.7603541789576,994.7699339115061m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M467.9161339076236,899.3555650548078m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.5613956423476,941.0918397828937m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M531.5287546003237,922.2557159923017m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M552.2149262819439,862.7172471103258m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M437.3160304296762,1036.273619630374m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M453.08901939354837,931.2804979947396m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.9723040582612,1006.4175426973961m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M574.0741716148332,948.9970868295059m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M549.8127680653706,1017.8549656746909m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M558.4258266575634,988.3494348069653m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M564.3748168442398,983.4177882857621m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M522.480230871588,1031.3659369759262m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M504.67822682112455,893.5582045316696m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M440.92281774338335,858.7375238002278m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M436.5815774574876,871.742106620688m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M457.57147029414773,917.8088684305549m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M441.4758269088343,964.7690577846952m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M434.5052292048931,879.4913655896671m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M555.7554471613839,1004.7414119029418m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M467.42308008577675,891.4814747781493m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M580.3978827055544,868.0391480466351m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M545.0565736824647,865.5805655815639m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M629.2117887837812,956.7400168264285m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M427.0541998585686,898.6886399444193m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M457.374248765409,909.0608268114738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M442.96603277884424,851.3107817433774m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M438.9774245861918,865.1799923912622m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.7539563057944,845.2480655652471m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M572.8616536585614,956.2936697117984m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M432.4091588007286,886.4467551289126m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M476.93310219142586,865.0384912081063m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M504.77368204202503,1001.935374522116m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M559.6904110983014,862.904528150335m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M584.1908471416682,914.6448836713098m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.3886295827106,866.2818287173286m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M511.4981472780928,983.6726941494271m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M513.7559393355623,977.5289399544708m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.1190766841173,958.3485308955424m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M455.19140088837594,925.1335760452785m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M638.1577573176473,1035.4589674398303m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M508.9303229767829,989.7675426392816m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M478.39648593310267,858.472208831925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M632.0028678551316,1031.5043134875596m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M480.8948882557452,850.7052386784926m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M522.2419872647151,952.6011606696993m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M469.7905273139477,989.3773809396662m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M510.63431698363274,890.1569869918749m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M507.80458249151707,1029.9384738258086m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M460.95026952121407,1012.487400921993m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.16702503710985,951.7823368967511m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.2801288785413,997.8641732959077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M605.0805514417589,1022.84068986075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M520.2397943083197,958.7740691625513m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M430.3272883454338,990.9369871774688m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M595.8142951475456,831.1530363122001m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M473.5353696970269,871.3737877048552m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M513.2944409595802,869.092082801275m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M503.40969795081764,992.9096440668218m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.9180048080161,1039.8838906418532m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M621.3623719504103,957.6108618113212m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.8629311369732,983.6935027930886m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M468.82019739504904,884.4948768843897m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M612.3730146801099,1024.5417865035124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M515.4394223038107,970.5653183241375m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M499.19941275939345,850.6448924597353m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M449.14301105123013,840.2663754713722m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M432.762579780072,984.1544141899794m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M493.9225535430014,1026.1253146245144m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.0434630457312,832.8822722709738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M435.1402825275436,977.5466273170896m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.2203181758523,841.8676333925687m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M636.3669858388603,1000.1208655056544m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M497.1593532692641,1006.1688802414574m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M619.0596133824438,1028.0490615055896m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.17186689935625,877.946300550364m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M458.04637973569334,1041.4892641482875m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M572.1469228388742,963.8233023756184m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M467.35129144974053,994.738720999565m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M514.311315161176,1033.115931483917m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M519.3089086934924,867.2598513709381m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M567.2361067794263,977.4571500774473m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M547.0445666909218,1031.0257180132903m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M511.32853676378727,881.7200042544864m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M453.0961193693802,1012.5685542891733m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M587.2091254144907,1018.9890309642069m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M549.3978139683604,1025.038069665432m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M512.8984201299027,876.068291739095m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M516.3387524737045,964.2873363993131m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M523.2588614663109,946.0099907214753m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M569.6579871494323,970.7390708094463m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M479.8007032154128,967.4617028478533m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M431.767794390209,892.8891979716718m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M578.5810779845342,1041.5319215091877m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M604.7515859333798,964.6941464697011m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M554.7598728854209,1012.0015211408027m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M475.6685177506879,978.7691359892488m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M436.84033210296184,971.1042631459422m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M527.3019028007984,1036.5149980382994m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M444.2669059801847,1037.450339293573m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M477.7227771906182,973.1528773359023m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M486.3374135568738,949.7982234959491m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.31392067391425,955.3437514002435m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M580.583270941861,1036.0187156992033m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M500.6249299682677,1028.5349401640706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M625.5403128098696,1029.7543185716495m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M490.2171554658562,939.1753518423066m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M590.8593014646322,911.0022937096655m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M498.36713790986687,913.0540469889529m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M495.127971525304,921.9331791820005m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.6158614261076,937.6022082483396m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.459528083913,946.6550620896742m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M496.7514991480857,917.4936145059764m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M581.6924448180944,1029.9447163757868m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M488.2938511185348,944.4368486809544m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M592.9490607799962,905.4182339133695m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M546.1554920403287,1036.5961511242203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M544.090188193135,1042.3361687539145m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M492.1601819638163,930.0402934644371m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M601.9234292143956,968.9214323242195m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M583.8042929470539,1024.1412224983796m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M489.8400679035112,933.7536233137362m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M493.6133101871237,926.0824580551125m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M596.5045704962686,983.8714166786522m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M606.8752673519775,958.6606616559438m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M516.1367976283655,850.3192309602164m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M609.088092901744,952.3597793374211m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M599.0621392773464,981.5398080460727m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M521.5367230791599,851.4533236580901m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M505.95780009869486,848.0905822035857m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M510.986160190776,849.0363534018397m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M600.7306334096938,975.9058642708696m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M541.7377298017964,829.5829895748757L542.6307488819584,824.9696096251719L543.7288783537224,819.3220126670785L550.7657424900681,820.696455901023L548.7674939632416,830.9511880450882Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M819.4508862989023,843.9412566465326L825.4913872750476,829.6360527910292L858.4912823121995,829.6360527910292L858.4912823121995,847.6421471885405Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M727.256921697408,1028.7971273474395m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M831.916075787507,891.0819435343146L836.6501813586801,891.7259795679711"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M835.9835725920275,911.2363933767192L831.4837661981583,911.5339600574225"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M833.8717244639993,898.6220514727756L822.1859544571489,895.0221113520674L816.538318766281,892.2794967577793L812.1513230865821,889.0759633858688L809.8485645195469,885.3553264755756L807.4456174159423,881.1956187514588L806.7016978114843,876.0079457405955L807.8424271307886,869.9494129586965L809.0683561526239,866.1652983501554L811.2441040547565,859.999590551015L814.3696708399802,839.3632616787218"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M839.2582388501614,885.7663029683754L834.2125232666731,885.5259597576223"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M817.9409582782537,829.6360527910292L814.3696708399802,839.3632616787218"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M793.9454093463719,891.7259795679711L771.5875879889354,952.4877530620433"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4297491945326,829.6360527910292L858.4912823121995,829.7380173997954"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M858.4912823121995,908.8121608621441L857.5130635304376,908.6560943596996"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M802.6626009074971,887.7858098745346L797.5742854708806,887.0564568550326"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M849.5192805370316,914.1985338483937L852.1415379792452,916.4802239052951"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M828.2027888484299,840.2559709358029L832.3089410727844,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M828.2027888484299,840.2559709358029L821.1974801560864,839.8033735984936"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M821.1974801560864,839.8033735984936L814.3696708399802,839.3632616787218"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M829.8326275609434,903.8450826592743L834.8286433210596,904.5536250364967"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,902.5299612344243L793.315089341253,890.1954834992066L641.8174000009894,861.5238505830057"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M641.8174000009894,864.9989541121759L792.676880476065,893.5550831942819L858.4912823121995,906.0123273157515"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M814.3696708399802,839.3632616787218L807.2689069267362,855.0813785921782L793.9454093463719,891.7259795679711"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M771.5875879889354,952.4877530620433L757.9453804176301,989.5719415745698"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M850.603998943232,893.5124249253422L855.2103049634025,894.1221260312013"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M788.0831966334954,829.6360527910292L814.3696708399802,839.3632616787218"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,903.2228970807046L833.8717244639993,898.6220514727756"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M840.6466784123331,892.2368384795263L845.8698933729902,892.8111645416357"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M833.8717244639993,898.6220514727756L793.9454093463719,891.7259795679711"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,1026.1898210188374L757.9453804176301,989.5719415745698"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M717.7334885271266,1046.309544133488L641.8174000009894,1019.0961949210614"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M795.398537568748,897.7709675333463L801.159772858955,899.0184609512798"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M757.9453804176301,989.5719415745698L737.0020318627357,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M793.9454093463719,891.7259795679711L641.8174000009894,862.3999097822234"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M711.1928337560967,1046.309544133488L693.4137074034661,1039.611299639102"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,946.7029222222045L757.9453804176301,989.5719415745698"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.2228621179238,859.0569421970285L665.790071234107,857.4619309548289L670.9706863453612,843.1609168103896L676.20021239575,828.697562132962L673.0825344724581,827.5915580098517L669.7376573495567,826.3939936119132L673.861953953281,814.7440014411695L674.7123731849715,815.0415722616017L676.7035217359662,815.7501237145625L677.7945512328297,812.6745312823914L675.2014825735241,811.7464429056272L679.1979796299711,800.7050949842669L714.1353789614514,813.4403081438504L750.5748174553737,826.720696690958L751.021326996386,825.4939993778244L759.8442292949185,828.7048453190364L759.3701087413356,830.0158189279027L756.2516419319436,838.5902045029216L752.4531552921981,849.0644456115551L738.712336958386,844.0400996874087L737.648918476887,846.966893479228L728.1317963972688,843.4803359275684L731.2991741439328,834.742605054751L724.8224191479385,832.3682876215316L718.3803751412779,852.3168987063691L725.3462395286188,853.8973448132165L724.5242201974615,858.058109367732L723.3905908502638,863.819083828479L722.4691718686372,868.5250379177742L722.1788617800921,869.970221941825L722.107862030156,870.3312577870674L683.3577761072665,862.6423346935771L665.2512620175257,859.0569421970285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M785.8672155383974,950.347574301064L803.0381106967106,902.817123843357L877.7243257714435,919.3216708921827L876.2222866108641,925.6787670403719L866.9741746950895,964.6702164681628L866.4282655054703,966.9373238291591L850.3412998672575,963.3166104787961L853.0203571096063,951.3037359206937L845.572483307682,949.6390366074629L843.8574448954314,957.3132971073501L817.4100379226729,951.3755260682665L818.9688768843189,944.3733819634654L807.0062078507617,941.6807279363275L805.4260689644143,948.7390583758242L798.2401053505018,947.1305420775898L795.7953472845256,954.2023926409893L787.2627550754696,950.8865206916817Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M837.8335105301812,1085.4979942976497L844.6581643009558,1070.2121737361886L860.185020797886,1076.9509649677202L866.6830757185817,1061.3176251444966L854.7211955729872,1056.0031555304304L859.6675115078688,1040.568489367608L906.5391799733043,1056.1019955463707L880.4814827395603,1105.4115433609113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M856.5001337602735,1006.7359138643369L869.9719419293106,970.0409395438619L902.1947841430083,981.3806218835525L912.2507154392079,984.9097677939571L910.2240670118481,990.5645128730685L910.9679866181687,990.8412675256841L899.6861263001338,1022.3340022773482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M824.9076115507632,882.9102759640664L824.9999112263322,881.7480963356793L826.9555599028245,853.6778095299378L841.1996875777841,854.6839261520654L841.4757977183908,850.7437354046851L854.4521854072809,851.6582926842384L858.4415824860334,851.9423360479996L858.3066829619929,853.9264774578623L858.1441724216565,856.1301535097882L868.6892131082714,856.874076097738L872.4734997972846,857.1435529324226L870.4255514442921,886.4186630672775L854.5507961716503,885.3064254731871L854.664395772852,883.6552361277863L854.7850953480229,881.9749138602056L851.1065193973482,881.7200042544864L840.0447583077475,880.933425986208L839.8317590570077,883.966329802759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M626.7354752728716,897.1976823257282L631.4411809435114,883.8810131438076L635.6364772981033,870.9690530551597L655.3657301226631,875.1433331924491L655.0817311219871,876.496956396848L658.9086176604033,877.2981014437973L660.8508552741259,875.7738448819146L671.2041966356337,877.9712713020854L670.9493864206597,879.1761099225841L671.90551639162,879.3748354446143L671.104796984233,883.20784385968L666.9663004307076,905.1560420617461L671.3177962359041,906.5939353443682L669.8078682133928,912.4828439294361L666.1868809498847,911.0657607298344L654.2668117666617,918.2874717214145L657.8317881152034,907.8341440693475Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M772.4025073442608,983.407383963L782.6209491789341,956.8887991919182L784.6546975811943,957.6826518960297L787.2627550754696,950.8865206916817L795.7953472845256,954.2023926409893L817.0266392715275,962.4447257765569L812.3430224126205,974.6053225812502L812.3146225120872,974.6906381230801L810.8756942404434,978.4247527169064L807.3604177171364,977.0638663843274L806.269388220273,979.8844798877835L809.7846647435799,981.2453656680882L804.200139942579,995.7521001612768Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M614.6173956748098,927.5494793276303L621.5406602108851,907.1474513444118L622.5827787676826,907.501202150248L626.1540662068874,896.991674197372L626.7354752728716,897.1976823257282L657.8317881152034,907.8341440693475L654.2668117666617,918.2874717214145L647.2938474044204,938.7321249134839Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M745.9267004719004,875.0590568734333L747.8255493482575,865.3495857180096L748.1158594386652,863.9179265825078L749.2076778188348,858.3692041933537L749.3275885079056,858.3910536612384L774.2019565710798,863.3227891237475L778.4682526756078,851.5667329179123L795.0017278539017,857.6107154511847L785.7891158135608,883.0174420266412Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M806.0074780303985,992.6266469107941L812.3146225120872,974.6906381230801L812.3430224126205,974.6053225812502L821.5130346016958,977.8504337458871L822.2711541578174,975.6967371837236L843.1553362552077,983.1087799374945L842.503716324456,984.9805171629414L849.1934705711901,987.3402162869461L848.2862515402958,989.9194455882534L850.2845000671223,990.6279791644774L849.7819796130061,992.0460865315981L850.6465987935662,992.3498923280276L846.1247035879642,1005.1846346091479L843.2760358294472,1004.1774994032457L842.75852653943,1005.6517871520482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M666.9663004307076,905.1560420617461L671.104796984233,883.20784385968L706.049296291545,890.599176580552L704.6466567823663,897.2892414899543L701.6772894477472,913.0145101640373L692.6200879728422,911.2436764789745L693.0168976886198,909.1877608895302L678.5889595486224,906.367118622642L678.0927501833066,908.3304355852306L671.3177962359041,906.5939353443682Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M731.646284035407,923.1130395750515L733.5246218722314,917.9045890904963L736.1610792661086,910.5986018162221L737.0398983964697,908.167085969355L739.1943463739008,908.9474184918217L740.5685859844089,905.1061007557437L738.7620367836207,904.4537424147129L739.7252667285502,901.3781893365085L743.0630438774824,890.7552434867248L779.3186719054356,897.8136257762089L773.25292657502,914.6376005746424L756.4291413072497,908.5291602709331L751.8086353382096,906.842601371929L747.9249489987269,917.6143057784066L741.1641950011253,915.1547004515305L737.1314091850072,926.331123386044L732.376792576164,924.6019107373431L732.7594023412094,923.5240138266236Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M695.1358457915485,956.82429215312L695.9649650966749,954.5498984279111L699.1402317052707,945.7478004074655L712.3848406746984,950.5525404037908L713.3843593802303,947.7818559659645L711.2583113024011,947.0171343805268L716.3253268133849,932.9285546792671L704.6963566066697,928.7043681992218L708.196644295007,918.9887295281515L718.7274850318208,922.8154733921401L718.3732751663774,923.7934880708344L733.4820220218971,929.2786912405863L731.7456836849451,934.0834426544607L730.959164230153,936.2590013695881L725.6160385785624,934.3248246205039L724.751419397071,936.7126328474842L725.7225382039323,937.0674225836992L723.9506999924779,941.9918190068565L728.3227068362758,943.5722446707077L726.1406478444114,949.6171874268912L720.3502237675712,947.5061400299892L717.7563662240282,954.7059638942592L723.5538902767003,956.8034834279679L720.2587129790336,965.9520321930759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.4998262990266,853.6642836583778L647.2583475289866,825.8560779984109L662.8491038009524,830.6536179049872L661.6444747056812,834.7634141440503L659.3764271270484,833.8634210019372L658.1788980066776,836.9254781268537L657.5982778267935,838.3925182684325L670.7292871950194,843.076640102081L670.9706863453612,843.1609168103896L665.790071234107,857.4619309548289L665.2228621179238,859.0569421970285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M647.2583475289866,825.8560779984109L658.8384067974985,793.4125101785176L676.20021239575,799.6063696132042L668.305829051882,821.8940212838352L670.4602770293131,822.6597971287556L667.10829993058,832.1279425593093L662.8491038009524,830.6536179049872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M727.0683779148385,968.425145146437L733.7794320872054,949.8013448091224L735.3816597843543,950.3829491618089L737.138509160839,945.528268030379L746.7132199266925,949.0012485766783L759.2281092396006,953.5510793575086L750.7665167804807,977.0284916595556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M816.8215288817883,966.1507552266121L820.0670063551515,956.6266092872247L858.5480821123347,969.8286909763701L857.2937531908974,973.528473878745L860.7798409285024,974.718729827553L859.7172113321722,977.8649998079054L856.1522349836305,976.6466527055018L855.2387048620731,979.3320101243444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.0670136520639,911.796151668299L720.9600327331573,907.3950769114308L724.1771103069186,908.053677638527L724.7585193719715,905.1914171529934L721.7181522892788,904.5671508079395L723.3621909515932,896.417348484043L725.2121288878843,887.3113662647083L743.0630438774824,890.7552434867248L739.7252667285502,901.3781893365085L735.161560558714,900.4428297244012L732.0509826103225,909.7548024449497L736.1610792661086,910.5986018162221L733.5246218722314,917.9045890904963L723.9861998679116,914.9351671067998L724.3404097314924,913.220517816022L721.8459518393502,912.7096604490653L721.9524514656514,912.171751535032Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M768.688431520015,847.9875774104148L770.6732689831406,842.5023099184036L773.3515373403206,835.1254922794178L775.1020756261423,835.7632907861844L799.6719336481765,844.7486481736414L795.0017278539017,857.6107154511847L778.4682526756078,851.5667329179123L770.8215795718133,848.7668762523681Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M745.6924012945965,929.4201911156997L747.7119497461244,923.8153373342939L750.554306415841,924.8422525925562L767.3709917087108,930.9517189622857L759.2281092396006,953.5510793575086L746.7132199266925,949.0012485766783L752.8357650581747,932.0140081210993Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M629.9525528457016,973.7760970736854L634.2827487252653,961.4948083050549L631.9231903590262,960.6655812291428L634.6937583908439,952.8134097615257L635.2964673824608,951.1060528969392L651.6666431343183,956.8815161380917L651.0639341427013,958.5607798141427L648.9662859663367,964.5141512239352L646.3795283986256,963.6068918770179L644.7922895364463,968.1067722192965L641.3764126617461,977.8015333958901Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M719.1597946211696,990.9192998525687L721.7394522149116,983.5977830411866L722.0581622039899,982.6842835987918L745.6356014953926,991.0389494136907L741.2280947752297,1003.582373984158L722.7105710217729,997.0276675582863L719.3159940727055,995.830132429488L720.8322331830859,991.5144263557158Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M752.5170550681651,853.0826711915433L752.5312550170347,853.0327295102179L757.5982705280185,839.0792178004049L756.2516419319436,838.5902045029216L759.3701087413356,830.0158189279027L773.3515373403206,835.1254922794178L770.6732689831406,842.5023099184036L768.1504111904651,841.5877514304593L762.6368861375377,856.7887591063045Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M794.0235090712085,1066.164942254778L796.5676667895168,1059.815257877577L797.8290956858546,1060.3261044011451L801.4366718856618,1051.3046116516925L800.1823429642245,1050.8010474182665L800.7913630446419,1049.2560205557384L801.2378725847229,1048.1438090866432L802.0456919651479,1048.4694612962194L802.8748112721369,1046.4146268237382L807.7154164668173,1048.363338212017L808.5729356743395,1046.223189048469L813.4908517086878,1048.2072748541832L812.5694327270612,1050.5034867152572L815.4252004595473,1051.6583551014774L813.3275522822514,1056.903119836934L811.9604126475751,1056.356898739934L808.4806359978393,1065.0381676219404L809.4020549785346,1065.4064762494527L807.0062078507617,1071.3951301518828Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M839.1233393261209,1054.5215955362655L847.6133316848427,1036.4723406489938L859.6675115078688,1040.568489367608L854.7211955729872,1056.0031555304304L852.9635573094711,1060.934750416316L849.2928702216595,1059.2347031226382Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M779.6231819465756,1060.3614787012339L780.4949011020362,1058.1641100924462L785.0309962574393,1046.8255937653594L786.4833355937153,1043.2330135637894L800.7913630446419,1049.2560205557384L800.1823429642245,1050.8010474182665L796.5676667895168,1059.815257877577L794.0235090712085,1066.164942254778Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M722.4691718686372,868.5250379177742L723.3905908502638,863.819083828479L723.9010001663119,863.9252097350545L725.0346295135096,858.1496690511703L724.5242201974615,858.058109367732L725.3462395286188,853.8973448132165L725.6160385785624,852.5083418372087L730.2365445485339,853.4301820467226L729.9809454483911,854.7411509803496L743.2618431774899,857.3703712644055L740.4975862335414,871.4299719491974L739.2787571875378,872.8761958125979L736.7203995203599,872.3726186165586L736.0332797151059,871.0616530166008L726.7993677500635,869.2335839020088L725.2192288637161,870.4092914704233L723.2485913503915,870.0128803579137Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M701.6772894477472,913.0145101640373L704.6466567823663,897.2892414899543L707.6302240658551,897.9270342779346L710.187792846933,885.6882694582455L718.0119653251022,887.3467414467596L716.3679266646504,895.4684624127112L714.482488851063,904.8012506929226L712.6972395749763,913.6169264568016L712.5481401002035,914.3546002227813L712.3919406486675,915.1120423148386Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.2587129790336,965.9520321930759L723.5538902767003,956.8034834279679L726.1406478444114,949.6171874268912L728.3227068362758,943.5722446707077L730.959164230153,936.2590013695881L731.7456836849451,934.0834426544607L736.295189904049,935.7346199927852L734.6227513421327,940.3770585125312L736.8765989709646,941.1990049439482L733.7794320872054,949.8013448091224L727.0683779148385,968.425145146437Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M753.8849835898727,1032.87247211067L756.5135521218181,1025.9203507550992L770.3679700568318,1031.1432860353962L770.2196594672278,1031.53968793666L783.1100585702807,1036.407834350597L782.4513386636972,1038.1588680129498L780.6298006270081,1042.9635439636186Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M756.5135521218181,1025.9203507550992L759.1855093901977,1018.5853453585878L783.8184783002362,1027.7556615280919L781.0976100927219,1035.111465709284L770.3679700568318,1031.1432860353962Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M759.1855093901977,1018.5853453585878L761.7864669077098,1011.5759861436673L787.3408548003063,1021.0938140363432L786.9582450343296,1022.1571298073977L784.7540972325951,1028.1094061825424L783.8184783002362,1027.7556615280919Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M751.4749365122989,1039.4978934549727L753.8849835898727,1032.87247211067L780.6298006270081,1042.9635439636186L779.8574811220169,1044.7353844279423L777.7811328703538,1049.9156482270919L776.8810138134286,1049.5681472234428L771.3674887632951,1047.5205960338935L771.5733880391344,1046.9816571543925L764.8481339169666,1044.473197847139Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M750.554306415841,924.8422525925562L754.3385931048542,914.3327509309165L771.1552783986554,920.442226562649L767.3709917087108,930.9517189622857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M709.756272142753,1013.7879355051555L712.0661306846887,1007.2249153018929L736.8552990462631,1016.0196522781625L737.3302084868774,1016.1829993519932L735.0266610328108,1022.7449706471525L734.5596404531971,1022.5816237293184L725.4669391028583,1019.357342037838L722.5117717199028,1018.315874800086L717.430556259118,1016.5159360514954Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M712.5481401002035,914.3546002227813L712.6972395749763,913.6169264568016L714.482488851063,904.8012506929226L715.6453069839627,905.0426336815581L717.5299559095874,895.7088052756153L716.3679266646504,895.4684624127112L718.0119653251022,887.3467414467596L718.3022754155099,885.9078037277795L725.2121288878843,887.3113662647083L723.3621909515932,896.417348484043L721.8885516896844,896.1197811546735L719.9108142023906,905.8853931766935L721.2148429481313,906.1548681086861L720.9600327331573,907.3950769114308L720.0670136520639,911.796151668299L719.3443939723074,911.6400852333754L718.5436745658517,915.5802413686179Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M712.0661306846887,1007.2249153018929L714.213478686288,1001.1165565801784L717.1189462440088,1002.1507433955558L739.0026470478624,1009.8967353114858L736.8552990462631,1016.0196522781625Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M804.710549258627,1036.876025212463L807.5521170422435,1029.1800038539805L805.3479692395777,1028.3580678505823L807.7785273576155,1021.7815358992666L820.627115495503,1026.564374262467L818.3164680674672,1032.8298146957532L817.891258453019,1032.6737509882078L816.077609276399,1032.0005961526185L813.1153419176117,1040.008741476573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M761.7864669077098,1011.5759861436673L763.7989153843373,1006.1126970886253L789.3604032527655,1015.6305324821733L787.3408548003063,1021.0938140363432Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M717.1189462440088,1002.1507433955558L718.7913848068565,997.375171198044L722.1717618051916,998.565423049964L722.7105710217729,997.0276675582863L741.2280947752297,1003.582373984158L739.0026470478624,1009.8967353114858Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M689.9489195905626,987.9426261223853L694.8313357504085,974.0663780341856L703.3284280849621,977.0857154773548L698.4452230390161,990.954674503766Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M642.9352516233921,1054.3447238882072L646.7550381878391,1043.409885498695L650.6387245273218,1032.311683170963L657.2148791747168,1034.6224662396125L653.2680819462985,1045.9464366049506L650.5961246779189,1045.011096496135L646.8544378392398,1055.7264034752734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M748.72566840332,1046.9389998302795L751.4749365122989,1039.4978934549727L764.8481339169666,1044.473197847139L763.5370051944628,1048.1999918953516L761.7935668826103,1052.920386732556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M670.7576870946214,1020.08772156341L676.2073123706505,1004.5822262754664L683.0532660689205,1007.0053848731332L682.7629559775814,1007.8273234074004L677.6036407928914,1022.5108747449704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M687.1846626475453,948.8243742361665L689.2823108239099,942.998963250313L691.9045682679862,943.9551258804277L693.6622065296397,939.0796314752661L700.6280709160492,941.6026950562373L699.1402317052707,945.7478004074655L695.9649650966749,954.5498984279111L688.999100709334,952.0195565004833L689.8069200906903,949.7732530040666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M686.5330427167937,1025.6716889971867L691.691569016315,1010.9881443544291L692.3439778331667,1009.1320205791853L695.9010653216392,1010.3857365255244L694.7106361752376,1013.7806525109336L698.2898124745116,1015.0416506100446L693.6622065296397,1028.2020040419884Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M789.4314030017704,1034.721306560561L790.2960221832618,1032.4042809777893L795.8592470595613,1017.3451564465649L801.9462923165411,1019.6195295676589L799.458934398368,1026.3375614676625L798.2543053012341,1025.891218834091L796.8721768297255,1029.6263462733477L798.0846947869286,1030.072688668035L795.5263371188194,1036.9894314403646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M664.3235319489613,1017.8060656059533L668.7097387416288,1005.3334159352817L669.7802571998909,1002.3068077899516L676.2073123706505,1004.5822262754664L670.7576870946214,1020.08772156341Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M658.2214978560805,1053.7423198232427L660.219746382907,1048.0023116385564L664.053732897155,1037.0320888264105L670.8783866707236,1039.4344276073389L670.6582874441519,1040.0722073181532L666.8108898662031,1051.0705167115666L666.3856802508235,1052.296133688651L662.7071043010801,1050.9924850640818L661.3683645650744,1054.8545303950086Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M754.3385931048542,914.3327509309165L756.4291413072497,908.5291602709331L773.25292657502,914.6376005746424L771.1552783986554,920.442226562649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.2064004736021,1041.829482594505L637.1953162578866,1027.5777487722225L643.8211707305163,1029.9093419206329L639.937484391965,1041.0075480914675L638.9529545204714,1043.8281355784275L636.7985065439716,1043.0769500904717L636.2809972520918,1044.5793209881522L632.6955098640174,1043.3172878380865L633.1065195286646,1042.1551351002418Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M761.7935668826103,1052.920386732556L763.5370051944628,1048.1999918953516L764.9822445567697,1048.7389306798577L766.1371738268062,1045.5781269441359L771.3674887632951,1047.5205960338935L776.8810138134286,1049.5681472234428L773.6426363158971,1058.3482645903714Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M795.5263371188194,1036.9894314403646L798.0846947869286,1030.072688668035L799.3248237585649,1030.5408799555153L800.699063369073,1026.7984700277448L799.458934398368,1026.3375614676625L801.9462923165411,1019.6195295676589L807.7785273576155,1021.7815358992666L805.3479692395777,1028.3580678505823L801.3514721859246,1039.1649578595534Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M698.4452230390161,990.954674503766L703.3284280849621,977.0857154773548L710.3510922724381,979.5733905169182L706.4674059320241,990.5853214939125L705.4686761125922,993.4413041365333Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.9547059936449,1008.1186433709227L641.8158222297207,994.2632442791946L648.7469756267965,996.7082555149682L648.0590669354424,998.65073830029L643.8779705306515,1010.5626092958264Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M650.6742244027555,1012.979523237329L654.8695207582787,1001.0666159633547L656.0812498293817,997.5874189208262L657.257479025051,997.0484761600383L658.7532070958987,997.5801359121688L659.1358168628067,998.80576234404L658.150498105213,1001.5982754067518L661.5592750050128,1002.8030925430357L657.1801681863144,1015.2757467660122Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M676.9094210118055,982.5136527083814L677.3417306020856,981.2734573422931L681.5370269566774,969.3615360190161L688.5170912928879,971.8273647176102L683.8965853238478,984.9940427746624Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M818.3464457402006,1046.309544133488L826.3173510357738,1028.676438009832L847.6133316848427,1036.4723406489938L842.9857257399708,1046.309544133488Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.1202526502311,1049.227929154411L653.2680819462985,1045.9464366049506L657.2148791747168,1034.6224662396125L664.053732897155,1037.0320888264105L660.219746382907,1048.0023116385564L657.5982778267935,1047.0804972997867L656.3368489295244,1050.7157328100875Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M663.4589127674699,979.7856387840584L668.7168387174606,964.8189986608922L674.8472727099434,966.9945477307774L670.6582874441519,978.9137561507523L670.0421673888341,978.6942248255946L668.9716489324346,981.7416519289836Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.1801681863144,1015.2757467660122L661.5592750050128,1002.8030925430357L668.7097387416288,1005.3334159352817L664.3235319489613,1017.8060656059533Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M683.6488750837743,985.7098598796874L683.8965853238478,984.9940427746624L688.5170912928879,971.8273647176102L694.8313357504085,974.0663780341856L689.9489195905626,987.9426261223853Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M784.619986592792,1030.2922183629125L786.0723259281367,1026.3802189198323L787.1144444849342,1026.7630955590867L788.5880837459117,1022.7595366169699L786.9582450343296,1022.1571298073977L787.3408548003063,1021.0938140363432L789.3604032527655,1015.6305324821733L789.5947024282068,1015.020842062775L795.8592470595613,1017.3451564465649L790.2960221832618,1032.4042809777893Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M693.6622065296397,1028.2020040419884L698.2898124745116,1015.0416506100446L704.7310675960034,1017.3305904679L703.611638199538,1020.5132560385391L700.110561626032,1030.4763736040331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.9595876662061,977.8441911488771L659.546826527454,973.3370340927504L663.2175136161968,962.8692233539186L668.7168387174606,964.8189986608922L663.4589127674699,979.7856387840584Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M643.8779705306515,1010.5626092958264L648.0590669354424,998.65073830029L654.8695207582787,1001.0666159633547L650.6742244027555,1012.979523237329Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M664.6635418636724,1061.7930972692557L668.2277293261141,1051.5803234609775L666.8108898662031,1051.0705167115666L670.6582874441519,1040.0722073181532L675.1659827008843,1041.652610622812L670.3821773054078,1055.3435284378938L667.7457199115306,1062.8907406656072Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M814.7309806793928,1041.2270774431527L817.891258453019,1032.6737509882078L818.3164680674672,1032.8298146957532L820.627115495503,1026.564374262467L826.3173510357738,1028.676438009832L819.84769601468,1043.1331329410896Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M670.3821773054078,1055.3435284378938L675.1659827008843,1041.652610622812L681.0621175160632,1043.7355379275978L677.17133120168,1054.8899047221057L676.2854120954871,1057.4129261551425Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M670.6582874441519,978.9137561507523L674.8472727099434,966.9945477307774L681.5370269566774,969.3615360190161L677.3417306020856,981.2734573422931Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.937484391965,1041.0075480914675L643.8211707305163,1029.9093419206329L650.6387245273218,1032.311683170963L646.7550381878391,1043.409885498695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.2596466373652,1056.6763080353849L686.1504329517484,1045.521944114007L691.4580587269738,1047.3926240629517L687.5601724376902,1058.5469849738292L686.8446527319029,1058.2993648084812L685.6258236858994,1061.8139056763612L684.4424945143983,1062.2248717048205L683.1171658430248,1061.7504400331527L682.7700559534132,1060.8286275253631L684.0101849241182,1057.2995202648453Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.6036407928914,1022.5108747449704L682.7629559775814,1007.8273234074004L687.3905619224533,1009.4722406105138L682.231246736832,1024.1557884630747Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M711.8610202940181,992.5059569431469L715.7439177474007,981.4867459922098L721.7394522149116,983.5977830411866L719.1597946211696,990.9192998525687L717.8557658754289,994.6180310691707Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M653.3887815214694,971.1542039737105L657.066568586044,960.687430377584L663.2175136161968,962.8692233539186L659.546826527454,973.3370340927504Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.231246736832,1024.1557884630747L687.3905619224533,1009.4722406105138L691.691569016315,1010.9881443544291L686.5330427167937,1025.6716889971867Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M705.1846771119162,1032.7798743098974L708.8348531611264,1022.362093788106L714.6528882514685,1024.4242183691822L710.996401113458,1034.8347128233872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M775.3221748517826,1056.0811871197075L777.7811328703538,1049.9156482270919L779.8574811220169,1044.7353844279423L785.0309962574393,1046.8255937653594L780.4949011020362,1058.1641100924462Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M706.4674059320241,990.5853214939125L710.3510922724381,979.5733905169182L715.7439177474007,981.4867459922098L711.8610202940181,992.5059569431469Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M740.3137757694349,873.9457770115696L740.413175418973,873.4141077790409L742.503723623231,862.7984022283927L748.1158594386652,863.9179265825078L747.8255493482575,865.3495857180096L745.9267004719004,875.0590568734333Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.17133120168,1054.8899047221057L681.0621175160632,1043.7355379275978L686.1504329517484,1045.521944114007L682.2596466373652,1056.6763080353849Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M715.503307483159,1038.2795571852475L716.0768276881427,1036.6346468157135L717.1331461947411,1033.6236587041058L720.0812136027962,1034.6724066124298L729.1731260670349,1037.889398214873L727.5361873805523,1042.5452938275412Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M699.948051086627,1030.9227159405127L700.110561626032,1030.4763736040331L703.611638199538,1020.5132560385391L708.8348531611264,1022.362093788106L705.1846771119162,1032.7798743098974Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M723.589390152134,1024.693688691128L725.4669391028583,1019.357342037838L734.5596404531971,1022.5816237293184L732.6813026154414,1027.9179679010995Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.0812136027962,1034.6724066124298L721.8317518895492,1029.6762866824865L730.9307643296197,1032.8932806034572L729.1731260670349,1037.889398214873Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M721.8317518895492,1029.6762866824865L723.589390152134,1024.693688691128L732.6813026154414,1027.9179679010995L730.9307643296197,1032.8932806034572Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M782.4513386636972,1038.1588680129498L783.1100585702807,1036.407834350597L784.2862877668813,1033.2896824018098L789.7572129676118,1035.3590867044404L787.9293638411909,1040.2137049287558Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M833.1065049339086,933.6797521053813m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M796.4106784528121,968.5250268452801m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M768.6552983038127,870.2043229965493m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M828.0600004624575,990.2742326008156m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M766.19239585381,908.7382893851027m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M719.4587824596092,942.782552100718m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M728.178340677172,902.9731904771179m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M784.17899925448,846.3686332083307m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M760.1763503486291,847.7680419399403m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M733.5151552380994,860.9848972447217m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M709.5267062839121,901.3646635613404m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M728.6658722963184,953.3024150026031m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M768.4998877393082,1034.6401534550823m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M770.1510263737291,1026.8380062039942m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M773.263970981352,1019.8390595964156m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M766.0851073432714,1041.2301987139508m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M760.8547924067825,922.6417197054252m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M723.3022356061265,1014.9032737691887m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M718.759829361923,900.6093008541502m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M725.5300499927253,1008.560825434979m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M729.173914953135,1002.86655872548m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M696.6378849511966,982.5136527083814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.1740706069395,1044.21101125516m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M756.797551122494,1045.7060989486054m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M676.7603215351701,1013.9575251964852m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M693.1620527328923,947.2855672738515m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M692.4102442665026,1020.3571920534596m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M794.7051066746935,1027.9824742786586m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M670.134467064403,1011.5697435773909m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M665.4382280278951,1044.0372606134042m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M763.794970953837,914.4856959744357m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M802.4212017571554,1029.2153783114627m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M704.4612685451284,985.0793581884354m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M642.506886465475,1003.384692451451m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M656.119116361253,1007.8918299730867m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M682.9325664928183,976.5509328562766m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.2584814205766,966.3099417374469m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M658.6585407629609,1041.4892641482875m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.3440031772479,972.8438685294241m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.9437701348215,1010.3045831327327m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M689.361199435778,979.530732775107m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M790.5555657148361,1024.56987800356m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M698.6377112511545,1024.3576311073266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M664.1302548507228,969.077497469727m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M649.3709845421836,1005.815134470351m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M819.431164146401,1037.0279271290638m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M676.0960794277489,974.1371275135316m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M645.2884989026934,1036.6596169942059m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M682.4971013572067,1015.9915607417934m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M717.0795019390061,987.2580221965909m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M658.3043308984488,967.0122351199389m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M686.9614078775048,1017.5719695347361m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M709.9172049090266,1028.602567811031m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M711.1060562832281,986.0365554494783m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M744.121729042381,869.3823681455106m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M704.4746796088293,1026.4197550951503m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M729.0745153026655,1023.6376562914811m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M725.5055945236236,1033.7828436652198m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.7922895364463,968.1067722192965L646.3795283986256,963.6068918770179L648.9662859663367,964.5141512239352L651.0639341427013,958.5607798141427L657.066568586044,960.687430377584L653.3887815214694,971.1542039737105L651.6950430348516,970.5517926835455L650.1567151127383,974.9382612770423L646.2517288485542,973.5565655874088L647.7900567697361,969.1628130800091Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer university"
        d="M1075.1651646215469,923.0058741322719L1055.3522898675874,922.0216166945174L1057.0034285048023,845.3084118310362L1025.7225163104013,846.0315265264362L1025.7225163104013,829.6360527910292L1075.1651646215469,829.6360527910292Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M985.6699794149026,975.1088923523203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M955.6071073804051,829.6360527910292L953.694058554247,876.5968394204974"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M943.9710371997207,949.390372112859L929.9959196886048,1032.7590658152476"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M950.6158249378204,829.6360527910292L948.1237337021157,876.4834305727854"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M891.1535340920091,874.2079700417817L893.0460718795657,878.5882569099776"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M864.7203270671889,895.6307718805037L860.142420948483,894.8868534504436"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M950.3278815047815,969.7787501355633L956.429126710631,938.4699343214743"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M941.8449891218916,831.8085229191929L946.6848054304719,903.6182658504695"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1063.7728602495044,1046.309544133488L1075.1651646215469,1018.9661415759474"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1013.1579271722585,973.6626898124814L1075.1651646215469,1006.5746474270709"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M907.7296091197059,916.9484228673391L919.705689216964,920.8032597792335L930.48502907902,926.0616492386907L1075.1651646215469,1002.7718796674162"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M918.7424592720345,906.5231851735152L928.4299807529896,914.7510088020936L938.4291122471914,921.8873997600749L946.1885960642248,926.6359725026414L1075.1651646215469,995.0050711827353"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1017.5425561945885,829.6360527910292L1014.1716458285227,919.9667447456159"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M880.0247176811099,829.6360527910292L884.747778845951,840.5181652391329L905.1073516765609,888.1052269362845L910.1877782503143,897.7251879516989"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M910.1877782503143,897.7251879516989L910.9608866432682,899.1890938952565L918.5365599952638,910.945069343783"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M942.5960087021813,1046.309544133488L1013.8600358134136,976.4833047003485L1014.2852454306558,969.2835034527816"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M946.6848054304719,903.6182658504695L945.9124859254807,918.2240047636442L943.1987176928669,931.0932188024744"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M913.7361879916862,1046.309544133488L858.4912823121995,1026.1898210188374"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M859.1642021676525,888.0126272044145L868.4407139820978,890.3016090011224"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M911.3505963822827,897.9728138549253L905.9222710318863,888.0625686333515L885.5342983007431,840.1852200902067L880.9303589398041,829.6360527910292"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M918.7424592720345,906.5231851735152L911.5351957343519,898.3099180120043L911.3505963822827,897.9728138549253"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M909.0052379658446,913.0998264662921L893.52098132018,909.3511104816571L876.1086870105937,905.8645843015984L858.4912823121995,902.5299612344243"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M969.865435006097,863.7056747688912L968.3775957953185,916.7777903606184"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M909.0052379658446,913.0998264662921L921.4988273531199,917.6351146185771L932.1077678157017,922.9933888386004L1075.1651646215469,998.8442582455464"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M956.429126710631,938.4699343214743L1014.2852454306558,969.2835034527816L1075.1651646215469,1000.8065085890703"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M959.852103561163,903.4403499057516L969.865435006097,863.7056747688912"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M934.5596258575097,976.6601783377118L921.3457834469154,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M956.429126710631,938.4699343214743L943.1987176928669,931.0932188024744"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,829.7380173997954L869.8638645317405,848.7200558977202M882.2091433303431,869.3261838867329L884.5560795199126,873.2445146488026L893.95329091046,886.5320717557333L895.5050298962742,888.2821028255858L905.1333849178627,896.6462464174256"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M869.8638645317405,848.7200558977202L882.2091433303431,869.3261838867329M905.1333849178627,896.6462464174256L905.9151710569859,897.3246166217141L917.8636401398107,904.3049589251168L934.3687154175714,910.2230018614791L958.9235846046358,916.2461244119331L974.2950305361301,918.5569461672567L1075.1651646215469,923.3773116283119"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M862.5374791901559,909.4572356911376L858.4912823121995,908.8121608621441"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M941.9317665947601,829.6360527910292L941.8449891218916,831.8085229191929"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M889.4313957039267,870.3312577870674L891.0123234773055,873.4994245655835"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M918.3314496055245,918.2593797892332L909.0052379658446,913.0998264662921L903.3213135143742,912.6680427403189L887.8654567673802,908.6852267738432L874.2587490733713,906.169434318319L858.4912823121995,903.2228970807046"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M956.429126710631,938.4699343214743L958.7610740642995,918.5350968865678L958.9235846046358,916.2461244119331L959.852103561163,903.4403499057516"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M943.1987176928669,931.0932188024744L934.5596258575097,976.6601783377118"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M943.1987176928669,931.0932188024744L938.918221638538,928.8885261365213L919.0824691867456,918.6412219591439L918.3314496055245,918.2593797892332"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M935.4171450631693,1046.309544133488L950.3278815047815,969.7787501355633"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,906.0123273157515L875.3434674795717,909.2023270959035L892.6705620884895,912.9510431615636L907.7296091197059,916.9484228673391"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1014.2852454306558,969.2835034527816L1012.7895173570141,962.1117864800617L1014.1716458285227,919.9667447456159"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M959.852103561163,903.4403499057516L962.602949439548,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M918.5365599952638,910.945069343783L924.7869046768174,918.8191375103779L930.9883384192362,925.5372670926154L937.9045029813424,931.9931993237697L945.5724760098383,937.2869552243501L963.7002900242805,947.2221005829051L1013.1579271722585,973.6626898124814"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1014.1716458285227,919.9667447456159L970.2622447218746,916.8839154564776L968.3775957953185,916.7777903606184L958.9235846046358,916.2461244119331"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M969.865435006097,863.7056747688912L972.0246163010597,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M948.1237337021157,876.4834305727854L946.6848054304719,903.6182658504695"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M874.1057051662356,829.6360527910292L897.9142880886793,888.0552855068818L901.3617204073817,895.8409418277442"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M901.3617204073817,895.8409418277442L909.0052379658446,913.0998264662921"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,1038.3201337163337L1072.120853108354,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1055.3522898675874,922.0216166945174L1075.1651646215469,923.0058741322719"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1014.1716458285227,919.9667447456159L1055.3522898675874,922.0216166945174"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M896.1140499766916,834.7634141440503L897.7304776236415,788.3600314604118L906.6448907125741,788.6721698748879L907.354099329561,768.2759759575129L904.2569324458018,768.1698485868983L905.5183613412082,731.8159260605462L908.7220278503373,731.92205399042L909.4233476063237,711.8732110522687L901.0540548218414,711.5829191138037L902.6767935594544,664.902984698303L906.5533799240366,665.0372066088021L912.321715189144,665.2505049845204L932.2781672161072,665.9445050312206L932.2568672914058,666.6041691759601L931.3851481340826,691.5704340133816L933.1703974111006,691.6339030419476L938.1877130968496,691.8035006150603L937.9116029571742,699.7485699779354L934.0421165674925,810.5904940948822L932.1219677655026,810.5270261522382L926.743342240341,810.3428650712594L925.8574231341481,835.8059494132176L899.076317335479,834.8632977716625Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M895.0009316690266,829.6360527910292L894.825010066852,835.4584376742132L937.1037835758179,839.930308948271L934.9209356987849,901.9025733130984L912.6972249792889,898.2599766561761L883.6488604880869,892.0599626875482L880.9698032457381,849.7729935869575L858.4912823121995,847.6421471885405L858.4912823121995,829.6360527910292Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1024.5533870905638,829.9731602682732L1025.2831067452207,810.8318803608418L1078.0864099022,812.8514090995304L1074.2453234130517,914.170441898983L1050.5684844721109,913.2631759634241L1050.625284272246,911.881467982661L1051.1072936886922,899.1318694315851L1051.844113319181,879.9200300388038L1052.893331850879,852.083837501239L1053.1481420658529,845.3510703989305L1034.81521766074,844.6570883151144L1035.360337967053,830.3914232281968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M837.8335105301812,1085.4979942976497L844.6581643009558,1070.2121737361886L860.185020797886,1076.9509649677202L866.6830757185817,1061.3176251444966L854.7211955729872,1056.0031555304304L859.6675115078688,1040.568489367608L906.5391799733043,1056.1019955463707L880.4814827395603,1105.4115433609113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M981.0628845086321,880.0760971871205L982.9617333849892,834.3742841761559L1011.9390981271863,835.9609770984389L1008.8214202038944,910.7047270066105L981.9480147296563,909.5779271037318L983.1747326366603,880.1541307577863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M856.5001337602735,1006.7359138643369L869.9719419293106,970.0409395438619L902.1947841430083,981.3806218835525L912.2507154392079,984.9097677939571L910.2240670118481,990.5645128730685L910.9679866181687,990.8412675256841L899.6861263001338,1022.3340022773482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M866.9741746950895,964.6702164681628L876.2222866108641,925.6787670403719L895.6888403622434,932.3896068916656L889.6301950057968,950.1061928924173L917.877840090543,959.8363540545106L911.0318863941357,979.8491051769815L903.5911125652492,977.2906807907857L902.1947841430083,981.3806218835525L869.9719419293106,970.0409395438619L871.3177816402167,966.1726043578237Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M824.9076115507632,882.9102759640664L824.9999112263322,881.7480963356793L826.9555599028245,853.6778095299378L841.1996875777841,854.6839261520654L841.4757977183908,850.7437354046851L854.4521854072809,851.6582926842384L858.4415824860334,851.9423360479996L858.3066829619929,853.9264774578623L858.1441724216565,856.1301535097882L868.6892131082714,856.874076097738L872.4734997972846,857.1435529324226L870.4255514442921,886.4186630672775L854.5507961716503,885.3064254731871L854.664395772852,883.6552361277863L854.7850953480229,881.9749138602056L851.1065193973482,881.7200042544864L840.0447583077475,880.933425986208L839.8317590570077,883.966329802759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M967.4277769131586,1027.0252828095108L982.3030134802684,1012.207525848411L983.684353065677,1012.9087741547264L996.277342104353,1019.2512185107917L995.7535217246041,1020.2999685923569L1004.1157145332545,1024.5168162817135L1017.431323251687,1031.2275604577735L1012.6262179324403,1040.8306760983542L996.723851644434,1072.6353093953803L980.5737751182169,1064.4929875829257L992.8969651050866,1039.8662034384906L986.8028198732063,1036.7907104361802L980.9634848581627,1033.8494308362715L975.343460181728,1031.0080307899043L969.9648346565664,1028.3008444556035Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M996.723851644434,1072.6353093953803L1012.6262179324403,1040.8306760983542L1021.9027297459543,1045.5000952333212L1015.3478750251234,1058.6104506463744L1039.7402336699888,1070.9061332414858L1037.4863860430196,1075.4277927218936L1038.6421042000875,1076.0083461184986L1033.8582988055423,1091.3513767756522Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M954.4166782349348,1010.0247079716064L955.7349069304764,1007.5443268595263L959.0442841798067,1001.3360871924087L957.4854452181607,1000.50686488254L955.713607005775,999.5642356355675L959.4410938955843,992.5985552812926L960.4966235151514,990.6206961460412L960.0012030359358,990.3522649332881L958.3500643996522,989.4731006114744L961.6878415485844,983.2294700681232L962.8711707191542,981.0185513887554L962.3962612785399,980.7636454254389L961.1490323320031,980.1040111742914L972.1476825345308,959.4888485358097L984.7406715722755,966.2142217447981L984.7122716717422,966.2641626107506L973.9684316851199,986.3830192093737L982.6643233206123,991.0181407947093L986.3634103080258,993.3424632260576L971.5023736925796,1007.9334471095353L968.5046064592898,1006.3395105483942L964.1112996898592,1014.5672157090157L963.8486006138846,1015.0562165938318Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1031.2289413865656,964.5776177570224L1035.070027875714,950.6877972199582L1036.019846757874,929.4139484721236L1057.5848375707865,930.3773960587569L1057.577737595886,930.6042119925842L1056.8756289537996,946.2232804559171L1054.6438701367006,946.1306814979762L1054.190260621719,956.1729791127145L1056.4149194639176,956.2718205521815L1056.1743091978133,961.8704054816626L1049.7038652915508,974.3504163818434Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1022.8880485026166,878.8005082686432L1023.9443670101464,850.9851202717982L1052.893331850879,852.083837501239L1051.844113319181,879.9200300388038L1036.614666887559,879.3321770885959Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M983.684353065677,1012.9087741547264L986.0731002185494,1008.1540179364383L1011.9390981271863,983.0453135743737L1014.9368653595448,983.1587206823751L1022.8667485779151,987.1768685355783L1004.1157145332545,1024.5168162817135L995.7535217246041,1020.2999685923569L996.277342104353,1019.2512185107917Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M982.9617333849892,834.3742841761559L983.9754520421848,810.1025192458183L1012.9670167323202,811.3208956168965L1011.9390981271863,835.9609770984389Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M973.8059211447835,934.9979889402166L974.0962312351912,926.9116892674938L974.8827506909147,926.9470642483793L1005.4552431553602,928.0603356007487L1006.6811721753329,928.1019532172941L1005.9790635341778,947.4489159658551L1005.8307529445738,951.5524003463797L1004.5480241244659,950.8927633152343L974.5569407269359,935.3808706267737Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1014.2071457039565,1041.0356395267881L1020.634200874716,1028.2519444618374L1030.2373115411028,1033.1128102126531L1039.10991366487,1037.6126454370096L1044.3323397412896,1040.2563622975722L1051.7313026040792,1044.012290458195L1045.3034585472196,1056.8032394112088Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1049.7038652915508,974.3504163818434L1056.1743091978133,961.8704054816626L1056.4149194639176,956.2718205521815L1056.5427190149203,953.5365132438019L1072.594184776768,954.2668997049332L1071.1836564056575,985.7098598796874Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1021.6834194073454,910.7681940319017L1022.8880485026166,878.8005082686432L1036.614666887559,879.3321770885959L1036.437956398353,884.1650551869534L1042.483190689236,884.3991557634436L1042.1636918140575,892.8174072154798L1034.879117436707,892.5344059751369L1034.651918235235,898.5086429822259L1034.1699088197201,911.2436764789745Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1004.1157145332545,1024.5168162817135L1022.8667485779151,987.1768685355783L1027.4233547728509,989.4731006114744L1019.3585720295087,1005.5529464157298L1028.097063514404,1009.9747674204409L1020.7691004015505,1024.5802822625265L1017.431323251687,1031.2275604577735Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M816.8215288817883,966.1507552266121L820.0670063551515,956.6266092872247L858.5480821123347,969.8286909763701L857.2937531908974,973.528473878745L860.7798409285024,974.718729827553L859.7172113321722,977.8649998079054L856.1522349836305,976.6466527055018L855.2387048620731,979.3320101243444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1030.2373115411028,1033.1128102126531L1031.732250727713,1030.1434375746176L1047.152607598342,999.4726778222248L1056.0323096988723,1003.9652518797666L1039.10991366487,1037.6126454370096Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.5427190149203,953.5365132438019L1056.8756289537996,946.2232804559171L1057.577737595886,930.6042119925842L1073.628414472565,931.3335604332387L1072.594184776768,954.2668997049332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1044.3323397412896,1040.2563622975722L1061.2555246595293,1006.6225071423687L1068.6536986371502,1010.3649279647507L1051.7313026040792,1044.012290458195Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M975.6692701475695,986.6379249664024L979.0567471217364,980.0405447836965L985.5058911023661,983.3782518645748L992.2808450507,970.1761959791183L1004.5693240491673,976.5332454917952L1005.7526532197371,977.1491818958893L987.6106392554939,994.1290287435986L986.3634103080258,993.3424632260576L982.6643233206123,991.0181407947093Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M839.1233393261209,1054.5215955362655L847.6133316848427,1036.4723406489938L859.6675115078688,1040.568489367608L854.7211955729872,1056.0031555304304L852.9635573094711,1060.934750416316L849.2928702216595,1059.2347031226382Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1024.95019680541,1026.6996295959689L1040.3784425370395,996.042380200699L1047.152607598342,999.4726778222248L1031.732250727713,1030.1434375746176Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1024.610186890699,961.2679933812469L1027.8769642887637,948.6464594518766L1028.7415834683925,929.0872502336279L1036.019846757874,929.4139484721236L1035.070027875714,950.6877972199582L1031.2289413865656,964.5776177570224Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1019.756170630455,958.5045962757431L1021.0736104398966,928.7470262548886L1028.7415834683925,929.0872502336279L1027.8769642887637,948.6464594518766L1024.610186890699,961.2679933812469Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M947.422413947992,1047.7827825010754L947.5139247374609,1045.2524746018462L967.4277769131586,1027.0252828095108L969.9648346565664,1028.3008444556035L957.6408557826653,1052.9339122152887Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1039.10991366487,1037.6126454370096L1056.0323096988723,1003.9652518797666L1061.2555246595293,1006.6225071423687L1044.3323397412896,1040.2563622975722Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1034.1699088197201,911.2436764789745L1034.651918235235,898.5086429822259L1051.1072936886922,899.1318694315851L1050.625284272246,911.881467982661Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M974.4930409509689,1061.431030972395L986.8028198732063,1036.7907104361802L992.8969651050866,1039.8662034384906L980.5737751182169,1064.4929875829257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M968.6395059842616,1058.476236356888L980.9634848581627,1033.8494308362715L986.8028198732063,1036.7907104361802L974.4930409509689,1061.431030972395Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1019.3585720295087,1005.5529464157298L1027.4233547728509,989.4731006114744L1036.1689462326467,993.909497898072L1028.097063514404,1009.9747674204409Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M963.0194813087583,1055.648371880874L975.343460181728,1031.0080307899043L980.9634848581627,1033.8494308362715L968.6395059842616,1058.476236356888Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M957.6408557826653,1052.9339122152887L969.9648346565664,1028.3008444556035L975.343460181728,1031.0080307899043L963.0194813087583,1055.648371880874Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1020.7691004015505,1024.5802822625265L1028.097063514404,1009.9747674204409L1036.1689462326467,993.909497898072L1040.3784425370395,996.042380200699L1024.95019680541,1026.6996295959689Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M979.0567471217364,980.0405447836965L985.8388010440394,966.8384825414978L992.2808450507,970.1761959791183L985.5058911023661,983.3782518645748Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1064.2201586756855,866.0019477414899m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M883.7695600641891,998.7880750363693m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M886.514094854705,954.9712751796469m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1037.8926623929292,865.4421857548878m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1018.1279096901417,1007.763857270591m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1043.881096883677,1017.0548772988841m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1056.4945969609544,1025.3106612414122m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M993.6211625579745,981.70939852437m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1036.0545577462763,1013.0856468598358m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1042.6386012537405,905.1872553797439m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M971.9899053107947,1044.7489099265076m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M966.4929468687624,1041.9709801720455m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1027.0620449334383,1017.2775286873803m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M785.8672155383974,950.347574301064L803.0381106967106,902.817123843357L877.7243257714435,919.3216708921827L876.2222866108641,925.6787670403719L866.9741746950895,964.6702164681628L866.4282655054703,966.9373238291591L850.3412998672575,963.3166104787961L853.0203571096063,951.3037359206937L845.572483307682,949.6390366074629L843.8574448954314,957.3132971073501L817.4100379226729,951.3755260682665L818.9688768843189,944.3733819634654L807.0062078507617,941.6807279363275L805.4260689644143,948.7390583758242L798.2401053505018,947.1305420775898L795.7953472845256,954.2023926409893L787.2627550754696,950.8865206916817Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer university"
        d="M1248.2933223238215,829.6360527910292L1247.4436919791624,852.52290816186L1160.3624982805923,848.5473408056423L1159.7534782011062,864.3008121955208L1080.7299672719091,862.664184147492L1076.7539812559262,923.084947662428L1075.1651646215469,923.0058741322719L1075.1651646215469,829.6360527910292Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1284.9441822962835,918.5673505864106m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,923.0058741322719L1076.7539812559262,923.084947662428"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1076.7539812559262,923.084947662428L1085.47038393002,923.5240138266236"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1257.7339224508032,838.6193372108974L1291.839046932757,839.3580594104715"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1100.8134299619123,830.8731539184228L1151.844894906506,833.6511682644486L1160.9155074469745,834.1048064567149"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,998.8442582455464L1164.6863830713555,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1148.3532849662006,1046.309544133488L1149.8813573690131,1045.0964111746289L1154.9483728790656,1042.9416950773448"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1178.3420017044991,834.9049159470014L1239.0388993201777,838.1303238817491"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1160.9155074469745,834.1048064567149L1169.9017091719434,834.4377518980764L1178.3420017044991,834.9049159470014"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1239.0388993201777,838.1303238817491L1247.9690901311114,838.3675473746844"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1247.9690901311114,838.3675473746844L1248.0961007950827,838.3706687348895L1257.7339224508032,838.6193372108974"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1089.3043704433367,829.6360527910292L1089.2688705688342,830.4975496460684"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,1018.9661415759474L1081.38868717663,1004.0287180519663"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1169.3345000557601,848.9572790265083L1169.9017091719434,834.4377518980764"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1154.9483728790656,1042.9416950773448L1159.0095585938543,1041.2551688766107L1161.1277178097516,1039.7101398902014L1161.9781370423734,1037.2516183024272L1166.2728330474347,927.3507551895455L1169.3345000557601,848.9572790265083"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1291.839046932757,932.8879775307141L1243.8653045669198,931.0932188024744L1166.2728330474347,927.3507551895455L1085.47038393002,923.5240138266236"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,1000.8065085890703L1081.38868717663,1004.0287180519663"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1089.2688705688342,830.4975496460684L1100.8134299619123,830.8731539184228"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1081.38868717663,1004.0287180519663L1085.47038393002,923.5240138266236"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1089.5189474662766,829.6360527910292L1088.4460623525083,862.8233730341308"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1088.4460623525083,862.8233730341308L1086.377602959983,926.840939306654L1081.5448866263032,1013.0856468598358L1080.991877459921,1019.5560635402799L1080.1414582291618,1024.559473744128L1078.2915202919394,1030.1153460959904L1075.1651646215469,1038.3201337163337"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1248.0961007950827,838.3706687348895L1247.4436919791624,852.52290816186L1243.8653045669198,931.0932188024744L1239.4940866082907,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,923.3773116283119L1168.122770984657,927.8189534167759L1291.839046932757,933.9492259537801"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,995.0050711827353L1171.9496575240046,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1089.2688705688342,830.4975496460684L1087.9033087054268,862.8129685320891"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1087.9033087054268,862.8129685320891L1087.199622293003,879.4663948467933L1085.47038393002,923.5240138266236"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1169.9017091719434,834.4377518980764L1170.08709740825,829.6360527910292"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1081.38868717663,1004.0287180519663L1154.9483728790656,1042.9416950773448L1161.3935724310577,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,1006.5746474270709L1150.0288790725172,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,1002.7718796674162L1157.280320232734,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1099.4384014643729,866.7739614113234L1100.8134299619123,830.8731539184228L1102.528468374163,773.0028041810729L1162.7015456091613,774.9942514277063L1160.9155074469745,834.1048064567149L1160.3624982805923,848.5473408056423L1159.7534782011062,864.3008121955208L1159.6114786993712,868.7726648640819L1135.4881302183494,867.9715188313276L1127.8422460025176,867.7093255664222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1177.526293464005,847.7888509891927L1178.3420017044991,834.9049159470014L1180.9918701620772,776.4758711606264L1241.7179565625265,779.4526356915012L1239.0388993201777,838.1303238817491L1238.5008789896965,845.7693324307911L1238.2523798644543,850.7655848963186L1228.657158059068,850.2973814648576L1228.5151585582644,853.2179299090058L1221.3149949954823,852.8631358812563L1221.456994496286,849.9436277430505L1206.6243577804416,849.2132302909158Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1257.1099135354161,850.7728680619039L1257.7339224508032,838.6193372108974L1259.5270605878904,794.2771329195239L1262.84353781119,794.4123927843757L1263.1054480010644,788.4172568381764L1265.2172961290926,788.5015342114493L1265.4792063180357,782.3149480889551L1293.0965313985944,783.5052368659526L1292.7912324722856,790.5710115833208L1305.994030477479,791.1453460692428L1306.050830276683,789.9051164691336L1311.27404523734,790.1246537715197L1311.0042461873963,796.4100766405463L1315.4054418178275,796.5952785527334L1314.5834224876016,815.8635335564613L1314.3988231364638,820.1512566492893L1313.662003505975,839.8304253965616L1312.9882947634906,853.1887972620316L1277.7250854671001,851.665575849358Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1024.5533870905638,829.9731602682732L1025.2831067452207,810.8318803608418L1078.0864099022,812.8514090995304L1074.2453234130517,914.170441898983L1050.5684844721109,913.2631759634241L1050.625284272246,911.881467982661L1051.1072936886922,899.1318694315851L1051.844113319181,879.9200300388038L1052.893331850879,852.083837501239L1053.1481420658529,845.3510703989305L1034.81521766074,844.6570883151144L1035.360337967053,830.3914232281968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1064.3455915674567,1074.4778907313012L1069.2067078035325,1059.007891396992L1069.7384170433506,1059.2908858424053L1082.2107065068558,1065.853856756352L1090.2044895002618,1070.0561108682305L1096.6607334576547,1057.6823951941915L1094.8888952462003,1056.7616225667298L1108.1548041403294,1031.36281569954L1114.929758087732,1034.9200276238844L1101.5715495171025,1060.5029758973978L1126.0846077390015,1073.407300055027L1099.204891175963,1124.878698963672L1075.7899624239653,1112.5477380584925L1081.9842961914837,1100.6849417774938L1085.647883305326,1093.6756655666977L1082.6146161966026,1092.0807083025575L1082.5436164466664,1084.7395304040983L1083.521835227497,1082.8542946893722L1073.1116940667853,1077.3837788826786L1072.4095854256302,1078.7227967483923L1064.614601733163,1074.6266705701128Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1170.4681294010952,1033.7433075313456L1172.1760678384453,998.2252024803311L1180.1982507323846,998.6080806753598L1180.1059510568157,1000.5994631140493L1192.4299299307168,1001.1873057829216L1192.302130379714,1003.8237535301596L1200.40241299849,1004.376221341081L1233.1072646286339,1005.6517871520482L1232.0801349077374,1033.0212528388947L1205.7242387244478,1031.7384090879932L1205.4126287093386,1038.1443020771258L1204.555109503679,1055.96778120799L1176.5559635432437,1041.8013911633752L1175.3442344721407,1041.368575031869L1174.2311161644757,1040.7235124749132L1172.8000767538324,1039.4271446429193L1172.062468238175,1038.3638315200806L1171.524447908625,1037.2016779487021L1170.921738917008,1035.4797759256326Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1204.6403092043474,920.3704360914417L1205.4126287093386,892.5905900453217L1206.4973471146077,853.7912187506445L1238.4582791402936,854.6839261520654L1236.5728413285688,922.2910909964703L1216.4964786116034,921.7313335547224L1216.5319784870371,920.7044178326614Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1260.0934808179736,1086.0296472660266L1260.3632798679173,1084.1870689974166L1261.9434187542647,1080.9409671910107L1262.7086382852867,1061.5943769766018L1279.0220142379403,1062.2394375898875L1280.347342910245,1028.9604741209187L1295.845799506642,1029.5764058646746L1295.9380991812795,1027.2021551569924L1306.6109394179657,1027.6204062155448L1304.6403019065037,1078.9922649594955L1300.962514841929,1078.8570106434636L1296.1929093962535,1078.6728566898964L1291.4666926870123,1078.481419808697L1291.0974939865991,1085.0797467282973L1284.5284393141046,1098.2753413147293Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1254.034835461527,922.603223380167L1257.1099135354161,850.7728680619039L1277.7250854671001,851.665575849358L1277.0450656358153,867.5751075795852L1284.3864398123696,867.9007682693191L1283.7916196826845,881.8188467565924L1283.1108109671623,897.7574417479336L1282.4520910615101,913.220517816022L1281.9984815465286,923.8361461549066Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1172.5799775291234,989.9048795513809L1173.2323863450438,971.9553380818106L1201.614142069593,973.3370340927504L1201.8839411213994,966.3983786865138L1216.7157889511436,966.9799816459417L1234.588792750612,967.6812345273793L1233.1072646286339,1005.6517871520482L1200.40241299849,1004.376221341081L1200.50891262386,1001.5847498243675L1200.912822314538,991.2730463808402Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1247.5430916296318,1077.9435237562284L1250.1937489723787,1021.4340334832668L1276.4423566451296,1022.6742216632701L1278.2141948575154,1022.7304046819918L1278.1502950815484,1024.5875652451068L1279.3691241284832,1024.6302227079868L1296.009098932147,1025.2680037808605L1295.9380991812795,1027.2021551569924L1295.845799506642,1029.5764058646746L1280.347342910245,1028.9604741209187L1279.0220142379403,1062.2394375898875L1262.7086382852867,1061.5943769766018L1261.9434187542647,1080.9409671910107L1260.3632798679173,1084.1870689974166Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1176.676663119346,891.7759209675714L1177.6469930382445,856.9666762477718L1177.526293464005,847.7888509891927L1206.6243577804416,849.2132302909158L1206.4973471146077,853.7912187506445L1205.4126287093386,892.5905900453217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building_part"
        d="M1200.40241299849,1004.376221341081L1200.50891262386,1001.5847498243675L1200.912822314538,991.2730463808402L1201.614142069593,973.3370340927504L1201.8839411213994,966.3983786865138L1216.7157889511436,966.9799816459417L1234.588792750612,967.6812345273793L1233.1072646286339,1005.6517871520482Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1133.8724914574996,917.0680737048388L1134.4823004230857,898.4233265030198L1137.9478771230206,898.5440181102604L1138.138787562959,892.8174072154798L1134.673210863024,892.7039986299351L1135.4881302183494,867.9715188313276L1159.6114786993712,868.7726648640819L1157.9887399645522,917.8692140635103Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1174.6563257807866,917.0191729292274L1175.358434422873,891.7332626883872L1176.676663119346,891.7759209675714L1205.4126287093386,892.5905900453217L1204.6403092043474,920.3704360914417L1204.6190092787147,921.199667989742L1178.3767126947641,920.4630353935063L1177.8244924154133,920.2861603223719L1176.775273882784,919.7544946447015L1175.87515482679,919.003295710776L1175.1525351461023,918.0814642226323Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1101.5715495171025,1060.5029758973978L1114.929758087732,1034.9200276238844L1139.4428163086995,1047.8243993981741L1126.0846077390015,1073.407300055027Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1094.8391954209656,977.6454684496857L1095.7038146015257,958.7022790890187L1096.0367245413363,958.7095621381886L1096.3207235420123,952.5158448535949L1111.5919809378684,953.2181396335363L1112.166290028952,953.2462314241566L1111.9319908535108,958.490030173678L1117.530715605244,958.7376539064571L1120.3091724980623,958.872910562437L1120.6562823876739,951.1976113519631L1129.0468750968575,951.5804921411909L1128.6784652825445,959.5960134128109L1128.082856265828,959.5606385986321L1127.1898371847346,979.1332874679938L1122.7255306653678,978.9356052377261L1116.6305965483189,978.6515670805238Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1278.5755046978593,1014.3830600469373L1279.6176232546568,987.4390572831035L1284.7272386150435,987.729337671306L1304.4777913670987,988.4878121777438L1308.1129785794765,988.6293108435348L1307.08505997248,1015.2258062534966L1295.38509001676,1014.7794629042037L1283.7064199838787,1014.3185535427183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1104.1086072605103,916.083815427497L1104.96612646617,890.0331739014946L1127.3957364615053,890.7770928521641L1127.303436785005,893.3417918398045L1134.6448109624907,893.5904583451338L1134.4823004230857,898.4233265030198L1133.8724914574996,917.0680737048388Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1069.7384170433506,1059.2908858424053L1089.4534699199721,1021.5193484481424L1101.925759382546,1028.0885976711288L1082.2107065068558,1065.853856756352Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1216.7157889511436,966.9799816459417L1217.3397978665307,953.9266769615933L1218.0766174979508,938.6260001524352L1235.6514223469421,939.4833217109554L1234.588792750612,967.6812345273793Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1205.4126287093386,1038.1443020771258L1205.7242387244478,1031.7384090879932L1232.0801349077374,1033.0212528388947L1230.294096746482,1070.140384817496L1220.1529657505453,1064.6272017573938L1221.2376841558143,1042.0354864164256L1216.6313781375065,1041.8221996324137L1216.7796887271106,1038.69676715089L1210.840954059735,1038.413771866355Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1283.1108109671623,897.7574417479336L1283.7916196826845,881.8188467565924L1311.9611650435254,883.0382509701885L1311.27404523734,898.9758027140051Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1279.6176232546568,987.4390572831035L1279.8156336694956,981.6709025278687L1280.4467425597832,969.4250025078654L1287.5972062973306,969.8005992523395L1305.3637104723603,970.7151408265345L1304.4777913670987,988.4878121777438L1284.7272386150435,987.729337671306Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1130.244404219091,991.6632079770789L1130.7406135844067,978.2905368735082L1154.9554728548974,979.1977942995727L1155.9336916357279,979.2258859849535L1155.2741828439757,997.1764490595087L1142.3837837418541,996.6874469136819L1139.8112261230126,996.5948486323468L1139.4428163086995,996.4034094810486L1133.8795914314687,993.5339024597779Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1097.808562753722,915.8778078607284L1098.9989918991923,879.8139043767005L1112.690899294801,880.2675395486876L1131.2928338646889,880.8834845032543L1131.0664235493168,887.6235002237372L1126.7717275442556,887.4882421749644L1126.7433276437223,888.2893859515898L1105.0513261668384,887.5662756641395L1104.96612646617,890.0331739014946L1104.1086072605103,916.083815427497Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1093.9390763649717,997.3814137778245L1094.8391954209656,977.6454684496857L1116.6305965483189,978.6515670805238L1104.3216065103188,1002.7323433556594Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1098.9989918991923,879.8139043767005L1099.4384014643729,866.7739614113234L1127.8422460025176,867.7093255664222L1127.4872472509742,878.4602818214335L1112.768210134469,877.9712713020854L1112.690899294801,880.2675395486876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1082.2107065068558,1065.853856756352L1101.925759382546,1028.0885976711288L1108.1548041403294,1031.36281569954L1094.8888952462003,1056.7616225667298L1096.6607334576547,1057.6823951941915L1090.2044895002618,1070.0561108682305Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1250.1937489723787,1021.4340334832668L1250.7601692024618,1009.1882037012838L1277.0663655605167,1010.5563667281531L1276.4423566451296,1022.6742216632701Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1130.0527048930526,978.2624451871961L1130.520514357835,965.689842632506L1141.4694647360593,966.1080974051729L1155.4232823196799,966.6251934417523L1154.9554728548974,979.1977942995727L1130.7406135844067,978.2905368735082Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1279.3691241284832,1024.6302227079868L1279.7170229051262,1015.5587429995649L1294.56307068374,1016.1330588459969L1294.4920709356666,1017.8768146391958L1295.272279300727,1017.8976231771521L1295.38509001676,1014.7794629042037L1307.08505997248,1015.2258062534966L1306.6109394179657,1027.6204062155448L1295.9380991812795,1027.2021551569924L1296.009098932147,1025.2680037808605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1172.1760678384453,998.2252024803311L1172.5799775291234,989.9048795513809L1200.912822314538,991.2730463808402L1200.50891262386,1001.5847498243675L1192.4299299307168,1001.1873057829216L1180.1059510568157,1000.5994631140493L1180.1982507323846,998.6080806753598Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1195.654107477516,962.8692233539186L1196.1148169683293,953.3731646933593L1196.8729365244508,937.599086932838L1205.4623285345733,938.0163029609248L1204.7255089031532,953.3096980582923L1204.2434994876385,963.2874782965519Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1117.530715605244,958.7376539064571L1118.6714449254796,933.771310787648L1129.8404945284128,934.2821665997617L1129.0468750968575,951.5804921411909L1120.6562823876739,951.1976113519631L1120.3091724980623,958.872910562437Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1141.0087552443147,943.3038116334938L1141.3069541966543,935.0895476052538L1157.4073308976367,935.6846789065748L1156.8906104927883,949.6598453503102L1143.3691024985164,949.1500311074778L1143.5813128622249,943.3953701881692Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1173.2323863450438,971.9553380818106L1173.5652962848544,965.0593391242437L1188.8728424422443,965.8032500250265L1201.8839411213994,966.3983786865138L1201.614142069593,973.3370340927504Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M1248.4526773188263,829.6360527910292L1248.0961007950827,838.3706687348895"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1178.7104115216061,953.7279535769485L1179.5253308760002,936.755290850997L1190.2470820527524,937.2796721514314L1189.4889624975622,953.047508019954L1189.4250627215952,954.2450505392626Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1104.3216065103188,1002.7323433556594L1116.6305965483189,978.6515670805238L1122.7255306653678,978.9356052377261L1118.7779445508495,986.6452079867013L1109.2537224963307,1005.2689093463123Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1095.831614151597,940.9014395368285L1096.2213238924742,932.2408240032382L1113.0877090105787,933.0138707370497L1113.0735090598464,933.5091200079769L1112.6979992697015,941.666161798872L1110.5932511184365,941.5746032181196Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1134.6164110628888,959.6241051773541L1135.0771205527708,947.2012918316759L1135.537830043584,934.8700148924254L1141.3069541966543,935.0895476052538L1141.0087552443147,943.3038116334938L1140.3926351899281,959.8436371060088Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1123.5972498208284,1013.6318713692017L1133.8795914314687,993.5339024597779L1139.4428163086995,996.4034094810486L1129.1667857868597,1016.5086530605331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1111.9319908535108,958.490030173678L1112.166290028952,953.2462314241566L1112.6979992697015,941.666161798872L1113.0735090598464,933.5091200079769L1118.6714449254796,933.771310787648L1117.530715605244,958.7376539064571Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1142.1005736263469,1004.4261619318277L1142.3837837418541,996.6874469136819L1155.2741828439757,997.1764490595087L1154.841873254627,1008.9759563347325L1150.6323769502342,1008.81989208702L1146.6500798463821,1006.7650458663702Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1209.8493242152035,1059.0359827573411L1210.840954059735,1038.413771866355L1216.7796887271106,1038.69676715089L1216.6313781375065,1041.8221996324137L1215.6531593557447,1062.1822144738398Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1143.9994225036353,1024.1412224983796L1150.5408661607653,1011.342930289451L1150.6323769502342,1008.81989208702L1154.841873254627,1008.9759563347325L1154.6864626901224,1012.8026505294256L1154.062453773804,1029.3215016862378Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1129.1667857868597,1016.5086530605331L1139.4428163086995,996.4034094810486L1139.8112261230126,996.5948486323468L1142.3837837418541,996.6874469136819L1142.1005736263469,1004.4261619318277L1134.510700323619,1019.2512185107917Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1118.622533986345,1011.066176454071L1128.8906756471843,990.9609170914628L1130.244404219091,991.6632079770789L1133.8795914314687,993.5339024597779L1123.5972498208284,1013.6318713692017Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1108.864012756385,1006.0419479361735L1109.2537224963307,1005.2689093463123L1118.7779445508495,986.6452079867013L1123.8094601863995,989.2462866017595L1113.902628365904,1008.6430192734115Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1189.4889624975622,953.047508019954L1190.2470820527524,937.2796721514314L1196.8729365244508,937.599086932838L1196.1148169683293,953.3731646933593Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1204.555109503679,1055.96778120799L1205.4126287093386,1038.1443020771258L1210.840954059735,1038.413771866355L1209.8493242152035,1059.0359827573411Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1204.7255089031532,953.3096980582923L1205.4623285345733,938.0163029609248L1212.0313832061365,938.3357177055441L1211.3016635505483,953.6353547219187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1215.6531593557447,1062.1822144738398L1216.6313781375065,1041.8221996324137L1221.2376841558143,1042.0354864164256L1220.1529657505453,1064.6272017573938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1173.8201064998284,959.6875717523508L1174.1183054512367,953.5084214545786L1178.7104115216061,953.7279535769485L1189.4250627215952,954.2450505392626L1189.1347526311874,960.4387662787922Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1140.5622457042336,960.6229233737104L1140.782344929874,954.670589055866L1156.684711216949,955.2657186738215L1156.46540087834,961.2180524799041L1141.6753640109673,960.6655812291428Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1211.3016635505483,953.6353547219187L1212.0313832061365,938.3357177055441L1218.0766174979508,938.6260001524352L1217.3397978665307,953.9266769615933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1139.0673065176234,1021.6036229874007L1146.6500798463821,1006.7650458663702L1150.6323769502342,1008.81989208702L1150.5408661607653,1011.342930289451L1143.9994225036353,1024.1412224983796Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1140.782344929874,954.670589055866L1140.9874553196132,949.0647152513266L1143.3691024985164,949.1500311074778L1156.8906104927883,949.6598453503102L1156.684711216949,955.2657186738215Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1096.3207235420123,952.5158448535949L1096.5826337318867,946.7830359195359L1110.3234520666301,947.4208241538145L1111.8546800147742,947.4842908405699L1111.5919809378684,953.2181396335363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1095.5689150746912,946.7330949134193L1095.831614151597,940.9014395368285L1110.5932511184365,941.5746032181196L1110.3234520666301,947.4208241538145L1096.5826337318867,946.7830359195359Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1134.510700323619,1019.2512185107917L1142.1005736263469,1004.4261619318277L1146.6500798463821,1006.7650458663702L1139.0673065176234,1021.6036229874007Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1173.5652962848544,965.0593391242437L1173.8201064998284,959.6875717523508L1189.1347526311874,960.4387662787922L1188.8728424422443,965.8032500250265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1141.4694647360593,966.1080974051729L1141.6753640109673,960.6655812291428L1156.46540087834,961.2180524799041L1156.259501600638,966.6605682191439L1155.4232823196799,966.6251934417523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1174.1183054512367,953.5084214545786L1174.9403247823939,936.535758191254L1179.5253308760002,936.755290850997L1178.7104115216061,953.7279535769485Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1287.441006846726,923.6873630802147L1287.8875163877383,913.4473343132995L1287.9656161135063,911.6328021339141L1294.052661367692,911.8877106402069L1293.5359409647062,923.9495542286895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1129.641695227474,946.9952851897106L1130.1308046178892,933.8139688093215L1135.5662299441174,934.0199758424424L1135.537830043584,934.8700148924254L1135.0771205527708,947.2012918316759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1281.9984815465286,923.8361461549066L1282.4520910615101,913.220517816022L1287.8875163877383,913.4473343132995L1287.441006846726,923.6873630802147L1287.4268068978563,924.0702453916892Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1203.4632911207154,981.620961772278m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1191.5416441652924,874.3713204571977m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1190.0340828020126,904.8054124689661m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1111.4602369572967,968.6207468048669m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1085.8309048842639,1043.6897593121976m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1226.5334766404703,946.7050030962564m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1143.0898368125781,985.4445497700945m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1101.387739052996,902.9555029282346m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1113.4537521665916,872.8408205569722m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1263.6158573171124,1015.9946820246987m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1186.5606172420084,994.7491253032349m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1200.7897560801357,945.6635249461979m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1123.856793353334,942.7398941349238m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1187.5711803538725,969.1763387224637m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1121.3970464495942,999.8014536052942m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1184.4945245087147,945.1641147886403m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1111.548592201434,994.6887803389691m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1137.7396111879498,953.4127012859099m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1131.5223997225985,1005.0181659902446m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1115.2390014436096,947.4561990294605m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1135.630918605253,1010.4668899150565m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1126.2471182784066,1002.2995247836225m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1116.5343524422497,997.2576026059687m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1193.1809495100752,945.3233017786406m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1208.380418269895,945.8227119245566m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1181.6245568264276,956.9668318978511m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1148.6238729031757,957.9448417588137m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1214.6875627515838,946.1306814979762m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1144.8032974526286,1016.473278536927m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1148.8360832678154,952.1652176561765m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1104.0873073358089,950.0000683031976m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1103.079899768345,944.1538495454006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1140.5835456298664,1013.0076147858053m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1181.3484466867521,962.7495733043179m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1148.967038362287,963.6630753739737m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1290.7156731067225,918.5673505864106m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1132.5889737503603,940.9326526932418m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1113.902628365904,1008.6430192734115L1123.8094601863995,989.2462866017595L1118.7779445508495,986.6452079867013L1122.7255306653678,978.9356052377261L1127.1898371847346,979.1332874679938L1126.956326894462,989.962103266269L1128.8906756471843,990.9609170914628L1118.622533986345,1011.066176454071Z"
      />
    </g>
    <g>
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer ocean"
        d="M-8.205035817809403,1079.266935247928L27.024251378141344,1091.9870708780363L8.509094281122088,1142.0933162742294L-8.205035817809403,1136.1848349492066Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M117.50475534051657,1192.028573800344m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M46.80399291589856,1191.847544056829L61.87723989598453,1152.5306846066378L72.33708088193089,1123.2910317550413L75.0437491396442,1116.5231540245004L98.43027798924595,1056.3142414703034L102.04574305098504,1046.309544133488L148.67601236514747,1046.309544133488L164.96729950606823,1096.4109175857157L173.64110233075917,1130.9588575721718L174.88123130239546,1144.7141043175943L174.3850219361484,1164.2019576625898L172.1390631692484,1186.695477154106L157.39162615314126,1232.8725088327192L152.36721049342304,1231.0081212962978Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M61.92693972121924,1185.0443595875986L75.02954918891191,1148.9308763314039L78.26871557347476,1145.4579959390685L83.36413098312914,1142.3253273223527L89.69257539045066,1140.441147676669L129.50529090780765,1153.6220711981878L144.74893729016185,1162.8421481996775L151.82840127684176,1170.2612737002783L156.98771646339446,1180.6933976141736L157.09342720266432,1192.2231287509203L155.12357857637107,1203.9369913446717L151.07028172258288,1218.6565412208438Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M62.62115950137377,1184.462774920743L73.4068104531616,1152.891705737915L105.60914162732661,1163.9044018262066L94.81560181546956,1195.4754208577797Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer pitch"
        d="M84.70997069496661,1155.5499443262815L89.26736577507108,1141.5606271964498L110.08054812159389,1148.349288632162L105.51684195268899,1162.3313092263415Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M-8.205035817809403,1240.031460992992L14.516462039202452,1249.4334917184897L23.64466326404363,1253.2111547831446"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M45.61119711026549,1262.983546542935L23.64466326404363,1253.2111547831446"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M45.825774134136736,1140.6252999869175L80.38293035887182,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M169.63987196050584,1115.0218391292728L169.63040532637388,1115.3537306697108L168.48888711910695,1121.2570276884362L167.56036816351116,1124.5665756864473L165.10141014587134,1128.0249007982202L161.5869225077331,1131.5758206662722L156.9735165135935,1134.800050164573L152.30331071745604,1137.3584164255299L145.4644569940865,1138.8607668923214L140.5394409848377,1139.2925365306437L133.948297502473,1138.1803395063616L123.84976635593921,1135.3525075390935L110.2509475229308,1127.3517552209087L102.1222650045529,1120.5765985744074L97.39525940921158,1114.4891479746439L95.07830089144409,1110.9319768766873L94.00068246014416,1107.0408312059008L92.91675293911248,1102.9239134755917L92.65484274830669,1097.5668187392876L93.10766337905079,1091.053817812819L94.00068246014416,1084.0164406076074L95.40411085728556,1073.3656833088025L98.43027798924595,1056.3142414703034"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M168.14887720439583,1078.6166741307825L169.83551571611315,1108.3944091317244L169.63987196050584,1115.0218391292728"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M196.24742281530052,1054.8971876706928L198.15494943782687,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M61.87723989598453,1152.5306846066378L46.80399291589856,1191.847544056829"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M182.5279044052586,1241.3475587922148L208.46884649340063,1250.862990458496"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M46.80399291589856,1191.847544056829L37.484881250187755,1216.5372525681742"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M152.36721049342304,1231.0081212962978L141.1074389880523,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M98.43027798924595,1056.3142414703034L84.41256062872708,1092.3928330396302"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M37.484881250187755,1216.5372525681742L23.64466326404363,1253.2111547831446L20.093097978271544,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M177.76539893541485,1226.3242615642957L184.7391521828249,1201.8322637854144L189.47956884186715,1173.4012125181034L191.0178967649117,1148.349288632162L188.10532923042774,1115.615914569702L184.0512434914708,1095.0573373176157L168.67033092677593,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M72.33708088193089,1123.2910317550413L61.87723989598453,1152.5306846066378"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M75.0437491396442,1116.5231540245004L72.33708088193089,1123.2910317550413"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M-8.205035817809403,1171.266303975135L20.65399600751698,1182.0958600714803L39.02242028620094,1189.1404205281287"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M178.45330762583762,1239.9731989493594L182.5279044052586,1241.3475587922148"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M174.60354338865727,1262.983546542935L182.5279044052586,1241.3475587922148L208.46884649340063,1170.9656272330321"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M164.4568901900202,1262.983546542935L177.76539893541485,1226.3242615642957"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M166.44803874287754,1224.1841673352756L158.12844578363,1250.01507093478L153.38250692281872,1262.983546542935"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M152.36721049342304,1231.0081212962978L157.39162615314126,1232.8725088327192"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M191.0178967649117,1148.349288632162L191.2088072039187,1096.1060759313405L192.30772556178272,1074.9169473079965L193.5478545324877,1066.6112822955474L194.79508347809315,1060.6309476261958L196.24742281530052,1054.8971876706928L200.25654204562306,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M123.84976635593921,1135.3525075390935L75.0437491396442,1116.5231540245004"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M84.41256062872708,1092.3928330396302L75.0437491396442,1116.5231540245004"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M157.1778380163014,1046.309544133488L168.14887720439583,1078.6166741307825L173.89591254573315,1100.272937611211L177.96419823449105,1121.9301738571376L180.08314633835107,1144.7921349084936L180.2456568768248,1158.7949707945809L179.1191275063902,1172.8269096994773L173.89591254573315,1198.4520054799505L167.69526768941432,1218.9187212144025L166.44803874287754,1224.1841673352756"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M39.02242028620094,1189.1404205281287L46.80399291589856,1191.847544056829"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M157.39162615314126,1232.8725088327192L178.45330762583762,1239.9731989493594"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M61.87723989598453,1152.5306846066378L65.83113710023463,1148.4845415917225L67.61007528658956,1146.2018874809146L71.23816252499819,1142.6020759199746L74.96643829997629,1139.4132239418104L78.55902566295117,1137.0889504840598L82.15871300082654,1135.395164322108L86.39660920575261,1133.9136212952435L90.40809509623796,1133.4891341901384L94.8511016909033,1133.4891341901384L101.32864557299763,1133.686812012922"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M9.58119051065296,1262.983546542935L14.516462039202452,1249.4334917184897L26.237731920555234,1218.0968077057041L33.282484920695424,1198.501944675576L39.02242028620094,1189.1404205281287L45.180465292185545,1179.9776006448083L52.1116186901927,1161.048489405308L64.54840827733278,1126.3945774738677L86.60960845742375,1066.3844708115794L93.7521833339706,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M102.04574305098504,1046.309544133488L98.43027798924595,1056.3142414703034"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M46.80399291589856,1191.847544056829L152.36721049342304,1231.0081212962978"
      />
      <path
        fill="rgb(90, 191, 242)"
        stroke="rgb(90, 191, 242)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="water-layer riverbank"
        d="M-8.205035817809403,1079.2658948311582L27.03214023821056,1091.9891517106444L8.514616484753788,1142.0922758635134L-8.205035817809403,1136.1817137235776Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M168.91094119101763,1196.8029715153389L168.73028627038002,1200.8761367192492L167.69526768941432,1218.9187212144025"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-224.87891812808812,916.366815706715L-78.12716764956713,969.8286909763701L-59.12132338993251,976.7527768849395L-57.26428547780961,971.600550132338L28.85288938973099,1002.9799655084498L26.91854063887149,1008.3163247681223L37.548781025223434,1012.185676864814L30.21371793653816,1032.4750298615545L35.32333329692483,1034.3384303604253L26.33713157195598,1059.1847629267722L21.901224952191114,1057.568989305757L14.339751549996436,1078.5032685841434L-224.87891812808812,991.3479574085213Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M196.96373140625656,1080.6288419347256L210.4142396505922,1043.7646697731689L213.33390715811402,1044.8342246050015L224.21895775943995,1038.917337001767L236.1666379570961,1043.3037623395212L241.9641620097682,1045.436629443895L240.9788432540372,1048.1583750005811L242.57318208832294,1048.7389306798577L242.74358149059117,1048.278023576364L244.91222941782326,1049.071865814738L229.08717396948487,1092.4354900871404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M101.77515511307865,1248.4773712153547L101.99446545355022,1247.8957918705419L110.27934742253274,1225.1402911860496L143.64291895739734,1237.1173178642057L145.535456744954,1237.7904527839273L136.30864475481212,1263.24572486151Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M175.7884503332898,1283.7122493209317L178.99132795631886,1274.9958810498938L178.0635978858918,1274.648391327355L179.62243684753776,1270.389039824251L180.4089563023299,1270.6803487539291L183.44222341198474,1262.3884433405474L191.0817965399474,1265.2162234913558L189.60736839286983,1269.2196424230933L226.34500583726913,1282.8050317442976L223.8363479943946,1289.6434934134595L227.69163443427533,1291.0677819331177L223.89314779546112,1301.4289779309183L218.01831290405244,1299.2535338057205L218.89634314831346,1296.8720927550457L214.92114602029324,1295.4051496284083L215.39605546090752,1294.1296371277422L184.79516309779137,1282.819597162772L183.42802346125245,1286.5400207727216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M197.63665126170963,1222.7879557712004L204.65931544825435,1202.6125632519834L209.39342101942748,1204.270959426649L231.36232152208686,1211.9667864218354L224.3388684494421,1232.1421517203562L207.77068228181452,1226.338827101048L198.25356020219624,1222.9939542156644Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.32104254234582,1259.4618249209598L186.82260041031986,1252.389245340135L225.0196771658957,1265.9881927049719L240.05742427241057,1271.3316322485916L236.02542734332383,1282.755093159154L232.78626095876098,1281.6148286880925L233.84257946535945,1278.623714340385L208.0325924726203,1269.4391645491123L207.08987356629223,1272.1254489477724L191.21590717881918,1265.3077777959406L192.09472631011158,1262.8139629429206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M58.964672363363206,1260.8642714424059L69.07030348386616,1238.0744803268462L82.04590228758752,1243.86427001236L77.53820703178644,1254.0611546980217L72.2660811310634,1265.9455367270857L71.94737114198506,1266.6613248214126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M68.85020425729454,1237.8123010559939L75.78135765623301,1221.8952957713045L73.78232024237514,1221.1576547292061L77.04988652747124,1212.1935931430198L90.09648508112878,1216.892027983442L85.30557970982045,1230.0301499566995L80.86257311608642,1242.2194084189832Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1.1795533951371908,1182.6202228134498L5.643859914503992,1169.6235059662722L20.313986090943217,1174.7121209492907L15.834690736606717,1187.7088282564655Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M91.68372394237667,1275.2934321169741L92.15863338299096,1274.2155897305347L97.19724899344146,1262.8420534785837L103.16438356041908,1249.3773105372675L109.59143873210996,1252.2539944099262L103.12888368591666,1266.824665990658L98.75608795508742,1276.6896331058815L98.1044680243358,1278.1701052337885Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M94.87240161560476,1245.8129259007983L99.38719684630632,1233.4176756273955L103.61010421533138,1221.838073973544L110.54835758730769,1224.3891253434122L110.27934742253274,1225.1402911860496L101.99446545355022,1247.8957918705419L101.77515511307865,1248.4773712153547Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M27.386350103653967,1175.554847666528L30.58922772668302,1166.7322221449576L37.73969146516174,1169.3405160247348L39.85153959132731,1163.5288155972958L45.17336531635374,1165.4712516386062L39.8657395420596,1180.1118125827052Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M43.217716639861465,1229.3923877202906L45.86127400863916,1221.802700498607L62.59985957574099,1229.2727422695607L63.365079106763005,1229.6129515040666L60.119601633399725,1236.940450871829L54.570576707832515,1234.4601509463973Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.65931544825435,1202.6125632519834L211.34196972101927,1183.3651507720351L218.01121292915195,1185.7102167513222L214.04232688900083,1197.1130107385106L212.1221780879423,1196.4325890694745L209.39342101942748,1204.270959426649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M85.30557970982045,1230.0301499566995L90.09648508112878,1216.892027983442L98.49417776521295,1219.967441092711L93.71037236973643,1233.120122762397Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M45.86127400863916,1221.802700498607L47.8950224108994,1215.9494281583466L65.09431746881455,1223.6317170402035L62.59985957574099,1229.2727422695607Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M72.2660811310634,1265.9455367270857L77.53820703178644,1254.0611546980217L84.07255071401596,1256.988815786317L78.81383587792516,1268.865910074208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M78.81383587792516,1268.865910074208L84.07255071401596,1256.988815786317L90.61320548597723,1259.9081525155343L85.57458987552673,1271.2681685239077L85.348179561086,1271.792524522636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M85.57458987552673,1271.2681685239077L90.61320548597723,1259.9081525155343L97.19724899344146,1262.8420534785837L92.15863338299096,1274.2155897305347Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M192.7755350265652,1236.5648686001077L195.19189319387078,1229.6129515040666L195.87191302515566,1229.8532827855088L205.38982398994267,1233.1908696009777L206.25365428440273,1233.4821800924838L203.83019614219666,1240.441376064904Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M93.16446317825466,1234.6089273490943L93.71037236973643,1233.120122762397L98.49417776521295,1219.967441092711L103.61010421533138,1221.838073973544L99.38719684630632,1233.4176756273955L97.76366922352463,1232.815287122503L96.6513398019597,1235.8844508025795Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M195.87191302515566,1229.8532827855088L198.25356020219624,1222.9939542156644L207.77068228181452,1226.338827101048L205.38982398994267,1233.1908696009777Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M41.36777870263904,1234.7223303415813L43.217716639861465,1229.3923877202906L54.570576707832515,1234.4601509463973L52.302529130131006,1239.5976168420166Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M208.2597916731611,1241.2133480398916L211.66856857202947,1231.8373160371557L217.11819384805858,1233.835914246738L213.72361689899117,1243.2119435444474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M113.81513498630375,1193.8243053820916L115.7928724726662,1188.290412651375L121.19279792439193,1190.2318013538606L119.22216041199863,1195.7667329343967Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M16.508399477228522,1219.3223951547407L18.54924785438925,1213.3702829475515L21.943824803456664,1214.5459321546368L19.902187540195882,1220.4990837494843Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M123.7692999728024,1242.8436443656683m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M72.01679311972111,1248.9621940320358m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M80.39949696697295,1225.9632442551665m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M101.0698909284547,1239.61530353548m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M52.98728227708489,1229.333085192833m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M55.47858462482691,1222.717208830174m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M98.71269921772182,1227.3272029170766m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M201.8209032099694,1228.0960551672615m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M47.96286661643535,1234.5912406453863m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M72.33708088193089,1123.2910317550413L101.32864557299763,1133.686812012922L108.22429909557104,1136.1536226733588L144.11072842311114,1149.7028584931977L149.73785307537764,1152.778301406186L154.72676885966212,1156.5133604863659L158.589155273512,1159.9362958706915L162.38764191325754,1164.5993923572823L165.07301024533808,1168.8941825968213L167.12805857229978,1174.0743536236696L169.00639641098678,1182.032395530492L169.13419596198946,1191.7767967986874L168.91094119101763,1196.8029715153389"
        style={{ display: 'none' }}
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M329.89577493909746,1214.716557331849L312.2886257590726,1262.983546542935"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.0711645586416,1046.5987816317938m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M208.46884649340063,1170.9656272330321L208.56430171243846,1170.7076070401818L234.20388930570334,1100.0606930330396L252.548647002317,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M234.20388930570334,1100.0606930330396L355.61267337109894,1144.9055393706076"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M296.4233371205628,1046.309544133488L380.4586415318772,1076.8594081760384L425.1435176897794,1093.0659820116125"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.56430171243846,1170.7076070401818L268.8651784984395,1192.712117104791L329.89577493909746,1214.716557331849"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,1250.862990458496L241.51291915308684,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M329.89577493909746,1214.716557331849L425.1435176897794,1249.457420737017"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1170.454788858071L355.61267337109894,1144.9055393706076"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M224.4027682254091,1165.5555244274437L225.24608748033643,1163.2239768956788L224.8066779151559,1163.061673691962L242.98419175483286,1113.036732032895L243.63660057168454,1113.27706735814L244.5225196769461,1110.8393801194616L250.8430752241984,1113.1636623782106L250.63086485862732,1113.7452530264854L276.0724420361221,1123.0642221248709L275.79554300941527,1123.843490043655L331.2913144752383,1144.1678901389241L331.0507042100653,1144.8202259233221L343.2397835580632,1149.2846147967502L339.9588062092662,1158.305980048608L327.613527411595,1153.7916574692354L327.4502279860899,1154.2598404018208L317.28148597572,1150.5393458087929L316.1683676689863,1153.6147883506492L317.15368642564863,1153.9758094269782L307.430665070191,1180.7142056673765L306.9770555542782,1180.550862468779L305.82212628237903,1183.7116046678275L314.34761851653457,1186.829688961152L314.14171924162656,1187.4039906202815L327.3658171715215,1192.2512195734307L324.08405093755573,1201.2798117096536L310.8465419439599,1196.4325890694745L310.612242766656,1197.0776371364482L309.76892351172864,1196.765517110005L307.3170654689893,1195.8728537620045L281.82657735142857,1186.5394169096835L282.08848754223436,1185.823620541487L250.3973545692861,1174.2085656765848L250.1204555425793,1174.9743026061915Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M248.73832707107067,1096.9852267317474L261.36681598518044,1062.3882176908664L262.73474450595677,1062.8907406656072L263.1315542217344,1061.8139056763612L285.3276539267972,1069.9853623672388L284.93715529982,1071.0549131543376L286.3476836718619,1071.572001365479L286.16387320682406,1072.0609982297756L292.35741808917373,1074.3436767486855L289.75646057073027,1081.4799034283496L289.1608515549451,1083.095671477262L286.8651929618791,1082.2518931045197L285.8159744301811,1085.1296867378987L335.55761057976633,1103.420191028621L334.4594811089337,1106.432189239189L333.86387209314853,1106.2116215392016L333.14125241339207,1108.17488190718L334.01297156885266,1108.5015717088245L328.44264671672136,1123.751933870837L327.81863780040294,1123.5324071329087L327.3516172207892,1124.8214763626456L327.8967375261709,1125.0201948429458L326.6850084550679,1128.3505492545664L301.0951206870377,1118.9473139098845L301.5700301285833,1117.6572031746618L292.0103081976995,1114.1281248410232L291.47149898298085,1115.595106324181L250.3334547933191,1100.4581314059906L251.26118486374617,1097.905994019471Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M196.96373140625656,1080.6288419347256L210.4142396505922,1043.7646697731689L213.33390715811402,1044.8342246050015L224.21895775943995,1038.917337001767L236.1666379570961,1043.3037623395212L241.9641620097682,1045.436629443895L240.9788432540372,1048.1583750005811L242.57318208832294,1048.7389306798577L242.74358149059117,1048.278023576364L244.91222941782326,1049.071865814738L229.08717396948487,1092.4354900871404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M197.63665126170963,1222.7879557712004L204.65931544825435,1202.6125632519834L209.39342101942748,1204.270959426649L231.36232152208686,1211.9667864218354L224.3388684494421,1232.1421517203562L207.77068228181452,1226.338827101048L198.25356020219624,1222.9939542156644Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.32104254234582,1259.4618249209598L186.82260041031986,1252.389245340135L225.0196771658957,1265.9881927049719L240.05742427241057,1271.3316322485916L236.02542734332383,1282.755093159154L232.78626095876098,1281.6148286880925L233.84257946535945,1278.623714340385L208.0325924726203,1269.4391645491123L207.08987356629223,1272.1254489477724L191.21590717881918,1265.3077777959406L192.09472631011158,1262.8139629429206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M253.61443214211613,1216.6298479144461L259.03565751668066,1201.3224680870771L285.397864789702,1210.72663210053L279.9766394132748,1226.0339911635965Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.00767375621945,1230.1227451222949L287.8852227078751,1224.9498987430707L290.046770661138,1225.7426803582348L292.38581798877567,1219.2797388876788L290.493280201219,1218.585794235114L292.15861878730357,1213.9934810916893L292.28641833830625,1214.0361373908818L292.832327529788,1212.5192376463674L298.834173085168,1214.716557331849L301.28682001307607,1215.6165010365658L316.81367650907487,1221.300189042464L310.4781321277842,1238.740332395304L298.6503626201302,1234.395646489691L299.61438145209104,1231.7592864218168L294.78797620534897,1229.9885341525078L293.7182466350496,1232.9432556703687Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.2304145907983,1154.2026180466637L415.2690302003175,1140.1290251002647L418.76931788772345,1130.3346115541644L435.43059261795133,1136.3377751004882L431.80171649251133,1146.4859187770635L426.8909004321322,1160.2192861959338Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M344.55091227963567,1209.3023270755075L354.0893342848867,1182.9188182475045L367.43334290385246,1187.779575556051L358.4976298902184,1212.511954860296L357.89492089953274,1214.1630658851936Z"
      />
      <path
        fill="rgb(255, 255, 255)"
        stroke="rgb(255, 255, 255)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M419.2655272539705,1075.5838554669172L426.15408080164343,1056.548336233478L438.89538043085486,1061.190693852026L438.76126979105175,1061.5662856251001L439.5406892709434,1061.8492799676023L432.7870352482423,1080.515436424408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M351.43157696630806,1106.9211836443283L353.9118349086493,1099.9400049340911L353.6641246685758,1099.8411655449308L359.3196492213756,1083.9737835107371L369.5096911555156,1087.6381313367747L360.85718825738877,1111.923490385525L352.02718598302454,1108.7491900818422L352.5446952730417,1107.310298315715Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.4173407899216,1122.4337329273112L420.9663657164201,1107.083488164004L421.10126524139196,1106.7224646452814L435.160793566145,1111.8527423101477L429.4705580258742,1127.5567160928622Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.7373716495931,1165.272534317337L370.147900021635,1161.3606110373512L372.5926580885425,1162.2605616673827L372.89006815478206,1161.4459242811427L386.2135657342151,1166.3066966449842L386.0218664081767,1166.8383434168063L378.8359027961269,1186.695477154106L371.34542914293706,1183.9737859852612L375.7884357366711,1171.685586748179L369.94910072069615,1169.5527584818192L371.1750297434628,1166.1724844397977Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M331.8869234910235,1096.6731022014283L332.31213310640305,1095.4547759792767L339.0089873280376,1076.6814966802485L349.07201859913766,1080.2959083174355L341.93575481232256,1100.280220514629Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M400.5144932102412,1068.7378997136839L408.3236768525094,1047.1803778661415L416.2393601210788,1050.0717115467414L408.43727645277977,1071.6292244065553Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M289.75646057073027,1081.4799034283496L292.35741808917373,1074.3436767486855L297.02052390854806,1061.5870940349996L305.4608164438978,1064.6272017573938L298.8838729094714,1083.0602972912602L298.3458525799215,1084.5689020277932Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.07073395513,1238.9879461186938L336.0538199460134,1227.6278772181831L350.08573725633323,1232.5749559435062L346.10265126638114,1243.9412590949796Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M367.5114426286891,1141.836335417349L369.77239023149014,1135.536659986712L383.25129837635905,1140.391208065208L393.9162497520447,1144.2251125774346L392.6122210044414,1147.8602971499786L391.6560910353437,1150.511254820507Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M378.8359027961269,1186.695477154106L386.0218664081767,1166.8383434168063L392.92461990658194,1169.3540412797593L388.6015240009874,1181.2957906480879L385.7386562936008,1189.2111678123474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.0325344847515,1051.5449491171166L359.7732587363571,1035.7773372735828L368.41156168468297,1038.9381454773247L362.67872629500926,1054.7203160319477Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M394.29885951709,1066.4697852246463L402.1017320705578,1044.912256324198L408.3236768525094,1047.1803778661415L400.5144932102412,1068.7378997136839Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M345.62774182576686,1048.4694612962194L351.37477716524154,1032.6945594819263L359.7732587363571,1035.7773372735828L354.0325344847515,1051.5449491171166Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M304.9717070525512,1086.7163222692907L305.4395165173337,1085.412680119276L312.0156711637974,1066.9733483223245L318.66992553696036,1069.3683937955648L311.98017128836364,1088.1406524810009L311.63306139875203,1089.1051184250973Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.06981476116925,1116.0414431807585L391.0604820186272,1107.785767282825L406.8571375673637,1113.5465342230164L404.42579056322575,1120.2582326345146L403.8664703089744,1121.8094861414284Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M311.98017128836364,1088.1406524810009L318.66992553696036,1069.3683937955648L325.62947883363813,1071.8768440950662L318.9326246129349,1090.6428534938022Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M408.36627670377493,1231.2994318804704L413.6668025031686,1216.5871916306205L415.516740440391,1211.4351431131363L421.98008437268436,1213.7812399924733L419.6623369688168,1220.2150554857217L414.8225206602365,1233.651764407754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M318.9326246129349,1090.6428534938022L325.62947883363813,1071.8768440950662L332.3192330803722,1074.2791708027944L325.62237885966897,1093.0524566066451Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M325.62237885966897,1093.0524566066451L332.3192330803722,1074.2791708027944L339.0089873280376,1076.6814966802485L332.31213310640305,1095.4547759792767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.41692465078086,1224.056198626291L393.1865300964564,1210.8327526985668L395.5255774250254,1204.319858178962L401.7901220563799,1206.602493151091L398.41684503201395,1215.9639937193133L394.67515819333494,1226.338827101048Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.88958686124533,1262.3031313386746L375.2504154080525,1258.5899774595164L380.2890310175717,1244.8422393999062L387.23359547927976,1247.406807408668L382.3440793445334,1260.7446265351027L380.8341513229534,1264.868733276613Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M298.8838729094714,1083.0602972912602L305.4608164438978,1064.6272017573938L312.0156711637974,1066.9733483223245L305.4395165173337,1085.412680119276Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M408.43727645277977,1071.6292244065553L416.2393601210788,1050.0717115467414L421.6250856211409,1052.0339473932981L421.1225651660934,1053.4301933464594L413.8230019528419,1073.5924945673905Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M369.77239023149014,1135.536659986712L372.22424827422947,1128.662672358565L386.1496659582481,1133.6795291444287L390.7346720546484,1135.3316993536428L389.03383359126747,1140.0863683479838L384.0094179324806,1138.2791783516295L383.25129837635905,1140.391208065208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M389.00543369166553,1263.1957861362025L393.8878498515114,1249.8662948599085L400.5215931851417,1252.3112159562297L395.5815883381292,1265.796760994941L392.9459198312834,1272.9972947072238L389.3241436816752,1271.6645566946827L391.16698164399713,1266.6613248214126L392.0600007250905,1266.980724426452L392.91041995584965,1264.6419282783754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.65931544825435,1202.6125632519834L211.34196972101927,1183.3651507720351L218.01121292915195,1185.7102167513222L214.04232688900083,1197.1130107385106L212.1221780879423,1196.4325890694745L209.39342101942748,1204.270959426649Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.8230019528419,1073.5924945673905L421.1225651660934,1053.4301933464594L426.56509046815336,1055.4142770874314L426.15408080164343,1056.548336233478L419.2655272539705,1075.5838554669172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M374.6477064155042,1121.8875169935636L377.0853645084426,1115.0769809847698L392.7968203565106,1120.7326603028923L390.35916226450354,1127.5567160928622L388.5731241013855,1126.9127019653097Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M341.93575481232256,1100.280220514629L349.07201859913766,1080.2959083174355L354.3938443241641,1082.2092359936796L347.26468051224947,1102.1935426760465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M401.3720124159008,1228.7619081945159L406.6725382162258,1214.0496625574306L413.6668025031686,1216.5871916306205L408.36627670377493,1231.2994318804704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M362.67872629500926,1054.7203160319477L368.41156168468297,1038.9381454773247L369.2690808903426,1036.5992723945528L374.144397075288,1038.378397454042L373.1314673051238,1041.1563286483288L373.9463866604492,1041.4538897522725L373.2442780183628,1043.3817940726876L372.07514879852533,1046.5842157173902L368.36186185944825,1056.8032394112088Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M233.35347007401288,1249.901668195147L238.75339552480727,1235.0406910246238L245.52124949730933,1237.5282735042274L245.21673945803195,1238.3647502204403L240.1284240214154,1252.374679855071Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.1985117448494,1194.5754745383747L414.9850311996415,1192.4072796883993L419.77593657001853,1179.1411168836057L426.24559159204364,1181.5080327414908L421.4483751328662,1194.7388174040243L420.6618556762114,1196.936142727267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M226.69921570271254,1247.4640289945528L232.09204117860645,1232.610329363495L238.75339552480727,1235.0406910246238L233.35347007401288,1249.901668195147Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M240.62463338766247,1209.011015566066L245.4502497483045,1195.1362503501587L252.6433133361861,1197.665463146288L247.82479695044458,1211.541263697669Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M347.26468051224947,1102.1935426760465L354.3938443241641,1082.2092359936796L359.3196492213756,1083.9737835107371L353.6641246685758,1099.8411655449308L352.1975853824988,1103.9653680026531Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.4483751328662,1194.7388174040243L426.24559159204364,1181.5080327414908L433.14124511461705,1184.0237252796069L428.40003956947476,1197.1202935371548L427.49360942374915,1199.6359804156236L424.6086529046297,1198.5799746615812L425.46617211122066,1196.205781830009Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M246.51366822887212,1254.7207628837787L251.55938381515443,1240.8377659986727L258.61754787620157,1243.4314664937556L257.86652829684317,1245.4862425718457L253.5789322666824,1257.3071754476987Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M338.9521875279024,1046.0244683111086L342.8287738934159,1035.3382782186382L344.4870125046,1035.9542093956843L346.34326153062284,1030.851967040915L351.37477716524154,1032.6945594819263L345.62774182576686,1048.4694612962194Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M321.23538317903876,1268.1501222075894L323.665941295214,1261.4104764289223L338.0307685472071,1266.6332343034446L335.60731040500104,1273.3728750054725Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M220.21457184571773,1245.0825701546855L223.45373823028058,1236.160155269783L225.60739732161164,1230.2361481883563L232.09204117860645,1232.610329363495L226.69921570271254,1247.4640289945528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M402.1017320705578,1044.912256324198L404.5180902387947,1038.2223338722251L418.65650717448443,1043.3817940726876L416.2393601210788,1050.0717115467414L408.3236768525094,1047.1803778661415Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.22424827422947,1128.662672358565L374.6477064155042,1121.8875169935636L388.5731241013855,1126.9127019653097L386.1496659582481,1133.6795291444287Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M362.04051742795855,1253.707421575673L367.07913303840905,1239.9659161954187L373.83278706111014,1242.46077965945L368.8012714255601,1256.2085224408656Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M346.10265126638114,1243.9412590949796L350.08573725633323,1232.5749559435062L356.6050921017304,1234.8846318661235L356.22248233668506,1235.9479148513637L358.369830340147,1236.7063622018322L355.10305294115096,1246.032448766753L352.6156950229779,1245.146034119185L352.2748962221667,1246.1240033274516Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M323.665941295214,1261.4104764289223L325.9481888236478,1255.0817786925472L340.3130160747096,1260.311824069824L339.1722867535427,1263.4798126374371L339.5335965938866,1264.6346455481835L339.0728871030733,1265.9247289332561L338.1301681967452,1266.3710561119951L338.0307685472071,1266.6332343034446Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.5815883381292,1265.796760994941L400.5215931851417,1252.3112159562297L407.3241581460461,1254.8196000671014L402.384942186065,1268.306180614978Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.8306412100792,1262.1543555269018L271.11823724024,1250.3407136620954L271.8692568205297,1248.3005045158789L278.43910037819296,1250.7027700901963L275.3419334953651,1259.2423024801537L274.41341453883797,1261.814147892408L273.40758474357426,1264.5711817615665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M408.1185664627701,1189.9123982121237L408.5997869921848,1188.5879674395546L412.92288289777935,1176.6462306333706L419.77593657001853,1179.1411168836057L414.9850311996415,1192.4072796883993Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M408.9334858190268,1270.7292470410466L413.8727017790079,1257.2437115963548L420.6121558500454,1259.7312861075625L415.6658399151638,1273.2168167121708Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.42579056322575,1120.2582326345146L406.8571375673637,1113.5465342230164L410.57042450550944,1103.2849371917546L415.89225023053586,1105.2336325948127L409.74130519945174,1122.1923575103283Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M394.67515819333494,1226.338827101048L398.41684503201395,1215.9639937193133L400.37249370943755,1216.6797869736329L401.9313326710835,1212.3205216736533L406.6725382162258,1214.0496625574306L401.3720124159008,1228.7619081945159Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.6658399151638,1273.2168167121708L420.6121558500454,1259.7312861075625L427.2593102483079,1262.1897287974134L422.3200942873955,1275.669012291357Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.6237938115373,1252.7648267550394L287.4955129669979,1250.3552791480906L291.4359991075471,1251.794141227845L304.5109975617379,1256.5768209123053L302.2784498585388,1262.72865094617L289.2034514034167,1257.9303696420975L290.5571799762547,1254.2099306830205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.8012714255601,1256.2085224408656L373.83278706111014,1242.46077965945L380.2890310175717,1244.8422393999062L375.2504154080525,1258.5899774595164Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.3440793445334,1260.7446265351027L387.23359547927976,1247.406807408668L393.8878498515114,1249.8662948599085L389.00543369166553,1263.1957861362025Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M240.1284240214154,1252.374679855071L245.21673945803195,1238.3647502204403L245.5922492481768,1238.5062437844463L245.5425494229421,1238.6404545889236L251.55938381515443,1240.8377659986727L246.51366822887212,1254.7207628837787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M402.384942186065,1268.306180614978L407.3241581460461,1254.8196000671014L413.8727017790079,1257.2437115963548L408.9334858190268,1270.7292470410466Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M234.42398853134364,1206.8355424413458L234.86260921042413,1205.5672964360565L239.34900454152375,1192.6694606775418L245.54964939691126,1194.8449382465333L245.4502497483045,1195.1362503501587L240.62463338766247,1209.011015566066Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M409.74130519945174,1122.1923575103283L415.89225023053586,1105.2336325948127L420.9663657164201,1107.083488164004L415.4173407899216,1122.4337329273112L414.82962063513696,1124.0567743056454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.08616785984486,1183.655422956217L399.4084748774767,1171.7147180573083L406.1905287997797,1174.1877576075494L401.8674328951165,1186.135741060134Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M401.8674328951165,1186.135741060134L406.1905287997797,1174.1877576075494L412.92288289777935,1176.6462306333706L408.5997869921848,1188.5879674395546Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M260.0911871390417,1259.6886300886981L264.38588314317167,1247.87498402223L271.11823724024,1250.3407136620954L266.8306412100792,1262.1543555269018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M392.6122210044414,1147.8602971499786L393.9162497520447,1144.2251125774346L397.2540269009769,1134.9342629774474L403.2921612178907,1137.1024758019485L402.4914418114349,1139.3143851133063L398.643255347386,1150.0222634896636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M295.7022952120751,1240.058511226438L297.8638431634754,1234.1199419498444L298.6503626201302,1234.395646489691L310.4781321277842,1238.740332395304L310.9388416185975,1238.902633829508L308.7772936662659,1244.8557645063847Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.6015240009874,1181.2957906480879L392.92461990658194,1169.3540412797593L399.4084748774767,1171.7147180573083L395.08616785984486,1183.655422956217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M253.5789322666824,1257.3071754476987L257.86652829684317,1245.4862425718457L264.38588314317167,1247.87498402223L260.0911871390417,1259.6886300886981Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M404.75948938913643,1152.24041111907L409.79100502468646,1138.158490919508L415.2690302003175,1140.1290251002647L410.2304145907983,1154.2026180466637Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M293.56204718444496,1245.9263287102804L295.7022952120751,1240.058511226438L308.7772936662659,1244.8557645063847L306.64414561353624,1250.7235779301263Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.4359991075471,1251.794141227845L293.56204718444496,1245.9263287102804L306.64414561353624,1250.7235779301263L305.00010695215315,1255.2378373960964L304.5109975617379,1256.5768209123053Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M398.643255347386,1150.0222634896636L402.4914418114349,1139.3143851133063L405.7369192838669,1140.4900468792766L406.9344484061003,1137.1316072568297L409.79100502468646,1138.158490919508L404.75948938913643,1152.24041111907Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M287.1555030532181,1263.572407354135L289.2034514034167,1257.9303696420975L302.2784498585388,1262.72865094617L300.2376014813781,1268.355078915134Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M229.27177332062274,1203.6113464408554L233.75027979072183,1190.6999818282202L239.34900454152375,1192.6694606775418L234.86260921042413,1205.5672964360565Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M223.87184786982834,1201.7188602550887L228.36455429065973,1188.8220577370375L233.75027979072183,1190.6999818282202L229.27177332062274,1203.6113464408554Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M391.68843536637723,1046.309544133488L380.4586415318772,1076.8594081760384L355.61267337109894,1144.9055393706076L329.89577493909746,1214.716557331849"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M218.59893308393657,1199.8700703363866L223.08453952800483,1186.9649411677383L228.36455429065973,1188.8220577370375L223.87184786982834,1201.7188602550887Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M378.41069318167865,1220.4283367847092L383.1731986515224,1207.2048839344643L388.0201149350032,1208.9621168472804L383.25129837635905,1222.1855663438328Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M213.68101704958826,1198.1544511164539L214.04232688900083,1197.1130107385106L218.01121292915195,1185.7102167513222L218.173723468557,1185.250359156169L223.08453952800483,1186.9649411677383L218.59893308393657,1199.8700703363866Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M423.42532373405993,1236.769826240372L428.2659289287403,1223.347688905429L432.8651349749416,1225.0133628924377L428.02452977746725,1238.4500625170767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M213.72361689899117,1243.2119435444474L217.11819384805858,1233.835914246738L223.45373823028058,1236.160155269783L220.21457184571773,1245.0825701546855L220.0449613314122,1245.5288986749947Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M419.1022278293967,1235.1967501798645L423.93573305010796,1221.7673270227388L428.2659289287403,1223.347688905429L423.42532373405993,1236.769826240372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M374.03158636111766,1218.8334086779505L378.7933029457927,1205.6099527883343L383.1731986515224,1207.2048839344643L378.41069318167865,1220.4283367847092Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.8225206602365,1233.651764407754L419.6623369688168,1220.2150554857217L423.93573305010796,1221.7673270227388L419.1022278293967,1235.1967501798645Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M208.2597916731611,1241.2133480398916L211.66856857202947,1231.8373160371557L217.11819384805858,1233.835914246738L213.72361689899117,1243.2119435444474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M298.834173085168,1214.716557331849L307.3170654689893,1195.8728537620045L309.76892351172864,1196.765517110005L301.28682001307607,1215.6165010365658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.36186185944825,1056.8032394112088L372.07514879852533,1046.5842157173902L376.5970440050587,1048.2364066815935L372.87586820404977,1058.4543875195086Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.87586820404977,1058.4543875195086L376.5970440050587,1048.2364066815935L380.91225104779005,1049.8230506568216L377.1918641347438,1060.0347866299562Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.2442780183628,1043.3817940726876L373.9463866604492,1041.4538897522725L374.59800659120083,1039.6539570093155L375.98013506270945,1040.1637645959854L383.42800886556506,1042.8927951860242L382.06796920578927,1046.613347550854Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.07514879852533,1046.5842157173902L373.2442780183628,1043.3817940726876L382.06796920578927,1046.613347550854L380.91225104779005,1049.8230506568216L376.5970440050587,1048.2364066815935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M273.0888747526333,1265.4565535387956L273.40758474357426,1264.5711817615665L274.41341453883797,1261.814147892408L281.0613578213379,1264.245539705269L279.73602914996445,1267.887944073882Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M271.79273486789316,1156.2834307244048m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M276.42034081276506,1091.0569390626624m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M220.9371915254742,1064.8508920408785m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M214.49909194931388,1217.3768530096859m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M269.5065429089591,1213.6782406354323m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M355.9937053639442,1198.5404394674115m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.8056175317615,1177.8302092896774m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.6908925231546,1087.8753462904133m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.3781099943444,1059.4042917019688m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M298.9304171912372,1069.4849207471125m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M341.0782356048003,1235.7814517715015m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M386.85729680396616,1175.324918535538m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M312.05590435676277,1077.3900213874876m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M397.46308172121644,1114.7939888169058m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M318.80245840363204,1080.0087530571036m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.01470127888024,1225.757245899178m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M325.6263232892379,1082.4610169748776m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M332.31528865080327,1084.8664612662978m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M395.8008986786008,1213.3983736839145m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M381.24200544320047,1252.9989148844033m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M305.45056092366576,1075.016827473417m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.7791319238022,1062.5297148460522m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M379.29109008423984,1134.5056142969988m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.7635134384036,1257.753503182903m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M212.4053882015869,1191.0714049804956m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M419.98893582075834,1065.0704206395894m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M383.72226338647306,1121.3100886726752m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M348.16637734137475,1091.2452543512918m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M407.51980190258473,1222.674552584067m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.37654310371727,1050.6522670681588m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M239.28589365258813,1244.1326914085075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M420.61136696487665,1186.9576583560556m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M232.7255167281255,1241.2528829905204m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M246.63515669014305,1203.3387618777342m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M353.7130356086418,1091.9079992738552m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M252.1912815924734,1250.1035042656586m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M225.50878655631095,1240.6213641469367m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M380.39868618827313,1127.7876872182824m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.93901890236884,1248.0841028965078m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M331.9894786858931,1260.8611502693966m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M401.4532676851377,1260.3087029000744m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M273.1638189330697,1254.9725376013666m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.18983399681747,1183.8645437713712m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M411.372721683234,1109.3900846559554m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.20051653683186,1221.5093087204732m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M295.70150632504374,1255.393896093592m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M374.5435734493658,1250.5248630526476m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M388.1171479271725,1255.3054628307m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M245.84311503265053,1246.606745521538m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.1288219830021,1262.7744281180203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M240.15682392194867,1200.3517753561027m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M415.3581743314862,1114.637926951982m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.639137214981,1178.9215918970294m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M407.39515789598227,1181.3915076698177m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M265.6062899613753,1255.0151936467737m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M398.20384578220546,1141.7697492800653m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M303.3205684153363,1239.4810927496292m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.0053938832134,1176.5047358046286m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M258.98043548874557,1252.5910813375376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M410.0118931364268,1146.1842005527578m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M301.17006486840546,1245.390526433941m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M299.03928347397596,1251.2583394022658m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M403.8057260774076,1145.2561568222009m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M234.3080222727731,1198.1409259168431m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M228.8150082603097,1196.208903030958m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M388.21891423594207,1216.509161844384m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M223.47977147158235,1194.345546039287m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M383.2142207287252,1214.6947089876048m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M218.56501098163426,1192.0389778092504m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M218.58709979150444,1239.686050305143m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M423.6817117203027,1229.2727422695607m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.60239250585437,1213.0186285451055m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M419.37991574034095,1227.7100684596226m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M212.69175386242568,1237.5251523214392m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.47748071700335,1052.5198243693449m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M383.25129837635905,1222.1855663438328L388.0201149350032,1208.9621168472804L393.1865300964564,1210.8327526985668L388.41692465078086,1224.056198626291Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,1249.611398781184L503.1296433797106,1199.1116189588793L425.1435176897794,1170.454788858071"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M535.4053409639746,1199.7316971844994m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1249.457420737017L462.22668725345284,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M425.1435176897794,1093.0659820116125L528.251721682027,1130.4625819935463L641.8174000009894,1172.1454452439211"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M509.0865224264562,1046.309544133488L552.9911902183667,1062.4017431549728L641.8174000009894,1094.8482138239779"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M615.9845353094861,1201.7188602550887L619.43591205962,1192.2938760044053L629.5770430555567,1196.042438999284L633.6942396843806,1184.8102691629902L670.0421673888341,1198.23248110665L660.4327456336468,1224.4390643495135L636.3590969778597,1215.5457540210336L637.1740163331851,1213.341151815839L638.39284538012,1209.9889898719266L622.6324785938486,1204.1783639150672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M502.35732387471944,1105.9005378372967L506.8926301440224,1093.4207637449726L515.9703426575288,1096.7438504290767L516.792361988686,1094.4622196997516L514.8154133874923,1093.739130917471L515.5593329928815,1091.6988756861538L510.294307067059,1089.7709848009981L515.5735329436138,1075.2571641169488L520.9308585431427,1077.2131503224373L521.6542671099305,1075.2290728199296L523.6170157613233,1075.9448806052096L524.5810345932841,1073.2938944245689L515.6729325931519,1070.034262068104L520.0662393625826,1057.937298329547L541.4545196853578,1065.7685423353687L535.4021854195744,1082.415238618385L528.4079211326316,1079.85685208207L527.3445026511326,1082.7835463192314L529.3924510022625,1083.5274445866235L529.9525601435453,1085.412680119276L527.6845125658438,1091.6770269526169L526.1043736794963,1092.5915524489246L524.1061251526698,1091.8549380670302L523.1066064452752,1094.5974737079814L529.8957603434101,1097.0840661646798L523.8300150120631,1113.7660612799227Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.8411570843309,1192.959732472431L598.6440296368673,1171.8281220756471L628.9964228756726,1183.1164946616627L625.9205559166148,1191.464676536154L620.4922305652872,1189.4452580879442L619.43591205962,1192.2938760044053L615.9845353094861,1201.7188602550887L615.8646246213466,1201.6772442813963L615.6729252943769,1202.2016055448912L611.2015188001096,1200.5567340673879L602.6973264915869,1197.410565149039Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M567.9374265354127,1260.7446265351027L568.9929561559111,1257.7462204452604L576.2925193673,1260.3336722711101L581.0613359278068,1246.811702866573L574.0528716901317,1244.3178813625127L574.8038912713528,1242.1913178027608L574.0031718658283,1241.9083308205009L577.0364389736205,1233.3261208990589L605.5530942231417,1243.4595571081154L602.9947365568951,1250.7027700901963L602.3289166763425,1252.6295758322813L601.1242875801399,1252.1978132515214L600.5357785392553,1253.8770053978078L593.8886241419241,1251.510114247445L589.2894180985168,1264.5358085068874L595.717262154445,1266.817383264657L594.5260441219434,1270.191365902312Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M542.8074593720958,1120.5765985744074L550.4470325000584,1099.4510100372136L566.5694980127737,1105.3262294251472L574.6768806073815,1108.281004074961L567.0302075045183,1129.413848573342Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.9641183549538,1281.1258466052823L630.8526719007641,1262.0201451773755L628.5775243481621,1261.1909540477209L631.3843811433762,1253.41715232376L646.6840384388342,1258.9863663557917L647.3577471803874,1260.9214929174632L638.2161348899826,1286.2913683610968L637.6773256743327,1286.1072199176997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.2304145907983,1154.2026180466637L415.2690302003175,1140.1290251002647L418.76931788772345,1130.3346115541644L435.43059261795133,1136.3377751004882L431.80171649251133,1146.4859187770635L426.8909004321322,1160.2192861959338Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M536.8829246554524,1173.0537177035585L544.7354970341548,1151.779510893859L563.1394211892039,1158.6253846464679L555.2947376715019,1179.8995704459958Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M612.8029576120898,1230.9945961618796L621.3994495971128,1207.515963092912L637.1740163331851,1213.341151815839L636.3590969778597,1215.5457540210336L634.367948426865,1220.9807873326354L632.312900098972,1226.5864412672818L630.484262086451,1231.9725673655048L628.5641132853925,1236.8124824007973Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M485.9161483719945,1099.8973479354754L492.20909290388227,1082.5421695229597L497.5309186289087,1067.816088133026L504.3129725512117,1070.2964476831257L500.4505861364305,1080.9690584642813L507.04804070852697,1083.3713820199482L499.29565686546266,1104.7737696608528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.5636971453205,1226.8486209632829L611.2015188001096,1200.5567340673879L615.6729252943769,1202.2016055448912L615.8646246213466,1201.6772442813963L615.9845353094861,1201.7188602550887L622.6324785938486,1204.1783639150672L621.3994495971128,1207.515963092912L612.8029576120898,1230.9945961618796Z"
      />
      <path
        fill="rgb(255, 255, 255)"
        stroke="rgb(255, 255, 255)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M419.2655272539705,1075.5838554669172L426.15408080164343,1056.548336233478L438.89538043085486,1061.190693852026L438.76126979105175,1061.5662856251001L439.5406892709434,1061.8492799676023L432.7870352482423,1080.515436424408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M525.0630440097302,1168.6673744590953L532.9219274772331,1147.3785884869285L544.7354970341548,1151.779510893859L536.8829246554524,1173.0537177035585Z"
      />
      <path
        fill="rgb(255, 255, 255)"
        stroke="rgb(255, 255, 255)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.8629311369732,1094.7670614235103L476.7035363325849,1081.3873062804341L478.1416757181287,1077.4118701675907L492.20909290388227,1082.5421695229597L485.9161483719945,1099.8973479354754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M446.2446434693411,1085.4199630357325L453.81321684643626,1064.5210789232515L464.85446689929813,1068.559988007415L464.1239583576098,1070.5940075344406L457.29299349617213,1089.4515770315193Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M593.0666048107669,1223.702463972848L602.1088174507022,1199.0117405815981L602.6973264915869,1197.410565149039L611.2015188001096,1200.5567340673879L601.5636971453205,1226.8486209632829Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.4173407899216,1122.4337329273112L420.9663657164201,1107.083488164004L421.10126524139196,1106.7224646452814L435.160793566145,1111.8527423101477L429.4705580258742,1127.5567160928622Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M491.2521740468219,1263.3029463202693L494.50475149415433,1254.0122562963516L500.8118959758431,1256.2376533942297L501.30100536718965,1257.675473860465L519.9179287739098,1264.245539705269L517.062161039561,1272.4157174155116Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M479.3605047632009,1170.8917585494928L481.71375204157084,1164.4006750108674L485.14303997997195,1165.662686118856L486.6174681261182,1164.075028249994L497.1341089140624,1167.9162024976686L498.7639476247132,1167.1296566976234L503.98716258537024,1169.028394749388L499.6427667560056,1181.026326413732L487.46788735780865,1176.5827660416253L487.8930969731882,1175.3998275748454L483.37199065461755,1173.7549497382715L482.62018218729645,1172.075738188345Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M606.9920224957168,1143.977495469153L612.952057087794,1127.4859681772068L618.1531832376495,1129.3784746262245L615.3258154047653,1137.1805064822547L618.0821834877133,1138.1803395063616L620.8109405562282,1130.6467345692217L626.0270555429161,1132.546523024328L620.1451206756756,1148.774815235287Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M519.4998191315681,1272.9546387707815L527.7839122163132,1249.9724148595706L535.3808854939416,1252.7294534370303L533.2832373166457,1258.547321436461L534.0484568476677,1259.5252887546085L533.4536367179826,1261.155580772087L532.2277076961473,1261.466657507699L529.4279508776963,1269.26229838375L530.4132696343586,1269.6170711009763L528.0813222806901,1276.0654002083465L527.4936021259055,1275.8458782937378L527.0044927345589,1276.2641143542714L526.7141826450825,1276.3920820998028L526.0901737287641,1276.4701112126932L525.7714637396857,1276.4201725814492L525.1971546476707,1276.1507120407186L524.7648450573906,1275.682537339162L524.5313347671181,1275.0874352268875L524.5100348424166,1274.7690763827413L522.4833864159882,1274.038723683916L522.0013769995421,1274.4423944153823L521.4057679846883,1274.648391327355L521.0799580179155,1274.6629567625932L520.4638379635289,1274.4923330601305L519.9534286484122,1274.1240355414338L519.6134187327698,1273.5778315584175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M585.8948411494493,1221.0515342913568L594.9370537865907,1196.3764074607752L602.1088174507022,1199.0117405815981L593.0666048107669,1223.702463972848Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M497.5380186038092,1245.3447491484694L500.74089622683823,1236.1674380297773L507.1190404575318,1238.4136487338692L506.75063064321876,1239.4561233003624L514.609514111653,1242.2339739254676L516.0626423330978,1241.8157358146273L516.9627613900229,1242.1278538103215L517.4234708808362,1243.2192262979224L522.9156960053369,1245.1533168680035L520.449638013728,1252.1978132515214L515.3258227035403,1250.3906524810009L513.9649941567332,1250.9295755471103L512.5615657595918,1250.433308553882L512.1718560187146,1249.278473278042L504.2206728756428,1246.4787772288546L503.8451630854979,1247.570149031002Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.3257864769548,1218.6284505063668L580.5872153723612,1215.1836957563646L587.0426704445854,1197.5447767493315L588.8571085073054,1192.6059962315485L595.4261631779373,1195.043654717505L594.9370537865907,1196.3764074607752L585.8948411494493,1221.0515342913568Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M494.50475149415433,1254.0122562963516L497.5380186038092,1245.3447491484694L503.8451630854979,1247.570149031002L503.47675327025354,1248.5907739810646L511.49183618929237,1251.4185597607866L512.5615657595918,1250.433308553882L513.9649941567332,1250.9295755471103L514.5109033472836,1252.4807998137549L519.8185291225091,1254.3524643140845L517.4163709059358,1261.2117618555203L501.0887950025499,1255.4438348757103L500.8118959758431,1256.2376533942297Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M475.8105172496289,1181.2739421981387L478.6662849839777,1173.3793640434742L487.46788735780865,1176.5827660416253L499.6427667560056,1181.026326413732L497.31870826426893,1187.4466470805928L497.33921930287033,1188.2550390064716L497.0702091390267,1188.7794012823142L496.8579987734556,1188.9843603367917L496.61659962311387,1189.1404205281287L496.0501793930307,1189.289197906386L495.4616703512147,1189.1976425950415L494.97256096079946,1188.8709565978497L494.7958504706621,1188.6306238961406L494.6041511455551,1188.1343524428084Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M537.577933321707,1203.8454362303019L539.7181813493371,1198.033764728345L540.4621009547263,1196.042438999284L542.2197392173111,1196.6947699026205L548.1939737582579,1180.5300544183701L554.2384191639721,1182.7762831477448L545.3871169639751,1206.7439873656258Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M524.8997445832938,1243.835139006842L533.5593474572524,1219.6345141632482L540.1433909647167,1222.0159817477688L535.9480946101248,1233.729794003535L531.482999204658,1246.2165982751176Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.0813222806901,1276.0654002083465L530.4132696343586,1269.6170711009763L531.2778888139874,1267.2148120771162L532.5961175113916,1267.6892296895385L534.7079656384885,1261.8359960918315L533.3826369671151,1261.353254955262L533.4536367179826,1261.155580772087L534.0484568476677,1259.5252887546085L536.1106051504612,1253.7989760315977L536.6423143902794,1253.997690815013L536.9965242557228,1253.5305550089106L537.5140335466713,1253.2538108383305L538.0954426117241,1253.2111547831446L538.6476628920063,1253.4098695809953L538.8748620944098,1253.594018893782L539.2077720332891,1254.075720179826L539.285871759057,1254.3659894028679L539.2645718343556,1254.947568205651L540.0368913384154,1255.23055465566L540.3911012047902,1254.7561361906119L540.9015105199069,1254.4866748112254L541.4900195607916,1254.4367360221222L542.0422398410738,1254.6427335264161L542.4603494815528,1255.0536881280132L542.6023489823565,1255.3085840065032L542.6804487081245,1255.5926108313724L542.6520488075912,1256.1877146172337L543.119858273305,1256.3510560332797L540.2988015292212,1264.18831825722L535.3950854446739,1277.7737174369395L531.7598982304335,1276.4482630598359L530.7816794486716,1277.0433650584891Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M599.9480583844706,1141.40456593642L607.4669319372624,1120.5984472185373L614.5179960252717,1123.1703440598212L612.952057087794,1127.4859681772068L606.9920224957168,1143.977495469153Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M626.9263857118785,1151.2405801205896L630.6893724771217,1140.8583514955826L634.5375589402393,1130.2003986528143L641.4758123131469,1132.7306755478494L640.8660033484921,1134.437987683341L633.8717390596867,1153.7781321834773Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M498.6361480746418,1159.7802350246347L499.996976621449,1156.0243695802055L501.2229056414217,1156.4634209917858L507.79274920001626,1138.3499261545949L514.2553042462096,1140.7033306299709L506.3183210529387,1162.5726832477376Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M596.0856719696894,1112.9732668581419L598.0910204723477,1107.3883293312974L597.8709212457761,1106.7006159601733L600.060869098641,1100.5715365917422L604.0013552373275,1089.5722653106786L610.506510133855,1091.9256863440387L604.6600751429796,1108.2529129129834L603.7812560116872,1108.7637558705173L601.5636971453205,1114.9500506753102Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M439.4341896465048,1082.9396088989452L444.33790573105216,1069.403768046759L447.0027630245313,1062.0480002532713L453.81321684643626,1064.5210789232515L446.2446434693411,1085.4199630357325Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M567.0302075045183,1129.413848573342L574.6768806073815,1108.281004074961L576.547329582274,1107.5090172984637L580.7000260883942,1109.0321824983694L581.2885351283476,1110.0673936302774L578.5384781351313,1117.6426374055445L573.4438516097143,1131.752690343652Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M580.3813160974532,1134.2819262635894L587.4110802598298,1114.822079950478L588.4673987654969,1111.9099650182761L594.7958431728184,1114.2196811400354L592.4283959455788,1120.7680342942476L586.7097605047747,1136.578109615948Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M559.773244141601,1251.5246797306463L562.6787116983905,1243.4314664937556L566.8882080027834,1231.6604489120655L573.7199617512524,1234.1272247130983L566.0377887720242,1255.5926108313724L562.253502083011,1254.2172134215944L562.8278111731634,1252.6295758322813Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M564.8615595754236,1059.3689173972234L566.952107777819,1053.608105439227L579.715496217832,1058.292081861291L591.195366948843,1062.494340557605L589.1048187455162,1068.2561855535023Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.312900098972,1226.5864412672818L634.367948426865,1220.9807873326354L658.4479081705213,1229.875131082721L656.3857598686591,1235.4807778261602Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M584.5198126519099,1190.6073861392215L588.2898993911222,1180.3885596697219L592.3226852053776,1169.4747281679884L598.6440296368673,1171.8281220756471L590.8411570843309,1192.959732472431Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.367948426865,1220.9807873326354L636.3590969778597,1215.5457540210336L660.4327456336468,1224.4390643495135L658.4479081705213,1229.875131082721Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.2947376715019,1179.8995704459958L563.1394211892039,1158.6253846464679L569.2690662946552,1160.906994258985L561.424382776022,1182.1884558750317Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M441.9002476390451,1243.4814053620212L446.7408528337255,1230.0519982553087L449.36311027687043,1222.780672999099L455.64185485895723,1225.0560191236436L448.1789922211319,1245.7629870488308Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M593.1802044119686,1138.945040004328L596.9786910507828,1128.4785197284073L598.3032308360562,1128.9529468338005L601.272598169744,1120.7534685358405L600.17446869798,1120.3497888525017L600.9467882048339,1118.2169447960332L607.4669319372624,1120.5984472185373L599.9480583844706,1141.40456593642Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M436.40092253685,1129.109008374624L441.7732369750738,1114.2623380539007L450.47543969843537,1117.4376762425527L445.09681417327374,1132.2905822237954Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.854000069201,1161.6862579258159L486.1851585358381,1155.237822433468L492.57040274329484,1157.554806964472L491.98189370241016,1159.1851229607128L493.3498222241178,1159.6741136452183L493.9312312910333,1158.0510806036182L498.6361480746418,1159.7802350246347L506.3183210529387,1162.5726832477376L503.98716258537024,1169.028394749388L498.7639476247132,1167.1296566976234Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.484262086451,1231.9725673655048L632.312900098972,1226.5864412672818L656.3857598686591,1235.4807778261602L654.4727110415697,1240.7170803532936Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M430.00936724152416,1046.1170659326017L436.88293195329607,1027.1813466446474L443.4740754356608,1029.5909718177281L443.03466587048024,1030.803067064844L439.0657798303291,1041.7441678792238L436.6068218136206,1048.5194015661255Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.862916671671,1250.035878778901L455.35075588338077,1245.9471365641803L454.54293650295585,1245.642301488202L454.5003366516903,1244.7642099326476L455.01074596773833,1243.3461542585865L455.5921550337225,1242.9497644705698L460.6520705688745,1244.8068660427816L474.30058922898024,1249.7882654508576L471.82743126153946,1256.5913863875903Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M459.6951517127454,1145.004378120415L462.0618100548163,1138.4851793069392L467.4412244670093,1123.6239633113146L473.27345950808376,1125.7568057039753L468.00764469616115,1140.2923692497425L465.53448672872037,1147.1372139360756Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.8717390596867,1153.7781321834773L640.8660033484921,1134.437987683341L647.2441475782543,1136.7695448943414L640.2498832922429,1156.0951172020286Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.424382776022,1182.1884558750317L569.2690662946552,1160.906994258985L574.9884906224906,1163.0398251847364L569.4252657461911,1178.12048170669L567.1438071038574,1184.31399744004Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M628.5641132853925,1236.8124824007973L630.484262086451,1231.9725673655048L654.4727110415697,1240.7170803532936L652.6440730299801,1245.7068058406003Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.8926808340475,1227.1815475462936L462.67871899623424,1222.2563132927753L481.7492519170046,1229.215520533733L479.26820508856326,1236.0613178219646L466.5624053366482,1231.4263600623235L467.2637250907719,1229.4995484277606Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M575.0452904226258,1181.3873460595496L575.4279001876712,1180.3604688020423L580.9982250388712,1165.2652514823712L586.9929706193507,1167.49067706801L582.9609736902639,1178.4045116947964L579.3399864267558,1188.2259077676572L575.6969103524461,1186.8723454261199L576.5828294577077,1184.462774920743L575.0878902729601,1183.9103214601055L575.8886096775532,1181.7140324125066Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M466.68231602571905,1175.9730897769332L467.1359255416319,1174.7194037744775L471.6010209461674,1162.2397535620257L472.8553498676047,1158.710697923787L479.2611051136628,1161.0203984575346L472.713350366801,1179.33255098667L471.6081209210679,1179.8850048091263L469.2832735432312,1179.0485210367478L469.5806836085394,1178.198511922732L469.25487364269793,1176.8948869737796Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M573.4438516097143,1131.752690343652L578.5384781351313,1117.6426374055445L582.2170540848747,1118.9889303809032L584.1514028366655,1113.6391309448518L587.4110802598298,1114.822079950478L580.3813160974532,1134.2819262635894Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M620.1451206756756,1148.774815235287L626.0270555429161,1132.546523024328L626.7212753230706,1130.6186434994452L632.4754106383771,1132.708826944232L629.6693427301943,1140.4827640177682L630.6893724771217,1140.8583514955826L626.9263857118785,1151.2405801205896Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M574.1735712662339,1212.8240741784684L580.6290263375267,1195.1778663634323L587.0426704445854,1197.5447767493315L580.5872153723612,1215.1836957563646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.2498832922429,1156.0951172020286L647.2441475782543,1136.7695448943414L652.0279529737309,1138.5059874830768L649.3630956821144,1145.8689570128918L651.0639341427013,1146.4932016292587L646.733738264069,1158.462040928658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.7252957886085,1079.3460069941357L560.1274540051818,1072.6987749389373L577.0080390740186,1078.8507681381889L574.6058808574453,1085.5052772131748L571.8629238381982,1084.505436593201Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.01516081020236,1154.21718373755L501.5771155077964,1136.1036830320954L507.79274920001626,1138.3499261545949L501.2229056414217,1156.4634209917858L499.996976621449,1156.0243695802055Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M507.79984917491674,1216.0274579511024L510.1949074184522,1209.2097316333093L526.7496825195849,1215.0567672774196L524.368035341613,1221.8734474494122L519.4714192328975,1220.144308517687Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M527.1890920847654,1045.8975367359817L527.5788018265739,1044.7842843057588L529.2228404870257,1040.185613493435L537.5921332715079,1043.2257306030951L548.5268836989999,1047.1866204007529L546.4718353711069,1052.8922953461297Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.8230019528419,1073.5924945673905L421.1225651660934,1053.4301933464594L426.56509046815336,1055.4142770874314L426.15408080164343,1056.548336233478L419.2655272539705,1075.5838554669172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M462.0760100046173,1220.8039199304767L462.61481922119856,1219.3223951547407L463.720048667863,1219.3369607091881L464.06794744357467,1218.3589877225459L467.0302148004994,1219.4503639517352L469.1207630028948,1221.2575327875093L470.23309242445976,1218.2102109682746L471.62232087086886,1218.7127226484008L471.77063146140426,1218.2955235126428L484.08041038457304,1222.7879557712004L481.7492519170046,1229.215520533733L462.67871899623424,1222.2563132927753L462.90512931067497,1221.6258331155404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M604.6600751429796,1108.2529129129834L610.506510133855,1091.9256863440387L617.4660634333268,1094.441411391832L615.6658253194764,1099.4582929415628L612.4487477475777,1108.4589147600345L610.2729998454452,1107.6650793212466L609.4438805384561,1109.9747968609445Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M552.8144797282293,1092.903677165974L555.2237379206344,1086.256458107382L569.3613659702241,1091.4148421455175L571.3391034593806,1092.1306482618675L568.9361563557759,1098.785144590307Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.3364907791838,1149.951515802648L484.64051952492446,1146.3725143410265L489.905545450747,1131.8234382164665L495.8158802157268,1133.9781266874634L489.2610254958272,1152.1051582358778Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M550.4470325000584,1099.4510100372136L552.8144797282293,1092.903677165974L568.9361563557759,1098.785144590307L566.5694980127737,1105.3262294251472Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M489.2610254958272,1152.1051582358778L495.8158802157268,1133.9781266874634L501.5771155077964,1136.1036830320954L495.01516081020236,1154.21718373755Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M429.4705580258742,1127.5567160928622L435.160793566145,1111.8527423101477L441.7732369750738,1114.2623380539007L436.40092253685,1129.109008374624L436.08221254777163,1129.9735892489552Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M432.7870352482423,1080.515436424408L439.5406892709434,1061.8492799676023L442.1203468646854,1062.791900745593L440.2633089516312,1067.9222109196708L444.33790573105216,1069.403768046759L439.4341896465048,1082.9396088989452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M541.8016295777634,1280.1052264436148L546.4647353962064,1267.1503079249524L547.066655500792,1267.3708705045283L549.0443929890171,1261.8640866288915L552.2969704372808,1263.0407680035569L550.3129218611866,1268.5465105557814L553.0692899432033,1269.5463246344589L552.2543705878779,1271.792524522636L548.4061841228977,1282.4929155772552Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.0537474937737,1056.4276473796926L464.3440575832501,1055.612997555174L469.8007828341797,1040.5820148750208L476.5544368568808,1043.0551012046635L471.34542184509337,1057.3921177354641L468.4115543877706,1056.3142414703034L467.8664340823889,1057.8238924448378Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M586.7097605047747,1136.578109615948L592.4283959455788,1120.7680342942476L598.9130398025736,1123.1276872041635L596.9786910507828,1128.4785197284073L593.1802044119686,1138.945040004328Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.62590343598276,1053.1607241393067L463.08972866181284,1038.123493600171L469.8007828341797,1040.5820148750208L464.3440575832501,1055.612997555174Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.1985117448494,1194.5754745383747L414.9850311996415,1192.4072796883993L419.77593657001853,1179.1411168836057L426.24559159204364,1181.5080327414908L421.4483751328662,1194.7388174040243L420.6618556762114,1196.936142727267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.34542184509337,1057.3921177354641L476.5544368568808,1043.0551012046635L483.2725910032168,1045.5146611561067L478.077775943093,1059.8506321762688L474.27928930334747,1058.4689534115605L473.28055948298424,1059.759075159207L472.04043051134795,1059.3054517358541Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M484.64051952492446,1063.0332782296464L484.88822976499796,1062.3382775173523L490.09014480095357,1048.0023116385564L496.701799322851,1050.4254550598562L492.7826131088659,1061.2260681469925L491.2521740468219,1065.44913346041Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.6520705688745,1244.8068660427816L463.2664391519502,1237.5709296567366L464.20915805734694,1237.9184212363325L476.91574669536203,1242.5523342639208L474.30058922898024,1249.7882654508576Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.4483751328662,1194.7388174040243L426.24559159204364,1181.5080327414908L433.14124511461705,1184.0237252796069L428.40003956947476,1197.1202935371548L427.49360942374915,1199.6359804156236L424.6086529046297,1198.5799746615812L425.46617211122066,1196.205781830009Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.077775943093,1059.8506321762688L483.2725910032168,1045.5146611561067L490.09014480095357,1048.0023116385564L484.88822976499796,1062.3382775173523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.2237379206344,1086.256458107382L557.7252957886085,1079.3460069941357L571.8629238381982,1084.505436593201L569.3613659702241,1091.4148421455175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M428.40003956947476,1197.1202935371548L433.14124511461705,1184.0237252796069L439.50518939550966,1186.3407001928426L435.8913021078333,1196.3337510530837L433.8007539054379,1202.1162928021513L432.31922578345984,1202.655219621025L430.46218787133694,1201.9810408889316L429.5415577767417,1200.5640168623067L430.5118876956403,1197.8922703363933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M542.6023489823565,1241.596212811768L544.3386873183772,1236.7625434831716L542.8571591973305,1236.2319424706511L547.0595555268228,1224.5170940435492L553.8132095495239,1226.9474585438147L549.5966132702306,1238.7049590065144L548.1229740073904,1238.1733177448623L546.4008356211707,1242.9705723328516Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M596.4327818602324,1068.6317769428715L600.9751881053671,1056.0739041725174L602.4141163779423,1052.0911705926992L608.146951767616,1054.1813777126372L606.2623028410599,1059.3907662327401L602.5056271664798,1069.7647935086861L602.1656172499061,1070.7219790760428Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.1199451899156,1162.4519962393679L436.9681316530332,1151.6941975341178L438.0946610253304,1148.533440735191L444.7702153213322,1150.9357408806682L439.7812995361164,1164.8615743969567Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M439.7812995361164,1164.8615743969567L444.7702153213322,1150.9357408806682L451.4465585052967,1153.3380401954055L450.9290492143482,1154.784205250442L446.46395380795,1167.2711517149583Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M515.1554233031347,1195.511834866833L517.302771304734,1189.7001563790254L530.4274695841596,1194.5827573407441L533.2264375165105,1195.6252384991385L531.0932894647121,1201.4285888271406Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.4252657461911,1178.12048170669L574.9884906224906,1163.0398251847364L580.9982250388712,1165.2652514823712L575.4279001876712,1180.3604688020423Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M611.7608390562236,1113.568382889498L616.6866439515725,1099.833882641513L615.6658253194764,1099.4582929415628L617.4660634333268,1094.441411391832L623.0505882343277,1096.4535746057518L622.5756787937135,1097.7509721913375L618.5144930789247,1109.1029306002893L616.3324340870604,1115.219517477788Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.6658399151638,1273.2168167121708L420.6121558500454,1259.7312861075625L427.2593102483079,1262.1897287974134L422.3200942873955,1275.669012291357Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.7702153213322,1046.1170659326017L445.49362388718873,1044.1111306459643L449.4688210161403,1033.1554676215164L456.34317461494356,1035.6566480584443L453.00539746694267,1044.8550330623984L451.6303689694032,1048.62552464474Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.0528645236045,1136.2878354596905L461.43149004969746,1121.4338976321742L467.4412244670093,1123.6239633113146L462.0618100548163,1138.4851793069392Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.3200942873955,1275.669012291357L427.2593102483079,1262.1897287974134L433.8567648185417,1264.621120477561L428.9246488343924,1278.1066415715031Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M473.8540796879679,1211.1656800471246L476.3840374555439,1204.199171897024L489.1261259689927,1208.8487134356983L486.6032681763172,1215.815216914285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.3312218943611,1218.1394639802165L473.8540796879679,1211.1656800471246L486.6032681763172,1215.815216914285L484.08041038457304,1222.7879557712004L471.77063146140426,1218.2955235126428Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M446.46395380795,1167.2711517149583L450.9290492143482,1154.784205250442L457.95171340182424,1157.314473176375L453.4874068805948,1169.8003746760078Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.4874068805948,1169.8003746760078L457.95171340182424,1157.314473176375L464.97437758836895,1159.8509826082736L460.51717104390264,1172.3306371183135Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.29119133297354,1068.6026452011429L506.190521501936,1066.1368509237655L510.1168076917529,1055.3227200112306L516.6653513237834,1057.7177695091814L511.838946078904,1070.9914475986734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.0568559300154,1047.8243993981741L571.1687040571123,1042.0282034538686L583.9320924980566,1046.7121876999736L585.7883415231481,1047.385341106914L583.6835933700204,1053.1825729962438L581.820244369097,1052.4948542467318Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M476.3840374555439,1204.199171897024L478.77278460841626,1197.5874331472442L491.5211842106655,1202.243221515324L489.1261259689927,1208.8487134356983Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M618.5144930789247,1109.1029306002893L622.5756787937135,1097.7509721913375L629.9667527955025,1100.4154744101688L625.8992559919134,1111.7747113476507Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M445.09681417327374,1132.2905822237954L450.47543969843537,1117.4376762425527L456.0528645236045,1119.4779238994233L450.67345011327416,1134.3245830503292Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.51717104390264,1172.3306371183135L464.97437758836895,1159.8509826082736L471.6010209461674,1162.2397535620257L467.1359255416319,1174.7194037744775Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M478.97789499815553,1144.3031431776471L484.2437098091468,1129.754062707536L489.905545450747,1131.8234382164665L484.64051952492446,1146.3725143410265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.20915805734694,1237.9184212363325L466.5624053366482,1231.4263600623235L479.26820508856326,1236.0613178219646L476.91574669536203,1242.5523342639208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M453.00539746694267,1044.8550330623984L456.34317461494356,1035.6566480584443L463.08972866181284,1038.123493600171L457.62590343598276,1053.1607241393067L454.2100265612826,1051.9142988803796L456.3289746651426,1046.0744086019695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M473.3515592329204,1142.2483371105045L478.6236851327121,1127.7054947898723L484.2437098091468,1129.754062707536L478.97789499815553,1144.3031431776471Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.302771304734,1189.7001563790254L519.5637189075351,1183.556584758684L532.6947282766923,1188.4319072389044L530.4274695841596,1194.5827573407441Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.0191377522424,1066.2929138783365L594.5615439973772,1053.7350368718617L600.9751881053671,1056.0739041725174L596.4327818602324,1068.6317769428715Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M535.9480946101248,1233.729794003535L540.1433909647167,1222.0159817477688L547.0595555268228,1224.5170940435492L542.8571591973305,1236.2319424706511Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M519.5637189075351,1183.556584758684L521.8309775991365,1177.4265329339541L534.955675878562,1182.3091425406747L532.6947282766923,1188.4319072389044Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.0302437301725,1229.6764156077988L505.4608018472791,1222.7244916022755L517.125271929428,1226.8486209632829L514.7018137872219,1233.7870157035068Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M450.67345011327416,1134.3245830503292L456.0528645236045,1119.4779238994233L461.43149004969746,1121.4338976321742L456.0528645236045,1136.2878354596905Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M468.00764469616115,1140.2923692497425L473.27345950808376,1125.7568057039753L478.6236851327121,1127.7054947898723L473.3515592329204,1142.2483371105045Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M616.6511440761387,1267.3282145359553L621.6826597126201,1252.6441413164139L627.025785362348,1254.4866748112254L624.0138181783259,1263.2675730539486L621.9942697267979,1269.170744128991Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.4608018472791,1222.7244916022755L507.79984917491674,1216.0274579511024L519.4714192328975,1220.144308517687L517.125271929428,1226.8486209632829Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M549.5966132702306,1238.7049590065144L553.8132095495239,1226.9474585438147L560.3546532057226,1229.3143580802716L556.1522568771616,1241.0645717764273Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M556.1522568771616,1241.0645717764273L560.3546532057226,1229.3143580802716L566.8882080027834,1231.6604489120655L562.6787116983905,1243.4314664937556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M466.17269559483975,1092.6976748532616L471.0196118801832,1079.3179157171398L476.7035363325849,1081.3873062804341L471.8629311369732,1094.7670614235103Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M586.5251611545682,1095.6951119108126L590.4585473183542,1084.696873311419L597.3258009413257,1087.1699439031072L593.3853148007765,1098.1681785788387Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M500.74089622683823,1236.1674380297773L503.0302437301725,1229.6764156077988L514.7018137872219,1233.7870157035068L512.4203551448882,1240.2780342767946L507.1190404575318,1238.4136487338692Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M426.8909004321322,1160.2192861959338L431.80171649251133,1146.4859187770635L434.6085732858628,1147.5065586082637L433.55225478019565,1150.4613152816892L436.9681316530332,1151.6941975341178L433.1199451899156,1162.4519962393679Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.4274622863159,1081.458054664079L630.8668718514964,1080.217876996845L635.0053684068844,1068.808648227714L640.894403248094,1070.9633562844247L640.2001834679395,1072.882929051295L636.6849069418386,1082.6129178944975L636.3164971275255,1083.6054758690298Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M614.2702857851982,1075.0522016971372L618.0403725234792,1064.613676299341L618.7842921288684,1062.5650891368277L624.7301267711446,1064.7406075303443L620.2153315395117,1077.2277161753736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M566.952107777819,1053.608105439227L569.0568559300154,1047.8243993981741L581.820244369097,1052.4948542467318L579.715496217832,1058.292081861291Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M450.7231499394402,1205.6026699952781L451.00004896428436,1204.844219241757L455.57795508299023,1192.2023207349703L461.1056800847873,1194.2217383808456L456.2650748891756,1207.6220837370493Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M499.37375659123063,1063.6356814871542L503.29925389401615,1052.835072153248L510.1168076917529,1055.3227200112306L506.190521501936,1066.1368509237655Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M593.3853148007765,1098.1681785788387L597.3258009413257,1087.1699439031072L604.0013552373275,1089.5722653106786L600.060869098641,1100.5715365917422Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.29299349617213,1089.4515770315193L464.1239583576098,1070.5940075344406L466.1087958198041,1071.3243816657923L464.5420679980889,1075.6608464191668L466.966315026395,1076.561848594807L461.7147001652047,1091.0611007264815Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M619.97472127527,1077.900866619777L620.2153315395117,1077.2277161753736L624.7301267711446,1064.7406075303443L625.1553363865241,1063.5711754406802L630.2152519216761,1065.413759186864L629.6835426799953,1066.87346804142L625.5592460762709,1078.2837404138409L625.0275368355215,1079.74344655592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M571.1687040571123,1042.0282034538686L573.2237523850054,1036.3589344141074L585.9942407980561,1041.0356395267881L583.9320924980566,1046.7121876999736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M439.99429878685623,1202.6479368256405L445.1607139483094,1188.4038164005615L450.2064295336604,1190.246366968844L445.62773452699184,1202.8882690411992L445.0542143220082,1204.4904836080968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M492.7826131088659,1061.2260681469925L496.701799322851,1050.4254550598562L503.29925389401615,1052.835072153248L499.37375659123063,1063.6356814871542Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M521.8309775991365,1177.4265329339541L523.8300150120631,1172.0049907267094L536.9539244053885,1176.887604153715L534.955675878562,1182.3091425406747Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M456.2650748891756,1207.6220837370493L461.1056800847873,1194.2217383808456L466.2855063099414,1196.0996610098518L461.43149004969746,1209.5000027362257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M580.2535165483132,1093.4207637449726L584.1869027111679,1082.4287640410475L590.4585473183542,1084.696873311419L586.5251611545682,1095.6951119108126Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M479.71550351474434,1262.983546542935L503.1296433797106,1199.1116189588793L528.251721682027,1130.4625819935463L552.9911902183667,1062.4017431549728L558.9204582506791,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M445.62773452699184,1202.8882690411992L450.2064295336604,1190.246366968844L455.57795508299023,1192.2023207349703L451.00004896428436,1204.844219241757Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M435.8913021078333,1196.3337510530837L439.50518939550966,1186.3407001928426L445.1607139483094,1188.4038164005615L439.99429878685623,1202.6479368256405L437.47144099511206,1201.7334258463234L439.01608000602573,1197.4677871474996Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M602.5056271664798,1069.7647935086861L606.2623028410599,1059.3907662327401L612.6751580620185,1061.7358741471544L612.3848479716107,1062.557806193363L608.9263712475076,1072.103655399289Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M436.93973175343126,1241.6815250711516L441.7732369750738,1228.2521144757047L446.7408528337255,1230.0519982553087L441.9002476390451,1243.4814053620212Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M461.7147001652047,1091.0611007264815L466.966315026395,1076.561848594807L471.42352157086134,1078.1838602926582L471.0196118801832,1079.3179157171398L466.17269559483975,1092.6976748532616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M537.5921332715079,1043.2257306030951L539.6542815733701,1037.4784307433292L550.5890319999307,1041.4466067869216L548.5268836989999,1047.1866204007529Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.7536739269271,1120.6400636788458L640.7602926073596,1117.813264968805L645.0115998769179,1105.9431947991252L649.7315054964274,1107.643230639398L645.4652093928307,1119.555954775773L642.9778514746577,1118.6632814863697L641.9862216291949,1121.4557462707162Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M423.42532373405993,1236.769826240372L428.2659289287403,1223.347688905429L432.8651349749416,1225.0133628924377L428.02452977746725,1238.4500625170767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M625.5592460762709,1078.2837404138409L629.6835426799953,1066.87346804142L635.0053684068844,1068.808648227714L630.8668718514964,1080.217876996845Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M635.8983874870464,1116.0622514272109L640.383993932046,1103.5471215480939L645.2529990272596,1105.2981382529251L645.0115998769179,1105.9431947991252L640.7602926073596,1117.813264968805Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M428.02452977746725,1238.4500625170767L432.8651349749416,1225.0133628924377L437.35784139391035,1226.6499054008164L432.5180250843987,1240.0720363436267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M631.1145820915699,1114.3330861027353L635.5938774468377,1101.8179531041533L640.383993932046,1103.5471215480939L635.8983874870464,1116.0622514272109Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M432.5180250843987,1240.0720363436267L437.35784139391035,1226.6499054008164L441.7732369750738,1228.2521144757047L436.93973175343126,1241.6815250711516Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.607661257498,1072.9900921760127L608.9263712475076,1072.103655399289L612.3848479716107,1062.557806193363L618.0403725234792,1064.613676299341L614.2702857851982,1075.0522016971372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M582.9609736902639,1178.4045116947964L586.9929706193507,1167.49067706801L592.3226852053776,1169.4747281679884L588.2898993911222,1180.3885596697219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M419.1022278293967,1235.1967501798645L423.93573305010796,1221.7673270227388L428.2659289287403,1223.347688905429L423.42532373405993,1236.769826240372Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M465.4989868532866,1199.6006068265997L467.5611351560801,1193.7681237524375L477.50425573810935,1197.2971615460701L476.08662739023566,1201.3151852902956L475.44920741114765,1203.1369244446978Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.6849069418386,1082.6129178944975L640.2001834679395,1072.882929051295L645.7918082429096,1074.9242302351631L642.2765317196026,1084.6542162164114Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M531.0932894647121,1201.4285888271406L533.2264375165105,1195.6252384991385L539.7181813493371,1198.033764728345L537.577933321707,1203.8454362303019Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M520.1254058210179,1087.5913125937805m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M610.5688321366906,1186.281397297047m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M586.5251611545682,1251.854483955074m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M550.0123562524095,1165.8395549268462m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M611.4831511434168,1217.1822987655178m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M429.4035027064383,1068.7160509089008m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M482.0332509186119,1088.654618166387m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M455.18430091347545,1078.0069892485626m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M602.1316951466724,1212.1301288795657m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M425.28709496278316,1117.1432396373712m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M492.7881353115663,1172.9153440147638m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M612.9859791910276,1137.6809432166629m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M594.0030126282945,1210.0316461934708m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M509.0557558685541,1244.1857514525764m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M587.5459797848016,1206.3642418626696m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M505.72744535282254,1253.2465280955657m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M548.3501732097939,1189.409884447232m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.3285114178434,1227.872370150406m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M606.4492688495666,1134.4452705485746m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M632.7373208282515,1146.0499879573472m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M602.6397378053516,1103.6355567472056m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.73975635599345,1076.1716917790473m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M572.7867094771937,1123.5282454881817m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M586.4036726932973,1127.5255037765019m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M565.0840254602954,1247.477554098703m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M590.0009933719411,1185.4979747869074m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.282690868713,1170.4027686561458m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.87132663466036,1236.7667050603777m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M598.8175845826045,1133.9489952195436m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.4377866750583,1123.2733447640203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M495.08379390183836,1162.1294706012122m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.8456552596763,1247.8677012738772m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M467.66684589535,1132.1209954270162m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M640.5567599898204,1145.2738437550142m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M568.9550896212459,1170.5806777467951m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.325699692592,1228.1990543096326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M581.5701674716547,1172.94759653043m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M472.9815716454759,1168.4790612729266m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M579.6744741387665,1125.3708132985048m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M625.4172465754673,1144.817104701884m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M580.607726411894,1205.1844296716154m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.4019827907905,1146.2840796899982m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M517.2751602912322,1215.5415924317203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M477.92867646645755,1226.0017388979904m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M610.2698443010449,1103.5616873456165m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.076791593805,1092.5166425155476m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M490.2289887564257,1140.1748030814342m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M559.6919888705015,1099.1180773228407m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M495.41670384351164,1144.1044252491556m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M435.6238697152585,1120.9095302606001m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M438.5608927179128,1074.95960446354m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M470.44845833349973,1049.3340522241779m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M591.8414646759629,1132.528836060781m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M463.7145264642313,1046.8713723593391m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M477.31176752597094,1051.4533919878304m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M490.9965749466792,1055.8252434958704m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M468.78390863351524,1243.679080048576m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M427.29638789594173,1189.38179361308m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.0827770419419,1053.9264744399115m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M563.543330879882,1085.3804271989502m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M434.09579731244594,1191.3377476236783m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M548.3359732590616,1231.5897020618431m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M601.3467534640804,1064.0112731275149m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M438.8078140709549,1157.073098971974m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.3571465909481,1159.8228916549124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M575.2109565064311,1171.6928695738316m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M617.5985962999985,1104.4689283780754m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.74704449623823,1129.9559022751637m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M481.49049727153033,1210.0066766380332m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M478.9676394779235,1216.977340544574m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M452.2078336048871,1162.292814232409m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M459.2320755645633,1164.8262006277218m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M511.42714752815664,1061.9273114949465m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M577.4229931691661,1047.6048702560365m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M483.9518219474703,1203.2211967753246m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.5740504618734,1125.8847762281075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M466.0575182233006,1167.284676973708m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.44172022491693,1138.0627732984722m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.73907601460814,1236.9893493964337m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M478.7996067367494,1136.0006825183518m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M524.9983553476632,1189.065511637833m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M595.4971629288048,1061.1834109094925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M541.5026417393237,1229.123965752311m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M527.2600918356329,1182.932343476452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M510.07815227191895,1228.262518429663m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M456.0528645236045,1127.8792433375493m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M473.3144815862179,1133.998934877105m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M622.5330789433792,1258.87712532375m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M512.4653216535226,1221.4344001803547m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M554.977605452761,1234.0096601317637m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M561.5206268820912,1236.3630321356468m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.4392992928624,1087.0430130832829m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M591.9242977173999,1091.432529217098m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M507.7225383352488,1234.9772269674577m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M431.9295160425827,1155.9567431742325m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M635.5362887615338,1076.550403995905m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M619.4990229485556,1069.895886321552m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M574.3865705169737,1053.0514798671938m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M456.0552311819047,1199.5329808462411m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M504.7460710266605,1059.479201993905m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M598.6937294630334,1093.8702232772484m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M462.1296542612836,1083.0061956006102m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M624.9494371106848,1072.050594041124m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.10154748894274,1196.447154671885m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M498.0397501727566,1057.0300512081012m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M529.3924510022625,1177.1570685491897m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M461.27213505562395,1201.8613949683495m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M585.3568208189681,1089.058299691882m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M630.7469611624256,1106.7963340114802m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.6032392475754,1197.5447767493315m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M440.52364136930555,1192.3687848621048m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M607.4448431264609,1066.1618209970184m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M441.8387145213783,1235.8667641021311m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M466.3667615791783,1085.1889904984273m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.1460182406008,1230.8915970576927m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M630.2791516976431,1073.5456757280044m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M640.4557825690135,1111.0027249590494m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M432.6900022570044,1232.5499864695594m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M635.7484991252422,1108.940626130905m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M437.1472088014707,1234.1625981261022m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M613.4853441007435,1068.358146651648m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M587.6414350057021,1173.9391011665575m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M641.2383575933054,1078.7685751318932m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M625.6862567402422,1112.3708678907715L625.8992559919134,1111.7747113476507L629.9667527955025,1100.4154744101688L630.1726520713419,1099.8619738374837L635.5938774468377,1101.8179531041533L631.1145820915699,1114.3330861027353Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M807.0062078507617,1071.3951301518828L818.3464457402006,1046.309544133488L842.9857257399708,1046.309544133488L839.1233393261209,1054.5215955362655L849.2928702216595,1059.2347031226382L844.6581643009558,1070.2121737361886L837.8335105301812,1085.4979942976497Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.6005250569433,1125.1263167513534m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,1101.8054681308568L711.1928337560967,1046.309544133488"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M828.5782986395061,1249.341937202029L847.6133316848427,1215.0921407882124L853.4668666506186,1209.3158522532322"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M818.4229676937684,1245.7203309470788L808.8451013825834,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M760.2836388610303,1220.2296210383065L818.4229676937684,1245.7203309470788"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M818.4229676937684,1245.7203309470788L828.5782986395061,1249.341937202029L837.8335105301812,1254.2879600422457"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M837.8335105301812,1254.2879600422457L843.7935451203957,1237.8757650875486L853.4668666506186,1209.3158522532322L858.4912823121995,1200.6368448315188"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,1094.8482138239779L710.216192746535,1119.8327042823657L853.4810666013509,1180.9337305943482L858.4912823121995,1182.9271414657123"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M704.5417349282652,1262.983546542935L665.5068611195311,1243.1058234437369"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M660.6165560986847,1256.457175930962L658.2293867170811,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,1171.1216878271662L853.4810666013509,1180.9337305943482"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M737.0020318627357,1046.309544133488L734.7505508931354,1052.4095396627672L710.216192746535,1119.8327042823657L685.3986244853586,1188.1416352540255"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M685.3986244853586,1188.1416352540255L665.5068611195311,1243.1058234437369"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M718.1744758645073,1201.761516630184L760.2836388610303,1220.2296210383065"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,1103.4951008441858L734.7505508931354,1052.4095396627672L717.7334885271266,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M665.5068611195311,1243.1058234437369L660.6165560986847,1256.457175930962"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M641.8174000009894,1172.1454452439211L685.3986244853586,1188.1416352540255"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M837.8335105301812,1254.2879600422457L856.9379655532539,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M685.3986244853586,1188.1416352540255L708.8632530616596,1197.6800287463702L718.1744758645073,1201.761516630184"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M853.4810666013509,1180.9337305943482L848.406951116398,1190.3660130933858L818.4229676937684,1245.7203309470788"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M660.6165560986847,1256.457175930962L641.8174000009894,1249.611398781184"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M700.8978699669242,1178.1839462849312L718.5507745416835,1130.6113606309518L782.4939385149628,1158.979122620076L774.9742760751396,1181.047134462744L781.7492300234735,1183.655422956217L770.722968807444,1208.7914915280417Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M849.9728900529444,1244.4520920547657L873.1677195774391,1199.3665168937296L889.0061860885471,1206.3403126928024L887.1357371127233,1210.6340366778895L901.3869647625834,1216.9128359253518L892.2027526218444,1237.9392291177064L896.9644692074507,1240.0366629608907L899.7713260017335,1233.609108231496L913.0230349451303,1239.4342750315554L910.0962674617767,1246.1458515725099L921.3221168639138,1251.0856343396008L923.2706655655056,1246.6348361237906L925.8716230839491,1247.7761467392556L924.0003852210939,1252.0636027120054L929.1171005573124,1254.3098082644865L936.0198540547863,1238.5062437844463L935.1268349736929,1238.1233788407408L937.614192891866,1232.4397046272643L939.9808512330055,1233.4821800924838L936.4166637705639,1241.6315861893818L938.9892213894054,1242.7656148727983L938.0536024570465,1244.9057033648714L951.7944207917899,1250.9503833865747L937.7625034805387,1283.0817747316323L900.0332361897454,1266.4771758560091L901.6630749022588,1262.7432164088823L899.4873270010576,1261.7787746214308L898.2897978778929,1264.5077179768123L888.3403662079945,1260.127674936317L889.906305144541,1256.5487303500995L887.8086569681764,1255.6207013940439L885.8033084655181,1260.212986963801Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.5064232172444,1262.8202052856795L729.5841357326135,1245.5008080708794L734.3963410286233,1247.698117303662L739.2645572386682,1242.3973156702705L740.1859762193635,1241.4828099352308L753.2396747479215,1248.1017895690165L754.4301038943231,1246.3091932255775L759.1429095398635,1235.4516467861831L802.3928018556908,1254.3524643140845L791.5716510303319,1275.5275194840506L777.922343484126,1268.4611986298114L768.2845218284056,1287.361926167272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M837.8335105301812,1085.4979942976497L844.6581643009558,1070.2121737361886L860.185020797886,1076.9509649677202L866.6830757185817,1061.3176251444966L854.7211955729872,1056.0031555304304L859.6675115078688,1040.568489367608L906.5391799733043,1056.1019955463707L880.4814827395603,1105.4115433609113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M794.3004080979154,1300.5644184397534L815.6736995857209,1257.1022184137255L844.7220640769228,1269.8646837188862L825.3044212665409,1309.3587833060883L822.6253640223294,1314.5180417336524Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M788.1486741807312,1144.7141043175943L788.5880837459117,1143.6580901974812L795.5965479835868,1126.9543183902279L798.7860145419836,1128.3016499667428L797.467785846442,1126.0834946753457L797.1206759558991,1124.6019496610388L797.0922760553658,1122.9789084070362L797.070976129733,1121.569151113741L801.1171730095521,1110.4565081256442L813.9799610991031,1115.1695776851848L809.9400753080845,1126.2811727090739L808.3102365974337,1128.6907634362578L806.9004971114919,1129.7114058895968L805.6461681909859,1130.2357725957409L804.0155405914411,1130.512521672994L854.0971866557375,1151.6661065476947L846.6493128528818,1169.4393544229679Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.7314403429627,1100.1740982243791L678.2410607729107,1098.749770487193L678.9289694642648,1096.8572556767613L679.9134993338957,1097.232845517341L692.0536677436903,1065.7404510038905L696.7167735630646,1067.546619491186L702.5774085046723,1052.3387909820303L720.6973336571828,1059.3689173972234L701.846899962984,1108.3028527554125L683.7190859476104,1101.2582101579756L683.3009763071314,1102.3423219202086Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M615.9845353094861,1201.7188602550887L619.43591205962,1192.2938760044053L629.5770430555567,1196.042438999284L633.6942396843806,1184.8102691629902L670.0421673888341,1198.23248110665L660.4327456336468,1224.4390643495135L636.3590969778597,1215.5457540210336L637.1740163331851,1213.341151815839L638.39284538012,1209.9889898719266L622.6324785938486,1204.1783639150672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M799.7713332986459,1193.9595574513078L808.756746138446,1173.2451519747265L811.9320127479732,1172.096546264831L813.8876614235342,1172.7988187987357L837.7128109531477,1183.4847970125265L827.409169417806,1206.4672413282096Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M733.7439322117716,1086.3053576922975L742.0430141314864,1064.1028300914913L768.433621305041,1074.0388341275975L764.3306246260181,1085.016281297896L761.9489774471149,1084.1152802249417L761.5663676820695,1085.1650609131902L763.9480148600414,1086.057738516014L760.1353282704949,1096.2413299079053Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M783.5494681354612,1101.2093106782995L787.7944643162191,1091.3513767756522L786.6040351688862,1090.8342900401913L789.6728021530434,1083.6980729908682L823.7873932691291,1098.502151755616L821.1020249361172,1104.7519209696911L820.3226054552943,1104.4189885077067L816.700829305686,1112.8380132107995L804.6182495830581,1107.5943312044255L804.0865403423086,1108.8407464544289L792.8117800010368,1103.9518426200375L792.3439705343917,1105.0213881656528Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M838.4922304339707,1135.309850757476L843.6373456697911,1123.3690625908785L850.9582088077441,1126.5433561955579L852.751346946694,1122.3910760660656L845.3807839816436,1119.194931909442L846.8197122542188,1115.864573101513L849.4979806123301,1109.621056385804L871.6869803406298,1119.2583970259875L858.724792602472,1143.9910207754L852.3750482695177,1141.3338181641884Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M661.3888756036758,1164.5848266878165L669.099448482506,1143.0629767519422L688.0563818030059,1149.8942934116349L680.8633182151243,1169.9990918668918L678.8153698630631,1170.8855161229149Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.9641183549538,1281.1258466052823L630.8526719007641,1262.0201451773755L628.5775243481621,1261.1909540477209L631.3843811433762,1253.41715232376L646.6840384388342,1258.9863663557917L647.3577471803874,1260.9214929174632L638.2161348899826,1286.2913683610968L637.6773256743327,1286.1072199176997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M770.5383694563061,1134.5305841257796L778.6528520258144,1115.1903859325685L797.0922760553658,1122.9789084070362L795.5965479835868,1126.9543183902279L788.5880837459117,1143.6580901974812L775.1375755015761,1137.974338541273L775.704784616828,1136.6207663910463Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M766.3998729027808,1104.55424232129L774.372355970554,1084.6334078786895L770.453169756569,1083.053014372941L772.9263277240098,1076.8947823913768L789.1552928620949,1083.4494133051485L788.3332735309377,1085.5052772131748L787.0860445853323,1085.7528964099474L785.7181160626933,1089.1758667309768L778.8011626154184,1106.4529975117184L776.5623038243502,1105.5457567423582L774.5987662859261,1110.4565081256442L772.5437179589644,1111.3928798148409L768.7026314688846,1109.8405835651793L767.6116019738838,1107.685887590982L768.5259209796786,1105.4115433609113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M774.9742760751396,1181.047134462744L782.4939385149628,1158.979122620076L796.1495571481064,1165.0384432263672L788.5028840461746,1186.2637104676105L781.7492300234735,1183.655422956217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M649.6179058970883,1159.4899618383497L658.9512175116688,1133.4464773950167L670.070567288436,1137.457255282905L668.1851294767112,1142.7300461325794L660.7443556496873,1163.5080074933358Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M794.0235090712085,1066.164942254778L796.5676667895168,1059.815257877577L797.8290956858546,1060.3261044011451L801.4366718856618,1051.3046116516925L800.1823429642245,1050.8010474182665L800.7913630446419,1049.2560205557384L801.2378725847229,1048.1438090866432L802.0456919651479,1048.4694612962194L802.8748112721369,1046.4146268237382L807.7154164668173,1048.363338212017L808.5729356743395,1046.223189048469L813.4908517086878,1048.2072748541832L812.5694327270612,1050.5034867152572L815.4252004595473,1051.6583551014774L813.3275522822514,1056.903119836934L811.9604126475751,1056.356898739934L808.4806359978393,1065.0381676219404L809.4020549785346,1065.4064762494527L807.0062078507617,1071.3951301518828Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M839.1233393261209,1054.5215955362655L847.6133316848427,1036.4723406489938L859.6675115078688,1040.568489367608L854.7211955729872,1056.0031555304304L852.9635573094711,1060.934750416316L849.2928702216595,1059.2347031226382Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M779.6231819465756,1060.3614787012339L780.4949011020362,1058.1641100924462L785.0309962574393,1046.8255937653594L786.4833355937153,1043.2330135637894L800.7913630446419,1049.2560205557384L800.1823429642245,1050.8010474182665L796.5676667895168,1059.815257877577L794.0235090712085,1066.164942254778Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M756.0883425055072,1130.7674221340567L756.5490519963205,1129.5553443636745L762.7638968024403,1112.9867922239937L771.984397704713,1116.4596888814121L773.940046380274,1111.2441007648595L777.490033893846,1112.5903949821368L768.688431520015,1136.0891173025593L762.083876973018,1133.5952559676953L762.2826762739569,1133.0563237834722Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M751.4749365122989,1039.4978934549727L753.8849835898727,1032.87247211067L780.6298006270081,1042.9635439636186L779.8574811220169,1044.7353844279423L777.7811328703538,1049.9156482270919L776.8810138134286,1049.5681472234428L771.3674887632951,1047.5205960338935L771.5733880391344,1046.9816571543925L764.8481339169666,1044.473197847139Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M824.1068921461701,1125.239721534308L827.4872691445053,1117.3731706971303L827.0407596034929,1117.175492411945L830.8179463176057,1108.3944091317244L829.7829277347773,1107.9480717820115L832.7806949689984,1100.9887428125367L841.4126868294552,1104.7311126915738L838.4149195952341,1111.6966803809628L837.2663014130667,1111.1941609443165L833.4891146998852,1119.9742002650164L833.0426051598042,1119.775481642224L829.6551281856373,1127.6565955006517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M815.4962002104148,1121.7886779145338L818.9972767839208,1113.6817878619768L818.4513675943017,1113.4549779151566L822.0234439177439,1105.162884452846L821.1020249361172,1104.7519209696911L823.7873932691291,1098.502151755616L824.3049025591463,1097.318159550894L832.7806949689984,1100.9887428125367L829.7829277347773,1107.9480717820115L828.5072988895699,1107.3956122249365L824.7301121754572,1116.1756563568488L824.3120025340468,1115.9915033942088L820.8251259103417,1124.0983907454647Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M686.9014525311068,1216.1190129052848L690.9547493858263,1205.333206705749L706.4532059822232,1212.413117076736L702.7896188693121,1222.1429100967944Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M833.1633047340438,1129.1724734003656L836.5578816831112,1121.3069674368016L835.9693726422265,1121.0447837528773L839.746559355408,1112.2782711545005L838.4149195952341,1111.6966803809628L841.4126868294552,1104.7311126915738L850.0083899265155,1108.4589147600345L849.4979806123301,1109.621056385804L846.8197122542188,1115.864573101513L845.4872836079448,1115.2829826320522L841.8939073570073,1123.6239633113146L841.48289769236,1123.439810546115L838.0954207191244,1131.312596957665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M709.3941734153777,1257.2863676268607L717.9125656755641,1240.5402134521864L728.8615160519257,1246.1458515725099L726.0838480452076,1251.6099918680266L721.6329525886104,1249.3273717109114L715.8859172482044,1260.6166585003957Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.9716489324346,1265.0247917599045L672.57212515641,1254.954850946553L688.1131816031411,1262.8420534785837L685.243213920854,1270.8780226646923L684.1868954133242,1270.5024422314018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.4119414659217,1241.2560041691177L679.8290885202587,1234.856541219633L696.4966743374243,1241.1852574152872L695.3985448665917,1244.0973180504516L699.1544316550717,1245.521615926642L696.5676740882918,1250.7100528334267L695.2352454410866,1250.1992203369737Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M731.6328729698434,1091.9673029771075L733.7439322117716,1086.3053576922975L760.1353282704949,1096.2413299079053L758.5686004487798,1100.4643738945015L751.4465366108343,1097.7863462995738L750.9085162803531,1099.2314825314097Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M670.6164764799178,1135.9549045125023L673.1322342986241,1128.932138628792L678.0643502827734,1130.7112399931066L692.995597762987,1136.1036830320954L690.4869399201125,1143.126441651024Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.312900098972,1226.5864412672818L634.367948426865,1220.9807873326354L658.4479081705213,1229.875131082721L656.3857598686591,1235.4807778261602Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M679.8290885202587,1234.856541219633L682.8339557284489,1226.8340554242022L698.5233227647841,1232.7871964648366L699.5157414954156,1233.1700617051683L696.4966743374243,1241.1852574152872Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.1851294767112,1142.7300461325794L670.070567288436,1137.457255282905L670.6164764799178,1135.9549045125023L690.4869399201125,1143.126441651024L688.0563818030059,1149.8942934116349L669.099448482506,1143.0629767519422Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M725.7083382532,1110.0528278439306L727.9471970461309,1104.0579648525454L740.8383850352839,1108.9187774495222L749.0372784193605,1111.9952788697556L748.1016594879329,1114.4818650856614L746.5854203766212,1118.5217854743823L737.5006078863516,1115.0842638695613L737.69151832629,1114.5890275696293Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.367948426865,1220.9807873326354L636.3590969778597,1215.5457540210336L660.4327456336468,1224.4390643495135L658.4479081705213,1229.875131082721Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M675.3426931900904,1121.9020827524364L677.6249407175928,1115.545166533906L697.7581032337621,1122.802038504742L695.4758557053283,1129.1589480666444L680.5517082009465,1123.772742091678Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.484262086451,1231.9725673655048L632.312900098972,1226.5864412672818L656.3857598686591,1235.4807778261602L654.4727110415697,1240.7170803532936Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M633.8717390596867,1153.7781321834773L640.8660033484921,1134.437987683341L647.2441475782543,1136.7695448943414L640.2498832922429,1156.0951172020286Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M727.2174773905426,1103.7739318185486L729.6267355829477,1097.325442457106L748.9023788934574,1104.5896163950674L746.8615305162966,1110.060110737104L741.2067948514596,1107.9272635146044L740.8383850352839,1108.9187774495222L727.9471970461309,1104.0579648525454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M628.5641132853925,1236.8124824007973L630.484262086451,1231.9725673655048L654.4727110415697,1240.7170803532936L652.6440730299801,1245.7068058406003Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M642.9352516233921,1054.3447238882072L646.7550381878391,1043.409885498695L650.6387245273218,1032.311683170963L657.2148791747168,1034.6224662396125L653.2680819462985,1045.9464366049506L650.5961246779189,1045.011096496135L646.8544378392398,1055.7264034752734Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M749.5192878348753,1126.9054190921597L752.8357650581747,1118.060883010272L753.3532743491232,1116.6864987304434L754.7212028708309,1117.2108664219268L755.2024234002456,1115.9415636067279L753.8352837637067,1115.417195819784L755.7412326158956,1110.3295777300373L762.7638968024403,1112.9867922239937L756.5490519963205,1129.5553443636745Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M727.841486306861,1239.640272980556L734.353741178289,1224.6159316608682L741.0221954993904,1227.5290396469645L735.3177600093186,1240.6744242184795L734.5099406288937,1242.5315263997763L733.2414117576554,1241.971794811543L732.3838925519958,1243.9485418484546L728.2730070119724,1242.1632271823473L729.1163262668997,1240.2072875113226Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.2498832922429,1156.0951172020286L647.2441475782543,1136.7695448943414L652.0279529737309,1138.5059874830768L649.3630956821144,1145.8689570128918L651.0639341427013,1146.4932016292587L646.733738264069,1158.462040928658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M721.3710423987359,1236.7063622018322L727.8485862817615,1221.7673270227388L734.353741178289,1224.6159316608682L727.841486306861,1239.640272980556L726.7070680754259,1239.1512879375368L725.8708487935364,1241.0791372847743L721.9800624800846,1239.3708110167645L722.8517816355452,1237.3514065220952Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M714.5747885275632,1238.3012861940078L717.1544461194426,1232.3481498863548L716.5801370283589,1232.0859704008326L722.1433619046584,1219.2734965081327L727.8485862817615,1221.7673270227388L721.3710423987359,1236.7063622018322L719.7057038126513,1240.5402134521864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M708.4948432454839,1235.5296763591468L716.5943369790912,1216.8493717024103L722.1433619046584,1219.2734965081327L716.5801370283589,1232.0859704008326L714.0359793119133,1237.9610773893073Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M699.1615316309035,1231.7457612906583L700.7345705414191,1227.5644130930305L702.7896188693121,1222.1429100967944L706.4532059822232,1212.413117076736L712.3351408485323,1214.9860202576965L704.2356471167877,1233.673612695653Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M748.72566840332,1046.9389998302795L751.4749365122989,1039.4978934549727L764.8481339169666,1044.473197847139L763.5370051944628,1048.1999918953516L761.7935668826103,1052.920386732556Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M729.6267355829477,1097.325442457106L731.6328729698434,1091.9673029771075L750.9085162803531,1099.2314825314097L748.9023788934574,1104.5896163950674Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M678.0643502827734,1130.7112399931066L680.5517082009465,1123.772742091678L695.4758557053283,1129.1589480666444L692.995597762987,1136.1036830320954Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M658.2214978560805,1053.7423198232427L660.219746382907,1048.0023116385564L664.053732897155,1037.0320888264105L670.8783866707236,1039.4344276073389L670.6582874441519,1040.0722073181532L666.8108898662031,1051.0705167115666L666.3856802508235,1052.296133688651L662.7071043010801,1050.9924850640818L661.3683645650744,1054.8545303950086Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M761.7935668826103,1052.920386732556L763.5370051944628,1048.1999918953516L764.9822445567697,1048.7389306798577L766.1371738268062,1045.5781269441359L771.3674887632951,1047.5205960338935L776.8810138134286,1049.5681472234428L773.6426363158971,1058.3482645903714Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M735.3177600093186,1240.6744242184795L741.0221954993904,1227.5290396469645L750.1638077888638,1231.526237973012L742.276524421759,1239.4061843995005L740.1859762193635,1241.4828099352308L739.2645572386682,1242.3973156702705Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.1202526502311,1049.227929154411L653.2680819462985,1045.9464366049506L657.2148791747168,1034.6224662396125L664.053732897155,1037.0320888264105L660.219746382907,1048.0023116385564L657.5982778267935,1047.0804972997867L656.3368489295244,1050.7157328100875Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M684.8464042050764,1221.540520611219L686.9014525311068,1216.1190129052848L702.7896188693121,1222.1429100967944L700.7345705414191,1227.5644130930305L700.5357712414116,1227.479100663215Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.8339557284489,1226.8340554242022L684.8464042050764,1221.540520611219L700.5357712414116,1227.479100663215L698.5233227647841,1232.7871964648366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.5801732549444,1088.410120323766L656.1309496536851,1078.5740169975907L658.2640977073461,1072.6779665648937L663.5646235067397,1074.6058622025885L661.4385754289106,1080.501910995692L657.8814879413694,1090.3307286752388Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M704.2356471167877,1233.673612695653L712.3351408485323,1214.9860202576965L716.5943369790912,1216.8493717024103L708.4948432454839,1235.5296763591468Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M664.6635418636724,1061.7930972692557L668.2277293261141,1051.5803234609775L666.8108898662031,1051.0705167115666L670.6582874441519,1040.0722073181532L675.1659827008843,1041.652610622812L670.3821773054078,1055.3435284378938L667.7457199115306,1062.8907406656072Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M670.3821773054078,1055.3435284378938L675.1659827008843,1041.652610622812L681.0621175160632,1043.7355379275978L677.17133120168,1054.8899047221057L676.2854120954871,1057.4129261551425Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M854.9618058362976,1192.8754600165412L833.4394148737192,1235.4807778261602"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M642.2765317196026,1084.6542162164114L645.7918082429096,1074.9242302351631L647.8965563960373,1069.1207740139216L652.049252900295,1070.6366647165269L650.0226044729352,1076.235157287214L651.2343335449696,1076.6814966802485L647.6480572707951,1086.6101997736841Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M734.5383405284956,1122.9934741635807L735.2112603839487,1121.1935625891201L737.5006078863516,1115.0842638695613L746.5854203766212,1118.5217854743823L744.1974621089175,1124.8859818382189L743.6160530438647,1126.4237089725211Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.2596466373652,1056.6763080353849L686.1504329517484,1045.521944114007L691.4580587269738,1047.3926240629517L687.5601724376902,1058.5469849738292L686.8446527319029,1058.2993648084812L685.6258236858994,1061.8139056763612L684.4424945143983,1062.2248717048205L683.1171658430248,1061.7504400331527L682.7700559534132,1060.8286275253631L684.0101849241182,1057.2995202648453Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M663.5504235569388,1093.3926725252531L663.8699224330485,1092.5208041798323L667.427009921521,1082.684706682805L669.1846481822431,1077.808269420173L671.8495054757223,1078.7727368013002L670.6866873437539,1081.9969908632338L672.728324607946,1082.7481721346267L668.2561292275786,1095.1072772555053Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.2561292275786,1095.1072772555053L672.728324607946,1082.7481721346267L678.0075504826382,1084.676064970903L673.5432439632714,1097.0351666552015Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M742.276524421759,1239.4061843995005L750.1638077888638,1231.526237973012L754.4088039696217,1233.3823022106662L749.9160975506529,1243.7217361633666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M647.6480572707951,1086.6101997736841L651.2343335449696,1076.6814966802485L652.9422719813883,1071.9621584406123L655.7554398644716,1072.9900921760127L654.0120015516877,1077.794743988663L656.1309496536851,1078.5740169975907L652.5801732549444,1088.410120323766Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M639.7536739269271,1120.6400636788458L640.7602926073596,1117.813264968805L645.0115998769179,1105.9431947991252L649.7315054964274,1107.643230639398L645.4652093928307,1119.555954775773L642.9778514746577,1118.6632814863697L641.9862216291949,1121.4557462707162Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M635.8983874870464,1116.0622514272109L640.383993932046,1103.5471215480939L645.2529990272596,1105.2981382529251L645.0115998769179,1105.9431947991252L640.7602926073596,1117.813264968805Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M655.110131021589,1123.0361310220324L659.3764271270484,1111.1306957532652L664.4434426380321,1112.9514181925915L660.1771465325728,1124.864133210387Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M775.3221748517826,1056.0811871197075L777.7811328703538,1049.9156482270919L779.8574811220169,1044.7353844279423L785.0309962574393,1046.8255937653594L780.4949011020362,1058.1641100924462Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M650.0928153377026,1121.2216536994092L654.3591114422306,1109.3234982108697L659.3764271270484,1111.1306957532652L655.110131021589,1123.0361310220324Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.8814879413694,1090.3307286752388L661.4385754289106,1080.501910995692L667.427009921521,1082.684706682805L663.8699224330485,1092.5208041798323Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M660.1771465325728,1124.864133210387L664.4434426380321,1112.9514181925915L669.3826585980132,1114.7305236589164L665.1171513795853,1126.6432356173173Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M673.5432439632714,1097.0351666552015L678.0075504826382,1084.676064970903L682.713256153278,1086.3906718594953L678.9289694642648,1096.8572556767613L678.2410607729107,1098.749770487193Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.1171513795853,1126.6432356173173L669.3826585980132,1114.7305236589164L674.116764168255,1116.4451231113635L669.8575680386275,1128.3505492545664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.17133120168,1054.8899047221057L681.0621175160632,1043.7355379275978L686.1504329517484,1045.521944114007L682.2596466373652,1056.6763080353849Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M645.4652093928307,1119.555954775773L649.7315054964274,1107.643230639398L654.3591114422306,1109.3234982108697L650.0928153377026,1121.2216536994092Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.6849069418386,1082.6129178944975L640.2001834679395,1072.882929051295L645.7918082429096,1074.9242302351631L642.2765317196026,1084.6542162164114Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M749.6967872101814,1244.2398518882692L749.9160975506529,1243.7217361633666L754.4088039696217,1233.3823022106662L759.1429095398635,1235.4516467861831L754.4301038943231,1246.3091932255775Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M687.5601724376902,1058.5469849738292L691.4580587269738,1047.3926240629517L696.0714647220448,1049.0156830134802L692.1735784327611,1060.1700413129292Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M744.1974621089175,1124.8859818382189L746.5854203766212,1118.5217854743823L748.1016594879329,1114.4818650856614L749.8166978992522,1115.1269207783043L749.236077719368,1116.6864987304434L752.8357650581747,1118.060883010272L749.5192878348753,1126.9054190921597Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M669.8575680386275,1128.3505492545664L674.116764168255,1116.4451231113635L674.8117728345096,1114.5245219948702L677.6249407175928,1115.545166533906L675.3426931900904,1121.9020827524364L672.6715248068795,1129.3711917558685Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M741.8410592861474,1168.5820613042451m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M698.8049551062286,1082.2019530744292m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M648.6546759512275,1207.0841977018863m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M818.7038111500442,1188.7221792112105m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M852.9761794880033,1130.9266048632562m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M783.0674587208778,1130.7424522931688m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M776.0582055961713,1096.8645385811105m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M785.4838168881834,1173.0433136676438m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M658.9030954586342,1151.1094888448715m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M849.9184569101781,1047.5445257513784m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M766.2973177079111,1123.0069995089434m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M832.0454531097785,1114.4360869377851m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M823.3613947667181,1110.7010051901452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M840.6032896758988,1118.4541587056592m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M745.8809450762346,1094.104316771496m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M681.8060371214524,1136.0287735676393m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M645.380009691231,1228.2302661738358m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M689.671231678687,1234.0138217103668m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M679.246101681143,1142.896511444822m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M737.3609750447795,1111.0235332180746m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M647.401135914959,1222.7099260580726m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M643.4669608660042,1233.7266728188843m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M733.302944874391,1100.5496878884733m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M755.1898012217134,1122.4826322565787m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M734.4302631309256,1233.5841387612745m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M645.6569087188691,1151.293640874792m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M722.2159394286573,1226.9266506303102m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M716.0642055105418,1225.679216215387m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M704.9101447425783,1224.854182322044m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M740.2672314886004,1098.2784625575878m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M686.7704974375665,1129.9350940734148m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M769.3376847915351,1051.2442671796307m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M741.8994368584827,1235.466212305706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M693.8184059802443,1221.842235560529m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M691.6836801562458,1227.1565780495293m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M657.0074021266773,1084.4554965794086m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M710.4142031623051,1225.2609771057032m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.6524576488882,1051.325420090463m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.8026137938723,1049.3132437779568m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M730.3667107569054,1115.8822601116262m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M646.7550381878391,1080.668377801776m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M740.8975514937192,1119.857674161438m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M686.8572749104351,1052.0339473932981m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M668.2987290769815,1087.6339696706273m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M673.1330231837928,1089.8916730750352m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M749.1958445264027,1236.3942439598031m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M651.8898979052901,1082.5921095502563m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M645.2458990514278,1112.7287698760629m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M659.777970158495,1117.9932562378235m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M779.5569155132398,1052.9984183600172m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M654.7354101175442,1116.1756563568488m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M662.6550378166139,1086.507198525127m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M664.780297008343,1119.7973302863538m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M678.1590166166425,1091.6239657453261m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.6177466604859,1121.5441812411882m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M681.6608820771798,1050.2059259992093m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M649.911371530965,1114.4392081736587m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M754.5302924308926,1239.5872129057534m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M691.8162130229175,1053.780815419741m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M748.4306249972433,1121.7033641827293m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M723.2343914005905,1116.679215844255L725.7083382532,1110.0528278439306L737.69151832629,1114.5890275696293L737.5006078863516,1115.0842638695613L735.2112603839487,1121.1935625891201Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M919.0043694609776,1062.3809347501956L897.2413682341576,1108.8199381856248"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1040.8438853444532,1250.7204567533918m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,1209.1993276486173L976.0660798624158,1158.2217071712948L862.1548694241792,1103.1860978477634L858.4912823121995,1101.8054681308568"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M933.7234065774828,1055.0033106515184L942.5960087021813,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1038.4717048006132,1107.034588725306L933.7234065774828,1055.0033106515184"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M883.4650500230491,1152.6222404013388L899.7287261513993,1121.08015774237"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M972.9910017903894,1234.1688404944725L991.7349358592182,1197.5874331472442"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M916.5738113438711,1089.317363338545L933.7234065774828,1055.0033106515184"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M866.8250752203166,1186.2418620330282L883.4650500230491,1152.6222404013388"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M991.7349358592182,1197.5874331472442L999.239609462209,1173.953666816L1000.0687287682667,1168.9295563451014L1000.6146379597485,1165.3713727770373"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M886.9937376119196,1115.2621743832715L858.4912823121995,1103.4951008441858"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,1125.6725324317813L1038.4717048006132,1107.034588725306"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M933.7234065774828,1055.0033106515184L935.4171450631693,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1019.2386613395065,1144.1824558489025L1038.4717048006132,1107.034588725306"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,1182.9271414657123L866.8250752203166,1186.2418620330282L972.9910017903894,1234.1688404944725L1029.1494375914335,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1007.5315914079547,1168.6673744590953L1075.1651646215469,1204.5924427062273"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1000.6146379597485,1165.3713727770373L899.7287261513993,1121.08015774237"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1072.120853108354,1046.309544133488L1068.0517785316333,1056.9884343659505"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M886.9937376119196,1115.2621743832715L872.7354099871591,1143.2263208334334"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M921.3457834469154,1046.309544133488L920.8543073991314,1048.902276983019"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M920.8543073991314,1048.902276983019L913.7361879916862,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,1200.6368448315188L866.8250752203166,1186.2418620330282"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M976.9945988189429,1262.983546542935L992.373144726269,1253.055096033495L1006.4823728753254,1245.748421552591L1019.9044812191278,1238.9744209991768L1030.1663117911667,1235.352809325792L1041.9088815990835,1231.9652846031822L1054.3030713368207,1229.7898186813109L1064.9617116227746,1228.6984440796077L1075.1651646215469,1227.9868136486039"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M872.7354099871591,1143.2263208334334L858.4912823121995,1171.1216878271662"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M957.5162117769942,1262.983546542935L1068.0517785316333,1056.9884343659505"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M899.7287261513993,1121.08015774237L916.5738113438711,1089.317363338545"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M991.7349358592182,1197.5874331472442L1007.0069821411744,1173.953666816L1007.5315914079547,1168.6673744590953"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M933.7234065774828,1055.0033106515184L920.8543073991314,1048.902276983019"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1007.5315914079547,1168.6673744590953L1000.6146379597485,1165.3713727770373"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M899.7287261513993,1121.08015774237L886.9937376119196,1115.2621743832715"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1038.4717048006132,1107.034588725306L1063.7728602495044,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1068.0517785316333,1056.9884343659505L1061.3478243350983,1094.1292867437005L1060.157395189628,1112.285554043483L1061.3478243350983,1132.935636258684L1063.6860827766359,1150.1783245559782L1068.0517785316333,1166.7540706433356L1074.3092231880873,1181.5288407891057L1075.1651646215469,1182.8615961275063"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1007.5315914079547,1168.6673744590953L1019.2386613395065,1144.1824558489025"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M957.5477672219276,1262.983546542935L972.9910017903894,1234.1688404944725"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M920.8543073991314,1048.902276983019L886.9937376119196,1115.2621743832715"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M849.9728900529444,1244.4520920547657L873.1677195774391,1199.3665168937296L889.0061860885471,1206.3403126928024L887.1357371127233,1210.6340366778895L901.3869647625834,1216.9128359253518L892.2027526218444,1237.9392291177064L896.9644692074507,1240.0366629608907L899.7713260017335,1233.609108231496L913.0230349451303,1239.4342750315554L910.0962674617767,1246.1458515725099L921.3221168639138,1251.0856343396008L923.2706655655056,1246.6348361237906L925.8716230839491,1247.7761467392556L924.0003852210939,1252.0636027120054L929.1171005573124,1254.3098082644865L936.0198540547863,1238.5062437844463L935.1268349736929,1238.1233788407408L937.614192891866,1232.4397046272643L939.9808512330055,1233.4821800924838L936.4166637705639,1241.6315861893818L938.9892213894054,1242.7656148727983L938.0536024570465,1244.9057033648714L951.7944207917899,1250.9503833865747L937.7625034805387,1283.0817747316323L900.0332361897454,1266.4771758560091L901.6630749022588,1262.7432164088823L899.4873270010576,1261.7787746214308L898.2897978778929,1264.5077179768123L888.3403662079945,1260.127674936317L889.906305144541,1256.5487303500995L887.8086569681764,1255.6207013940439L885.8033084655181,1260.212986963801Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M923.957785371691,1111.3429399947636L924.0713849719614,1110.1308588287793L924.4255948374048,1108.976000181865L924.6882939133793,1108.43706608098L925.3612137688324,1107.4382691802457L926.2116329995915,1106.5872108731419L926.693642414175,1106.2189044342376L928.0962819261476,1105.532231362071L927.1259520053864,1103.3494428656995L962.1130511630327,1087.7723450623453L963.0265812836587,1089.8635818404146L966.4424581574276,1089.0125213763677L967.3567771641538,1089.125926750712L968.1929964441806,1089.5087999245152L969.3337257653475,1087.5954742594622L970.1281340820715,1088.0137216774747L1011.1951785208657,1109.2881241585128L1010.2098597642034,1111.2149692024104L1011.2874781964347,1111.9026821264997L1012.2152082659304,1112.774548035115L1012.7114176312461,1113.3977552219294L1013.228926923126,1114.4818650856614L1013.4064262975007,1115.056172737386L1013.5902367625386,1116.2328790286556L1013.5476369131356,1117.423110473901L1013.2644267985597,1118.5925334799103L1013.0451164580882,1119.1449921447784L1012.4424074674025,1120.172918883618L1012.0739976512268,1120.6400636788458L1011.1951785208657,1121.4630291517824L1010.1885598385707,1122.0862355558202L1009.6434395341203,1122.3276109774597L1008.4948213519529,1122.6314110620879L1007.7722016712651,1122.7031994387507L1010.458358890377,1123.9496119711548L1001.1960470248014,1143.9702126146294L1000.3527277689427,1144.7921349084936L999.3461090885103,1145.4226220739074L998.8143998477608,1145.6494309720583L997.6665705507621,1145.9542704443447L996.4903413550928,1146.017735316418L995.335412084125,1145.8408660027198L993.8112841108814,1145.2457527415827L992.996364755556,1147.1517796413973L927.4659619210288,1119.1741236746311L928.2808812763542,1117.2462404309772L925.120603502728,1115.9061895906925L925.3115139426664,1115.2330428375863L924.6669939868152,1114.2415298046544L924.4113948866725,1113.7025961121544L924.0642849970609,1112.5331722833216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.779746714048,1191.8548268633895L1080.6660674959421,1172.6427582446486L1083.20312523935,1173.953666816L1087.3558217426762,1165.867645855993L1096.0225245915353,1149.0442807255313L1146.153870480135,1175.0304843881167L1145.7286608647555,1175.8524030013941L1123.5972498208284,1218.876064945478L1123.4481503460556,1219.1600932632573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M916.0847019525245,1199.522576849442L918.8481700113043,1193.0315201203339L921.7331265294924,1194.2716776044108L924.6172941625118,1187.4539298927411L921.7473264792934,1186.2418620330282L924.978604003787,1178.644844751805L937.8193032825366,1184.1163210598752L934.892535799183,1191.025627341587L943.1490178667009,1194.5546665280126L950.6323915449902,1176.8730385098606L947.705624062568,1175.6266354913823L949.2644630242139,1171.9623341714032L943.2129176426679,1169.3758897683583L949.9586828052998,1153.685535997618L950.3207815298811,1152.828240931034L993.3931744713336,1171.2257282226346L967.4206769382581,1221.44896572968ZM953.963068719022,1199.310335307382L957.4925451939926,1200.812672348693L957.8751549590379,1199.9116863235831L959.6817041607574,1200.677420412656L961.2129321070388,1201.3370336769149L963.2466805083677,1196.5314270816743L956.386526861228,1193.5974980592728ZM961.5742419464514,1181.0762657313608L968.4691065847874,1184.2005936219357L969.851235056296,1181.1178818293847L971.2333635287359,1181.7421232745983L972.5657921750098,1178.765531477984L964.280910205096,1175.0304843881167Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1064.3455915674567,1074.4778907313012L1069.2067078035325,1059.007891396992L1069.7384170433506,1059.2908858424053L1082.2107065068558,1065.853856756352L1090.2044895002618,1070.0561108682305L1096.6607334576547,1057.6823951941915L1094.8888952462003,1056.7616225667298L1108.1548041403294,1031.36281569954L1114.929758087732,1034.9200276238844L1101.5715495171025,1060.5029758973978L1126.0846077390015,1073.407300055027L1099.204891175963,1124.878698963672L1075.7899624239653,1112.5477380584925L1081.9842961914837,1100.6849417774938L1085.647883305326,1093.6756655666977L1082.6146161966026,1092.0807083025575L1082.5436164466664,1084.7395304040983L1083.521835227497,1082.8542946893722L1073.1116940667853,1077.3837788826786L1072.4095854256302,1078.7227967483923L1064.614601733163,1074.6266705701128Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M837.8335105301812,1085.4979942976497L844.6581643009558,1070.2121737361886L860.185020797886,1076.9509649677202L866.6830757185817,1061.3176251444966L854.7211955729872,1056.0031555304304L859.6675115078688,1040.568489367608L906.5391799733043,1056.1019955463707L880.4814827395603,1105.4115433609113Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M967.4277769131586,1027.0252828095108L982.3030134802684,1012.207525848411L983.684353065677,1012.9087741547264L996.277342104353,1019.2512185107917L995.7535217246041,1020.2999685923569L1004.1157145332545,1024.5168162817135L1017.431323251687,1031.2275604577735L1012.6262179324403,1040.8306760983542L996.723851644434,1072.6353093953803L980.5737751182169,1064.4929875829257L992.8969651050866,1039.8662034384906L986.8028198732063,1036.7907104361802L980.9634848581627,1033.8494308362715L975.343460181728,1031.0080307899043L969.9648346565664,1028.3008444556035Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1041.9798813490197,1176.9156950376928L1064.6785015081987,1132.7941405409947L1096.0225245915353,1149.0442807255313L1087.3558217426762,1165.867645855993L1072.9625945920125,1158.4058590121567L1058.9164773318917,1185.7102167513222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M900.4371458822861,1162.5934913516976L909.0762377157807,1142.5032371357083L925.9568227855489,1149.8162628747523L928.3305811015889,1144.3104260321707L949.9586828052998,1153.685535997618L943.2129176426679,1169.3758897683583L938.9537215139717,1179.2753288382664L926.9271527044475,1174.067070800811Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M882.0687216017395,1184.9808950726874L883.4224501727149,1181.820153452456L882.1894211769104,1181.2739421981387L893.1659825686365,1159.4400223633274L900.4371458822861,1162.5934913516976L926.9271527044475,1174.067070800811L916.0847019525245,1199.522576849442L910.3092667125165,1197.2264143438078L906.7087904885411,1195.6668545091525L907.1056002033874,1194.746100207325L901.7411746280268,1192.4291281062178L901.3869647625834,1193.2510446552187L894.5907108904794,1190.3098314353265L894.9591207057238,1189.4733489188366L889.7437946051359,1187.219839550089L889.3469848902896,1188.1416352540255Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M996.723851644434,1072.6353093953803L1012.6262179324403,1040.8306760983542L1021.9027297459543,1045.5000952333212L1015.3478750251234,1058.6104506463744L1039.7402336699888,1070.9061332414858L1037.4863860430196,1075.4277927218936L1038.6421042000875,1076.0083461184986L1033.8582988055423,1091.3513767756522Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1052.276422909461,1234.6297352393158L1063.72868262697,1213.0009417836554L1098.2053724685684,1231.3909866358154L1086.7531127519906,1253.0342882010154Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer tree_row"
        d="M885.5697981761768,1128.8187339049764L862.2897689510137,1177.915522331372"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M838.4922304339707,1135.309850757476L843.6373456697911,1123.3690625908785L850.9582088077441,1126.5433561955579L852.751346946694,1122.3910760660656L845.3807839816436,1119.194931909442L846.8197122542188,1115.864573101513L849.4979806123301,1109.621056385804L871.6869803406298,1119.2583970259875L858.724792602472,1143.9910207754L852.3750482695177,1141.3338181641884Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1069.7384170433506,1059.2908858424053L1089.4534699199721,1021.5193484481424L1101.925759382546,1028.0885976711288L1082.2107065068558,1065.853856756352Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1014.2071457039565,1041.0356395267881L1020.634200874716,1028.2519444618374L1030.2373115411028,1033.1128102126531L1039.10991366487,1037.6126454370096L1044.3323397412896,1040.2563622975722L1051.7313026040792,1044.012290458195L1045.3034585472196,1056.8032394112088Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1058.9164773318917,1185.7102167513222L1072.9625945920125,1158.4058590121567L1087.3558217426762,1165.867645855993L1083.20312523935,1173.953666816L1080.6660674959421,1172.6427582446486L1070.779746714048,1191.8548268633895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1054.090860972181,1101.8325189026073L1058.9235773058608,1088.9698643092997L1081.9842961914837,1100.6849417774938L1075.7899624239653,1112.5477380584925Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1057.606137495488,1088.3039978542365L1061.3407243601978,1080.9201588407159L1082.6146161966026,1092.0807083025575L1085.647883305326,1093.6756655666977L1081.9842961914837,1100.6849417774938L1058.9235773058608,1088.9698643092997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M947.422413947992,1047.7827825010754L947.5139247374609,1045.2524746018462L967.4277769131586,1027.0252828095108L969.9648346565664,1028.3008444556035L957.6408557826653,1052.9339122152887Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M974.4930409509689,1061.431030972395L986.8028198732063,1036.7907104361802L992.8969651050866,1039.8662034384906L980.5737751182169,1064.4929875829257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M968.6395059842616,1058.476236356888L980.9634848581627,1033.8494308362715L986.8028198732063,1036.7907104361802L974.4930409509689,1061.431030972395Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1061.3407243601978,1080.9201588407159L1064.614601733163,1074.6266705701128L1072.4095854256302,1078.7227967483923L1073.1116940667853,1077.3837788826786L1083.521835227497,1082.8542946893722L1082.5436164466664,1084.7395304040983L1082.6146161966026,1092.0807083025575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M963.0194813087583,1055.648371880874L975.343460181728,1031.0080307899043L980.9634848581627,1033.8494308362715L968.6395059842616,1058.476236356888Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M957.6408557826653,1052.9339122152887L969.9648346565664,1028.3008444556035L975.343460181728,1031.0080307899043L963.0194813087583,1055.648371880874Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M995.6541220732033,1271.3035417464562L1001.5218569897115,1259.7520939200185L1006.8223827900365,1262.4664726099L1000.9617478493601,1274.0179159147665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1044.5027391407639,1260.1349576716311L1050.5542845213786,1248.038325630594L1055.3522898675874,1250.4541163942777L1049.2999556008726,1262.5517846094444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M990.6581063140184,1268.7452249168418L996.5187412546948,1257.193772827275L1001.5218569897115,1259.7520939200185L995.6541220732033,1271.3035417464562Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1000.9617478493601,1274.0179159147665L1006.8223827900365,1262.4664726099L1011.7899986505508,1265.010226299055L1006.2204626854509,1275.9592806119472L1005.9293637089431,1276.5543826515786Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1022.0944290719926,1248.8383873496205L1028.1467633387074,1236.741735601332L1032.8942799745128,1239.12943966873L1026.8427345929667,1251.2344103902578Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1049.2999556008726,1262.5517846094444L1055.3522898675874,1250.4541163942777L1060.0366956125945,1252.8147655567154L1053.9843613458797,1264.9113892633468Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1067.4064696906134,1271.6791221369058L1073.4588039582595,1259.5752275069244L1078.1219097776338,1261.9275504397228L1072.069575510919,1274.0251986356452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1039.9035330964252,1257.8180074198171L1045.9550784779713,1245.7203309470788L1050.5542845213786,1248.038325630594L1044.5027391407639,1260.1349576716311Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.849863496609,1269.3757008067332L1068.895097787492,1257.2790848892182L1073.4588039582595,1259.5752275069244L1067.4064696906134,1271.6791221369058Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1013.0585275217891,1244.296033108607L1019.1108617885038,1232.1920906701125L1023.6390680838376,1234.4736760724336L1017.5875227022916,1246.5713721723296Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1058.3074572514743,1267.0868441620842L1064.359791518189,1254.99750699196L1068.895097787492,1257.2790848892182L1062.849863496609,1269.3757008067332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1017.5875227022916,1246.5713721723296L1023.6390680838376,1234.4736760724336L1028.1467633387074,1236.741735601332L1022.0944290719926,1248.8383873496205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1026.8427345929667,1251.2344103902578L1032.8942799745128,1239.12943966873L1037.3664753539488,1241.3902149209753L1031.314141087234,1253.4878989513963Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1031.314141087234,1253.4878989513963L1037.3664753539488,1241.3902149209753L1041.7810820480809,1243.6156160701066L1035.7366366423666,1255.7195385652594Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1053.9843613458797,1264.9113892633468L1060.0366956125945,1252.8147655567154L1064.359791518189,1254.99750699196L1058.3074572514743,1267.0868441620842Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1035.7366366423666,1255.7195385652594L1041.7810820480809,1243.6156160701066L1045.9550784779713,1245.7203309470788L1039.9035330964252,1257.8180074198171Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M882.1231547435746,1240.8346448172815m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1060.3128057532012,1162.1367534394376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M904.6963420109823,1177.6710276366211m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1069.4536291565746,1179.8319442765787m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1067.9957676185295,1101.2582101579756m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1070.817613247782,1090.5252864789218m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M983.6906641554087,1050.6491458015516m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M977.7258962458,1047.6340020862408m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1049.9271200615913,1255.2950589177199m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1027.495143408887,1243.9839152102359m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1054.6683256076649,1257.6827565981075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1045.2285143658519,1252.9281682511792m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1018.3480089167133,1239.3853765260428m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1063.603249735199,1262.1824460662901m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1022.8667485779151,1241.6565556307323m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1032.1038160864264,1246.3123144013807m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1036.549978225492,1248.5512390723452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1059.1712875468656,1259.953929706011m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M963.4730908237398,1279.169917928055L979.3620460471138,1247.739733001683L996.8161513209343,1256.6340424227528L996.5187412546948,1257.193772827275L990.6581063140184,1268.7452249168418L985.243980913423,1279.4040051666088L1000.3882276443765,1287.1559296352789L996.0438318140805,1295.752638312988Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M1086.7531127519906,1253.0342882010154L1098.2053724685684,1231.3909866358154L1098.920892175287,1229.973968620412L1162.8372340211645,1262.983546542935L1106.1723333345726,1262.983546542935Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1174.1135721346363,1227.7766537703574m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1237.9762697247788,1086.327206441667L1258.3358425553888,1097.3535336614586"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1100.9483294878155,1138.7681705104187L1146.6926796967164,1048.2291237232275L1148.060608218424,1046.5425988091156L1148.3532849662006,1046.309544133488"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,1182.8615961275063L1083.20312523935,1195.3630576245487L1096.6678334325552,1211.2156191510148L1114.18583848048,1225.8987397197634L1133.610581267625,1239.2646908545867"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,1204.5924427062273L1175.4996450366452,1257.8887540060095L1185.3914880203083,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1171.9496575240046,1046.309544133488L1271.864450524561,1099.274139534682L1291.839046932757,1109.8624322433025"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1161.3935724310577,1046.309544133488L1237.9762697247788,1086.327206441667"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1291.839046932757,1236.6855543176644L1290.5949735315517,1236.040509935934L1208.3180962670594,1194.1156175318174L1100.9483294878155,1138.7681705104187L1075.1651646215469,1125.6725324317813"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1075.1651646215469,1227.9868136486039L1077.4695009607822,1227.8265927489847L1088.9359606290236,1228.0325910462998L1098.920892175287,1229.1874298607L1106.985674917698,1231.1714633055963L1133.610581267625,1239.2646908545867"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1258.3358425553888,1097.3535336614586L1291.839046932757,1115.0457686143927"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1133.610581267625,1239.2646908545867L1175.2022349722683,1260.460599921178L1180.3015948133543,1262.983546542935"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1150.0288790725172,1046.309544133488L1266.4929249752313,1108.1259824759327L1291.839046932757,1121.5795552278869"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1157.280320232734,1046.309544133488L1291.839046932757,1117.6540819373913"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1239.4940866082907,1046.309544133488L1237.9762697247788,1086.327206441667"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1133.610581267625,1239.2646908545867L1075.1651646215469,1209.1993276486173"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1258.3358425553888,1097.3535336614586L1208.3180962670594,1194.1156175318174L1175.4996450366452,1257.8887540060095"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1175.4996450366452,1257.8887540060095L1172.883698683232,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1290.5949735315517,1236.040509935934L1291.839046932757,1233.6413604645059"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1136.2399386856705,1143.0130371605046L1141.3984649851918,1133.1697284351103L1140.675845304504,1126.9688841383904L1144.1272220537066,1120.725377423223L1147.50049907621,1112.9867922239937L1141.3558651348576,1109.677238697186L1148.032208318822,1097.1901884996332L1159.0024586198851,1102.9873787416145L1166.939441813156,1087.815002136398L1177.3140830993652,1067.9939998597838L1223.462342998013,1092.3439335003495L1213.1658014375716,1118.5925334799103L1211.8901725905016,1117.8767300979234L1208.1910856030881,1124.9494469040073L1230.0037866560742,1136.458462563809L1228.6003582589328,1139.136475219857L1225.7445905264467,1144.5788512867875L1223.6682422738522,1148.5552892917767L1222.236413977109,1151.2905196528882L1209.2040153732523,1176.186372433789L1203.3291804809123,1178.4180369321257Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1220.7130748908967,1188.2050997372717L1234.035783585161,1161.4667323892936L1235.3895121561363,1158.7523141582496L1238.9820995200425,1151.559985046275L1241.7179565625265,1146.06039203424L1247.1178820142522,1135.2463857880794L1253.2199161062017,1138.3145522531122L1255.8768845386803,1132.9928587921895L1278.0303843924776,1144.126273816917L1291.338893136941,1150.8160940785892L1301.1826140675694,1155.7549043633044L1310.8977465620264,1160.6375292320736L1319.8058485612273,1165.109190756455L1290.7432841202244,1223.4049106938764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.779746714048,1191.8548268633895L1080.6660674959421,1172.6427582446486L1083.20312523935,1173.953666816L1087.3558217426762,1165.867645855993L1096.0225245915353,1149.0442807255313L1146.153870480135,1175.0304843881167L1145.7286608647555,1175.8524030013941L1123.5972498208284,1218.876064945478L1123.4481503460556,1219.1600932632573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1270.645621479489,1294.263846856542L1270.9359315689653,1293.6833117343485L1283.7135199587792,1268.5683587305248L1285.4569582706317,1269.4610127210617L1285.6060577454045,1269.5317591852508L1294.6624703351408,1251.723394582048L1329.8972797319293,1269.7731294748373L1320.967877808027,1287.3473607557826L1333.8377658724785,1293.9382061953656L1320.6562677929178,1319.8760092146695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1064.3455915674567,1074.4778907313012L1069.2067078035325,1059.007891396992L1069.7384170433506,1059.2908858424053L1082.2107065068558,1065.853856756352L1090.2044895002618,1070.0561108682305L1096.6607334576547,1057.6823951941915L1094.8888952462003,1056.7616225667298L1108.1548041403294,1031.36281569954L1114.929758087732,1034.9200276238844L1101.5715495171025,1060.5029758973978L1126.0846077390015,1073.407300055027L1099.204891175963,1124.878698963672L1075.7899624239653,1112.5477380584925L1081.9842961914837,1100.6849417774938L1085.647883305326,1093.6756655666977L1082.6146161966026,1092.0807083025575L1082.5436164466664,1084.7395304040983L1083.521835227497,1082.8542946893722L1073.1116940667853,1077.3837788826786L1072.4095854256302,1078.7227967483923L1064.614601733163,1074.6266705701128Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1170.4681294010952,1033.7433075313456L1172.1760678384453,998.2252024803311L1180.1982507323846,998.6080806753598L1180.1059510568157,1000.5994631140493L1192.4299299307168,1001.1873057829216L1192.302130379714,1003.8237535301596L1200.40241299849,1004.376221341081L1233.1072646286339,1005.6517871520482L1232.0801349077374,1033.0212528388947L1205.7242387244478,1031.7384090879932L1205.4126287093386,1038.1443020771258L1204.555109503679,1055.96778120799L1176.5559635432437,1041.8013911633752L1175.3442344721407,1041.368575031869L1174.2311161644757,1040.7235124749132L1172.8000767538324,1039.4271446429193L1172.062468238175,1038.3638315200806L1171.524447908625,1037.2016779487021L1170.921738917008,1035.4797759256326Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1260.0934808179736,1086.0296472660266L1260.3632798679173,1084.1870689974166L1261.9434187542647,1080.9409671910107L1262.7086382852867,1061.5943769766018L1279.0220142379403,1062.2394375898875L1280.347342910245,1028.9604741209187L1295.845799506642,1029.5764058646746L1295.9380991812795,1027.2021551569924L1306.6109394179657,1027.6204062155448L1304.6403019065037,1078.9922649594955L1300.962514841929,1078.8570106434636L1296.1929093962535,1078.6728566898964L1291.4666926870123,1078.481419808697L1291.0974939865991,1085.0797467282973L1284.5284393141046,1098.2753413147293Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1123.5972498208284,1218.876064945478L1145.7286608647555,1175.8524030013941L1177.6043931888416,1191.6061710575595L1169.5893102707341,1207.8135170536116L1168.9376903399825,1209.1389845502563L1170.3624186618254,1209.8547785128467L1167.5626618433744,1215.5166228967719L1165.1818035515025,1220.3222163319588L1158.2293502278626,1235.8771680439822Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1247.5430916296318,1077.9435237562284L1250.1937489723787,1021.4340334832668L1276.4423566451296,1022.6742216632701L1278.2141948575154,1022.7304046819918L1278.1502950815484,1024.5875652451068L1279.3691241284832,1024.6302227079868L1296.009098932147,1025.2680037808605L1295.9380991812795,1027.2021551569924L1295.845799506642,1029.5764058646746L1280.347342910245,1028.9604741209187L1279.0220142379403,1062.2394375898875L1262.7086382852867,1061.5943769766018L1261.9434187542647,1080.9409671910107L1260.3632798679173,1084.1870689974166Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1244.6589239966124,1279.9772587670013L1258.4139422811568,1252.7929173316807L1266.3154255999252,1237.329558248166L1294.4573599454015,1251.7442024187185L1285.4569582706317,1269.4610127210617L1283.7135199587792,1268.5683587305248L1270.9359315689653,1293.6833117343485Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1041.9798813490197,1176.9156950376928L1064.6785015081987,1132.7941405409947L1096.0225245915353,1149.0442807255313L1087.3558217426762,1165.867645855993L1072.9625945920125,1158.4058590121567L1058.9164773318917,1185.7102167513222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1113.5058186510578,1131.0223225811496L1134.8578102132306,1090.2526974668726L1148.032208318822,1097.1901884996332L1141.3558651348576,1109.677238697186L1147.50049907621,1112.9867922239937L1144.1272220537066,1120.725377423223L1140.675845304504,1126.9688841383904L1141.3984649851918,1133.1697284351103L1136.2399386856705,1143.0130371605046Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1052.276422909461,1234.6297352393158L1063.72868262697,1213.0009417836554L1098.2053724685684,1231.3909866358154L1086.7531127519906,1253.0342882010154Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1134.8578102132306,1090.2526974668726L1153.1765346676111,1055.2592543093488L1170.3269187863916,1064.301550310105L1159.951488615945,1084.1225631427951L1166.939441813156,1087.815002136398L1159.0024586198851,1102.9873787416145L1148.032208318822,1097.1901884996332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1101.5715495171025,1060.5029758973978L1114.929758087732,1034.9200276238844L1139.4428163086995,1047.8243993981741L1126.0846077390015,1073.407300055027Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1247.1178820142522,1135.2463857880794L1256.0898837884888,1117.2462404309772L1258.8675517961383,1114.8865855191834L1259.9238703027368,1114.3476518769749L1260.4973905086517,1114.1562159797177L1261.6594197535887,1113.9720629635267L1262.2550287712365,1113.9647800740786L1263.6229572920129,1114.1562159797177L1287.0938969571143,1125.9555241581984L1278.0303843924776,1144.126273816917L1255.8768845386803,1132.9928587921895L1253.2199161062017,1138.3145522531122Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1069.7384170433506,1059.2908858424053L1089.4534699199721,1021.5193484481424L1101.925759382546,1028.0885976711288L1082.2107065068558,1065.853856756352Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1205.4126287093386,1038.1443020771258L1205.7242387244478,1031.7384090879932L1232.0801349077374,1033.0212528388947L1230.294096746482,1070.140384817496L1220.1529657505453,1064.6272017573938L1221.2376841558143,1042.0354864164256L1216.6313781375065,1041.8221996324137L1216.7796887271106,1038.69676715089L1210.840954059735,1038.413771866355Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1208.1910856030881,1124.9494469040073L1211.8901725905016,1117.8767300979234L1213.1658014375716,1118.5925334799103L1219.5084457946941,1122.0227704672143L1229.8546871813014,1095.709677725099L1237.8910700241104,1099.9472878384404L1227.5235287128016,1125.8348365118727L1233.82357321959,1129.1589480666444L1230.0037866560742,1136.458462563809Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1058.9164773318917,1185.7102167513222L1072.9625945920125,1158.4058590121567L1087.3558217426762,1165.867645855993L1083.20312523935,1173.953666816L1080.6660674959421,1172.6427582446486L1070.779746714048,1191.8548268633895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1054.090860972181,1101.8325189026073L1058.9235773058608,1088.9698643092997L1081.9842961914837,1100.6849417774938L1075.7899624239653,1112.5477380584925Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1082.2107065068558,1065.853856756352L1101.925759382546,1028.0885976711288L1108.1548041403294,1031.36281569954L1094.8888952462003,1056.7616225667298L1096.6607334576547,1057.6823951941915L1090.2044895002618,1070.0561108682305Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1278.0303843924776,1144.126273816917L1287.0938969571143,1125.9555241581984L1300.4024057006463,1132.645361950621L1291.338893136941,1150.8160940785892Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1227.5235287128016,1125.8348365118727L1237.8910700241104,1099.9472878384404L1246.6855724239722,1104.5896163950674L1233.82357321959,1129.1589480666444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1291.338893136941,1150.8160940785892L1300.4024057006463,1132.645361950621L1310.2390266573057,1137.5914680436254L1301.1826140675694,1155.7549043633044Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1057.606137495488,1088.3039978542365L1061.3407243601978,1080.9201588407159L1082.6146161966026,1092.0807083025575L1085.647883305326,1093.6756655666977L1081.9842961914837,1100.6849417774938L1058.9235773058608,1088.9698643092997Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1164.6863830713555,1046.309544133488L1291.839046932757,1113.7286064266227"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1159.951488615945,1084.1225631427951L1170.3269187863916,1064.301550310105L1177.3140830993652,1067.9939998597838L1166.939441813156,1087.815002136398Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1061.3407243601978,1080.9201588407159L1064.614601733163,1074.6266705701128L1072.4095854256302,1078.7227967483923L1073.1116940667853,1077.3837788826786L1083.521835227497,1082.8542946893722L1082.5436164466664,1084.7395304040983L1082.6146161966026,1092.0807083025575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1176.0029543777928,1211.0241859261878L1184.0251372708008,1194.8022818290628L1190.7503913929686,1198.1544511164539L1182.7282084999606,1214.3690645894967Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1157.8680403875187,1236.6075247596018L1158.2293502278626,1235.8771680439822L1160.9581072963774,1230.3641167813912L1178.143202405423,1238.9244820973836L1175.0531354965642,1245.1751651191153Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1284.5284393141046,1098.2753413147293L1291.0974939865991,1085.0797467282973L1291.4666926870123,1078.481419808697L1296.1929093962535,1078.6728566898964L1295.9025993058458,1090.479508173652L1290.2336636912078,1101.2155531649478Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1182.0694885943085,1215.6799652706832L1182.7282084999606,1214.3690645894967L1190.7503913929686,1198.1544511164539L1196.8169256104156,1201.180973763112L1188.1352339256555,1218.7127226484008Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1209.8493242152035,1059.0359827573411L1210.840954059735,1038.413771866355L1216.7796887271106,1038.69676715089L1216.6313781375065,1041.8221996324137L1215.6531593557447,1062.1822144738398Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1169.5893102707341,1207.8135170536116L1177.6043931888416,1191.6061710575595L1184.0251372708008,1194.8022818290628L1176.0029543777928,1211.0241859261878Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1290.2336636912078,1101.2155531649478L1295.9025993058458,1090.479508173652L1296.1929093962535,1078.6728566898964L1300.962514841929,1078.8570106434636L1300.6154049523175,1093.037890789099L1295.0947799254209,1103.7666489193216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1167.5626618433744,1215.5166228967719L1170.3624186618254,1209.8547785128467L1182.0694885943085,1215.6799652706832L1188.1352339256555,1218.7127226484008L1185.3362659923732,1224.382882968057Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1247.9541012952104,1247.4994023395702L1255.7916848370805,1231.7592864218168L1261.3833096148446,1234.5870790667832L1253.4960262468085,1250.3053403291851L1252.3836968252435,1249.7456093714572Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1237.090350618586,1241.986360321287L1244.9421341121197,1226.2743225716986L1250.4272592626512,1229.052178478334L1242.4973760433495,1244.728836574126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1165.1818035515025,1220.3222163319588L1167.5626618433744,1215.5166228967719L1185.3362659923732,1224.382882968057L1182.9554077005014,1229.1874298607L1167.6407615691423,1221.5478033879772Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1242.4973760433495,1244.728836574126L1250.4272592626512,1229.052178478334L1255.7916848370805,1231.7592864218168L1247.9541012952104,1247.4994023395702Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1160.9581072963774,1230.3641167813912L1163.3957653893158,1225.431602019351L1165.2670032512397,1226.366917785257L1180.58086049743,1233.991973426193L1178.143202405423,1238.9244820973836Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1204.555109503679,1055.96778120799L1205.4126287093386,1038.1443020771258L1210.840954059735,1038.413771866355L1209.8493242152035,1059.0359827573411Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1215.6531593557447,1062.1822144738398L1216.6313781375065,1041.8221996324137L1221.2376841558143,1042.0354864164256L1220.1529657505453,1064.6272017573938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1253.4960262468085,1250.3053403291851L1261.3833096148446,1234.5870790667832L1266.301225649193,1237.0746617065743L1258.4139422811568,1252.7929173316807Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1165.2670032512397,1226.366917785257L1167.6407615691423,1221.5478033879772L1182.9554077005014,1229.1874298607L1180.58086049743,1233.991973426193Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1225.7445905264467,1144.5788512867875L1228.6003582589328,1139.136475219857L1241.7179565625265,1146.06039203424L1238.9820995200425,1151.559985046275Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1192.904839371331,1253.0769442603923L1195.6186076020822,1247.5774317774922L1208.8143056323752,1254.1038107480854L1206.093437424861,1259.5960353207774Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1067.4064696906134,1271.6791221369058L1073.4588039582595,1259.5752275069244L1078.1219097776338,1261.9275504397228L1072.069575510919,1274.0251986356452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1072.069575510919,1274.0251986356452L1078.1219097776338,1261.9275504397228L1081.998496142216,1263.8834839831106L1081.502286775969,1264.8832987351343L1081.9771962165833,1265.1236287942156L1076.428171291016,1276.2214584406465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1222.236413977109,1151.2905196528882L1223.6682422738522,1148.5552892917767L1235.3895121561363,1158.7523141582496L1234.035783585161,1161.4667323892936Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1099.0218695970252,1078.0527676357888m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1075.2416865751147,1233.0108813219704m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1154.1973532987759,1074.2125840201043m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1120.507182912901,1054.1636905493215m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1229.4823329346254,1108.9125349707901m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1236.4513528663665,1115.2122345902026m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1221.5051165493205,1107.1511150435545m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1183.3758839992806,1204.589321507141m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1213.2399567328393,1050.4296167483553m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1176.8076182138175,1201.307902494911m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1178.0161917405203,1217.1968643241562m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1254.6564777195454,1241.0437639071606m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1243.7390827881172,1235.5192724163644m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1176.4881193377078,1222.964823125396m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1249.1705636819825,1238.244064532686m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1170.7686950098723,1232.1775251422077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1207.6980317821726,1047.1907820915803m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1218.4450273122638,1052.1088577620685m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1259.898625947535,1243.6905243708752m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1213.1658014375716,1118.5925334799103L1223.462342998013,1092.3439335003495L1229.8546871813014,1095.709677725099L1219.5084457946941,1122.0227704672143Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M-8.205035817809403,1451.3613143917173L0.9602430555969477,1425.6091883806512L5.650959890335798,1412.4204590017907L32.1835665628314,1422.6535086031072L16.791609591804445,1463.6219685804099L1.4059637105092406,1457.9031069525518L-8.205035817809403,1454.352354216855Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M201.19926095195115,1391.490309087094m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M18.038838538341224,1479.6580600519665L40.39744878280908,1418.6501782680862"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M167.31975789833814,1473.7561085494235L165.13691002130508,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M-0.8896948816254735,1320.7332836287096L104.1134135555476,1366.19468519371"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M128.17286226153374,1299.7144242241047L45.61119711026549,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M95.32601113151759,1479.6580600519665L107.10408081486821,1447.6128894411959L132.35395866632462,1379.0994807509705L156.65401763748378,1311.9878311846405L174.60354338865727,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M180.9146323017776,1479.6580600519665L167.31975789833814,1473.7561085494235L107.10408081486821,1447.6128894411959L103.34819402452558,1445.9826412647963"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M85.59510091505945,1479.6580600519665L103.28429425042123,1431.490373567678L164.4568901900202,1262.983546542935"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer highway"
        d="M153.38250692281872,1262.983546542935L74.09471914358437,1479.6580600519665"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M103.34819402452558,1445.9826412647963L82.08850213792175,1436.7494160667993"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer path"
        d="M-8.205035817809403,1311.4749224353582L3.9083104636520147,1278.560250681825L9.58119051065296,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M141.1074389880523,1262.983546542935L128.17286226153374,1299.7144242241047L104.1134135555476,1366.19468519371L78.78622486442327,1435.317874922417L62.580926310271025,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M20.093097978271544,1262.983546542935L-0.8896948816254735,1320.7332836287096L-8.205035817809403,1340.7938907807693"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,1335.1259064255282L156.65401763748378,1311.9878311846405"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M132.35395866632462,1379.0994807509705L186.55280135851353,1402.4922224902548L208.46884649340063,1412.0355229252018"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M82.08850213792175,1436.7494160667993L78.78622486442327,1435.317874922417L40.39744878280908,1418.6501782680862L-8.205035817809403,1397.8324071150273"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M22.928354673087597,1488.2056332919747L44.479145537130535,1429.0673633255064L70.36013228073716,1440.114993098192L65.88083692546934,1452.3683846406639L64.45689748879522,1456.2874262523837L56.484414420090616,1453.3608896820806L49.815171212889254,1471.6795525876805L51.95541923865676,1472.4587813247927L49.66686062235385,1478.7446259679273L47.51951261982322,1477.9581154300831L41.32596773840487,1494.9731482053176L35.563943561166525,1492.8477018810809L34.834223905578256,1494.859749468509L28.179969534277916,1492.4149139067158L28.916789165697992,1490.4163902350701Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M101.77515511307865,1248.4773712153547L101.99446545355022,1247.8957918705419L110.27934742253274,1225.1402911860496L143.64291895739734,1237.1173178642057L145.535456744954,1237.7904527839273L136.30864475481212,1263.24572486151Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M82.10270208772272,1342.9141818289645L87.72903785388917,1327.4936793493107L90.83330471161753,1328.6349766543135L96.56614010222256,1312.9304179525934L90.83330471161753,1310.8257234790362L95.18480051774532,1298.906045299489L117.7911209994927,1307.268653117586L102.01576537825167,1350.2634093728848Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M55.1093859244138,1332.9223826229572L60.99132078886032,1316.8921940503642L90.4435949716717,1327.783945500385L95.79382059630007,1313.2071597380564L65.82403712440282,1302.1301969829947L71.29496232513338,1287.2204335979186L96.09833063650876,1296.3976771398447L95.18480051774532,1298.906045299489L90.83330471161753,1310.8257234790362L96.56614010222256,1312.9304179525934L90.83330471161753,1328.6349766543135L87.72903785388917,1327.4936793493107L82.10270208772272,1342.9141818289645Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M173.045493314974,1308.4089133692905L179.586936972104,1290.6433044504374L211.73877943586558,1302.5629968377762L213.44671787321568,1297.9488912345842L223.82924802042544,1301.7972739995457L221.69609996769577,1307.6015758393332L218.66283285990357,1306.47484044265L215.95537571515888,1313.8095412580296L219.23714194912463,1315.0278291092254L215.339255659841,1325.6230749753304L203.69608550332487,1321.3002915270627L204.18440600764006,1319.960280126892Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M175.7884503332898,1283.7122493209317L178.99132795631886,1274.9958810498938L178.0635978858918,1274.648391327355L179.62243684753776,1270.389039824251L180.4089563023299,1270.6803487539291L183.44222341198474,1262.3884433405474L191.0817965399474,1265.2162234913558L189.60736839286983,1269.2196424230933L226.34500583726913,1282.8050317442976L223.8363479943946,1289.6434934134595L227.69163443427533,1291.0677819331177L223.89314779546112,1301.4289779309183L218.01831290405244,1299.2535338057205L218.89634314831346,1296.8720927550457L214.92114602029324,1295.4051496284083L215.39605546090752,1294.1296371277422L184.79516309779137,1282.819597162772L183.42802346125245,1286.5400207727216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.32104254234582,1259.4618249209598L186.82260041031986,1252.389245340135L225.0196771658957,1265.9881927049719L240.05742427241057,1271.3316322485916L236.02542734332383,1282.755093159154L232.78626095876098,1281.6148286880925L233.84257946535945,1278.623714340385L208.0325924726203,1269.4391645491123L207.08987356629223,1272.1254489477724L191.21590717881918,1265.3077777959406L192.09472631011158,1262.8139629429206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M58.964672363363206,1260.8642714424059L69.07030348386616,1238.0744803268462L82.04590228758752,1243.86427001236L77.53820703178644,1254.0611546980217L72.2660811310634,1265.9455367270857L71.94737114198506,1266.6613248214126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-11.31403599306941,1487.4825855758972L-5.4392011016607285,1471.5443059350364L-3.837762290611863,1472.1331490334123L11.547094706445932,1477.8592814267613L5.665159839205444,1493.7965061962605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M171.2034442378208,1337.6353009524755L175.41294054314494,1327.6070808228105L198.50127044226974,1337.379367721267L199.31618979759514,1338.4072621045634L198.74188070744276,1339.7888850830495L197.4449519366026,1340.277863028925L194.41247371211648,1347.5064095780253L187.1981101995334,1344.4591432502493L186.40449076984078,1346.365115382243L183.5763340499252,1345.167640591506L184.38415343221277,1343.2543854843825L181.04637628234923,1341.837390332017L180.23145692702383,1343.7652111263014L177.5815884694457,1342.6384816076607L178.4107077755034,1340.6825702828355Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M155.05967880040407,1380.906607975252L159.35437480546534,1370.857642953284L164.48529009148479,1373.06115470035L165.83901866246015,1373.642723549623L166.6397380689159,1371.7638086345978L168.04237757902592,1372.3734676819295L169.5665055513382,1373.0330646135844L168.77288612071425,1374.9036561944522L171.36595477722585,1376.023097855039L172.17456304468215,1374.1452239640057L175.3277408424765,1375.506032353267L174.51992146205157,1377.3766232691705L180.79156606830657,1380.0836732988246L176.49687006417662,1390.132624948863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M147.52660529688,1359.0577111956663L155.5700881164521,1337.592645415105L167.1848583733663,1341.9861644329503L166.73834883235395,1343.1690744771622L165.0659102704376,1342.5458879447542L163.18836131878197,1347.5636303420179L164.72590035572648,1348.1441609491594L163.62777088582516,1351.0707419328392L162.0823429878801,1350.4829289293848L160.97711354214698,1353.4313568361104L162.45154168922454,1353.9910794226453L161.35972330719233,1356.8968504169025L159.88608404714614,1356.3433703244664L158.0361461089924,1361.2976398323663L159.37567473109812,1361.8074237676337L158.8084656149149,1363.3242908488028Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-26.997091939672828,1292.110248583369L-17.99669026490301,1271.3461976936087L-13.021974429488182,1273.5143678546883L-7.714348655194044,1275.8385955775157L-16.71396144386381,1296.602633011993L-22.072075930424035,1294.263846856542Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M148.24922497849911,1400.705908281263L150.9424821715802,1394.5053032650612L162.7347518047318,1399.649933152832L163.62067090999335,1399.1328694131225L165.27890952304006,1399.848643756006L165.5337197361514,1400.8692462900653L170.62203517276794,1403.0945962532423L167.2416581744328,1410.8973604547791L166.85194843262434,1411.8045612671413L165.42800899781287,1411.1803405387327L164.59888969175518,1413.0935769015923L154.43645877111703,1408.6647304208018L155.26557807531208,1406.7514928341843L151.72900162730366,1405.1992627135478Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M51.56570949871093,1383.7332994141616L63.35087915696204,1356.2164444299415L69.91362273972481,1359.0577111956663L69.8000231385231,1359.3417337699793L62.98246934171766,1375.258423506748L58.13555305637419,1386.5755952759646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M45.27276496775448,1381.0200085751712L50.28298067767173,1369.318929664325L57.05083465017378,1353.502102444414L63.35087915696204,1356.2164444299415L51.56570949871093,1383.7332994141616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M91.68372394237667,1275.2934321169741L92.15863338299096,1274.2155897305347L97.19724899344146,1262.8420534785837L103.16438356041908,1249.3773105372675L109.59143873210996,1252.2539944099262L103.12888368591666,1266.824665990658L98.75608795508742,1276.6896331058815L98.1044680243358,1278.1701052337885Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M77.90030575916171,1395.1295254966244L83.93055121414363,1381.0408160239458L88.96206684969366,1369.2981221787632L89.5718758162111,1367.8665671073832L95.09960081614554,1370.2552663921379L84.68867077026516,1398.0633692354895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M141.58787063136697,1374.9036561944522L147.52660529688,1359.0577111956663L158.8084656149149,1363.3242908488028L158.1852455837652,1364.9899312066846L156.84571696352214,1364.4791071312502L155.03127890080214,1369.318929664325L156.2359079970047,1369.7725328053348L155.13777852617204,1372.7001450341195L153.93314942903817,1372.2392594683915L151.3392918864265,1379.1483782702126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M126.06101413536817,1416.3114332826808L131.31972897052765,1402.442284767516L141.48137100506574,1406.3186994828284L140.9149507759139,1407.807466880884L143.0693987524137,1408.6293578962795L141.55237075593323,1412.6046040914953L139.4050227534026,1411.7827135440893L138.21459360793233,1414.9287851853296L140.36904158443213,1415.744433154352L138.93800217378885,1419.51472303411L136.7906541712582,1418.6928333085962L136.02464575413615,1420.712184981443Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M155.5700881164521,1337.592645415105L161.49462283216417,1321.7819881057367L170.99754496198148,1325.7364764786325L168.6379865957424,1332.0297368038446L170.60783522203565,1332.7663256716914L169.63750530127436,1335.345426466316L167.9926777537912,1334.736804538872L166.04412905219942,1339.924134306144L167.7165676150471,1340.561886371579L167.1848583733663,1341.9861644329503Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M131.31972897052765,1402.442284767516L136.5208551203832,1388.7302045733668L146.68328604102135,1392.612869183533L146.15157680027187,1394.0163291399367L148.2989248028025,1394.8382217935286L146.889185317792,1398.552343074698L144.74183731433004,1397.7294104923494L143.50880831759423,1400.9826465630904L145.6561563219875,1401.8045383901335L144.21012807358056,1405.6174909705296L142.05568009708077,1404.795599595178L141.48137100506574,1406.3186994828284Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M64.54840827733278,1414.4762253644876L69.55862398818135,1401.6058278433047L80.23146422486752,1405.794353660196L75.95096817053854,1416.8004058320075L75.22124851401895,1418.670985603705Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M102.21456468012184,1480.8211798146367L106.70017112232745,1468.5043766372837L107.23898033890873,1468.731174966786L110.74005691427737,1458.9091358915903L116.77740234415978,1461.5100373271853L112.68150564096868,1471.0844672978856L108.15329934470356,1483.003849468194Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-14.099592860788107,1384.8184073795564L-11.519935268908739,1378.8008937658742L-10.159106723032892,1379.3970273514278L2.0654725013300776,1384.6831590328366L8.436516758985817,1387.4401440420188L6.083269479684532,1392.9249803926796L5.8568591652438045,1393.4493271918036Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-22.00107617955655,1407.4454186530784L-19.613117911852896,1400.8910940499045L0.19423463847488165,1409.9610292133875L0.0459240498021245,1410.3657323969528L-1.6052145874127746,1414.8934126924723L-11.158625428564847,1411.4071407425217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M69.3322136728093,1378.0008470444009L76.14976747054607,1362.0768809756264L76.42587761115283,1361.4172830041498L82.88922154251486,1364.2169326394796L82.00330243632197,1366.2862381665036L76.97888677753508,1378.036219723057L75.79555760603398,1380.7932073744014L74.70373922400177,1380.3250397387892L74.29272955842316,1381.2884246618487L70.18973288033158,1379.5239528184757L70.60784252081066,1378.55328503903Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M43.48672680463642,1366.3923563808203L50.26168075297028,1350.5682398458011L57.05083465017378,1353.502102444414L50.28298067767173,1369.318929664325L48.44803157635033,1368.5261644655839L48.02992193587124,1369.5041162697598L44.58564516250044,1368.0153406499885L44.99665482714772,1367.0373886353336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M30.42592830117792,1360.7514427169226L37.19378227367997,1344.9273133068345L43.82042563147843,1347.7904326263815L37.045471685007215,1363.6072728750296L35.44403287302703,1362.9206252959557L35.02592323254794,1363.8840126371942L31.74415699765086,1362.4732639561407L32.14806668832898,1361.495311159175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M23.821373754180968,1357.9028940135613L30.596327701583505,1342.092283019796L37.19378227367997,1344.9273133068345L30.42592830117792,1360.7514427169226L28.867089339531958,1360.078319735825L28.448979699984193,1361.0562727311626L25.04020280018449,1359.574777926784L25.451212465763092,1358.6113899834454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-3.837762290611863,1472.1331490334123L-1.1658050222322345,1464.8766427016817L14.226151948794723,1470.5882160654292L11.547094706445932,1477.8592814267613Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M175.15024146717042,1428.691791461315L176.6033696886152,1425.3324510790408L183.28602396138012,1409.8975667590275L189.69966806750745,1412.6971968156286L184.94426257256418,1423.6886729071848L182.9886138960719,1422.8314112238586L179.6082368977368,1430.6331128487363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M62.98246934171766,1375.258423506748L69.8000231385231,1359.3417337699793L76.14976747054607,1362.0768809756264L69.3322136728093,1378.0008470444009L68.24118417687714,1377.532679217402L67.82307453732938,1378.5033471425995L63.705089022405446,1376.7253497364L64.11609868798405,1375.7536411923356Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.42628645244986,1438.8967272266746L206.02014399506152,1432.880300913006L210.7755494909361,1421.9096467220224L211.34906969591975,1420.5987850339152L216.3805853324011,1422.788756211754L214.58823607955128,1428.0748548102565L212.0085784867406,1435.6934464275837L209.4786207182333,1441.5402910695411Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M37.045471685007215,1363.6072728750296L43.82042563147843,1347.7904326263815L50.26168075297028,1350.5682398458011L43.48672680463642,1366.3923563808203L41.269167938269675,1365.4362520077266L40.85815827269107,1366.3996390029788L37.94559074006975,1365.1449470599182L38.35660040564835,1364.1742772674188Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-1.1658050222322345,1464.8766427016817L1.4059637105092406,1457.9031069525518L16.791609591804445,1463.6219685804099L14.226151948794723,1470.5882160654292Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M170.08322595618665,1422.4912114734761L170.29622520692647,1422.0022393255495L176.75956913921982,1407.049038247671L183.28602396138012,1409.8975667590275L176.6033696886152,1425.3324510790408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M45.46446429286152,1411.4706031852402L52.3593289302662,1395.0161251286045L58.107153156772256,1397.439147267025L51.211499634198844,1413.8946599401534Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.80083365552127,1401.5069927545264L211.79557923600078,1387.5743519631214L214.3042370788753,1388.6657015555538L213.73071687389165,1389.998417076189L218.25182319246233,1391.9615970845334L212.83059781882912,1404.5542340097018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M39.87993949186057,1409.111048411578L46.7755930153653,1392.662806977518L52.3593289302662,1395.0161251286045L45.46446429286152,1411.4706031852402Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-26.08987290877849,1418.7344479793683L-24.0206246310845,1413.0020245490596L-13.178173879161477,1416.9627030948177L-5.709000152535737,1419.6988679342903L-7.260739139281213,1423.978935030289L-14.72281289100647,1421.2438122443855L-15.25452213268727,1422.6961636184715Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M208.29529154859483,1469.489596855361L210.24384025018662,1464.1036552712321L226.5501162270084,1471.0553372474387L224.55896767508239,1476.5338653032668Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M206.36725388467312,1474.7975073731504L208.29529154859483,1469.489596855361L224.55896767508239,1476.5338653032668L222.6033189976588,1481.9697343800217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M167.06494768429548,1418.5430204868317L169.87811556644738,1412.0521688088775L167.2416581744328,1410.8973604547791L170.62203517276794,1403.0945962532423L177.23368969280273,1405.978498922661L176.75956913921982,1407.049038247671L170.29622520692647,1422.0022393255495L167.28425802383572,1420.690337285865Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M123.53815634176135,1422.958335895557L126.06101413536817,1416.3114332826808L136.02464575413615,1420.712184981443L138.12939390726388,1421.632909276057L137.3996742516756,1423.3131007486954L138.25009348150343,1423.6314527723007L137.00286453589797,1426.912766563706L135.89053511526436,1426.4872570317239L135.174226523377,1428.386964420788L130.06540004909039,1426.0055677248165Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M76.97888677753508,1378.036219723057L82.00330243632197,1366.2862381665036L88.96206684969366,1369.2981221787632L83.93055121414363,1381.0408160239458Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.5039048846811,1479.9493601880968L206.36725388467312,1474.7975073731504L222.6033189976588,1481.9697343800217L220.76048103533685,1487.064362256322Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M160.0485945865512,1459.6321865874343L163.9961807001382,1450.5259037339129L165.67571923695505,1451.2624800116755L168.78708607051522,1444.1047863196582L172.71258337423205,1445.833869398106L170.31042515672743,1451.3904445255175L165.66151928715408,1462.084316235967Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M197.10494202096015,1477.0155510972254L203.16437626164407,1460.90038611833L208.30239152349532,1462.8427388495766L205.16262478847057,1471.1687363726087L202.23585730604827,1478.95789931342Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M190.11777770798653,1472.791696114L194.7666835784912,1462.0978409177624L197.02684229519218,1456.882512814831L199.8123991638422,1458.1018158858642L197.55145156010985,1463.3098605531268L200.71251821983606,1464.6987411598675L196.06361234933138,1475.3925923439674Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M72.2660811310634,1265.9455367270857L77.53820703178644,1254.0611546980217L84.07255071401596,1256.988815786317L78.81383587792516,1268.865910074208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M78.81383587792516,1268.865910074208L84.07255071401596,1256.988815786317L90.61320548597723,1259.9081525155343L85.57458987552673,1271.2681685239077L85.348179561086,1271.792524522636Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M177.65889930911362,1466.8606087011285L182.12399471458048,1456.5631219553761L182.91761414520442,1454.7632969804108L189.30995832756162,1457.5629089232534L188.52343887183815,1459.3627331708558L184.0583434663713,1469.660215758253Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M85.57458987552673,1271.2681685239077L90.61320548597723,1259.9081525155343L97.19724899344146,1262.8420534785837L92.15863338299096,1274.2155897305347Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M144.89014790486544,1453.0061263665557L148.3628245787695,1443.4243888901547L149.27004361059517,1443.8145250384696L152.19681109301746,1437.0677674734034L155.84619825612754,1438.6699279188178L152.91233079787344,1445.4094013879076L153.75565005466342,1445.7849723496474L153.65703928936273,1446.0117714214139L149.7094531757757,1455.103495147545Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M130.1356109129265,1478.6031373078004L133.66508738789707,1468.7956772428006L139.75292153004557,1471.431947177276L135.66333591472358,1480.9917984390631L132.8714679563418,1487.5106751993299L130.3699100902304,1486.426623663865L133.16177804768085,1479.906705528032Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-4.75918127130717,1423.6033628899604L-1.6052145874127746,1414.8934126924723L0.0459240498021245,1410.3657323969528L5.650959890335798,1412.4204590017907L0.9602430555969477,1425.6091883806512Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M9.747645480558276,1354.3874628650956L15.019771379418671,1341.9008534112945L20.745506796054542,1344.345742052421L15.473380895331502,1356.8323471024632Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-5.765011066570878,1371.7076284475625L-3.4480525497347116,1366.0313463681377L9.173336388543248,1371.1978452391922L6.869788935407996,1376.8668404761702Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M36.43566271755844,1285.3134048194624L41.821388218551874,1272.841236403212L47.40591302048415,1275.2788666808046L42.02018752042204,1287.7520710974932Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M52.919438070617616,1292.4931105477735L58.31226354651153,1280.0199146606028L63.87548842281103,1282.444017376285L58.48266294691712,1294.9088858212344Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M115.68637284915894,1284.2438870868646L120.07257964182645,1274.3508402314037L121.63930746447295,1270.7999934921972L126.76943386439234,1273.0888489084318L120.80308818351477,1286.532738066744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M17.918138962239027,1317.5372309074737L23.262053498998284,1305.16395692667L28.85288938973099,1307.6015758393332L23.509763739071786,1319.960280126892Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M29.01618881523609,1322.3625208726153L34.359314465895295,1310.0038208663464L39.922539342194796,1312.42791310139L34.57941369153559,1324.7866087863222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M15.473380895331502,1356.8323471024632L20.745506796054542,1344.345742052421L26.251931871287525,1346.6845113141462L20.98690594639629,1359.1711121513508Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M42.02018752042204,1287.7520710974932L47.40591302048415,1275.2788666808046L52.88393819518387,1277.6603151485324L47.50531267002225,1290.132474896498Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M154.90426823683083,1457.3860475542024L160.64420360140502,1444.1474412027746L165.78931883629411,1446.408149602823L163.9961807001382,1450.5259037339129L160.0485945865512,1459.6321865874343Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M23.509763739071786,1319.960280126892L28.85288938973099,1307.6015758393332L34.359314465895295,1310.0038208663464L29.01618881523609,1322.3625208726153Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M45.37926459312439,1329.4922499852255L50.72239024285227,1317.1335626887158L56.22881531808525,1319.5212390692905L50.88568966835737,1331.879922109656Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M58.48266294691712,1294.9088858212344L63.87548842281103,1282.444017376285L69.29671379830688,1284.8036152590066L63.91098829731345,1297.2695198468864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M47.50531267002225,1290.132474896498L52.88393819518387,1277.6603151485324L58.31226354651153,1280.0199146606028L52.919438070617616,1292.4931105477735Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M34.57941369153559,1324.7866087863222L39.922539342194796,1312.42791310139L45.357964667491615,1314.7875007772818L40.014839017763734,1327.1461922586896Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M25.728111491538584,1280.6576722390018L31.1209369674325,1268.1927781715058L36.50666246749461,1270.530532734003L31.1209369674325,1283.0037456965074Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M183.8745330022648,1470.0638750977814L184.0583434663713,1469.660215758253L188.52343887183815,1459.3627331708558L194.7666835784912,1462.0978409177624L190.11777770798653,1472.791696114Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-3.4480525497347116,1366.0313463681377L-1.2652046717703342,1360.6307591581717L11.363284242339432,1365.7972620544024L9.173336388543248,1371.1978452391922Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-10.159106723032892,1379.3970273514278L-7.80664832983166,1373.9257051511668L4.41083091776818,1379.2128813797608L2.0654725013300776,1384.6831590328366Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M-0.677484517917037,1349.9658615225926L0.9034432554617524,1346.2163413749076L0.5421334151178598,1346.061325096991L4.234120427630842,1337.3231872557662L9.733445529825985,1339.654676236678L4.467630717903376,1352.148572371807Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M31.1209369674325,1283.0037456965074L36.50666246749461,1270.530532734003L41.821388218551874,1272.841236403212L36.43566271755844,1285.3134048194624Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M40.014839017763734,1327.1461922586896L45.357964667491615,1314.7875007772818L50.72239024285227,1317.1335626887158L45.37926459312439,1329.4922499852255Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M4.467630717903376,1352.148572371807L9.733445529825985,1339.654676236678L15.019771379418671,1341.9008534112945L9.747645480558276,1354.3874628650956Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M12.610513187013566,1315.219259459991L17.95363883767277,1302.8532640291378L23.262053498998284,1305.16395692667L17.918138962239027,1317.5372309074737Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M165.66151928715408,1462.084316235967L170.31042515672743,1451.3904445255175L176.35565944947302,1454.0340036069974L171.70675357896835,1464.7278712373227Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M98.75608795508742,1276.6896331058815L103.12888368591666,1266.824665990658L109.61983863078058,1269.7231907951646L105.24783178698272,1279.5808710730635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M149.7094531757757,1455.103495147545L153.65703928936273,1446.0117714214139L155.30817792657763,1446.7275409274735L157.3135264283046,1442.0927240015008L160.8635139418766,1443.6376633192413L160.64420360140502,1444.1474412027746L154.90426823683083,1457.3860475542024Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M139.22121228836477,1450.5186211979017L143.16800951678306,1441.4050438292325L143.7423186087981,1440.1014683707617L144.74183731433004,1440.5405017933808L147.81691538728774,1439.469967642799L149.7094531757757,1440.299137451686L148.3628245787695,1443.4243888901547L144.89014790486544,1453.0061263665557Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M171.70675357896835,1464.7278712373227L176.35565944947302,1454.0340036069974L182.12399471458048,1456.5631219553761L177.65889930911362,1466.8606087011285L177.48928879387677,1467.2642682031728Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M23.155553873628378,1400.3095274870284L27.761859893798828,1389.5801878767088L33.53729513473809,1392.0822800970636L28.93098911549896,1402.8043332523666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M6.083269479684532,1392.9249803926796L8.436516758985817,1387.4401440420188L10.696675474755466,1382.1956293517724L16.423199776560068,1384.6696341978386L11.81689375732094,1395.3979410403408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M17.436129547655582,1397.8292860062793L22.035335591994226,1387.1072251568548L27.761859893798828,1389.5801878767088L23.155553873628378,1400.3095274870284Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M190.0893778083846,1425.920257736463L194.84478330332786,1414.9433503267355L200.35120837949216,1417.3528407323174L195.5958028845489,1428.3235021331348Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M200.5705187190324,1430.4989057597704L205.325924214907,1419.5209652357735L210.7755494909361,1421.9096467220224L206.02014399506152,1432.880300913006Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M11.81689375732094,1395.3979410403408L16.423199776560068,1384.6696341978386L22.035335591994226,1387.1072251568548L17.436129547655582,1397.8292860062793Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M118.35044125653803,1473.5293103847653L122.4400268709287,1463.9548837901093L128.58387192711234,1466.6130031156354L124.48797522298992,1476.172861022409Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M147.52660529688,1486.1082745241001L151.62250200100243,1476.5484303170815L157.20702680200338,1478.9506168081425L153.8692496540025,1488.8433717209846L149.3339433837682,1486.8875016397797Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M135.66333591472358,1480.9917984390631L139.75292153004557,1471.431947177276L145.67666735965759,1473.9901892179623L141.59497060719877,1483.5500369551592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M141.59497060719877,1483.5500369551592L145.67666735965759,1473.9901892179623L151.62250200100243,1476.5484303170815L147.52660529688,1486.1082745241001Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.94426257256418,1423.6886729071848L189.69966806750745,1412.6971968156286L194.84478330332786,1414.9433503267355L190.0893778083846,1425.920257736463Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M117.01170152053237,1440.802673398517L120.46938935760409,1431.4768488230184L126.8546335650608,1434.2754298043437L122.9078363366425,1443.3827743651345Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M195.5958028845489,1428.3235021331348L200.35120837949216,1417.3528407323174L205.325924214907,1419.5209652357735L200.5705187190324,1430.4989057597704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M112.68150564096868,1471.0844672978856L116.77740234415978,1461.5100373271853L122.4400268709287,1463.9548837901093L118.35044125653803,1473.5293103847653Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M105.24783178698272,1279.5808710730635L109.61983863078058,1269.7231907951646L114.9353532679379,1272.061985229142L110.54835758730769,1281.9550353507511Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M124.48797522298992,1476.172861022409L128.58387192711234,1466.6130031156354L133.66508738789707,1468.7956772428006L130.1356109129265,1478.6031373078004Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M110.54835758730769,1281.9550353507511L114.9353532679379,1272.061985229142L120.07257964182645,1274.3508402314037L115.68637284915894,1284.2438870868646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M128.15156233683228,1445.678855348844L132.1062484262511,1436.5652716192417L137.65527335181832,1439.0028443299234L133.70768723729998,1448.1164248562418Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M133.70768723729998,1448.1164248562418L137.65527335181832,1439.0028443299234L143.16800951678306,1441.4050438292325L139.22121228836477,1450.5186211979017Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M122.9078363366425,1443.3827743651345L126.8546335650608,1434.2754298043437L132.1062484262511,1436.5652716192417L128.15156233683228,1445.678855348844Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M120.80308818351477,1286.532738066744L126.76943386439234,1273.0888489084318L130.02280019968748,1274.5349889877252L124.54477502219379,1288.205679576844Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M120.8661990724504,1429.9818443208933L123.53815634176135,1422.958335895557L130.06540004909039,1426.0055677248165L127.4857424562797,1432.823080856353Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M193.61175430752337,1397.6877956916578L196.5172218652442,1391.0044558662921L200.79692903440446,1392.8896077899262L197.90566142648458,1399.5510980361141L196.18352303933352,1398.7926685004495L195.3828036338091,1399.0621242714114L194.3130740635097,1398.59499823628Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M183.00991382077336,1392.9822007785551L185.84438162855804,1386.4403469609097L190.16747753322124,1388.325500125531L187.33932081516832,1394.8808769802563L186.25539129413664,1394.994277348742L185.15726182237267,1394.5271510425955L184.80226307269186,1393.761438361369Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,1350.9739868761972L186.55280135851353,1402.4922224902548"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M189.54346861783415,1366.7544067497365L190.97529691457748,1363.4304091120139L199.3445896981284,1367.0654787491076L197.91276140138507,1370.396757264156Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M178.9700280316174,1391.2385393292643L181.8052847245708,1384.6831590328366L185.84438162855804,1386.4403469609097L183.00991382077336,1392.9822007785551L181.54258564766496,1392.3506957585923L180.7063663676381,1392.627434372902L179.6437367722392,1392.1592675377615Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M197.90566142648458,1399.5510980361141L200.79692903440446,1392.8896077899262L204.73741517402232,1394.6187036391348L201.83904759027064,1401.2729096389376L200.917628608644,1401.4861853648908L199.67039966396987,1400.939991415944L199.40848947316408,1400.203409791924Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.14307633787394,1347.251517090015L205.93494429532439,1340.7814062405378L207.50877209194005,1341.4618137427606L208.16749199759215,1341.078954482451L209.53542051836848,1341.6740509308875L209.93933020997792,1342.52508038003L207.14667336642742,1348.9951896015555Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M194.7240837290883,1354.7495138603263L196.1133121754974,1351.5243462696671L204.48260495997965,1355.167745161336L203.09337651263922,1358.3918706821278Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M199.01167975738645,1385.2855343432166L200.42141924332827,1382.0395735087804L208.64240143820643,1385.6475837249309L207.23187306616455,1388.8852198980749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M183.0525136711076,1381.791964897886L184.42675328068435,1378.5959403230809L192.7889460902661,1382.238284616731L191.42180645558983,1385.434307509102Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M196.1133121754974,1351.5243462696671L197.4733518352732,1348.3928111414425L205.84264461975545,1352.0351712997071L204.48260495997965,1355.167745161336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M208.1958918981254,1364.1461871406063L209.58512034453452,1360.963679314591L217.80531365331262,1364.5644178753719L216.41608520504087,1367.7531662918627Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.31220555771142,1373.0892447899096L205.65883415471762,1369.9785268842243L213.88612743839622,1373.5927856178023L212.53318775258958,1376.689977050759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M200.42141924332827,1382.0395735087804L201.7609478663653,1378.956949681975L209.98193005938083,1382.5576788978651L208.64240143820643,1385.6475837249309Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M197.4733518352732,1348.3928111414425L198.7773805828765,1345.359070112463L203.14307633787394,1347.251517090015L207.14667336642742,1348.9951896015555L205.84264461975545,1352.0351712997071Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.42675328068435,1378.5959403230809L185.74498197901994,1375.5486876559444L194.11427476163954,1379.1910335510038L192.7889460902661,1382.238284616731Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M197.66505116131157,1388.3681553523056L199.01167975738645,1385.2855343432166L207.23187306616455,1388.8852198980749L205.88524447008967,1391.9751219055615Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M190.97529691457748,1363.4304091120139L192.27222568634897,1360.4330878062174L200.6415184698999,1364.075441641733L199.3445896981284,1367.0654787491076Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.00817681197077,1376.1011258470826L204.31220555771142,1373.0892447899096L212.53318775258958,1376.689977050759L211.22915900684893,1379.7018565456383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M187.02061082515866,1372.5929865413345L188.31043962109834,1369.5956691987813L196.67973240464926,1373.2380182207562L195.38990360870957,1376.2363743609749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M185.74498197901994,1375.5486876559444L187.02061082515866,1372.5929865413345L195.38990360870957,1376.2363743609749L194.11427476163954,1379.1910335510038Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.65883415471762,1369.9785268842243L206.92736302688718,1367.0654787491076L215.14755633473396,1370.6662141378038L213.88612743839622,1373.5927856178023Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M181.8052847245708,1384.6831590328366L183.0525136711076,1381.791964897886L191.42180645558983,1385.434307509102L190.16747753322124,1388.325500125531L185.84438162855804,1386.4403469609097Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M206.92736302688718,1367.0654787491076L208.1958918981254,1364.1461871406063L216.41608520504087,1367.7531662918627L215.14755633473396,1370.6662141378038Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M192.27222568634897,1360.4330878062174L193.50525468122214,1357.5907812272198L201.8674474908039,1361.23313655518L200.6415184698999,1364.075441641733Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M188.31043962109834,1369.5956691987813L189.54346861783415,1366.7544067497365L197.91276140138507,1370.396757264156L196.67973240464926,1373.2380182207562Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.7609478663653,1378.956949681975L203.00817681197077,1376.1011258470826L211.22915900684893,1379.7018565456383L209.98193005938083,1382.5576788978651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M193.50525468122214,1357.5907812272198L194.7240837290883,1354.7495138603263L203.09337651263922,1358.3918706821278L201.8674474908039,1361.23313655518Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M196.5172218652442,1391.0044558662921L197.66505116131157,1388.3681553523056L205.88524447008967,1391.9751219055615L204.73741517402232,1394.6187036391348L200.79692903440446,1392.8896077899262Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M157.73242495581508,1349.3135450379923m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M160.5400706352666,1404.14640937699m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M62.49809326790273,1367.2995630195364m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M56.81574658770114,1362.7676901426166m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M100.16346078272909,1264.8333600210026m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M84.66973750200123,1388.0851743370295m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M150.16779600642622,1367.1539105838165m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M135.4219367634505,1410.2055157152936m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M164.32593509647995,1328.8825871669687m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M75.66933582723141,1372.1435450781137m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M50.269569613039494,1359.947232409846m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M37.12120475061238,1354.270940699149m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M30.51033911574632,1351.4151066951454m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M5.19419482909143,1471.360162412282m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M183.6938780825585,1417.7637856872752m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M69.56651285011321,1368.6676553748548m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M43.65397066157311,1357.0882796146907m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M7.812507841736078,1464.2493056678213m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M176.7887579249218,1415.9493854995817m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M51.78580872435123,1404.4553989605047m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M46.12002865411341,1402.0635903510265m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M170.83266776427627,1415.2981155891903m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M130.81563074421138,1422.2956226165406m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M82.96889904141426,1373.6666521416046m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M165.17714321333915,1455.511316780001m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M203.8002184703946,1467.0062590399757m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M195.41514796484262,1468.7457399973646m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M183.09116909094155,1463.1111517678946m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M149.14776626136154,1449.5084295952693m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M134.82238331716508,1475.0170229896903m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M0.019890806637704372,1419.2483891588636m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M15.246970580890775,1349.3666042769328m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1.704162660986185,1371.4527368484996m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M41.9207878690213,1280.296657758765m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M58.39667436014861,1287.4680455899797m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M120.94666545744985,1279.2968452298082m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M23.38433084730059,1312.5694051524624m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M34.46896963566542,1317.3957389579155m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M20.86462859995663,1351.758431065362m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M47.45324618648738,1282.7061949600466m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M159.45061891153455,1453.955976493191m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M28.934933545067906,1314.9820522824302m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M50.80443440005183,1324.5067463195883m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M63.89126614481211,1289.8567725755274m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M52.9060270069167,1285.0761966221035m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M39.96829473692924,1319.7865363932215m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M31.11935919523239,1275.5941043356434m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M189.4101468641311,1465.8785091899335m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M3.9572214018553495,1365.9137840243056m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M-2.873743458651006,1379.3044341788627m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M5.138972801156342,1342.8580014077015m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M36.47116259299219,1277.9224929106422m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M45.36822018772364,1322.1398792788386m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M9.7421232778579,1347.0247147860937m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M17.936283343471587,1310.192130208481m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M171.00858936831355,1458.0591610879637m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M154.61869146302342,1450.9149991213344m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M143.91745132487267,1446.9720261339098m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M176.91734636202455,1460.6454977979884m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M28.3456356190145,1396.19590501301m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M10.65802005585283,1390.1825627586804m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M22.59860027767718,1393.7042179820128m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M195.21950420737267,1421.63707074197m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M205.67224521841854,1426.2042775726877m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M16.927298003807664,1391.253104521893m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M123.46478993352503,1470.0711576128379m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M140.67197385337204,1477.4909947132692m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M189.8929451657459,1419.3160129976459m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M200.46165243629366,1423.9227552637458m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M117.56234402768314,1467.519156279508m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M129.2031475258991,1472.4837499344721m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M138.43784837797284,1444.7602149751037m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M127.50625349581242,1439.9735036469065m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M125.54192707128823,1280.5338661228307m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M125.46777177602053,1427.9937063069083m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M197.2051305565983,1395.2887021549977m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M186.59066789224744,1390.6538508445956m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M202.35813465435058,1343.0702385529876m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M194.44402915798128,1366.9094225624576m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M182.40641594305634,1388.839443563018m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M201.31996052898467,1397.0854214620776m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M206.54080883041024,1344.8877789480612m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M199.60334434360266,1354.9586295140907m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M203.82704059872776,1385.4665590361692m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M187.9207298802212,1382.0156449447386m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M200.9783728402108,1351.7802789798006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M205.20128020830452,1382.2986262077466m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M202.3108014864847,1348.6934801898897m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M189.27051402255893,1378.893486941699m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M202.44806767068803,1388.6272078161128m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M195.8088021343574,1363.7529253833927m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M207.77068228181452,1376.3955514547415m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M191.85017161536962,1372.9155023880303m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M190.5674427933991,1375.8920108303428m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M186.61354559008032,1385.0587332812138m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M197.07023103162646,1360.83259200491m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M193.11160051170737,1369.9962132428773m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M206.4950534356758,1379.329403124284m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M198.29852671176195,1357.9913259670138m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M198.7773805828765,1345.359070112463L201.58423737622797,1338.8816748447716L201.9881470669061,1339.0595796150155L202.795966447331,1338.6548722679727L204.00059554353356,1339.17922316771L204.29090563300997,1340.058343147859L205.93494429532439,1340.7814062405378L203.14307633787394,1347.251517090015Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer school"
        d="M245.0305623356253,1479.6580600519665L260.38938608951867,1442.8938036928885L263.0116435326636,1444.048606717959L286.9858925379813,1454.6145252995193L333.8283722177148,1475.279193288181L331.90822341572493,1479.6580600519665Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M242.37201613094658,1360.1282577645034m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M400.65807048231363,1479.6580600519665L419.9810469597578,1426.5371945803054L425.1435176897794,1412.401732381899"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M214.13462656456977,1337.6561085339636L208.46884649340063,1350.9739868761972"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M241.51291915308684,1262.983546542935L303.9366884706542,1285.8804156142287L425.1435176897794,1330.5856894785538"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1428.7791821477003L419.9810469597578,1426.5371945803054L275.61883252020925,1363.7987018874846L214.13462656456977,1337.6561085339636L208.46884649340063,1335.1259064255282"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M208.46884649340063,1412.0355229252018L251.08447437454015,1430.5904578841291L363.74766697827727,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M293.68274675961584,1313.3413690966554L425.1435176897794,1370.002455486916"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M312.2886257590726,1262.983546542935L303.9366884706542,1285.8804156142287L293.68274675961584,1313.3413690966554L275.61883252020925,1363.7987018874846L251.08447437454015,1430.5904578841291L233.20989280194044,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M245.1173398066312,1323.4049828173593L261.11200577020645,1279.623526966665L268.1630698572844,1282.2172129522078L267.9366595419124,1282.8268798743375L293.46974750980735,1292.1175312851556L289.83456029649824,1302.187418118585L288.24022145941854,1306.6236153026111L283.2363168383017,1304.8019033409655L271.96155649609864,1336.012309571728L276.7737617921084,1337.769509837497L271.5292469058186,1352.297346251551L246.15945836436003,1343.0702385529876L250.14175546821207,1332.0297368038446L252.20390377100557,1332.7663256716914L255.19457102753222,1324.489059841726L252.2678035441786,1323.4122654865496L251.93489360436797,1324.3121950812638L253.2673222515732,1324.8011741191149L252.75691293552518,1326.210890088696Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M241.00014317873865,1495.3559989673086L244.28112052567303,1487.8446296206675L245.5283494722098,1488.3752113790251L251.53808389045298,1474.343911101576L249.62424617726356,1473.5074628526345L253.01882312539965,1465.5986524182372L254.9255608636886,1466.4215769455768L261.03390604350716,1452.1488683070056L259.7866770979017,1451.617243414279L263.0116435326636,1444.048606717959L286.9858925379813,1454.6145252995193L282.54919703211635,1464.9962840867229L274.88832397945225,1461.6868985914625L272.36546618677676,1467.5763760525733L288.1266218582168,1474.3792832884938L280.09023901540786,1493.158768220339L264.3290833430365,1486.3704444053583L261.8559253755957,1492.1319371382706L269.5167984282598,1495.4413081016392L265.03119198419154,1505.7376967496239Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M173.045493314974,1308.4089133692905L179.586936972104,1290.6433044504374L211.73877943586558,1302.5629968377762L213.44671787321568,1297.9488912345842L223.82924802042544,1301.7972739995457L221.69609996769577,1307.6015758393332L218.66283285990357,1306.47484044265L215.95537571515888,1313.8095412580296L219.23714194912463,1315.0278291092254L215.339255659841,1325.6230749753304L203.69608550332487,1321.3002915270627L204.18440600764006,1319.960280126892Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M226.70631567761302,1334.0917692817748L237.562966379337,1304.3628613231704L248.32021743059158,1274.9105692030862L261.11200577020645,1279.623526966665L245.1173398066312,1323.4049828173593L243.5301009453833,1327.7350476207212L242.23317217454314,1327.246068790555L238.1940752696246,1338.3146683848463Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M175.7884503332898,1283.7122493209317L178.99132795631886,1274.9958810498938L178.0635978858918,1274.648391327355L179.62243684753776,1270.389039824251L180.4089563023299,1270.6803487539291L183.44222341198474,1262.3884433405474L191.0817965399474,1265.2162234913558L189.60736839286983,1269.2196424230933L226.34500583726913,1282.8050317442976L223.8363479943946,1289.6434934134595L227.69163443427533,1291.0677819331177L223.89314779546112,1301.4289779309183L218.01831290405244,1299.2535338057205L218.89634314831346,1296.8720927550457L214.92114602029324,1295.4051496284083L215.39605546090752,1294.1296371277422L184.79516309779137,1282.819597162772L183.42802346125245,1286.5400207727216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M184.32104254234582,1259.4618249209598L186.82260041031986,1252.389245340135L225.0196771658957,1265.9881927049719L240.05742427241057,1271.3316322485916L236.02542734332383,1282.755093159154L232.78626095876098,1281.6148286880925L233.84257946535945,1278.623714340385L208.0325924726203,1269.4391645491123L207.08987356629223,1272.1254489477724L191.21590717881918,1265.3077777959406L192.09472631011158,1262.8139629429206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M218.5350333089009,1331.0725873121992L229.37827294599265,1301.3582317917608L237.562966379337,1304.3628613231704L226.70631567761302,1334.0917692817748Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M284.96555519942194,1357.4565727240406L291.9464084226638,1338.6486299927346L297.3818337479606,1341.0290163164027L304.35479811020195,1344.0762841552496L301.16612043697387,1351.418227827642L301.07382076233625,1351.6377473506145L296.3894150182605,1362.4524564510211Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M364.336964905262,1472.6647723540664L364.5704751955345,1472.0759293008596L366.88112262357026,1466.2582404790446L380.8341513229534,1471.8356064124964L391.847001475282,1476.2436053776182L388.94863389153033,1483.5354719553143L372.6494578886777,1477.0155510972254L372.99656778015196,1476.143730992917Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M221.49020069092512,1410.606057413388L224.53766775038093,1403.449362121988L236.09642709326,1408.4171227579936L247.73959725070745,1413.4202523357235L248.0015074396506,1413.5336524015293L245.42184984777123,1420.8890472864732Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M212.18528897687793,1406.0492439973168L212.83059781882912,1404.5542340097018L218.25182319246233,1391.9615970845334L220.2713716449216,1387.2695231144316L227.96774457395077,1390.6153571163304L219.88166190497577,1409.3950689355843Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M271.48664705455303,1393.9601491354406L279.05522043351084,1373.719711191021L286.5251830480993,1376.6608466035686L286.36188362166286,1377.0364212887362L283.0454063983634,1384.7539043221623L281.7555776014924,1384.1941842185333L280.6716480823234,1386.72436841717L281.0542578473687,1386.8877067551948L280.34504923038185,1388.5460588536225L281.2522682612762,1388.93515771674L281.15996858570725,1389.1546760541387L277.900291162543,1396.7379378569312Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M378.19848281610757,1455.0400331052952L380.4870414324105,1448.6053951629438L388.1266145603731,1451.3477896852419L399.1465646876022,1455.302204160951L398.2464456325397,1457.8177973572165L398.5154557963833,1458.6823372384533L398.56515562254936,1459.5895318011753L398.49415587168187,1460.0358465127647L398.36714520677924,1460.4613539846614L397.96323551703244,1461.2624315540306L397.3605265254155,1461.9428272331133L396.60950694512576,1462.4317965637892L385.589556818828,1458.4773861570284Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M408.4869762780145,1313.6253935447894L413.3125926386565,1300.2668684562668L416.15416042041034,1292.3932335157879L420.98766564112157,1294.150444837287L418.2241975842044,1301.761900932528L420.37075669970363,1302.5411487678066L420.17984626069665,1303.065502401907L415.4528406653553,1316.1618457888253Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.0577679583803,1308.735593734309L399.883384318091,1295.3770592268556L403.6818709569052,1296.75869078096L404.3342797746882,1294.9733897144906L402.5340416627005,1294.3137853587978L404.89360002893955,1287.800969261676L409.6632054746151,1289.537374023348L406.665438240394,1297.8427719725296L401.8398218806833,1311.201301728841Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M418.4080080483109,1457.4640746298246L421.42707520723343,1450.504056129139L433.9987643202767,1456.0106901759282L438.6689701154828,1458.0518785631284L435.64990295656025,1465.0108491242863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M214.58823607955128,1428.0748548102565L216.3805853324011,1422.788756211754L225.5371864568442,1426.7359044118784L240.1994237722829,1433.3193347919732L238.39208568446338,1438.3151638521813L223.41823835484684,1431.8732278347015Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.88958686124533,1262.3031313386746L375.2504154080525,1258.5899774595164L380.2890310175717,1244.8422393999062L387.23359547927976,1247.406807408668L382.3440793445334,1260.7446265351027L380.8341513229534,1264.868733276613Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M323.9925401471555,1373.9465126213618L330.7035943195224,1358.462616238743L331.49721375014633,1356.6409178981557L338.1443681474775,1359.5539704137482L335.2176006641239,1366.307045659516L330.63259457051754,1376.8595578656532Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M389.00543369166553,1263.1957861362025L393.8878498515114,1249.8662948599085L400.5215931851417,1252.3112159562297L395.5815883381292,1265.796760994941L392.9459198312834,1272.9972947072238L389.3241436816752,1271.6645566946827L391.16698164399713,1266.6613248214126L392.0600007250905,1266.980724426452L392.91041995584965,1264.6419282783754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.42628645244986,1438.8967272266746L206.02014399506152,1432.880300913006L210.7755494909361,1421.9096467220224L211.34906969591975,1420.5987850339152L216.3805853324011,1422.788756211754L214.58823607955128,1428.0748548102565L212.0085784867406,1435.6934464275837L209.4786207182333,1441.5402910695411Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M317.3871967140585,1371.6223177905194L322.17100210953504,1360.6099516465329L324.3041501622647,1355.662964280229L330.7035943195224,1358.462616238743L323.9925401471555,1373.9465126213618L323.7866408722475,1374.4219633056782Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M381.16075017489493,1442.8511488009244L382.3298793947324,1439.5698425555602L385.2140470277518,1440.6112465122715L386.01476643420756,1438.3578187711537L388.7293235519901,1439.3357607261278L403.00895110331476,1444.4595500905998L401.0454135648906,1449.9869961817749L390.0191523479298,1446.0325786750764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M318.95392453763634,1274.4850503425114L321.23538317903876,1268.1501222075894L335.60731040500104,1273.3728750054725L336.07511987071484,1274.0179159147665L335.635710304603,1275.2653416320682L334.72139129880816,1275.8177878120914L333.3179629025981,1279.7077983673662L328.4568466665223,1277.9370583444834L327.6987271113321,1280.0698532653041L322.5962117249146,1278.2481343266554L323.36143125686795,1276.0872483626008Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M299.28068262618035,1400.798501165118L300.4577007070184,1398.0633692354895L305.8647261336446,1385.4696801500395L312.33438115473837,1388.2693200735375L307.5442646695301,1399.437697739806L306.473746214062,1398.9705717307515L305.97043687291443,1400.118099485524L307.04805530421436,1400.5925080035813L305.75112653244287,1403.598134898115Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M333.6800616271794,1493.215987780597L334.0555714191869,1492.336887225043L340.2988161249086,1478.134976274334L346.71246023103595,1480.9917984390631L340.0929168490693,1496.0509562734514Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M371.81323860865086,1369.787098042667L375.2007155828178,1361.9842875744216L378.68049223162234,1353.962989255786L384.7107376875356,1356.6055451100692L380.67874075844884,1365.903380277101L377.8513729246333,1372.4234056221321Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M336.89003922604024,1380.1544186342508L341.67384462151676,1369.1285411790013L343.11908398289233,1365.7972620544024L349.63922771438956,1368.653090134263L348.1931994687766,1371.977085270919L343.40939407330006,1383.0039985682815Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M321.23538317903876,1268.1501222075894L323.665941295214,1261.4104764289223L338.0307685472071,1266.6332343034446L335.60731040500104,1273.3728750054725Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M327.5993274608627,1489.4811100908555L333.8283722177148,1475.279193288181L340.2988161249086,1478.134976274334L334.0555714191869,1492.336887225043Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.80083365552127,1401.5069927545264L211.79557923600078,1387.5743519631214L214.3042370788753,1388.6657015555538L213.73071687389165,1389.998417076189L218.25182319246233,1391.9615970845334L212.83059781882912,1404.5542340097018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M259.87187679857016,1426.2250848854892L264.4781828178093,1413.5752671035007L269.3258879883215,1415.6736881826073L270.67172770015895,1412.5338590857573L272.99657507799566,1413.5398946064524L271.64994648005813,1416.6870058169588L266.34942067973316,1429.0319909080863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.8722929377109,1393.4711749730632L287.54521279316396,1391.9116592849605L292.7542278030887,1379.8006919450127L299.3800822747871,1382.6637968635187L293.97305685002357,1395.249168082606L293.51234735827893,1396.3477990566753Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M305.8363262331113,1446.1251709563658L311.8247607247904,1432.185337274801L318.25181589461863,1434.963110680692L312.2633814038709,1448.9029387771152Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M353.46611425466835,1358.384588052053L353.59312491863966,1358.1016058134846L355.75467287097126,1353.1046785772778L359.09954999480397,1345.394442957826L365.95970364194363,1348.4063360453583L360.3254790166393,1361.3891928675584Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M273.13778569176793,1431.9658203022555L278.43910037819296,1419.6208404363133L279.1972199343145,1417.8490957780741L285.4830644913018,1420.576937334612L284.7320449091494,1422.3424390996806L279.6153295747936,1434.2546225162223L279.43151910975575,1434.6936563085765Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M299.1110721109435,1443.2121548145078L304.4115979112685,1430.8671949729323L308.16038472391665,1432.4901641486213L309.01080395653844,1430.4916232065298L312.0014712139964,1431.781675728038L311.8247607247904,1432.185337274801L305.8363262331113,1446.1251709563658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M319.8603546814993,1407.6014739242382L320.88117331359535,1405.2065452961251L325.67917865980417,1394.0589843322523L332.19143353030086,1396.8648630096577L326.59270877949893,1409.8902841811068L326.3662984650582,1410.4219122715294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M323.665941295214,1261.4104764289223L325.9481888236478,1255.0817786925472L340.3130160747096,1260.311824069824L339.1722867535427,1263.4798126374371L339.5335965938866,1264.6346455481835L339.0728871030733,1265.9247289332561L338.1301681967452,1266.3710561119951L338.0307685472071,1266.6332343034446Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M395.5815883381292,1265.796760994941L400.5215931851417,1252.3112159562297L407.3241581460461,1254.8196000671014L402.384942186065,1268.306180614978Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M352.8705052379519,1293.37119605951L357.80972119793296,1279.7077983673662L360.6796888811514,1280.750266725663L361.36049759667367,1278.8786093527451L364.76217452064157,1280.1052264436148L359.1350498702377,1295.660044023767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.8306412100792,1262.1543555269018L271.11823724024,1250.3407136620954L271.8692568205297,1248.3005045158789L278.43910037819296,1250.7027700901963L275.3419334953651,1259.2423024801537L274.41341453883797,1261.814147892408L273.40758474357426,1264.5711817615665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M312.2633814038709,1448.9029387771152L318.25181589461863,1434.963110680692L324.5021605780348,1437.677420775406L323.8292407216504,1439.2577334456146L318.5145149724558,1451.6099608824588Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.404432781972,1457.6190884155221L337.23004914075136,1444.0558892586268L343.79910381231457,1447.0105195464566L338.9734874544665,1460.574753283523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M408.9334858190268,1270.7292470410466L413.8727017790079,1257.2437115963548L420.6121558500454,1259.7312861075625L415.6658399151638,1273.2168167121708Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M381.7484703287482,1303.8884462206624L386.16386590898037,1291.649357660208L386.574875574559,1290.529902371578L393.3427295461297,1292.9956168415956L388.5163243021816,1306.354155939538Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M208.29529154859483,1469.489596855361L210.24384025018662,1464.1036552712321L226.5501162270084,1471.0553372474387L224.55896767508239,1476.5338653032668Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.6658399151638,1273.2168167121708L420.6121558500454,1259.7312861075625L427.2593102483079,1262.1897287974134L422.3200942873955,1275.669012291357Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M360.15586850140244,1361.7866162611172L360.3254790166393,1361.3891928675584L365.95970364194363,1348.4063360453583L372.3591477992013,1351.2059909356758L368.87937115039676,1359.213767558802L366.55452377162874,1364.5852253735065Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.3440793445334,1260.7446265351027L387.23359547927976,1247.406807408668L393.8878498515114,1249.8662948599085L389.00543369166553,1263.1957861362025Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.3200942873955,1275.669012291357L427.2593102483079,1262.1897287974134L433.8567648185417,1264.621120477561L428.9246488343924,1278.1066415715031Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M206.36725388467312,1474.7975073731504L208.29529154859483,1469.489596855361L224.55896767508239,1476.5338653032668L222.6033189976588,1481.9697343800217Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M402.384942186065,1268.306180614978L407.3241581460461,1254.8196000671014L413.8727017790079,1257.2437115963548L408.9334858190268,1270.7292470410466Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M401.8398218806833,1311.201301728841L406.665438240394,1297.8427719725296L413.3125926386565,1300.2668684562668L408.4869762780145,1313.6253935447894Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M326.59270877949893,1409.8902841811068L332.19143353030086,1396.8648630096577L338.69737731292844,1399.6863460931927L333.8070722911507,1411.0742230066098L333.1057525379583,1412.7107215966098Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M210.24384025018662,1464.1036552712321L212.08667821250856,1458.994445471093L228.56966467853636,1465.4644460063428L226.5501162270084,1471.0553372474387Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.34942067973316,1429.0319909080863L271.64994648005813,1416.6870058169588L278.43910037819296,1419.6208404363133L273.13778569176793,1431.9658203022555Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.5163243021816,1306.354155939538L393.3427295461297,1292.9956168415956L399.883384318091,1295.3770592268556L395.0577679583803,1308.735593734309Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M286.06447355728596,1437.564021104481L286.2482840223238,1437.1249874946661L291.3720993325114,1425.2117686439306L298.0121537540108,1428.0894199227914L292.7116279536858,1440.4343847129494Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M293.97305685002357,1395.249168082606L299.3800822747871,1382.6637968635187L305.8647261336446,1385.4696801500395L300.4577007070184,1398.0633692354895Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M390.40176211390644,1427.4090209221467L392.3645107652992,1421.9096467220224L409.06049648299813,1428.8967434228398L407.41645782254636,1433.5180444307625L395.093267833814,1429.0881706303917Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.42707520723343,1450.504056129139L424.2828429406509,1443.927924609743L436.5074221631512,1449.2857920839451L433.9987643202767,1456.0106901759282Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.7999071618542,1296.624481100589L366.6397234732285,1283.2378328028135L372.99656778015196,1285.5474918503314L372.57135816384107,1286.7096037920564L368.156751469709,1298.9341356861405Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.5039048846811,1479.9493601880968L206.36725388467312,1474.7975073731504L222.6033189976588,1481.9697343800217L220.76048103533685,1487.064362256322Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M219.83196207974106,1448.3713136371225L222.22070923261344,1441.7806150075048L235.2949188016355,1446.8617477016523L233.02056013513356,1453.1829878445715L221.49730066675693,1448.9736834140494Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M212.08667821250856,1458.994445471093L214.07782676350325,1453.8987566106953L230.42670259065926,1460.3198649515398L228.56966467853636,1465.4644460063428Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.4528406653553,1316.1618457888253L420.17984626069665,1303.065502401907L426.6502901688218,1305.426133650355L425.7004712866619,1308.0270926663652L421.9161845976487,1318.515189904254Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M424.2828429406509,1443.927924609743L427.16701057273895,1437.2945668301545L439.0728798052296,1442.5036674891599L436.5074221631512,1449.2857920839451Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M279.6153295747936,1434.2546225162223L284.7320449091494,1422.3424390996806L291.3720993325114,1425.2117686439306L286.2482840223238,1437.1249874946661Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M292.7116279536858,1440.4343847129494L298.0121537540108,1428.0894199227914L304.4115979112685,1430.8671949729323L299.1110721109435,1443.2121548145078Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M349.73073850478977,1385.7672264762223L354.5145439002663,1374.7476001866162L358.0156204737723,1376.2790296622552L358.9717504447326,1374.0817611799575L361.9979175776243,1375.4134391290136L356.2650821870193,1388.623046330642Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M281.15996858570725,1389.1546760541387L281.2522682612762,1388.93515771674L283.0454063983634,1384.7539043221623L286.36188362166286,1377.0364212887362L292.7542278030887,1379.8006919450127L287.54521279316396,1391.9116592849605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M284.9024443104863,1269.77937180968L287.1555030532181,1263.572407354135L300.2376014813781,1268.355078915134L297.9837538525462,1274.5703621944413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M313.97131984028965,1402.215484266635L318.76932518649846,1391.0616762680002L325.67917865980417,1394.0589843322523L320.88117331359535,1405.2065452961251Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M338.83148795273155,1417.8636609129608L340.5039265146479,1413.979970079381L345.26643198542297,1402.8677957733162L350.3831473207101,1405.0858625094406L344.663722993806,1418.3807232580148L343.94110331404954,1420.0671577206813Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M341.26993493176997,1289.1472291904502L345.8194411508739,1276.5543826515786L346.20915089175105,1275.4848635648377L352.0626858584583,1277.6030938117765L347.1234698975459,1291.2737783482298Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M333.8070722911507,1411.0742230066098L338.69737731292844,1399.6863460931927L345.3942315354943,1402.583774981089L345.26643198542297,1402.8677957733162L340.5039265146479,1413.979970079381Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M356.2650821870193,1388.623046330642L361.9979175776243,1375.4134391290136L367.71734190452844,1377.9082538532093L366.77462299820036,1380.105521121528L361.98371762782335,1391.1251388960518Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M347.64019030239433,1355.5006655827165L350.1914479956031,1349.6183755551465L350.67345741018653,1348.5197371765971L353.14661537855864,1342.8080632551573L359.09954999480397,1345.394442957826L355.75467287097126,1353.1046785772778L353.59312491863966,1358.1016058134846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M344.663722993806,1418.3807232580148L350.3831473207101,1405.0858625094406L356.0520829362795,1407.5380114489235L350.3405474703759,1420.8328674971126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M347.1234698975459,1291.2737783482298L352.0626858584583,1277.6030938117765L357.80972119793296,1279.7077983673662L352.8705052379519,1293.37119605951Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.2042981470004,1425.5810985034332L362.16831697896123,1423.3557557603344L366.9308224497363,1412.2435964811593L372.47195851430297,1414.6458052550443L372.29524802416563,1415.0421852259897L367.69604197889566,1425.7433955599554L366.73202314786613,1427.9833026523702Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M380.8341513229534,1471.8356064124964L383.23709842562675,1465.0743110761978L394.39825916755944,1469.0786549644545L391.847001475282,1476.2436053776182Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.7293235519901,1439.3357607261278L389.96945252269506,1435.8567836121656L392.371610741131,1436.7348509663716L393.1226303204894,1434.622911526356L405.4466091953218,1439.0382166975178L403.4554606433958,1444.6156045291573L403.00895110331476,1444.4595500905998Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M350.3405474703759,1420.8328674971126L356.0520829362795,1407.5380114489235L361.51590816117823,1409.8975667590275L356.74709160253406,1421.0097297956236L355.7972727213055,1423.2069834051654Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M307.5442646695301,1399.437697739806L312.33438115473837,1388.2693200735375L318.76932518649846,1391.0616762680002L313.97131984028965,1402.215484266635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M330.42669529281557,1377.3277257373556L330.63259457051754,1376.8595578656532L335.2176006641239,1366.307045659516L341.67384462151676,1369.1285411790013L336.89003922604024,1380.1544186342508Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M354.23133378475904,1467.4348871638067L359.0640501193702,1453.863384315744L364.4213757198304,1456.2801437256858L359.5957593601197,1469.8370768120512Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M294.8731759060174,1330.5336704761721L298.65746259503067,1320.0528740896843L300.2447014572099,1319.2736282246187L305.76532648224384,1321.689394166693L305.60912703257054,1322.0649718274362L303.1714689396322,1327.6778266942129L301.15192048903555,1332.3335277023725L300.2376014813781,1331.9225776838139L299.95439136680216,1332.7455180776305Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M287.1555030532181,1263.572407354135L289.2034514034167,1257.9303696420975L302.2784498585388,1262.72865094617L300.2376014813781,1268.355078915134Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M266.3991205058992,1406.134554227814L268.7870787726715,1400.578983202111L281.4439675863832,1406.0492439973168L279.05522043351084,1411.6193757927977Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M343.40939407330006,1383.0039985682815L348.1931994687766,1371.977085270919L354.5145439002663,1374.7476001866162L349.73073850478977,1385.7672264762223Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M318.5145149724558,1451.6099608824588L323.8292407216504,1439.2577334456146L329.48476527351886,1441.7171528432518L324.176350611262,1454.0620933687314Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M373.21666700579226,1396.0356880030595L378.0067834891379,1385.0160780344158L381.1536501990631,1386.3987320964225L382.56338968500495,1383.1454891818576L384.9876367133111,1384.2014668220654L383.5842083161697,1387.4474266404286L378.7933029457927,1398.481597923208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M383.23709842562675,1465.0743110761978L385.589556818828,1458.4773861570284L396.60950694512576,1462.4317965637892L394.39825916755944,1469.0786549644545Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M219.22294199932367,1455.281396935694L221.49730066675693,1448.9736834140494L233.02056013513356,1453.1829878445715L230.73831260669976,1459.4761324874125Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M338.9734874544665,1460.574753283523L343.79910381231457,1447.0105195464566L349.01521879900247,1449.3492541792803L344.1825024643913,1462.9207658604719Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M359.5957593601197,1469.8370768120512L364.4213757198304,1456.2801437256858L369.87888985779136,1458.7249920326285L366.88112262357026,1466.2582404790446L364.5704751955345,1472.0759293008596Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.97258272208273,1474.4999648672529L414.95663129910827,1469.2128613055684L423.82213344890624,1473.1537409294397L428.0174298034981,1475.0170229896903L426.02628125064075,1480.2895571184345L422.1283949613571,1478.567765139509Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M349.18561819847673,1465.1669031004421L354.01833453495055,1451.5953958160244L359.0640501193702,1453.863384315744L354.23133378475904,1467.4348871638067Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M344.1825024643913,1462.9207658604719L349.01521879900247,1449.3492541792803L354.01833453495055,1451.5953958160244L349.18561819847673,1465.1669031004421Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M405.61700859479606,1400.0681617455557L407.62945707235485,1394.6187036391348L419.1732275802642,1399.664498328697L419.77593657001853,1399.9339540656656L417.76348809339106,1405.3761254134588Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M393.1226303204894,1434.622911526356L395.093267833814,1429.0881706303917L407.41645782254636,1433.5180444307625L405.4466091953218,1439.0382166975178Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M221.7954996181652,1436.4591544750147L223.41823835484684,1431.8732278347015L238.39208568446338,1438.3151638521813L236.84034669864923,1442.5889772735536Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M239.5115150809288,1397.5036502070725L241.82216250896454,1392.0677149053663L252.84921261109412,1396.8159656119533L253.4582326905802,1397.0708562792279L251.5096839889884,1402.6482778727077L240.10712409671396,1397.758540851064Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M220.19327192008495,1440.986817732919L221.7954996181652,1436.4591544750147L236.84034669864923,1442.5889772735536L235.2949188016355,1446.8617477016523L222.22070923261344,1441.7806150075048Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M329.0169558087364,1345.28104177583L329.93048592843115,1343.1690744771622L333.88517201785,1334.0563963763416L339.5406965697184,1336.5366606744938L339.4199969936162,1336.8061188650317L336.464829611592,1343.616437064018L335.96152027044445,1344.7847815384157L334.66459149867296,1347.7613020576537Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M243.34550159517676,1379.531235428527L244.69923016615212,1376.349775036797L247.49819809943438,1377.5472444393672L247.72539730090648,1377.0364212887362L258.80924720317125,1381.7992475023493L257.05160894058645,1386.815921117086L245.64194907341152,1381.9053654796444L246.14525841455907,1380.7287042792886Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M403.66057103220373,1405.3761254134588L405.61700859479606,1400.0681617455557L417.76348809339106,1405.3761254134588L415.8070505298674,1410.6840850152075Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M367.5824423795566,1393.5772927743383L372.3662477750331,1382.5503962910734L378.0067834891379,1385.0160780344158L373.21666700579226,1396.0356880030595Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M407.62945707235485,1394.6187036391348L409.6632054746151,1389.1057786056772L410.2651255792007,1389.3741943794303L421.1998760057613,1394.151577307377L419.1732275802642,1399.664498328697Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M249.1848366111517,1372.055113307666L251.5096839889884,1366.591067938134L262.74184448085725,1371.4173641358502L260.7790958294645,1377.0228964383714L260.51639675348997,1376.92302062409Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M268.7870787726715,1400.578983202111L270.89892690069973,1395.667396940291L283.55581571441144,1401.1532671549357L281.4439675863832,1406.0492439973168Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M401.7262222804129,1410.5998152066022L403.66057103220373,1405.3761254134588L415.8070505298674,1410.6840850152075L413.88690172787756,1415.914013014175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M361.98371762782335,1391.1251388960518L366.77462299820036,1380.105521121528L372.3662477750331,1382.5503962910734L367.5824423795566,1393.5772927743383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M384.1932283965871,1400.8411563155241L388.9699338171631,1389.8142713871785L394.56865856796503,1392.2591431322508L389.7848531724885,1403.2860241713934Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M306.8066561529413,1366.994733279571L311.5904615484178,1355.9750771527179L317.12528652511537,1358.4053955683485L312.34858110453933,1369.4188055894338Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M389.7848531724885,1403.2860241713934L394.56865856796503,1392.2591431322508L400.09638356789947,1394.6686414186843L395.3125781742856,1405.6955186268315Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.9894678052515,1428.0467649428174L377.5886738486588,1417.332033393439L377.75907325092703,1416.9346131850034L383.2228984758258,1419.2952056629583L378.4461930543184,1430.4063132731244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.2651255792007,1389.3741943794303L412.44797345623374,1383.797802480869L423.21311336848885,1388.5034036277793L423.58152318466455,1388.6657015555538L421.1998760057613,1394.151577307377Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M236.09642709326,1408.4171227579936L238.34948583506048,1403.1299688001163L249.6384461261332,1407.9770469334908L247.73959725070745,1413.4202523357235Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M356.74709160253406,1421.0097297956236L361.51590816117823,1409.8975667590275L366.9308224497363,1412.2435964811593L362.16831697896123,1423.3557557603344Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M243.42360132094473,1387.1072251568548L245.64194907341152,1381.9053654796444L257.05160894058645,1386.815921117086L255.18037107773125,1392.1592675377615L254.57135099731386,1391.8908518683165Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M200.5705187190324,1430.4989057597704L205.325924214907,1419.5209652357735L210.7755494909361,1421.9096467220224L206.02014399506152,1432.880300913006Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M378.7933029457927,1398.481597923208L383.5842083161697,1387.4474266404286L388.9699338171631,1389.8142713871785L384.1932283965871,1400.8411563155241Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.9161845976487,1318.515189904254L425.7004712866619,1308.0270926663652L431.66760585363954,1310.1879686759785L427.883319163695,1320.6906279888935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M380.67874075844884,1365.903380277101L384.7107376875356,1356.6055451100692L391.41469188407063,1359.5394051535986L387.86470437143,1367.7032283218578L385.51145709306,1366.6763786561787L385.02234770264477,1367.8103868882172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M237.90297629497945,1402.9385408773087L240.10712409671396,1397.758540851064L251.5096839889884,1402.6482778727077L249.6384461261332,1407.9770469334908L238.34948583506048,1403.1299688001163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M301.15192048903555,1332.3335277023725L303.1714689396322,1327.6778266942129L305.60912703257054,1322.0649718274362L311.3427513083443,1324.5670884130523L307.6712753335014,1333.0493089416996L306.8989558285102,1334.835640582256Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M338.12306822184473,1321.0089847208L342.1905650263652,1309.8051076908596L347.74668992776424,1311.84633911727L343.6649931743741,1323.0429301848635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M335.42981102876365,1288.53860321315L335.55051060486585,1288.205679576844L337.5132592562586,1282.755093159154L338.00236864667386,1281.4233974097297L339.2850974686444,1281.890531339217L341.75825543608516,1275.0666274572723L345.8194411508739,1276.5543826515786L341.26993493176997,1289.1472291904502L337.80435823183507,1287.8862809496932L337.3152488414198,1289.2252581594512Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M296.3894150182605,1362.4524564510211L301.07382076233625,1351.6377473506145L301.16612043697387,1351.418227827642L306.4453463135287,1353.7289045378566L301.6694297781214,1364.763129484374Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M327.81863780040294,1317.182460641954L331.8798235151917,1306.0285158464685L336.8758392762393,1307.863752468489L332.7941425209865,1319.053067294415L331.73072404041886,1321.9869432277046L329.9659858029336,1321.3356644916348L331.0436042351648,1318.3664153018035Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M303.8727886946872,1314.9862138153985L306.2118360232562,1308.9197415770032L316.0689680185169,1312.7389875352383L313.73780955187976,1318.8127391044982Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M328.2304363520816,1455.8119811848737L333.53806212730706,1443.4608015976846L334.9833014877513,1440.0941858273L338.15146812144667,1441.4685059972107L337.23004914075136,1444.0558892586268L332.404432781972,1457.6190884155221Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M301.6694297781214,1364.763129484374L306.4453463135287,1353.7289045378566L311.5904615484178,1355.9750771527179L306.8066561529413,1366.994733279571Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M367.69604197889566,1425.7433955599554L372.29524802416563,1415.0421852259897L377.5886738486588,1417.332033393439L372.9894678052515,1428.0467649428174Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M332.7941425209865,1319.053067294415L336.8758392762393,1307.863752468489L342.1905650263652,1309.8051076908596L338.12306822184473,1321.0089847208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M312.34858110453933,1369.4188055894338L317.12528652511537,1358.4053955683485L322.17100210953504,1360.6099516465329L317.3871967140585,1371.6223177905194Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M388.1266145603731,1451.3477896852419L390.0191523479298,1446.0325786750764L401.0454135648906,1449.9869961817749L399.1465646876022,1455.302204160951Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M343.6649931743741,1323.0429301848635L347.74668992776424,1311.84633911727L348.15059961844236,1310.7549774362706L352.8776052137837,1312.4913764498197L348.3990987436846,1324.7793261180632Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M309.3153139958158,1300.847403027583L310.676142542623,1297.3184179430827L326.7063083797693,1303.5336752571166L325.338379858993,1307.0699398615398L322.89362179115415,1306.1200696108863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M400.5215931851417,1373.2380182207562L404.17098034825176,1364.8193097272888L410.6627241810784,1367.654330721125L407.00544815696776,1376.0657531577162Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M247.16528815869242,1376.796095106285L249.1848366111517,1372.055113307666L260.51639675348997,1376.92302062409L258.80924720317125,1381.7992475023493L247.72539730090648,1377.0364212887362Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M394.15764890331775,1370.4529374628328L397.8070360664278,1362.0342255895957L404.17098034825176,1364.8193097272888L400.5215931851417,1373.2380182207562Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M241.38985291868448,1391.8908518683165L243.42360132094473,1387.1072251568548L254.57135099731386,1391.8908518683165L252.84921261109412,1396.8159656119533L241.82216250896454,1392.0677149053663Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M377.184764158912,1302.2300738748163L381.61435968987644,1289.9982650876045L386.16386590898037,1291.649357660208L381.7484703287482,1303.8884462206624Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M372.64235791377723,1300.5789838237688L377.0711645586416,1288.3398894169368L381.61435968987644,1289.9982650876045L377.184764158912,1302.2300738748163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M387.86470437143,1367.7032283218578L391.41469188407063,1359.5394051535986L391.52119150944054,1359.284513107501L397.8070360664278,1362.0342255895957L394.15764890331775,1370.4529374628328Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M307.76357500907034,1304.8726494456641L309.3153139958158,1300.847403027583L322.89362179115415,1306.1200696108863L321.34188280440867,1310.1525956508704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M306.2118360232562,1308.9197415770032L307.76357500907034,1304.8726494456641L321.34188280440867,1310.1525956508704L319.7901438185945,1314.1851193453185L316.0689680185169,1312.7389875352383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.156751469709,1298.9341356861405L372.57135816384107,1286.7096037920564L377.0711645586416,1288.3398894169368L372.64235791377723,1300.5789838237688Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.04406376648694,1383.6198988589458L414.08491214364767,1378.9215770079754L425.2539617465809,1383.8113273181953L423.21311336848885,1388.5034036277793L412.44797345623374,1383.797802480869Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M324.21185048669577,1340.6752876313403L328.1665365770459,1331.561565873213L333.88517201785,1334.0563963763416L329.93048592843115,1343.1690744771622Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.2477302746847,1374.8890909664333L417.1607791027054,1370.4883101820014L428.81104923505336,1375.5913429618813L426.91220035776496,1379.9921205099672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M348.3990987436846,1324.7793261180632L352.8776052137837,1312.4913764498197L357.2504009436816,1314.0925253015012L352.77820556238294,1326.3877548021264Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M318.6486256113276,1338.2376803490333L318.7977250861004,1337.9037187211215L322.4684121757746,1329.435029072687L322.6033117007464,1329.1239553866908L328.1665365770459,1331.561565873213L324.21185048669577,1340.6752876313403Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M368.87937115039676,1359.213767558802L372.3591477992013,1351.2059909356758L378.68049223162234,1353.962989255786L375.2007155828178,1361.9842875744216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M324.176350611262,1454.0620933687314L329.48476527351886,1441.7171528432518L333.53806212730706,1443.4608015976846L328.2304363520816,1455.8119811848737Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M410.90333444532007,1479.9920148486272L412.97258272208273,1474.4999648672529L422.1283949613571,1478.567765139509L420.0591466855258,1484.0598119013011Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M336.464829611592,1343.616437064018L339.4199969936162,1336.8061188650317L346.62726053223014,1339.9449418778531L344.5296123540029,1344.7847815384157L343.6649931743741,1346.7625396354124Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M352.77820556238294,1326.3877548021264L357.2504009436816,1314.0925253015012L361.4101974228397,1315.6239681751467L356.93800204247236,1327.911912295036Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M355.0320531902835,1336.181891381275L363.7129559898749,1316.0775748305023L425.1435176897794,1338.5862072650343L425.1435176897794,1367.0373886353336Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M313.20610031019896,1335.4588278080337L316.883887372911,1326.990135173779L322.4684121757746,1329.435029072687L318.7977250861004,1337.9037187211215Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M307.6712753335014,1333.0493089416996L311.3427513083443,1324.5670884130523L316.883887372911,1326.990135173779L313.20610031019896,1335.4588278080337Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M236.54214774817228,1282.628165917471L240.07162422221154,1272.9972947072238L244.98954025749117,1274.8179746353999L242.67968171462417,1281.133129317779L241.4679526425898,1284.4488433185034Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M291.9464084226638,1338.6486299927346L294.8731759060174,1330.5336704761721L299.95439136680216,1332.7455180776305L300.8119105724618,1333.1210951390676L297.3818337479606,1341.0290163164027Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M343.6649931743741,1346.7625396354124L344.5296123540029,1344.7847815384157L346.62726053223014,1339.9449418778531L353.14661537855864,1342.8080632551573L350.67345741018653,1348.5197371765971L350.1914479956031,1349.6183755551465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.5965916393325,1378.7093409607187L415.2477302746847,1374.8890909664333L426.91220035776496,1379.9921205099672L425.2539617465809,1383.8113273181953L414.08491214364767,1378.9215770079754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M382.2872795443982,1424.4959969166666L384.3991276724264,1418.5648681893945L392.3645107652992,1421.9096467220224L390.40176211390644,1427.4090209221467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M407.00544815696776,1376.0657531577162L410.6627241810784,1367.654330721125L414.4612108198926,1369.318929664325L410.81103476975113,1377.7313904548064Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M213.58161739818752,1351.772996341344L216.31747444253415,1345.4797539371066L216.5935845822096,1345.6077204048634L217.38010403700173,1345.161398325581L218.71963265910745,1345.7492117802612L218.8821431985125,1346.606482994277L220.48437089659274,1347.3149801190011L217.7556138280779,1353.6082208543085Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.14307633787394,1347.251517090015L205.93494429532439,1340.7814062405378L207.50877209194005,1341.4618137427606L208.16749199759215,1341.078954482451L209.53542051836848,1341.6740509308875L209.93933020997792,1342.52508038003L207.14667336642742,1348.9951896015555Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M217.7556138280779,1353.6082208543085L220.48437089659274,1347.3149801190011L221.993510033004,1347.9818620732985L222.71612971276045,1347.4928846727125L224.06985828466713,1348.0952632115223L224.53766775038093,1349.094025441911L221.80259959306568,1355.372699296102Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M199.01167975738645,1385.2855343432166L200.42141924332827,1382.0395735087804L208.64240143820643,1385.6475837249309L207.23187306616455,1388.8852198980749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M319.83905475679785,1322.114910130389L322.0929023856297,1316.8068827167153L327.15281791985035,1318.961513699498L326.848307880573,1319.6918616634794L324.9060702677816,1324.2695394605398Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M208.1958918981254,1364.1461871406063L209.58512034453452,1360.963679314591L217.80531365331262,1364.5644178753719L216.41608520504087,1367.7531662918627Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M204.31220555771142,1373.0892447899096L205.65883415471762,1369.9785268842243L213.88612743839622,1373.5927856178023L212.53318775258958,1376.689977050759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M210.8749491404742,1357.9944470929913L212.23498880118132,1354.8556322543882L220.45597099605948,1358.462616238743L219.1022424250841,1361.5951871960424Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M212.23498880118132,1354.8556322543882L213.58161739818752,1351.772996341344L217.7556138280779,1353.6082208543085L221.80259959306568,1355.372699296102L220.45597099605948,1358.462616238743Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M200.42141924332827,1382.0395735087804L201.7609478663653,1378.956949681975L209.98193005938083,1382.5576788978651L208.64240143820643,1385.6475837249309Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M203.00817681197077,1376.1011258470826L204.31220555771142,1373.0892447899096L212.53318775258958,1376.689977050759L211.22915900684893,1379.7018565456383Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M209.58512034453452,1360.963679314591L210.8749491404742,1357.9944470929913L219.1022424250841,1361.5951871960424L217.80531365331262,1364.5644178753719Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M205.65883415471762,1369.9785268842243L206.92736302688718,1367.0654787491076L215.14755633473396,1370.6662141378038L213.88612743839622,1373.5927856178023Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M206.92736302688718,1367.0654787491076L208.1958918981254,1364.1461871406063L216.41608520504087,1367.7531662918627L215.14755633473396,1370.6662141378038Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M201.7609478663653,1378.956949681975L203.00817681197077,1376.1011258470826L211.22915900684893,1379.7018565456383L209.98193005938083,1382.5576788978651Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M273.0888747526333,1265.4565535387956L273.40758474357426,1264.5711817615665L274.41341453883797,1261.814147892408L281.0613578213379,1264.245539705269L279.73602914996445,1267.887944073882Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M238.92379492614418,1361.3538201060146L240.82974377740175,1356.7969743129797L245.81865956261754,1358.9016548315994L243.91981068719178,1363.4512166138738Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M331.5256136506796,1286.7387346173637L333.49546227697283,1281.288147045765L337.5132592562586,1282.755093159154L335.55051060486585,1288.205679576844Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M263.86521830782294,1315.0143041377887m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M241.3409419786185,1313.8834084151313m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M213.34731822274625,1267.7141990363598m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M228.04742207191885,1317.7172169913538m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M220.10886110551655,1398.2579184067436m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M390.0822632377967,1456.5600008727051m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.3342001559213,1308.345449983608m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.8616030998528,1303.2891849926673m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M329.6030981903896,1370.1273003797978m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M210.4181840820238,1430.4770580953918m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M323.5823193686083,1366.1166570931673m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M392.0836673080921,1443.655349492561m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M306.3972242595628,1393.166346386075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.93893928360194,1363.9443543888628m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M342.5416193474084,1376.0657531577162m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M329.63386474829167,1267.3916782946326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M212.0259339818731,1396.7337763765827m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M293.46422530617565,1387.2872094297782m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M312.04407106433064,1440.5436228848994m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M358.7555956495926,1355.6026224568486m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M278.93452085740864,1427.1541313710622m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M305.4016499835998,1437.8511615544558m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M326.53748675156385,1401.0357054062188m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M358.69879584852606,1287.0602140701376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M318.0451277345419,1444.0808579730801m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M338.1017682971433,1452.3153261905536m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.77124306187034,1265.22974855965m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M387.5444166082889,1298.442033671774m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M217.408503937535,1470.2729872735217m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M421.4633639678359,1267.7037951420061m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M366.813278417103,1355.209360213019m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M215.44338862784207,1475.6662065708078m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M407.5758128166199,1305.7340872497298m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M332.64583193231374,1404.7883170139976m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M219.3381193727255,1464.784050673712m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M272.3938660863787,1424.3264172696508m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.20024875272065,1300.865089562256m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M292.1317966589704,1432.606685000006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M299.91968037653714,1390.3594258418307m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.186421549879,1291.6670442176983m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M227.56462377030402,1447.617050891742m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M221.2566904015839,1459.6571552436799m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M420.57665597461164,1312.093950229697m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M285.4925311235711,1429.73319705436m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M298.5620073750615,1435.6507914923131m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M355.67736203223467,1381.0231296909042m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M287.89942265860736,1382.277818763163m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M292.56962845195085,1269.0677455947734m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M319.82485480606556,1398.1372354985215m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M345.43998693022877,1409.5323975374922m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M346.6659159511328,1283.3751639039256m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M339.53832991141826,1406.971010603942m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M361.5182748204097,1384.3648052215576m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M352.9730604328215,1351.3620474757627m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M350.3594807367772,1412.959369473625m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M352.4658066611737,1285.4913109643385m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.22902140021324,1419.1994919227436m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M387.6162052452564,1470.4571308260784m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.1468722810969,1441.8981760623865m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M355.9298055889085,1415.3646990987472m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M313.1540338266641,1395.249168082606m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M336.15400848165154,1372.9935304140672m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M359.3267491944134,1461.8575176871382m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M294.7169764563441,1263.1500089699402m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M273.92114960215986,1406.0918991123326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M348.96157454233617,1378.8758006067947m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M324.0004290090874,1446.663038445171m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.40122654661536,1391.7420788379386m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M389.93868596479297,1463.753053945955m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M226.1201732950285,1454.231672287453m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M343.9931697966531,1454.9620060049929m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M365.2954615345225,1462.4910970977508m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M420.4954007063061,1474.7590141119435m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M354.12483415938914,1459.5156661928631m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M349.1004184996709,1457.258083152119m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M412.6964725833386,1400.0015780916438m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M400.26914962846786,1434.0704780016094m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M246.49315719120204,1397.2872532480396m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M227.54490161687136,1441.3842365620658m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M334.6756359040737,1339.9875974026509m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M251.74003873486072,1381.2644960987382m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M408.16432185843587,1402.7221440873109m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.7930351626128,1389.2972069112584m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M414.4146665399894,1394.3846202907152m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M255.97556828148663,1371.7357185394503m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M276.17184168752283,1400.8661251827143m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M367.17695491667837,1386.8377689193003m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M389.3793657105416,1396.5496308654547m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M311.9667602246627,1362.7000657534227m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.9402239276096,1398.9768139487132m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M378.1046053683385,1423.6709866826423m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M416.91622440703213,1389.0204681628384m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M242.87611435726285,1408.1965646655299m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M361.8401403548196,1416.626664524898m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M250.24273288901895,1386.9615731369704m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M383.88398503977805,1394.1474158247001m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M386.0447441069409,1362.7219136315398m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M244.7118523446843,1402.792889191769m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M305.5752049293369,1330.006197779905m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M340.7035147007555,1282.3233324550092m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M301.418563994579,1358.0901616793126m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M309.9724561283365,1313.8626007656567m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M332.94718642905354,1449.9339377135038m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M306.6275790054351,1360.3685845220461m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.6431468008086,1421.5371955703013m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M317.2586082769558,1365.0138598293997m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M394.58601406309754,1450.6673929672688m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M318.00805008690804,1302.1905392720364m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M405.59018646739423,1370.4466952192597m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M254.0451639611274,1376.9802411417477m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M399.1639201827347,1367.6366443536244m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M248.07329607661813,1391.97928338591m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M381.6782594639808,1296.9397177854553m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M377.1279643587768,1295.288626474794m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M392.8378424337134,1364.8692477219738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M315.3274150704965,1305.4968797480687m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M313.7796205151826,1309.5356484483927m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M372.61238024104387,1293.6375347697176m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M418.6328405914828,1383.7093708557077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M329.04851125366986,1337.3658427936025m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M323.48134194593877,1334.732643023599m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M373.78072057757527,1356.5878587178886m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M328.85760081373155,1448.7614495074376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M416.5162591477856,1479.280410210602m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M341.5460450705141,1341.7801695251837m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M357.0934126069769,1321.0058635780588m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M420.1001687627286,1468.4336322029121m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M317.8384395716712,1332.4469290962443m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M312.275214696303,1330.0197227196768m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M348.83850830886513,1343.7964224671014m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M420.49776736460626,1379.457368967589m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M387.32510626874864,1423.2028219401836m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M410.7345128171146,1372.692862417549m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M217.03378303349018,1349.5445087756962m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M221.1446685725823,1351.3506033266895m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M213.00020833220333,1364.3553025112487m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M209.0999553836882,1373.3410152071156m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M215.66585451178253,1358.228531670291m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M217.01721642445773,1355.1136455913074m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M214.34289249777794,1361.2799534518272m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M210.4024063590914,1370.3218503324315m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M211.67251300252974,1367.409842717927m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M277.01437205728143,1265.0143878594972m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.3973110439256,1468.96525580436L416.6574697615579,1463.8560495902784L425.7643710626289,1467.9020085576922L423.82213344890624,1473.1537409294397L414.95663129910827,1469.2128613055684Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer park"
        d="M425.1435176897794,1338.5862072650343L440.5331080025062,1344.2250582082197L431.50430642813444,1369.8370360019617L425.1435176897794,1367.0373886353336Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M596.3120822841302,1326.455379542429m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1370.002455486916L438.5198706397787,1375.7682064152323L536.1106051504612,1418.423378300853"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M451.4607584550977,1340.292428329587L609.089670673944,1397.2830917667598"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1412.401732381899L438.5198706397787,1375.7682064152323L451.4607584550977,1340.292428329587L477.6525663267821,1268.6110146935098L479.71550351474434,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,1394.5770888230763L614.9716055402532,1381.6993717569858"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M588.0705890506506,1454.7071174629964L636.9586504241452,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M635.1828677821904,1325.9632794815116L614.9716055402532,1381.6993717569858"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M614.9716055402532,1381.6993717569858L609.089670673944,1397.2830917667598L588.0705890506506,1454.7071174629964L578.9400211675093,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M425.1435176897794,1330.5856894785538L451.4607584550977,1340.292428329587"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M462.22668725345284,1262.983546542935L477.6525663267821,1268.6110146935098L635.1828677821904,1325.9632794815116"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M640.9299031225964,1310.2732800878584L635.1828677821904,1325.9632794815116"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,1307.848146717064L640.9299031225964,1310.2732800878584"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M640.9299031225964,1310.2732800878584L641.8174000009894,1310.7300082435831"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M452.99829749111086,1374.0599133349024L457.10129416920245,1362.8134666508995L465.151876963675,1365.776454557199L468.1070443475619,1357.7041822075844L478.1842755675316,1361.4110407526605L474.6831989940256,1370.9918511961587L476.2357268668711,1371.566137602087L476.68223640788347,1370.3468193095177L487.6098868586123,1374.372025379911L487.17757726833224,1375.5268398188055L488.80741597991437,1376.1229736828245L492.2374928034842,1366.7044687690213L502.3849348882213,1370.4394126017578L499.1252574659884,1379.3751795226708L514.3263039961457,1384.9734227894805L517.5788814453408,1376.0803183834068L527.7058124905452,1379.8006919450127L524.2268247278407,1389.3325795317069L525.8282635388896,1389.9276718418114L526.3244729051366,1388.5741488770582L531.688898479566,1390.5508541124873L526.7496825195849,1404.0725431805477L524.5029348675162,1410.2304845494218L524.2126247780398,1411.031567921862L475.69691765028983,1389.6863057347946L478.43198580667377,1382.1956293517724L473.80437986180186,1380.4883782276884L473.4075701478869,1381.5724463271908Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M545.0684069739655,1417.0552957635373L549.6818129690364,1404.511578884907L552.4736809274182,1396.9148007705808L555.8682578764856,1387.6815102235414L562.9761217636988,1390.3240532255732L561.027573062107,1395.6247417605482L586.3058508140966,1404.9932696828619L586.0865404745564,1405.6029258077033L589.6720278626308,1406.9283554917201L587.4465801352635,1412.980176826939L590.2321370039135,1414.0080600013025L587.5956796100363,1421.1657847613096L584.8109116284177,1420.1379026486538L582.8615740397945,1425.4312858306803L579.2760866507888,1424.0996174858883L578.872176961042,1425.2117686439306L578.3972675204277,1425.034906450659L577.3977488139644,1427.756502990611L573.8619612501934,1426.445642404724L571.7990240622312,1432.0511302170344L571.2610037326813,1431.809765580576L564.9112594015896,1429.0039010448381L549.8735122960061,1422.3559638597071L551.0071416413411,1419.2660753941163Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M457.69690318685025,1433.8582436400466L462.3529090313241,1422.9229634455405L467.1359255416319,1424.9787266943604L473.9179794639349,1409.047585947439L469.42527304403484,1407.1197833078913L474.2650893535465,1395.7381421197206L498.48783748503774,1406.134554227814L493.64013231452554,1417.5088957808912L489.01962634548545,1415.5311578656547L481.9827622063458,1432.0365651086904L486.00765916053206,1433.765651198104L485.03732923977077,1436.0336455302313L485.5682495953515,1436.260444924701L482.13186168204993,1444.3461505309679Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M567.9374265354127,1260.7446265351027L568.9929561559111,1257.7462204452604L576.2925193673,1260.3336722711101L581.0613359278068,1246.811702866573L574.0528716901317,1244.3178813625127L574.8038912713528,1242.1913178027608L574.0031718658283,1241.9083308205009L577.0364389736205,1233.3261208990589L605.5530942231417,1243.4595571081154L602.9947365568951,1250.7027700901963L602.3289166763425,1252.6295758322813L601.1242875801399,1252.1978132515214L600.5357785392553,1253.8770053978078L593.8886241419241,1251.510114247445L589.2894180985168,1264.5358085068874L595.717262154445,1266.817383264657L594.5260441219434,1270.191365902312Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.9641183549538,1281.1258466052823L630.8526719007641,1262.0201451773755L628.5775243481621,1261.1909540477209L631.3843811433762,1253.41715232376L646.6840384388342,1258.9863663557917L647.3577471803874,1260.9214929174632L638.2161348899826,1286.2913683610968L637.6773256743327,1286.1072199176997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M627.7839049184695,1376.5047906353138L632.8012206032872,1363.1047716964968L647.1518479036167,1370.4675027020276L654.3236115667969,1374.1670718058012L647.8681564964354,1386.8232037173584Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M443.2610761858523,1289.1264214669354L450.0502300830558,1270.6023195791058L464.67696752306074,1276.001936529763L457.88781362678856,1294.5260239895433L446.9956630486995,1290.5080542657524Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M641.6596227781847,1471.9490055246279L644.920089087449,1465.6558722038753L647.2157476786524,1466.8533261828125L648.3564769998193,1466.3008952266537L652.6511730048805,1457.9946587127633L652.5383622897789,1456.570404484868L650.234814837575,1455.3656662022695L653.3461816720665,1449.3492541792803L663.2814133921638,1454.5292156632058L655.96765022818,1468.682278081309L655.025720207952,1468.1787441577762L653.9126019012183,1470.326045586262L656.5703592188656,1471.7222073008306L654.8340208828449,1475.0815252070315L653.3106817966327,1478.0215772627853Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.1797520462424,1465.9679801254533L630.5339619126171,1465.280302322004L633.4394294703379,1459.6748413755558L636.0119870873168,1461.0137854092754L637.1243165088817,1458.8591985744424L635.9835871877149,1458.2568296571262L643.2973503507674,1444.1193514009938L653.3461816720665,1449.3492541792803L650.234814837575,1455.3656662022695L647.7190570188686,1454.0548108355142L646.5641277497634,1454.8277993872762L642.2765317196026,1463.1257168105803L642.404331269674,1464.3450187859125L644.920089087449,1465.6558722038753L641.6596227781847,1471.9490055246279Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M491.2521740468219,1263.3029463202693L494.50475149415433,1254.0122562963516L500.8118959758431,1256.2376533942297L501.30100536718965,1257.675473860465L519.9179287739098,1264.245539705269L517.062161039561,1272.4157174155116Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.2876159343868,1435.126447885763L640.6182931074873,1428.699074018281L649.2920959312469,1411.9387687174603L649.5689949570224,1411.3998581664637L657.1446683108807,1415.354295426514L644.8703892622143,1439.0808716122992Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M519.4998191315681,1272.9546387707815L527.7839122163132,1249.9724148595706L535.3808854939416,1252.7294534370303L533.2832373166457,1258.547321436461L534.0484568476677,1259.5252887546085L533.4536367179826,1261.155580772087L532.2277076961473,1261.466657507699L529.4279508776963,1269.26229838375L530.4132696343586,1269.6170711009763L528.0813222806901,1276.0654002083465L527.4936021259055,1275.8458782937378L527.0044927345589,1276.2641143542714L526.7141826450825,1276.3920820998028L526.0901737287641,1276.4701112126932L525.7714637396857,1276.4201725814492L525.1971546476707,1276.1507120407186L524.7648450573906,1275.682537339162L524.5313347671181,1275.0874352268875L524.5100348424166,1274.7690763827413L522.4833864159882,1274.038723683916L522.0013769995421,1274.4423944153823L521.4057679846883,1274.648391327355L521.0799580179155,1274.6629567625932L520.4638379635289,1274.4923330601305L519.9534286484122,1274.1240355414338L519.6134187327698,1273.5778315584175Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M434.25357453525066,1285.1719122109935L435.9055020585656,1280.6857627006248L440.8447180185467,1267.2002466232516L450.0502300830558,1270.6023195791058L443.2610761858523,1289.1264214669354L441.68803727347404,1288.53860321315L442.481656704098,1286.3693973626941L439.1296796053648,1285.1292563523166L438.54117056541145,1286.75225964142Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M552.6653802525252,1447.2945385188796L554.7559284549206,1442.5182325742207L558.433715518564,1444.1401586607099L559.0932243103161,1444.8143138452433L559.7448442410678,1443.3474020212889L565.3151690913364,1445.813062143512L565.6054791826755,1446.720258387737L567.2424178682268,1447.4505928964354L567.5264168689027,1446.805568120908L569.4465656718239,1447.6482617645524L569.1633555553854,1448.30056899786L570.4531843522564,1448.874848997686L571.3533034073189,1448.4847131338902L577.7661586301401,1451.3269824474119L575.1517900479957,1458.4628211050294L568.9645562553778,1455.7412366210483L568.7381459409371,1454.6644626469351L567.1714181182906,1453.9695011926815L566.8172082519159,1454.7851445688866L564.7337600262836,1453.863384315744L565.0879698907956,1453.0560637246817L563.6782304039225,1452.4318467080593L562.77811134886,1452.9915613029152L557.1154868211597,1450.4978139577433L556.6902772067115,1450.3063873415813L557.385285872966,1448.726077189669L556.3360673412681,1448.9175038514659Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.0813222806901,1276.0654002083465L530.4132696343586,1269.6170711009763L531.2778888139874,1267.2148120771162L532.5961175113916,1267.6892296895385L534.7079656384885,1261.8359960918315L533.3826369671151,1261.353254955262L533.4536367179826,1261.155580772087L534.0484568476677,1259.5252887546085L536.1106051504612,1253.7989760315977L536.6423143902794,1253.997690815013L536.9965242557228,1253.5305550089106L537.5140335466713,1253.2538108383305L538.0954426117241,1253.2111547831446L538.6476628920063,1253.4098695809953L538.8748620944098,1253.594018893782L539.2077720332891,1254.075720179826L539.285871759057,1254.3659894028679L539.2645718343556,1254.947568205651L540.0368913384154,1255.23055465566L540.3911012047902,1254.7561361906119L540.9015105199069,1254.4866748112254L541.4900195607916,1254.4367360221222L542.0422398410738,1254.6427335264161L542.4603494815528,1255.0536881280132L542.6023489823565,1255.3085840065032L542.6804487081245,1255.5926108313724L542.6520488075912,1256.1877146172337L543.119858273305,1256.3510560332797L540.2988015292212,1264.18831825722L535.3950854446739,1277.7737174369395L531.7598982304335,1276.4482630598359L530.7816794486716,1277.0433650584891Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M431.2707961378619,1424.0215900372714L433.424455229193,1417.5588333960623L446.21624356880784,1422.6753562949598L455.6907657980919,1427.139566253405L452.88469788990915,1433.5388517221436Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M557.7891955636442,1432.9864181103185L559.8158439900726,1428.3588745552115L563.3382204892114,1429.91734168306L564.0892400713637,1430.8526298627257L564.9112594015896,1429.0039010448381L571.2610037326813,1431.809765580576L570.4460843773559,1433.6595340105705L571.7572130998597,1434.247339962516L572.572132455185,1432.3913294975646L574.9174908716232,1433.4327345350757L574.1096714902669,1435.2825025361963L575.3924003122374,1435.8567836121656L576.2073196684942,1434.007015766576L583.0035735415295,1437.0115878120996L580.35291619692,1444.2608407661319L574.1096714902669,1441.4976361724548L573.9037722153589,1440.2928952709772L572.3804331291467,1439.612497464288L571.9694234635681,1440.5477843396366L570.070574587211,1439.7040494680405L570.4815842518583,1438.7687624809332L569.0426559811458,1438.1383019937202L567.9871263587847,1438.790610118769L562.2748020077124,1436.260444924701L561.8069925438613,1436.0544528136961L562.5304011097178,1434.4314844729379L561.3036832017824,1434.5448841964826Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M550.0502227852121,1454.3024168666452L552.0342713622376,1449.7747623077594L555.7625471372157,1451.4330993639305L556.3502672920004,1452.2196129085496L557.1154868211597,1450.4978139577433L562.77811134886,1452.9915613029152L562.9974216884002,1453.9695011926815L564.4150500353426,1454.5937180719338L564.7337600262836,1453.863384315744L566.8172082519159,1454.7851445688866L566.4984982628375,1455.5217203944921L568.0573372235522,1456.2093991669826L568.9645562553778,1455.7412366210483L575.1517900479957,1458.4628211050294L572.5011327043176,1465.7058094725944L567.540616819635,1463.508569331374L565.2867691917345,1462.5087832207792L566.044888747856,1460.8088343976997L564.6351492609829,1460.1846180777065L563.8762408187613,1461.885607416276L562.6290118740872,1461.3404585858807L561.6444820035249,1460.90038611833L562.3671016832814,1459.2420513285324L560.9565733112395,1458.6188752283342L560.233953631483,1460.2772101666778L554.0262087993324,1457.527536650654L554.7701284047216,1455.8119811848737L553.7777096740901,1455.9607528401539Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.2592377960682,1439.9235661933199L557.2432863721624,1435.3886196948588L560.786962796934,1436.9616503375582L561.537982378155,1437.9395924885757L562.2748020077124,1436.260444924701L567.9871263587847,1438.790610118769L568.3626361507922,1439.6832421938889L569.8007755354047,1440.3209850857966L570.070574587211,1439.7040494680405L571.9694234635681,1440.5477843396366L571.7004132987931,1441.1647198810242L573.2237523850054,1441.8305524475873L574.1096714902669,1441.4976361724548L580.35291619692,1444.2608407661319L577.7661586301401,1451.3269824474119L571.3533034073189,1448.4847131338902L571.0977043071762,1447.393372957129L569.8078755112365,1446.8263753717765L569.4465656718239,1447.6482617645524L567.5264168689027,1446.805568120908L567.8948266841471,1445.9826412647963L566.2436880469322,1445.2533469670452L565.3151690913364,1445.813062143512L559.7448442410678,1443.3474020212889L559.262834825553,1443.1414101221599L559.9862433914095,1441.4830710841343L559.0506244599819,1441.6037532356568Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M533.1128379171714,1402.8958857422695L540.1717908652499,1383.6916845329106L547.5912647675723,1386.4403469609097L544.79229683429,1394.0662669274025L543.3320686379448,1398.0279966588132L540.5331007046625,1405.6455809287727Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M597.8709212457761,1330.6044163196348L600.1886686487123,1324.3330027000047L621.4980603624135,1332.270064535085L619.1740018697456,1338.5414709751494L604.7878746939823,1333.1845582979731Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M614.2631858093664,1292.88221480418L616.6511440761387,1286.2497528959066L625.7643564669415,1289.5519394283183L635.1970677310601,1292.982091830112L636.132686663419,1293.3150152363814L633.7368395337835,1299.954753078986L632.6671099634841,1299.5718915252946L617.9054729985073,1294.2076660380699Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.4230619082227,1306.0066677862778L608.9689710978419,1304.490828549955L610.8118090610951,1299.3742184322327L615.439415005967,1301.046116459649L630.2010519709438,1306.4040943551809L627.8052048441023,1313.0511023411527Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M418.4080080483109,1457.4640746298246L421.42707520723343,1450.504056129139L433.9987643202767,1456.0106901759282L438.6689701154828,1458.0518785631284L435.64990295656025,1465.0108491242863Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M612.1513376813382,1417.756503119599L614.9219057150185,1410.2731396411546L615.5033147810027,1410.542594966013L629.6125429309905,1417.4027783484198L631.3133813925087,1418.22466822993L630.6262615872547,1419.6416477696039L633.5956289200112,1421.0877572810277L631.788290833123,1424.8434791308828L628.8189234994352,1423.4046529671177L628.3227141331881,1424.4325345959514L623.7519079893827,1422.2217566133477L617.2317642560229,1419.053840579465L616.9698540670797,1419.6062753032893L612.9449571128935,1418.0686131939292Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M606.1771031413227,1434.7935312902555L608.3812509430572,1429.0319909080863L608.7070609088987,1429.1589154684916L619.5140117844567,1433.3193347919732L622.1149693029001,1434.3180847461335L629.7687423815951,1438.8467897656374L627.3160954527557,1443.7864352385513L619.9108215002343,1440.0796207357198L617.3169639566913,1439.0808716122992Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.1922005228698,1362.792659147177L634.5943587394431,1356.1665063728578L650.3200145373121,1364.252305389382L649.7812053216621,1365.3082859087735L652.5872732307762,1366.747124128975L650.6955243283883,1370.4602200817317L647.882356445305,1369.021382631734L647.1518479036167,1370.4675027020276L632.8012206032872,1363.1047716964968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M482.4150717975572,1288.8007805636153L484.8030300643295,1282.2026475304738L502.48433453869075,1288.6728130471893L500.18867594655603,1295.0150051284581L500.0963762719184,1295.2636572266929Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.4736591652036,1425.4957885090262L637.9321358893067,1418.8197580557317L643.1411509010941,1408.7354754651897L649.2920959312469,1411.9387687174603L640.6182931074873,1428.699074018281Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M616.3955449750647,1283.9598614349961L618.174483162351,1279.0211424762383L623.9641183549538,1281.1258466052823L637.6773256743327,1286.1072199176997L635.1970677310601,1292.982091830112L625.7643564669415,1289.5519394283183L626.4593651322648,1287.6241035643034Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M574.9742906717584,1375.9450698667206L575.2433008374646,1375.2157682012767L578.8011772101745,1365.5704603558406L589.7217276878655,1369.6383245387115L585.8948411494493,1379.999403118156Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.2237379206344,1367.7531662918627L555.3018376464024,1367.5336472829804L561.4101828271523,1351.0145615781657L568.0431372746825,1353.494819809217L567.1927180439234,1355.78364792699L561.8566923672333,1370.2334185382351Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M573.8264613747597,1337.8974764477462L576.0227203173563,1331.9225776838139L580.9840250890702,1318.515189904254L587.7865900499746,1321.0453980742022L582.8118742145598,1334.502719171811L578.3688676208258,1332.851636805106L577.9649579301476,1333.9357123528607L578.7017775615677,1335.402647327166L577.6604478890076,1338.2012670896947L576.1718197930604,1338.768273555208Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.8642736366019,1332.0006061694585L563.3240205403417,1325.346333685331L567.6818274334073,1313.5608898247592L574.3573817312717,1316.048444129061L569.3968658456579,1329.4568770588376L566.2862878981978,1328.3020549435169L564.4221500102431,1333.326049926225Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M568.3910360513255,1372.6574897114187L573.7270617252216,1358.2150067854673L574.8038912713528,1355.309236341156L579.2547867260873,1356.967595989816L577.3835488632321,1362.0196603354998L579.7793959928676,1362.9206252959557L578.8011772101745,1365.5704603558406L575.2433008374646,1375.2157682012767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.1646835925058,1340.7814062405378L642.0777324177325,1335.4806757722981L661.077265589498,1345.2383862840943L661.4314754540101,1345.4298158031888L658.8944177124649,1350.404900652822L657.6187888644636,1349.7463419474661Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M600.3519680751488,1451.0356811084785L602.2650169003755,1446.0325786750764L613.0719677768648,1450.192987876013L620.5419303914532,1453.062305895146L617.3453638572246,1459.2420513285324Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.5943587394431,1356.1665063728578L636.4513966524974,1351.0291268560104L648.7327756760642,1357.3286064779386L657.7465884154662,1361.963480069302L656.1664495291188,1365.0742015708238L651.1988336695358,1362.523201967124L650.3200145373121,1364.252305389382Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M541.8016295777634,1280.1052264436148L546.4647353962064,1267.1503079249524L547.066655500792,1267.3708705045283L549.0443929890171,1261.8640866288915L552.2969704372808,1263.0407680035569L550.3129218611866,1268.5465105557814L553.0692899432033,1269.5463246344589L552.2543705878779,1271.792524522636L548.4061841228977,1282.4929155772552Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.9973565340042,1360.3758671525866L593.1234046118334,1354.6496377252042L610.790509134531,1361.23313655518L608.671561033465,1366.9520779219456Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M615.439415005967,1301.046116459649L617.9054729985073,1294.2076660380699L632.6671099634841,1299.5718915252946L630.2010519709438,1306.4040943551809Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M560.3830531062558,1479.8151540542021L567.540616819635,1463.508569331374L572.5011327043176,1465.7058094725944L573.1030528089032,1465.974222282879L566.4842983130366,1482.514881588053Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M602.2508169515058,1340.072908448521L604.7878746939823,1333.1845582979731L619.1740018697456,1338.5414709751494L616.856254465878,1344.8066294733435L616.6298441514373,1345.4298158031888Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.4513966524974,1351.0291268560104L638.39284538012,1345.6711834501475L651.2911333451048,1352.297346251551L657.7110885400325,1355.606783962343L655.7554398644716,1359.4405694627203L649.3346957806498,1356.1456988500431L648.7327756760642,1357.3286064779386Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M464.3298576325178,1335.3880820157938L466.67521604988724,1328.8753045033664L478.51718550827354,1333.1845582979731L481.7768629314378,1334.3612275649793L479.43150451406837,1340.8729595467448Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M477.27705653663725,1478.3055949653499L477.7306660525501,1477.2641966687515L483.8611000441015,1463.1538065350614L489.9623452499509,1465.8327333619818L486.2845581872389,1474.330386441201L483.393290579319,1480.9772334336303Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M595.9365724939853,1344.0762841552496L597.3187009654939,1340.348608771339L601.55659717042,1341.9362262738869L602.2508169515058,1340.072908448521L616.6298441514373,1345.4298158031888L614.5605958746746,1351.0145615781657L603.3000354832038,1346.8124777595513Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M592.2729853801429,1354.331282534171L594.1718342574313,1349.207426561974L601.4145976705477,1351.8999223136343L612.6822580378503,1356.0957607924938L610.790509134531,1361.23313655518L593.1234046118334,1354.6496377252042Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.8566923672333,1370.2334185382351L567.1927180439234,1355.78364792699L573.7270617252216,1358.2150067854673L568.3910360513255,1372.6574897114187Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.8185001946986,1484.392726130318L487.88599699828774,1475.0243054968305L486.2845581872389,1474.330386441201L489.9623452499509,1465.8327333619818L495.8655800409615,1468.4128250139765L495.3054709006101,1469.7018301240169L488.86421578004956,1484.5342146758921L488.1124073136598,1486.2705701659434Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M428.9246488343924,1278.1066415715031L433.8567648185417,1264.621120477561L440.8447180185467,1267.2002466232516L435.9055020585656,1280.6857627006248Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M447.09506270010024,1463.7426503454335L447.9312819810584,1461.814862914849L453.1821079561487,1449.7393899941817L459.5886520873755,1452.5379636045545L454.868746467866,1463.3951700809412L453.5016068313271,1466.541218303144Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.443421007134,1357.739554990083L533.2193375406787,1344.7920641824603L533.4394367672503,1344.1896853549406L540.348501354456,1346.7625396354124L540.029791363515,1347.6343760089949L535.6080846954137,1359.5966258151457L535.3453856185079,1360.3196868700907Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M473.9605793124065,1308.6502823028713L476.3911374313757,1301.9179585827515L483.08089167810977,1304.3555786372162L490.40885479189456,1307.0200014505535L487.98539664782584,1313.7523202155717L487.34008780680597,1313.5119918421842Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M491.87539407704026,1445.4302086452954L497.09150906372815,1433.1424728082493L498.7355477241799,1433.8509610886686L499.42345641646534,1432.2352747847326L504.4762719767168,1434.4033946311101L498.4097377592698,1448.2152592833154Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M535.6080846954137,1359.5966258151457L540.029791363515,1347.6343760089949L541.4261197857559,1348.15144359041L542.5242492565885,1345.1822058814578L545.0613069999963,1346.1247881366871L543.9631775282323,1349.101308084093L546.7266455870122,1350.1281603500247L546.3085359456018,1351.2621712908149L542.3120388910174,1362.09768848354L541.4545196853578,1361.7720510056242L540.1149910651147,1362.8634046595544L538.4283525524661,1362.2402198966593L538.1096425624564,1360.5319234831259Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M485.23533965460956,1442.5889772735536L490.8482643570751,1429.3441004776396L497.50251872837543,1432.185337274801L497.09150906372815,1433.1424728082493L491.87539407704026,1445.4302086452954Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M530.2641701586545,1311.7755930847488L534.2117562731728,1301.0887722237967L540.9938101954758,1303.6189867518842L537.1030238810927,1314.1351809850894L535.2175860684365,1319.244497536216L531.4687992539257,1317.848305115942L533.297437267378,1312.9096102970652Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M589.111918721348,1365.4789073751308L590.9973565340042,1360.3758671525866L608.671561033465,1366.9520779219456L606.7861232208088,1372.055113307666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.9925110870972,1491.840637512505L506.8926301440224,1489.7713694595732L512.3706553196535,1477.157039792277L518.2312902612612,1479.7298447284847L512.9157756241038,1491.9831662587821L511.8602460036054,1494.3988720229827Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.6658399151638,1273.2168167121708L420.6121558500454,1259.7312861075625L427.2593102483079,1262.1897287974134L422.3200942873955,1275.669012291357Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M542.6804487081245,1319.6981039526872L543.8282780032605,1316.5873620915227L547.7048643669114,1306.1127869244665L554.2881189901382,1308.5649708705023L549.9295232091099,1320.3577058967203L549.2637033285573,1322.1575657613575Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.17100927606225,1325.1621862789616L443.9552959660068,1314.6740990965627L445.69873427785933,1309.855046079494L451.35425882972777,1311.9170851530507L451.06394873932004,1312.718179882504L452.00587875954807,1313.7814509272575L451.3258589282632,1315.828923479654L449.8301308564842,1316.1410381463356L445.8265338279307,1327.2242207974195Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M516.0271424595267,1309.628242552746L521.0089582689106,1296.1781558678485L527.6419127155095,1298.6438683285378L523.6951154870912,1309.3306929580867L522.6671968800947,1312.1085155890323Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.9783183038235,1461.8648002073169L629.527343230322,1451.1417980259284L630.8526719007641,1448.5835475553758L635.2822674326599,1450.894191882573L633.4607293950394,1454.3950090371072L635.5938774468377,1455.5009131669067L633.4394294703379,1459.6748413755558L630.5339619126171,1465.280302322004Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M422.3200942873955,1275.669012291357L427.2593102483079,1262.1897287974134L433.8567648185417,1264.621120477561L428.9246488343924,1278.1066415715031Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M569.3968658456579,1329.4568770588376L574.3573817312717,1316.048444129061L580.9840250890702,1318.515189904254L576.0227203173563,1331.9225776838139Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M548.6404832992703,1365.0606766962446L551.9853604221717,1355.9969250522554L555.3018376464024,1357.2297707549296L558.4550154432654,1348.6976417000405L561.7998925680295,1349.944013601169L561.4101828271523,1351.0145615781657L555.3018376464024,1367.5336472829804Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M582.8118742145598,1334.502719171811L587.7865900499746,1321.0453980742022L594.3209337322041,1323.4757287316024L592.4354959204793,1328.5777557347901L589.3391179228202,1336.9403277672827Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M471.5868209954351,1315.2483901651576L473.9605793124065,1308.6502823028713L487.34008780680597,1313.5119918421842L484.9663294898346,1320.0955297364853Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M469.2051738165319,1321.86729937559L471.5868209954351,1315.2483901651576L484.9663294898346,1320.0955297364853L482.58547119703144,1326.7144343187101L481.2175426762551,1326.2254554159008Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M536.784313891083,1319.6273579997942L538.6050630416721,1314.6949067446403L537.1030238810927,1314.1351809850894L540.9938101954758,1303.6189867518842L547.7048643669114,1306.1127869244665L543.8282780032605,1316.5873620915227L541.9641401162371,1315.8923867968842L540.1220910390839,1320.8747755112126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M522.0155769502744,1355.351891770959L525.9205632144585,1344.7920641824603L527.025792661123,1341.794734818861L533.4394367672503,1344.1896853549406L533.2193375406787,1344.7920641824603L528.443421007134,1357.739554990083Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M535.3950854446739,1277.7737174369395L540.2988015292212,1264.18831825722L546.7053456623107,1266.505266378168L546.4647353962064,1267.1503079249524L541.8016295777634,1280.1052264436148Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.3130087777972,1303.7396713024937L442.8500665202737,1296.8086292659864L444.472805256024,1297.418294904288L455.35785585734993,1301.4289779309183L452.813698139973,1308.360015351791Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M495.3196708513424,1345.4162908913568L500.2525757215917,1332.078634655103L506.7435306683183,1334.4954365137964L502.93794405367225,1344.7920641824603L501.8114146832377,1347.8320477236994Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M472.23844092618674,1472.6855795276351L477.57446660101414,1460.3978919908404L483.8611000441015,1463.1538065350614L477.7306660525501,1477.2641966687515L475.4981183502823,1476.28626006376L476.292526666075,1474.4645926812664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.42707520723343,1450.504056129139L424.2828429406509,1443.927924609743L436.5074221631512,1449.2857920839451L433.9987643202767,1456.0106901759282Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M568.2206366490573,1289.6861492446624L572.7701428700238,1277.0860209669918L579.5024969661608,1279.5309324641712L575.0878902729601,1291.7981328372844L574.9600907219574,1292.138339000754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.4528406653553,1316.1618457888253L420.17984626069665,1303.065502401907L426.6502901688218,1305.426133650355L425.7004712866619,1308.0270926663652L421.9161845976487,1318.515189904254Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.9471971774474,1305.844367926009L514.4257036466151,1293.7186848432757L521.0089582689106,1296.1781558678485L516.0271424595267,1309.628242552746L513.5326845655218,1308.7064630007371L513.8087947070599,1307.9553062119521L511.90994582884014,1307.2468050648458L512.1221561944112,1306.6517056594603Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.471448160708,1477.6397659010254L559.5184339256957,1468.4201075308956L562.6290118740872,1461.3404585858807L563.8762408187613,1461.885607416276L565.2867691917345,1462.5087832207792L567.540616819635,1463.508569331374L560.3830531062558,1479.8151540542021Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M424.2828429406509,1443.927924609743L427.16701057273895,1437.2945668301545L439.0728798052296,1442.5036674891599L436.5074221631512,1449.2857920839451Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M617.0976536162198,1459.7310208496638L617.3453638572246,1459.2420513285324L620.5419303914532,1453.062305895146L623.241498674266,1447.8615360669792L629.527343230322,1451.1417980259284L623.9783183038235,1461.8648002073169L623.3905981490389,1463.0123175568879Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M488.86421578004956,1484.5342146758921L495.3054709006101,1469.7018301240169L500.8118959758431,1472.1050593452528L496.10619030706584,1482.9331051819026L494.76745057012886,1486.0229652752168L492.3432035436854,1484.9597206441686L491.94639382790774,1485.8814767627046Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M556.4070670921355,1322.7672291705385L560.7656628713012,1310.9817809253L567.6818274334073,1313.5608898247592L563.3240205403417,1325.346333685331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M519.081709491089,1457.7043980131857L524.2686356920749,1445.8983718841337L525.8850633399561,1446.6141414023004L527.854911965318,1442.1208138116635L531.4474993292242,1443.7011254667304L526.9263930097222,1454.0048734834418L524.2899356167763,1460.0150393014774Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.073361100629,1405.6029258077033L440.4266083771363,1399.3742351881228L453.4306070813909,1404.6176965143532L450.9716490646824,1410.8266154322773L449.90113060642034,1410.4011049107648L448.30679177027196,1409.7415115362965L446.7266528829932,1409.0756758912466L444.6503046322614,1408.2184124011546L442.0564470887184,1407.1551558375359L439.71029978618026,1406.2271470413543Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M618.7771921539679,1401.7129858890548L620.5419303914532,1396.9574559447356L637.8895360399038,1406.0003466671333L635.8273877371103,1409.9828769415617Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.791515246965,1387.0645699226297L446.9814630979672,1381.1042787441984L461.5237897252664,1387.5108893024735L460.7017703950405,1389.4168495996855L458.9370321566239,1388.6448941295967L457.46970398630947,1392.6482417904772Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M435.71380273159593,1411.7119685304351L438.073361100629,1405.6029258077033L439.71029978618026,1406.2271470413543L442.0564470887184,1407.1551558375359L444.6503046322614,1408.2184124011546L446.7266528829932,1409.0756758912466L448.30679177027196,1409.7415115362965L449.90113060642034,1410.4011049107648L450.9716490646824,1410.8266154322773L448.47719117160887,1416.9991159411147L446.9459632243961,1416.3821782488376L445.6490344526246,1415.8432680438273L443.9197960905731,1415.09940543212L441.30542750936,1413.9872526517138L439.5548892216757,1413.2496320460923L437.59214057028294,1412.4485489288345Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M466.0022961953655,1470.573651035782L471.5513211200014,1457.7751425574534L477.57446660101414,1460.3978919908404L472.23844092618674,1472.6855795276351L472.012030611746,1473.2099202936515Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M460.02806165255606,1467.9665108411573L460.87138090934604,1466.0168770328164L465.5912865297869,1455.153432491701L471.5513211200014,1457.7751425574534L466.0022961953655,1470.573651035782Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M592.7478948207572,1471.813758878503L594.6538436729461,1467.0655595338903L614.8793058646843,1477.5971112265252L613.5681771440431,1480.211530303117L606.9210227457806,1477.5263668815605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M561.9134921673685,1287.3972993078642L565.7687786063179,1276.6896331058815L566.4558984125033,1274.7971668676473L572.7701428700238,1277.0860209669918L568.2206366490573,1289.6861492446624Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M442.55975642986596,1393.1798712024465L444.791515246965,1387.0645699226297L457.46970398630947,1392.6482417904772L455.23794516921043,1398.7718611019664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M638.39284538012,1345.6711834501475L640.1646835925058,1340.7814062405378L657.6187888644636,1349.7463419474661L656.3155490038916,1352.297346251551L652.3324630148709,1350.2561267320998L651.2911333451048,1352.297346251551Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M616.6511440761387,1267.3282145359553L621.6826597126201,1252.6441413164139L627.025785362348,1254.4866748112254L624.0138181783259,1263.2675730539486L621.9942697267979,1269.170744128991Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M440.4266083771363,1399.3742351881228L442.55975642986596,1393.1798712024465L455.23794516921043,1398.7718611019664L453.4306070813909,1404.6176965143532Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M549.9295232091099,1320.3577058967203L554.2881189901382,1308.5649708705023L560.7656628713012,1310.9817809253L556.4070670921355,1322.7672291705385Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M588.8571085073054,1482.6209980235435L590.7559573827311,1477.3703131875955L605.106584683992,1482.578343379777L605.4047836344689,1482.6855001710355L603.5122458469123,1487.936180985067Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M496.10619030706584,1482.9331051819026L500.8118959758431,1472.1050593452528L506.715130767785,1474.6841083071195L501.23710559215397,1487.2911599781364L500.8615958020091,1488.1775436708704L497.6445182291791,1486.7595377820544L498.7923475243151,1484.1097490377724Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M498.2819382082671,1448.5055203796364L498.4097377592698,1448.2152592833154L504.4762719767168,1434.4033946311101L509.0186782218516,1436.409216996748L508.004959564656,1438.7053002882749L508.6644683564082,1438.9882792378776L503.47675327025354,1450.8088821978308Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M433.424455229193,1417.5588333960623L435.71380273159593,1411.7119685304351L437.59214057028294,1412.4485489288345L439.5548892216757,1413.2496320460923L441.30542750936,1413.9872526517138L443.9197960905731,1415.09940543212L445.6490344526246,1415.8432680438273L446.9459632243961,1416.3821782488376L448.47719117160887,1416.9991159411147L446.21624356880784,1422.6753562949598Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M590.7559573827311,1477.3703131875955L592.7478948207572,1471.813758878503L606.9210227457806,1477.5263668815605L605.106584683992,1482.578343379777Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M444.472805256024,1297.418294904288L446.9956630486995,1290.5080542657524L457.88781362678856,1294.5260239895433L455.35785585734993,1301.4289779309183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M501.23710559215397,1487.2911599781364L506.715130767785,1474.6841083071195L512.3706553196535,1477.157039792277L506.8926301440224,1489.7713694595732Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M542.1132395919412,1362.6293202391826L542.3120388910174,1362.09768848354L546.3085359456018,1351.2621712908149L552.8428796287626,1353.7008143696003L551.9853604221717,1355.9969250522554L548.6404832992703,1365.0606766962446Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M617.1544534182176,1406.0918991123326L618.7771921539679,1401.7129858890548L635.8273877371103,1409.9828769415617L633.6942396843806,1414.1141774877906L631.6746912319213,1413.1362319733016L625.5379461515695,1410.152456945274L625.0559367351234,1409.9194144890644L625.5663460511714,1408.863440763671L623.3408983238041,1407.778336564079L622.8375889826566,1408.8415930308402Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M443.09067678358406,1455.8764835810289L445.2877246122807,1450.8161647333764L446.9459632243961,1447.0032370099798L453.1821079561487,1449.7393899941817L447.9312819810584,1461.814862914849L443.1900764349848,1459.7310208496638L444.5793048813939,1456.5277496790513Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M555.1030383454636,1284.9315828476101L558.958324784413,1274.2228724509478L565.7687786063179,1276.6896331058815L561.9134921673685,1287.3972993078642Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M548.4061841228977,1282.4929155772552L552.2543705878779,1271.792524522636L558.958324784413,1274.2228724509478L555.1030383454636,1284.9315828476101Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.97258272208273,1474.4999648672529L414.95663129910827,1469.2128613055684L423.82213344890624,1473.1537409294397L428.0174298034981,1475.0170229896903L426.02628125064075,1480.2895571184345L422.1283949613571,1478.567765139509Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M496.21978990733624,1417.5650755995885L500.68488531187177,1407.0844107777812L507.15454033296555,1409.862194240559L504.4265721505508,1416.268778228201L502.6902338145301,1420.3438952313736Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.6951154870912,1309.3306929580867L527.6419127155095,1298.6438683285378L534.2117562731728,1301.0887722237967L530.2641701586545,1311.7755930847488Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M608.7070609088987,1429.1589154684916L610.840208960697,1423.567990441341L621.6471598371863,1427.7346553141251L623.8371076891199,1428.5783916413784L622.2987797670066,1432.6243711984716L620.1025208262727,1431.781675728038L619.5140117844567,1433.3193347919732Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M454.868746467866,1463.3951700809412L459.5886520873755,1452.5379636045545L465.5912865297869,1455.153432491701L460.87138090934604,1466.0168770328164Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M517.380871030502,1353.6290283878334L520.640548452735,1344.7920641824603L522.5890971543267,1339.5194270093925L527.2309030499309,1341.2485361676663L527.025792661123,1341.794734818861L525.9205632144585,1344.7920641824603L522.0155769502744,1355.351891770959Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M508.67156833224,1453.1049607228488L513.8513945555314,1441.2916442197748L519.131409317255,1443.6303807785735L513.9507942060009,1455.4364107693546Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M427.883319163695,1320.6906279888935L431.66760585363954,1310.1879686759785L437.87535068485886,1312.456003433559L434.08396402094513,1322.9440939733759Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.9321069614962,1445.9056544248015L604.122054814361,1440.1649305499159L615.2619156297296,1444.452267551329L613.0719677768648,1450.192987876013L602.2650169003755,1446.0325786750764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M503.47675327025354,1450.8088821978308L508.6644683564082,1438.9882792378776L513.8513945555314,1441.2916442197748L508.67156833224,1453.1049607228488Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M434.08396402094513,1322.9440939733759L437.87535068485886,1312.456003433559L443.9552959660068,1314.6740990965627L440.17100927606225,1325.1621862789616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M513.9507942060009,1455.4364107693546L519.131409317255,1443.6303807785735L524.2686356920749,1445.8983718841337L519.081709491089,1457.7043980131857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M523.8300150120631,1432.3621992864646L525.2184545733035,1429.102735746652L529.3640511017293,1419.3867579321377L534.6085659880191,1421.632909276057L530.4700694344938,1431.3561664959416L528.2730216057971,1430.4135958272964L526.8837931603193,1433.6730587510392Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M615.5033147810027,1410.542594966013L617.1544534182176,1406.0918991123326L622.8375889826566,1408.8415930308402L623.1562989726663,1408.9976482708007L622.5898787435144,1410.1597395204008L624.9778370102867,1411.3155883657746L625.5379461515695,1410.152456945274L631.6746912319213,1413.1362319733016L629.6125429309905,1417.4027783484198Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.6742099393159,1416.0773506672122L633.6942396843806,1414.1141774877906L635.8273877371103,1409.9828769415617L637.8895360399038,1406.0003466671333L638.1664350656793,1405.461435652338L643.4172610398382,1408.1965646655299L643.1411509010941,1408.7354754651897L637.9321358893067,1418.8197580557317Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M421.9161845976487,1318.515189904254L425.7004712866619,1308.0270926663652L431.66760585363954,1310.1879686759785L427.883319163695,1320.6906279888935Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M512.9938753498718,1351.9925158522092L515.6516326675192,1344.7920641824603L518.2099903365597,1337.8829111428931L522.5890971543267,1339.5194270093925L520.640548452735,1344.7920641824603L517.380871030502,1353.6290283878334Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M508.68576828110963,1350.3913757503033L510.7550165578723,1344.7920641824603L513.8939944058657,1336.2817677822895L518.2099903365597,1337.8829111428931L515.6516326675192,1344.7920641824603L512.9938753498718,1351.9925158522092Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M575.0878902729601,1291.7981328372844L579.5024969661608,1279.5309324641712L579.637396492064,1279.1345447422937L584.4488129010424,1280.8844767129049L579.892206707038,1293.5480616101995Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M604.122054814361,1440.1649305499159L606.1771031413227,1434.7935312902555L617.3169639566913,1439.0808716122992L615.2619156297296,1444.452267551329Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M610.840208960697,1423.567990441341L612.9449571128935,1418.0686131939292L616.9698540670797,1419.6062753032893L623.7519079893827,1422.2217566133477L621.6471598371863,1427.7346553141251Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M579.892206707038,1293.5480616101995L584.4488129010424,1280.8844767129049L589.1687185214832,1282.60007546423L584.605012351647,1295.2490918319672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M601.4145976705477,1351.8999223136343L603.3000354832038,1346.8124777595513L614.5605958746746,1351.0145615781657L612.6822580378503,1356.0957607924938Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M494.92996111046523,1325.5231984225102L498.02712799422443,1317.1335626887158L499.3950565159321,1317.6433498705737L504.83758181799203,1319.6554483054206L501.7333149574697,1328.0534040327184Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M603.816755887121,1302.6191775831394L607.7856419272721,1291.606701837387L612.9378571389243,1293.4845980880782L610.8118090610951,1299.3742184322327L608.9689710978419,1304.490828549955Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M544.4096870692447,1472.7490414092317L548.4629839230329,1463.5231343726628L554.2029192885384,1466.0668142987415L550.1567224096507,1475.2864757976495Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M550.1567224096507,1475.2864757976495L554.2029192885384,1466.0668142987415L555.0746384449303,1464.0963727505878L557.1793865971267,1465.018131643068L556.3076674416661,1466.9948150850832L559.5184339256957,1468.4201075308956L555.471448160708,1477.6397659010254Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M509.50068763643503,1422.3559638597071L510.91042712237686,1419.0465580131859L513.639184191823,1412.6399765932001L519.0959094418213,1414.9787228195928L514.9574128873646,1424.7019893708639Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M542.2741723591462,1479.6580600519665L425.1435176897794,1428.7791821477003"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M533.6232472332194,1468.2213988928124L537.7617437867448,1458.7884540418163L538.3076529772952,1457.5410613408312L540.3911012047902,1458.4628211050294L539.8380920384079,1459.7102136369795L543.0275585977361,1461.1199021772482L538.8819620683789,1470.5528438561596Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M584.605012351647,1295.2490918319672L589.1687185214832,1282.60007546423L593.484714451246,1284.1585753546096L592.23038553074,1287.6594767021015L588.9210082814097,1296.822154270485Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M522.7807964812964,1463.4378248457797L524.2899356167763,1460.0150393014774L526.9263930097222,1454.0048734834418L532.3973182104528,1456.428915368393L528.2588216578588,1465.8608230734244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M415.2477302746847,1374.8890909664333L417.1607791027054,1370.4883101820014L428.81104923505336,1375.5913429618813L426.91220035776496,1379.9921205099672Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M538.8819620683789,1470.5528438561596L543.0275585977361,1461.1199021772482L548.4629839230329,1463.5231343726628L544.4096870692447,1472.7490414092317L544.3173873936757,1472.9550324263982Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M528.2588216578588,1465.8608230734244L532.3973182104528,1456.428915368393L537.7617437867448,1458.7884540418163L533.6232472332194,1468.2213988928124Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M520.0457283230498,1426.891959251836L524.1842248775065,1417.161413201131L529.3640511017293,1419.3867579321377L525.2184545733035,1429.102735746652Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M588.8074086820707,1297.1623601871543L588.9210082814097,1296.822154270485L592.23038553074,1287.6594767021015L597.736810605973,1289.6507761175744L594.3138337573037,1299.1609395658597Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M594.3138337573037,1299.1609395658597L597.736810605973,1289.6507761175744L598.2756198225543,1288.155741030816L603.023136456497,1289.8848629998975L599.055039302446,1300.8827761001885Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M599.055039302446,1300.8827761001885L603.023136456497,1289.8848629998975L607.7856419272721,1291.606701837387L603.816755887121,1302.6191775831394Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M437.1243311036378,1472.862440503668L440.99302860721946,1463.6646233410574L446.44975385721773,1465.974222282879L442.5952563052997,1475.1730767395347Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M514.9574128873646,1424.7019893708639L519.0959094418213,1414.9787228195928L524.1842248775065,1417.161413201131L520.0457283230498,1426.891959251836Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M466.67521604988724,1328.8753045033664L468.0360445966944,1325.0987230492756L483.03829182777554,1330.5409531374462L482.3937718719244,1332.3335277023725L479.24059407413006,1331.1859887270257L478.51718550827354,1333.1845582979731Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M414.3973110439256,1468.96525580436L416.6574697615579,1463.8560495902784L425.7643710626289,1467.9020085576922L423.82213344890624,1473.1537409294397L414.95663129910827,1469.2128613055684Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M610.4291992960498,1486.426623663865L613.5681771440431,1480.211530303117L614.8793058646843,1477.5971112265252L615.0639052139595,1477.2215419881977L619.9676213013008,1479.709037575405L615.3258154047653,1488.91411594674Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M501.8114146832377,1347.8320477236994L502.93794405367225,1344.7920641824603L506.7435306683183,1334.4954365137964L507.0267407828942,1333.7234749291092L510.50651743263006,1335.027070388198L506.89973011799157,1344.7920641824603L505.3053912827745,1349.1221156283282Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M505.3053912827745,1349.1221156283282L506.89973011799157,1344.7920641824603L510.50651743263006,1335.027070388198L513.8939944058657,1336.2817677822895L510.7550165578723,1344.7920641824603L508.68576828110963,1350.3913757503033Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M483.08089167810977,1304.3555786372162L484.5695197749883,1300.2242126907222L496.1487901574001,1304.4263247451745L494.6609509466216,1308.5576881854795L490.40885479189456,1307.0200014505535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M413.5965916393325,1378.7093409607187L415.2477302746847,1374.8890909664333L426.91220035776496,1379.9921205099672L425.2539617465809,1383.8113273181953L414.08491214364767,1378.9215770079754Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M504.4265721505508,1416.268778228201L507.15454033296555,1409.862194240559L513.639184191823,1412.6399765932001L510.91042712237686,1419.0465580131859Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M468.0360445966944,1325.0987230492756L469.2051738165319,1321.86729937559L481.2175426762551,1326.2254554159008L480.51543403510004,1328.1595228333026L483.506101292558,1329.2373568341136L483.03829182777554,1330.5409531374462Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M543.3320686379448,1398.0279966588132L544.79229683429,1394.0662669274025L552.4736809274182,1396.9148007705808L549.6818129690364,1404.511578884907L546.5428351219743,1403.3494866886176L547.8744748821482,1399.7144360719249Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M524.5029348675162,1410.2304845494218L526.7496825195849,1404.0725431805477L532.4399180617183,1406.1772093442269L530.1931704087183,1412.335148846265Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M592.4354959204793,1328.5777557347901L594.3209337322041,1323.4757287316024L594.7532433224842,1322.3136229519732L600.1886686487123,1324.3330027000047L597.8709212457761,1330.6044163196348Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M499.3950565159321,1317.6433498705737L501.4430048689246,1312.1085155890323L506.87843019422144,1314.12165601179L504.83758181799203,1319.6554483054206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M438.902480404824,1448.0165500668809L440.86601794324815,1443.5169812035747L447.25126214977354,1446.3020326127298L446.9459632243961,1447.0032370099798L445.2877246122807,1450.8161647333764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M534.7852764781564,1422.0657016709447L536.8553136419505,1417.1832609083503L542.4532495066524,1419.5854679672047L540.3769012540579,1424.4533419148065Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M568.1196592273191,1409.9547870038077m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M640.9748696312308,1375.3364515057765m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M641.1350135114044,1456.8117682589218m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M526.5319499522448,1265.3649992342107m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M442.977077184245,1275.644042972941m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M566.2910212147981,1450.4021006505936m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M536.5326592214406,1265.7010451373644m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M572.6383988885209,1436.6360163781792m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M564.5846605496481,1457.9946587127633m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M570.0492746615782,1443.8041214086115m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M539.8459808994085,1396.0471320780925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M625.3288913313299,1293.1485535339452m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.5380946388468,1457.7574564227834m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M621.0980951022357,1417.5796407377347m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M618.8931584134698,1436.8201608238742m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M641.5618008999154,1363.6780183794908m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M627.0336742242798,1285.0335407597013m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M582.4821198191494,1372.4265267443843m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M561.2484611738473,1361.658650093712m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M581.9062329558656,1326.4834698205814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M568.8407011348754,1320.6979106571525m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M575.3947669714689,1364.2450227653608m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M547.0287889689207,1275.948876729235m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M600.8947217222303,1360.8045018683188m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M624.0532624842599,1300.309524225071m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M566.8771635983139,1472.894691624213m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M610.7116205245256,1339.3071897528134m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M484.48747561872005,1470.0815612031147m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.9066490950063,1346.1206266260706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M602.9016479952261,1355.372699296102m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M567.7914826041088,1364.2242152662948m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M434.88310565426946,1272.653966437094m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M453.76036147680134,1457.1769349928945m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M534.2346339700744,1352.686447152868m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M482.1855059377849,1307.835662117228m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M498.13520539179444,1439.9173240116797m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M540.9598880922422,1355.4299199916422m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M491.1622410295531,1437.8657266492955m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M598.8917398778722,1366.2154926862568m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M549.0593818258494,1312.57668783376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M444.99978118017316,1320.6510934904218m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M521.892510715872,1303.9872827040963m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M630.3540958771482,1457.587877586484m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.0907962117344,1270.144548390992m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M575.1904454668984,1323.9855154477991m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M553.8747426653281,1361.1447046459652m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M587.6232906244695,1331.5407582758926m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M479.46305995900184,1314.3796708672307m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M477.08614609763026,1320.9808944207616m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M542.403549682349,1310.124505306594m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M527.619823904708,1350.0719799869694m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M540.9322770787403,1272.462534911465m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.8350378749892,1302.5838045221753m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.14796146098524,1339.6442724503577m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M478.0493760416284,1467.919694669079m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M428.98618195205927,1449.8954443167895m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M573.8643279094249,1284.609062907286m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M515.4757110644132,1301.0107433879748m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M560.4280196148902,1473.0299382503144m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M622.9393552923575,1456.1521793003194m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M495.1847713254392,1477.51908437768m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M562.0444472618401,1318.164581216406m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M525.4393426859751,1450.3095084270462m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M445.74764521606266,1405.1108313645236m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M628.4868024457246,1403.856146424543m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M449.8159309066832,1384.0849451599643m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M443.33838702365756,1411.2687718099914m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M471.786409182474,1465.4852532017976m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M466.21292878780514,1461.896011020057m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M567.339450860396,1282.242182248272m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M450.01473020762205,1392.914576686453m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.8374045314267,1399.0725279673934m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M555.3468041541055,1315.669744996354m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.4106605378911,1478.8091281517409m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M503.5374975018203,1443.602290977724m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M440.9496398707852,1417.2789746765047m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M595.6967511149123,1474.5925567676313m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M451.17912611179054,1295.972159597557m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M547.1479107709602,1359.0473074377514m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M628.4055471764877,1408.3099648193456m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M447.90130430739373,1453.3463246189058m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M560.4359084768221,1280.8106092009693m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M553.6814655680209,1278.3584154406562m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M501.963669703342,1413.0654869745485m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M528.953041437082,1305.209733816795m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M615.9159022197127,1428.1570436749607m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M460.2308053849265,1459.2743025119416m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M521.6487449072301,1349.2105476921424m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M513.9003054955974,1448.3681925521232m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M432.8769682664424,1316.5727967415005m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.5966168530285,1445.1784408441745m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M508.66525724250823,1446.0502648423426m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M439.02081332262605,1318.8085775766522m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M519.1085316194221,1450.6673929672688m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M529.9154824949801,1425.3678235164843m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M624.3830168806016,1412.2259102310054m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M638.0954353148118,1412.0490477052517m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M426.7922896677628,1314.3515805397183m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M516.8176063448191,1348.3928111414425m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M514.4801367884502,1341.3380087125115m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M579.7683515874669,1286.3413069215603m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M610.7195093864575,1439.6229011015967m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M584.5277015129104,1288.0745908892713m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M607.9875967726111,1351.4577621496283m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M608.9610822368413,1296.4288886934519m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M549.3070920659229,1469.4084488367662m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M554.8371837241575,1471.8532925150357m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M515.0031682820991,1417.0126407127827m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M538.3242195853963,1464.6706514446996m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M588.4169100550935,1291.4548054989427m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M528.3440213566646,1458.221457388252m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M543.6728674378246,1467.0374698252417m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M533.0102827213705,1462.3246394596063m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M524.7025230545551,1423.139359607827m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M593.3308816598728,1293.2369863139465m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M598.6661184495315,1294.5229028323665m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M603.4215239444748,1296.2447405187413m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M519.5708188824356,1420.9317023102194m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M474.8535983944312,1329.7086490602233m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M506.72301962878555,1339.9095690050162m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M510.3976511480287,1340.5369172892533m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M489.6152353603393,1304.3909516911954m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M509.03287817072123,1414.4543776470236m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M474.6271880790591,1325.661569064483m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M548.6791387191042,1398.8706962321885m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M412.04406376648694,1383.6198988589458L414.08491214364767,1378.9215770079754L425.2539617465809,1383.8113273181953L423.21311336848885,1388.5034036277793L412.44797345623374,1383.797802480869Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M841.7258746158332,1479.6580600519665L858.4912823121995,1448.2579141394235"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M825.2397326044738,1441.2531507723033m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M753.1331751225516,1368.0652786209248L858.4912823121995,1424.0632046768442"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M807.9292046045884,1479.6580600519665L719.5992041863501,1434.3118425598368L644.2392803709954,1395.7381421197206L641.8174000009894,1394.5770888230763"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M842.7088267141953,1479.6580600519665L858.4912823121995,1450.2304409095086"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M856.9379655532539,1262.983546542935L858.4912823121995,1263.6910118227825"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,1341.8405114687048L785.8672155383974,1304.3982343776152L704.5417349282652,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M658.2293867170811,1262.983546542935L641.8174000009894,1307.848146717064"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M641.8174000009894,1310.7300082435831L753.1331751225516,1368.0652786209248"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M720.5064232172444,1262.8202052856795L729.5841357326135,1245.5008080708794L734.3963410286233,1247.698117303662L739.2645572386682,1242.3973156702705L740.1859762193635,1241.4828099352308L753.2396747479215,1248.1017895690165L754.4301038943231,1246.3091932255775L759.1429095398635,1235.4516467861831L802.3928018556908,1254.3524643140845L791.5716510303319,1275.5275194840506L777.922343484126,1268.4611986298114L768.2845218284056,1287.361926167272Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M794.3004080979154,1300.5644184397534L815.6736995857209,1257.1022184137255L844.7220640769228,1269.8646837188862L825.3044212665409,1309.3587833060883L822.6253640223294,1314.5180417336524Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M724.1487104073167,1344.8066294733435L737.0611983211711,1319.053067294415L742.8650334617123,1307.466325986199L755.826432316564,1314.008254318498L754.4869036944583,1316.6934810667299L767.0727927573025,1323.0502128521912L750.0864969501272,1356.9249405721202L749.8308978490531,1356.967595989816L748.5410690531135,1357.1298946561292Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.549460968934,1395.8941976549104L678.6031594984233,1370.2833564928733L682.8899666424841,1361.8854519184679L686.2348437653854,1355.3227612334304L688.1557814534754,1351.5389115465805L691.7412688424811,1344.5226063020527L710.5285916477442,1354.1252879919484L699.7705517113209,1375.2438582824543L687.2982622478157,1368.8372363853268L685.0231146952137,1373.3025213824585L680.1406985344365,1370.765049669426L677.4758412418887,1375.9315450135618L682.4016461381689,1378.461732227821L671.8495054757223,1399.1401520003565Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M697.3896934185177,1379.92865777947L699.7705517113209,1375.2438582824543L710.5285916477442,1354.1252879919484L742.4114239467308,1370.502875416074L735.9054801650345,1383.258889743127L720.7683334080502,1375.48522488866L714.3554781870916,1372.189321523998L711.1163118034601,1378.546002427116L710.4149920474738,1378.1922756563872L709.3941734153777,1380.1908316765912L706.2551955683157,1378.5740924943238L703.8735483894125,1383.258889743127Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M853.7145768916234,1330.7396657206118L866.6412647562101,1305.3834779160097L873.8406394328922,1309.075799065642L886.9653377113864,1315.82164080441L874.0323387589306,1341.185073082801Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M772.8206169847399,1402.024056318216L777.6746332449839,1392.6419995641336L779.1419614162296,1393.4139545913786L780.7150003276765,1390.3594258418307L808.7354462128133,1404.2847784520127L808.5303358240053,1405.065055132378L803.1162104234099,1415.5384404375218L800.2880537034944,1421.002447228413L794.2365083228797,1417.9978682459332L793.9525093222037,1418.5648681893945L786.9227451588959,1415.0713155125268L787.3834546497092,1414.1422674087808L781.6861191345379,1411.3155883657746L781.4163200836629,1411.8680237056687L777.695933168754,1410.0182494595647L777.4198230300099,1410.563402326312L774.0465460065752,1408.8915307079442L776.5410038987175,1403.888397865463Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M732.1140935001895,1429.1381081622094L740.8099851347506,1411.8961136378348L763.1685953801498,1423.2704457398504L755.0044129844755,1439.4345952742733L754.472703743726,1440.4978468897752Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M623.9641183549538,1281.1258466052823L630.8526719007641,1262.0201451773755L628.5775243481621,1261.1909540477209L631.3843811433762,1253.41715232376L646.6840384388342,1258.9863663557917L647.3577471803874,1260.9214929174632L638.2161348899826,1286.2913683610968L637.6773256743327,1286.1072199176997Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M705.2627768367529,1335.2673980160616L717.8557658754289,1310.1525956508704L730.5197546640411,1316.5374237494543L717.9196656504646,1341.6605260139331Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M769.6169504756108,1448.8176290732808L778.1992425108328,1432.2134271240793L779.4890713077039,1432.880300913006L783.4642684366554,1425.190961328335L794.8952282276005,1431.1574567947537L788.984893460758,1442.5816947324201L782.3377390643582,1455.4509758255444Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M659.8726364923641,1360.6598896738142L673.0115347225219,1334.899103725329L685.6045237602666,1341.3692200640216L682.0466473866254,1348.3501556692645L677.9720506072044,1346.2589968587272L676.646721935831,1348.8526579169556L674.5916736088693,1347.803957534954L672.5011254064739,1351.8999223136343L678.6315593980253,1355.0543441390619L676.7532215612009,1358.7320735775866L672.4727255068719,1367.1299819713458L665.7119715092704,1363.6572108780965Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M701.0603805063292,1414.1422674087808L713.2494598543271,1390.2179353768006L728.4008065611124,1397.9988663033582L719.5921042114496,1415.2689853073098L706.049296291545,1408.3099648193456L702.6547193434089,1414.9579154704697Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M647.8681564964354,1386.8232037173584L654.3236115667969,1374.1670718058012L657.6826886404306,1367.5690200151876L662.4735940108076,1370.0211822222918L665.7119715092704,1363.6572108780965L672.4727255068719,1367.1299819713458L659.4190269764513,1392.7481173779815Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M627.7839049184695,1376.5047906353138L632.8012206032872,1363.1047716964968L647.1518479036167,1370.4675027020276L654.3236115667969,1374.1670718058012L647.8681564964354,1386.8232037173584Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M696.7372846025974,1298.9414183818735L706.9352153977379,1272.1961953849532L717.9906654004008,1277.8371811029501L705.2698768116534,1303.2860638387501Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M690.8135387711227,1408.8842481295578L699.9835509611294,1390.89105542982L703.0026181200519,1384.9526153518818L713.2494598543271,1390.2179353768006L701.0603805063292,1414.1422674087808Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M671.8495054757223,1399.1401520003565L682.4016461381689,1378.461732227821L684.9103039801121,1373.5220402129926L694.3422263599932,1378.369139045477L690.4514400446787,1385.994027512148L681.2885278305039,1403.9799503381364Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M652.8286723811179,1435.9837080482394L661.8779849950224,1418.4722755434923L674.7620730083436,1425.1836787657812L674.414963118732,1425.8495128653012L665.7048715334386,1442.6950943227857Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M713.2494598543271,1390.2179353768006L720.7683334080502,1375.48522488866L735.9054801650345,1383.258889743127L728.4008065611124,1397.9988663033582Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M822.6253640223294,1314.5180417336524L825.3044212665409,1309.3587833060883L828.1530890231952,1310.8475715210661L829.2583184689283,1308.7210283670574L828.2382887238637,1308.1821097931825L835.8352620033547,1293.598000117112L846.5286132786423,1299.2035953407176L843.1056364290416,1305.779864134267L840.051858282648,1304.1787133594044L834.8996430719271,1314.071717652958L836.4158821823075,1314.8655294575728L837.3657010635361,1315.1557961362414L838.3155199438334,1315.6447758199647L835.402952411212,1321.2295455872081Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M807.9986265823245,1351.6949680754915L815.6026998357847,1336.8695819894783L816.7150292564183,1337.436588565819L817.1473388466984,1336.5928411465138L817.2325385464355,1335.324618880637L814.8942801058292,1334.1198595268652L817.7997476626188,1328.4570716163144L829.9533271361142,1334.743046816904L827.0478595783934,1340.4058295935392L825.0275222398341,1339.3644105829298L823.3621836537495,1339.8107330338098L818.862377258949,1348.6050481181592L822.016343941912,1350.2280365498737L818.4797674929723,1357.101804501377Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M818.4797674929723,1357.101804501377L822.016343941912,1350.2280365498737L825.2263215398416,1351.886397414375L830.2649371502921,1342.0714754550718L827.0478595783934,1340.4058295935392L829.9533271361142,1334.743046816904L842.0927066588774,1341.0290163164027L839.1872391011566,1346.6845113141462L836.7984919473529,1345.451663736254L835.750062301755,1346.2163413749076L835.3248526873067,1347.0600876207463L836.5862815827131,1347.7196869603358L828.9822083301842,1362.5304845916107Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M832.248985728249,1364.2169326394796L839.8530589807779,1349.406138611026L840.9235774381086,1349.9512962428853L841.5893973186612,1348.6757937753573L841.560997418128,1347.9173586731777L839.1872391011566,1346.6845113141462L842.0927066588774,1341.0290163164027L854.0829867059365,1347.2161442539655L851.1775191482157,1352.8778764633462L848.0243413504213,1351.255929027684L843.0709254397079,1360.9220642964356L846.2170032626018,1362.5440094708465L842.6102159498259,1369.574861713685Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M794.4345187367871,1344.67866299022L796.9147766800597,1339.8533885590732L797.8503956114873,1338.0244026756845L800.9333625435829,1339.6120207132772L806.0855777561665,1329.570278499741L803.0026108212769,1327.9680928364396L805.9151783548295,1322.3136229519732L817.7997476626188,1328.4570716163144L814.8942801058292,1334.1198595268652L812.8037319034338,1333.035784008447L811.6338137965649,1333.7442825199105L811.2015042062849,1334.5880302847363L812.4132332755253,1335.2257828419097L804.8170488839969,1350.036607165821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M641.6596227781847,1471.9490055246279L644.920089087449,1465.6558722038753L647.2157476786524,1466.8533261828125L648.3564769998193,1466.3008952266537L652.6511730048805,1457.9946587127633L652.5383622897789,1456.570404484868L650.234814837575,1455.3656662022695L653.3461816720665,1449.3492541792803L663.2814133921638,1454.5292156632058L655.96765022818,1468.682278081309L655.025720207952,1468.1787441577762L653.9126019012183,1470.326045586262L656.5703592188656,1471.7222073008306L654.8340208828449,1475.0815252070315L653.3106817966327,1478.0215772627853Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M754.4869036944583,1316.6934810667299L755.826432316564,1314.008254318498L758.0518800439313,1309.5783041599207L762.6652860390022,1300.3802703754045L775.2511751018465,1306.7370171179064L767.0727927573025,1323.0502128521912Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M630.1797520462424,1465.9679801254533L630.5339619126171,1465.280302322004L633.4394294703379,1459.6748413755558L636.0119870873168,1461.0137854092754L637.1243165088817,1458.8591985744424L635.9835871877149,1458.2568296571262L643.2973503507674,1444.1193514009938L653.3461816720665,1449.3492541792803L650.234814837575,1455.3656662022695L647.7190570188686,1454.0548108355142L646.5641277497634,1454.8277993872762L642.2765317196026,1463.1257168105803L642.404331269674,1464.3450187859125L644.920089087449,1465.6558722038753L641.6596227781847,1471.9490055246279Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M783.4074686346576,1375.506032353267L790.8561313236132,1361.23313655518L797.6941961608827,1364.8193097272888L799.5370341222733,1361.4391308859922L805.3053693892434,1364.4791071312502L801.5707825245336,1371.6576905013062L796.085657374002,1382.1675393022597Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M772.3102076686919,1350.1000701696612L777.3914231294766,1340.1935923648998L790.7922315485775,1347.1173083870672L796.1637570988387,1349.895115878433L791.0754416631535,1359.808862450067L780.183291086927,1354.1679434296675Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M707.7998345792294,1473.6988888308406L720.8109332583845,1448.52736798767L728.1672962717712,1452.3683846406639L715.1561975926161,1477.5263668815605Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M637.2876159343868,1435.126447885763L640.6182931074873,1428.699074018281L649.2920959312469,1411.9387687174603L649.5689949570224,1411.3998581664637L657.1446683108807,1415.354295426514L644.8703892622143,1439.0808716122992Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M762.1974765723571,1444.9485206576064L774.2800562959164,1421.5767294932157L781.7066301731393,1425.4312858306803L778.1992425108328,1432.2134271240793L769.6169504756108,1448.8176290732808Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M721.4633420743048,1480.5028304164298L727.6710869064555,1468.4970941208303L734.7434509182349,1454.8340415540151L741.0789953004569,1458.129905628506L728.3937065862119,1482.6563701713458L727.7988864555955,1483.804924432654Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M748.0874595372006,1397.8147208238952L751.333725896664,1391.3092845506035L759.5255193049088,1395.3979410403408L772.8206169847399,1402.024056318216L776.5410038987175,1403.888397865463L774.0465460065752,1408.8915307079442L773.3018375141546,1410.3865397605114L761.5024679061025,1404.504296300467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M705.2698768116534,1303.2860638387501L717.9906654004008,1277.8371811029501L724.4043095074594,1281.0686252960004L716.1336274882779,1297.6232507466339L711.683520918712,1306.51749617327Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M701.783000187017,1470.5663685239851L706.9636152982712,1460.5466635511257L706.6307053584605,1460.376044423785L707.0985148241743,1459.4761324874125L714.0430792858824,1446.0544262933545L714.6670882022008,1444.8559283604845L721.0097325593233,1448.1517971768044L720.8109332583845,1448.52736798767L707.7998345792294,1473.6988888308406Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M753.8849835898727,1495.023085261695L760.7017485015094,1481.8417704277672L766.0456630373374,1471.5089337332174L766.2862733015791,1471.0418125800788L772.8908278495073,1474.4791576988064L772.6857174597681,1474.8828167608008L760.4824381610379,1498.4666606211103Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M795.2707380177453,1462.084316235967L801.8760814508423,1449.2993167927489L807.8211272070184,1437.8053855421022L814.327070989646,1441.1928096949123L807.8566270815209,1453.700047556311L801.7695818264037,1465.4644460063428Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M717.9196656504646,1341.6605260139331L730.5197546640411,1316.5374237494543L731.7101838095114,1317.1398049793206L732.0296826856211,1316.516616106499L737.0611983211711,1319.053067294415L724.1487104073167,1344.8066294733435Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M728.3937065862119,1482.6563701713458L741.0789953004569,1458.129905628506L747.4926394075155,1461.4746650769375L747.2583402311429,1461.9209796669893L734.8144506691024,1486.002158141695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M659.4190269764513,1392.7481173779815L672.4727255068719,1367.1299819713458L678.6031594984233,1370.2833564928733L665.549460968934,1395.8941976549104Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M751.333725896664,1391.3092845506035L757.7323811678216,1378.4190769419074L772.9121277742088,1386.0231579202227L769.2414406854659,1393.42123718746L762.2400764236227,1389.9276718418114L759.5255193049088,1395.3979410403408Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M660.3617458837107,1288.9068999649025L662.9343035025522,1281.8416331335902L673.1669452870265,1287.2204335979186L672.4372256323695,1288.6374399131164L689.0488005345687,1297.3829218121246L686.3342434158549,1302.576521831099L672.0262159658596,1295.044135918375Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.473579547368,1328.8690622220747L647.2086477028206,1321.3210991546512L668.2987290769815,1332.156663140282L664.6848417883739,1339.2510093026794L664.2454322231933,1339.0169240841642L655.9116393141448,1334.736804538872L653.6577916862443,1333.580942927394Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M760.4824381610379,1498.4666606211103L772.6857174597681,1474.8828167608008L778.7656627399847,1478.0579897887073L772.8277169596404,1489.5518543105572L769.291140511632,1496.3765874416567L766.5694834170863,1501.641822848469Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M734.8144506691024,1486.002158141695L747.2583402311429,1461.9209796669893L752.7363654077053,1464.7694856324233L747.5352392569184,1474.8328795582056L747.0177299669012,1474.5561442216858L746.195710635744,1476.1510135014541L747.3506399067119,1476.7460983563215L743.4109426531941,1484.3500714967959L740.9085959000513,1489.183568214532Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M668.9716489324346,1265.0247917599045L672.57212515641,1254.954850946553L688.1131816031411,1262.8420534785837L685.243213920854,1270.8780226646923L684.1868954133242,1270.5024422314018Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M826.962659877725,1444.5022049723193L829.4145179204643,1439.768552012276L835.0629424965009,1428.855128813535L839.6479485919699,1420.003695357591L844.6581643009558,1422.6046113925986L841.5467974673957,1428.5991989504546L839.4704492157325,1432.6035639047623L838.4149195952341,1434.6520417300053L837.1534906988963,1437.0823325677775L835.8991617765278,1439.5199050991796L834.6377328811213,1441.9574767719023L833.3763039847836,1444.3888054108247L832.1219750642776,1446.8118102974258L831.5263660475612,1447.9458054229617L827.5156690441072,1445.8692417307757L827.9550786092877,1445.0119827901945Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M692.4717773841694,1328.8045586440712L692.754987497814,1328.2448340244591L697.3328936174512,1319.1102882912382L701.620489647612,1310.5562642789446L708.5508541604504,1314.0498696202412L705.5538758123294,1320.0310260765254L699.7208518851548,1331.6541596828029L699.4021418951452,1332.3127201073803Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M644.8703892622143,1439.0808716122992L657.1446683108807,1415.354295426514L662.1477840449661,1417.9552132035606L661.8779849950224,1418.4722755434923L652.8286723811179,1435.9837080482394L649.8735049981624,1441.681780488696Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M692.2729780832306,1296.4465752420947L702.13089896366,1269.6170711009763L706.9352153977379,1272.1961953849532L696.7372846025974,1298.9414183818735Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M642.0777324177325,1335.4806757722981L644.473579547368,1328.8690622220747L653.6577916862443,1333.580942927394L653.0124828461558,1334.8502058936283L655.2592304982245,1336.0050269179046L655.9116393141448,1334.736804538872L664.2454322231933,1339.0169240841642L661.077265589498,1345.2383862840943Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M745.3523913798854,1303.1580965896137L749.9586974000558,1293.9600542872213L762.6652860390022,1300.3802703754045L758.0518800439313,1309.5783041599207Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M716.1336274882779,1297.6232507466339L724.4043095074594,1281.0686252960004L731.405673770234,1284.5976186511107L723.128680662252,1301.1522356732748Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M723.128680662252,1301.1522356732748L731.405673770234,1284.5976186511107L738.4567378563806,1288.155741030816L737.5779187260196,1289.9056707215495L735.2609602091834,1294.5333066862077L734.6014514183626,1294.1931006414816L733.2556117074564,1296.8866581455804L733.5033219484612,1298.0487681869417L730.1655447985977,1304.6957841841504Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M676.7532215612009,1358.7320735775866L678.6315593980253,1355.0543441390619L680.0980986850336,1352.1693799067289L680.8136183889583,1351.7157756132074L682.0892472369596,1349.207426561974L682.0466473866254,1348.3501556692645L685.6045237602666,1341.3692200640216L685.7820231374353,1341.0082087484188L691.9187682168558,1344.161595149897L691.7412688424811,1344.5226063020527L688.1557814534754,1351.5389115465805L687.440261747688,1351.9498604019172L686.1646329024807,1354.4519662046805L686.2348437653854,1355.3227612334304L682.8899666424841,1361.8854519184679L680.9343179659918,1360.879408900626L679.8361884942278,1363.032985812053L677.3977415161207,1361.7866162611172L678.4966598739848,1359.6319985901937Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M726.6076684240252,1311.8036834234372L730.1655447985977,1304.6957841841504L733.5033219484612,1298.0487681869417L735.2609602091834,1294.5333066862077L737.5779187260196,1289.9056707215495L742.5952344117686,1292.4431720324792L737.0682982960716,1303.4702118262649L734.36794112809,1308.8698031790555L731.6257729958743,1314.3338940395042Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.1922005228698,1362.792659147177L634.5943587394431,1356.1665063728578L650.3200145373121,1364.252305389382L649.7812053216621,1365.3082859087735L652.5872732307762,1366.747124128975L650.6955243283883,1370.4602200817317L647.882356445305,1369.021382631734L647.1518479036167,1370.4675027020276L632.8012206032872,1363.1047716964968Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M856.0394242694601,1474.4999648672529L859.377201417461,1467.9020085576922L869.6311431275681,1473.1110862232745L868.7878238717094,1474.7902248632163L876.5125967003405,1478.7238188125193L874.0181388081983,1483.6488708737306L866.2933659795672,1479.7225622260012Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.4736591652036,1425.4957885090262L637.9321358893067,1418.8197580557317L643.1411509010941,1408.7354754651897L649.2920959312469,1411.9387687174603L640.6182931074873,1428.699074018281Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M842.0643067592755,1324.6097440323792L847.2875217199326,1314.2704307078384L848.9386603562161,1315.1131404619664L850.383899718523,1312.2427249695174L849.7180798379704,1311.9098024712875L852.4318480696529,1306.538303845562L857.0097541892901,1308.8698031790555L852.7158470712602,1317.3593255872838L853.6577770905569,1317.8347801496275L848.5631505660713,1327.932719902601Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M835.402952411212,1321.2295455872081L838.3155199438334,1315.6447758199647L844.1335550369695,1304.4481728072278L850.1787893278524,1307.6223835083656L841.4473978169262,1324.3902236516587Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M852.8783576106653,1403.817652768921L855.3444156032056,1398.8925439990126L855.9613245436922,1397.6732305125333L872.6360103366897,1406.1064642746933L869.5538322888315,1412.2508790567517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M857.4704636801034,1385.2002238510177L860.1495209224522,1379.8568720696494L865.1739365831017,1382.3943404550664L880.2400835892186,1390.012982269749L877.5547152562067,1395.3698510415852L870.5738620338961,1391.8263488770463L871.2830706499517,1390.4239288466051L867.3283845614642,1388.4180931779556L866.6199648305774,1389.8350788094103L861.2618503430858,1387.1145077566616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M808.0128265321255,1468.3701702817343L813.816661673598,1457.1446837992407L822.7744634971023,1461.8075803904794L822.1717545073479,1462.962380268611L819.5360860005021,1468.0434974394739L816.9564284067601,1473.0403418359347Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M787.5254541505128,1458.5481306929141L794.3422190612182,1445.38027123129L801.8760814508423,1449.2993167927489L795.2707380177453,1462.084316235967L795.065627628006,1462.4806934958324Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M655.4935296736658,1302.29353731405L657.8317881152034,1295.8441922138445L668.638738992624,1301.5350971408188L674.2658636439592,1304.4970708531328L671.1260969089344,1310.5208912566304L669.276947857812,1309.557496496942Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M640.1646835925058,1340.7814062405378L642.0777324177325,1335.4806757722981L661.077265589498,1345.2383862840943L661.4314754540101,1345.4298158031888L658.8944177124649,1350.404900652822L657.6187888644636,1349.7463419474661Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M850.015489901416,1409.514711278025L852.8783576106653,1403.817652768921L869.5538322888315,1412.2508790567517L866.6901756944135,1417.9552132035606Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M634.5943587394431,1356.1665063728578L636.4513966524974,1351.0291268560104L648.7327756760642,1357.3286064779386L657.7465884154662,1361.963480069302L656.1664495291188,1365.0742015708238L651.1988336695358,1362.523201967124L650.3200145373121,1364.252305389382Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M745.0549813145772,1403.9518603738397L748.0874595372006,1397.8147208238952L761.5024679061025,1404.504296300467L760.8011481501162,1405.9150364329107L764.1602252237499,1407.6014739242382L762.799396677874,1410.3303598836064L760.5321379872039,1409.1817934508435L759.5255193049088,1411.1876231129281Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M841.5467974673957,1428.5991989504546L844.6581643009558,1422.6046113925986L859.6249116575345,1430.4063132731244L856.5214336849749,1436.4019344486296Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M665.7048715334386,1442.6950943227857L674.414963118732,1425.8495128653012L679.7296888697892,1428.6283291769214L671.0203861696646,1445.458298441954Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M702.6547193434089,1414.9579154704697L706.049296291545,1408.3099648193456L719.5921042114496,1415.2689853073098L716.204627238214,1421.9169292873703Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M636.4513966524974,1351.0291268560104L638.39284538012,1345.6711834501475L651.2911333451048,1352.297346251551L657.7110885400325,1355.606783962343L655.7554398644716,1359.4405694627203L649.3346957806498,1356.1456988500431L648.7327756760642,1357.3286064779386Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M672.2321152416989,1484.1378386742435L677.1145314015448,1474.705955832731L679.8992993831635,1469.3262604610063L685.7954342002049,1472.3953194436617L683.17396564316,1477.4691471937113L678.1282500568777,1487.220415736083Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M855.9613245436922,1397.6732305125333L858.611981886439,1392.3933509611525L875.2866676794365,1400.8265911419876L872.6360103366897,1406.1064642746933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M822.1717545073479,1462.962380268611L822.7744634971023,1461.8075803904794L824.8295118249953,1457.8177973572165L825.9489412205294,1458.4128837850876L841.2777873026207,1466.3924468755722L841.6603970695287,1466.5911555620842L839.0097397249192,1471.7294898126274Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M819.5360860005021,1468.0434974394739L822.1717545073479,1462.962380268611L839.0097397249192,1471.7294898126274L836.374071217142,1476.816842705477Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M681.2885278305039,1403.9799503381364L690.4514400446787,1385.994027512148L695.256545365788,1388.4607484042645L686.0936331516132,1406.4466648283415Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M686.0936331516132,1406.4466648283415L695.256545365788,1388.4607484042645L699.9835509611294,1390.89105542982L690.8135387711227,1408.8842481295578Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M816.9564284067601,1473.0403418359347L819.5360860005021,1468.0434974394739L836.374071217142,1476.816842705477L833.794413626194,1481.8136807791889Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M737.0682982960716,1303.4702118262649L742.5952344117686,1292.4431720324792L743.4811535179615,1290.6859602783807L749.9586974000558,1293.9600542872213L745.3523913798854,1303.1580965896137L743.5521532669663,1306.7505421051756Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M666.839289765805,1271.0195155651309L668.9716489324346,1265.0247917599045L684.1868954133242,1270.5024422314018L682.0608473364264,1276.4836362558417L680.0980986850336,1275.7751318933442Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M721.9027516394854,1465.4998182388954L728.9751156521961,1451.8294772319496L734.7434509182349,1454.8340415540151L727.6710869064555,1468.4970941208303Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M825.9489412205294,1458.4128837850876L828.5782986395061,1453.324477023445L830.0314268609509,1454.0829005972482L843.9071447215974,1461.3186110155657L841.2777873026207,1466.3924468755722Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M653.1331824203953,1308.7428764188662L655.4935296736658,1302.29353731405L669.276947857812,1309.557496496942L667.9019193621352,1312.2073519555852L665.8397710593417,1311.1305556893349L665.0887514781207,1312.5621224748902L667.1437998060137,1313.6462011951953L666.1300811506808,1315.5813125008717Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M779.4109715810046,1334.8502058936283L782.1318397894502,1329.5557131739333L782.8481483804062,1329.9240077496506L791.5077512543648,1334.4028427447192L797.9923951113597,1337.7487022592686L797.8503956114873,1338.0244026756845L796.9147766800597,1339.8533885590732L795.0230277786031,1338.8754325727932L793.37898911722,1342.0714754550718Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M830.0314268609509,1454.0829005972482L832.8090948695317,1448.7187946555205L846.784212378785,1456.0106901759282L847.0603225193918,1456.1459371335804L844.2826545117423,1461.5100373271853L843.9071447215974,1461.3186110155657Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M701.4571902221069,1456.5277496790513L702.0243993373588,1455.4364107693546L708.402543569915,1443.1206028591841L714.0430792858824,1446.0544262933545L707.0985148241743,1459.4761324874125Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M666.6333904899657,1481.224838502705L671.522906624712,1471.792951702606L672.6431249072775,1472.3880369313993L676.7177216866985,1464.4865077384748L679.5805893940851,1465.9887873190455L675.5059926146641,1473.8695076303557L677.1145314015448,1474.705955832731L672.2321152416989,1484.1378386742435Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M752.4176554176956,1482.1247476171702L754.6999029461294,1477.7105102413334L759.6391189061105,1468.1714616431855L766.0456630373374,1471.5089337332174L760.7017485015094,1481.8417704277672L756.556151971221,1479.6799075617455L754.678603021428,1483.3013916094787Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M834.6377328811213,1441.9574767719023L835.8991617765278,1439.5199050991796L837.4083009138703,1438.7614799346775L851.8228279901668,1446.2739428193308L849.2999701974913,1451.1417980259284L834.8925430960953,1443.6303807785735Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M837.1534906988963,1437.0823325677775L838.4149195952341,1434.6520417300053L839.9240587316453,1433.8998582228087L854.0127758421004,1441.2489893184975L854.3385858070105,1441.4123263750225L851.8228279901668,1446.2739428193308L837.4083009138703,1438.7614799346775Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M832.1219750642776,1446.8118102974258L833.3763039847836,1444.3888054108247L834.8925430960953,1443.6303807785735L849.2999701974913,1451.1417980259284L846.784212378785,1456.0106901759282L832.8090948695317,1448.7187946555205L832.3767852792516,1448.4992782059126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M657.8317881152034,1295.8441922138445L660.3617458837107,1288.9068999649025L672.0262159658596,1295.044135918375L668.638738992624,1301.5350971408188Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M839.4704492157325,1432.6035639047623L841.5467974673957,1428.5991989504546L856.5214336849749,1436.4019344486296L854.0127758421004,1441.2489893184975L839.9240587316453,1433.8998582228087Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M801.7695818264037,1465.4644460063428L807.8566270815209,1453.700047556311L813.9515611995012,1456.8752302858047L813.816661673598,1457.1446837992407L808.0128265321255,1468.3701702817343L807.8708270313218,1468.6531480210833Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M776.8171140383929,1339.8950037043542L779.4109715810046,1334.8502058936283L793.37898911722,1342.0714754550718L791.9755607200786,1344.8139121197164L790.7922315485775,1347.1173083870672L777.3914231294766,1340.1935923648998Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M638.39284538012,1345.6711834501475L640.1646835925058,1340.7814062405378L657.6187888644636,1349.7463419474661L656.3155490038916,1352.297346251551L652.3324630148709,1350.2561267320998L651.2911333451048,1352.297346251551Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M782.1673396630213,1455.7630842067301L782.3377390643582,1455.4509758255444L788.984893460758,1442.5816947324201L794.3422190612182,1445.38027123129L787.5254541505128,1458.5481306929141Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M821.980844068341,1427.267531214282L822.7602635473013,1425.7787679955363L828.1672889729962,1415.2981155891903L834.0563238151371,1418.358875555452L830.2436372255906,1425.7361130015925L827.8698789095506,1430.3220437034033Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M679.432278804481,1444.0839790594764L679.5521894935519,1443.8717450043187L685.7954342002049,1431.7889582826756L691.5006585763767,1434.7581588984467L685.1367142945528,1447.0604569488205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M696.6599737629294,1452.6378383296542L697.9782024594024,1450.0723058744334L697.6090037589893,1449.8808792466298L702.6476193685085,1440.122275642585L708.402543569915,1443.1206028591841L702.0243993373588,1455.4364107693546Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M796.085657374002,1382.1675393022597L801.5707825245336,1371.6576905013062L807.9276268323883,1374.868283499498L802.5774012068287,1385.526900599245Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M852.4602479701862,1480.8138973107561L855.7341253431514,1474.343911101576L856.0394242694601,1474.4999648672529L866.2933659795672,1479.7225622260012L863.019488606602,1486.1925434158184L852.7655468946323,1480.9699509302154Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M673.7412543781102,1441.659932859242L680.3245089994743,1428.9393984009512L685.7954342002049,1431.7889582826756L679.5521894935519,1443.8717450043187L675.689803079702,1441.8586422554217L675.3639931147918,1442.5036674891599Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M802.5774012068287,1385.526900599245L807.9276268323883,1374.868283499498L814.2205713633448,1378.0570271802135L813.6257512336597,1379.2544962880202L808.8703457377851,1388.708356777206Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M677.7172403922305,1319.5566120464355L681.8131370963529,1311.3854495058767L684.3146949643269,1306.4040943551809L689.4030104000121,1308.9759222730063L686.9511523572728,1313.865721913986L682.8126558028162,1322.1367581360973Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M685.1367142945528,1447.0604569488205L691.5006585763767,1434.7581588984467L696.8082843525335,1437.521366180852L691.0399490864947,1448.6969470451586L690.4443400716409,1449.830941861961Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M691.0399490864947,1448.6969470451586L696.8082843525335,1437.521366180852L696.9928837036714,1437.167642421089L702.6476193685085,1440.122275642585L697.6090037589893,1449.8808792466298L696.6954736383632,1451.6380506530404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M664.9254520535469,1276.3920820998028L666.839289765805,1271.0195155651309L680.0980986850336,1275.7751318933442L678.1779498830438,1281.1539370664395L675.5769923655316,1280.2186286924407Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M814.0722607737407,1391.331132341642L818.812677432783,1381.8845580336638L820.3297054311261,1378.8789217257872L825.4180208668113,1381.444480524864L823.9080928443,1384.456357951276L819.1668872982264,1393.9102113484405Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M654.8340208828449,1475.0815252070315L656.5703592188656,1471.7222073008306L661.4740753043443,1462.233087753877L663.3027133168653,1463.1891787792556L661.5379750803113,1466.5911555620842L665.4074614690617,1468.6104932874441L660.5321452841163,1478.0434247776866Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M662.9343035025522,1281.8416331335902L664.9254520535469,1276.3920820998028L675.5769923655316,1280.2186286924407L673.1669452870265,1287.2204335979186Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M769.7589499764144,1355.0605863993987L772.3102076686919,1350.1000701696612L780.183291086927,1354.1679434296675L779.4961712826043,1355.5006655827165L784.9741964573041,1358.3284077537246L783.1171585442498,1361.963480069302L774.5632664104924,1357.5481258132495Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M748.72566840332,1474.5987989180721L753.849483714439,1464.6987411598675L759.822929370217,1467.8177394471131L759.6391189061105,1468.1714616431855L754.6999029461294,1477.7105102413334Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M842.5534161506221,1385.378127432894L847.1384222442284,1376.2644644379616L853.643577140756,1379.5666080960073L850.3696997677907,1386.0439653540961L849.0443710964173,1388.6802667509764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M730.8384646531194,1315.914234822616L731.6257729958743,1314.3338940395042L734.36794112809,1308.8698031790555L737.1953089609742,1310.2940877494402L739.4775564884767,1305.7517737713642L742.8650334617123,1307.466325986199L737.0611983211711,1319.053067294415L732.0296826856211,1316.516616106499Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M699.7208518851548,1331.6541596828029L705.5538758123294,1320.0310260765254L710.6272024121135,1322.6038893228397L704.7949673710391,1334.2259782343172Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M811.4145034560934,1423.3557557603344L812.8313429160044,1420.606067597866L818.2533571785316,1410.131649583578L823.2138730650768,1412.7107215966098L817.7926476886496,1423.1851357179694L815.0567906452343,1421.7608743389137L813.639951184392,1424.5105620399117Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M660.5321452841163,1478.0434247776866L665.4074614690617,1468.6104932874441L671.522906624712,1471.792951702606L666.6333904899657,1481.224838502705Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M769.3053404605016,1287.8654732215218L774.2374564465135,1278.3761020363308L780.2826907373965,1281.5367996366695L779.5529710818082,1282.9610898210667L775.3434747774154,1291.039691511076Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M632.6742099393159,1416.0773506672122L633.6942396843806,1414.1141774877906L635.8273877371103,1409.9828769415617L637.8895360399038,1406.0003466671333L638.1664350656793,1405.461435652338L643.4172610398382,1408.1965646655299L643.1411509010941,1408.7354754651897L637.9321358893067,1418.8197580557317Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M808.8451013825834,1262.983546542935L785.8672155383974,1304.3982343776152L753.1331751225516,1368.0652786209248L719.5992041863501,1434.3118425598368"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M764.3093247003853,1365.6984264533967L769.7589499764144,1355.0605863993987L774.5632664104924,1357.5481258132495L771.4810883626342,1363.5646174987778L772.0972084179521,1363.8767300127074L769.7305500768125,1368.497033986263Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M678.1282500568777,1487.220415736083L683.17396564316,1477.4691471937113L688.6732907453552,1480.3467767862603L683.6275751590729,1490.0834762929007Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M803.1162104234099,1415.5384404375218L808.5303358240053,1405.065055132378L813.5121516343206,1407.6514116115868L808.0909262578934,1418.1320755761117Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M817.7926476886496,1423.1851357179694L823.2138730650768,1412.7107215966098L828.1672889729962,1415.2981155891903L822.7602635473013,1425.7787679955363Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M845.2103845821694,1407.0844107777812L850.5329991932958,1396.4611994032748L855.3444156032056,1398.8925439990126L852.8783576106653,1403.817652768921L850.015489901416,1409.514711278025Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M808.0909262578934,1418.1320755761117L813.5121516343206,1407.6514116115868L818.2533571785316,1410.131649583578L812.8313429160044,1420.606067597866Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M775.3434747774154,1291.039691511076L779.5529710818082,1282.9610898210667L785.7039161138237,1286.1925316257402L781.5015197834,1294.263846856542Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M824.1494919946417,1396.4258268219419L828.8899086546153,1386.9792594551109L834.2054232908413,1389.6654983125627L829.4571177707985,1399.1255868263543Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M808.8703457377851,1388.708356777206L813.6257512336597,1379.2544962880202L818.812677432783,1381.8845580336638L814.0722607737407,1391.331132341642Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M840.6040785619989,1404.7602270524949L845.9337931489572,1394.1370121203363L850.5329991932958,1396.4611994032748L845.2103845821694,1407.0844107777812Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M687.4473617225885,1325.5658540334553L692.0323678189889,1316.4313047709875L697.3328936174512,1319.1102882912382L692.754987497814,1328.2448340244591Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M819.1668872982264,1393.9102113484405L823.9080928443,1384.456357951276L828.8899086546153,1386.9792594551109L824.1494919946417,1396.4258268219419Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M829.4571177707985,1399.1255868263543L834.2054232908413,1389.6654983125627L839.1233393261209,1392.1592675377615L834.3821337800473,1401.6058278433047Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M682.3661462636665,1323.0013149376027L682.8126558028162,1322.1367581360973L686.9511523572728,1313.865721913986L692.0323678189889,1316.4313047709875L687.4473617225885,1325.5658540334553Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M775.1375755015761,1487.575177301187L779.7864813711494,1478.5885722953826L785.5193167636171,1481.5723178749904L781.9693292500451,1488.446995967999L778.4398527750745,1486.6045246482827L777.3488232791424,1488.715407898184Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M782.8481483804062,1329.9240077496506L785.4278059732169,1324.8927276358008L794.0803088732064,1329.3788485424593L791.5077512543648,1334.4028427447192Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M785.4278059732169,1324.8927276358008L788.0066746799275,1319.8687265440822L796.6599664641544,1324.3548506996594L794.0803088732064,1329.3788485424593Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M830.2436372255906,1425.7361130015925L834.0563238151371,1418.358875555452L834.5738331051543,1417.3601233027875L839.6479485919699,1420.003695357591L835.0629424965009,1428.855128813535L832.8516947198659,1427.69928288972L833.1065049339086,1427.2248762268573Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M672.5934250820428,1317.6287845233455L676.9583319500089,1308.9332665596157L681.8131370963529,1311.3854495058767L677.7172403922305,1319.5566120464355L677.4545413162559,1320.088247065898Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M821.0665250606835,1442.7377492133528L824.0500923441723,1436.9689328842796L829.4145179204643,1439.768552012276L826.962659877725,1444.5022049723193L826.438050611876,1445.5363256488927Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M819.5116305295378,1285.2145680706017m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M697.463059826754,1372.033265455626m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M716.4136820584536,1362.3140865415335m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M747.6401611110196,1426.2042775726877m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M717.8904768638313,1325.902937399689m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M783.4208796992898,1437.7304793377407m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.1980592478067,1350.376810470596m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M706.7387827560306,1288.389827965293m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M701.8603110266849,1399.8881778027862m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M681.152839419432,1392.567092871759m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M663.6206344207749,1430.9171324912459m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M833.7281471919268,1306.9815072603524m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M816.3229528581724,1344.5049198791385m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M831.332300064154,1348.9733416805975m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M840.5685786865652,1356.8999715466052m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M807.0803631460294,1336.6250929008238m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M655.0911977561191,1461.8252665181644m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M764.8276228765026,1311.7932795919478m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M792.4891255805269,1373.5823818822391m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M784.2365879407153,1349.9970728349872m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M717.9819876533002,1463.034165118821m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M648.8818751526996,1422.0261677508242m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M770.198359541595,1438.581496996805m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M728.5901392279193,1474.4999648672529m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M760.4524604883045,1399.9193888925947m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M716.25353817828,1289.345942961052m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M713.9563018130139,1454.0017523989081m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M804.8667487092316,1451.4996825237758m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M727.4912208719179,1330.3568058684468m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M737.8287845104933,1472.289202848915m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.0103043513373,1381.5152258472517m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M762.4664867380634,1387.9748949697241m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.4861365705729,1291.9749984280206m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M743.3904316145927,1475.4924667398445m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M678.5424152668566,1263.933422704693m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M835.7674177978188,1433.6272827112116m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M699.1528538828716,1324.138451456558m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M654.177667635493,1427.2279973234981m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M699.5196859259158,1284.3219161112793m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M653.6719916369766,1337.5104554747231m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M754.0080498233438,1301.7691836217418m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M723.7684673005715,1291.1104377578013m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M729.846834808588,1295.7099825181067m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M683.8279522312805,1352.060140343383m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M735.284626792185,1300.7589703449048m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M643.6105381380767,1415.3792642415501m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M849.7890795879066,1316.2367533063516m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M815.1743346750736,1465.502939316444m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M794.702740015462,1453.923725284636m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M664.878118885681,1303.3953041713685m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M650.6213690340519,1343.009896619711m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M647.3001584941521,1359.6465638470836m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M753.2783301686868,1404.2285985257477m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.7157024294138,1435.661195137538m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M711.1234117774293,1415.1139705749229m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M648.3257104409859,1353.9515451178886m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M831.7243764614686,1464.6779339620844m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M829.2717295344919,1469.8870140505023m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M688.272536598146,1396.2208738997579m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M693.0374087281525,1398.6688644932583m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M826.6652498124167,1474.9285925286822m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M743.5923864590004,1298.5585567727685m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M675.513092590496,1270.7614990980364m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M728.3219179501757,1460.1669319462962m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M834.9304096298292,1459.8662677328102m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M788.6985278017819,1336.2994542294182m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M838.4078196194023,1455.0473156357184m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M708.034922641702,1450.7454201187938m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M673.2702893670648,1474.2877317452803m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M760.3735718773678,1474.61024286272m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M843.3572910996154,1444.9516417440027m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M845.7113272640854,1440.0057549197227m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M841.0537436474115,1449.9308166257106m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M664.8978410391137,1295.444684269838m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M848.22156287916,1435.1514166286215m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M807.7943050786853,1461.3040459696203m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M785.3852061228827,1341.1320137842558m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M648.0054226797074,1347.7082428089343m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M788.3372179623693,1450.4156253580004m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M828.4173658713698,1422.0480154422112m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M685.5248462641612,1439.3149534519762m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M703.0034070070833,1446.5007418757305m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M802.0433253068477,1378.5179123599082m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M679.770710946992,1436.7244473258033m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M808.099604004994,1382.3912193402648m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M682.3353797029704,1316.7111675646156m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M690.975260425359,1442.291433388833m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M696.8437842270359,1444.4096126696095m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M672.5113809257746,1276.0830868100747m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M818.9909656960517,1387.8937459993176m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M660.9889103444293,1470.166870648507m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M669.2643256811425,1281.030130959116m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M777.0324799474329,1356.524395773653m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M754.1816047681496,1471.3851310247555m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M848.0953411003575,1382.4723683749326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M705.1744215916842,1327.1285057878122m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M818.0230024335906,1416.6589159043506m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M666.0251592965797,1474.9181889449246m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M774.4275779994205,1285.413281953428m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M785.3268285514787,1279.3748743101023m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M808.3133921418339,1411.5954473307356m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M822.9835183192044,1419.241106590256m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M851.0962638789788,1401.3550988212228m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M813.1713528316468,1414.1318637337536m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M829.1770632006228,1393.0456633889116m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M813.8434838009998,1385.295938057825m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M845.5701166493818,1400.6101942867972m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M692.3913110001013,1322.338592105545m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M824.0280035333708,1390.4447362679057m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M834.2898341044784,1395.642428053543m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M687.4197507090867,1319.2840320416726m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M834.9438206935301,1422.8699047737755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M677.2044644178823,1314.5076379100792m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M779.5529710818082,1282.9610898210667L780.2826907373965,1281.5367996366695L784.2152880160138,1273.9898254261352L790.367021933198,1277.2139886971563L785.7039161138237,1286.1925316257402Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer school"
        d="M911.8965055737644,1442.5036674891599L937.4579934412614,1393.2724641896784L983.3443431509659,1417.1114755831659L1009.7846501478925,1429.747762166895L1029.4365921355784,1439.8465792858042L1044.0775295263156,1447.3652831683867L1042.0855920892209,1451.3269824474119L1034.6093183849007,1465.9887873190455L1027.6836871905252,1479.6580600519665L982.556245922111,1479.6580600519665L957.7757553076372,1466.328984935768Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M916.7647217838094,1409.8122565704398m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,1450.2304409095086L869.4118327870965,1429.8684445219114L902.7051934590563,1364.635163369123L937.8051033318043,1299.820543460548"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M937.8051033318043,1299.820543460548L1075.1651646215469,1370.1709960917942"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M858.4912823121995,1263.6910118227825L864.3022174276412,1266.3356828633696"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M902.7051934590563,1364.635163369123L858.4912823121995,1341.8405114687048"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M937.0540837505832,1301.1168626048602L961.0141328070313,1276.4628284932114L974.2950305361301,1264.7272402518429L976.9945988189429,1262.983546542935"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M937.0540837505832,1301.1168626048602L957.5162117769942,1262.983546542935"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1029.1494375914335,1262.983546542935L1075.1651646215469,1286.5941208773293"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,1453.5679216366261L1074.9963429933414,1453.4805312650278L902.7051934590563,1364.635163369123"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M858.4912823121995,1448.2579141394235L937.0540837505832,1301.1168626048602"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M937.8051033318043,1299.820543460548L957.5477672219276,1262.983546542935"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,1453.1517769959755L1074.9963429933414,1453.4805312650278L1061.534001457505,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M869.4118327870965,1429.8684445219114L964.8276082817465,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M858.4912823121995,1424.0632046768442L869.4118327870965,1429.8684445219114"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M864.3022174276412,1266.3356828633696L937.8051033318043,1299.820543460548"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M849.9728900529444,1244.4520920547657L873.1677195774391,1199.3665168937296L889.0061860885471,1206.3403126928024L887.1357371127233,1210.6340366778895L901.3869647625834,1216.9128359253518L892.2027526218444,1237.9392291177064L896.9644692074507,1240.0366629608907L899.7713260017335,1233.609108231496L913.0230349451303,1239.4342750315554L910.0962674617767,1246.1458515725099L921.3221168639138,1251.0856343396008L923.2706655655056,1246.6348361237906L925.8716230839491,1247.7761467392556L924.0003852210939,1252.0636027120054L929.1171005573124,1254.3098082644865L936.0198540547863,1238.5062437844463L935.1268349736929,1238.1233788407408L937.614192891866,1232.4397046272643L939.9808512330055,1233.4821800924838L936.4166637705639,1241.6315861893818L938.9892213894054,1242.7656148727983L938.0536024570465,1244.9057033648714L951.7944207917899,1250.9503833865747L937.7625034805387,1283.0817747316323L900.0332361897454,1266.4771758560091L901.6630749022588,1262.7432164088823L899.4873270010576,1261.7787746214308L898.2897978778929,1264.5077179768123L888.3403662079945,1260.127674936317L889.906305144541,1256.5487303500995L887.8086569681764,1255.6207013940439L885.8033084655181,1260.212986963801Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M960.1992134507746,1465.7474238644354L982.8410338098183,1421.3353644888848L1007.5947022968903,1434.0559128983878L1009.7846501478925,1429.747762166895L1029.4365921355784,1439.8465792858042L1027.1969444574788,1444.2400335064158L1036.0411466825753,1448.7822567527182L1036.2604570221156,1448.343223852571L1042.0855920892209,1451.3269824474119L1034.6093183849007,1465.9887873190455L1019.9541810452938,1458.4555385783315L1003.6195051679388,1490.5089819235727L983.968352066353,1480.4175210986286L984.9528819369152,1478.4689311478287ZM977.426908409223,1453.629302968271L987.936449220404,1459.0298177399673L993.4215743718669,1461.8429526421241L996.7522515449673,1455.3230113871396L980.7504856074229,1447.0958292782307Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1054.884480402805,1513.5621928418986L1056.734418339096,1509.9407245996408L1055.8839991083369,1509.507937693037L1078.5897192433476,1465.0743110761978L1092.0047276131809,1471.977095211856L1086.1440926715732,1483.4366380316205L1087.2422221424058,1483.9963501230814L1086.3847029358149,1485.6682036309503L1088.2204409232363,1486.6045246482827L1088.5959507133812,1485.8669117689133L1095.2644050354138,1489.3115320303477L1090.3890888513997,1498.8495111893862L1092.7770471191034,1505.6742351693101L1101.9541592821479,1510.4016010123305L1098.602182184346,1516.9558220934123L1097.794362803921,1516.5386409037746L1096.8303439728916,1518.430000805296L1098.4601826835424,1519.266443632543L1097.8937624534592,1520.3577724946663L1109.6434322353452,1526.4094948214479L1107.467684334144,1530.6759714926593L1102.585268174298,1540.2284586289898L1061.4535350743681,1519.0323644927703L1061.9071445893496,1518.132460175082L1055.8626991836354,1515.0072424090467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M963.4730908237398,1279.169917928055L979.3620460471138,1247.739733001683L996.8161513209343,1256.6340424227528L996.5187412546948,1257.193772827275L990.6581063140184,1268.7452249168418L985.243980913423,1279.4040051666088L1000.3882276443765,1287.1559296352789L996.0438318140805,1295.752638312988Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M853.7145768916234,1330.7396657206118L866.6412647562101,1305.3834779160097L873.8406394328922,1309.075799065642L886.9653377113864,1315.82164080441L874.0323387589306,1341.185073082801Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M956.2729272609577,1293.4065691693686L963.4730908237398,1279.169917928055L996.0438318140805,1295.752638312988L995.8024326628074,1296.2270539724268L988.8436682512984,1309.9965381864458Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1067.194259326905,1350.745103939902L1070.1778266085312,1344.8492849678732L1077.0868911966681,1331.1787060690112L1077.7747998880222,1329.8251716382802L1094.7752956459299,1338.478007865604L1084.4716541096568,1358.873564684298L1084.19475508295,1359.3979140613228Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M995.2857122588903,1313.277905756142L1002.2373766964301,1299.5157107533887L1006.6882721511647,1290.714050698094L1019.3869719300419,1297.4037295137532L1014.8090658094734,1306.4529923866503L1008.0696117375046,1319.7906979210675Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M977.3772085839882,1363.1963247111998L988.5036583365873,1341.6033052019775L1001.2457468500361,1348.208664346952L990.8916166033596,1368.2993628587574L989.3682775171474,1371.2613080502488L984.4148616073653,1368.6884628608823L985.165881187655,1367.2361001735553Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M990.8916166033596,1368.2993628587574L1001.2457468500361,1348.208664346952L1013.9586465787143,1354.8129768213257L1006.1565629104152,1369.9639616468921L1003.6195051679388,1374.9036561944522Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M888.3119663074613,1329.0740171354264L891.9968533469364,1322.079537163023L900.3732461063191,1326.5230042855255L902.9813035987318,1321.5624676379375L908.3039182107896,1324.3902236516587L917.8565401649103,1306.2261887467466L918.0616505546495,1305.8506102282554L923.0647662905976,1308.5087901703082L908.2116185342893,1336.7343327081762L902.3864834690467,1333.638163802214L895.4837299715728,1329.9812286570668L894.2862008502707,1332.2492569405586Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M861.5813492191955,1302.7825179044157L870.6732616852969,1284.937825168483L882.9404407581314,1291.2384052295238L874.8330581635237,1307.1334032593295L873.8406394328922,1309.075799065642L866.6412647562101,1305.3834779160097Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M927.458861945197,1335.9124331665225L938.0181025816128,1315.4034071303904L948.1947334529832,1320.6906279888935L937.6354928165674,1341.1923557333648Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M985.43489135243,1394.4626480746083L993.1454642303288,1379.4812975372188L1005.9293637089431,1386.1147106299177L998.2124797422439,1401.0960468342528L994.8889025431126,1399.3742351881228L994.5694036670029,1399.9974166126922L992.6208549663424,1398.9840965378098L991.4943255949765,1401.1740745431744L989.0700785666704,1399.9121063044295L990.1973968222737,1397.7294104923494L988.715868701227,1396.9574559447356L989.0282676024362,1396.3342742458917Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M921.5840270547196,1345.9687314820476L926.905852779746,1335.62945000967L927.458861945197,1335.9124331665225L937.6354928165674,1341.1923557333648L942.5676088025793,1343.7506458307616L943.7438379973173,1344.3603073409759L939.7757408441976,1352.0559788383543L938.4149122973904,1354.6995757934637L936.1184648191556,1353.502102444414Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1025.1773960059509,1389.4595048199408L1028.1822632141411,1383.6136566293426L1036.8915659124032,1366.7044687690213L1044.2897398909554,1370.5528133730404L1032.5755699835718,1393.2932716016658Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1059.2785760574043,1406.5735898003913L1061.7020342005417,1401.783731003292L1080.7788782101125,1411.492450909689L1086.8099125511944,1414.5750602707267L1083.6993346046656,1420.7329923138022L1077.4198011364788,1417.5297031230293L1060.7664152681828,1409.047585947439L1061.4535350743681,1407.672218982596Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M958.4202752634883,1354.883722415194L963.721589948982,1344.8347196765244L963.4099799338728,1344.6724207238294L970.1841449961066,1331.5116276391782L976.9519989686087,1335.027070388198L970.0713342819363,1348.3855284992605L965.5920389257371,1357.0809969813563L961.5742419464514,1354.9971234397963L960.9644329808652,1356.1945965308696Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M977.6896074851975,1393.9528665402904L989.3682775171474,1371.2613080502488L995.6896219486371,1374.5353640089743L993.1454642303288,1379.4812975372188L985.43489135243,1394.4626480746083L984.0038519417867,1397.226911786478Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M996.7806514455006,1403.888397865463L998.2124797422439,1401.0960468342528L1005.9293637089431,1386.1147106299177L1008.6013209782541,1380.9274154244922L1014.8019658336416,1384.1442463640124L1008.9768307683989,1395.4624439957552L1003.2297954270616,1406.6162449149415L1002.9812963008881,1407.1125007299706Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1026.8711344935,1330.2080315174535L1033.0788793247193,1317.9200914683752L1038.712315064855,1306.7869555307552L1044.807249181904,1309.8977017886937L1032.972379698418,1333.3114846120588Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M971.4668738171458,1390.7287575565279L979.1348468456417,1375.838951798156L983.1534327119589,1368.0371885113418L984.4148616073653,1368.6884628608823L989.3682775171474,1371.2613080502488L977.6896074851975,1393.9528665402904Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1053.2120418418199,1403.4847346707247L1059.7526966119185,1390.5373292914592L1064.536502007395,1381.0834712935612L1064.8481120234355,1380.459247798659L1070.9146462399513,1383.549153557513L1062.8995633218437,1399.4231325639412L1061.7020342005417,1401.783731003292L1059.2785760574043,1406.5735898003913Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M970.7229542126879,1361.3184473402798L971.361163077876,1360.078319735825L975.8396695470437,1351.3828550130129L982.4797239694744,1338.478007865604L988.5036583365873,1341.6033052019775L977.3772085839882,1363.1963247111998L976.7397886039689,1364.4364517563954Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1066.4992506587878,1439.123526525218L1071.6727657951415,1428.890501232352L1077.4198011364788,1417.5297031230293L1083.6993346046656,1420.7329923138022L1072.7850952167064,1442.3268057382666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M965.5920389257371,1357.0809969813563L970.0713342819363,1348.3855284992605L976.9519989686087,1335.027070388198L982.7211231207475,1338.0108777517453L982.4797239694744,1338.478007865604L975.8396695470437,1351.3828550130129L971.361163077876,1360.078319735825Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M862.5800790414214,1461.5526921045966L865.7198457745835,1455.3448589737527L866.0527557143942,1455.5071553364396L881.3177020214498,1463.2817708314396L886.3066178057343,1465.8192086843774L883.1668510716408,1472.0405570990406L878.1779352873564,1469.489596855361Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M890.9484237013385,1407.3538662265055L893.5422812439501,1402.201959464699L911.4286961080506,1411.2729332824238L912.5268255788833,1411.8253686260432L917.6577408639714,1414.4398125046864L915.0638833222911,1419.5989927346818L909.8130573462695,1416.921088412404Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M869.9293420789763,1361.2757919491269L872.2605005465448,1356.6409178981557L892.7060619639233,1366.9874506569467L889.6159950550646,1373.1464653387666L876.6545962011442,1366.591067938134L877.4198157321662,1365.0606766962446Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1038.8543145647272,1336.3171406737529L1049.3638553768396,1315.531374153681L1054.445070836693,1318.1177640319802L1050.1432748567313,1326.6291231084615L1050.767283773981,1326.9412372885272L1044.5666389167309,1339.2156364261173Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M868.3910141577944,1369.971244264394L871.4242812646553,1363.9401928903535L876.6545962011442,1366.591067938134L889.6159950550646,1373.1464653387666L886.596927896142,1379.1764683327638L873.3310190029442,1372.4660609466955Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M874.8330581635237,1307.1334032593295L882.9404407581314,1291.2384052295238L883.3585503986105,1290.4237829963677L889.7792944805697,1293.7186848432757L881.2538022464141,1310.429337546695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1028.4086735295132,1420.1379026486538L1028.6003728546202,1419.7841779994778L1031.3283410379663,1414.4762253644876L1032.2568599944934,1413.6470524668694L1034.4894076958299,1409.3097587432712L1034.6661181859672,1407.9988946700469L1037.6212855689228,1402.2654219921678L1043.8503303257748,1405.4968081931584L1040.9022629167885,1411.2302781986073L1039.8396333213896,1412.087541316636L1037.5999856442213,1416.4248333000578L1037.5644857687876,1417.7003233050928L1034.6448182603344,1423.3765630819835Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M856.0394242694601,1474.4999648672529L859.377201417461,1467.9020085576922L869.6311431275681,1473.1110862232745L868.7878238717094,1474.7902248632163L876.5125967003405,1478.7238188125193L874.0181388081983,1483.6488708737306L866.2933659795672,1479.7225622260012Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1042.709601004608,1392.0250597046688L1045.4446691619232,1386.618250511121L1046.26037740428,1385.6184533149935L1048.8392461109906,1380.5237508937716L1049.2431558007374,1379.0849155317992L1051.7313026040792,1374.1733140465803L1057.8041479103267,1377.2632226096466L1057.6479484606534,1377.575334510766L1055.3238899679855,1382.1748219071887L1054.352771161124,1383.3296350482851L1051.7731135692447,1388.4253757763654L1051.5183033533394,1389.708153528627L1048.7832351960242,1395.1295254966244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M868.929823372513,1448.9736834140494L872.2818004712462,1442.3403304615058L887.9222565675154,1450.2991048060358L884.5347795942798,1456.9178850883618L869.2698332881555,1449.1505449949764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1061.8858446646482,1348.038042455446L1063.4951723366976,1344.8492849678732L1068.087278407067,1335.7636589352041L1071.7792654205114,1328.4716369435191L1077.0868911966681,1331.1787060690112L1070.1778266085312,1344.8492849678732L1067.194259326905,1350.745103939902Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M852.8783576106653,1403.817652768921L855.3444156032056,1398.8925439990126L855.9613245436922,1397.6732305125333L872.6360103366897,1406.1064642746933L869.5538322888315,1412.2508790567517Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M893.3363819690421,1350.837697490584L899.3106165109202,1339.4913367838599L902.3864834690467,1333.638163802214L908.2116185342893,1336.7343327081762L903.9524224055931,1344.8274370306171L899.1615170342848,1353.9276164574549Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M937.6354928165674,1341.1923557333648L948.1947334529832,1320.6906279888935L953.1197494631633,1323.2343603149056L946.8552048327401,1335.4099299809895L942.5676088025793,1343.7506458307616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M857.4704636801034,1385.2002238510177L860.1495209224522,1379.8568720696494L865.1739365831017,1382.3943404550664L880.2400835892186,1390.012982269749L877.5547152562067,1395.3698510415852L870.5738620338961,1391.8263488770463L871.2830706499517,1390.4239288466051L867.3283845614642,1388.4180931779556L866.6199648305774,1389.8350788094103L861.2618503430858,1387.1145077566616Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M883.1810510223731,1422.788756211754L885.8885081661865,1417.4027783484198L904.7531418120489,1426.9762288611382L902.0385846924037,1432.3621992864646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1012.4140075678006,1373.209928132128L1020.4503904106095,1357.5907812272198L1026.7646348671988,1360.86484364653L1026.5232357159257,1361.3257299694233L1020.5355901103467,1372.9550365884788L1018.7211520494893,1376.4839831735007Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M859.377201417461,1467.9020085576922L862.5800790414214,1461.5526921045966L878.1779352873564,1469.489596855361L874.9750576643273,1475.8389060380869L869.6311431275681,1473.1110862232745Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M902.9813035987318,1321.5624676379375L912.5410255296156,1303.4057080117054L917.8565401649103,1306.2261887467466L908.3039182107896,1324.3902236516587Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1006.1565629104152,1369.9639616468921L1013.9586465787143,1354.8129768213257L1014.1929457541555,1354.3448074287735L1020.4503904106095,1357.5907812272198L1012.4140075678006,1373.209928132128Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.8995633218437,1399.4231325639412L1070.9146462399513,1383.549153557513L1077.11529109627,1386.709803215228L1076.9669805057347,1387.0011072568595L1071.7508655209094,1397.3330295276828L1069.093108203262,1402.5775327668525Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M866.0527557143942,1455.5071553364396L869.2698332881555,1449.1505449949764L884.5347795942798,1456.9178850883618L882.841041107662,1460.2772101666778L881.3177020214498,1463.2817708314396Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M885.1516885356978,1417.027205852326L887.6319464789703,1412.087541316636L888.3758660834283,1412.463114080485L906.1210703328252,1421.470612120349L905.5751611422747,1422.5546738142148L906.6945905378088,1423.1216733818874L906.3261807225645,1423.8509700084105L904.7531418120489,1426.9762288611382L885.8885081661865,1417.4027783484198Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M880.2116836896166,1427.4797657751478L882.6990416068584,1422.540108686313L883.1810510223731,1422.788756211754L902.0385846924037,1432.3621992864646L901.2023654123768,1434.02782305656L899.5583267491311,1437.3018493773416Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M888.3758660834283,1412.463114080485L890.9484237013385,1407.3538662265055L909.8130573462695,1416.921088412404L907.814808819443,1420.8890472864732L906.6945905378088,1420.3147649685852L906.1210703328252,1421.470612120349Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M850.015489901416,1409.514711278025L852.8783576106653,1403.817652768921L869.5538322888315,1412.2508790567517L866.6901756944135,1417.9552132035606Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M887.7873570434749,1313.9791236105375L896.5392595920712,1295.5403997167014L901.719874702394,1297.9988297112286L896.0509390868247,1309.911226767581L892.9608721788973,1316.4313047709875Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M948.8179534841329,1344.1262222984806L951.9506202423945,1338.0524929068051L958.215164873749,1325.877968261484L963.2466805083677,1328.4934849282727L956.7123368270695,1341.1923557333648L954.8347878754139,1344.8347196765244L953.8565690936521,1346.7417320837267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M841.5467974673957,1428.5991989504546L844.6581643009558,1422.6046113925986L859.6249116575345,1430.4063132731244L856.5214336849749,1436.4019344486296Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M865.1739365831017,1382.3943404550664L868.0439042653888,1376.682694437448L870.5738620338961,1377.9581917528994L883.8334598401561,1384.6623515924439L880.9698032457381,1390.3812736328691L880.2400835892186,1390.012982269749Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M956.7123368270695,1341.1923557333648L963.2466805083677,1328.4934849282727L963.4872907744721,1328.032596425619L970.1841449961066,1331.5116276391782L963.4099799338728,1344.6724207238294Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M988.8436682512984,1309.9965381864458L995.8024326628074,1296.2270539724268L1002.2373766964301,1299.5157107533887L995.2857122588903,1313.277905756142Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M855.9613245436922,1397.6732305125333L858.611981886439,1392.3933509611525L875.2866676794365,1400.8265911419876L872.6360103366897,1406.1064642746933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M858.611981886439,1392.3933509611525L861.2618503430858,1387.1145077566616L866.6199648305774,1389.8350788094103L870.5738620338961,1391.8263488770463L877.5547152562067,1395.3698510415852L877.9302250482142,1395.5539965801872L875.2866676794365,1400.8265911419876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1008.0696117375046,1319.7906979210675L1014.8090658094734,1306.4529923866503L1021.3576094415039,1309.7843000260182L1020.4929902609438,1311.5134166032076L1014.6110553946346,1323.120958769694Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1023.0584479039535,1380.9482228732668L1025.772216135636,1375.6766535700299L1031.7535506524146,1364.040068892762L1036.8915659124032,1366.7044687690213L1028.1822632141411,1383.6136566293426Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M898.6234967056662,1392.1238949284889L901.273365162313,1386.8585763531737L915.4677930129692,1394.0589843322523L918.6359596466646,1395.667396940291L916.8854213599116,1399.154717176687L914.4122633924708,1397.8927485705353L913.5121443355456,1399.6863460931927L911.811305873096,1398.8207584824413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M927.5511616198346,1417.5650755995885L930.5560288298875,1411.520540843252L944.7078568283468,1418.6210479964502L941.7029896201566,1424.65205180645Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.205343540758,1307.332116513513L1068.8737978627905,1294.2003833409399L1075.259042069316,1297.4671929972246L1070.2204264588654,1307.3955799080431L1068.5968988360837,1310.5989199848846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M893.5422812439501,1402.201959464699L896.0793389873579,1397.1769740250893L907.1765999533236,1402.81785805244L911.2377856690437,1404.87362726219L910.12466736231,1407.0844107777812L912.846324454993,1408.4524952815846L911.4286961080506,1411.2729332824238Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M894.8739210050553,1473.642709468957L903.0523033486679,1457.4775993209332L908.1122188856825,1460.0576940872706L906.8223900878802,1462.6159403240308L900.3306462559849,1475.4779017232358L899.9480364909396,1476.2217578566633Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.01810974814,1304.1641479837708L1057.5422377213836,1301.1522356732748L1062.6802529813722,1291.039691511076L1068.8737978627905,1294.2003833409399L1062.205343540758,1307.332116513513Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1043.5671202102676,1296.602633011993L1049.7535651167855,1284.4207528703846L1056.4078194890171,1287.8228173758835L1051.2705931141973,1297.9353662305512L1050.2213745824993,1300.018216541037Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M889.9489049958065,1471.1333641679958L893.3718818444759,1464.35230130516L897.9000881388783,1455.3875137879513L898.1130873896182,1454.9692885321565L903.0523033486679,1457.4775993209332L894.8739210050553,1473.642709468957Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M903.7607230804861,1381.9261729260907L906.3900804976001,1376.689977050759L921.6976266540587,1384.4636405571364L919.0611692611128,1389.6863057347946L915.6026925370097,1387.9364012260921Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1037.0682764025405,1293.272359425202L1043.248410220258,1281.0904734316282L1049.7535651167855,1284.4207528703846L1043.5671202102676,1296.602633011993Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1020.5994898863137,1327.01198316738L1020.9323998261243,1326.3461395730264L1026.8072347184643,1314.7302797464654L1033.0788793247193,1317.9200914683752L1026.8711344935,1330.2080315174535Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1045.593768636696,1462.2830250463448L1048.4495363710448,1456.620341818314L1049.9026645915583,1457.3714824998751L1061.8858446646482,1463.48047960829L1059.030076932162,1469.1285922075622L1058.6687670908868,1468.944448620081L1047.0610968098044,1463.034165118821Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M918.9546696357429,1351.0707419328392L921.5840270547196,1345.9687314820476L936.1184648191556,1353.502102444414L933.4898962872103,1358.6113899834454Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M916.3253122186288,1356.173789005261L918.9546696357429,1351.0707419328392L933.4898962872103,1358.6113899834454L930.8605388691649,1363.720673755277Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1049.9949642671272,1341.9861644329503L1056.195609123446,1329.7117702020332L1062.262143340893,1332.8016985803843L1056.1743091978133,1344.8492849678732L1056.0607095984742,1345.0760873425752Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1014.6110553946346,1323.120958769694L1020.4929902609438,1311.5134166032076L1026.8072347184643,1314.7302797464654L1020.9323998261243,1326.3461395730264Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M870.5738620338961,1377.9581917528994L873.3310190029442,1372.4660609466955L886.596927896142,1379.1764683327638L883.8334598401561,1384.6623515924439Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1031.1019307225943,1290.2385942772962L1032.2142601432279,1288.0423389123753L1037.2883756281808,1278.0431779106148L1043.248410220258,1281.0904734316282L1037.0682764025405,1293.272359425202Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M925.9426228348166,1490.068911309354L927.0336523307487,1487.915373857133L933.064686672762,1475.9741526087746L938.1806131210178,1478.5750476452522L932.951087070629,1488.9359634295106L931.0656492598355,1492.6698010587133Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1012.4921072917059,1279.169917928055L1018.0553321689367,1268.2135859592818L1024.631486814469,1271.5730024725199L1019.5573713295162,1281.572172807064L1019.0682619391009,1282.5355714554898Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.2204264588654,1307.3955799080431L1075.259042069316,1297.4671929972246L1081.488086826168,1300.6632549706846L1075.691351659596,1312.0731425741687L1074.4717337284237,1314.475386052858L1071.8786650709808,1313.1572213708423L1073.8627136480063,1309.252664218191Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1056.0607095984742,1345.0760873425752L1056.1743091978133,1344.8492849678732L1062.262143340893,1332.8016985803843L1068.087278407067,1335.7636589352041L1063.4951723366976,1344.8492849678732L1061.8858446646482,1348.038042455446Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1049.9026645915583,1457.3714824998751L1052.9146317755803,1451.4112517624162L1064.8978118486702,1457.520254122559L1061.8858446646482,1463.48047960829Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M923.8307747077197,1401.8191035618074L930.7611392186955,1388.7364468039013L936.0198540547863,1391.5360854077153L929.0887006567791,1404.6249790955335Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M905.2067513270304,1478.8861146261916L905.5751611422747,1478.1495412830263L912.0740049500018,1465.2875848393887L917.2396312244236,1467.923856104724L910.3731664875522,1481.522380720824Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M910.3731664875522,1481.522380720824L917.2396312244236,1467.923856104724L922.3918464351445,1470.5455613438971L916.3679120680317,1482.4867919427343L915.5245928131044,1484.1378386742435Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1006.2204626854509,1275.9592806119472L1011.7899986505508,1265.010226299055L1018.0553321689367,1268.2135859592818L1012.4921072917059,1279.169917928055Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M852.4602479701862,1480.8138973107561L855.7341253431514,1474.343911101576L856.0394242694601,1474.4999648672529L866.2933659795672,1479.7225622260012L863.019488606602,1486.1925434158184L852.7655468946323,1480.9699509302154Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M940.4344607489184,1375.3572589713149L946.6422055801377,1362.7291962592863L952.0705309314653,1365.42168676015L949.5334731889889,1370.6089935689233L945.862786100246,1378.0570271802135Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1041.3203725572675,1474.393848306965L1044.268439966254,1468.5543138845824L1055.8697991594672,1474.4645926812664L1052.9217317504808,1480.3041221247986L1043.9639299260452,1475.7327894987538Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M900.3306462559849,1475.4779017232358L906.8223900878802,1462.6159403240308L912.0740049500018,1465.2875848393887L905.5751611422747,1478.1495412830263Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1044.5666389167309,1339.2156364261173L1050.767283773981,1326.9412372885272L1056.195609123446,1329.7117702020332L1049.9949642671272,1341.9861644329503Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1025.6728164860979,1284.7047785026953L1030.7469319710508,1274.704572301358L1037.2883756281808,1278.0431779106148L1032.2142601432279,1288.0423389123753Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1052.8649319503456,1387.0364798898809L1055.3238899679855,1382.1748219071887L1057.6479484606534,1377.575334510766L1064.536502007395,1381.0834712935612L1059.7526966119185,1390.5373292914592Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M921.6195269301534,1485.158428802155L927.6568723600358,1473.21720280312L933.064686672762,1475.9741526087746L927.0336523307487,1487.915373857133Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M901.273365162313,1386.8585763531737L903.7607230804861,1381.9261729260907L915.6026925370097,1387.9364012260921L914.4264633413404,1390.267873186618L916.7789217336103,1391.4653401882388L915.4677930129692,1394.0589843322523Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M896.0793389873579,1397.1769740250893L898.6234967056662,1392.1238949284889L911.811305873096,1398.8207584824413L909.8201573221013,1402.7824855004437L907.7296091197059,1401.7265106891282L907.1765999533236,1402.81785805244Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1044.268439966254,1468.5543138845824L1047.0610968098044,1463.034165118821L1058.6687670908868,1468.944448620081L1055.8697991594672,1474.4645926812664Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M919.0540692862123,1399.2681174776517L925.9915337739512,1386.1927385064773L930.7611392186955,1388.7364468039013L923.8307747077197,1401.8191035618074Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1051.2705931141973,1297.9353662305512L1056.4078194890171,1287.8228173758835L1062.6802529813722,1291.039691511076L1057.5422377213836,1301.1522356732748Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M916.3679120680317,1482.4867919427343L922.3918464351445,1470.5455613438971L927.6568723600358,1473.21720280312L921.6195269301534,1485.158428802155Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M946.8552048327401,1335.4099299809895L953.1197494631633,1323.2343603149056L958.215164873749,1325.877968261484L951.9506202423945,1338.0524929068051Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M995.6541220732033,1271.3035417464562L1001.5218569897115,1259.7520939200185L1006.8223827900365,1262.4664726099L1000.9617478493601,1274.0179159147665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1020.5355901103467,1372.9550365884788L1026.5232357159257,1361.3257299694233L1031.7535506524146,1364.040068892762L1025.772216135636,1375.6766535700299Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1019.5573713295162,1281.572172807064L1024.631486814469,1271.5730024725199L1030.7469319710508,1274.704572301358L1025.6728164860979,1284.7047785026953Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1003.2297954270616,1406.6162449149415L1008.9768307683989,1395.4624439957552L1014.3065453553572,1398.2256669397466L1008.5658211028203,1409.3805037811399Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M896.0509390868247,1309.911226767581L901.719874702394,1297.9988297112286L906.7087904885411,1300.3729876847938L901.0469548469409,1312.2853806614876Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M990.6581063140184,1268.7452249168418L996.5187412546948,1257.193772827275L1001.5218569897115,1259.7520939200185L995.6541220732033,1271.3035417464562Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1000.9617478493601,1274.0179159147665L1006.8223827900365,1262.4664726099L1011.7899986505508,1265.010226299055L1006.2204626854509,1275.9592806119472L1005.9293637089431,1276.5543826515786Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1023.4836575193331,1417.1187581541017L1029.2235928848386,1405.971216343809L1034.3474081959575,1408.6220753192902L1031.3283410379663,1414.4762253644876L1028.6003728546202,1419.7841779994778Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M901.2023654123768,1434.02782305656L902.0385846924037,1432.3621992864646L904.7531418120489,1426.9762288611382L906.3261807225645,1423.8509700084105L911.9959052242339,1426.7213392965496L906.8649899382144,1436.9117128620856Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M906.8649899382144,1436.9117128620856L911.9959052242339,1426.7213392965496L912.8392244810238,1425.034906450659L917.7145406650379,1427.5151382037438L911.733206147328,1439.3711330913939Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1049.2999556008726,1262.5517846094444L1055.3522898675874,1250.4541163942777L1060.0366956125945,1252.8147655567154L1053.9843613458797,1264.9113892633468Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1067.4064696906134,1271.6791221369058L1073.4588039582595,1259.5752275069244L1078.1219097776338,1261.9275504397228L1072.069575510919,1274.0251986356452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1018.480541783385,1414.5324052046053L1024.2204771488905,1403.3640518537723L1029.2235928848386,1405.971216343809L1023.4836575193331,1417.1187581541017Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer playground"
        d="M911.8965055737644,1442.5036674891599L937.4579934412614,1393.2724641896784L983.3443431509659,1417.1114755831659L957.7757553076372,1466.328984935768Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1013.4908371130005,1411.9387687174603L1019.2386613395065,1400.7839359948412L1024.2204771488905,1403.3640518537723L1018.480541783385,1414.5324052046053Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1008.5658211028203,1409.3805037811399L1014.3065453553572,1398.2256669397466L1019.2386613395065,1400.7839359948412L1013.4908371130005,1411.9387687174603Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.849863496609,1269.3757008067332L1068.895097787492,1257.2790848892182L1073.4588039582595,1259.5752275069244L1067.4064696906134,1271.6791221369058Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1058.3074572514743,1267.0868441620842L1064.359791518189,1254.99750699196L1068.895097787492,1257.2790848892182L1062.849863496609,1269.3757008067332Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M932.951087070629,1488.9359634295106L938.1806131210178,1478.5750476452522L943.4393279580399,1481.2602106584236L938.2090130215511,1491.613839937374Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M967.8245866289362,1389.1900486764498L973.3239117302,1378.5033471425995L975.6337702721357,1374.018298394978L979.1348468456417,1375.838951798156L971.4668738171458,1390.7287575565279L971.3256632033736,1391.0044558662921Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M952.290630158037,1381.1261265645735L956.6910369014367,1372.5929865413345L962.800170969218,1375.7682064152323L958.406075312756,1384.3003021595068Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1053.9843613458797,1264.9113892633468L1060.0366956125945,1252.8147655567154L1064.359791518189,1254.99750699196L1058.3074572514743,1267.0868441620842Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1072.069575510919,1274.0251986356452L1078.1219097776338,1261.9275504397228L1081.998496142216,1263.8834839831106L1081.502286775969,1264.8832987351343L1081.9771962165833,1265.1236287942156L1076.428171291016,1276.2214584406465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1041.0726623190567,1481.4589189197868L1043.9639299260452,1475.7327894987538L1052.9217317504808,1480.3041221247986L1050.0375641183928,1486.0156827792525Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M934.8215360483155,1371.990610130597L940.0802508844063,1361.2830745754763L944.905867244117,1363.6780183794908L939.6479412941262,1374.379307993222Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M882.841041107662,1460.2772101666778L884.5347795942798,1456.9178850883618L887.9222565675154,1450.2991048060358L892.7549729030579,1452.7647624560632L889.2688851645216,1459.6821238985285L887.7163572926074,1462.750146791339Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1058.1086579505354,1434.85699351551L1064.8268120978028,1421.5548817971721L1066.7548497607931,1422.540108686313L1065.7837309539318,1424.4751895992085L1064.9617116227746,1425.4739408269525L1067.3212699908763,1426.6724421097897L1062.1414437657222,1436.9117128620856Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1071.7508655209094,1397.3330295276828L1076.9669805057347,1387.0011072568595L1081.3673872519284,1389.2472690921277L1076.14417229034,1399.572945799213Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.1414437657222,1436.9117128620856L1067.3212699908763,1426.6724421097897L1071.6727657951415,1428.890501232352L1066.4992506587878,1439.123526525218Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M892.4007630366832,1335.8281624484807L894.2862008502707,1332.2492569405586L895.4837299715728,1329.9812286570668L902.3864834690467,1333.638163802214L899.3106165109202,1339.4913367838599Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M889.2688851645216,1459.6821238985285L892.7549729030579,1452.7647624560632L897.9000881388783,1455.3875137879513L893.3718818444759,1464.35230130516L891.720743207261,1463.508569331374L892.7549729030579,1461.4601000286639Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M964.3093101046979,1387.369398780167L968.7034057602286,1378.8227415932342L969.8086352068931,1376.682694437448L973.3239117302,1378.5033471425995L967.8245866289362,1389.1900486764498Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1041.547571759671,1453.1049607228488L1044.3678396167234,1447.5213375440799L1051.1498935390264,1450.9722190285102L1048.4566363459453,1456.3082334753126L1048.3225257052109,1456.5631219553761Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M912.5268255788833,1411.8253686260432L915.8653916129842,1405.1992627135478L921.0026179878041,1407.8001843029633L917.6577408639714,1414.4398125046864Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M886.4273173818365,1332.6529242820106L888.3119663074613,1329.0740171354264L894.2862008502707,1332.2492569405586L892.4007630366832,1335.8281624484807Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1017.6009337659925,1456.8897953410633m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M977.0592874800786,1273.9575733803213m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M870.3395628584549,1323.2811774648726m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M989.3114777170122,1355.7024985780008m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1002.4267093641683,1361.5556529313326m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M872.2589227743447,1297.010463969782m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M995.6817330876365,1390.288680610247m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M932.6639325264841,1345.1645194594748m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1036.2360015520826,1377.0832380750217m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1070.7718578530475,1410.2700185365975m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M970.1802005656064,1339.8492270447314m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M985.4175358582288,1386.7170858145691m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1007.4527027951553,1390.788058704231m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1033.8109656386077,1324.0635440247133m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M979.2405575858429,1383.2838586731814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1061.3257355233654,1394.9807525360957m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M977.4119195733219,1355.730588736944m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M976.2767124548554,1343.431249764748m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M876.141820226796,1464.5499696941115m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M901.1881654616445,1409.3128798464313m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1044.8119824994355,1331.6291905664839m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M878.3325569657609,1371.2186527173035m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M882.3053874364123,1300.4260472948663m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1036.0474577704445,1412.8667767494917m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M866.560798372142,1476.757542297244m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1050.3065742831677,1384.474044274073m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M878.5960449287668,1449.7248249244876m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1069.1325525073335,1340.306993627455m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M862.7575784157962,1404.9620586144738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M946.8678270094097,1329.3216276299208m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M869.1712225237861,1387.7657803110778m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M893.966701974161,1424.883013034705m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1019.5329158594832,1367.1403857171535m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M868.7791461246088,1468.6958027537912m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M910.4212885415182,1313.894852625206m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1013.3046599887311,1363.7778943846934m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1070.4610367240384,1392.1665501315147m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M875.2929787691683,1456.2125202482566m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M896.0051836930215,1419.4366955338046m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M899.0920950565487,1414.6915814206004m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M895.7156624896452,1303.955030797515m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M957.5982559332624,1333.2729905652814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M874.5033037690446,1383.5283461171202m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M963.447846468538,1336.3525135680102m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M995.5413113599643,1304.756126449909m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M865.6236016685143,1399.2504311907105m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M868.0888707749546,1393.8821213431656m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1014.278145454824,1315.652058497537m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1031.329129923135,1371.190562620759m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M907.044855972752,1393.0914396974258m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1068.732587248087,1302.3996565113775m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M902.9955035485327,1403.845742734149m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M900.8520999774337,1468.1288069095463m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1063.20801779069,1297.6763103785925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1049.9870754061267,1292.212206389755m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M898.2109092678875,1460.914951167535m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M912.7303581964225,1383.1954270447604m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1043.4101318744943,1288.8465575603768m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1027.006822904572,1322.132596610114m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1053.3003970859572,1462.6585950916633m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M927.5353838987648,1352.286942484323m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M924.9068153668195,1357.392069415655m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1056.12776491791,1337.3939330279827m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1020.7107228282839,1318.926140719559m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M878.5857894085348,1378.5678502554074m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1037.7317296257243,1284.5664070444182m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1018.5625859405845,1275.3714612424374m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1062.1303993593901,1340.306993627455m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M929.9257088247687,1396.677596390713m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M911.4081850694492,1473.0361804007553m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M916.3836897909641,1476.0344933844171m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1012.1394751993939,1272.0869545610622m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M947.4232028340921,1368.0153406499885m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1048.595480300486,1474.4292204943486m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M906.2007478307933,1470.3822249742225m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1050.380729577504,1334.4631847529672m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1031.4805960571393,1281.3734588143416m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1058.4242123952135,1384.605131139513m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M910.355022107251,1389.101617120672m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M903.9445335445926,1397.9988663033582m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1051.468603529036,1468.7488610763103m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M924.9099709112197,1394.0028043254279m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1056.9750286052004,1294.487529728096m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M922.0100255552679,1477.8519989228807m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M952.5351848527789,1330.6439507575706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1001.2394357612357,1266.8850085865706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1026.1461481535807,1368.497033986263m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1025.1521516507491,1278.1388935977593m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1008.7693537203595,1402.421477382537m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M901.381442559883,1305.1421088664792m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M996.0887983236462,1264.24866087595m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1006.3727177055553,1269.5140725714155m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1029.5951582444832,1411.5486307749525m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M906.9533451832831,1429.669734778814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M912.2877930868417,1432.2134271240793m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1072.763795292005,1266.8038581986912m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1023.8497006762773,1410.25233228039m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M963.5559238661081,1381.5620426032692m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1018.8584182327613,1407.6514116115868m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1013.9010578915477,1405.0827414048836m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1068.153544840403,1264.4754658895545m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M972.7922024885193,1383.8466999665834m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M957.5461894487962,1378.4471670072526m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M939.8633072022349,1367.8343155011535m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M888.6527651092038,1454.841324083507m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1062.7133861975744,1430.7641988382675m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1066.9078936669976,1432.9011082090437m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M897.394412140362,1334.732643023599m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M893.5833033220842,1457.5348191754892m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M968.7333834320307,1383.0955513189547m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1046.3487326484174,1452.0385899581015m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M958.406075312756,1384.3003021595068L962.800170969218,1375.7682064152323L964.1751994648948,1373.0892447899096L966.1024482417852,1374.0890437928028L964.7345197210088,1376.7680050344206L968.7034057602286,1378.8227415932342L964.3093101046979,1387.369398780167Z"
      />
    </g>
    <g>
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="0"
        className="landuse-layer parking"
        d="M1162.8372340211645,1262.983546542935L1164.7991937855259,1263.9968864973634L1153.169434693642,1287.0643756175414L1106.1723333345726,1262.983546542935Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1290.3267522519454,1412.7325693173334m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1108.8356128558517,1387.4182962407358L1259.8528705528006,1464.7486784346402"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1172.883698683232,1262.983546542935L1142.9154929826036,1321.356472122483L1108.8356128558517,1387.4182962407358"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1075.1651646215469,1286.5941208773293L1142.9154929826036,1321.356472122483L1291.839046932757,1397.8084786082618"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1126.031752370298,1479.6580600519665L1075.1651646215469,1453.5679216366261"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1280.106732645072,1475.1231395397335L1291.839046932757,1452.2570659336634"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1280.106732645072,1475.1231395397335L1288.9383126916364,1479.6580600519665"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1075.1651646215469,1370.1709960917942L1088.3900514375418,1376.9448684575036"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer rail"
        d="M1180.3015948133543,1262.983546542935L1291.839046932757,1318.1697831256315"
        style={{ display: 'none' }}
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1088.3900514375418,1376.9448684575036L1108.8356128558517,1387.4182962407358"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1277.7818852672353,1479.6580600519665L1280.106732645072,1475.1231395397335"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1185.3914880203083,1262.983546542935L1291.839046932757,1317.8170936577953"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer major_road"
        d="M1259.8528705528006,1464.7486784346402L1280.106732645072,1475.1231395397335"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1165.0753039261326,1294.1577275348827L1176.477863818407,1272.01932928944L1236.5018415777013,1303.087350468617L1250.2008489472792,1309.9757305239327L1249.9168499466032,1310.5208912566304L1275.2874273741618,1323.5672822692432L1275.840436540544,1322.4759224299341L1290.04906434007,1329.8678272222169L1289.7232543751597,1330.5409531374462L1280.9358519501984,1348.434426235035L1278.8595036985353,1352.4388374895789L1257.0673136841506,1341.0935197807848L1261.4117095144466,1332.7028625081293L1258.8320519216359,1331.3628533151932L1260.4973905086517,1328.1387152229436L1258.0029326165095,1326.8486434156075L1259.1231508972123,1324.6804899349809L1258.5488418061286,1324.2976297475398L1258.87465177197,1323.8013680055737L1245.5519430767745,1317.0201610438526L1243.4542949004099,1321.165041938424L1244.4033248964697,1321.6477789105847L1240.4139278177172,1329.520340248011L1202.2878508111462,1310.089132281486L1201.069021766074,1312.4986591273919Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1270.645621479489,1294.263846856542L1270.9359315689653,1293.6833117343485L1283.7135199587792,1268.5683587305248L1285.4569582706317,1269.4610127210617L1285.6060577454045,1269.5317591852508L1294.6624703351408,1251.723394582048L1329.8972797319293,1269.7731294748373L1320.967877808027,1287.3473607557826L1333.8377658724785,1293.9382061953656L1320.6562677929178,1319.8760092146695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1054.884480402805,1513.5621928418986L1056.734418339096,1509.9407245996408L1055.8839991083369,1509.507937693037L1078.5897192433476,1465.0743110761978L1092.0047276131809,1471.977095211856L1086.1440926715732,1483.4366380316205L1087.2422221424058,1483.9963501230814L1086.3847029358149,1485.6682036309503L1088.2204409232363,1486.6045246482827L1088.5959507133812,1485.8669117689133L1095.2644050354138,1489.3115320303477L1090.3890888513997,1498.8495111893862L1092.7770471191034,1505.6742351693101L1101.9541592821479,1510.4016010123305L1098.602182184346,1516.9558220934123L1097.794362803921,1516.5386409037746L1096.8303439728916,1518.430000805296L1098.4601826835424,1519.266443632543L1097.8937624534592,1520.3577724946663L1109.6434322353452,1526.4094948214479L1107.467684334144,1530.6759714926593L1102.585268174298,1540.2284586289898L1061.4535350743681,1519.0323644927703L1061.9071445893496,1518.132460175082L1055.8626991836354,1515.0072424090467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1244.6589239966124,1279.9772587670013L1258.4139422811568,1252.7929173316807L1266.3154255999252,1237.329558248166L1294.4573599454015,1251.7442024187185L1285.4569582706317,1269.4610127210617L1283.7135199587792,1268.5683587305248L1270.9359315689653,1293.6833117343485Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1280.9358519501984,1348.434426235035L1289.7232543751597,1330.5409531374462L1334.4467859519646,1352.7010124269873L1325.6096837026998,1370.6589315216988L1319.5297384224832,1367.639765478205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1217.7295076074079,1349.094025441911L1219.8342557596043,1344.8773751687258L1224.1644516400993,1336.2099816203117L1228.3313480950892,1327.8692566975951L1235.878621547483,1331.6749672801234L1234.0428835591301,1335.345426466316L1234.822303039953,1336.2744851275347L1235.155212980695,1336.3806038033217L1235.736622045748,1336.2037393427454L1237.5723600331694,1332.524957577698L1243.9363043149933,1335.721003387589L1242.1005663285032,1339.406025730539L1242.2922656545416,1340.561886371579L1243.4826948009431,1340.100998668L1245.1054335376248,1336.8550166827627L1252.6527069890872,1340.653439683374L1248.6838209507987,1348.5904828351922L1242.2638657540083,1361.452655766625Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1159.901788789779,1397.6451405254193L1160.0153883909807,1397.425622459501L1167.4561622180045,1383.1246817363426L1177.0237730089575,1364.7059088633396L1178.1574023542926,1362.5304845916107L1190.679391642101,1369.0858858353458L1189.878672237508,1370.6162761864252L1172.4245669646189,1404.2005085651763Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1276.5275563448668,1378.1569029781967L1287.1222968567163,1357.101804501377L1284.5142393633723,1355.78364792699L1286.3073775013909,1352.2193179950118L1304.7823014054447,1361.587904566899L1298.106747109443,1374.8537182719447L1292.3944227574393,1386.2000211100094Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1067.194259326905,1350.745103939902L1070.1778266085312,1344.8492849678732L1077.0868911966681,1331.1787060690112L1077.7747998880222,1329.8251716382802L1094.7752956459299,1338.478007865604L1084.4716541096568,1358.873564684298L1084.19475508295,1359.3979140613228Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1104.3989173499867,1458.994445471093L1117.722414930351,1433.2766798450612L1124.7876789681613,1436.9689328842796L1129.9682940784842,1439.6686771023087L1130.2231042934582,1439.8039243784733L1125.3193882089108,1449.2785095497966L1117.3469051402062,1464.6779339620844L1111.1738712973893,1461.4538578670472L1110.7344617322087,1462.3038322520442Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1134.354500872083,1384.619696345646L1139.6558155594394,1374.4146806905046L1140.2151358136907,1374.7049448778853L1146.678479745984,1362.2610274022445L1158.3074499526992,1368.355543072801L1156.3163014017045,1372.211169376038L1151.8796058958396,1380.7214216734283L1152.3900152118877,1380.9908781461418L1147.0468895621598,1391.2666293447837Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1208.2612964669243,1491.1540026301518L1210.8764539351687,1486.1082745241001L1215.377049215138,1477.4129678634927L1223.2927324846387,1462.1269710059278L1229.2243671761826,1465.2303650509566L1217.2971980171278,1488.2482879040763L1214.1858311835676,1494.2501011923887Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1271.1205309191719,1454.324264459312L1280.2763431593776,1436.714043685235L1281.6442716810852,1434.0777605515905L1290.552373680286,1438.7406726572663L1287.278496307321,1445.0473551261239L1284.2097293231636,1443.4316714303568L1282.0126814963296,1447.6555443033576L1285.0814484804869,1449.2712270119227L1280.028632919304,1458.987162947189Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1059.2785760574043,1406.5735898003913L1061.7020342005417,1401.783731003292L1080.7788782101125,1411.492450909689L1086.8099125511944,1414.5750602707267L1083.6993346046656,1420.7329923138022L1077.4198011364788,1417.5297031230293L1060.7664152681828,1409.047585947439L1061.4535350743681,1407.672218982596Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1121.704712034203,1377.9935644348152L1133.9505911823362,1354.4301182976924L1140.0873362636194,1357.6407192735933L1133.1356718260795,1370.9991338155232L1127.8351460266858,1381.1968718897551Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1192.15381979011,1474.9681261461228L1195.8387068295851,1467.8593538231216L1204.0099891992286,1452.0635586413555L1210.2958337562159,1455.3448589737527L1203.0317704174668,1469.3761977022514L1198.4396643470973,1478.2421331345104Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1185.1090667918324,1410.6206225687638L1189.9354720376432,1401.3301299558952L1196.2994163194671,1389.0912134079263L1202.918170816265,1392.5566891655326L1199.8004928939044,1398.5585852931254L1191.7286101747304,1414.086087564472Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1217.2971980171278,1488.2482879040763L1229.2243671761826,1465.2303650509566L1235.4108120808378,1468.4554797476158L1223.4765429487452,1491.4723515394144Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1066.4992506587878,1439.123526525218L1071.6727657951415,1428.890501232352L1077.4198011364788,1417.5297031230293L1083.6993346046656,1420.7329923138022L1072.7850952167064,1442.3268057382666Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1133.9505911823362,1354.4301182976924L1144.8143418589607,1333.5382873634808L1150.9447758514434,1336.7488980153576L1150.590565986,1337.4293059133925L1143.9994225036353,1350.1219180878252L1140.0873362636194,1357.6407192735933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1192.5364295551553,1384.0672588343732L1194.2514679683372,1380.756794337649L1192.8977393954992,1380.0555832376704L1195.2856976632029,1375.4633770477958L1196.3420161698014,1374.676854794845L1198.8932738620788,1369.943154161796L1198.829374087043,1368.6395652680658L1201.869741170667,1362.792659147177L1202.4716612752527,1361.630559958052L1208.835605558008,1364.953518084716L1199.2616836773232,1383.379572909791L1197.9718548804522,1382.7137347292155L1196.256816469133,1386.0158753194846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1161.8369264276698,1456.4570051203482L1167.6691614687443,1445.210692093242L1172.3109673643485,1436.2458798256703L1178.483212320134,1439.469967642799L1170.595928952098,1454.6852698749863L1168.0162713583559,1459.6821238985285Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1098.4885825831443,1424.0215900372714L1109.1756227705628,1403.3848592373542L1115.1285573877394,1406.4893199405633L1107.736694498919,1420.775647338014L1104.4344172254205,1427.1322836955078Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1149.3851480036974,1449.3492541792803L1154.2612530738115,1439.9381312839687L1159.7747781258076,1429.2795978342183L1165.8334234813228,1432.4547917474993L1161.022007071413,1441.745242651552L1155.444582246244,1452.5171563681215Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1147.0468895621598,1391.2666293447837L1152.3900152118877,1380.9908781461418L1151.8796058958396,1380.7214216734283L1156.3163014017045,1372.211169376038L1163.0131556233391,1375.712026259862L1160.9368073726073,1379.7080987812951L1153.4960335437208,1394.0163291399367L1153.2404344426468,1394.5125858560205Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1198.6305747870356,1387.2632808834314L1200.3527131732553,1383.9538582847454L1199.2616836773232,1383.379572909791L1208.835605558008,1364.953518084716L1214.7672402504832,1368.0652786209248L1213.8316213181242,1369.8578434842639L1211.124953060411,1375.0805196668953L1210.1183343790472,1375.8181443307549L1207.6309764618054,1380.5944962250069L1207.5741766607389,1381.9053654796444L1205.1862183939666,1386.4902848028578L1204.328699188307,1386.0439653540961L1202.6065608020872,1389.3461043592542Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1084.4716541096568,1358.873564684298L1094.7752956459299,1338.478007865604L1100.6785304360092,1341.4826213107444L1092.9048466691747,1356.8822851544246L1090.3819888764992,1361.8781692921184Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1244.063314979896,1502.138071861118L1246.6642724983394,1497.0070426347665L1256.054383913055,1478.567765139509L1261.0574996490031,1481.1332870507613L1251.0512681789696,1500.7845708043315L1249.066430715844,1504.710867526941Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1283.5502205323428,1422.2071914849803L1285.2021480556577,1419.0319928778335L1288.3198259780183,1420.654964825604L1288.7663355180994,1419.797702766955L1291.899002276361,1421.4279570993967L1292.8764321738854,1419.5428129350767L1297.3486275533214,1410.9389751730487L1297.5608379179612,1410.5280298134312L1303.8040826246142,1413.7885424536653L1296.0303988568485,1428.741728996858L1284.5000394145027,1422.6961636184715Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1124.7876789681613,1436.9689328842796L1130.8818241991103,1425.204486085102L1129.854694479145,1424.6738994899206L1134.1280905585736,1416.4102681595832L1134.2693011732772,1416.1335304952227L1140.470734915696,1419.3659505993128L1135.021109639667,1429.8965343809687L1129.9682940784842,1439.6686771023087Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1112.2727896552533,1427.7773102987558L1114.1645385557786,1424.120424805209L1121.556401444599,1409.8476290889084L1128.054456366226,1413.2423494714312L1120.5000829380006,1427.8345303968526L1118.4095347356051,1426.743186970707L1116.680296374485,1430.073396449443Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1173.1826865188777,1404.3628061232157L1183.6851273560897,1384.1515289661475L1189.2554522072896,1387.0645699226297L1187.8307238854468,1389.8142713871785L1186.5763949649408,1389.1546760541387L1183.6354275317863,1394.8174143866636L1184.8897564522922,1395.469726589974L1184.5142466621473,1396.1917435335927L1178.7530113719404,1407.289363378659Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1249.2439300920814,1443.9851445746608L1255.3033643336967,1432.3195443311706L1259.3140613371506,1424.6093968031928L1264.621687112376,1427.4017383651808L1264.1546665336937,1428.2943719034083L1254.8639547685161,1446.167825827375L1254.551555867307,1446.762913255021Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1061.8858446646482,1348.038042455446L1063.4951723366976,1344.8492849678732L1068.087278407067,1335.7636589352041L1071.7792654205114,1328.4716369435191L1077.0868911966681,1331.1787060690112L1070.1778266085312,1344.8492849678732L1067.194259326905,1350.745103939902Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1208.729105932638,1473.932969498448L1209.3744147745892,1472.6855795276351L1216.638478112407,1458.6542474986054L1223.2927324846387,1462.1269710059278L1215.377049215138,1477.4129678634927Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1098.509882508777,1330.335998267401L1100.714030311443,1326.005935091991L1106.9714749688283,1313.6888568792492L1113.5342185506597,1316.9983130181208L1111.464970273897,1321.087013331242L1111.7268804637715,1321.2222629184835L1106.3269550129771,1330.548235796392L1103.5768980197608,1329.1447629919276L1102.0535589335486,1332.143138202373Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1251.0299682542682,1410.1170844277367L1252.2345973495394,1407.785619141534L1260.207080418244,1392.4640961703844L1260.5399903580546,1391.8201066520996L1266.1813149610534,1394.7747592022642L1265.968315708451,1395.178422900848L1262.7512381365523,1401.3727851030417L1261.9363187802956,1400.939991415944L1259.0166512718424,1406.5600650100969L1259.8315706280991,1406.9855757649057L1258.9882513722405,1408.6220753192902L1256.670503968373,1413.072769548744Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.8995633218437,1399.4231325639412L1070.9146462399513,1383.549153557513L1077.11529109627,1386.709803215228L1076.9669805057347,1387.0011072568595L1071.7508655209094,1397.3330295276828L1069.093108203262,1402.5775327668525Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1265.6283057937399,1451.8159525278024L1274.1608980037272,1435.4094269797206L1274.9403174836189,1433.914423323702L1280.2763431593776,1436.714043685235L1271.1205309191719,1454.324264459312L1270.971431444399,1454.6145252995193Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1241.4560463735834,1494.3354103425518L1250.8382689272985,1475.9034082507715L1256.054383913055,1478.567765139509L1246.6642724983394,1497.0070426347665Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1254.8639547685161,1446.167825827375L1264.1546665336937,1428.2943719034083L1269.3912925571203,1431.044057016261L1268.6331730019301,1432.5109714427963L1260.1005807919428,1448.9175038514659Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1153.4960335437208,1394.0163291399367L1160.9368073726073,1379.7080987812951L1167.4561622180045,1383.1246817363426L1160.0153883909807,1397.425622459501Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1118.7637446010485,1431.18658701377L1120.5000829380006,1427.8345303968526L1128.054456366226,1413.2423494714312L1134.1280905585736,1416.4102681595832L1129.854694479145,1424.6738994899206L1127.5653469758108,1429.0881706303917L1123.2777509447187,1426.8493042625487L1122.7965304162353,1427.7773102987558L1124.1565700769424,1428.479556937702L1121.9106113100424,1432.8303634081967Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1116.8293958492577,1465.6766793988645L1117.3469051402062,1464.6779339620844L1125.3193882089108,1449.2785095497966L1130.917324074544,1452.2050478435121L1129.9682940784842,1454.0402457751334L1123.2430399572477,1467.0166626353748L1122.4344316897914,1468.5969686158933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1107.736694498919,1420.775647338014L1115.1285573877394,1406.4893199405633L1121.556401444599,1409.8476290889084L1114.1645385557786,1424.120424805209Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1232.8595543885604,1405.7090434208512L1237.7987703485414,1396.2063087141141L1244.020715130493,1384.2368394690566L1244.3544139554724,1383.5990914176218L1249.5626400811598,1386.3269464527257L1249.3291297908872,1386.7597410515882L1246.1680631330237,1392.8396699978039L1244.6305240960792,1392.0396248963661L1236.5231415024027,1407.6295638736337Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1237.7987703485414,1437.9822474098764L1243.9852152559906,1426.0763125917874L1246.5080730468035,1421.229247114621L1251.9513872349635,1424.0777698014863L1251.5608886079863,1424.828914008569L1249.3078298661858,1429.1661980245262L1243.2412956487387,1440.8380457567982Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1260.1005807919428,1448.9175038514659L1268.6331730019301,1432.5109714427963L1274.1608980037272,1435.4094269797206L1265.6283057937399,1451.8159525278024Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1203.0317704174668,1469.3761977022514L1210.2958337562159,1455.3448589737527L1216.638478112407,1458.6542474986054L1209.3744147745892,1472.6855795276351Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1236.6722409771755,1491.8832921003923L1240.7042379062623,1483.953695484437L1246.0481524439529,1473.4440009789541L1250.8382689272985,1475.9034082507715L1241.4560463735834,1494.3354103425518Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1088.078441423364,1322.6964832493104L1091.0336088072509,1316.8703460246325L1089.6585803097114,1316.1618457888253L1094.2230753656477,1307.1625339980237L1100.848929837346,1310.5562642789446L1094.5914851799607,1322.8733480516821L1093.471266899258,1322.2990576168522L1092.1956380521879,1324.8074164032005Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1111.464970273897,1321.087013331242L1113.5342185506597,1316.9983130181208L1113.9097283408046,1316.2471571285278L1131.860042980872,1325.3817066331394L1129.415284912102,1330.228839118965L1118.4805344864726,1324.6659246017225L1111.7268804637715,1321.2222629184835Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1246.67137247324,1404.87362726219L1254.650955516845,1389.5520978546701L1260.207080418244,1392.4640961703844L1252.2345973495394,1407.785619141534Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1062.205343540758,1307.332116513513L1068.8737978627905,1294.2003833409399L1075.259042069316,1297.4671929972246L1070.2204264588654,1307.3955799080431L1068.5968988360837,1310.5989199848846Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1258.9882513722405,1408.6220753192902L1259.8315706280991,1406.9855757649057L1262.7512381365523,1401.3727851030417L1265.968315708451,1395.178422900848L1272.0987497009337,1398.3962875972502L1265.1107965027913,1411.8326511993073Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1241.3637466989458,1402.0948014296591L1246.1680631330237,1392.8396699978039L1249.3291297908872,1386.7597410515882L1254.650955516845,1389.5520978546701L1246.67137247324,1404.87362726219Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1265.1107965027913,1411.8326511993073L1272.0987497009337,1398.3962875972502L1278.0445843422785,1401.5142753389664L1272.4458595914766,1412.293534136843L1271.0566311450675,1414.9433503267355Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1143.9994225036353,1350.1219180878252L1150.590565986,1337.4293059133925L1156.7841108674183,1340.6752876313403L1152.1423049727455,1349.6183755551465L1150.1929673841223,1353.3668534867465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1206.1423483649269,1421.632909276057L1214.207131108269,1406.1137468544766L1219.281246593222,1408.778130564373L1211.2093638749793,1424.2910448252223Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1277.8954848665744,1415.142060491722L1283.5013095932081,1404.3628061232157L1290.7574840700254,1408.175757298246L1286.5692876921967,1416.2334057437256L1285.1524482294917,1418.9550057370216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1196.3633160945028,1416.5163856111467L1204.4351988136768,1400.9972117356956L1209.445414523594,1403.618942281697L1201.3735318053514,1419.1391506521031Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1193.3868487868458,1337.3231872557662L1200.1050029341131,1323.8793965843506L1200.7140230145305,1324.1842282232828L1203.520879807882,1318.5640878533013L1206.844457006082,1320.2443043044768L1203.9531893990934,1326.034025369212L1204.491209727712,1326.310766630806L1197.858255281113,1339.5839304877445Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1140.5693456791341,1432.7877084570937L1146.0189709551632,1422.2706538289785L1146.082870730199,1422.1364465779625L1153.3469340680167,1425.9348228569143L1147.8334090178832,1436.5860789008439Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1211.2093638749793,1424.2910448252223L1219.281246593222,1408.778130564373L1224.1005518641323,1411.2937406427227L1216.0357691198587,1426.821214393247Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1094.5914851799607,1322.8733480516821L1100.848929837346,1310.5562642789446L1106.9714749688283,1313.6888568792492L1100.714030311443,1326.005935091991Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1201.3735318053514,1419.1391506521031L1209.445414523594,1403.618942281697L1214.207131108269,1406.1137468544766L1206.1423483649269,1421.632909276057Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1216.0357691198587,1426.821214393247L1224.1005518641323,1411.2937406427227L1228.8062575347722,1413.7604525280185L1227.0202193725854,1417.1967856809497L1220.826674491167,1429.095453188289L1220.7343748155981,1429.2795978342183Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1081.998496142216,1315.311853487976L1087.8023312827572,1303.8884462206624L1094.2230753656477,1307.1625339980237L1089.6585803097114,1316.1618457888253L1088.4255513129756,1318.5859358683228Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1191.7286101747304,1414.086087564472L1199.8004928939044,1398.5585852931254L1204.4351988136768,1400.9972117356956L1196.3633160945028,1416.5163856111467Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1075.691351659596,1312.0731425741687L1081.488086826168,1300.6632549706846L1087.8023312827572,1303.8884462206624L1081.998496142216,1315.311853487976Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1070.2204264588654,1307.3955799080431L1075.259042069316,1297.4671929972246L1081.488086826168,1300.6632549706846L1075.691351659596,1312.0731425741687L1074.4717337284237,1314.475386052858L1071.8786650709808,1313.1572213708423L1073.8627136480063,1309.252664218191Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1102.8613783130422,1349.2573646688834L1105.5546355061233,1343.9202274531126L1107.0211747931316,1344.6724207238294L1119.0264436779544,1350.7731941193342L1116.3260865090415,1356.1165683157742L1107.0211747931316,1351.3828550130129Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1123.2430399572477,1467.0166626353748L1129.9682940784842,1454.0402457751334L1135.4108193796128,1456.882512814831L1134.5178002985194,1458.6115927039646L1128.685565257445,1469.857883994002Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1177.0095730582252,1494.8170949001797L1182.884407949634,1483.4792926707305L1185.8395753335208,1477.766689572949L1190.0064717885107,1479.935835541226L1188.9501532809809,1481.9759765225463L1181.1693695383146,1496.9862355315126Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1212.1733827060089,1346.7906298316084L1213.1303015630692,1344.8700925256126L1218.806337153539,1333.5029144571163L1224.1644516400993,1336.2099816203117L1219.8342557596043,1344.8773751687258L1217.7295076074079,1349.094025441911L1217.1125986669213,1348.7891949019395L1216.9145882520825,1349.1720537357032Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1243.2412956487387,1440.8380457567982L1249.3078298661858,1429.1661980245262L1255.3033643336967,1432.3195443311706L1249.2439300920814,1443.9851445746608Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1191.4162112735212,1465.563280183822L1199.6016935929656,1449.7674797736108L1204.0099891992286,1452.0635586413555L1195.8387068295851,1467.8593538231216Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1189.878672237508,1370.6162761864252L1190.679391642101,1369.0858858353458L1195.639907527715,1359.5258802692406L1201.869741170667,1362.792659147177L1198.829374087043,1368.6395652680658L1196.1077169934288,1373.87576722214Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1220.826674491167,1429.095453188289L1227.0202193725854,1417.1967856809497L1232.7814546637237,1420.2086475752294L1226.5950097562745,1432.1145924706943Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1147.8334090178832,1436.5860789008439L1153.3469340680167,1425.9348228569143L1159.7747781258076,1429.2795978342183L1154.2612530738115,1439.9381312839687Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1174.6208259062842,1456.789920677431L1182.8063082247972,1440.9941002759151L1187.1436040801927,1443.26209224388L1178.9652217356488,1459.0579074784182Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1187.079704305157,1463.289053350687L1195.2643977385014,1447.499489930924L1199.6016935929656,1449.7674797736108L1191.4162112735212,1465.563280183822Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1226.5950097562745,1432.1145924706943L1232.7814546637237,1420.2086475752294L1238.4227792648599,1423.1643283944577L1232.235545472242,1435.0692278472707Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1228.3242481201887,1483.0818762555718L1236.0127321863547,1468.1933091911487L1240.5346273919567,1470.5455613438971L1232.845354437828,1485.4278812161647Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1127.8351460266858,1381.1968718897551L1133.1356718260795,1370.9991338155232L1139.6558155594394,1374.4146806905046L1134.354500872083,1384.619696345646Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1232.235545472242,1435.0692278472707L1238.4227792648599,1423.1643283944577L1243.9852152559906,1426.0763125917874L1237.7987703485414,1437.9822474098764Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1207.1205671457574,1344.239623497706L1213.7535215923563,1330.966468556784L1218.806337153539,1333.5029144571163L1213.1303015630692,1344.8700925256126L1212.1733827060089,1346.7906298316084Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1221.7757044853643,1386.171931074001L1227.3318293876946,1375.48522488866L1233.5040743434802,1378.7239061803557L1227.9629382789135,1389.4033247730695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1215.6531593557447,1382.9540607039817L1215.971869344823,1382.3516851942986L1220.6136752404273,1373.4159221067093L1221.202184281312,1372.2819147910923L1227.3318293876946,1375.48522488866L1221.7757044853643,1386.171931074001Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1239.499608810991,1276.3702339492738L1245.445443452336,1264.0894812066108L1251.0299682542682,1266.817383264657L1244.7157237967476,1279.0700407037511Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1178.9652217356488,1459.0579074784182L1187.1436040801927,1443.26209224388L1191.2111008847132,1445.387553770095L1183.0327185401693,1461.1771220001392Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1183.0327185401693,1461.1771220001392L1191.2111008847132,1445.387553770095L1195.2643977385014,1447.499489930924L1187.079704305157,1463.289053350687Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1178.7530113719404,1407.289363378659L1184.5142466621473,1396.1917435335927L1187.0513044055551,1397.5171750173904L1186.108585499227,1399.317014854867L1189.9354720376432,1401.3301299558952L1185.1090667918324,1410.6206225687638Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1170.595928952098,1454.6852698749863L1178.483212320134,1439.469967642799L1178.7743112966418,1438.8967272266746L1182.8063082247972,1440.9941002759151L1174.6208259062842,1456.789920677431Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1227.2821295624599,1390.706909764558L1227.9629382789135,1389.4033247730695L1233.5040743434802,1378.7239061803557L1238.7698891544715,1381.4798531862907L1232.540844399482,1393.4638923802413Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1232.540844399482,1393.4638923802413L1238.7698891544715,1381.4798531862907L1244.020715130493,1384.2368394690566L1237.7987703485414,1396.2063087141141Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1109.4304329855368,1339.924134306144L1112.0739903533831,1334.6795836733654L1113.1374088358134,1335.2257828419097L1124.0721592614427,1340.788688887842L1122.016322048381,1344.8565676119179L1121.4215019196272,1346.0321945208125Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1096.759344222024,1365.1314221858047L1099.2822020146996,1360.14178264793L1101.9186594076455,1361.4817862780765L1111.2235711235553,1366.2154926862568L1111.7623803392053,1366.4984745946713L1109.2395225455984,1371.4881095606834Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1197.858255281113,1339.5839304877445L1204.491209727712,1326.310766630806L1209.2040153732523,1328.6776322484948L1202.5639609508216,1341.9507915712893Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1161.022007071413,1441.745242651552L1165.8334234813228,1432.4547917474993L1172.4805778777227,1435.9202458304353L1172.3109673643485,1436.2458798256703L1167.6691614687443,1445.210692093242Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1115.6247667539865,1330.31415028451L1118.4805344864726,1324.6659246017225L1129.415284912102,1330.228839118965L1126.5595171796158,1335.877060272731Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1158.8959589945152,1353.1618992919102L1163.2119549252093,1344.8700925256126L1163.537764889188,1344.2250582082197L1163.9771744553,1343.3896346390247L1170.2346191108227,1346.6772286714986L1169.9790200097486,1347.17348877294L1165.1676036017016,1356.435963800177Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1209.1827154485509,1378.8008937658742L1211.124953060411,1375.0805196668953L1213.8316213181242,1369.8578434842639L1220.6136752404273,1373.4159221067093L1215.971869344823,1382.3516851942986Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1279.2350134896114,1432.823080856353L1281.8990818960592,1427.69928288972L1293.7836512038484,1433.9362709801644L1291.1258938852698,1439.0382166975178L1290.552373680286,1438.7406726572663L1281.6442716810852,1434.0777605515905Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1152.1423049727455,1349.6183755551465L1156.7841108674183,1340.6752876313403L1163.537764889188,1344.2250582082197L1163.2119549252093,1344.8700925256126L1158.8959589945152,1353.1618992919102Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1128.6287654573098,1469.9712831387296L1128.685565257445,1469.857883994002L1134.5178002985194,1458.6115927039646L1139.8041261481121,1461.3685483145528L1133.9150913069025,1472.728234232869Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1202.5639609508216,1341.9507915712893L1209.2040153732523,1328.6776322484948L1213.7535215923563,1330.966468556784L1207.1205671457574,1344.239623497706Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1281.8990818960592,1427.69928288972L1284.5000394145027,1422.6961636184715L1296.0303988568485,1428.741728996858L1296.3917086971924,1428.9321158421226L1293.7836512038484,1433.9362709801644Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1085.1516739400104,1448.9882484860718L1087.7171315820888,1443.8998348070309L1088.0358415730298,1444.0694139776751L1098.3118720948696,1449.2993167927489L1099.5307011408731,1449.9162515588105L1096.958143522963,1454.9973782906309Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1165.1676036017016,1356.435963800177L1169.9790200097486,1347.17348877294L1170.2346191108227,1346.6772286714986L1176.251453503035,1349.8170875930227L1171.1702380431816,1359.5893431860022Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1272.4458595914766,1412.293534136843L1278.0445843422785,1401.5142753389664L1283.5013095932081,1404.3628061232157L1277.8954848665744,1415.142060491722Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1135.021109639667,1429.8965343809687L1140.470734915696,1419.3659505993128L1146.0189709551632,1422.2706538289785L1140.5693456791341,1432.7877084570937Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1085.5058838054538,1281.7282309122384L1091.4304185211658,1269.8865318899043L1096.4051343565807,1272.3949096407741L1090.4805996399373,1284.23660437949Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1133.9150913069025,1472.728234232869L1139.8041261481121,1461.3685483145528L1144.9279414601624,1464.0537179918028L1139.046006592922,1475.4144398700446Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1139.046006592922,1475.4144398700446L1144.9279414601624,1464.0537179918028L1150.0588567452505,1466.7253619520925L1144.1698219031096,1478.0860794526525Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1144.1698219031096,1478.0860794526525L1150.0588567452505,1466.7253619520925L1155.1897720303386,1469.398045244161L1149.300737189129,1480.7577180070803Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1161.985237017274,1486.980093375314L1167.8600719086826,1475.633955463767L1172.9341873936355,1478.2702227956615L1167.0593525022268,1489.6225985297933Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1167.0593525022268,1489.6225985297933L1172.9341873936355,1478.2702227956615L1178.0154028553516,1480.9272962762043L1172.1405679630116,1492.273425522726Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1189.5599622484297,1335.402647327166L1197.3265460403636,1319.8541612019762L1200.7495228899643,1321.5759925968014L1199.7010932443663,1323.6744415173307L1200.1050029341131,1323.8793965843506L1193.3868487868458,1337.3231872557662Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1076.0526614999399,1276.9726186674088L1076.428171291016,1276.2214584406465L1081.9771962165833,1265.1236287942156L1086.8454124266282,1267.568544510752L1080.920877710916,1279.417530204635Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1107.0211747931316,1344.6724207238294L1109.4304329855368,1339.924134306144L1121.4215019196272,1346.0321945208125L1120.8471928276122,1347.1662061316893L1119.0264436779544,1350.7731941193342Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1090.5515993908048,1439.0943963420577L1093.1454569334164,1433.9570782706141L1101.6283493172377,1438.2797914813273L1101.4721498666331,1438.5919006345794L1106.0571559621021,1440.9379206500016L1104.5764167262241,1443.8498973818496L1099.998510606587,1441.5038783522323L1099.034491774626,1443.4108641697094Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1067.4064696906134,1271.6791221369058L1073.4588039582595,1259.5752275069244L1078.1219097776338,1261.9275504397228L1072.069575510919,1274.0251986356452Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1090.4805996399373,1284.23660437949L1096.4051343565807,1272.3949096407741L1101.039840276353,1274.7264204565436L1095.1153055597097,1286.5753939179704Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1095.1153055597097,1286.5753939179704L1101.039840276353,1274.7264204565436L1105.6745461970568,1277.0579304881394L1099.7500114804134,1288.9068999649025Z"
      />
      <path
        fill="none"
        stroke="rgb(151, 215, 247)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1.5px"
        className="roads-layer minor_road"
        d="M1108.8356128558517,1387.4182962407358L1075.1651646215469,1453.1517769959755"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1149.300737189129,1480.7577180070803L1155.1897720303386,1469.398045244161L1155.891091786325,1468.0434974394739L1160.1289879903197,1470.2625836827792L1153.5449444828555,1482.9757598242722Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1080.920877710916,1279.417530204635L1086.8454124266282,1267.568544510752L1091.4304185211658,1269.8865318899043L1085.5058838054538,1281.7282309122384Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1242.2638657540083,1361.452655766625L1248.6838209507987,1348.5904828351922L1252.8862172793597,1350.7024484812282L1246.466262084432,1363.5646174987778Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1157.6345300981775,1485.1084916740656L1164.2106847446412,1472.3953194436617L1168.405981099233,1474.5779917496257L1167.8600719086826,1475.633955463767L1161.985237017274,1486.980093375314L1161.8227264788002,1487.2911599781364Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1113.1374088358134,1335.2257828419097L1115.6247667539865,1330.31415028451L1126.5595171796158,1335.877060272731L1124.0721592614427,1340.788688887842Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1249.3078298661858,1429.1661980245262L1251.5608886079863,1424.828914008569L1252.1422976749018,1425.141023768112L1254.665155466646,1420.2939576371573L1260.0863808421418,1423.1351981428452L1259.3140613371506,1424.6093968031928L1255.3033643336967,1432.3195443311706Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1153.5449444828555,1482.9757598242722L1160.1289879903197,1470.2625836827792L1164.2106847446412,1472.3953194436617L1157.6345300981775,1485.1084916740656Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1072.069575510919,1274.0251986356452L1078.1219097776338,1261.9275504397228L1081.998496142216,1263.8834839831106L1081.502286775969,1264.8832987351343L1081.9771962165833,1265.1236287942156L1076.428171291016,1276.2214584406465Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1088.0358415730298,1444.0694139776751L1090.5515993908048,1439.0943963420577L1099.034491774626,1443.4108641697094L1100.8205299368128,1444.3253432698548L1098.3118720948696,1449.2993167927489Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1104.4060173248872,1356.549364800565L1107.0211747931316,1351.3828550130129L1116.3260865090415,1356.1165683157742L1113.7038290649652,1361.2976398323663Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1101.9186594076455,1361.4817862780765L1104.4060173248872,1356.549364800565L1113.7038290649652,1361.2976398323663L1111.2235711235553,1366.2154926862568Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1071.7508655209094,1397.3330295276828L1076.9669805057347,1387.0011072568595L1081.3673872519284,1389.2472690921277L1076.14417229034,1399.572945799213Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1076.14417229034,1399.572945799213L1081.3673872519284,1389.2472690921277L1085.5271837301552,1391.3592223543674L1080.3047576555982,1401.6911381306127Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1080.3047576555982,1401.6911381306127L1085.5271837301552,1391.3592223543674L1089.6798802344128,1393.4711749730632L1084.4645541347563,1403.8030876023695Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1173.6362960347906,1362.9268675437197L1179.5537307765335,1351.5597190828994L1182.941207749769,1353.3252384224907L1178.1574023542926,1362.5304845916107L1177.0237730089575,1364.7059088633396Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1170.3340187622234,1361.1977637913078L1171.1702380431816,1359.5893431860022L1176.251453503035,1349.8170875930227L1179.5537307765335,1351.5597190828994L1173.6362960347906,1362.9268675437197Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1090.3819888764992,1361.8781692921184L1092.9048466691747,1356.8822851544246L1099.2822020146996,1360.14178264793L1096.759344222024,1365.1314221858047Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1289.6096547748893,1417.827248070389L1294.0881612431258,1409.231731126085L1297.3486275533214,1410.9389751730487L1292.8764321738854,1419.5428129350767Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1080.7788782101125,1411.492450909689L1082.9901259867474,1407.1197833078913L1089.021160329692,1410.2023946135305L1086.8099125511944,1414.5750602707267Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1286.5692876921967,1416.2334057437256L1290.7574840700254,1408.175757298246L1291.0414830707014,1407.6295638736337L1294.0881612431258,1409.231731126085L1289.6096547748893,1417.827248070389Z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1100.8560298122466,1457.0739392489195L1103.2936879042536,1452.2404201426543L1106.702464803122,1453.9695011926815L1104.2577067352831,1458.8103016144596Z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1228.4575698729604,1311.5092550711706m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1236.2430869312957,1342.765407747589m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1171.6987917385995,1390.2751557859592m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1291.4856259543449,1368.2213347791694m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1082.4765611272305,1341.6636471468955m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1119.8287408547476,1444.5406984011643m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1145.6947387615219,1377.7137041129172m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1203.0656925207004,1461.602629401721m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1191.733343492262,1405.9753778185695m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1226.3520328337327,1478.3513707108796m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1201.3151542320848,1372.3100048843771m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1169.131756324321,1449.948502783198m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1157.6416300721467,1440.842207210604m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1153.6577551970258,1386.1292758332565m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1205.4118398241699,1378.205800503958m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1093.0791905000806,1349.1824575080536m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1132.951072475873,1427.5505106276833m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1121.1098919035867,1418.6813892717473m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1181.159114019014,1395.8307350696996m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1255.6520519955084,1438.1528670890257m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1216.3331791860983,1467.4057570975274m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1106.13525568787,1323.6140994164161m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1257.2929351124913,1403.9664255399257m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1272.9531133631244,1444.265002218075m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1261.7477749995887,1439.3388818143867m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1160.4753089947626,1388.5699873915873m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1128.1333449771628,1420.5415648734197m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1123.655627394095,1459.3596120900474m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1114.6449702000245,1415.3116403650492m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1241.0063812891021,1394.5229895599186m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1243.5529056657106,1433.5742241195403m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1267.1303449552506,1442.1634687040932m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1209.8351242644712,1464.0152246705256m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1095.2525717429817,1313.3590555991977m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1253.4408042188734,1398.6688644932583m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1265.1912628868595,1404.1786608174443m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1247.1470707999542,1397.4672372578643m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1271.579662637785,1406.6734651904553m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1150.522721780464,1345.1468330351636m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1212.7098252633587,1415.2055228990503m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1284.3272733548656,1411.6589097715914m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1202.903970866464,1410.0681871292181m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1198.9390292577446,1331.8164589386433m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1146.9593232022598,1429.361786684487m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1217.6577189704403,1417.7918755952269m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1100.7810856308788,1318.2811039863154m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1207.791909228079,1412.6264518126845m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1221.5248387018219,1422.0084815225564m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1088.1123635265976,1311.236674748361m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1198.0807211650535,1407.541132553015m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1081.746841470711,1307.9802754139528m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1075.8530733138323,1304.0299384468235m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1110.939572121948,1350.0147592443973m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1128.8796312417835,1462.8136087632738m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1218.646982157603,1340.5400384226814m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1249.2731188777834,1436.5787963508628m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1197.7162557803094,1458.8134226985276m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1196.3885604506359,1365.7161128218286m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1226.8056423496455,1424.65205180645m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1153.8044880134985,1432.9333595125936m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1180.8837927645072,1450.0265299421735m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1193.34109339118,1456.5277496790513m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1232.5085000684485,1427.6389416931197m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1133.7454807916656,1377.8052569343708m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1238.1103803636506,1430.572771678213m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1212.9646354783326,1338.87127105752m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1227.6418616296723,1382.4473994383588m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1221.6510604806244,1378.9184558908455m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1245.1906332382932,1271.593810251914m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1185.086977981031,1452.2227339949459m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1189.1473748097196,1454.3388295196928m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1184.3438472608104,1404.3097473070957m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1176.7019074745476,1447.8396884561516m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1233.364441501908,1385.4415901107714m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1238.2807797640562,1388.8498472757638m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1116.7505072373897,1340.355891420506m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1103.9910632297397,1365.6734574586153m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1203.5295575540513,1334.1302633211017m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1166.6664872178808,1438.995561781805m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1122.5196313895285,1330.2714947033674m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1164.439461717382,1350.1676946789958m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1214.4682524120435,1376.9407069645822m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1286.5132767762989,1433.3796759392135m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1157.6747632892802,1347.2442344459705m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1134.244845702313,1465.6132174558006m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1208.1603190442547,1336.4586322405376m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1288.9643459329382,1428.2205059630796m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1092.6453031376004,1449.6083043632098m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1170.7087396662682,1353.1265264865942m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1277.9720068201423,1408.3276510802098m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1140.5188569677994,1426.083595150616m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1090.9555090805516,1277.061051653698m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1139.4230941552669,1468.390977469273m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1144.5508538959548,1471.0699022724293m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1149.679402523674,1473.7415435290895m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1081.636397415772,1271.895523019135m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1114.2229161290452,1345.3517874665558m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1096.3215124290437,1438.8436686731875m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1095.7614032868296,1279.480993855279m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1100.3953203214332,1281.816663837526m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1240.7823376320302,1477.3734342590906m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1154.7164403628558,1475.510152832605m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1086.1748592304066,1274.651512491051m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1247.5746470745653,1356.0780743984506m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1119.8484630081803,1335.5514215654694m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1158.8793923854828,1477.685541650746m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1077.0237803058699,1269.5744151431136m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1094.4289746405557,1444.197378626559m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1110.3660519169644,1356.3329665628262m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1107.8116386793554,1361.3891928675584m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1076.5567597271875,1393.2901504891925m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1080.8364668954164,1395.4655651077628m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1084.9938967162743,1397.5806375839747m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1178.3940681898966,1357.927863035351m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1175.3608010811731,1355.574532296043m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1094.832095446065,1361.0104962126352m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="none"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer address"
        d="M1084.9000192694366,1410.847422791645m0,4.5a4.5,4.5 0 1,1 0,-9a4.5,4.5 0 1,1 0,9z"
      />
      <path
        fill="none"
        stroke="rgb(104, 197, 243)"
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeWidth="1px"
        className="buildings-layer building"
        d="M1235.517311707139,1481.3028653110377L1240.8675373326987,1470.779642120935L1246.0481524439529,1473.4440009789541L1240.7042379062623,1483.953695484437Z"
      />
    </g>
    <path
      d="M975.585257532075,753.6717146979645L971.0712149785832,848.466608311981L879.6618532752618,845.0810764003545L814.2082362547517,840.567033843603L656.2167468937114,781.884480654262L528.6950447643176,1131.7227785256691L447.4422788079828,1101.2529912916943"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
      stroke="#1295D8"
      strokeWidth="3px"
    />
    <path
      d="M975.585257532075,753.6717146979645L980.9996015932411,665.0840637455694L977.8298804778606,635.5L980.9996015932411,523.5031872498803L976.7733067721128,501.31513944268227L973.6035856576636,501.31513944268227L970.4338645422831,489.69282868597656L973.9400317845866,396.2874816409312L975.5067596081644,355.4771168050356L981.6293047387153,246.90878509450704L984.747771547176,199.00307543296367L984.0669628307223,184.78706860728562L982.9759333347902,179.61344214202836L982.9759333347902,179.61344214202836L981.3531945990399,171.9175095469691L977.2991088582203,159.05521047767252L972.5586922001094,147.54665309982374L965.1100295102224,136.03807661077008L961.3825426213443,128.8800653750077L944.2755472389981,109.767025757581L924.0003852210939,92.92236723052338L910.5143771022558,82.54791854834184"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
      stroke="#1295D8"
      strokeWidth="3px"
    />
    <path
      d="M975.585257532075,753.6717146979645L971.0712149785832,848.466608311981L879.6618532752618,845.0810764003545L814.2082362547517,840.567033843603L656.2167468937114,781.884480654262L507.6545816734433,727.4219123506919L384.03545816708356,686.2155378484167L263.58605577703565,639.7262948211282L235.0585657376796,629.160557769239L219.20996015984565,613.3119521918707L219.20996015984565,602.7462151399814"
      strokeLinejoin="round"
      strokeLinecap="round"
      fill="none"
      stroke="#1295D8"
      strokeWidth="3px"
    />
    <path
      d="M975.585257532075,753.6717146979645L971.0712149785832,848.466608311981L879.6618532752618,845.0810764003545L814.2082362547517,840.567033843603L656.2167468937114,781.884480654262L528.6950447643176,1131.7227785256691L447.4422788079828,1101.2529912916943"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeOpacity="0"
      fill="none"
      stroke="hsla(200, 85%, 30%, 1)"
      strokeWidth="3px"
      ref={a => this.path1 = a}
    />
    <path
      d="M975.585257532075,753.6717146979645L980.9996015932411,665.0840637455694L977.8298804778606,635.5L980.9996015932411,523.5031872498803L976.7733067721128,501.31513944268227L973.6035856576636,501.31513944268227L970.4338645422831,489.69282868597656L973.9400317845866,396.2874816409312L975.5067596081644,355.4771168050356L981.6293047387153,246.90878509450704L984.747771547176,199.00307543296367L984.0669628307223,184.78706860728562L982.9759333347902,179.61344214202836L982.9759333347902,179.61344214202836L981.3531945990399,171.9175095469691L977.2991088582203,159.05521047767252L972.5586922001094,147.54665309982374L965.1100295102224,136.03807661077008L961.3825426213443,128.8800653750077L944.2755472389981,109.767025757581L924.0003852210939,92.92236723052338L910.5143771022558,82.54791854834184"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeOpacity="0"
      fill="none"
      stroke="hsla(200, 85%, 30%, 1)"
      strokeWidth="3px"
      ref={a => this.path2 = a}
    />
    <path
      d="M975.585257532075,753.6717146979645L971.0712149785832,848.466608311981L879.6618532752618,845.0810764003545L814.2082362547517,840.567033843603L656.2167468937114,781.884480654262L507.6545816734433,727.4219123506919L384.03545816708356,686.2155378484167L263.58605577703565,639.7262948211282L235.0585657376796,629.160557769239L219.20996015984565,613.3119521918707L219.20996015984565,602.7462151399814"
      strokeLinejoin="round"
      strokeLinecap="round"
      strokeOpacity="0"
      fill="none"
      stroke="hsla(200, 85%, 30%, 1)"
      strokeWidth="3px"
      ref={a => this.path3 = a}
    />
    <text
      textAnchor="middle"
      x="605.4337681699544"
      y="1162.1925657605752"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,605.4337681699544,1162.1925657605752)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Atlantic Ave.
    </text>
    <text
      textAnchor="middle"
      x="256.4911929545924"
      y="1036.80344275292"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,256.4911929545924,1036.80344275292)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Atlantic Ave.
    </text>
    <text
      textAnchor="middle"
      x="631.3895128499717"
      y="1095.6104380995966"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,631.3895128499717,1095.6104380995966)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      State St.
    </text>
    <text
      textAnchor="middle"
      x="280.9091273015365"
      y="966.7345876712352"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,280.9091273015365,966.7345876712352)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      State St.
    </text>
    <text
      textAnchor="middle"
      x="655.0882362546399"
      y="1029.0283104423434"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,655.0882362546399,1029.0283104423434)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Schermerhorn St.
    </text>
    <text
      textAnchor="middle"
      x="678.2227043407038"
      y="964.703204059042"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,678.2227043407038,964.703204059042)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Livingston St.
    </text>
    <text
      textAnchor="middle"
      x="709.8210022104904"
      y="881.1934168227017"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(11,709.8210022104904,881.1934168227017)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Joralemon St.
    </text>
    <text
      textAnchor="middle"
      x="342.4847878301516"
      y="802.1789431539364"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(12,342.4847878301516,802.1789431539364)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Joralemon St.
    </text>
    <text
      textAnchor="middle"
      x="580.0422788085416"
      y="758.1857572505251"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,580.0422788085416,758.1857572505251)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Remsen St.
    </text>
    <text
      textAnchor="middle"
      x="271.9588745525107"
      y="715.8666083123535"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,271.9588745525107,715.8666083123535)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Grace Ct.
    </text>
    <text
      textAnchor="middle"
      x="541.6729171061888"
      y="794.862352993805"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,541.6729171061888,794.862352993805)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hunts Ln.
    </text>
    <text
      textAnchor="middle"
      x="628.0039809355512"
      y="618.2504381001927"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,628.0039809355512,618.2504381001927)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pierrepont St.
    </text>
    <text
      textAnchor="middle"
      x="512.4244402982295"
      y="523.5569029841572"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(24,512.4244402982295,523.5569029841572)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Love Ln.
    </text>
    <text
      textAnchor="middle"
      x="683.6220529563725"
      y="716.4308636323549"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,683.6220529563725,716.4308636323549)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Clinton St.
    </text>
    <text
      textAnchor="middle"
      x="504.4320660419762"
      y="1206.7687359726988"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,504.4320660419762,1206.7687359726988)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Clinton St.
    </text>
    <text
      textAnchor="middle"
      x="775.8388745523989"
      y="953.4180976748466"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,775.8388745523989,953.4180976748466)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Court St.
    </text>
    <text
      textAnchor="middle"
      x="533.7733426382765"
      y="664.5193742685951"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,533.7733426382765,664.5193742685951)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Henry St.
    </text>
    <text
      textAnchor="middle"
      x="356.5971724251285"
      y="1152.6002253359184"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,356.5971724251285,1152.6002253359184)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Henry St.
    </text>
    <text
      textAnchor="middle"
      x="685.5960820904002"
      y="248.95615671714768"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,685.5960820904002,248.95615671714768)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Henry St.
    </text>
    <text
      textAnchor="middle"
      x="508.3818532759324"
      y="946.6470338446088"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,508.3818532759324,946.6470338446088)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Sidney Pl.
    </text>
    <text
      textAnchor="middle"
      x="379.73164051026106"
      y="894.7355444845743"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,379.73164051026106,894.7355444845743)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Garden Pl.
    </text>
    <text
      textAnchor="middle"
      x="248.82440646737814"
      y="858.6232040575705"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,248.82440646737814,858.6232040575705)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Willow Pl.
    </text>
    <text
      textAnchor="middle"
      x="194.65589582920074"
      y="841.6955444831401"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,194.65589582920074,841.6955444831401)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Columbia Pl.
    </text>
    <text
      textAnchor="middle"
      x="409.6371724251658"
      y="621.6359700150788"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,409.6371724251658,621.6359700150788)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hicks St.
    </text>
    <text
      textAnchor="middle"
      x="235.8465341264382"
      y="1108.5883104419336"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,235.8465341264382,1108.5883104419336)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hicks St.
    </text>
    <text
      textAnchor="middle"
      x="563.138992536813"
      y="204.4263059697114"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,563.138992536813,204.4263059697114)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hicks St.
    </text>
    <text
      textAnchor="middle"
      x="493.87033582199365"
      y="178.45055970177054"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,493.87033582199365,178.45055970177054)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Willow St.
    </text>
    <text
      textAnchor="middle"
      x="427.07555970177054"
      y="154.94869403075427"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,427.07555970177054,154.94869403075427)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Columbia Heights
    </text>
    <text
      textAnchor="middle"
      x="328.1203358210623"
      y="258.85167910391465"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,328.1203358210623,258.85167910391465)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Furman St.
    </text>
    <text
      textAnchor="middle"
      x="150.0009328359738"
      y="757.3386194021441"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,150.0009328359738,757.3386194021441)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Furman St.
    </text>
    <text
      textAnchor="middle"
      x="671.9897388061509"
      y="505.00279850838706"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-70,671.9897388061509,505.00279850838706)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Monroe Pl.
    </text>
    <text
      textAnchor="middle"
      x="760.0397256165743"
      y="744.6436295891181"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,760.0397256165743,744.6436295891181)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Montague St.
    </text>
    <text
      textAnchor="middle"
      x="311.57096247933805"
      y="580.8809135388583"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,311.57096247933805,580.8809135388583)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Montague St.
    </text>
    <text
      textAnchor="middle"
      x="579.4780234880745"
      y="1232.160225335043"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,579.4780234880745,1232.160225335043)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pacific St.
    </text>
    <text
      textAnchor="middle"
      x="329.744995996356"
      y="1219.4071256997995"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,329.744995996356,1219.4071256997995)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Amity St.
    </text>
    <text
      textAnchor="middle"
      x="1034.267810722813"
      y="641.949161503464"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1034.267810722813,641.949161503464)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Johnson St.
    </text>
    <text
      textAnchor="middle"
      x="1183.3132137032226"
      y="364.5676998361014"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1183.3132137032226,364.5676998361014)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Concord St.
    </text>
    <text
      textAnchor="middle"
      x="1185.4763458408415"
      y="407.83034257637337"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1185.4763458408415,407.83034257637337)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Chapel St.
    </text>
    <text
      textAnchor="middle"
      x="1184.3947797715664"
      y="453.2561174542643"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1184.3947797715664,453.2561174542643)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cathedral St.
    </text>
    <text
      textAnchor="middle"
      x="1181.1500815656036"
      y="517.0685154972598"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1181.1500815656036,517.0685154972598)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Tillary St.
    </text>
    <text
      textAnchor="middle"
      x="970.2446982059628"
      y="526.8026101142168"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,970.2446982059628,526.8026101142168)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Tillary St.
    </text>
    <text
      textAnchor="middle"
      x="1051.3621533438563"
      y="50.913539967965335"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1051.3621533438563,50.913539967965335)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Prospect St.
    </text>
    <text
      textAnchor="middle"
      x="1048.1174551388249"
      y="121.2153344200924"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1048.1174551388249,121.2153344200924)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Sands St.
    </text>
    <text
      textAnchor="middle"
      x="1206.3656830629334"
      y="933.1049061864614"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1206.3656830629334,933.1049061864614)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Willoughby St.
    </text>
    <text
      textAnchor="middle"
      x="1080.536746893078"
      y="1009.84362958977"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(28,1080.536746893078,1009.84362958977)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Fulton St.
    </text>
    <text
      textAnchor="middle"
      x="1121.7273851912469"
      y="1155.4215019312687"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(28,1121.7273851912469,1155.4215019312687)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Livingston St.
    </text>
    <text
      textAnchor="middle"
      x="1095.771640509367"
      y="1222.003629589919"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(28,1095.771640509367,1222.003629589919)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Schermerhorn St.
    </text>
    <text
      textAnchor="middle"
      x="1097.4644064670429"
      y="704.0172466123477"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1097.4644064670429,704.0172466123477)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Jay St.
    </text>
    <text
      textAnchor="middle"
      x="1110.8482871130109"
      y="359.15986949391663"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1110.8482871130109,359.15986949391663)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Jay St.
    </text>
    <text
      textAnchor="middle"
      x="979.5350447650999"
      y="694.4249061867595"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,979.5350447650999,694.4249061867595)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Adams St.
    </text>
    <text
      textAnchor="middle"
      x="1003.7732463292778"
      y="187.19086460210383"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1003.7732463292778,187.19086460210383)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Adams St.
    </text>
    <text
      textAnchor="middle"
      x="981.0603588912636"
      y="351.5889070141129"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,981.0603588912636,351.5889070141129)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Brooklyn Bridge Blvd.
    </text>
    <text
      textAnchor="middle"
      x="885.8825448611751"
      y="278.0424143560231"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,885.8825448611751,278.0424143560231)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cadman Plaza E.
    </text>
    <text
      textAnchor="middle"
      x="944.5512149780989"
      y="988.9661827823147"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-79,944.5512149780989,988.9661827823147)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Boerum Pl.
    </text>
    <text
      textAnchor="middle"
      x="897.1537681696936"
      y="1122.1304380991496"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-62,897.1537681696936,1122.1304380991496)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Boerum Pl.
    </text>
    <text
      textAnchor="middle"
      x="1007.74781072326"
      y="1176.298948738724"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-62,1007.74781072326,1176.298948738724)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Smith St.
    </text>
    <text
      textAnchor="middle"
      x="1020.1614277446643"
      y="858.0589487394318"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1020.1614277446643,858.0589487394318)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pearl St.
    </text>
    <text
      textAnchor="middle"
      x="1176.4601511480287"
      y="705.1457572504878"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1176.4601511480287,705.1457572504878)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Lawrence St.
    </text>
    <text
      textAnchor="middle"
      x="1257.7129171052948"
      y="707.4027785258368"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1257.7129171052948,707.4027785258368)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Bridge St.
    </text>
    <text
      textAnchor="middle"
      x="1319.21674689278"
      y="1025.642778526526"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1319.21674689278,1025.642778526526)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Duffield St.
    </text>
    <text
      textAnchor="middle"
      x="1393.6984490212053"
      y="1033.5423529953696"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(-88,1393.6984490212053,1033.5423529953696)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Albee Square W.
    </text>
    <text
      textAnchor="middle"
      x="1204.1086617875844"
      y="771.7278849091381"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1204.1086617875844,771.7278849091381)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Myrtle Promenade
    </text>
    <text
      textAnchor="middle"
      x="1204.1086617875844"
      y="841.6955444831401"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(2.5,1204.1086617875844,841.6955444831401)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      MetroTech Center
    </text>
    <text
      textAnchor="middle"
      x="801.2303639147431"
      y="622.2002253346145"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(77,801.2303639147431,622.2002253346145)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cadman Plaza W.
    </text>
    <text
      textAnchor="middle"
      x="570.5606343280524"
      y="362.75466417800635"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,570.5606343280524,362.75466417800635)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Clark St.
    </text>
    <text
      textAnchor="middle"
      x="592.8255597017705"
      y="294.7229477609508"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,592.8255597017705,294.7229477609508)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pineapple St.
    </text>
    <text
      textAnchor="middle"
      x="620.0382462693378"
      y="227.928171641659"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,620.0382462693378,227.928171641659)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Orange St.
    </text>
    <text
      textAnchor="middle"
      x="643.5401119412854"
      y="159.8964552236721"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,643.5401119412854,159.8964552236721)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cranberry St.
    </text>
    <text
      textAnchor="middle"
      x="668.2789179105312"
      y="93.10167910251766"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,668.2789179105312,93.10167910251766)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Middagh St.
    </text>
    <text
      textAnchor="middle"
      x="895.6166394781321"
      y="74.70799347665161"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(42,895.6166394781321,74.70799347665161)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Brooklyn Bridge
    </text>
    <text
      textAnchor="middle"
      x="1162.4526462396607"
      y="172.56963788205758"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(67,1162.4526462396607,172.56963788205758)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Manhattan Bridge
    </text>
    <text
      textAnchor="middle"
      x="693.0177238807082"
      y="25.06996268685907"
      fill="rgb(255, 255, 255)"
      stroke="#42b6f0"
      strokeWidth="2px"
      transform="rotate(19,693.0177238807082,25.06996268685907)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Poplar St.
    </text>
    <text
      textAnchor="middle"
      x="605.4337681699544"
      y="1162.1925657605752"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,605.4337681699544,1162.1925657605752)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Atlantic Ave.
    </text>
    <text
      textAnchor="middle"
      x="256.4911929545924"
      y="1036.80344275292"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,256.4911929545924,1036.80344275292)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Atlantic Ave.
    </text>
    <text
      textAnchor="middle"
      x="631.3895128499717"
      y="1095.6104380995966"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,631.3895128499717,1095.6104380995966)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      State St.
    </text>
    <text
      textAnchor="middle"
      x="280.9091273015365"
      y="966.7345876712352"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,280.9091273015365,966.7345876712352)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      State St.
    </text>
    <text
      textAnchor="middle"
      x="655.0882362546399"
      y="1029.0283104423434"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,655.0882362546399,1029.0283104423434)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Schermerhorn St.
    </text>
    <text
      textAnchor="middle"
      x="678.2227043407038"
      y="964.703204059042"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,678.2227043407038,964.703204059042)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Livingston St.
    </text>
    <text
      textAnchor="middle"
      x="709.8210022104904"
      y="881.1934168227017"
      fill="rgb(255, 255, 255)"
      transform="rotate(11,709.8210022104904,881.1934168227017)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Joralemon St.
    </text>
    <text
      textAnchor="middle"
      x="342.4847878301516"
      y="802.1789431539364"
      fill="rgb(255, 255, 255)"
      transform="rotate(12,342.4847878301516,802.1789431539364)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Joralemon St.
    </text>
    <text
      textAnchor="middle"
      x="580.0422788085416"
      y="758.1857572505251"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,580.0422788085416,758.1857572505251)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Remsen St.
    </text>
    <text
      textAnchor="middle"
      x="271.9588745525107"
      y="715.8666083123535"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,271.9588745525107,715.8666083123535)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Grace Ct.
    </text>
    <text
      textAnchor="middle"
      x="541.6729171061888"
      y="794.862352993805"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,541.6729171061888,794.862352993805)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hunts Ln.
    </text>
    <text
      textAnchor="middle"
      x="628.0039809355512"
      y="618.2504381001927"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,628.0039809355512,618.2504381001927)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pierrepont St.
    </text>
    <text
      textAnchor="middle"
      x="512.4244402982295"
      y="523.5569029841572"
      fill="rgb(255, 255, 255)"
      transform="rotate(24,512.4244402982295,523.5569029841572)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Love Ln.
    </text>
    <text
      textAnchor="middle"
      x="683.6220529563725"
      y="716.4308636323549"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,683.6220529563725,716.4308636323549)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Clinton St.
    </text>
    <text
      textAnchor="middle"
      x="504.4320660419762"
      y="1206.7687359726988"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,504.4320660419762,1206.7687359726988)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Clinton St.
    </text>
    <text
      textAnchor="middle"
      x="775.8388745523989"
      y="953.4180976748466"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,775.8388745523989,953.4180976748466)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Court St.
    </text>
    <text
      textAnchor="middle"
      x="533.7733426382765"
      y="664.5193742685951"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,533.7733426382765,664.5193742685951)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Henry St.
    </text>
    <text
      textAnchor="middle"
      x="356.5971724251285"
      y="1152.6002253359184"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,356.5971724251285,1152.6002253359184)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Henry St.
    </text>
    <text
      textAnchor="middle"
      x="685.5960820904002"
      y="248.95615671714768"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,685.5960820904002,248.95615671714768)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Henry St.
    </text>
    <text
      textAnchor="middle"
      x="508.3818532759324"
      y="946.6470338446088"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,508.3818532759324,946.6470338446088)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Sidney Pl.
    </text>
    <text
      textAnchor="middle"
      x="379.73164051026106"
      y="894.7355444845743"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,379.73164051026106,894.7355444845743)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Garden Pl.
    </text>
    <text
      textAnchor="middle"
      x="248.82440646737814"
      y="858.6232040575705"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,248.82440646737814,858.6232040575705)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Willow Pl.
    </text>
    <text
      textAnchor="middle"
      x="194.65589582920074"
      y="841.6955444831401"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,194.65589582920074,841.6955444831401)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Columbia Pl.
    </text>
    <text
      textAnchor="middle"
      x="409.6371724251658"
      y="621.6359700150788"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,409.6371724251658,621.6359700150788)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hicks St.
    </text>
    <text
      textAnchor="middle"
      x="235.8465341264382"
      y="1108.5883104419336"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,235.8465341264382,1108.5883104419336)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hicks St.
    </text>
    <text
      textAnchor="middle"
      x="563.138992536813"
      y="204.4263059697114"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,563.138992536813,204.4263059697114)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Hicks St.
    </text>
    <text
      textAnchor="middle"
      x="493.87033582199365"
      y="178.45055970177054"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,493.87033582199365,178.45055970177054)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Willow St.
    </text>
    <text
      textAnchor="middle"
      x="427.07555970177054"
      y="154.94869403075427"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,427.07555970177054,154.94869403075427)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Columbia Heights
    </text>
    <text
      textAnchor="middle"
      x="328.1203358210623"
      y="258.85167910391465"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,328.1203358210623,258.85167910391465)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Furman St.
    </text>
    <text
      textAnchor="middle"
      x="150.0009328359738"
      y="757.3386194021441"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,150.0009328359738,757.3386194021441)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Furman St.
    </text>
    <text
      textAnchor="middle"
      x="671.9897388061509"
      y="505.00279850838706"
      fill="rgb(255, 255, 255)"
      transform="rotate(-70,671.9897388061509,505.00279850838706)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Monroe Pl.
    </text>
    <text
      textAnchor="middle"
      x="760.0397256165743"
      y="744.6436295891181"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,760.0397256165743,744.6436295891181)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Montague St.
    </text>
    <text
      textAnchor="middle"
      x="311.57096247933805"
      y="580.8809135388583"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,311.57096247933805,580.8809135388583)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Montague St.
    </text>
    <text
      textAnchor="middle"
      x="579.4780234880745"
      y="1232.160225335043"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,579.4780234880745,1232.160225335043)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pacific St.
    </text>
    <text
      textAnchor="middle"
      x="329.744995996356"
      y="1219.4071256997995"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,329.744995996356,1219.4071256997995)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Amity St.
    </text>
    <text
      textAnchor="middle"
      x="1034.267810722813"
      y="641.949161503464"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1034.267810722813,641.949161503464)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Johnson St.
    </text>
    <text
      textAnchor="middle"
      x="1183.3132137032226"
      y="364.5676998361014"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1183.3132137032226,364.5676998361014)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Concord St.
    </text>
    <text
      textAnchor="middle"
      x="1185.4763458408415"
      y="407.83034257637337"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1185.4763458408415,407.83034257637337)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Chapel St.
    </text>
    <text
      textAnchor="middle"
      x="1184.3947797715664"
      y="453.2561174542643"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1184.3947797715664,453.2561174542643)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cathedral St.
    </text>
    <text
      textAnchor="middle"
      x="1181.1500815656036"
      y="517.0685154972598"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1181.1500815656036,517.0685154972598)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Tillary St.
    </text>
    <text
      textAnchor="middle"
      x="970.2446982059628"
      y="526.8026101142168"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,970.2446982059628,526.8026101142168)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Tillary St.
    </text>
    <text
      textAnchor="middle"
      x="1051.3621533438563"
      y="50.913539967965335"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1051.3621533438563,50.913539967965335)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Prospect St.
    </text>
    <text
      textAnchor="middle"
      x="1048.1174551388249"
      y="121.2153344200924"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1048.1174551388249,121.2153344200924)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Sands St.
    </text>
    <text
      textAnchor="middle"
      x="1206.3656830629334"
      y="933.1049061864614"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1206.3656830629334,933.1049061864614)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Willoughby St.
    </text>
    <text
      textAnchor="middle"
      x="1080.536746893078"
      y="1009.84362958977"
      fill="rgb(255, 255, 255)"
      transform="rotate(28,1080.536746893078,1009.84362958977)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Fulton St.
    </text>
    <text
      textAnchor="middle"
      x="1121.7273851912469"
      y="1155.4215019312687"
      fill="rgb(255, 255, 255)"
      transform="rotate(28,1121.7273851912469,1155.4215019312687)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Livingston St.
    </text>
    <text
      textAnchor="middle"
      x="1095.771640509367"
      y="1222.003629589919"
      fill="rgb(255, 255, 255)"
      transform="rotate(28,1095.771640509367,1222.003629589919)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Schermerhorn St.
    </text>
    <text
      textAnchor="middle"
      x="1097.4644064670429"
      y="704.0172466123477"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1097.4644064670429,704.0172466123477)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Jay St.
    </text>
    <text
      textAnchor="middle"
      x="1110.8482871130109"
      y="359.15986949391663"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1110.8482871130109,359.15986949391663)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Jay St.
    </text>
    <text
      textAnchor="middle"
      x="979.5350447650999"
      y="694.4249061867595"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,979.5350447650999,694.4249061867595)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Adams St.
    </text>
    <text
      textAnchor="middle"
      x="1003.7732463292778"
      y="187.19086460210383"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1003.7732463292778,187.19086460210383)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Adams St.
    </text>
    <text
      textAnchor="middle"
      x="981.0603588912636"
      y="351.5889070141129"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,981.0603588912636,351.5889070141129)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Brooklyn Bridge Blvd.
    </text>
    <text
      textAnchor="middle"
      x="885.8825448611751"
      y="278.0424143560231"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,885.8825448611751,278.0424143560231)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cadman Plaza E.
    </text>
    <text
      textAnchor="middle"
      x="944.5512149780989"
      y="988.9661827823147"
      fill="rgb(255, 255, 255)"
      transform="rotate(-79,944.5512149780989,988.9661827823147)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Boerum Pl.
    </text>
    <text
      textAnchor="middle"
      x="897.1537681696936"
      y="1122.1304380991496"
      fill="rgb(255, 255, 255)"
      transform="rotate(-62,897.1537681696936,1122.1304380991496)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Boerum Pl.
    </text>
    <text
      textAnchor="middle"
      x="1007.74781072326"
      y="1176.298948738724"
      fill="rgb(255, 255, 255)"
      transform="rotate(-62,1007.74781072326,1176.298948738724)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Smith St.
    </text>
    <text
      textAnchor="middle"
      x="1020.1614277446643"
      y="858.0589487394318"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1020.1614277446643,858.0589487394318)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pearl St.
    </text>
    <text
      textAnchor="middle"
      x="1176.4601511480287"
      y="705.1457572504878"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1176.4601511480287,705.1457572504878)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Lawrence St.
    </text>
    <text
      textAnchor="middle"
      x="1257.7129171052948"
      y="707.4027785258368"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1257.7129171052948,707.4027785258368)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Bridge St.
    </text>
    <text
      textAnchor="middle"
      x="1319.21674689278"
      y="1025.642778526526"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1319.21674689278,1025.642778526526)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Duffield St.
    </text>
    <text
      textAnchor="middle"
      x="1393.6984490212053"
      y="1033.5423529953696"
      fill="rgb(255, 255, 255)"
      transform="rotate(-88,1393.6984490212053,1033.5423529953696)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Albee Square W.
    </text>
    <text
      textAnchor="middle"
      x="1204.1086617875844"
      y="771.7278849091381"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1204.1086617875844,771.7278849091381)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Myrtle Promenade
    </text>
    <text
      textAnchor="middle"
      x="1204.1086617875844"
      y="841.6955444831401"
      fill="rgb(255, 255, 255)"
      transform="rotate(2.5,1204.1086617875844,841.6955444831401)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      MetroTech Center
    </text>
    <text
      textAnchor="middle"
      x="801.2303639147431"
      y="622.2002253346145"
      fill="rgb(255, 255, 255)"
      transform="rotate(77,801.2303639147431,622.2002253346145)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cadman Plaza W.
    </text>
    <text
      textAnchor="middle"
      x="570.5606343280524"
      y="362.75466417800635"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,570.5606343280524,362.75466417800635)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Clark St.
    </text>
    <text
      textAnchor="middle"
      x="592.8255597017705"
      y="294.7229477609508"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,592.8255597017705,294.7229477609508)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Pineapple St.
    </text>
    <text
      textAnchor="middle"
      x="620.0382462693378"
      y="227.928171641659"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,620.0382462693378,227.928171641659)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Orange St.
    </text>
    <text
      textAnchor="middle"
      x="643.5401119412854"
      y="159.8964552236721"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,643.5401119412854,159.8964552236721)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Cranberry St.
    </text>
    <text
      textAnchor="middle"
      x="668.2789179105312"
      y="93.10167910251766"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,668.2789179105312,93.10167910251766)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Middagh St.
    </text>
    <text
      textAnchor="middle"
      x="895.6166394781321"
      y="74.70799347665161"
      fill="rgb(255, 255, 255)"
      transform="rotate(42,895.6166394781321,74.70799347665161)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Brooklyn Bridge
    </text>
    <text
      textAnchor="middle"
      x="1162.4526462396607"
      y="172.56963788205758"
      fill="rgb(255, 255, 255)"
      transform="rotate(67,1162.4526462396607,172.56963788205758)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Manhattan Bridge
    </text>
    <text
      textAnchor="middle"
      x="693.0177238807082"
      y="25.06996268685907"
      fill="rgb(255, 255, 255)"
      transform="rotate(19,693.0177238807082,25.06996268685907)"
      style={{ fontFamily: 'Marr Sans', fontSize: this.props.labelFontSize }}>
      Poplar St.
    </text>
  </svg>
)
}
}



// WEBPACK FOOTER //
// ./src/components/map-page/large-map.js